
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired98d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired98d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jK8PJ", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $e5f92a4f74b1c440$export$ffb0004e005737fa, (v) => $e5f92a4f74b1c440$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $e5f92a4f74b1c440$export$34b9dba7ce09269b, (v) => $e5f92a4f74b1c440$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $e5f92a4f74b1c440$export$25062201e9e25d76, (v) => $e5f92a4f74b1c440$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5f92a4f74b1c440$export$ffb0004e005737fa;
var $e5f92a4f74b1c440$export$34b9dba7ce09269b;
var $e5f92a4f74b1c440$export$25062201e9e25d76;
"use strict";

var $dhiZh = parcelRequire("dhiZh");
var $e5f92a4f74b1c440$var$k = Symbol.for("react.element"), $e5f92a4f74b1c440$var$l = Symbol.for("react.fragment"), $e5f92a4f74b1c440$var$m = Object.prototype.hasOwnProperty, $e5f92a4f74b1c440$var$n = $dhiZh.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e5f92a4f74b1c440$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e5f92a4f74b1c440$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e5f92a4f74b1c440$var$m.call(a, b) && !$e5f92a4f74b1c440$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e5f92a4f74b1c440$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e5f92a4f74b1c440$var$n.current
    };
}
$e5f92a4f74b1c440$export$ffb0004e005737fa = $e5f92a4f74b1c440$var$l;
$e5f92a4f74b1c440$export$34b9dba7ce09269b = $e5f92a4f74b1c440$var$q;
$e5f92a4f74b1c440$export$25062201e9e25d76 = $e5f92a4f74b1c440$var$q;

});
parcelRegister("dhiZh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jCv7E"));

});
parcelRegister("jCv7E", function(module, exports) {

$parcel$export(module.exports, "Children", () => $e489b533c3988ba6$export$dca3b0875bd9a954, (v) => $e489b533c3988ba6$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e489b533c3988ba6$export$16fa2f45be04daa8, (v) => $e489b533c3988ba6$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e489b533c3988ba6$export$ffb0004e005737fa, (v) => $e489b533c3988ba6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e489b533c3988ba6$export$e2c29f18771995cb, (v) => $e489b533c3988ba6$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e489b533c3988ba6$export$221d75b3f55bb0bd, (v) => $e489b533c3988ba6$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e489b533c3988ba6$export$5f8d39834fd61797, (v) => $e489b533c3988ba6$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e489b533c3988ba6$export$74bf444e3cd11ea5, (v) => $e489b533c3988ba6$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e489b533c3988ba6$export$ae55be85d98224ed, (v) => $e489b533c3988ba6$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $e489b533c3988ba6$export$3ba232387fd5d6dd, (v) => $e489b533c3988ba6$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $e489b533c3988ba6$export$e530037191fcd5d7, (v) => $e489b533c3988ba6$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e489b533c3988ba6$export$fd42f52fd3ae1109, (v) => $e489b533c3988ba6$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e489b533c3988ba6$export$c8a8987d4410bf2d, (v) => $e489b533c3988ba6$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $e489b533c3988ba6$export$d38cd72104c1f0e9, (v) => $e489b533c3988ba6$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $e489b533c3988ba6$export$7d1e3a5e95ceca43, (v) => $e489b533c3988ba6$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e489b533c3988ba6$export$257a8862b851cb5b, (v) => $e489b533c3988ba6$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e489b533c3988ba6$export$a8257692ac88316c, (v) => $e489b533c3988ba6$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e489b533c3988ba6$export$488013bae63b21da, (v) => $e489b533c3988ba6$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e489b533c3988ba6$export$7c73462e0d25e514, (v) => $e489b533c3988ba6$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e489b533c3988ba6$export$7568632d0d33d16d, (v) => $e489b533c3988ba6$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $e489b533c3988ba6$export$88948ce120ea2619, (v) => $e489b533c3988ba6$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $e489b533c3988ba6$export$35808ee640e87ca7, (v) => $e489b533c3988ba6$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e489b533c3988ba6$export$fae74005e78b1a27, (v) => $e489b533c3988ba6$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e489b533c3988ba6$export$dc8fbce3eb94dc1e, (v) => $e489b533c3988ba6$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e489b533c3988ba6$export$6a7bc4e911dc01cf, (v) => $e489b533c3988ba6$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e489b533c3988ba6$export$6d9c69b0de29b591, (v) => $e489b533c3988ba6$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $e489b533c3988ba6$export$f680877a34711e37, (v) => $e489b533c3988ba6$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e489b533c3988ba6$export$d5a552a76deda3c2, (v) => $e489b533c3988ba6$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e489b533c3988ba6$export$aaabe4eda9ed9969, (v) => $e489b533c3988ba6$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e489b533c3988ba6$export$e5c5a5f917a5871c, (v) => $e489b533c3988ba6$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e489b533c3988ba6$export$1538c33de8887b59, (v) => $e489b533c3988ba6$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $e489b533c3988ba6$export$13e3392192263954, (v) => $e489b533c3988ba6$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e489b533c3988ba6$export$b8f5890fc79d6aca, (v) => $e489b533c3988ba6$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e489b533c3988ba6$export$60241385465d0a34, (v) => $e489b533c3988ba6$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e489b533c3988ba6$export$306c0aa65ff9ec16, (v) => $e489b533c3988ba6$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e489b533c3988ba6$export$7b286972b8d8ccbf, (v) => $e489b533c3988ba6$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e489b533c3988ba6$export$83d89fbfd8236492, (v) => $e489b533c3988ba6$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e489b533c3988ba6$export$dca3b0875bd9a954;
var $e489b533c3988ba6$export$16fa2f45be04daa8;
var $e489b533c3988ba6$export$ffb0004e005737fa;
var $e489b533c3988ba6$export$e2c29f18771995cb;
var $e489b533c3988ba6$export$221d75b3f55bb0bd;
var $e489b533c3988ba6$export$5f8d39834fd61797;
var $e489b533c3988ba6$export$74bf444e3cd11ea5;
var $e489b533c3988ba6$export$ae55be85d98224ed;
var $e489b533c3988ba6$export$3ba232387fd5d6dd;
var $e489b533c3988ba6$export$e530037191fcd5d7;
var $e489b533c3988ba6$export$fd42f52fd3ae1109;
var $e489b533c3988ba6$export$c8a8987d4410bf2d;
var $e489b533c3988ba6$export$d38cd72104c1f0e9;
var $e489b533c3988ba6$export$7d1e3a5e95ceca43;
var $e489b533c3988ba6$export$257a8862b851cb5b;
var $e489b533c3988ba6$export$a8257692ac88316c;
var $e489b533c3988ba6$export$488013bae63b21da;
var $e489b533c3988ba6$export$7c73462e0d25e514;
var $e489b533c3988ba6$export$7568632d0d33d16d;
var $e489b533c3988ba6$export$88948ce120ea2619;
var $e489b533c3988ba6$export$35808ee640e87ca7;
var $e489b533c3988ba6$export$fae74005e78b1a27;
var $e489b533c3988ba6$export$dc8fbce3eb94dc1e;
var $e489b533c3988ba6$export$6a7bc4e911dc01cf;
var $e489b533c3988ba6$export$6d9c69b0de29b591;
var $e489b533c3988ba6$export$f680877a34711e37;
var $e489b533c3988ba6$export$d5a552a76deda3c2;
var $e489b533c3988ba6$export$aaabe4eda9ed9969;
var $e489b533c3988ba6$export$e5c5a5f917a5871c;
var $e489b533c3988ba6$export$1538c33de8887b59;
var $e489b533c3988ba6$export$13e3392192263954;
var $e489b533c3988ba6$export$b8f5890fc79d6aca;
var $e489b533c3988ba6$export$60241385465d0a34;
var $e489b533c3988ba6$export$306c0aa65ff9ec16;
var $e489b533c3988ba6$export$7b286972b8d8ccbf;
var $e489b533c3988ba6$export$83d89fbfd8236492;
"use strict";
var $e489b533c3988ba6$var$l = Symbol.for("react.element"), $e489b533c3988ba6$var$n = Symbol.for("react.portal"), $e489b533c3988ba6$var$p = Symbol.for("react.fragment"), $e489b533c3988ba6$var$q = Symbol.for("react.strict_mode"), $e489b533c3988ba6$var$r = Symbol.for("react.profiler"), $e489b533c3988ba6$var$t = Symbol.for("react.provider"), $e489b533c3988ba6$var$u = Symbol.for("react.context"), $e489b533c3988ba6$var$v = Symbol.for("react.forward_ref"), $e489b533c3988ba6$var$w = Symbol.for("react.suspense"), $e489b533c3988ba6$var$x = Symbol.for("react.memo"), $e489b533c3988ba6$var$y = Symbol.for("react.lazy"), $e489b533c3988ba6$var$z = Symbol.iterator;
function $e489b533c3988ba6$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e489b533c3988ba6$var$z && a[$e489b533c3988ba6$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e489b533c3988ba6$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e489b533c3988ba6$var$C = Object.assign, $e489b533c3988ba6$var$D = {};
function $e489b533c3988ba6$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e489b533c3988ba6$var$D;
    this.updater = e || $e489b533c3988ba6$var$B;
}
$e489b533c3988ba6$var$E.prototype.isReactComponent = {};
$e489b533c3988ba6$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e489b533c3988ba6$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e489b533c3988ba6$var$F() {}
$e489b533c3988ba6$var$F.prototype = $e489b533c3988ba6$var$E.prototype;
function $e489b533c3988ba6$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e489b533c3988ba6$var$D;
    this.updater = e || $e489b533c3988ba6$var$B;
}
var $e489b533c3988ba6$var$H = $e489b533c3988ba6$var$G.prototype = new $e489b533c3988ba6$var$F;
$e489b533c3988ba6$var$H.constructor = $e489b533c3988ba6$var$G;
$e489b533c3988ba6$var$C($e489b533c3988ba6$var$H, $e489b533c3988ba6$var$E.prototype);
$e489b533c3988ba6$var$H.isPureReactComponent = !0;
var $e489b533c3988ba6$var$I = Array.isArray, $e489b533c3988ba6$var$J = Object.prototype.hasOwnProperty, $e489b533c3988ba6$var$K = {
    current: null
}, $e489b533c3988ba6$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e489b533c3988ba6$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e489b533c3988ba6$var$J.call(b, d) && !$e489b533c3988ba6$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e489b533c3988ba6$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e489b533c3988ba6$var$K.current
    };
}
function $e489b533c3988ba6$var$N(a, b) {
    return {
        $$typeof: $e489b533c3988ba6$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e489b533c3988ba6$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e489b533c3988ba6$var$l;
}
function $e489b533c3988ba6$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e489b533c3988ba6$var$P = /\/+/g;
function $e489b533c3988ba6$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e489b533c3988ba6$var$escape("" + a.key) : b.toString(36);
}
function $e489b533c3988ba6$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e489b533c3988ba6$var$l:
                case $e489b533c3988ba6$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e489b533c3988ba6$var$Q(h, 0) : d, $e489b533c3988ba6$var$I(c) ? (e = "", null != a && (e = a.replace($e489b533c3988ba6$var$P, "$&/") + "/"), $e489b533c3988ba6$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e489b533c3988ba6$var$O(c) && (c = $e489b533c3988ba6$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e489b533c3988ba6$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e489b533c3988ba6$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e489b533c3988ba6$var$Q(k, g);
        h += $e489b533c3988ba6$var$R(k, b, e, f, c);
    }
    else if (f = $e489b533c3988ba6$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e489b533c3988ba6$var$Q(k, g++), h += $e489b533c3988ba6$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e489b533c3988ba6$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e489b533c3988ba6$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e489b533c3988ba6$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e489b533c3988ba6$var$U = {
    current: null
}, $e489b533c3988ba6$var$V = {
    transition: null
}, $e489b533c3988ba6$var$W = {
    ReactCurrentDispatcher: $e489b533c3988ba6$var$U,
    ReactCurrentBatchConfig: $e489b533c3988ba6$var$V,
    ReactCurrentOwner: $e489b533c3988ba6$var$K
};
function $e489b533c3988ba6$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e489b533c3988ba6$export$dca3b0875bd9a954 = {
    map: $e489b533c3988ba6$var$S,
    forEach: function(a, b, e) {
        $e489b533c3988ba6$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e489b533c3988ba6$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e489b533c3988ba6$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e489b533c3988ba6$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e489b533c3988ba6$export$16fa2f45be04daa8 = $e489b533c3988ba6$var$E;
$e489b533c3988ba6$export$ffb0004e005737fa = $e489b533c3988ba6$var$p;
$e489b533c3988ba6$export$e2c29f18771995cb = $e489b533c3988ba6$var$r;
$e489b533c3988ba6$export$221d75b3f55bb0bd = $e489b533c3988ba6$var$G;
$e489b533c3988ba6$export$5f8d39834fd61797 = $e489b533c3988ba6$var$q;
$e489b533c3988ba6$export$74bf444e3cd11ea5 = $e489b533c3988ba6$var$w;
$e489b533c3988ba6$export$ae55be85d98224ed = $e489b533c3988ba6$var$W;
$e489b533c3988ba6$export$3ba232387fd5d6dd = $e489b533c3988ba6$var$X;
$e489b533c3988ba6$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e489b533c3988ba6$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e489b533c3988ba6$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e489b533c3988ba6$var$J.call(b, f) && !$e489b533c3988ba6$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e489b533c3988ba6$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e489b533c3988ba6$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e489b533c3988ba6$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e489b533c3988ba6$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e489b533c3988ba6$export$c8a8987d4410bf2d = $e489b533c3988ba6$var$M;
$e489b533c3988ba6$export$d38cd72104c1f0e9 = function(a) {
    var b = $e489b533c3988ba6$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e489b533c3988ba6$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e489b533c3988ba6$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e489b533c3988ba6$var$v,
        render: a
    };
};
$e489b533c3988ba6$export$a8257692ac88316c = $e489b533c3988ba6$var$O;
$e489b533c3988ba6$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e489b533c3988ba6$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e489b533c3988ba6$var$T
    };
};
$e489b533c3988ba6$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e489b533c3988ba6$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e489b533c3988ba6$export$7568632d0d33d16d = function(a) {
    var b = $e489b533c3988ba6$var$V.transition;
    $e489b533c3988ba6$var$V.transition = {};
    try {
        a();
    } finally{
        $e489b533c3988ba6$var$V.transition = b;
    }
};
$e489b533c3988ba6$export$88948ce120ea2619 = $e489b533c3988ba6$var$X;
$e489b533c3988ba6$export$35808ee640e87ca7 = function(a, b) {
    return $e489b533c3988ba6$var$U.current.useCallback(a, b);
};
$e489b533c3988ba6$export$fae74005e78b1a27 = function(a) {
    return $e489b533c3988ba6$var$U.current.useContext(a);
};
$e489b533c3988ba6$export$dc8fbce3eb94dc1e = function() {};
$e489b533c3988ba6$export$6a7bc4e911dc01cf = function(a) {
    return $e489b533c3988ba6$var$U.current.useDeferredValue(a);
};
$e489b533c3988ba6$export$6d9c69b0de29b591 = function(a, b) {
    return $e489b533c3988ba6$var$U.current.useEffect(a, b);
};
$e489b533c3988ba6$export$f680877a34711e37 = function() {
    return $e489b533c3988ba6$var$U.current.useId();
};
$e489b533c3988ba6$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e489b533c3988ba6$var$U.current.useImperativeHandle(a, b, e);
};
$e489b533c3988ba6$export$aaabe4eda9ed9969 = function(a, b) {
    return $e489b533c3988ba6$var$U.current.useInsertionEffect(a, b);
};
$e489b533c3988ba6$export$e5c5a5f917a5871c = function(a, b) {
    return $e489b533c3988ba6$var$U.current.useLayoutEffect(a, b);
};
$e489b533c3988ba6$export$1538c33de8887b59 = function(a, b) {
    return $e489b533c3988ba6$var$U.current.useMemo(a, b);
};
$e489b533c3988ba6$export$13e3392192263954 = function(a, b, e) {
    return $e489b533c3988ba6$var$U.current.useReducer(a, b, e);
};
$e489b533c3988ba6$export$b8f5890fc79d6aca = function(a) {
    return $e489b533c3988ba6$var$U.current.useRef(a);
};
$e489b533c3988ba6$export$60241385465d0a34 = function(a) {
    return $e489b533c3988ba6$var$U.current.useState(a);
};
$e489b533c3988ba6$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e489b533c3988ba6$var$U.current.useSyncExternalStore(a, b, e);
};
$e489b533c3988ba6$export$7b286972b8d8ccbf = function() {
    return $e489b533c3988ba6$var$U.current.useTransition();
};
$e489b533c3988ba6$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("b4Mpg", function(module, exports) {
"use strict";
function $81059df8248b2d83$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($81059df8248b2d83$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$81059df8248b2d83$var$checkDCE();

module.exports = (parcelRequire("80HKq"));

});
parcelRegister("80HKq", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $5d50423c547436fe$export$ae55be85d98224ed, (v) => $5d50423c547436fe$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $5d50423c547436fe$export$d39a5bbd09211389, (v) => $5d50423c547436fe$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $5d50423c547436fe$export$882461b6382ed46c, (v) => $5d50423c547436fe$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $5d50423c547436fe$export$466bfc07425424d5, (v) => $5d50423c547436fe$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $5d50423c547436fe$export$cd75ccfd720a3cd4, (v) => $5d50423c547436fe$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $5d50423c547436fe$export$fa8d919ba61d84db, (v) => $5d50423c547436fe$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $5d50423c547436fe$export$757ceba2d55c277e, (v) => $5d50423c547436fe$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $5d50423c547436fe$export$b3890eb0ae9dca99, (v) => $5d50423c547436fe$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $5d50423c547436fe$export$502457920280e6be, (v) => $5d50423c547436fe$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $5d50423c547436fe$export$c78a37762a8d58e1, (v) => $5d50423c547436fe$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $5d50423c547436fe$export$dc54d992c10e8a18, (v) => $5d50423c547436fe$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $5d50423c547436fe$export$83d89fbfd8236492, (v) => $5d50423c547436fe$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5d50423c547436fe$export$ae55be85d98224ed;
var $5d50423c547436fe$export$d39a5bbd09211389;
var $5d50423c547436fe$export$882461b6382ed46c;
var $5d50423c547436fe$export$466bfc07425424d5;
var $5d50423c547436fe$export$cd75ccfd720a3cd4;
var $5d50423c547436fe$export$fa8d919ba61d84db;
var $5d50423c547436fe$export$757ceba2d55c277e;
var $5d50423c547436fe$export$b3890eb0ae9dca99;
var $5d50423c547436fe$export$502457920280e6be;
var $5d50423c547436fe$export$c78a37762a8d58e1;
var $5d50423c547436fe$export$dc54d992c10e8a18;
var $5d50423c547436fe$export$83d89fbfd8236492;
"use strict";

var $dhiZh = parcelRequire("dhiZh");

var $4bDui = parcelRequire("4bDui");
function $5d50423c547436fe$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5d50423c547436fe$var$da = new Set, $5d50423c547436fe$var$ea = {};
function $5d50423c547436fe$var$fa(a, b) {
    $5d50423c547436fe$var$ha(a, b);
    $5d50423c547436fe$var$ha(a + "Capture", b);
}
function $5d50423c547436fe$var$ha(a, b) {
    $5d50423c547436fe$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$5d50423c547436fe$var$da.add(b[a]);
}
var $5d50423c547436fe$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5d50423c547436fe$var$ja = Object.prototype.hasOwnProperty, $5d50423c547436fe$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5d50423c547436fe$var$la = {}, $5d50423c547436fe$var$ma = {};
function $5d50423c547436fe$var$oa(a) {
    if ($5d50423c547436fe$var$ja.call($5d50423c547436fe$var$ma, a)) return !0;
    if ($5d50423c547436fe$var$ja.call($5d50423c547436fe$var$la, a)) return !1;
    if ($5d50423c547436fe$var$ka.test(a)) return $5d50423c547436fe$var$ma[a] = !0;
    $5d50423c547436fe$var$la[a] = !0;
    return !1;
}
function $5d50423c547436fe$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $5d50423c547436fe$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $5d50423c547436fe$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $5d50423c547436fe$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $5d50423c547436fe$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5d50423c547436fe$var$z[b] = new $5d50423c547436fe$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $5d50423c547436fe$var$ra = /[\-:]([a-z])/g;
function $5d50423c547436fe$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5d50423c547436fe$var$ra, $5d50423c547436fe$var$sa);
    $5d50423c547436fe$var$z[b] = new $5d50423c547436fe$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5d50423c547436fe$var$ra, $5d50423c547436fe$var$sa);
    $5d50423c547436fe$var$z[b] = new $5d50423c547436fe$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5d50423c547436fe$var$ra, $5d50423c547436fe$var$sa);
    $5d50423c547436fe$var$z[b] = new $5d50423c547436fe$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$5d50423c547436fe$var$z.xlinkHref = new $5d50423c547436fe$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5d50423c547436fe$var$z[a] = new $5d50423c547436fe$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $5d50423c547436fe$var$ta(a, b, c, d) {
    var e = $5d50423c547436fe$var$z.hasOwnProperty(b) ? $5d50423c547436fe$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $5d50423c547436fe$var$qa(b, c, e, d) && (c = null), d || null === e ? $5d50423c547436fe$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $5d50423c547436fe$var$ua = $dhiZh.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $5d50423c547436fe$var$va = Symbol.for("react.element"), $5d50423c547436fe$var$wa = Symbol.for("react.portal"), $5d50423c547436fe$var$ya = Symbol.for("react.fragment"), $5d50423c547436fe$var$za = Symbol.for("react.strict_mode"), $5d50423c547436fe$var$Aa = Symbol.for("react.profiler"), $5d50423c547436fe$var$Ba = Symbol.for("react.provider"), $5d50423c547436fe$var$Ca = Symbol.for("react.context"), $5d50423c547436fe$var$Da = Symbol.for("react.forward_ref"), $5d50423c547436fe$var$Ea = Symbol.for("react.suspense"), $5d50423c547436fe$var$Fa = Symbol.for("react.suspense_list"), $5d50423c547436fe$var$Ga = Symbol.for("react.memo"), $5d50423c547436fe$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $5d50423c547436fe$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $5d50423c547436fe$var$Ja = Symbol.iterator;
function $5d50423c547436fe$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5d50423c547436fe$var$Ja && a[$5d50423c547436fe$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5d50423c547436fe$var$A = Object.assign, $5d50423c547436fe$var$La;
function $5d50423c547436fe$var$Ma(a) {
    if (void 0 === $5d50423c547436fe$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $5d50423c547436fe$var$La = b && b[1] || "";
    }
    return "\n" + $5d50423c547436fe$var$La + a;
}
var $5d50423c547436fe$var$Na = !1;
function $5d50423c547436fe$var$Oa(a, b) {
    if (!a || $5d50423c547436fe$var$Na) return "";
    $5d50423c547436fe$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $5d50423c547436fe$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $5d50423c547436fe$var$Ma(a) : "";
}
function $5d50423c547436fe$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $5d50423c547436fe$var$Ma(a.type);
        case 16:
            return $5d50423c547436fe$var$Ma("Lazy");
        case 13:
            return $5d50423c547436fe$var$Ma("Suspense");
        case 19:
            return $5d50423c547436fe$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $5d50423c547436fe$var$Oa(a.type, !1), a;
        case 11:
            return a = $5d50423c547436fe$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $5d50423c547436fe$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $5d50423c547436fe$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5d50423c547436fe$var$ya:
            return "Fragment";
        case $5d50423c547436fe$var$wa:
            return "Portal";
        case $5d50423c547436fe$var$Aa:
            return "Profiler";
        case $5d50423c547436fe$var$za:
            return "StrictMode";
        case $5d50423c547436fe$var$Ea:
            return "Suspense";
        case $5d50423c547436fe$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5d50423c547436fe$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $5d50423c547436fe$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $5d50423c547436fe$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $5d50423c547436fe$var$Ga:
            return b = a.displayName || null, null !== b ? b : $5d50423c547436fe$var$Qa(a.type) || "Memo";
        case $5d50423c547436fe$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $5d50423c547436fe$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $5d50423c547436fe$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $5d50423c547436fe$var$Qa(b);
        case 8:
            return b === $5d50423c547436fe$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $5d50423c547436fe$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $5d50423c547436fe$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $5d50423c547436fe$var$Ua(a) {
    var b = $5d50423c547436fe$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $5d50423c547436fe$var$Va(a) {
    a._valueTracker || (a._valueTracker = $5d50423c547436fe$var$Ua(a));
}
function $5d50423c547436fe$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $5d50423c547436fe$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $5d50423c547436fe$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $5d50423c547436fe$var$Ya(a, b) {
    var c = b.checked;
    return $5d50423c547436fe$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $5d50423c547436fe$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $5d50423c547436fe$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $5d50423c547436fe$var$ab(a, b) {
    b = b.checked;
    null != b && $5d50423c547436fe$var$ta(a, "checked", b, !1);
}
function $5d50423c547436fe$var$bb(a, b) {
    $5d50423c547436fe$var$ab(a, b);
    var c = $5d50423c547436fe$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $5d50423c547436fe$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $5d50423c547436fe$var$cb(a, b.type, $5d50423c547436fe$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $5d50423c547436fe$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $5d50423c547436fe$var$cb(a, b, c) {
    if ("number" !== b || $5d50423c547436fe$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $5d50423c547436fe$var$eb = Array.isArray;
function $5d50423c547436fe$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $5d50423c547436fe$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $5d50423c547436fe$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($5d50423c547436fe$var$p(91));
    return $5d50423c547436fe$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $5d50423c547436fe$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($5d50423c547436fe$var$p(92));
            if ($5d50423c547436fe$var$eb(c)) {
                if (1 < c.length) throw Error($5d50423c547436fe$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $5d50423c547436fe$var$Sa(c)
    };
}
function $5d50423c547436fe$var$ib(a, b) {
    var c = $5d50423c547436fe$var$Sa(b.value), d = $5d50423c547436fe$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $5d50423c547436fe$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $5d50423c547436fe$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $5d50423c547436fe$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $5d50423c547436fe$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $5d50423c547436fe$var$mb, $5d50423c547436fe$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $5d50423c547436fe$var$mb = $5d50423c547436fe$var$mb || document.createElement("div");
        $5d50423c547436fe$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $5d50423c547436fe$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $5d50423c547436fe$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $5d50423c547436fe$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5d50423c547436fe$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5d50423c547436fe$var$pb).forEach(function(a) {
    $5d50423c547436fe$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5d50423c547436fe$var$pb[b] = $5d50423c547436fe$var$pb[a];
    });
});
function $5d50423c547436fe$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $5d50423c547436fe$var$pb.hasOwnProperty(a) && $5d50423c547436fe$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $5d50423c547436fe$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $5d50423c547436fe$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $5d50423c547436fe$var$tb = $5d50423c547436fe$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $5d50423c547436fe$var$ub(a, b) {
    if (b) {
        if ($5d50423c547436fe$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($5d50423c547436fe$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($5d50423c547436fe$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($5d50423c547436fe$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($5d50423c547436fe$var$p(62));
    }
}
function $5d50423c547436fe$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5d50423c547436fe$var$wb = null;
function $5d50423c547436fe$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $5d50423c547436fe$var$yb = null, $5d50423c547436fe$var$zb = null, $5d50423c547436fe$var$Ab = null;
function $5d50423c547436fe$var$Bb(a) {
    if (a = $5d50423c547436fe$var$Cb(a)) {
        if ("function" !== typeof $5d50423c547436fe$var$yb) throw Error($5d50423c547436fe$var$p(280));
        var b = a.stateNode;
        b && (b = $5d50423c547436fe$var$Db(b), $5d50423c547436fe$var$yb(a.stateNode, a.type, b));
    }
}
function $5d50423c547436fe$var$Eb(a) {
    $5d50423c547436fe$var$zb ? $5d50423c547436fe$var$Ab ? $5d50423c547436fe$var$Ab.push(a) : $5d50423c547436fe$var$Ab = [
        a
    ] : $5d50423c547436fe$var$zb = a;
}
function $5d50423c547436fe$var$Fb() {
    if ($5d50423c547436fe$var$zb) {
        var a = $5d50423c547436fe$var$zb, b = $5d50423c547436fe$var$Ab;
        $5d50423c547436fe$var$Ab = $5d50423c547436fe$var$zb = null;
        $5d50423c547436fe$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$5d50423c547436fe$var$Bb(b[a]);
    }
}
function $5d50423c547436fe$var$Gb(a, b) {
    return a(b);
}
function $5d50423c547436fe$var$Hb() {}
var $5d50423c547436fe$var$Ib = !1;
function $5d50423c547436fe$var$Jb(a, b, c) {
    if ($5d50423c547436fe$var$Ib) return a(b, c);
    $5d50423c547436fe$var$Ib = !0;
    try {
        return $5d50423c547436fe$var$Gb(a, b, c);
    } finally{
        if ($5d50423c547436fe$var$Ib = !1, null !== $5d50423c547436fe$var$zb || null !== $5d50423c547436fe$var$Ab) $5d50423c547436fe$var$Hb(), $5d50423c547436fe$var$Fb();
    }
}
function $5d50423c547436fe$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $5d50423c547436fe$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($5d50423c547436fe$var$p(231, b, typeof c));
    return c;
}
var $5d50423c547436fe$var$Lb = !1;
if ($5d50423c547436fe$var$ia) try {
    var $5d50423c547436fe$var$Mb = {};
    Object.defineProperty($5d50423c547436fe$var$Mb, "passive", {
        get: function() {
            $5d50423c547436fe$var$Lb = !0;
        }
    });
    window.addEventListener("test", $5d50423c547436fe$var$Mb, $5d50423c547436fe$var$Mb);
    window.removeEventListener("test", $5d50423c547436fe$var$Mb, $5d50423c547436fe$var$Mb);
} catch (a) {
    $5d50423c547436fe$var$Lb = !1;
}
function $5d50423c547436fe$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $5d50423c547436fe$var$Ob = !1, $5d50423c547436fe$var$Pb = null, $5d50423c547436fe$var$Qb = !1, $5d50423c547436fe$var$Rb = null, $5d50423c547436fe$var$Sb = {
    onError: function(a) {
        $5d50423c547436fe$var$Ob = !0;
        $5d50423c547436fe$var$Pb = a;
    }
};
function $5d50423c547436fe$var$Tb(a, b, c, d, e, f, g, h, k) {
    $5d50423c547436fe$var$Ob = !1;
    $5d50423c547436fe$var$Pb = null;
    $5d50423c547436fe$var$Nb.apply($5d50423c547436fe$var$Sb, arguments);
}
function $5d50423c547436fe$var$Ub(a, b, c, d, e, f, g, h, k) {
    $5d50423c547436fe$var$Tb.apply(this, arguments);
    if ($5d50423c547436fe$var$Ob) {
        if ($5d50423c547436fe$var$Ob) {
            var l = $5d50423c547436fe$var$Pb;
            $5d50423c547436fe$var$Ob = !1;
            $5d50423c547436fe$var$Pb = null;
        } else throw Error($5d50423c547436fe$var$p(198));
        $5d50423c547436fe$var$Qb || ($5d50423c547436fe$var$Qb = !0, $5d50423c547436fe$var$Rb = l);
    }
}
function $5d50423c547436fe$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $5d50423c547436fe$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $5d50423c547436fe$var$Xb(a) {
    if ($5d50423c547436fe$var$Vb(a) !== a) throw Error($5d50423c547436fe$var$p(188));
}
function $5d50423c547436fe$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $5d50423c547436fe$var$Vb(a);
        if (null === b) throw Error($5d50423c547436fe$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $5d50423c547436fe$var$Xb(e), a;
                if (f === d) return $5d50423c547436fe$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($5d50423c547436fe$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($5d50423c547436fe$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($5d50423c547436fe$var$p(190));
    }
    if (3 !== c.tag) throw Error($5d50423c547436fe$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $5d50423c547436fe$var$Zb(a) {
    a = $5d50423c547436fe$var$Yb(a);
    return null !== a ? $5d50423c547436fe$var$$b(a) : null;
}
function $5d50423c547436fe$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $5d50423c547436fe$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $5d50423c547436fe$var$ac = $4bDui.unstable_scheduleCallback, $5d50423c547436fe$var$bc = $4bDui.unstable_cancelCallback, $5d50423c547436fe$var$cc = $4bDui.unstable_shouldYield, $5d50423c547436fe$var$dc = $4bDui.unstable_requestPaint, $5d50423c547436fe$var$B = $4bDui.unstable_now, $5d50423c547436fe$var$ec = $4bDui.unstable_getCurrentPriorityLevel, $5d50423c547436fe$var$fc = $4bDui.unstable_ImmediatePriority, $5d50423c547436fe$var$gc = $4bDui.unstable_UserBlockingPriority, $5d50423c547436fe$var$hc = $4bDui.unstable_NormalPriority, $5d50423c547436fe$var$ic = $4bDui.unstable_LowPriority, $5d50423c547436fe$var$jc = $4bDui.unstable_IdlePriority, $5d50423c547436fe$var$kc = null, $5d50423c547436fe$var$lc = null;
function $5d50423c547436fe$var$mc(a) {
    if ($5d50423c547436fe$var$lc && "function" === typeof $5d50423c547436fe$var$lc.onCommitFiberRoot) try {
        $5d50423c547436fe$var$lc.onCommitFiberRoot($5d50423c547436fe$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $5d50423c547436fe$var$oc = Math.clz32 ? Math.clz32 : $5d50423c547436fe$var$nc, $5d50423c547436fe$var$pc = Math.log, $5d50423c547436fe$var$qc = Math.LN2;
function $5d50423c547436fe$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($5d50423c547436fe$var$pc(a) / $5d50423c547436fe$var$qc | 0) | 0;
}
var $5d50423c547436fe$var$rc = 64, $5d50423c547436fe$var$sc = 4194304;
function $5d50423c547436fe$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $5d50423c547436fe$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $5d50423c547436fe$var$tc(h) : (f &= g, 0 !== f && (d = $5d50423c547436fe$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $5d50423c547436fe$var$tc(g) : 0 !== f && (d = $5d50423c547436fe$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $5d50423c547436fe$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $5d50423c547436fe$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5d50423c547436fe$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $5d50423c547436fe$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $5d50423c547436fe$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $5d50423c547436fe$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $5d50423c547436fe$var$yc() {
    var a = $5d50423c547436fe$var$rc;
    $5d50423c547436fe$var$rc <<= 1;
    0 === ($5d50423c547436fe$var$rc & 4194240) && ($5d50423c547436fe$var$rc = 64);
    return a;
}
function $5d50423c547436fe$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $5d50423c547436fe$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $5d50423c547436fe$var$oc(b);
    a[b] = c;
}
function $5d50423c547436fe$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $5d50423c547436fe$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $5d50423c547436fe$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $5d50423c547436fe$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $5d50423c547436fe$var$C = 0;
function $5d50423c547436fe$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $5d50423c547436fe$var$Ec, $5d50423c547436fe$var$Fc, $5d50423c547436fe$var$Gc, $5d50423c547436fe$var$Hc, $5d50423c547436fe$var$Ic, $5d50423c547436fe$var$Jc = !1, $5d50423c547436fe$var$Kc = [], $5d50423c547436fe$var$Lc = null, $5d50423c547436fe$var$Mc = null, $5d50423c547436fe$var$Nc = null, $5d50423c547436fe$var$Oc = new Map, $5d50423c547436fe$var$Pc = new Map, $5d50423c547436fe$var$Qc = [], $5d50423c547436fe$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $5d50423c547436fe$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $5d50423c547436fe$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $5d50423c547436fe$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $5d50423c547436fe$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $5d50423c547436fe$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5d50423c547436fe$var$Pc.delete(b.pointerId);
    }
}
function $5d50423c547436fe$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $5d50423c547436fe$var$Cb(b), null !== b && $5d50423c547436fe$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $5d50423c547436fe$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $5d50423c547436fe$var$Lc = $5d50423c547436fe$var$Tc($5d50423c547436fe$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $5d50423c547436fe$var$Mc = $5d50423c547436fe$var$Tc($5d50423c547436fe$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $5d50423c547436fe$var$Nc = $5d50423c547436fe$var$Tc($5d50423c547436fe$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $5d50423c547436fe$var$Oc.set(f, $5d50423c547436fe$var$Tc($5d50423c547436fe$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $5d50423c547436fe$var$Pc.set(f, $5d50423c547436fe$var$Tc($5d50423c547436fe$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $5d50423c547436fe$var$Vc(a) {
    var b = $5d50423c547436fe$var$Wc(a.target);
    if (null !== b) {
        var c = $5d50423c547436fe$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $5d50423c547436fe$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $5d50423c547436fe$var$Ic(a.priority, function() {
                        $5d50423c547436fe$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $5d50423c547436fe$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $5d50423c547436fe$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $5d50423c547436fe$var$wb = d;
            c.target.dispatchEvent(d);
            $5d50423c547436fe$var$wb = null;
        } else return b = $5d50423c547436fe$var$Cb(c), null !== b && $5d50423c547436fe$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $5d50423c547436fe$var$Zc(a, b, c) {
    $5d50423c547436fe$var$Xc(a) && c.delete(b);
}
function $5d50423c547436fe$var$$c() {
    $5d50423c547436fe$var$Jc = !1;
    null !== $5d50423c547436fe$var$Lc && $5d50423c547436fe$var$Xc($5d50423c547436fe$var$Lc) && ($5d50423c547436fe$var$Lc = null);
    null !== $5d50423c547436fe$var$Mc && $5d50423c547436fe$var$Xc($5d50423c547436fe$var$Mc) && ($5d50423c547436fe$var$Mc = null);
    null !== $5d50423c547436fe$var$Nc && $5d50423c547436fe$var$Xc($5d50423c547436fe$var$Nc) && ($5d50423c547436fe$var$Nc = null);
    $5d50423c547436fe$var$Oc.forEach($5d50423c547436fe$var$Zc);
    $5d50423c547436fe$var$Pc.forEach($5d50423c547436fe$var$Zc);
}
function $5d50423c547436fe$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $5d50423c547436fe$var$Jc || ($5d50423c547436fe$var$Jc = !0, $4bDui.unstable_scheduleCallback($4bDui.unstable_NormalPriority, $5d50423c547436fe$var$$c)));
}
function $5d50423c547436fe$var$bd(a) {
    function b(b) {
        return $5d50423c547436fe$var$ad(b, a);
    }
    if (0 < $5d50423c547436fe$var$Kc.length) {
        $5d50423c547436fe$var$ad($5d50423c547436fe$var$Kc[0], a);
        for(var c = 1; c < $5d50423c547436fe$var$Kc.length; c++){
            var d = $5d50423c547436fe$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $5d50423c547436fe$var$Lc && $5d50423c547436fe$var$ad($5d50423c547436fe$var$Lc, a);
    null !== $5d50423c547436fe$var$Mc && $5d50423c547436fe$var$ad($5d50423c547436fe$var$Mc, a);
    null !== $5d50423c547436fe$var$Nc && $5d50423c547436fe$var$ad($5d50423c547436fe$var$Nc, a);
    $5d50423c547436fe$var$Oc.forEach(b);
    $5d50423c547436fe$var$Pc.forEach(b);
    for(c = 0; c < $5d50423c547436fe$var$Qc.length; c++)d = $5d50423c547436fe$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $5d50423c547436fe$var$Qc.length && (c = $5d50423c547436fe$var$Qc[0], null === c.blockedOn);)$5d50423c547436fe$var$Vc(c), null === c.blockedOn && $5d50423c547436fe$var$Qc.shift();
}
var $5d50423c547436fe$var$cd = $5d50423c547436fe$var$ua.ReactCurrentBatchConfig, $5d50423c547436fe$var$dd = !0;
function $5d50423c547436fe$var$ed(a, b, c, d) {
    var e = $5d50423c547436fe$var$C, f = $5d50423c547436fe$var$cd.transition;
    $5d50423c547436fe$var$cd.transition = null;
    try {
        $5d50423c547436fe$var$C = 1, $5d50423c547436fe$var$fd(a, b, c, d);
    } finally{
        $5d50423c547436fe$var$C = e, $5d50423c547436fe$var$cd.transition = f;
    }
}
function $5d50423c547436fe$var$gd(a, b, c, d) {
    var e = $5d50423c547436fe$var$C, f = $5d50423c547436fe$var$cd.transition;
    $5d50423c547436fe$var$cd.transition = null;
    try {
        $5d50423c547436fe$var$C = 4, $5d50423c547436fe$var$fd(a, b, c, d);
    } finally{
        $5d50423c547436fe$var$C = e, $5d50423c547436fe$var$cd.transition = f;
    }
}
function $5d50423c547436fe$var$fd(a, b, c, d) {
    if ($5d50423c547436fe$var$dd) {
        var e = $5d50423c547436fe$var$Yc(a, b, c, d);
        if (null === e) $5d50423c547436fe$var$hd(a, b, d, $5d50423c547436fe$var$id, c), $5d50423c547436fe$var$Sc(a, d);
        else if ($5d50423c547436fe$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($5d50423c547436fe$var$Sc(a, d), b & 4 && -1 < $5d50423c547436fe$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $5d50423c547436fe$var$Cb(e);
                null !== f && $5d50423c547436fe$var$Ec(f);
                f = $5d50423c547436fe$var$Yc(a, b, c, d);
                null === f && $5d50423c547436fe$var$hd(a, b, d, $5d50423c547436fe$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $5d50423c547436fe$var$hd(a, b, d, null, c);
    }
}
var $5d50423c547436fe$var$id = null;
function $5d50423c547436fe$var$Yc(a, b, c, d) {
    $5d50423c547436fe$var$id = null;
    a = $5d50423c547436fe$var$xb(d);
    a = $5d50423c547436fe$var$Wc(a);
    if (null !== a) {
        if (b = $5d50423c547436fe$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $5d50423c547436fe$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $5d50423c547436fe$var$id = a;
    return null;
}
function $5d50423c547436fe$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($5d50423c547436fe$var$ec()){
                case $5d50423c547436fe$var$fc:
                    return 1;
                case $5d50423c547436fe$var$gc:
                    return 4;
                case $5d50423c547436fe$var$hc:
                case $5d50423c547436fe$var$ic:
                    return 16;
                case $5d50423c547436fe$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $5d50423c547436fe$var$kd = null, $5d50423c547436fe$var$ld = null, $5d50423c547436fe$var$md = null;
function $5d50423c547436fe$var$nd() {
    if ($5d50423c547436fe$var$md) return $5d50423c547436fe$var$md;
    var a, b = $5d50423c547436fe$var$ld, c = b.length, d, e = "value" in $5d50423c547436fe$var$kd ? $5d50423c547436fe$var$kd.value : $5d50423c547436fe$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $5d50423c547436fe$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $5d50423c547436fe$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $5d50423c547436fe$var$pd() {
    return !0;
}
function $5d50423c547436fe$var$qd() {
    return !1;
}
function $5d50423c547436fe$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $5d50423c547436fe$var$pd : $5d50423c547436fe$var$qd;
        this.isPropagationStopped = $5d50423c547436fe$var$qd;
        return this;
    }
    $5d50423c547436fe$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $5d50423c547436fe$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $5d50423c547436fe$var$pd);
        },
        persist: function() {},
        isPersistent: $5d50423c547436fe$var$pd
    });
    return b;
}
var $5d50423c547436fe$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5d50423c547436fe$var$td = $5d50423c547436fe$var$rd($5d50423c547436fe$var$sd), $5d50423c547436fe$var$ud = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$sd, {
    view: 0,
    detail: 0
}), $5d50423c547436fe$var$vd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$ud), $5d50423c547436fe$var$wd, $5d50423c547436fe$var$xd, $5d50423c547436fe$var$yd, $5d50423c547436fe$var$Ad = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5d50423c547436fe$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $5d50423c547436fe$var$yd && ($5d50423c547436fe$var$yd && "mousemove" === a.type ? ($5d50423c547436fe$var$wd = a.screenX - $5d50423c547436fe$var$yd.screenX, $5d50423c547436fe$var$xd = a.screenY - $5d50423c547436fe$var$yd.screenY) : $5d50423c547436fe$var$xd = $5d50423c547436fe$var$wd = 0, $5d50423c547436fe$var$yd = a);
        return $5d50423c547436fe$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $5d50423c547436fe$var$xd;
    }
}), $5d50423c547436fe$var$Bd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Ad), $5d50423c547436fe$var$Cd = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$Ad, {
    dataTransfer: 0
}), $5d50423c547436fe$var$Dd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Cd), $5d50423c547436fe$var$Ed = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$ud, {
    relatedTarget: 0
}), $5d50423c547436fe$var$Fd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Ed), $5d50423c547436fe$var$Gd = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5d50423c547436fe$var$Hd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Gd), $5d50423c547436fe$var$Id = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $5d50423c547436fe$var$Jd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Id), $5d50423c547436fe$var$Kd = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$sd, {
    data: 0
}), $5d50423c547436fe$var$Ld = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Kd), $5d50423c547436fe$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5d50423c547436fe$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5d50423c547436fe$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5d50423c547436fe$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $5d50423c547436fe$var$Od[a]) ? !!b[a] : !1;
}
function $5d50423c547436fe$var$zd() {
    return $5d50423c547436fe$var$Pd;
}
var $5d50423c547436fe$var$Qd = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $5d50423c547436fe$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $5d50423c547436fe$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $5d50423c547436fe$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5d50423c547436fe$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $5d50423c547436fe$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $5d50423c547436fe$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $5d50423c547436fe$var$Rd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Qd), $5d50423c547436fe$var$Sd = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5d50423c547436fe$var$Td = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Sd), $5d50423c547436fe$var$Ud = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5d50423c547436fe$var$zd
}), $5d50423c547436fe$var$Vd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Ud), $5d50423c547436fe$var$Wd = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5d50423c547436fe$var$Xd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Wd), $5d50423c547436fe$var$Yd = $5d50423c547436fe$var$A({}, $5d50423c547436fe$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5d50423c547436fe$var$Zd = $5d50423c547436fe$var$rd($5d50423c547436fe$var$Yd), $5d50423c547436fe$var$$d = [
    9,
    13,
    27,
    32
], $5d50423c547436fe$var$ae = $5d50423c547436fe$var$ia && "CompositionEvent" in window, $5d50423c547436fe$var$be = null;
$5d50423c547436fe$var$ia && "documentMode" in document && ($5d50423c547436fe$var$be = document.documentMode);
var $5d50423c547436fe$var$ce = $5d50423c547436fe$var$ia && "TextEvent" in window && !$5d50423c547436fe$var$be, $5d50423c547436fe$var$de = $5d50423c547436fe$var$ia && (!$5d50423c547436fe$var$ae || $5d50423c547436fe$var$be && 8 < $5d50423c547436fe$var$be && 11 >= $5d50423c547436fe$var$be), $5d50423c547436fe$var$ee = String.fromCharCode(32), $5d50423c547436fe$var$fe = !1;
function $5d50423c547436fe$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $5d50423c547436fe$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5d50423c547436fe$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $5d50423c547436fe$var$ie = !1;
function $5d50423c547436fe$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $5d50423c547436fe$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $5d50423c547436fe$var$fe = !0;
            return $5d50423c547436fe$var$ee;
        case "textInput":
            return a = b.data, a === $5d50423c547436fe$var$ee && $5d50423c547436fe$var$fe ? null : a;
        default:
            return null;
    }
}
function $5d50423c547436fe$var$ke(a, b) {
    if ($5d50423c547436fe$var$ie) return "compositionend" === a || !$5d50423c547436fe$var$ae && $5d50423c547436fe$var$ge(a, b) ? (a = $5d50423c547436fe$var$nd(), $5d50423c547436fe$var$md = $5d50423c547436fe$var$ld = $5d50423c547436fe$var$kd = null, $5d50423c547436fe$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $5d50423c547436fe$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $5d50423c547436fe$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5d50423c547436fe$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$5d50423c547436fe$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $5d50423c547436fe$var$ne(a, b, c, d) {
    $5d50423c547436fe$var$Eb(d);
    b = $5d50423c547436fe$var$oe(b, "onChange");
    0 < b.length && (c = new $5d50423c547436fe$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $5d50423c547436fe$var$pe = null, $5d50423c547436fe$var$qe = null;
function $5d50423c547436fe$var$re(a) {
    $5d50423c547436fe$var$se(a, 0);
}
function $5d50423c547436fe$var$te(a) {
    var b = $5d50423c547436fe$var$ue(a);
    if ($5d50423c547436fe$var$Wa(b)) return a;
}
function $5d50423c547436fe$var$ve(a, b) {
    if ("change" === a) return b;
}
var $5d50423c547436fe$var$we = !1;
if ($5d50423c547436fe$var$ia) {
    var $5d50423c547436fe$var$xe;
    if ($5d50423c547436fe$var$ia) {
        var $5d50423c547436fe$var$ye = "oninput" in document;
        if (!$5d50423c547436fe$var$ye) {
            var $5d50423c547436fe$var$ze = document.createElement("div");
            $5d50423c547436fe$var$ze.setAttribute("oninput", "return;");
            $5d50423c547436fe$var$ye = "function" === typeof $5d50423c547436fe$var$ze.oninput;
        }
        $5d50423c547436fe$var$xe = $5d50423c547436fe$var$ye;
    } else $5d50423c547436fe$var$xe = !1;
    $5d50423c547436fe$var$we = $5d50423c547436fe$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $5d50423c547436fe$var$Ae() {
    $5d50423c547436fe$var$pe && ($5d50423c547436fe$var$pe.detachEvent("onpropertychange", $5d50423c547436fe$var$Be), $5d50423c547436fe$var$qe = $5d50423c547436fe$var$pe = null);
}
function $5d50423c547436fe$var$Be(a) {
    if ("value" === a.propertyName && $5d50423c547436fe$var$te($5d50423c547436fe$var$qe)) {
        var b = [];
        $5d50423c547436fe$var$ne(b, $5d50423c547436fe$var$qe, a, $5d50423c547436fe$var$xb(a));
        $5d50423c547436fe$var$Jb($5d50423c547436fe$var$re, b);
    }
}
function $5d50423c547436fe$var$Ce(a, b, c) {
    "focusin" === a ? ($5d50423c547436fe$var$Ae(), $5d50423c547436fe$var$pe = b, $5d50423c547436fe$var$qe = c, $5d50423c547436fe$var$pe.attachEvent("onpropertychange", $5d50423c547436fe$var$Be)) : "focusout" === a && $5d50423c547436fe$var$Ae();
}
function $5d50423c547436fe$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $5d50423c547436fe$var$te($5d50423c547436fe$var$qe);
}
function $5d50423c547436fe$var$Ee(a, b) {
    if ("click" === a) return $5d50423c547436fe$var$te(b);
}
function $5d50423c547436fe$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $5d50423c547436fe$var$te(b);
}
function $5d50423c547436fe$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5d50423c547436fe$var$He = "function" === typeof Object.is ? Object.is : $5d50423c547436fe$var$Ge;
function $5d50423c547436fe$var$Ie(a, b) {
    if ($5d50423c547436fe$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$5d50423c547436fe$var$ja.call(b, e) || !$5d50423c547436fe$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $5d50423c547436fe$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $5d50423c547436fe$var$Ke(a, b) {
    var c = $5d50423c547436fe$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $5d50423c547436fe$var$Je(c);
    }
}
function $5d50423c547436fe$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $5d50423c547436fe$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $5d50423c547436fe$var$Me() {
    for(var a = window, b = $5d50423c547436fe$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $5d50423c547436fe$var$Xa(a.document);
    }
    return b;
}
function $5d50423c547436fe$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $5d50423c547436fe$var$Oe(a) {
    var b = $5d50423c547436fe$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $5d50423c547436fe$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $5d50423c547436fe$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $5d50423c547436fe$var$Ke(c, f);
                var g = $5d50423c547436fe$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $5d50423c547436fe$var$Pe = $5d50423c547436fe$var$ia && "documentMode" in document && 11 >= document.documentMode, $5d50423c547436fe$var$Qe = null, $5d50423c547436fe$var$Re = null, $5d50423c547436fe$var$Se = null, $5d50423c547436fe$var$Te = !1;
function $5d50423c547436fe$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $5d50423c547436fe$var$Te || null == $5d50423c547436fe$var$Qe || $5d50423c547436fe$var$Qe !== $5d50423c547436fe$var$Xa(d) || (d = $5d50423c547436fe$var$Qe, "selectionStart" in d && $5d50423c547436fe$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $5d50423c547436fe$var$Se && $5d50423c547436fe$var$Ie($5d50423c547436fe$var$Se, d) || ($5d50423c547436fe$var$Se = d, d = $5d50423c547436fe$var$oe($5d50423c547436fe$var$Re, "onSelect"), 0 < d.length && (b = new $5d50423c547436fe$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $5d50423c547436fe$var$Qe)));
}
function $5d50423c547436fe$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $5d50423c547436fe$var$We = {
    animationend: $5d50423c547436fe$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $5d50423c547436fe$var$Ve("Animation", "AnimationIteration"),
    animationstart: $5d50423c547436fe$var$Ve("Animation", "AnimationStart"),
    transitionend: $5d50423c547436fe$var$Ve("Transition", "TransitionEnd")
}, $5d50423c547436fe$var$Xe = {}, $5d50423c547436fe$var$Ye = {};
$5d50423c547436fe$var$ia && ($5d50423c547436fe$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $5d50423c547436fe$var$We.animationend.animation, delete $5d50423c547436fe$var$We.animationiteration.animation, delete $5d50423c547436fe$var$We.animationstart.animation), "TransitionEvent" in window || delete $5d50423c547436fe$var$We.transitionend.transition);
function $5d50423c547436fe$var$Ze(a) {
    if ($5d50423c547436fe$var$Xe[a]) return $5d50423c547436fe$var$Xe[a];
    if (!$5d50423c547436fe$var$We[a]) return a;
    var b = $5d50423c547436fe$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $5d50423c547436fe$var$Ye) return $5d50423c547436fe$var$Xe[a] = b[c];
    return a;
}
var $5d50423c547436fe$var$$e = $5d50423c547436fe$var$Ze("animationend"), $5d50423c547436fe$var$af = $5d50423c547436fe$var$Ze("animationiteration"), $5d50423c547436fe$var$bf = $5d50423c547436fe$var$Ze("animationstart"), $5d50423c547436fe$var$cf = $5d50423c547436fe$var$Ze("transitionend"), $5d50423c547436fe$var$df = new Map, $5d50423c547436fe$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $5d50423c547436fe$var$ff(a, b) {
    $5d50423c547436fe$var$df.set(a, b);
    $5d50423c547436fe$var$fa(b, [
        a
    ]);
}
for(var $5d50423c547436fe$var$gf = 0; $5d50423c547436fe$var$gf < $5d50423c547436fe$var$ef.length; $5d50423c547436fe$var$gf++){
    var $5d50423c547436fe$var$hf = $5d50423c547436fe$var$ef[$5d50423c547436fe$var$gf], $5d50423c547436fe$var$jf = $5d50423c547436fe$var$hf.toLowerCase(), $5d50423c547436fe$var$kf = $5d50423c547436fe$var$hf[0].toUpperCase() + $5d50423c547436fe$var$hf.slice(1);
    $5d50423c547436fe$var$ff($5d50423c547436fe$var$jf, "on" + $5d50423c547436fe$var$kf);
}
$5d50423c547436fe$var$ff($5d50423c547436fe$var$$e, "onAnimationEnd");
$5d50423c547436fe$var$ff($5d50423c547436fe$var$af, "onAnimationIteration");
$5d50423c547436fe$var$ff($5d50423c547436fe$var$bf, "onAnimationStart");
$5d50423c547436fe$var$ff("dblclick", "onDoubleClick");
$5d50423c547436fe$var$ff("focusin", "onFocus");
$5d50423c547436fe$var$ff("focusout", "onBlur");
$5d50423c547436fe$var$ff($5d50423c547436fe$var$cf, "onTransitionEnd");
$5d50423c547436fe$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5d50423c547436fe$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5d50423c547436fe$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5d50423c547436fe$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5d50423c547436fe$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5d50423c547436fe$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5d50423c547436fe$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5d50423c547436fe$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5d50423c547436fe$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5d50423c547436fe$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5d50423c547436fe$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5d50423c547436fe$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($5d50423c547436fe$var$lf));
function $5d50423c547436fe$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $5d50423c547436fe$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $5d50423c547436fe$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5d50423c547436fe$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5d50423c547436fe$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($5d50423c547436fe$var$Qb) throw a = $5d50423c547436fe$var$Rb, $5d50423c547436fe$var$Qb = !1, $5d50423c547436fe$var$Rb = null, a;
}
function $5d50423c547436fe$var$D(a, b) {
    var c = b[$5d50423c547436fe$var$of];
    void 0 === c && (c = b[$5d50423c547436fe$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($5d50423c547436fe$var$pf(b, a, 2, !1), c.add(d));
}
function $5d50423c547436fe$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $5d50423c547436fe$var$pf(c, a, d, b);
}
var $5d50423c547436fe$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $5d50423c547436fe$var$sf(a) {
    if (!a[$5d50423c547436fe$var$rf]) {
        a[$5d50423c547436fe$var$rf] = !0;
        $5d50423c547436fe$var$da.forEach(function(b) {
            "selectionchange" !== b && ($5d50423c547436fe$var$mf.has(b) || $5d50423c547436fe$var$qf(b, !1, a), $5d50423c547436fe$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$5d50423c547436fe$var$rf] || (b[$5d50423c547436fe$var$rf] = !0, $5d50423c547436fe$var$qf("selectionchange", !1, b));
    }
}
function $5d50423c547436fe$var$pf(a, b, c, d) {
    switch($5d50423c547436fe$var$jd(b)){
        case 1:
            var e = $5d50423c547436fe$var$ed;
            break;
        case 4:
            e = $5d50423c547436fe$var$gd;
            break;
        default:
            e = $5d50423c547436fe$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$5d50423c547436fe$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $5d50423c547436fe$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $5d50423c547436fe$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $5d50423c547436fe$var$Jb(function() {
        var d = f, e = $5d50423c547436fe$var$xb(c), g = [];
        a: {
            var h = $5d50423c547436fe$var$df.get(a);
            if (void 0 !== h) {
                var k = $5d50423c547436fe$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $5d50423c547436fe$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $5d50423c547436fe$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $5d50423c547436fe$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $5d50423c547436fe$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $5d50423c547436fe$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $5d50423c547436fe$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $5d50423c547436fe$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $5d50423c547436fe$var$Vd;
                        break;
                    case $5d50423c547436fe$var$$e:
                    case $5d50423c547436fe$var$af:
                    case $5d50423c547436fe$var$bf:
                        k = $5d50423c547436fe$var$Hd;
                        break;
                    case $5d50423c547436fe$var$cf:
                        k = $5d50423c547436fe$var$Xd;
                        break;
                    case "scroll":
                        k = $5d50423c547436fe$var$vd;
                        break;
                    case "wheel":
                        k = $5d50423c547436fe$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $5d50423c547436fe$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $5d50423c547436fe$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $5d50423c547436fe$var$Kb(w, x), null != F && t.push($5d50423c547436fe$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $5d50423c547436fe$var$wb && (n = c.relatedTarget || c.fromElement) && ($5d50423c547436fe$var$Wc(n) || n[$5d50423c547436fe$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $5d50423c547436fe$var$Wc(n) : null, null !== n && (J = $5d50423c547436fe$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $5d50423c547436fe$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $5d50423c547436fe$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $5d50423c547436fe$var$ue(k);
                        u = null == n ? h : $5d50423c547436fe$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $5d50423c547436fe$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $5d50423c547436fe$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $5d50423c547436fe$var$vf(F))u++;
                            for(; 0 < w - u;)t = $5d50423c547436fe$var$vf(t), w--;
                            for(; 0 < u - w;)x = $5d50423c547436fe$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $5d50423c547436fe$var$vf(t);
                                x = $5d50423c547436fe$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $5d50423c547436fe$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $5d50423c547436fe$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $5d50423c547436fe$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $5d50423c547436fe$var$ve;
                else if ($5d50423c547436fe$var$me(h)) {
                    if ($5d50423c547436fe$var$we) na = $5d50423c547436fe$var$Fe;
                    else {
                        na = $5d50423c547436fe$var$De;
                        var xa = $5d50423c547436fe$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $5d50423c547436fe$var$Ee);
                if (na && (na = na(a, d))) {
                    $5d50423c547436fe$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $5d50423c547436fe$var$cb(h, "number", h.value);
            }
            xa = d ? $5d50423c547436fe$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($5d50423c547436fe$var$me(xa) || "true" === xa.contentEditable) $5d50423c547436fe$var$Qe = xa, $5d50423c547436fe$var$Re = d, $5d50423c547436fe$var$Se = null;
                    break;
                case "focusout":
                    $5d50423c547436fe$var$Se = $5d50423c547436fe$var$Re = $5d50423c547436fe$var$Qe = null;
                    break;
                case "mousedown":
                    $5d50423c547436fe$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5d50423c547436fe$var$Te = !1;
                    $5d50423c547436fe$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($5d50423c547436fe$var$Pe) break;
                case "keydown":
                case "keyup":
                    $5d50423c547436fe$var$Ue(g, c, e);
            }
            var $a;
            if ($5d50423c547436fe$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $5d50423c547436fe$var$ie ? $5d50423c547436fe$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($5d50423c547436fe$var$de && "ko" !== c.locale && ($5d50423c547436fe$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $5d50423c547436fe$var$ie && ($a = $5d50423c547436fe$var$nd()) : ($5d50423c547436fe$var$kd = e, $5d50423c547436fe$var$ld = "value" in $5d50423c547436fe$var$kd ? $5d50423c547436fe$var$kd.value : $5d50423c547436fe$var$kd.textContent, $5d50423c547436fe$var$ie = !0)), xa = $5d50423c547436fe$var$oe(d, ba), 0 < xa.length && (ba = new $5d50423c547436fe$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $5d50423c547436fe$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $5d50423c547436fe$var$ce ? $5d50423c547436fe$var$je(a, c) : $5d50423c547436fe$var$ke(a, c)) d = $5d50423c547436fe$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $5d50423c547436fe$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $5d50423c547436fe$var$se(g, b);
    });
}
function $5d50423c547436fe$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $5d50423c547436fe$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $5d50423c547436fe$var$Kb(a, c), null != f && d.unshift($5d50423c547436fe$var$tf(a, f, e)), f = $5d50423c547436fe$var$Kb(a, b), null != f && d.push($5d50423c547436fe$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $5d50423c547436fe$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $5d50423c547436fe$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $5d50423c547436fe$var$Kb(c, f), null != k && g.unshift($5d50423c547436fe$var$tf(c, k, h))) : e || (k = $5d50423c547436fe$var$Kb(c, f), null != k && g.push($5d50423c547436fe$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $5d50423c547436fe$var$xf = /\r\n?/g, $5d50423c547436fe$var$yf = /\u0000|\uFFFD/g;
function $5d50423c547436fe$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($5d50423c547436fe$var$xf, "\n").replace($5d50423c547436fe$var$yf, "");
}
function $5d50423c547436fe$var$Af(a, b, c) {
    b = $5d50423c547436fe$var$zf(b);
    if ($5d50423c547436fe$var$zf(a) !== b && c) throw Error($5d50423c547436fe$var$p(425));
}
function $5d50423c547436fe$var$Bf() {}
var $5d50423c547436fe$var$Cf = null, $5d50423c547436fe$var$Df = null;
function $5d50423c547436fe$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $5d50423c547436fe$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $5d50423c547436fe$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $5d50423c547436fe$var$Hf = "function" === typeof Promise ? Promise : void 0, $5d50423c547436fe$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5d50423c547436fe$var$Hf ? function(a) {
    return $5d50423c547436fe$var$Hf.resolve(null).then(a).catch($5d50423c547436fe$var$If);
} : $5d50423c547436fe$var$Ff;
function $5d50423c547436fe$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $5d50423c547436fe$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $5d50423c547436fe$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $5d50423c547436fe$var$bd(b);
}
function $5d50423c547436fe$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $5d50423c547436fe$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $5d50423c547436fe$var$Nf = Math.random().toString(36).slice(2), $5d50423c547436fe$var$Of = "__reactFiber$" + $5d50423c547436fe$var$Nf, $5d50423c547436fe$var$Pf = "__reactProps$" + $5d50423c547436fe$var$Nf, $5d50423c547436fe$var$uf = "__reactContainer$" + $5d50423c547436fe$var$Nf, $5d50423c547436fe$var$of = "__reactEvents$" + $5d50423c547436fe$var$Nf, $5d50423c547436fe$var$Qf = "__reactListeners$" + $5d50423c547436fe$var$Nf, $5d50423c547436fe$var$Rf = "__reactHandles$" + $5d50423c547436fe$var$Nf;
function $5d50423c547436fe$var$Wc(a) {
    var b = a[$5d50423c547436fe$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$5d50423c547436fe$var$uf] || c[$5d50423c547436fe$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $5d50423c547436fe$var$Mf(a); null !== a;){
                if (c = a[$5d50423c547436fe$var$Of]) return c;
                a = $5d50423c547436fe$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $5d50423c547436fe$var$Cb(a) {
    a = a[$5d50423c547436fe$var$Of] || a[$5d50423c547436fe$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $5d50423c547436fe$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($5d50423c547436fe$var$p(33));
}
function $5d50423c547436fe$var$Db(a) {
    return a[$5d50423c547436fe$var$Pf] || null;
}
var $5d50423c547436fe$var$Sf = [], $5d50423c547436fe$var$Tf = -1;
function $5d50423c547436fe$var$Uf(a) {
    return {
        current: a
    };
}
function $5d50423c547436fe$var$E(a) {
    0 > $5d50423c547436fe$var$Tf || (a.current = $5d50423c547436fe$var$Sf[$5d50423c547436fe$var$Tf], $5d50423c547436fe$var$Sf[$5d50423c547436fe$var$Tf] = null, $5d50423c547436fe$var$Tf--);
}
function $5d50423c547436fe$var$G(a, b) {
    $5d50423c547436fe$var$Tf++;
    $5d50423c547436fe$var$Sf[$5d50423c547436fe$var$Tf] = a.current;
    a.current = b;
}
var $5d50423c547436fe$var$Vf = {}, $5d50423c547436fe$var$H = $5d50423c547436fe$var$Uf($5d50423c547436fe$var$Vf), $5d50423c547436fe$var$Wf = $5d50423c547436fe$var$Uf(!1), $5d50423c547436fe$var$Xf = $5d50423c547436fe$var$Vf;
function $5d50423c547436fe$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $5d50423c547436fe$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $5d50423c547436fe$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $5d50423c547436fe$var$$f() {
    $5d50423c547436fe$var$E($5d50423c547436fe$var$Wf);
    $5d50423c547436fe$var$E($5d50423c547436fe$var$H);
}
function $5d50423c547436fe$var$ag(a, b, c) {
    if ($5d50423c547436fe$var$H.current !== $5d50423c547436fe$var$Vf) throw Error($5d50423c547436fe$var$p(168));
    $5d50423c547436fe$var$G($5d50423c547436fe$var$H, b);
    $5d50423c547436fe$var$G($5d50423c547436fe$var$Wf, c);
}
function $5d50423c547436fe$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($5d50423c547436fe$var$p(108, $5d50423c547436fe$var$Ra(a) || "Unknown", e));
    return $5d50423c547436fe$var$A({}, c, d);
}
function $5d50423c547436fe$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $5d50423c547436fe$var$Vf;
    $5d50423c547436fe$var$Xf = $5d50423c547436fe$var$H.current;
    $5d50423c547436fe$var$G($5d50423c547436fe$var$H, a);
    $5d50423c547436fe$var$G($5d50423c547436fe$var$Wf, $5d50423c547436fe$var$Wf.current);
    return !0;
}
function $5d50423c547436fe$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($5d50423c547436fe$var$p(169));
    c ? (a = $5d50423c547436fe$var$bg(a, b, $5d50423c547436fe$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $5d50423c547436fe$var$E($5d50423c547436fe$var$Wf), $5d50423c547436fe$var$E($5d50423c547436fe$var$H), $5d50423c547436fe$var$G($5d50423c547436fe$var$H, a)) : $5d50423c547436fe$var$E($5d50423c547436fe$var$Wf);
    $5d50423c547436fe$var$G($5d50423c547436fe$var$Wf, c);
}
var $5d50423c547436fe$var$eg = null, $5d50423c547436fe$var$fg = !1, $5d50423c547436fe$var$gg = !1;
function $5d50423c547436fe$var$hg(a) {
    null === $5d50423c547436fe$var$eg ? $5d50423c547436fe$var$eg = [
        a
    ] : $5d50423c547436fe$var$eg.push(a);
}
function $5d50423c547436fe$var$ig(a) {
    $5d50423c547436fe$var$fg = !0;
    $5d50423c547436fe$var$hg(a);
}
function $5d50423c547436fe$var$jg() {
    if (!$5d50423c547436fe$var$gg && null !== $5d50423c547436fe$var$eg) {
        $5d50423c547436fe$var$gg = !0;
        var a = 0, b = $5d50423c547436fe$var$C;
        try {
            var c = $5d50423c547436fe$var$eg;
            for($5d50423c547436fe$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $5d50423c547436fe$var$eg = null;
            $5d50423c547436fe$var$fg = !1;
        } catch (e) {
            throw null !== $5d50423c547436fe$var$eg && ($5d50423c547436fe$var$eg = $5d50423c547436fe$var$eg.slice(a + 1)), $5d50423c547436fe$var$ac($5d50423c547436fe$var$fc, $5d50423c547436fe$var$jg), e;
        } finally{
            $5d50423c547436fe$var$C = b, $5d50423c547436fe$var$gg = !1;
        }
    }
    return null;
}
var $5d50423c547436fe$var$kg = [], $5d50423c547436fe$var$lg = 0, $5d50423c547436fe$var$mg = null, $5d50423c547436fe$var$ng = 0, $5d50423c547436fe$var$og = [], $5d50423c547436fe$var$pg = 0, $5d50423c547436fe$var$qg = null, $5d50423c547436fe$var$rg = 1, $5d50423c547436fe$var$sg = "";
function $5d50423c547436fe$var$tg(a, b) {
    $5d50423c547436fe$var$kg[$5d50423c547436fe$var$lg++] = $5d50423c547436fe$var$ng;
    $5d50423c547436fe$var$kg[$5d50423c547436fe$var$lg++] = $5d50423c547436fe$var$mg;
    $5d50423c547436fe$var$mg = a;
    $5d50423c547436fe$var$ng = b;
}
function $5d50423c547436fe$var$ug(a, b, c) {
    $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg++] = $5d50423c547436fe$var$rg;
    $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg++] = $5d50423c547436fe$var$sg;
    $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg++] = $5d50423c547436fe$var$qg;
    $5d50423c547436fe$var$qg = a;
    var d = $5d50423c547436fe$var$rg;
    a = $5d50423c547436fe$var$sg;
    var e = 32 - $5d50423c547436fe$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $5d50423c547436fe$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $5d50423c547436fe$var$rg = 1 << 32 - $5d50423c547436fe$var$oc(b) + e | c << e | d;
        $5d50423c547436fe$var$sg = f + a;
    } else $5d50423c547436fe$var$rg = 1 << f | c << e | d, $5d50423c547436fe$var$sg = a;
}
function $5d50423c547436fe$var$vg(a) {
    null !== a.return && ($5d50423c547436fe$var$tg(a, 1), $5d50423c547436fe$var$ug(a, 1, 0));
}
function $5d50423c547436fe$var$wg(a) {
    for(; a === $5d50423c547436fe$var$mg;)$5d50423c547436fe$var$mg = $5d50423c547436fe$var$kg[--$5d50423c547436fe$var$lg], $5d50423c547436fe$var$kg[$5d50423c547436fe$var$lg] = null, $5d50423c547436fe$var$ng = $5d50423c547436fe$var$kg[--$5d50423c547436fe$var$lg], $5d50423c547436fe$var$kg[$5d50423c547436fe$var$lg] = null;
    for(; a === $5d50423c547436fe$var$qg;)$5d50423c547436fe$var$qg = $5d50423c547436fe$var$og[--$5d50423c547436fe$var$pg], $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg] = null, $5d50423c547436fe$var$sg = $5d50423c547436fe$var$og[--$5d50423c547436fe$var$pg], $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg] = null, $5d50423c547436fe$var$rg = $5d50423c547436fe$var$og[--$5d50423c547436fe$var$pg], $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg] = null;
}
var $5d50423c547436fe$var$xg = null, $5d50423c547436fe$var$yg = null, $5d50423c547436fe$var$I = !1, $5d50423c547436fe$var$zg = null;
function $5d50423c547436fe$var$Ag(a, b) {
    var c = $5d50423c547436fe$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $5d50423c547436fe$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $5d50423c547436fe$var$xg = a, $5d50423c547436fe$var$yg = $5d50423c547436fe$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $5d50423c547436fe$var$xg = a, $5d50423c547436fe$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $5d50423c547436fe$var$qg ? {
                id: $5d50423c547436fe$var$rg,
                overflow: $5d50423c547436fe$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $5d50423c547436fe$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $5d50423c547436fe$var$xg = a, $5d50423c547436fe$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $5d50423c547436fe$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $5d50423c547436fe$var$Eg(a) {
    if ($5d50423c547436fe$var$I) {
        var b = $5d50423c547436fe$var$yg;
        if (b) {
            var c = b;
            if (!$5d50423c547436fe$var$Cg(a, b)) {
                if ($5d50423c547436fe$var$Dg(a)) throw Error($5d50423c547436fe$var$p(418));
                b = $5d50423c547436fe$var$Lf(c.nextSibling);
                var d = $5d50423c547436fe$var$xg;
                b && $5d50423c547436fe$var$Cg(a, b) ? $5d50423c547436fe$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $5d50423c547436fe$var$I = !1, $5d50423c547436fe$var$xg = a);
            }
        } else {
            if ($5d50423c547436fe$var$Dg(a)) throw Error($5d50423c547436fe$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $5d50423c547436fe$var$I = !1;
            $5d50423c547436fe$var$xg = a;
        }
    }
}
function $5d50423c547436fe$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $5d50423c547436fe$var$xg = a;
}
function $5d50423c547436fe$var$Gg(a) {
    if (a !== $5d50423c547436fe$var$xg) return !1;
    if (!$5d50423c547436fe$var$I) return $5d50423c547436fe$var$Fg(a), $5d50423c547436fe$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$5d50423c547436fe$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $5d50423c547436fe$var$yg)) {
        if ($5d50423c547436fe$var$Dg(a)) throw $5d50423c547436fe$var$Hg(), Error($5d50423c547436fe$var$p(418));
        for(; b;)$5d50423c547436fe$var$Ag(a, b), b = $5d50423c547436fe$var$Lf(b.nextSibling);
    }
    $5d50423c547436fe$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($5d50423c547436fe$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $5d50423c547436fe$var$yg = $5d50423c547436fe$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $5d50423c547436fe$var$yg = null;
        }
    } else $5d50423c547436fe$var$yg = $5d50423c547436fe$var$xg ? $5d50423c547436fe$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $5d50423c547436fe$var$Hg() {
    for(var a = $5d50423c547436fe$var$yg; a;)a = $5d50423c547436fe$var$Lf(a.nextSibling);
}
function $5d50423c547436fe$var$Ig() {
    $5d50423c547436fe$var$yg = $5d50423c547436fe$var$xg = null;
    $5d50423c547436fe$var$I = !1;
}
function $5d50423c547436fe$var$Jg(a) {
    null === $5d50423c547436fe$var$zg ? $5d50423c547436fe$var$zg = [
        a
    ] : $5d50423c547436fe$var$zg.push(a);
}
var $5d50423c547436fe$var$Kg = $5d50423c547436fe$var$ua.ReactCurrentBatchConfig;
function $5d50423c547436fe$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($5d50423c547436fe$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($5d50423c547436fe$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($5d50423c547436fe$var$p(284));
        if (!c._owner) throw Error($5d50423c547436fe$var$p(290, a));
    }
    return a;
}
function $5d50423c547436fe$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($5d50423c547436fe$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $5d50423c547436fe$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $5d50423c547436fe$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $5d50423c547436fe$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $5d50423c547436fe$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $5d50423c547436fe$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $5d50423c547436fe$var$Ha && $5d50423c547436fe$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $5d50423c547436fe$var$Lg(a, b, c), d.return = a, d;
        d = $5d50423c547436fe$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $5d50423c547436fe$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $5d50423c547436fe$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $5d50423c547436fe$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $5d50423c547436fe$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $5d50423c547436fe$var$va:
                    return c = $5d50423c547436fe$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $5d50423c547436fe$var$Lg(a, null, b), c.return = a, c;
                case $5d50423c547436fe$var$wa:
                    return b = $5d50423c547436fe$var$Sg(b, a.mode, c), b.return = a, b;
                case $5d50423c547436fe$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($5d50423c547436fe$var$eb(b) || $5d50423c547436fe$var$Ka(b)) return b = $5d50423c547436fe$var$Tg(b, a.mode, c, null), b.return = a, b;
            $5d50423c547436fe$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $5d50423c547436fe$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $5d50423c547436fe$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $5d50423c547436fe$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($5d50423c547436fe$var$eb(c) || $5d50423c547436fe$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $5d50423c547436fe$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $5d50423c547436fe$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $5d50423c547436fe$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $5d50423c547436fe$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($5d50423c547436fe$var$eb(d) || $5d50423c547436fe$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $5d50423c547436fe$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $5d50423c547436fe$var$I && $5d50423c547436fe$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $5d50423c547436fe$var$I && $5d50423c547436fe$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $5d50423c547436fe$var$I && $5d50423c547436fe$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $5d50423c547436fe$var$Ka(h);
        if ("function" !== typeof l) throw Error($5d50423c547436fe$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($5d50423c547436fe$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $5d50423c547436fe$var$I && $5d50423c547436fe$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $5d50423c547436fe$var$I && $5d50423c547436fe$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $5d50423c547436fe$var$I && $5d50423c547436fe$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $5d50423c547436fe$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $5d50423c547436fe$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $5d50423c547436fe$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $5d50423c547436fe$var$Ha && $5d50423c547436fe$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $5d50423c547436fe$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $5d50423c547436fe$var$ya ? (d = $5d50423c547436fe$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $5d50423c547436fe$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $5d50423c547436fe$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $5d50423c547436fe$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $5d50423c547436fe$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $5d50423c547436fe$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($5d50423c547436fe$var$eb(f)) return n(a, d, f, h);
            if ($5d50423c547436fe$var$Ka(f)) return t(a, d, f, h);
            $5d50423c547436fe$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $5d50423c547436fe$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $5d50423c547436fe$var$Ug = $5d50423c547436fe$var$Og(!0), $5d50423c547436fe$var$Vg = $5d50423c547436fe$var$Og(!1), $5d50423c547436fe$var$Wg = $5d50423c547436fe$var$Uf(null), $5d50423c547436fe$var$Xg = null, $5d50423c547436fe$var$Yg = null, $5d50423c547436fe$var$Zg = null;
function $5d50423c547436fe$var$$g() {
    $5d50423c547436fe$var$Zg = $5d50423c547436fe$var$Yg = $5d50423c547436fe$var$Xg = null;
}
function $5d50423c547436fe$var$ah(a) {
    var b = $5d50423c547436fe$var$Wg.current;
    $5d50423c547436fe$var$E($5d50423c547436fe$var$Wg);
    a._currentValue = b;
}
function $5d50423c547436fe$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $5d50423c547436fe$var$ch(a, b) {
    $5d50423c547436fe$var$Xg = a;
    $5d50423c547436fe$var$Zg = $5d50423c547436fe$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($5d50423c547436fe$var$dh = !0), a.firstContext = null);
}
function $5d50423c547436fe$var$eh(a) {
    var b = a._currentValue;
    if ($5d50423c547436fe$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $5d50423c547436fe$var$Yg) {
            if (null === $5d50423c547436fe$var$Xg) throw Error($5d50423c547436fe$var$p(308));
            $5d50423c547436fe$var$Yg = a;
            $5d50423c547436fe$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $5d50423c547436fe$var$Yg = $5d50423c547436fe$var$Yg.next = a;
    }
    return b;
}
var $5d50423c547436fe$var$fh = null;
function $5d50423c547436fe$var$gh(a) {
    null === $5d50423c547436fe$var$fh ? $5d50423c547436fe$var$fh = [
        a
    ] : $5d50423c547436fe$var$fh.push(a);
}
function $5d50423c547436fe$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $5d50423c547436fe$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $5d50423c547436fe$var$ih(a, d);
}
function $5d50423c547436fe$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $5d50423c547436fe$var$jh = !1;
function $5d50423c547436fe$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $5d50423c547436fe$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $5d50423c547436fe$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5d50423c547436fe$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($5d50423c547436fe$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $5d50423c547436fe$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $5d50423c547436fe$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $5d50423c547436fe$var$ih(a, c);
}
function $5d50423c547436fe$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5d50423c547436fe$var$Cc(a, c);
    }
}
function $5d50423c547436fe$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $5d50423c547436fe$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $5d50423c547436fe$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $5d50423c547436fe$var$A({}, q, r);
                            break a;
                        case 2:
                            $5d50423c547436fe$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $5d50423c547436fe$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $5d50423c547436fe$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($5d50423c547436fe$var$p(191, e));
            e.call(d);
        }
    }
}
var $5d50423c547436fe$var$th = {}, $5d50423c547436fe$var$uh = $5d50423c547436fe$var$Uf($5d50423c547436fe$var$th), $5d50423c547436fe$var$vh = $5d50423c547436fe$var$Uf($5d50423c547436fe$var$th), $5d50423c547436fe$var$wh = $5d50423c547436fe$var$Uf($5d50423c547436fe$var$th);
function $5d50423c547436fe$var$xh(a) {
    if (a === $5d50423c547436fe$var$th) throw Error($5d50423c547436fe$var$p(174));
    return a;
}
function $5d50423c547436fe$var$yh(a, b) {
    $5d50423c547436fe$var$G($5d50423c547436fe$var$wh, b);
    $5d50423c547436fe$var$G($5d50423c547436fe$var$vh, a);
    $5d50423c547436fe$var$G($5d50423c547436fe$var$uh, $5d50423c547436fe$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $5d50423c547436fe$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $5d50423c547436fe$var$lb(b, a);
    }
    $5d50423c547436fe$var$E($5d50423c547436fe$var$uh);
    $5d50423c547436fe$var$G($5d50423c547436fe$var$uh, b);
}
function $5d50423c547436fe$var$zh() {
    $5d50423c547436fe$var$E($5d50423c547436fe$var$uh);
    $5d50423c547436fe$var$E($5d50423c547436fe$var$vh);
    $5d50423c547436fe$var$E($5d50423c547436fe$var$wh);
}
function $5d50423c547436fe$var$Ah(a) {
    $5d50423c547436fe$var$xh($5d50423c547436fe$var$wh.current);
    var b = $5d50423c547436fe$var$xh($5d50423c547436fe$var$uh.current);
    var c = $5d50423c547436fe$var$lb(b, a.type);
    b !== c && ($5d50423c547436fe$var$G($5d50423c547436fe$var$vh, a), $5d50423c547436fe$var$G($5d50423c547436fe$var$uh, c));
}
function $5d50423c547436fe$var$Bh(a) {
    $5d50423c547436fe$var$vh.current === a && ($5d50423c547436fe$var$E($5d50423c547436fe$var$uh), $5d50423c547436fe$var$E($5d50423c547436fe$var$vh));
}
var $5d50423c547436fe$var$L = $5d50423c547436fe$var$Uf(0);
function $5d50423c547436fe$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $5d50423c547436fe$var$Dh = [];
function $5d50423c547436fe$var$Eh() {
    for(var a = 0; a < $5d50423c547436fe$var$Dh.length; a++)$5d50423c547436fe$var$Dh[a]._workInProgressVersionPrimary = null;
    $5d50423c547436fe$var$Dh.length = 0;
}
var $5d50423c547436fe$var$Fh = $5d50423c547436fe$var$ua.ReactCurrentDispatcher, $5d50423c547436fe$var$Gh = $5d50423c547436fe$var$ua.ReactCurrentBatchConfig, $5d50423c547436fe$var$Hh = 0, $5d50423c547436fe$var$M = null, $5d50423c547436fe$var$N = null, $5d50423c547436fe$var$O = null, $5d50423c547436fe$var$Ih = !1, $5d50423c547436fe$var$Jh = !1, $5d50423c547436fe$var$Kh = 0, $5d50423c547436fe$var$Lh = 0;
function $5d50423c547436fe$var$P() {
    throw Error($5d50423c547436fe$var$p(321));
}
function $5d50423c547436fe$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$5d50423c547436fe$var$He(a[c], b[c])) return !1;
    return !0;
}
function $5d50423c547436fe$var$Nh(a, b, c, d, e, f) {
    $5d50423c547436fe$var$Hh = f;
    $5d50423c547436fe$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $5d50423c547436fe$var$Fh.current = null === a || null === a.memoizedState ? $5d50423c547436fe$var$Oh : $5d50423c547436fe$var$Ph;
    a = c(d, e);
    if ($5d50423c547436fe$var$Jh) {
        f = 0;
        do {
            $5d50423c547436fe$var$Jh = !1;
            $5d50423c547436fe$var$Kh = 0;
            if (25 <= f) throw Error($5d50423c547436fe$var$p(301));
            f += 1;
            $5d50423c547436fe$var$O = $5d50423c547436fe$var$N = null;
            b.updateQueue = null;
            $5d50423c547436fe$var$Fh.current = $5d50423c547436fe$var$Qh;
            a = c(d, e);
        }while ($5d50423c547436fe$var$Jh);
    }
    $5d50423c547436fe$var$Fh.current = $5d50423c547436fe$var$Rh;
    b = null !== $5d50423c547436fe$var$N && null !== $5d50423c547436fe$var$N.next;
    $5d50423c547436fe$var$Hh = 0;
    $5d50423c547436fe$var$O = $5d50423c547436fe$var$N = $5d50423c547436fe$var$M = null;
    $5d50423c547436fe$var$Ih = !1;
    if (b) throw Error($5d50423c547436fe$var$p(300));
    return a;
}
function $5d50423c547436fe$var$Sh() {
    var a = 0 !== $5d50423c547436fe$var$Kh;
    $5d50423c547436fe$var$Kh = 0;
    return a;
}
function $5d50423c547436fe$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5d50423c547436fe$var$O ? $5d50423c547436fe$var$M.memoizedState = $5d50423c547436fe$var$O = a : $5d50423c547436fe$var$O = $5d50423c547436fe$var$O.next = a;
    return $5d50423c547436fe$var$O;
}
function $5d50423c547436fe$var$Uh() {
    if (null === $5d50423c547436fe$var$N) {
        var a = $5d50423c547436fe$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $5d50423c547436fe$var$N.next;
    var b = null === $5d50423c547436fe$var$O ? $5d50423c547436fe$var$M.memoizedState : $5d50423c547436fe$var$O.next;
    if (null !== b) $5d50423c547436fe$var$O = b, $5d50423c547436fe$var$N = a;
    else {
        if (null === a) throw Error($5d50423c547436fe$var$p(310));
        $5d50423c547436fe$var$N = a;
        a = {
            memoizedState: $5d50423c547436fe$var$N.memoizedState,
            baseState: $5d50423c547436fe$var$N.baseState,
            baseQueue: $5d50423c547436fe$var$N.baseQueue,
            queue: $5d50423c547436fe$var$N.queue,
            next: null
        };
        null === $5d50423c547436fe$var$O ? $5d50423c547436fe$var$M.memoizedState = $5d50423c547436fe$var$O = a : $5d50423c547436fe$var$O = $5d50423c547436fe$var$O.next = a;
    }
    return $5d50423c547436fe$var$O;
}
function $5d50423c547436fe$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5d50423c547436fe$var$Wh(a) {
    var b = $5d50423c547436fe$var$Uh(), c = b.queue;
    if (null === c) throw Error($5d50423c547436fe$var$p(311));
    c.lastRenderedReducer = a;
    var d = $5d50423c547436fe$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($5d50423c547436fe$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $5d50423c547436fe$var$M.lanes |= m;
                $5d50423c547436fe$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $5d50423c547436fe$var$He(d, b.memoizedState) || ($5d50423c547436fe$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $5d50423c547436fe$var$M.lanes |= f, $5d50423c547436fe$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $5d50423c547436fe$var$Xh(a) {
    var b = $5d50423c547436fe$var$Uh(), c = b.queue;
    if (null === c) throw Error($5d50423c547436fe$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $5d50423c547436fe$var$He(f, b.memoizedState) || ($5d50423c547436fe$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $5d50423c547436fe$var$Yh() {}
function $5d50423c547436fe$var$Zh(a, b) {
    var c = $5d50423c547436fe$var$M, d = $5d50423c547436fe$var$Uh(), e = b(), f = !$5d50423c547436fe$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $5d50423c547436fe$var$dh = !0);
    d = d.queue;
    $5d50423c547436fe$var$$h($5d50423c547436fe$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $5d50423c547436fe$var$O && $5d50423c547436fe$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $5d50423c547436fe$var$bi(9, $5d50423c547436fe$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $5d50423c547436fe$var$Q) throw Error($5d50423c547436fe$var$p(349));
        0 !== ($5d50423c547436fe$var$Hh & 30) || $5d50423c547436fe$var$di(c, b, e);
    }
    return e;
}
function $5d50423c547436fe$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $5d50423c547436fe$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5d50423c547436fe$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $5d50423c547436fe$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $5d50423c547436fe$var$ei(b) && $5d50423c547436fe$var$fi(a);
}
function $5d50423c547436fe$var$ai(a, b, c) {
    return c(function() {
        $5d50423c547436fe$var$ei(b) && $5d50423c547436fe$var$fi(a);
    });
}
function $5d50423c547436fe$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$5d50423c547436fe$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $5d50423c547436fe$var$fi(a) {
    var b = $5d50423c547436fe$var$ih(a, 1);
    null !== b && $5d50423c547436fe$var$gi(b, a, 1, -1);
}
function $5d50423c547436fe$var$hi(a) {
    var b = $5d50423c547436fe$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5d50423c547436fe$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $5d50423c547436fe$var$ii.bind(null, $5d50423c547436fe$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $5d50423c547436fe$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $5d50423c547436fe$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5d50423c547436fe$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $5d50423c547436fe$var$ji() {
    return $5d50423c547436fe$var$Uh().memoizedState;
}
function $5d50423c547436fe$var$ki(a, b, c, d) {
    var e = $5d50423c547436fe$var$Th();
    $5d50423c547436fe$var$M.flags |= a;
    e.memoizedState = $5d50423c547436fe$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $5d50423c547436fe$var$li(a, b, c, d) {
    var e = $5d50423c547436fe$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $5d50423c547436fe$var$N) {
        var g = $5d50423c547436fe$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $5d50423c547436fe$var$Mh(d, g.deps)) {
            e.memoizedState = $5d50423c547436fe$var$bi(b, c, f, d);
            return;
        }
    }
    $5d50423c547436fe$var$M.flags |= a;
    e.memoizedState = $5d50423c547436fe$var$bi(1 | b, c, f, d);
}
function $5d50423c547436fe$var$mi(a, b) {
    return $5d50423c547436fe$var$ki(8390656, 8, a, b);
}
function $5d50423c547436fe$var$$h(a, b) {
    return $5d50423c547436fe$var$li(2048, 8, a, b);
}
function $5d50423c547436fe$var$ni(a, b) {
    return $5d50423c547436fe$var$li(4, 2, a, b);
}
function $5d50423c547436fe$var$oi(a, b) {
    return $5d50423c547436fe$var$li(4, 4, a, b);
}
function $5d50423c547436fe$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $5d50423c547436fe$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $5d50423c547436fe$var$li(4, 4, $5d50423c547436fe$var$pi.bind(null, b, a), c);
}
function $5d50423c547436fe$var$ri() {}
function $5d50423c547436fe$var$si(a, b) {
    var c = $5d50423c547436fe$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5d50423c547436fe$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5d50423c547436fe$var$ti(a, b) {
    var c = $5d50423c547436fe$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5d50423c547436fe$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5d50423c547436fe$var$ui(a, b, c) {
    if (0 === ($5d50423c547436fe$var$Hh & 21)) return a.baseState && (a.baseState = !1, $5d50423c547436fe$var$dh = !0), a.memoizedState = c;
    $5d50423c547436fe$var$He(c, b) || (c = $5d50423c547436fe$var$yc(), $5d50423c547436fe$var$M.lanes |= c, $5d50423c547436fe$var$rh |= c, a.baseState = !0);
    return b;
}
function $5d50423c547436fe$var$vi(a, b) {
    var c = $5d50423c547436fe$var$C;
    $5d50423c547436fe$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $5d50423c547436fe$var$Gh.transition;
    $5d50423c547436fe$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $5d50423c547436fe$var$C = c, $5d50423c547436fe$var$Gh.transition = d;
    }
}
function $5d50423c547436fe$var$wi() {
    return $5d50423c547436fe$var$Uh().memoizedState;
}
function $5d50423c547436fe$var$xi(a, b, c) {
    var d = $5d50423c547436fe$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5d50423c547436fe$var$zi(a)) $5d50423c547436fe$var$Ai(b, c);
    else if (c = $5d50423c547436fe$var$hh(a, b, c, d), null !== c) {
        var e = $5d50423c547436fe$var$R();
        $5d50423c547436fe$var$gi(c, a, d, e);
        $5d50423c547436fe$var$Bi(c, b, d);
    }
}
function $5d50423c547436fe$var$ii(a, b, c) {
    var d = $5d50423c547436fe$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5d50423c547436fe$var$zi(a)) $5d50423c547436fe$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($5d50423c547436fe$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $5d50423c547436fe$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $5d50423c547436fe$var$hh(a, b, e, d);
        null !== c && (e = $5d50423c547436fe$var$R(), $5d50423c547436fe$var$gi(c, a, d, e), $5d50423c547436fe$var$Bi(c, b, d));
    }
}
function $5d50423c547436fe$var$zi(a) {
    var b = a.alternate;
    return a === $5d50423c547436fe$var$M || null !== b && b === $5d50423c547436fe$var$M;
}
function $5d50423c547436fe$var$Ai(a, b) {
    $5d50423c547436fe$var$Jh = $5d50423c547436fe$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $5d50423c547436fe$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5d50423c547436fe$var$Cc(a, c);
    }
}
var $5d50423c547436fe$var$Rh = {
    readContext: $5d50423c547436fe$var$eh,
    useCallback: $5d50423c547436fe$var$P,
    useContext: $5d50423c547436fe$var$P,
    useEffect: $5d50423c547436fe$var$P,
    useImperativeHandle: $5d50423c547436fe$var$P,
    useInsertionEffect: $5d50423c547436fe$var$P,
    useLayoutEffect: $5d50423c547436fe$var$P,
    useMemo: $5d50423c547436fe$var$P,
    useReducer: $5d50423c547436fe$var$P,
    useRef: $5d50423c547436fe$var$P,
    useState: $5d50423c547436fe$var$P,
    useDebugValue: $5d50423c547436fe$var$P,
    useDeferredValue: $5d50423c547436fe$var$P,
    useTransition: $5d50423c547436fe$var$P,
    useMutableSource: $5d50423c547436fe$var$P,
    useSyncExternalStore: $5d50423c547436fe$var$P,
    useId: $5d50423c547436fe$var$P,
    unstable_isNewReconciler: !1
}, $5d50423c547436fe$var$Oh = {
    readContext: $5d50423c547436fe$var$eh,
    useCallback: function(a, b) {
        $5d50423c547436fe$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $5d50423c547436fe$var$eh,
    useEffect: $5d50423c547436fe$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $5d50423c547436fe$var$ki(4194308, 4, $5d50423c547436fe$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $5d50423c547436fe$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $5d50423c547436fe$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $5d50423c547436fe$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $5d50423c547436fe$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $5d50423c547436fe$var$xi.bind(null, $5d50423c547436fe$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $5d50423c547436fe$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $5d50423c547436fe$var$hi,
    useDebugValue: $5d50423c547436fe$var$ri,
    useDeferredValue: function(a) {
        return $5d50423c547436fe$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $5d50423c547436fe$var$hi(!1), b = a[0];
        a = $5d50423c547436fe$var$vi.bind(null, a[1]);
        $5d50423c547436fe$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $5d50423c547436fe$var$M, e = $5d50423c547436fe$var$Th();
        if ($5d50423c547436fe$var$I) {
            if (void 0 === c) throw Error($5d50423c547436fe$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $5d50423c547436fe$var$Q) throw Error($5d50423c547436fe$var$p(349));
            0 !== ($5d50423c547436fe$var$Hh & 30) || $5d50423c547436fe$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $5d50423c547436fe$var$mi($5d50423c547436fe$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $5d50423c547436fe$var$bi(9, $5d50423c547436fe$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $5d50423c547436fe$var$Th(), b = $5d50423c547436fe$var$Q.identifierPrefix;
        if ($5d50423c547436fe$var$I) {
            var c = $5d50423c547436fe$var$sg;
            var d = $5d50423c547436fe$var$rg;
            c = (d & ~(1 << 32 - $5d50423c547436fe$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $5d50423c547436fe$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $5d50423c547436fe$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $5d50423c547436fe$var$Ph = {
    readContext: $5d50423c547436fe$var$eh,
    useCallback: $5d50423c547436fe$var$si,
    useContext: $5d50423c547436fe$var$eh,
    useEffect: $5d50423c547436fe$var$$h,
    useImperativeHandle: $5d50423c547436fe$var$qi,
    useInsertionEffect: $5d50423c547436fe$var$ni,
    useLayoutEffect: $5d50423c547436fe$var$oi,
    useMemo: $5d50423c547436fe$var$ti,
    useReducer: $5d50423c547436fe$var$Wh,
    useRef: $5d50423c547436fe$var$ji,
    useState: function() {
        return $5d50423c547436fe$var$Wh($5d50423c547436fe$var$Vh);
    },
    useDebugValue: $5d50423c547436fe$var$ri,
    useDeferredValue: function(a) {
        var b = $5d50423c547436fe$var$Uh();
        return $5d50423c547436fe$var$ui(b, $5d50423c547436fe$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $5d50423c547436fe$var$Wh($5d50423c547436fe$var$Vh)[0], b = $5d50423c547436fe$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5d50423c547436fe$var$Yh,
    useSyncExternalStore: $5d50423c547436fe$var$Zh,
    useId: $5d50423c547436fe$var$wi,
    unstable_isNewReconciler: !1
}, $5d50423c547436fe$var$Qh = {
    readContext: $5d50423c547436fe$var$eh,
    useCallback: $5d50423c547436fe$var$si,
    useContext: $5d50423c547436fe$var$eh,
    useEffect: $5d50423c547436fe$var$$h,
    useImperativeHandle: $5d50423c547436fe$var$qi,
    useInsertionEffect: $5d50423c547436fe$var$ni,
    useLayoutEffect: $5d50423c547436fe$var$oi,
    useMemo: $5d50423c547436fe$var$ti,
    useReducer: $5d50423c547436fe$var$Xh,
    useRef: $5d50423c547436fe$var$ji,
    useState: function() {
        return $5d50423c547436fe$var$Xh($5d50423c547436fe$var$Vh);
    },
    useDebugValue: $5d50423c547436fe$var$ri,
    useDeferredValue: function(a) {
        var b = $5d50423c547436fe$var$Uh();
        return null === $5d50423c547436fe$var$N ? b.memoizedState = a : $5d50423c547436fe$var$ui(b, $5d50423c547436fe$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $5d50423c547436fe$var$Xh($5d50423c547436fe$var$Vh)[0], b = $5d50423c547436fe$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5d50423c547436fe$var$Yh,
    useSyncExternalStore: $5d50423c547436fe$var$Zh,
    useId: $5d50423c547436fe$var$wi,
    unstable_isNewReconciler: !1
};
function $5d50423c547436fe$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $5d50423c547436fe$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $5d50423c547436fe$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5d50423c547436fe$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $5d50423c547436fe$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $5d50423c547436fe$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5d50423c547436fe$var$R(), e = $5d50423c547436fe$var$yi(a), f = $5d50423c547436fe$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5d50423c547436fe$var$nh(a, f, e);
        null !== b && ($5d50423c547436fe$var$gi(b, a, e, d), $5d50423c547436fe$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5d50423c547436fe$var$R(), e = $5d50423c547436fe$var$yi(a), f = $5d50423c547436fe$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5d50423c547436fe$var$nh(a, f, e);
        null !== b && ($5d50423c547436fe$var$gi(b, a, e, d), $5d50423c547436fe$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $5d50423c547436fe$var$R(), d = $5d50423c547436fe$var$yi(a), e = $5d50423c547436fe$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $5d50423c547436fe$var$nh(a, e, d);
        null !== b && ($5d50423c547436fe$var$gi(b, a, d, c), $5d50423c547436fe$var$oh(b, a, d));
    }
};
function $5d50423c547436fe$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$5d50423c547436fe$var$Ie(c, d) || !$5d50423c547436fe$var$Ie(e, f) : !0;
}
function $5d50423c547436fe$var$Gi(a, b, c) {
    var d = !1, e = $5d50423c547436fe$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $5d50423c547436fe$var$eh(f) : (e = $5d50423c547436fe$var$Zf(b) ? $5d50423c547436fe$var$Xf : $5d50423c547436fe$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $5d50423c547436fe$var$Yf(a, e) : $5d50423c547436fe$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $5d50423c547436fe$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $5d50423c547436fe$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $5d50423c547436fe$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $5d50423c547436fe$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $5d50423c547436fe$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $5d50423c547436fe$var$eh(f) : (f = $5d50423c547436fe$var$Zf(b) ? $5d50423c547436fe$var$Xf : $5d50423c547436fe$var$H.current, e.context = $5d50423c547436fe$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($5d50423c547436fe$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $5d50423c547436fe$var$Ei.enqueueReplaceState(e, e.state, null), $5d50423c547436fe$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $5d50423c547436fe$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $5d50423c547436fe$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $5d50423c547436fe$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $5d50423c547436fe$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $5d50423c547436fe$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $5d50423c547436fe$var$Ni(a, b, c) {
    c = $5d50423c547436fe$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $5d50423c547436fe$var$Oi || ($5d50423c547436fe$var$Oi = !0, $5d50423c547436fe$var$Pi = d);
        $5d50423c547436fe$var$Li(a, b);
    };
    return c;
}
function $5d50423c547436fe$var$Qi(a, b, c) {
    c = $5d50423c547436fe$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $5d50423c547436fe$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $5d50423c547436fe$var$Li(a, b);
        "function" !== typeof d && (null === $5d50423c547436fe$var$Ri ? $5d50423c547436fe$var$Ri = new Set([
            this
        ]) : $5d50423c547436fe$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $5d50423c547436fe$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $5d50423c547436fe$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $5d50423c547436fe$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $5d50423c547436fe$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $5d50423c547436fe$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $5d50423c547436fe$var$mh(-1, 1), b.tag = 2, $5d50423c547436fe$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $5d50423c547436fe$var$Wi = $5d50423c547436fe$var$ua.ReactCurrentOwner, $5d50423c547436fe$var$dh = !1;
function $5d50423c547436fe$var$Xi(a, b, c, d) {
    b.child = null === a ? $5d50423c547436fe$var$Vg(b, null, c, d) : $5d50423c547436fe$var$Ug(b, a.child, c, d);
}
function $5d50423c547436fe$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $5d50423c547436fe$var$ch(b, e);
    d = $5d50423c547436fe$var$Nh(a, b, c, d, f, e);
    c = $5d50423c547436fe$var$Sh();
    if (null !== a && !$5d50423c547436fe$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5d50423c547436fe$var$Zi(a, b, e);
    $5d50423c547436fe$var$I && c && $5d50423c547436fe$var$vg(b);
    b.flags |= 1;
    $5d50423c547436fe$var$Xi(a, b, d, e);
    return b.child;
}
function $5d50423c547436fe$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$5d50423c547436fe$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $5d50423c547436fe$var$bj(a, b, f, d, e);
        a = $5d50423c547436fe$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $5d50423c547436fe$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $5d50423c547436fe$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $5d50423c547436fe$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $5d50423c547436fe$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($5d50423c547436fe$var$Ie(f, d) && a.ref === b.ref) {
            if ($5d50423c547436fe$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($5d50423c547436fe$var$dh = !0);
            else return b.lanes = a.lanes, $5d50423c547436fe$var$Zi(a, b, e);
        }
    }
    return $5d50423c547436fe$var$cj(a, b, c, d, e);
}
function $5d50423c547436fe$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $5d50423c547436fe$var$G($5d50423c547436fe$var$ej, $5d50423c547436fe$var$fj), $5d50423c547436fe$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $5d50423c547436fe$var$G($5d50423c547436fe$var$ej, $5d50423c547436fe$var$fj), $5d50423c547436fe$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $5d50423c547436fe$var$G($5d50423c547436fe$var$ej, $5d50423c547436fe$var$fj);
            $5d50423c547436fe$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $5d50423c547436fe$var$G($5d50423c547436fe$var$ej, $5d50423c547436fe$var$fj), $5d50423c547436fe$var$fj |= d;
    $5d50423c547436fe$var$Xi(a, b, e, c);
    return b.child;
}
function $5d50423c547436fe$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $5d50423c547436fe$var$cj(a, b, c, d, e) {
    var f = $5d50423c547436fe$var$Zf(c) ? $5d50423c547436fe$var$Xf : $5d50423c547436fe$var$H.current;
    f = $5d50423c547436fe$var$Yf(b, f);
    $5d50423c547436fe$var$ch(b, e);
    c = $5d50423c547436fe$var$Nh(a, b, c, d, f, e);
    d = $5d50423c547436fe$var$Sh();
    if (null !== a && !$5d50423c547436fe$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5d50423c547436fe$var$Zi(a, b, e);
    $5d50423c547436fe$var$I && d && $5d50423c547436fe$var$vg(b);
    b.flags |= 1;
    $5d50423c547436fe$var$Xi(a, b, c, e);
    return b.child;
}
function $5d50423c547436fe$var$hj(a, b, c, d, e) {
    if ($5d50423c547436fe$var$Zf(c)) {
        var f = !0;
        $5d50423c547436fe$var$cg(b);
    } else f = !1;
    $5d50423c547436fe$var$ch(b, e);
    if (null === b.stateNode) $5d50423c547436fe$var$ij(a, b), $5d50423c547436fe$var$Gi(b, c, d), $5d50423c547436fe$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $5d50423c547436fe$var$eh(l) : (l = $5d50423c547436fe$var$Zf(c) ? $5d50423c547436fe$var$Xf : $5d50423c547436fe$var$H.current, l = $5d50423c547436fe$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5d50423c547436fe$var$Hi(b, g, d, l);
        $5d50423c547436fe$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $5d50423c547436fe$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $5d50423c547436fe$var$Wf.current || $5d50423c547436fe$var$jh ? ("function" === typeof m && ($5d50423c547436fe$var$Di(b, c, m, d), k = b.memoizedState), (h = $5d50423c547436fe$var$jh || $5d50423c547436fe$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $5d50423c547436fe$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $5d50423c547436fe$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $5d50423c547436fe$var$eh(k) : (k = $5d50423c547436fe$var$Zf(c) ? $5d50423c547436fe$var$Xf : $5d50423c547436fe$var$H.current, k = $5d50423c547436fe$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $5d50423c547436fe$var$Hi(b, g, d, k);
        $5d50423c547436fe$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $5d50423c547436fe$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $5d50423c547436fe$var$Wf.current || $5d50423c547436fe$var$jh ? ("function" === typeof y && ($5d50423c547436fe$var$Di(b, c, y, d), n = b.memoizedState), (l = $5d50423c547436fe$var$jh || $5d50423c547436fe$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $5d50423c547436fe$var$jj(a, b, c, d, f, e);
}
function $5d50423c547436fe$var$jj(a, b, c, d, e, f) {
    $5d50423c547436fe$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $5d50423c547436fe$var$dg(b, c, !1), $5d50423c547436fe$var$Zi(a, b, f);
    d = b.stateNode;
    $5d50423c547436fe$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $5d50423c547436fe$var$Ug(b, a.child, null, f), b.child = $5d50423c547436fe$var$Ug(b, null, h, f)) : $5d50423c547436fe$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $5d50423c547436fe$var$dg(b, c, !0);
    return b.child;
}
function $5d50423c547436fe$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $5d50423c547436fe$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $5d50423c547436fe$var$ag(a, b.context, !1);
    $5d50423c547436fe$var$yh(a, b.containerInfo);
}
function $5d50423c547436fe$var$lj(a, b, c, d, e) {
    $5d50423c547436fe$var$Ig();
    $5d50423c547436fe$var$Jg(e);
    b.flags |= 256;
    $5d50423c547436fe$var$Xi(a, b, c, d);
    return b.child;
}
var $5d50423c547436fe$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $5d50423c547436fe$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $5d50423c547436fe$var$oj(a, b, c) {
    var d = b.pendingProps, e = $5d50423c547436fe$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $5d50423c547436fe$var$G($5d50423c547436fe$var$L, e & 1);
    if (null === a) {
        $5d50423c547436fe$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $5d50423c547436fe$var$pj(g, d, 0, null), a = $5d50423c547436fe$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $5d50423c547436fe$var$nj(c), b.memoizedState = $5d50423c547436fe$var$mj, a) : $5d50423c547436fe$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $5d50423c547436fe$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $5d50423c547436fe$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $5d50423c547436fe$var$Pg(h, f) : (f = $5d50423c547436fe$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $5d50423c547436fe$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $5d50423c547436fe$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $5d50423c547436fe$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $5d50423c547436fe$var$qj(a, b) {
    b = $5d50423c547436fe$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $5d50423c547436fe$var$sj(a, b, c, d) {
    null !== d && $5d50423c547436fe$var$Jg(d);
    $5d50423c547436fe$var$Ug(b, a.child, null, c);
    a = $5d50423c547436fe$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $5d50423c547436fe$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $5d50423c547436fe$var$Ki(Error($5d50423c547436fe$var$p(422))), $5d50423c547436fe$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $5d50423c547436fe$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $5d50423c547436fe$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $5d50423c547436fe$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $5d50423c547436fe$var$nj(g);
        b.memoizedState = $5d50423c547436fe$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $5d50423c547436fe$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($5d50423c547436fe$var$p(419));
        d = $5d50423c547436fe$var$Ki(f, d, void 0);
        return $5d50423c547436fe$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($5d50423c547436fe$var$dh || h) {
        d = $5d50423c547436fe$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $5d50423c547436fe$var$ih(a, e), $5d50423c547436fe$var$gi(d, a, e, -1));
        }
        $5d50423c547436fe$var$tj();
        d = $5d50423c547436fe$var$Ki(Error($5d50423c547436fe$var$p(421)));
        return $5d50423c547436fe$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $5d50423c547436fe$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $5d50423c547436fe$var$yg = $5d50423c547436fe$var$Lf(e.nextSibling);
    $5d50423c547436fe$var$xg = b;
    $5d50423c547436fe$var$I = !0;
    $5d50423c547436fe$var$zg = null;
    null !== a && ($5d50423c547436fe$var$og[$5d50423c547436fe$var$pg++] = $5d50423c547436fe$var$rg, $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg++] = $5d50423c547436fe$var$sg, $5d50423c547436fe$var$og[$5d50423c547436fe$var$pg++] = $5d50423c547436fe$var$qg, $5d50423c547436fe$var$rg = a.id, $5d50423c547436fe$var$sg = a.overflow, $5d50423c547436fe$var$qg = b);
    b = $5d50423c547436fe$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $5d50423c547436fe$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $5d50423c547436fe$var$bh(a.return, b, c);
}
function $5d50423c547436fe$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $5d50423c547436fe$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $5d50423c547436fe$var$Xi(a, b, d.children, c);
    d = $5d50423c547436fe$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $5d50423c547436fe$var$vj(a, c, b);
            else if (19 === a.tag) $5d50423c547436fe$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $5d50423c547436fe$var$G($5d50423c547436fe$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $5d50423c547436fe$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $5d50423c547436fe$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $5d50423c547436fe$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $5d50423c547436fe$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $5d50423c547436fe$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $5d50423c547436fe$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $5d50423c547436fe$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $5d50423c547436fe$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($5d50423c547436fe$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $5d50423c547436fe$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $5d50423c547436fe$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $5d50423c547436fe$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $5d50423c547436fe$var$kj(b);
            $5d50423c547436fe$var$Ig();
            break;
        case 5:
            $5d50423c547436fe$var$Ah(b);
            break;
        case 1:
            $5d50423c547436fe$var$Zf(b.type) && $5d50423c547436fe$var$cg(b);
            break;
        case 4:
            $5d50423c547436fe$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $5d50423c547436fe$var$G($5d50423c547436fe$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $5d50423c547436fe$var$G($5d50423c547436fe$var$L, $5d50423c547436fe$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $5d50423c547436fe$var$oj(a, b, c);
                $5d50423c547436fe$var$G($5d50423c547436fe$var$L, $5d50423c547436fe$var$L.current & 1);
                a = $5d50423c547436fe$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $5d50423c547436fe$var$G($5d50423c547436fe$var$L, $5d50423c547436fe$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $5d50423c547436fe$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $5d50423c547436fe$var$G($5d50423c547436fe$var$L, $5d50423c547436fe$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $5d50423c547436fe$var$dj(a, b, c);
    }
    return $5d50423c547436fe$var$Zi(a, b, c);
}
var $5d50423c547436fe$var$zj, $5d50423c547436fe$var$Aj, $5d50423c547436fe$var$Bj, $5d50423c547436fe$var$Cj;
$5d50423c547436fe$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$5d50423c547436fe$var$Aj = function() {};
$5d50423c547436fe$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $5d50423c547436fe$var$xh($5d50423c547436fe$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $5d50423c547436fe$var$Ya(a, e);
                d = $5d50423c547436fe$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $5d50423c547436fe$var$A({}, e, {
                    value: void 0
                });
                d = $5d50423c547436fe$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $5d50423c547436fe$var$gb(a, e);
                d = $5d50423c547436fe$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $5d50423c547436fe$var$Bf);
        }
        $5d50423c547436fe$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($5d50423c547436fe$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($5d50423c547436fe$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $5d50423c547436fe$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$5d50423c547436fe$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $5d50423c547436fe$var$Dj(a, b) {
    if (!$5d50423c547436fe$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $5d50423c547436fe$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $5d50423c547436fe$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $5d50423c547436fe$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5d50423c547436fe$var$S(b), null;
        case 1:
            return $5d50423c547436fe$var$Zf(b.type) && $5d50423c547436fe$var$$f(), $5d50423c547436fe$var$S(b), null;
        case 3:
            d = b.stateNode;
            $5d50423c547436fe$var$zh();
            $5d50423c547436fe$var$E($5d50423c547436fe$var$Wf);
            $5d50423c547436fe$var$E($5d50423c547436fe$var$H);
            $5d50423c547436fe$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $5d50423c547436fe$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $5d50423c547436fe$var$zg && ($5d50423c547436fe$var$Fj($5d50423c547436fe$var$zg), $5d50423c547436fe$var$zg = null));
            $5d50423c547436fe$var$Aj(a, b);
            $5d50423c547436fe$var$S(b);
            return null;
        case 5:
            $5d50423c547436fe$var$Bh(b);
            var e = $5d50423c547436fe$var$xh($5d50423c547436fe$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $5d50423c547436fe$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($5d50423c547436fe$var$p(166));
                    $5d50423c547436fe$var$S(b);
                    return null;
                }
                a = $5d50423c547436fe$var$xh($5d50423c547436fe$var$uh.current);
                if ($5d50423c547436fe$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$5d50423c547436fe$var$Of] = b;
                    d[$5d50423c547436fe$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $5d50423c547436fe$var$D("cancel", d);
                            $5d50423c547436fe$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $5d50423c547436fe$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $5d50423c547436fe$var$lf.length; e++)$5d50423c547436fe$var$D($5d50423c547436fe$var$lf[e], d);
                            break;
                        case "source":
                            $5d50423c547436fe$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5d50423c547436fe$var$D("error", d);
                            $5d50423c547436fe$var$D("load", d);
                            break;
                        case "details":
                            $5d50423c547436fe$var$D("toggle", d);
                            break;
                        case "input":
                            $5d50423c547436fe$var$Za(d, f);
                            $5d50423c547436fe$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $5d50423c547436fe$var$D("invalid", d);
                            break;
                        case "textarea":
                            $5d50423c547436fe$var$hb(d, f), $5d50423c547436fe$var$D("invalid", d);
                    }
                    $5d50423c547436fe$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $5d50423c547436fe$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $5d50423c547436fe$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $5d50423c547436fe$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $5d50423c547436fe$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $5d50423c547436fe$var$Va(d);
                            $5d50423c547436fe$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $5d50423c547436fe$var$Va(d);
                            $5d50423c547436fe$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $5d50423c547436fe$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $5d50423c547436fe$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$5d50423c547436fe$var$Of] = b;
                    a[$5d50423c547436fe$var$Pf] = d;
                    $5d50423c547436fe$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $5d50423c547436fe$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $5d50423c547436fe$var$D("cancel", a);
                                $5d50423c547436fe$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $5d50423c547436fe$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $5d50423c547436fe$var$lf.length; e++)$5d50423c547436fe$var$D($5d50423c547436fe$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $5d50423c547436fe$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $5d50423c547436fe$var$D("error", a);
                                $5d50423c547436fe$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $5d50423c547436fe$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $5d50423c547436fe$var$Za(a, d);
                                e = $5d50423c547436fe$var$Ya(a, d);
                                $5d50423c547436fe$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $5d50423c547436fe$var$A({}, d, {
                                    value: void 0
                                });
                                $5d50423c547436fe$var$D("invalid", a);
                                break;
                            case "textarea":
                                $5d50423c547436fe$var$hb(a, d);
                                e = $5d50423c547436fe$var$gb(a, d);
                                $5d50423c547436fe$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $5d50423c547436fe$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $5d50423c547436fe$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $5d50423c547436fe$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $5d50423c547436fe$var$ob(a, k) : "number" === typeof k && $5d50423c547436fe$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($5d50423c547436fe$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $5d50423c547436fe$var$D("scroll", a) : null != k && $5d50423c547436fe$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $5d50423c547436fe$var$Va(a);
                                $5d50423c547436fe$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $5d50423c547436fe$var$Va(a);
                                $5d50423c547436fe$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $5d50423c547436fe$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $5d50423c547436fe$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $5d50423c547436fe$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $5d50423c547436fe$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $5d50423c547436fe$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $5d50423c547436fe$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($5d50423c547436fe$var$p(166));
                c = $5d50423c547436fe$var$xh($5d50423c547436fe$var$wh.current);
                $5d50423c547436fe$var$xh($5d50423c547436fe$var$uh.current);
                if ($5d50423c547436fe$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$5d50423c547436fe$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $5d50423c547436fe$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $5d50423c547436fe$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $5d50423c547436fe$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$5d50423c547436fe$var$Of] = b, b.stateNode = d;
            }
            $5d50423c547436fe$var$S(b);
            return null;
        case 13:
            $5d50423c547436fe$var$E($5d50423c547436fe$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($5d50423c547436fe$var$I && null !== $5d50423c547436fe$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $5d50423c547436fe$var$Hg(), $5d50423c547436fe$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $5d50423c547436fe$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($5d50423c547436fe$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($5d50423c547436fe$var$p(317));
                        f[$5d50423c547436fe$var$Of] = b;
                    } else $5d50423c547436fe$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $5d50423c547436fe$var$S(b);
                    f = !1;
                } else null !== $5d50423c547436fe$var$zg && ($5d50423c547436fe$var$Fj($5d50423c547436fe$var$zg), $5d50423c547436fe$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($5d50423c547436fe$var$L.current & 1) ? 0 === $5d50423c547436fe$var$T && ($5d50423c547436fe$var$T = 3) : $5d50423c547436fe$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $5d50423c547436fe$var$S(b);
            return null;
        case 4:
            return $5d50423c547436fe$var$zh(), $5d50423c547436fe$var$Aj(a, b), null === a && $5d50423c547436fe$var$sf(b.stateNode.containerInfo), $5d50423c547436fe$var$S(b), null;
        case 10:
            return $5d50423c547436fe$var$ah(b.type._context), $5d50423c547436fe$var$S(b), null;
        case 17:
            return $5d50423c547436fe$var$Zf(b.type) && $5d50423c547436fe$var$$f(), $5d50423c547436fe$var$S(b), null;
        case 19:
            $5d50423c547436fe$var$E($5d50423c547436fe$var$L);
            f = b.memoizedState;
            if (null === f) return $5d50423c547436fe$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $5d50423c547436fe$var$Dj(f, !1);
                else {
                    if (0 !== $5d50423c547436fe$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $5d50423c547436fe$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $5d50423c547436fe$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $5d50423c547436fe$var$G($5d50423c547436fe$var$L, $5d50423c547436fe$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $5d50423c547436fe$var$B() > $5d50423c547436fe$var$Gj && (b.flags |= 128, d = !0, $5d50423c547436fe$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $5d50423c547436fe$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $5d50423c547436fe$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$5d50423c547436fe$var$I) return $5d50423c547436fe$var$S(b), null;
                    } else 2 * $5d50423c547436fe$var$B() - f.renderingStartTime > $5d50423c547436fe$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $5d50423c547436fe$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $5d50423c547436fe$var$B(), b.sibling = null, c = $5d50423c547436fe$var$L.current, $5d50423c547436fe$var$G($5d50423c547436fe$var$L, d ? c & 1 | 2 : c & 1), b;
            $5d50423c547436fe$var$S(b);
            return null;
        case 22:
        case 23:
            return $5d50423c547436fe$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($5d50423c547436fe$var$fj & 1073741824) && ($5d50423c547436fe$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $5d50423c547436fe$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($5d50423c547436fe$var$p(156, b.tag));
}
function $5d50423c547436fe$var$Ij(a, b) {
    $5d50423c547436fe$var$wg(b);
    switch(b.tag){
        case 1:
            return $5d50423c547436fe$var$Zf(b.type) && $5d50423c547436fe$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $5d50423c547436fe$var$zh(), $5d50423c547436fe$var$E($5d50423c547436fe$var$Wf), $5d50423c547436fe$var$E($5d50423c547436fe$var$H), $5d50423c547436fe$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $5d50423c547436fe$var$Bh(b), null;
        case 13:
            $5d50423c547436fe$var$E($5d50423c547436fe$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($5d50423c547436fe$var$p(340));
                $5d50423c547436fe$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $5d50423c547436fe$var$E($5d50423c547436fe$var$L), null;
        case 4:
            return $5d50423c547436fe$var$zh(), null;
        case 10:
            return $5d50423c547436fe$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $5d50423c547436fe$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $5d50423c547436fe$var$Jj = !1, $5d50423c547436fe$var$U = !1, $5d50423c547436fe$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $5d50423c547436fe$var$V = null;
function $5d50423c547436fe$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $5d50423c547436fe$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $5d50423c547436fe$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $5d50423c547436fe$var$W(a, b, d);
    }
}
var $5d50423c547436fe$var$Nj = !1;
function $5d50423c547436fe$var$Oj(a, b) {
    $5d50423c547436fe$var$Cf = $5d50423c547436fe$var$dd;
    a = $5d50423c547436fe$var$Me();
    if ($5d50423c547436fe$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $5d50423c547436fe$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $5d50423c547436fe$var$dd = !1;
    for($5d50423c547436fe$var$V = b; null !== $5d50423c547436fe$var$V;)if (b = $5d50423c547436fe$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $5d50423c547436fe$var$V = a;
    else for(; null !== $5d50423c547436fe$var$V;){
        b = $5d50423c547436fe$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $5d50423c547436fe$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($5d50423c547436fe$var$p(163));
            }
        } catch (F) {
            $5d50423c547436fe$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $5d50423c547436fe$var$V = a;
            break;
        }
        $5d50423c547436fe$var$V = b.return;
    }
    n = $5d50423c547436fe$var$Nj;
    $5d50423c547436fe$var$Nj = !1;
    return n;
}
function $5d50423c547436fe$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $5d50423c547436fe$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $5d50423c547436fe$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5d50423c547436fe$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $5d50423c547436fe$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $5d50423c547436fe$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$5d50423c547436fe$var$Of], delete b[$5d50423c547436fe$var$Pf], delete b[$5d50423c547436fe$var$of], delete b[$5d50423c547436fe$var$Qf], delete b[$5d50423c547436fe$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $5d50423c547436fe$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $5d50423c547436fe$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $5d50423c547436fe$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $5d50423c547436fe$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $5d50423c547436fe$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($5d50423c547436fe$var$Vj(a, b, c), a = a.sibling; null !== a;)$5d50423c547436fe$var$Vj(a, b, c), a = a.sibling;
}
function $5d50423c547436fe$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($5d50423c547436fe$var$Wj(a, b, c), a = a.sibling; null !== a;)$5d50423c547436fe$var$Wj(a, b, c), a = a.sibling;
}
var $5d50423c547436fe$var$X = null, $5d50423c547436fe$var$Xj = !1;
function $5d50423c547436fe$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$5d50423c547436fe$var$Zj(a, b, c), c = c.sibling;
}
function $5d50423c547436fe$var$Zj(a, b, c) {
    if ($5d50423c547436fe$var$lc && "function" === typeof $5d50423c547436fe$var$lc.onCommitFiberUnmount) try {
        $5d50423c547436fe$var$lc.onCommitFiberUnmount($5d50423c547436fe$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $5d50423c547436fe$var$U || $5d50423c547436fe$var$Lj(c, b);
        case 6:
            var d = $5d50423c547436fe$var$X, e = $5d50423c547436fe$var$Xj;
            $5d50423c547436fe$var$X = null;
            $5d50423c547436fe$var$Yj(a, b, c);
            $5d50423c547436fe$var$X = d;
            $5d50423c547436fe$var$Xj = e;
            null !== $5d50423c547436fe$var$X && ($5d50423c547436fe$var$Xj ? (a = $5d50423c547436fe$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $5d50423c547436fe$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $5d50423c547436fe$var$X && ($5d50423c547436fe$var$Xj ? (a = $5d50423c547436fe$var$X, c = c.stateNode, 8 === a.nodeType ? $5d50423c547436fe$var$Kf(a.parentNode, c) : 1 === a.nodeType && $5d50423c547436fe$var$Kf(a, c), $5d50423c547436fe$var$bd(a)) : $5d50423c547436fe$var$Kf($5d50423c547436fe$var$X, c.stateNode));
            break;
        case 4:
            d = $5d50423c547436fe$var$X;
            e = $5d50423c547436fe$var$Xj;
            $5d50423c547436fe$var$X = c.stateNode.containerInfo;
            $5d50423c547436fe$var$Xj = !0;
            $5d50423c547436fe$var$Yj(a, b, c);
            $5d50423c547436fe$var$X = d;
            $5d50423c547436fe$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$5d50423c547436fe$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $5d50423c547436fe$var$Mj(c, b, g) : 0 !== (f & 4) && $5d50423c547436fe$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $5d50423c547436fe$var$Yj(a, b, c);
            break;
        case 1:
            if (!$5d50423c547436fe$var$U && ($5d50423c547436fe$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $5d50423c547436fe$var$W(c, b, h);
            }
            $5d50423c547436fe$var$Yj(a, b, c);
            break;
        case 21:
            $5d50423c547436fe$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($5d50423c547436fe$var$U = (d = $5d50423c547436fe$var$U) || null !== c.memoizedState, $5d50423c547436fe$var$Yj(a, b, c), $5d50423c547436fe$var$U = d) : $5d50423c547436fe$var$Yj(a, b, c);
            break;
        default:
            $5d50423c547436fe$var$Yj(a, b, c);
    }
}
function $5d50423c547436fe$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $5d50423c547436fe$var$Kj);
        b.forEach(function(b) {
            var d = $5d50423c547436fe$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $5d50423c547436fe$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $5d50423c547436fe$var$X = h.stateNode;
                        $5d50423c547436fe$var$Xj = !1;
                        break a;
                    case 3:
                        $5d50423c547436fe$var$X = h.stateNode.containerInfo;
                        $5d50423c547436fe$var$Xj = !0;
                        break a;
                    case 4:
                        $5d50423c547436fe$var$X = h.stateNode.containerInfo;
                        $5d50423c547436fe$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $5d50423c547436fe$var$X) throw Error($5d50423c547436fe$var$p(160));
            $5d50423c547436fe$var$Zj(f, g, e);
            $5d50423c547436fe$var$X = null;
            $5d50423c547436fe$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $5d50423c547436fe$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$5d50423c547436fe$var$dk(b, a), b = b.sibling;
}
function $5d50423c547436fe$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            if (d & 4) {
                try {
                    $5d50423c547436fe$var$Pj(3, a, a.return), $5d50423c547436fe$var$Qj(3, a);
                } catch (t) {
                    $5d50423c547436fe$var$W(a, a.return, t);
                }
                try {
                    $5d50423c547436fe$var$Pj(5, a, a.return);
                } catch (t) {
                    $5d50423c547436fe$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            d & 512 && null !== c && $5d50423c547436fe$var$Lj(c, c.return);
            break;
        case 5:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            d & 512 && null !== c && $5d50423c547436fe$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $5d50423c547436fe$var$ob(e, "");
                } catch (t) {
                    $5d50423c547436fe$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $5d50423c547436fe$var$ab(e, f);
                    $5d50423c547436fe$var$vb(h, g);
                    var l = $5d50423c547436fe$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $5d50423c547436fe$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $5d50423c547436fe$var$nb(e, q) : "children" === m ? $5d50423c547436fe$var$ob(e, q) : $5d50423c547436fe$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $5d50423c547436fe$var$bb(e, f);
                            break;
                        case "textarea":
                            $5d50423c547436fe$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $5d50423c547436fe$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $5d50423c547436fe$var$fb(e, !!f.multiple, f.defaultValue, !0) : $5d50423c547436fe$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$5d50423c547436fe$var$Pf] = f;
                } catch (t) {
                    $5d50423c547436fe$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($5d50423c547436fe$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $5d50423c547436fe$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $5d50423c547436fe$var$bd(b.containerInfo);
            } catch (t) {
                $5d50423c547436fe$var$W(a, a.return, t);
            }
            break;
        case 4:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            break;
        case 13:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($5d50423c547436fe$var$fk = $5d50423c547436fe$var$B()));
            d & 4 && $5d50423c547436fe$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($5d50423c547436fe$var$U = (l = $5d50423c547436fe$var$U) || m, $5d50423c547436fe$var$ck(b, a), $5d50423c547436fe$var$U = l) : $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($5d50423c547436fe$var$V = a, m = a.child; null !== m;){
                    for(q = $5d50423c547436fe$var$V = m; null !== $5d50423c547436fe$var$V;){
                        r = $5d50423c547436fe$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $5d50423c547436fe$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $5d50423c547436fe$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $5d50423c547436fe$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $5d50423c547436fe$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $5d50423c547436fe$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $5d50423c547436fe$var$V = y) : $5d50423c547436fe$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $5d50423c547436fe$var$rb("display", g));
                            } catch (t) {
                                $5d50423c547436fe$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $5d50423c547436fe$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $5d50423c547436fe$var$ck(b, a);
            $5d50423c547436fe$var$ek(a);
            d & 4 && $5d50423c547436fe$var$ak(a);
            break;
        case 21:
            break;
        default:
            $5d50423c547436fe$var$ck(b, a), $5d50423c547436fe$var$ek(a);
    }
}
function $5d50423c547436fe$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($5d50423c547436fe$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($5d50423c547436fe$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($5d50423c547436fe$var$ob(e, ""), d.flags &= -33);
                    var f = $5d50423c547436fe$var$Uj(a);
                    $5d50423c547436fe$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $5d50423c547436fe$var$Uj(a);
                    $5d50423c547436fe$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($5d50423c547436fe$var$p(161));
            }
        } catch (k) {
            $5d50423c547436fe$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $5d50423c547436fe$var$hk(a, b, c) {
    $5d50423c547436fe$var$V = a;
    $5d50423c547436fe$var$ik(a, b, c);
}
function $5d50423c547436fe$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $5d50423c547436fe$var$V;){
        var e = $5d50423c547436fe$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $5d50423c547436fe$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $5d50423c547436fe$var$U;
                h = $5d50423c547436fe$var$Jj;
                var l = $5d50423c547436fe$var$U;
                $5d50423c547436fe$var$Jj = g;
                if (($5d50423c547436fe$var$U = k) && !l) for($5d50423c547436fe$var$V = e; null !== $5d50423c547436fe$var$V;)g = $5d50423c547436fe$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $5d50423c547436fe$var$jk(e) : null !== k ? (k.return = g, $5d50423c547436fe$var$V = k) : $5d50423c547436fe$var$jk(e);
                for(; null !== f;)$5d50423c547436fe$var$V = f, $5d50423c547436fe$var$ik(f, b, c), f = f.sibling;
                $5d50423c547436fe$var$V = e;
                $5d50423c547436fe$var$Jj = h;
                $5d50423c547436fe$var$U = l;
            }
            $5d50423c547436fe$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $5d50423c547436fe$var$V = f) : $5d50423c547436fe$var$kk(a, b, c);
    }
}
function $5d50423c547436fe$var$kk(a) {
    for(; null !== $5d50423c547436fe$var$V;){
        var b = $5d50423c547436fe$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $5d50423c547436fe$var$U || $5d50423c547436fe$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$5d50423c547436fe$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $5d50423c547436fe$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $5d50423c547436fe$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $5d50423c547436fe$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $5d50423c547436fe$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($5d50423c547436fe$var$p(163));
                }
                $5d50423c547436fe$var$U || b.flags & 512 && $5d50423c547436fe$var$Rj(b);
            } catch (r) {
                $5d50423c547436fe$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $5d50423c547436fe$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5d50423c547436fe$var$V = c;
            break;
        }
        $5d50423c547436fe$var$V = b.return;
    }
}
function $5d50423c547436fe$var$gk(a) {
    for(; null !== $5d50423c547436fe$var$V;){
        var b = $5d50423c547436fe$var$V;
        if (b === a) {
            $5d50423c547436fe$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5d50423c547436fe$var$V = c;
            break;
        }
        $5d50423c547436fe$var$V = b.return;
    }
}
function $5d50423c547436fe$var$jk(a) {
    for(; null !== $5d50423c547436fe$var$V;){
        var b = $5d50423c547436fe$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $5d50423c547436fe$var$Qj(4, b);
                    } catch (k) {
                        $5d50423c547436fe$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $5d50423c547436fe$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $5d50423c547436fe$var$Rj(b);
                    } catch (k) {
                        $5d50423c547436fe$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $5d50423c547436fe$var$Rj(b);
                    } catch (k) {
                        $5d50423c547436fe$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $5d50423c547436fe$var$W(b, b.return, k);
        }
        if (b === a) {
            $5d50423c547436fe$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $5d50423c547436fe$var$V = h;
            break;
        }
        $5d50423c547436fe$var$V = b.return;
    }
}
var $5d50423c547436fe$var$lk = Math.ceil, $5d50423c547436fe$var$mk = $5d50423c547436fe$var$ua.ReactCurrentDispatcher, $5d50423c547436fe$var$nk = $5d50423c547436fe$var$ua.ReactCurrentOwner, $5d50423c547436fe$var$ok = $5d50423c547436fe$var$ua.ReactCurrentBatchConfig, $5d50423c547436fe$var$K = 0, $5d50423c547436fe$var$Q = null, $5d50423c547436fe$var$Y = null, $5d50423c547436fe$var$Z = 0, $5d50423c547436fe$var$fj = 0, $5d50423c547436fe$var$ej = $5d50423c547436fe$var$Uf(0), $5d50423c547436fe$var$T = 0, $5d50423c547436fe$var$pk = null, $5d50423c547436fe$var$rh = 0, $5d50423c547436fe$var$qk = 0, $5d50423c547436fe$var$rk = 0, $5d50423c547436fe$var$sk = null, $5d50423c547436fe$var$tk = null, $5d50423c547436fe$var$fk = 0, $5d50423c547436fe$var$Gj = Infinity, $5d50423c547436fe$var$uk = null, $5d50423c547436fe$var$Oi = !1, $5d50423c547436fe$var$Pi = null, $5d50423c547436fe$var$Ri = null, $5d50423c547436fe$var$vk = !1, $5d50423c547436fe$var$wk = null, $5d50423c547436fe$var$xk = 0, $5d50423c547436fe$var$yk = 0, $5d50423c547436fe$var$zk = null, $5d50423c547436fe$var$Ak = -1, $5d50423c547436fe$var$Bk = 0;
function $5d50423c547436fe$var$R() {
    return 0 !== ($5d50423c547436fe$var$K & 6) ? $5d50423c547436fe$var$B() : -1 !== $5d50423c547436fe$var$Ak ? $5d50423c547436fe$var$Ak : $5d50423c547436fe$var$Ak = $5d50423c547436fe$var$B();
}
function $5d50423c547436fe$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($5d50423c547436fe$var$K & 2) && 0 !== $5d50423c547436fe$var$Z) return $5d50423c547436fe$var$Z & -$5d50423c547436fe$var$Z;
    if (null !== $5d50423c547436fe$var$Kg.transition) return 0 === $5d50423c547436fe$var$Bk && ($5d50423c547436fe$var$Bk = $5d50423c547436fe$var$yc()), $5d50423c547436fe$var$Bk;
    a = $5d50423c547436fe$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $5d50423c547436fe$var$jd(a.type);
    return a;
}
function $5d50423c547436fe$var$gi(a, b, c, d) {
    if (50 < $5d50423c547436fe$var$yk) throw $5d50423c547436fe$var$yk = 0, $5d50423c547436fe$var$zk = null, Error($5d50423c547436fe$var$p(185));
    $5d50423c547436fe$var$Ac(a, c, d);
    if (0 === ($5d50423c547436fe$var$K & 2) || a !== $5d50423c547436fe$var$Q) a === $5d50423c547436fe$var$Q && (0 === ($5d50423c547436fe$var$K & 2) && ($5d50423c547436fe$var$qk |= c), 4 === $5d50423c547436fe$var$T && $5d50423c547436fe$var$Ck(a, $5d50423c547436fe$var$Z)), $5d50423c547436fe$var$Dk(a, d), 1 === c && 0 === $5d50423c547436fe$var$K && 0 === (b.mode & 1) && ($5d50423c547436fe$var$Gj = $5d50423c547436fe$var$B() + 500, $5d50423c547436fe$var$fg && $5d50423c547436fe$var$jg());
}
function $5d50423c547436fe$var$Dk(a, b) {
    var c = a.callbackNode;
    $5d50423c547436fe$var$wc(a, b);
    var d = $5d50423c547436fe$var$uc(a, a === $5d50423c547436fe$var$Q ? $5d50423c547436fe$var$Z : 0);
    if (0 === d) null !== c && $5d50423c547436fe$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $5d50423c547436fe$var$bc(c);
        if (1 === b) 0 === a.tag ? $5d50423c547436fe$var$ig($5d50423c547436fe$var$Ek.bind(null, a)) : $5d50423c547436fe$var$hg($5d50423c547436fe$var$Ek.bind(null, a)), $5d50423c547436fe$var$Jf(function() {
            0 === ($5d50423c547436fe$var$K & 6) && $5d50423c547436fe$var$jg();
        }), c = null;
        else {
            switch($5d50423c547436fe$var$Dc(d)){
                case 1:
                    c = $5d50423c547436fe$var$fc;
                    break;
                case 4:
                    c = $5d50423c547436fe$var$gc;
                    break;
                case 16:
                    c = $5d50423c547436fe$var$hc;
                    break;
                case 536870912:
                    c = $5d50423c547436fe$var$jc;
                    break;
                default:
                    c = $5d50423c547436fe$var$hc;
            }
            c = $5d50423c547436fe$var$Fk(c, $5d50423c547436fe$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $5d50423c547436fe$var$Gk(a, b) {
    $5d50423c547436fe$var$Ak = -1;
    $5d50423c547436fe$var$Bk = 0;
    if (0 !== ($5d50423c547436fe$var$K & 6)) throw Error($5d50423c547436fe$var$p(327));
    var c = a.callbackNode;
    if ($5d50423c547436fe$var$Hk() && a.callbackNode !== c) return null;
    var d = $5d50423c547436fe$var$uc(a, a === $5d50423c547436fe$var$Q ? $5d50423c547436fe$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $5d50423c547436fe$var$Ik(a, d);
    else {
        b = d;
        var e = $5d50423c547436fe$var$K;
        $5d50423c547436fe$var$K |= 2;
        var f = $5d50423c547436fe$var$Jk();
        if ($5d50423c547436fe$var$Q !== a || $5d50423c547436fe$var$Z !== b) $5d50423c547436fe$var$uk = null, $5d50423c547436fe$var$Gj = $5d50423c547436fe$var$B() + 500, $5d50423c547436fe$var$Kk(a, b);
        for(;;)try {
            $5d50423c547436fe$var$Lk();
            break;
        } catch (h) {
            $5d50423c547436fe$var$Mk(a, h);
        }
        $5d50423c547436fe$var$$g();
        $5d50423c547436fe$var$mk.current = f;
        $5d50423c547436fe$var$K = e;
        null !== $5d50423c547436fe$var$Y ? b = 0 : ($5d50423c547436fe$var$Q = null, $5d50423c547436fe$var$Z = 0, b = $5d50423c547436fe$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $5d50423c547436fe$var$xc(a), 0 !== e && (d = e, b = $5d50423c547436fe$var$Nk(a, e)));
        if (1 === b) throw c = $5d50423c547436fe$var$pk, $5d50423c547436fe$var$Kk(a, 0), $5d50423c547436fe$var$Ck(a, d), $5d50423c547436fe$var$Dk(a, $5d50423c547436fe$var$B()), c;
        if (6 === b) $5d50423c547436fe$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$5d50423c547436fe$var$Ok(e) && (b = $5d50423c547436fe$var$Ik(a, d), 2 === b && (f = $5d50423c547436fe$var$xc(a), 0 !== f && (d = f, b = $5d50423c547436fe$var$Nk(a, f))), 1 === b)) throw c = $5d50423c547436fe$var$pk, $5d50423c547436fe$var$Kk(a, 0), $5d50423c547436fe$var$Ck(a, d), $5d50423c547436fe$var$Dk(a, $5d50423c547436fe$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($5d50423c547436fe$var$p(345));
                case 2:
                    $5d50423c547436fe$var$Pk(a, $5d50423c547436fe$var$tk, $5d50423c547436fe$var$uk);
                    break;
                case 3:
                    $5d50423c547436fe$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $5d50423c547436fe$var$fk + 500 - $5d50423c547436fe$var$B(), 10 < b)) {
                        if (0 !== $5d50423c547436fe$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $5d50423c547436fe$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $5d50423c547436fe$var$Ff($5d50423c547436fe$var$Pk.bind(null, a, $5d50423c547436fe$var$tk, $5d50423c547436fe$var$uk), b);
                        break;
                    }
                    $5d50423c547436fe$var$Pk(a, $5d50423c547436fe$var$tk, $5d50423c547436fe$var$uk);
                    break;
                case 4:
                    $5d50423c547436fe$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $5d50423c547436fe$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $5d50423c547436fe$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $5d50423c547436fe$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $5d50423c547436fe$var$Ff($5d50423c547436fe$var$Pk.bind(null, a, $5d50423c547436fe$var$tk, $5d50423c547436fe$var$uk), d);
                        break;
                    }
                    $5d50423c547436fe$var$Pk(a, $5d50423c547436fe$var$tk, $5d50423c547436fe$var$uk);
                    break;
                case 5:
                    $5d50423c547436fe$var$Pk(a, $5d50423c547436fe$var$tk, $5d50423c547436fe$var$uk);
                    break;
                default:
                    throw Error($5d50423c547436fe$var$p(329));
            }
        }
    }
    $5d50423c547436fe$var$Dk(a, $5d50423c547436fe$var$B());
    return a.callbackNode === c ? $5d50423c547436fe$var$Gk.bind(null, a) : null;
}
function $5d50423c547436fe$var$Nk(a, b) {
    var c = $5d50423c547436fe$var$sk;
    a.current.memoizedState.isDehydrated && ($5d50423c547436fe$var$Kk(a, b).flags |= 256);
    a = $5d50423c547436fe$var$Ik(a, b);
    2 !== a && (b = $5d50423c547436fe$var$tk, $5d50423c547436fe$var$tk = c, null !== b && $5d50423c547436fe$var$Fj(b));
    return a;
}
function $5d50423c547436fe$var$Fj(a) {
    null === $5d50423c547436fe$var$tk ? $5d50423c547436fe$var$tk = a : $5d50423c547436fe$var$tk.push.apply($5d50423c547436fe$var$tk, a);
}
function $5d50423c547436fe$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$5d50423c547436fe$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $5d50423c547436fe$var$Ck(a, b) {
    b &= ~$5d50423c547436fe$var$rk;
    b &= ~$5d50423c547436fe$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $5d50423c547436fe$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $5d50423c547436fe$var$Ek(a) {
    if (0 !== ($5d50423c547436fe$var$K & 6)) throw Error($5d50423c547436fe$var$p(327));
    $5d50423c547436fe$var$Hk();
    var b = $5d50423c547436fe$var$uc(a, 0);
    if (0 === (b & 1)) return $5d50423c547436fe$var$Dk(a, $5d50423c547436fe$var$B()), null;
    var c = $5d50423c547436fe$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $5d50423c547436fe$var$xc(a);
        0 !== d && (b = d, c = $5d50423c547436fe$var$Nk(a, d));
    }
    if (1 === c) throw c = $5d50423c547436fe$var$pk, $5d50423c547436fe$var$Kk(a, 0), $5d50423c547436fe$var$Ck(a, b), $5d50423c547436fe$var$Dk(a, $5d50423c547436fe$var$B()), c;
    if (6 === c) throw Error($5d50423c547436fe$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $5d50423c547436fe$var$Pk(a, $5d50423c547436fe$var$tk, $5d50423c547436fe$var$uk);
    $5d50423c547436fe$var$Dk(a, $5d50423c547436fe$var$B());
    return null;
}
function $5d50423c547436fe$var$Qk(a, b) {
    var c = $5d50423c547436fe$var$K;
    $5d50423c547436fe$var$K |= 1;
    try {
        return a(b);
    } finally{
        $5d50423c547436fe$var$K = c, 0 === $5d50423c547436fe$var$K && ($5d50423c547436fe$var$Gj = $5d50423c547436fe$var$B() + 500, $5d50423c547436fe$var$fg && $5d50423c547436fe$var$jg());
    }
}
function $5d50423c547436fe$var$Rk(a) {
    null !== $5d50423c547436fe$var$wk && 0 === $5d50423c547436fe$var$wk.tag && 0 === ($5d50423c547436fe$var$K & 6) && $5d50423c547436fe$var$Hk();
    var b = $5d50423c547436fe$var$K;
    $5d50423c547436fe$var$K |= 1;
    var c = $5d50423c547436fe$var$ok.transition, d = $5d50423c547436fe$var$C;
    try {
        if ($5d50423c547436fe$var$ok.transition = null, $5d50423c547436fe$var$C = 1, a) return a();
    } finally{
        $5d50423c547436fe$var$C = d, $5d50423c547436fe$var$ok.transition = c, $5d50423c547436fe$var$K = b, 0 === ($5d50423c547436fe$var$K & 6) && $5d50423c547436fe$var$jg();
    }
}
function $5d50423c547436fe$var$Hj() {
    $5d50423c547436fe$var$fj = $5d50423c547436fe$var$ej.current;
    $5d50423c547436fe$var$E($5d50423c547436fe$var$ej);
}
function $5d50423c547436fe$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $5d50423c547436fe$var$Gf(c));
    if (null !== $5d50423c547436fe$var$Y) for(c = $5d50423c547436fe$var$Y.return; null !== c;){
        var d = c;
        $5d50423c547436fe$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $5d50423c547436fe$var$$f();
                break;
            case 3:
                $5d50423c547436fe$var$zh();
                $5d50423c547436fe$var$E($5d50423c547436fe$var$Wf);
                $5d50423c547436fe$var$E($5d50423c547436fe$var$H);
                $5d50423c547436fe$var$Eh();
                break;
            case 5:
                $5d50423c547436fe$var$Bh(d);
                break;
            case 4:
                $5d50423c547436fe$var$zh();
                break;
            case 13:
                $5d50423c547436fe$var$E($5d50423c547436fe$var$L);
                break;
            case 19:
                $5d50423c547436fe$var$E($5d50423c547436fe$var$L);
                break;
            case 10:
                $5d50423c547436fe$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $5d50423c547436fe$var$Hj();
        }
        c = c.return;
    }
    $5d50423c547436fe$var$Q = a;
    $5d50423c547436fe$var$Y = a = $5d50423c547436fe$var$Pg(a.current, null);
    $5d50423c547436fe$var$Z = $5d50423c547436fe$var$fj = b;
    $5d50423c547436fe$var$T = 0;
    $5d50423c547436fe$var$pk = null;
    $5d50423c547436fe$var$rk = $5d50423c547436fe$var$qk = $5d50423c547436fe$var$rh = 0;
    $5d50423c547436fe$var$tk = $5d50423c547436fe$var$sk = null;
    if (null !== $5d50423c547436fe$var$fh) {
        for(b = 0; b < $5d50423c547436fe$var$fh.length; b++)if (c = $5d50423c547436fe$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $5d50423c547436fe$var$fh = null;
    }
    return a;
}
function $5d50423c547436fe$var$Mk(a, b) {
    do {
        var c = $5d50423c547436fe$var$Y;
        try {
            $5d50423c547436fe$var$$g();
            $5d50423c547436fe$var$Fh.current = $5d50423c547436fe$var$Rh;
            if ($5d50423c547436fe$var$Ih) {
                for(var d = $5d50423c547436fe$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $5d50423c547436fe$var$Ih = !1;
            }
            $5d50423c547436fe$var$Hh = 0;
            $5d50423c547436fe$var$O = $5d50423c547436fe$var$N = $5d50423c547436fe$var$M = null;
            $5d50423c547436fe$var$Jh = !1;
            $5d50423c547436fe$var$Kh = 0;
            $5d50423c547436fe$var$nk.current = null;
            if (null === c || null === c.return) {
                $5d50423c547436fe$var$T = 1;
                $5d50423c547436fe$var$pk = b;
                $5d50423c547436fe$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $5d50423c547436fe$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $5d50423c547436fe$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $5d50423c547436fe$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $5d50423c547436fe$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $5d50423c547436fe$var$Si(f, l, b);
                            $5d50423c547436fe$var$tj();
                            break a;
                        }
                        k = Error($5d50423c547436fe$var$p(426));
                    }
                } else if ($5d50423c547436fe$var$I && h.mode & 1) {
                    var J = $5d50423c547436fe$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $5d50423c547436fe$var$Vi(J, g, h, f, b);
                        $5d50423c547436fe$var$Jg($5d50423c547436fe$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $5d50423c547436fe$var$Ji(k, h);
                4 !== $5d50423c547436fe$var$T && ($5d50423c547436fe$var$T = 2);
                null === $5d50423c547436fe$var$sk ? $5d50423c547436fe$var$sk = [
                    f
                ] : $5d50423c547436fe$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $5d50423c547436fe$var$Ni(f, k, b);
                            $5d50423c547436fe$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $5d50423c547436fe$var$Ri || !$5d50423c547436fe$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $5d50423c547436fe$var$Qi(f, h, b);
                                $5d50423c547436fe$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $5d50423c547436fe$var$Sk(c);
        } catch (na) {
            b = na;
            $5d50423c547436fe$var$Y === c && null !== c && ($5d50423c547436fe$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $5d50423c547436fe$var$Jk() {
    var a = $5d50423c547436fe$var$mk.current;
    $5d50423c547436fe$var$mk.current = $5d50423c547436fe$var$Rh;
    return null === a ? $5d50423c547436fe$var$Rh : a;
}
function $5d50423c547436fe$var$tj() {
    if (0 === $5d50423c547436fe$var$T || 3 === $5d50423c547436fe$var$T || 2 === $5d50423c547436fe$var$T) $5d50423c547436fe$var$T = 4;
    null === $5d50423c547436fe$var$Q || 0 === ($5d50423c547436fe$var$rh & 268435455) && 0 === ($5d50423c547436fe$var$qk & 268435455) || $5d50423c547436fe$var$Ck($5d50423c547436fe$var$Q, $5d50423c547436fe$var$Z);
}
function $5d50423c547436fe$var$Ik(a, b) {
    var c = $5d50423c547436fe$var$K;
    $5d50423c547436fe$var$K |= 2;
    var d = $5d50423c547436fe$var$Jk();
    if ($5d50423c547436fe$var$Q !== a || $5d50423c547436fe$var$Z !== b) $5d50423c547436fe$var$uk = null, $5d50423c547436fe$var$Kk(a, b);
    for(;;)try {
        $5d50423c547436fe$var$Tk();
        break;
    } catch (e) {
        $5d50423c547436fe$var$Mk(a, e);
    }
    $5d50423c547436fe$var$$g();
    $5d50423c547436fe$var$K = c;
    $5d50423c547436fe$var$mk.current = d;
    if (null !== $5d50423c547436fe$var$Y) throw Error($5d50423c547436fe$var$p(261));
    $5d50423c547436fe$var$Q = null;
    $5d50423c547436fe$var$Z = 0;
    return $5d50423c547436fe$var$T;
}
function $5d50423c547436fe$var$Tk() {
    for(; null !== $5d50423c547436fe$var$Y;)$5d50423c547436fe$var$Uk($5d50423c547436fe$var$Y);
}
function $5d50423c547436fe$var$Lk() {
    for(; null !== $5d50423c547436fe$var$Y && !$5d50423c547436fe$var$cc();)$5d50423c547436fe$var$Uk($5d50423c547436fe$var$Y);
}
function $5d50423c547436fe$var$Uk(a) {
    var b = $5d50423c547436fe$var$Vk(a.alternate, a, $5d50423c547436fe$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $5d50423c547436fe$var$Sk(a) : $5d50423c547436fe$var$Y = b;
    $5d50423c547436fe$var$nk.current = null;
}
function $5d50423c547436fe$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $5d50423c547436fe$var$Ej(c, b, $5d50423c547436fe$var$fj), null !== c) {
                $5d50423c547436fe$var$Y = c;
                return;
            }
        } else {
            c = $5d50423c547436fe$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $5d50423c547436fe$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $5d50423c547436fe$var$T = 6;
                $5d50423c547436fe$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $5d50423c547436fe$var$Y = b;
            return;
        }
        $5d50423c547436fe$var$Y = b = a;
    }while (null !== b);
    0 === $5d50423c547436fe$var$T && ($5d50423c547436fe$var$T = 5);
}
function $5d50423c547436fe$var$Pk(a, b, c) {
    var d = $5d50423c547436fe$var$C, e = $5d50423c547436fe$var$ok.transition;
    try {
        $5d50423c547436fe$var$ok.transition = null, $5d50423c547436fe$var$C = 1, $5d50423c547436fe$var$Wk(a, b, c, d);
    } finally{
        $5d50423c547436fe$var$ok.transition = e, $5d50423c547436fe$var$C = d;
    }
    return null;
}
function $5d50423c547436fe$var$Wk(a, b, c, d) {
    do $5d50423c547436fe$var$Hk();
    while (null !== $5d50423c547436fe$var$wk);
    if (0 !== ($5d50423c547436fe$var$K & 6)) throw Error($5d50423c547436fe$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($5d50423c547436fe$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $5d50423c547436fe$var$Bc(a, f);
    a === $5d50423c547436fe$var$Q && ($5d50423c547436fe$var$Y = $5d50423c547436fe$var$Q = null, $5d50423c547436fe$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $5d50423c547436fe$var$vk || ($5d50423c547436fe$var$vk = !0, $5d50423c547436fe$var$Fk($5d50423c547436fe$var$hc, function() {
        $5d50423c547436fe$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $5d50423c547436fe$var$ok.transition;
        $5d50423c547436fe$var$ok.transition = null;
        var g = $5d50423c547436fe$var$C;
        $5d50423c547436fe$var$C = 1;
        var h = $5d50423c547436fe$var$K;
        $5d50423c547436fe$var$K |= 4;
        $5d50423c547436fe$var$nk.current = null;
        $5d50423c547436fe$var$Oj(a, c);
        $5d50423c547436fe$var$dk(c, a);
        $5d50423c547436fe$var$Oe($5d50423c547436fe$var$Df);
        $5d50423c547436fe$var$dd = !!$5d50423c547436fe$var$Cf;
        $5d50423c547436fe$var$Df = $5d50423c547436fe$var$Cf = null;
        a.current = c;
        $5d50423c547436fe$var$hk(c, a, e);
        $5d50423c547436fe$var$dc();
        $5d50423c547436fe$var$K = h;
        $5d50423c547436fe$var$C = g;
        $5d50423c547436fe$var$ok.transition = f;
    } else a.current = c;
    $5d50423c547436fe$var$vk && ($5d50423c547436fe$var$vk = !1, $5d50423c547436fe$var$wk = a, $5d50423c547436fe$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($5d50423c547436fe$var$Ri = null);
    $5d50423c547436fe$var$mc(c.stateNode, d);
    $5d50423c547436fe$var$Dk(a, $5d50423c547436fe$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($5d50423c547436fe$var$Oi) throw $5d50423c547436fe$var$Oi = !1, a = $5d50423c547436fe$var$Pi, $5d50423c547436fe$var$Pi = null, a;
    0 !== ($5d50423c547436fe$var$xk & 1) && 0 !== a.tag && $5d50423c547436fe$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $5d50423c547436fe$var$zk ? $5d50423c547436fe$var$yk++ : ($5d50423c547436fe$var$yk = 0, $5d50423c547436fe$var$zk = a) : $5d50423c547436fe$var$yk = 0;
    $5d50423c547436fe$var$jg();
    return null;
}
function $5d50423c547436fe$var$Hk() {
    if (null !== $5d50423c547436fe$var$wk) {
        var a = $5d50423c547436fe$var$Dc($5d50423c547436fe$var$xk), b = $5d50423c547436fe$var$ok.transition, c = $5d50423c547436fe$var$C;
        try {
            $5d50423c547436fe$var$ok.transition = null;
            $5d50423c547436fe$var$C = 16 > a ? 16 : a;
            if (null === $5d50423c547436fe$var$wk) var d = !1;
            else {
                a = $5d50423c547436fe$var$wk;
                $5d50423c547436fe$var$wk = null;
                $5d50423c547436fe$var$xk = 0;
                if (0 !== ($5d50423c547436fe$var$K & 6)) throw Error($5d50423c547436fe$var$p(331));
                var e = $5d50423c547436fe$var$K;
                $5d50423c547436fe$var$K |= 4;
                for($5d50423c547436fe$var$V = a.current; null !== $5d50423c547436fe$var$V;){
                    var f = $5d50423c547436fe$var$V, g = f.child;
                    if (0 !== ($5d50423c547436fe$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($5d50423c547436fe$var$V = l; null !== $5d50423c547436fe$var$V;){
                                    var m = $5d50423c547436fe$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $5d50423c547436fe$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $5d50423c547436fe$var$V = q;
                                    else for(; null !== $5d50423c547436fe$var$V;){
                                        m = $5d50423c547436fe$var$V;
                                        var r = m.sibling, y = m.return;
                                        $5d50423c547436fe$var$Sj(m);
                                        if (m === l) {
                                            $5d50423c547436fe$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $5d50423c547436fe$var$V = r;
                                            break;
                                        }
                                        $5d50423c547436fe$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $5d50423c547436fe$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $5d50423c547436fe$var$V = g;
                    else b: for(; null !== $5d50423c547436fe$var$V;){
                        f = $5d50423c547436fe$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $5d50423c547436fe$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $5d50423c547436fe$var$V = x;
                            break b;
                        }
                        $5d50423c547436fe$var$V = f.return;
                    }
                }
                var w = a.current;
                for($5d50423c547436fe$var$V = w; null !== $5d50423c547436fe$var$V;){
                    g = $5d50423c547436fe$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $5d50423c547436fe$var$V = u;
                    else b: for(g = w; null !== $5d50423c547436fe$var$V;){
                        h = $5d50423c547436fe$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $5d50423c547436fe$var$Qj(9, h);
                            }
                        } catch (na) {
                            $5d50423c547436fe$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $5d50423c547436fe$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $5d50423c547436fe$var$V = F;
                            break b;
                        }
                        $5d50423c547436fe$var$V = h.return;
                    }
                }
                $5d50423c547436fe$var$K = e;
                $5d50423c547436fe$var$jg();
                if ($5d50423c547436fe$var$lc && "function" === typeof $5d50423c547436fe$var$lc.onPostCommitFiberRoot) try {
                    $5d50423c547436fe$var$lc.onPostCommitFiberRoot($5d50423c547436fe$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $5d50423c547436fe$var$C = c, $5d50423c547436fe$var$ok.transition = b;
        }
    }
    return !1;
}
function $5d50423c547436fe$var$Xk(a, b, c) {
    b = $5d50423c547436fe$var$Ji(c, b);
    b = $5d50423c547436fe$var$Ni(a, b, 1);
    a = $5d50423c547436fe$var$nh(a, b, 1);
    b = $5d50423c547436fe$var$R();
    null !== a && ($5d50423c547436fe$var$Ac(a, 1, b), $5d50423c547436fe$var$Dk(a, b));
}
function $5d50423c547436fe$var$W(a, b, c) {
    if (3 === a.tag) $5d50423c547436fe$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $5d50423c547436fe$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $5d50423c547436fe$var$Ri || !$5d50423c547436fe$var$Ri.has(d))) {
                a = $5d50423c547436fe$var$Ji(c, a);
                a = $5d50423c547436fe$var$Qi(b, a, 1);
                b = $5d50423c547436fe$var$nh(b, a, 1);
                a = $5d50423c547436fe$var$R();
                null !== b && ($5d50423c547436fe$var$Ac(b, 1, a), $5d50423c547436fe$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $5d50423c547436fe$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $5d50423c547436fe$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $5d50423c547436fe$var$Q === a && ($5d50423c547436fe$var$Z & c) === c && (4 === $5d50423c547436fe$var$T || 3 === $5d50423c547436fe$var$T && ($5d50423c547436fe$var$Z & 130023424) === $5d50423c547436fe$var$Z && 500 > $5d50423c547436fe$var$B() - $5d50423c547436fe$var$fk ? $5d50423c547436fe$var$Kk(a, 0) : $5d50423c547436fe$var$rk |= c);
    $5d50423c547436fe$var$Dk(a, b);
}
function $5d50423c547436fe$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $5d50423c547436fe$var$sc, $5d50423c547436fe$var$sc <<= 1, 0 === ($5d50423c547436fe$var$sc & 130023424) && ($5d50423c547436fe$var$sc = 4194304)));
    var c = $5d50423c547436fe$var$R();
    a = $5d50423c547436fe$var$ih(a, b);
    null !== a && ($5d50423c547436fe$var$Ac(a, b, c), $5d50423c547436fe$var$Dk(a, c));
}
function $5d50423c547436fe$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $5d50423c547436fe$var$Yk(a, c);
}
function $5d50423c547436fe$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($5d50423c547436fe$var$p(314));
    }
    null !== d && d.delete(b);
    $5d50423c547436fe$var$Yk(a, c);
}
var $5d50423c547436fe$var$Vk;
$5d50423c547436fe$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $5d50423c547436fe$var$Wf.current) $5d50423c547436fe$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $5d50423c547436fe$var$dh = !1, $5d50423c547436fe$var$yj(a, b, c);
            $5d50423c547436fe$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $5d50423c547436fe$var$dh = !1, $5d50423c547436fe$var$I && 0 !== (b.flags & 1048576) && $5d50423c547436fe$var$ug(b, $5d50423c547436fe$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $5d50423c547436fe$var$ij(a, b);
            a = b.pendingProps;
            var e = $5d50423c547436fe$var$Yf(b, $5d50423c547436fe$var$H.current);
            $5d50423c547436fe$var$ch(b, c);
            e = $5d50423c547436fe$var$Nh(null, b, d, a, e, c);
            var f = $5d50423c547436fe$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $5d50423c547436fe$var$Zf(d) ? (f = !0, $5d50423c547436fe$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $5d50423c547436fe$var$kh(b), e.updater = $5d50423c547436fe$var$Ei, b.stateNode = e, e._reactInternals = b, $5d50423c547436fe$var$Ii(b, d, a, c), b = $5d50423c547436fe$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $5d50423c547436fe$var$I && f && $5d50423c547436fe$var$vg(b), $5d50423c547436fe$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $5d50423c547436fe$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $5d50423c547436fe$var$Zk(d);
                a = $5d50423c547436fe$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $5d50423c547436fe$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $5d50423c547436fe$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $5d50423c547436fe$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $5d50423c547436fe$var$$i(null, b, d, $5d50423c547436fe$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($5d50423c547436fe$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5d50423c547436fe$var$Ci(d, e), $5d50423c547436fe$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5d50423c547436fe$var$Ci(d, e), $5d50423c547436fe$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $5d50423c547436fe$var$kj(b);
                if (null === a) throw Error($5d50423c547436fe$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $5d50423c547436fe$var$lh(a, b);
                $5d50423c547436fe$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $5d50423c547436fe$var$Ji(Error($5d50423c547436fe$var$p(423)), b);
                        b = $5d50423c547436fe$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $5d50423c547436fe$var$Ji(Error($5d50423c547436fe$var$p(424)), b);
                        b = $5d50423c547436fe$var$lj(a, b, d, c, e);
                        break a;
                    } else for($5d50423c547436fe$var$yg = $5d50423c547436fe$var$Lf(b.stateNode.containerInfo.firstChild), $5d50423c547436fe$var$xg = b, $5d50423c547436fe$var$I = !0, $5d50423c547436fe$var$zg = null, c = $5d50423c547436fe$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $5d50423c547436fe$var$Ig();
                    if (d === e) {
                        b = $5d50423c547436fe$var$Zi(a, b, c);
                        break a;
                    }
                    $5d50423c547436fe$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $5d50423c547436fe$var$Ah(b), null === a && $5d50423c547436fe$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $5d50423c547436fe$var$Ef(d, e) ? g = null : null !== f && $5d50423c547436fe$var$Ef(d, f) && (b.flags |= 32), $5d50423c547436fe$var$gj(a, b), $5d50423c547436fe$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $5d50423c547436fe$var$Eg(b), null;
        case 13:
            return $5d50423c547436fe$var$oj(a, b, c);
        case 4:
            return $5d50423c547436fe$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $5d50423c547436fe$var$Ug(b, null, d, c) : $5d50423c547436fe$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5d50423c547436fe$var$Ci(d, e), $5d50423c547436fe$var$Yi(a, b, d, e, c);
        case 7:
            return $5d50423c547436fe$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $5d50423c547436fe$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $5d50423c547436fe$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $5d50423c547436fe$var$G($5d50423c547436fe$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($5d50423c547436fe$var$He(f.value, g)) {
                        if (f.children === e.children && !$5d50423c547436fe$var$Wf.current) {
                            b = $5d50423c547436fe$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $5d50423c547436fe$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $5d50423c547436fe$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($5d50423c547436fe$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $5d50423c547436fe$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $5d50423c547436fe$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $5d50423c547436fe$var$ch(b, c), e = $5d50423c547436fe$var$eh(e), d = d(e), b.flags |= 1, $5d50423c547436fe$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $5d50423c547436fe$var$Ci(d, b.pendingProps), e = $5d50423c547436fe$var$Ci(d.type, e), $5d50423c547436fe$var$$i(a, b, d, e, c);
        case 15:
            return $5d50423c547436fe$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5d50423c547436fe$var$Ci(d, e), $5d50423c547436fe$var$ij(a, b), b.tag = 1, $5d50423c547436fe$var$Zf(d) ? (a = !0, $5d50423c547436fe$var$cg(b)) : a = !1, $5d50423c547436fe$var$ch(b, c), $5d50423c547436fe$var$Gi(b, d, e), $5d50423c547436fe$var$Ii(b, d, e, c), $5d50423c547436fe$var$jj(null, b, d, !0, a, c);
        case 19:
            return $5d50423c547436fe$var$xj(a, b, c);
        case 22:
            return $5d50423c547436fe$var$dj(a, b, c);
    }
    throw Error($5d50423c547436fe$var$p(156, b.tag));
};
function $5d50423c547436fe$var$Fk(a, b) {
    return $5d50423c547436fe$var$ac(a, b);
}
function $5d50423c547436fe$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5d50423c547436fe$var$Bg(a, b, c, d) {
    return new $5d50423c547436fe$var$$k(a, b, c, d);
}
function $5d50423c547436fe$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $5d50423c547436fe$var$Zk(a) {
    if ("function" === typeof a) return $5d50423c547436fe$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $5d50423c547436fe$var$Da) return 11;
        if (a === $5d50423c547436fe$var$Ga) return 14;
    }
    return 2;
}
function $5d50423c547436fe$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $5d50423c547436fe$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $5d50423c547436fe$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $5d50423c547436fe$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $5d50423c547436fe$var$ya:
            return $5d50423c547436fe$var$Tg(c.children, e, f, b);
        case $5d50423c547436fe$var$za:
            g = 8;
            e |= 8;
            break;
        case $5d50423c547436fe$var$Aa:
            return a = $5d50423c547436fe$var$Bg(12, c, b, e | 2), a.elementType = $5d50423c547436fe$var$Aa, a.lanes = f, a;
        case $5d50423c547436fe$var$Ea:
            return a = $5d50423c547436fe$var$Bg(13, c, b, e), a.elementType = $5d50423c547436fe$var$Ea, a.lanes = f, a;
        case $5d50423c547436fe$var$Fa:
            return a = $5d50423c547436fe$var$Bg(19, c, b, e), a.elementType = $5d50423c547436fe$var$Fa, a.lanes = f, a;
        case $5d50423c547436fe$var$Ia:
            return $5d50423c547436fe$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $5d50423c547436fe$var$Ba:
                    g = 10;
                    break a;
                case $5d50423c547436fe$var$Ca:
                    g = 9;
                    break a;
                case $5d50423c547436fe$var$Da:
                    g = 11;
                    break a;
                case $5d50423c547436fe$var$Ga:
                    g = 14;
                    break a;
                case $5d50423c547436fe$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($5d50423c547436fe$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $5d50423c547436fe$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $5d50423c547436fe$var$Tg(a, b, c, d) {
    a = $5d50423c547436fe$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $5d50423c547436fe$var$pj(a, b, c, d) {
    a = $5d50423c547436fe$var$Bg(22, a, d, b);
    a.elementType = $5d50423c547436fe$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $5d50423c547436fe$var$Qg(a, b, c) {
    a = $5d50423c547436fe$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $5d50423c547436fe$var$Sg(a, b, c) {
    b = $5d50423c547436fe$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $5d50423c547436fe$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $5d50423c547436fe$var$zc(0);
    this.expirationTimes = $5d50423c547436fe$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5d50423c547436fe$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $5d50423c547436fe$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $5d50423c547436fe$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $5d50423c547436fe$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $5d50423c547436fe$var$kh(f);
    return a;
}
function $5d50423c547436fe$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5d50423c547436fe$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $5d50423c547436fe$var$dl(a) {
    if (!a) return $5d50423c547436fe$var$Vf;
    a = a._reactInternals;
    a: {
        if ($5d50423c547436fe$var$Vb(a) !== a || 1 !== a.tag) throw Error($5d50423c547436fe$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($5d50423c547436fe$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($5d50423c547436fe$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($5d50423c547436fe$var$Zf(c)) return $5d50423c547436fe$var$bg(a, c, b);
    }
    return b;
}
function $5d50423c547436fe$var$el(a, b, c, d, e, f, g, h, k) {
    a = $5d50423c547436fe$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $5d50423c547436fe$var$dl(null);
    c = a.current;
    d = $5d50423c547436fe$var$R();
    e = $5d50423c547436fe$var$yi(c);
    f = $5d50423c547436fe$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $5d50423c547436fe$var$nh(c, f, e);
    a.current.lanes = e;
    $5d50423c547436fe$var$Ac(a, e, d);
    $5d50423c547436fe$var$Dk(a, d);
    return a;
}
function $5d50423c547436fe$var$fl(a, b, c, d) {
    var e = b.current, f = $5d50423c547436fe$var$R(), g = $5d50423c547436fe$var$yi(e);
    c = $5d50423c547436fe$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $5d50423c547436fe$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $5d50423c547436fe$var$nh(e, b, g);
    null !== a && ($5d50423c547436fe$var$gi(a, e, g, f), $5d50423c547436fe$var$oh(a, e, g));
    return g;
}
function $5d50423c547436fe$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $5d50423c547436fe$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $5d50423c547436fe$var$il(a, b) {
    $5d50423c547436fe$var$hl(a, b);
    (a = a.alternate) && $5d50423c547436fe$var$hl(a, b);
}
function $5d50423c547436fe$var$jl() {
    return null;
}
var $5d50423c547436fe$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $5d50423c547436fe$var$ll(a) {
    this._internalRoot = a;
}
$5d50423c547436fe$var$ml.prototype.render = $5d50423c547436fe$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($5d50423c547436fe$var$p(409));
    $5d50423c547436fe$var$fl(a, b, null, null);
};
$5d50423c547436fe$var$ml.prototype.unmount = $5d50423c547436fe$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $5d50423c547436fe$var$Rk(function() {
            $5d50423c547436fe$var$fl(null, a, null, null);
        });
        b[$5d50423c547436fe$var$uf] = null;
    }
};
function $5d50423c547436fe$var$ml(a) {
    this._internalRoot = a;
}
$5d50423c547436fe$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $5d50423c547436fe$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $5d50423c547436fe$var$Qc.length && 0 !== b && b < $5d50423c547436fe$var$Qc[c].priority; c++);
        $5d50423c547436fe$var$Qc.splice(c, 0, a);
        0 === c && $5d50423c547436fe$var$Vc(a);
    }
};
function $5d50423c547436fe$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $5d50423c547436fe$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $5d50423c547436fe$var$pl() {}
function $5d50423c547436fe$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $5d50423c547436fe$var$gl(g);
                f.call(a);
            };
        }
        var g = $5d50423c547436fe$var$el(b, d, a, 0, null, !1, !1, "", $5d50423c547436fe$var$pl);
        a._reactRootContainer = g;
        a[$5d50423c547436fe$var$uf] = g.current;
        $5d50423c547436fe$var$sf(8 === a.nodeType ? a.parentNode : a);
        $5d50423c547436fe$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $5d50423c547436fe$var$gl(k);
            h.call(a);
        };
    }
    var k = $5d50423c547436fe$var$bl(a, 0, !1, null, null, !1, !1, "", $5d50423c547436fe$var$pl);
    a._reactRootContainer = k;
    a[$5d50423c547436fe$var$uf] = k.current;
    $5d50423c547436fe$var$sf(8 === a.nodeType ? a.parentNode : a);
    $5d50423c547436fe$var$Rk(function() {
        $5d50423c547436fe$var$fl(b, k, c, d);
    });
    return k;
}
function $5d50423c547436fe$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $5d50423c547436fe$var$gl(g);
                h.call(a);
            };
        }
        $5d50423c547436fe$var$fl(b, g, a, e);
    } else g = $5d50423c547436fe$var$ql(c, b, a, e, d);
    return $5d50423c547436fe$var$gl(g);
}
$5d50423c547436fe$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $5d50423c547436fe$var$tc(b.pendingLanes);
                0 !== c && ($5d50423c547436fe$var$Cc(b, c | 1), $5d50423c547436fe$var$Dk(b, $5d50423c547436fe$var$B()), 0 === ($5d50423c547436fe$var$K & 6) && ($5d50423c547436fe$var$Gj = $5d50423c547436fe$var$B() + 500, $5d50423c547436fe$var$jg()));
            }
            break;
        case 13:
            $5d50423c547436fe$var$Rk(function() {
                var b = $5d50423c547436fe$var$ih(a, 1);
                if (null !== b) {
                    var c = $5d50423c547436fe$var$R();
                    $5d50423c547436fe$var$gi(b, a, 1, c);
                }
            }), $5d50423c547436fe$var$il(a, 1);
    }
};
$5d50423c547436fe$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $5d50423c547436fe$var$ih(a, 134217728);
        if (null !== b) {
            var c = $5d50423c547436fe$var$R();
            $5d50423c547436fe$var$gi(b, a, 134217728, c);
        }
        $5d50423c547436fe$var$il(a, 134217728);
    }
};
$5d50423c547436fe$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $5d50423c547436fe$var$yi(a), c = $5d50423c547436fe$var$ih(a, b);
        if (null !== c) {
            var d = $5d50423c547436fe$var$R();
            $5d50423c547436fe$var$gi(c, a, b, d);
        }
        $5d50423c547436fe$var$il(a, b);
    }
};
$5d50423c547436fe$var$Hc = function() {
    return $5d50423c547436fe$var$C;
};
$5d50423c547436fe$var$Ic = function(a, b) {
    var c = $5d50423c547436fe$var$C;
    try {
        return $5d50423c547436fe$var$C = a, b();
    } finally{
        $5d50423c547436fe$var$C = c;
    }
};
$5d50423c547436fe$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $5d50423c547436fe$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $5d50423c547436fe$var$Db(d);
                        if (!e) throw Error($5d50423c547436fe$var$p(90));
                        $5d50423c547436fe$var$Wa(d);
                        $5d50423c547436fe$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $5d50423c547436fe$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $5d50423c547436fe$var$fb(a, !!c.multiple, b, !1);
    }
};
$5d50423c547436fe$var$Gb = $5d50423c547436fe$var$Qk;
$5d50423c547436fe$var$Hb = $5d50423c547436fe$var$Rk;
var $5d50423c547436fe$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $5d50423c547436fe$var$Cb,
        $5d50423c547436fe$var$ue,
        $5d50423c547436fe$var$Db,
        $5d50423c547436fe$var$Eb,
        $5d50423c547436fe$var$Fb,
        $5d50423c547436fe$var$Qk
    ]
}, $5d50423c547436fe$var$tl = {
    findFiberByHostInstance: $5d50423c547436fe$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $5d50423c547436fe$var$ul = {
    bundleType: $5d50423c547436fe$var$tl.bundleType,
    version: $5d50423c547436fe$var$tl.version,
    rendererPackageName: $5d50423c547436fe$var$tl.rendererPackageName,
    rendererConfig: $5d50423c547436fe$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $5d50423c547436fe$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $5d50423c547436fe$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $5d50423c547436fe$var$tl.findFiberByHostInstance || $5d50423c547436fe$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5d50423c547436fe$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5d50423c547436fe$var$vl.isDisabled && $5d50423c547436fe$var$vl.supportsFiber) try {
        $5d50423c547436fe$var$kc = $5d50423c547436fe$var$vl.inject($5d50423c547436fe$var$ul), $5d50423c547436fe$var$lc = $5d50423c547436fe$var$vl;
    } catch (a) {}
}
$5d50423c547436fe$export$ae55be85d98224ed = $5d50423c547436fe$var$sl;
$5d50423c547436fe$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$5d50423c547436fe$var$nl(b)) throw Error($5d50423c547436fe$var$p(200));
    return $5d50423c547436fe$var$cl(a, b, null, c);
};
$5d50423c547436fe$export$882461b6382ed46c = function(a, b) {
    if (!$5d50423c547436fe$var$nl(a)) throw Error($5d50423c547436fe$var$p(299));
    var c = !1, d = "", e = $5d50423c547436fe$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $5d50423c547436fe$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$5d50423c547436fe$var$uf] = b.current;
    $5d50423c547436fe$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $5d50423c547436fe$var$ll(b);
};
$5d50423c547436fe$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($5d50423c547436fe$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($5d50423c547436fe$var$p(268, a));
    }
    a = $5d50423c547436fe$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$5d50423c547436fe$export$cd75ccfd720a3cd4 = function(a) {
    return $5d50423c547436fe$var$Rk(a);
};
$5d50423c547436fe$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$5d50423c547436fe$var$ol(b)) throw Error($5d50423c547436fe$var$p(200));
    return $5d50423c547436fe$var$rl(null, a, b, !0, c);
};
$5d50423c547436fe$export$757ceba2d55c277e = function(a, b, c) {
    if (!$5d50423c547436fe$var$nl(a)) throw Error($5d50423c547436fe$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $5d50423c547436fe$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $5d50423c547436fe$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$5d50423c547436fe$var$uf] = b.current;
    $5d50423c547436fe$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $5d50423c547436fe$var$ml(b);
};
$5d50423c547436fe$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$5d50423c547436fe$var$ol(b)) throw Error($5d50423c547436fe$var$p(200));
    return $5d50423c547436fe$var$rl(null, a, b, !1, c);
};
$5d50423c547436fe$export$502457920280e6be = function(a) {
    if (!$5d50423c547436fe$var$ol(a)) throw Error($5d50423c547436fe$var$p(40));
    return a._reactRootContainer ? ($5d50423c547436fe$var$Rk(function() {
        $5d50423c547436fe$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$5d50423c547436fe$var$uf] = null;
        });
    }), !0) : !1;
};
$5d50423c547436fe$export$c78a37762a8d58e1 = $5d50423c547436fe$var$Qk;
$5d50423c547436fe$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$5d50423c547436fe$var$ol(c)) throw Error($5d50423c547436fe$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($5d50423c547436fe$var$p(38));
    return $5d50423c547436fe$var$rl(a, b, c, !1, d);
};
$5d50423c547436fe$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4bDui", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bnBsT"));

});
parcelRegister("bnBsT", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $848ee774e10f1b44$export$c4744153514ff05d, (v) => $848ee774e10f1b44$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $848ee774e10f1b44$export$3e506c1ccc9cc1a7, (v) => $848ee774e10f1b44$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $848ee774e10f1b44$export$e26fe2ed2fa76875, (v) => $848ee774e10f1b44$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $848ee774e10f1b44$export$502329bbf4b505b1, (v) => $848ee774e10f1b44$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $848ee774e10f1b44$export$6e3807111c4874c4, (v) => $848ee774e10f1b44$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $848ee774e10f1b44$export$c27134553091fb3a, (v) => $848ee774e10f1b44$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $848ee774e10f1b44$export$33ee1acdc04fd2a2, (v) => $848ee774e10f1b44$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $848ee774e10f1b44$export$b00a404bbd5edef2, (v) => $848ee774e10f1b44$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $848ee774e10f1b44$export$8352ce38b91d0c62, (v) => $848ee774e10f1b44$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $848ee774e10f1b44$export$d66a1c1c77bd778b, (v) => $848ee774e10f1b44$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $848ee774e10f1b44$export$d3dfb8e4810cb555, (v) => $848ee774e10f1b44$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $848ee774e10f1b44$export$839f9183b0465a69, (v) => $848ee774e10f1b44$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $848ee774e10f1b44$export$72fdf0e06517287b, (v) => $848ee774e10f1b44$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $848ee774e10f1b44$export$4b844e58a3e414b4, (v) => $848ee774e10f1b44$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $848ee774e10f1b44$export$816d2913ae6b83b1, (v) => $848ee774e10f1b44$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $848ee774e10f1b44$export$61bcfe829111a1d0, (v) => $848ee774e10f1b44$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $848ee774e10f1b44$export$7ee8c9beb337bc3f, (v) => $848ee774e10f1b44$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $848ee774e10f1b44$export$b5836b71941fa3ed, (v) => $848ee774e10f1b44$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $848ee774e10f1b44$export$cf845f2c119da08a, (v) => $848ee774e10f1b44$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $848ee774e10f1b44$export$c4744153514ff05d;
var $848ee774e10f1b44$export$3e506c1ccc9cc1a7;
var $848ee774e10f1b44$export$e26fe2ed2fa76875;
var $848ee774e10f1b44$export$502329bbf4b505b1;
var $848ee774e10f1b44$export$6e3807111c4874c4;
var $848ee774e10f1b44$export$c27134553091fb3a;
var $848ee774e10f1b44$export$33ee1acdc04fd2a2;
var $848ee774e10f1b44$export$b00a404bbd5edef2;
var $848ee774e10f1b44$export$8352ce38b91d0c62;
var $848ee774e10f1b44$export$d66a1c1c77bd778b;
var $848ee774e10f1b44$export$d3dfb8e4810cb555;
var $848ee774e10f1b44$export$839f9183b0465a69;
var $848ee774e10f1b44$export$72fdf0e06517287b;
var $848ee774e10f1b44$export$4b844e58a3e414b4;
var $848ee774e10f1b44$export$816d2913ae6b83b1;
var $848ee774e10f1b44$export$61bcfe829111a1d0;
var $848ee774e10f1b44$export$7ee8c9beb337bc3f;
var $848ee774e10f1b44$export$b5836b71941fa3ed;
var $848ee774e10f1b44$export$cf845f2c119da08a;
"use strict";
function $848ee774e10f1b44$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $848ee774e10f1b44$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $848ee774e10f1b44$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $848ee774e10f1b44$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $848ee774e10f1b44$var$g(C, c)) n < e && 0 > $848ee774e10f1b44$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $848ee774e10f1b44$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $848ee774e10f1b44$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $848ee774e10f1b44$var$l = performance;
    $848ee774e10f1b44$export$c4744153514ff05d = function() {
        return $848ee774e10f1b44$var$l.now();
    };
} else {
    var $848ee774e10f1b44$var$p = Date, $848ee774e10f1b44$var$q = $848ee774e10f1b44$var$p.now();
    $848ee774e10f1b44$export$c4744153514ff05d = function() {
        return $848ee774e10f1b44$var$p.now() - $848ee774e10f1b44$var$q;
    };
}
var $848ee774e10f1b44$var$r = [], $848ee774e10f1b44$var$t = [], $848ee774e10f1b44$var$u = 1, $848ee774e10f1b44$var$v = null, $848ee774e10f1b44$var$y = 3, $848ee774e10f1b44$var$z = !1, $848ee774e10f1b44$var$A = !1, $848ee774e10f1b44$var$B = !1, $848ee774e10f1b44$var$D = "function" === typeof setTimeout ? setTimeout : null, $848ee774e10f1b44$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $848ee774e10f1b44$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $848ee774e10f1b44$var$G(a) {
    for(var b = $848ee774e10f1b44$var$h($848ee774e10f1b44$var$t); null !== b;){
        if (null === b.callback) $848ee774e10f1b44$var$k($848ee774e10f1b44$var$t);
        else if (b.startTime <= a) $848ee774e10f1b44$var$k($848ee774e10f1b44$var$t), b.sortIndex = b.expirationTime, $848ee774e10f1b44$var$f($848ee774e10f1b44$var$r, b);
        else break;
        b = $848ee774e10f1b44$var$h($848ee774e10f1b44$var$t);
    }
}
function $848ee774e10f1b44$var$H(a) {
    $848ee774e10f1b44$var$B = !1;
    $848ee774e10f1b44$var$G(a);
    if (!$848ee774e10f1b44$var$A) {
        if (null !== $848ee774e10f1b44$var$h($848ee774e10f1b44$var$r)) $848ee774e10f1b44$var$A = !0, $848ee774e10f1b44$var$I($848ee774e10f1b44$var$J);
        else {
            var b = $848ee774e10f1b44$var$h($848ee774e10f1b44$var$t);
            null !== b && $848ee774e10f1b44$var$K($848ee774e10f1b44$var$H, b.startTime - a);
        }
    }
}
function $848ee774e10f1b44$var$J(a, b) {
    $848ee774e10f1b44$var$A = !1;
    $848ee774e10f1b44$var$B && ($848ee774e10f1b44$var$B = !1, $848ee774e10f1b44$var$E($848ee774e10f1b44$var$L), $848ee774e10f1b44$var$L = -1);
    $848ee774e10f1b44$var$z = !0;
    var c = $848ee774e10f1b44$var$y;
    try {
        $848ee774e10f1b44$var$G(b);
        for($848ee774e10f1b44$var$v = $848ee774e10f1b44$var$h($848ee774e10f1b44$var$r); null !== $848ee774e10f1b44$var$v && (!($848ee774e10f1b44$var$v.expirationTime > b) || a && !$848ee774e10f1b44$var$M());){
            var d = $848ee774e10f1b44$var$v.callback;
            if ("function" === typeof d) {
                $848ee774e10f1b44$var$v.callback = null;
                $848ee774e10f1b44$var$y = $848ee774e10f1b44$var$v.priorityLevel;
                var e = d($848ee774e10f1b44$var$v.expirationTime <= b);
                b = $848ee774e10f1b44$export$c4744153514ff05d();
                "function" === typeof e ? $848ee774e10f1b44$var$v.callback = e : $848ee774e10f1b44$var$v === $848ee774e10f1b44$var$h($848ee774e10f1b44$var$r) && $848ee774e10f1b44$var$k($848ee774e10f1b44$var$r);
                $848ee774e10f1b44$var$G(b);
            } else $848ee774e10f1b44$var$k($848ee774e10f1b44$var$r);
            $848ee774e10f1b44$var$v = $848ee774e10f1b44$var$h($848ee774e10f1b44$var$r);
        }
        if (null !== $848ee774e10f1b44$var$v) var w = !0;
        else {
            var m = $848ee774e10f1b44$var$h($848ee774e10f1b44$var$t);
            null !== m && $848ee774e10f1b44$var$K($848ee774e10f1b44$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $848ee774e10f1b44$var$v = null, $848ee774e10f1b44$var$y = c, $848ee774e10f1b44$var$z = !1;
    }
}
var $848ee774e10f1b44$var$N = !1, $848ee774e10f1b44$var$O = null, $848ee774e10f1b44$var$L = -1, $848ee774e10f1b44$var$P = 5, $848ee774e10f1b44$var$Q = -1;
function $848ee774e10f1b44$var$M() {
    return $848ee774e10f1b44$export$c4744153514ff05d() - $848ee774e10f1b44$var$Q < $848ee774e10f1b44$var$P ? !1 : !0;
}
function $848ee774e10f1b44$var$R() {
    if (null !== $848ee774e10f1b44$var$O) {
        var a = $848ee774e10f1b44$export$c4744153514ff05d();
        $848ee774e10f1b44$var$Q = a;
        var b = !0;
        try {
            b = $848ee774e10f1b44$var$O(!0, a);
        } finally{
            b ? $848ee774e10f1b44$var$S() : ($848ee774e10f1b44$var$N = !1, $848ee774e10f1b44$var$O = null);
        }
    } else $848ee774e10f1b44$var$N = !1;
}
var $848ee774e10f1b44$var$S;
if ("function" === typeof $848ee774e10f1b44$var$F) $848ee774e10f1b44$var$S = function() {
    $848ee774e10f1b44$var$F($848ee774e10f1b44$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $848ee774e10f1b44$var$T = new MessageChannel, $848ee774e10f1b44$var$U = $848ee774e10f1b44$var$T.port2;
    $848ee774e10f1b44$var$T.port1.onmessage = $848ee774e10f1b44$var$R;
    $848ee774e10f1b44$var$S = function() {
        $848ee774e10f1b44$var$U.postMessage(null);
    };
} else $848ee774e10f1b44$var$S = function() {
    $848ee774e10f1b44$var$D($848ee774e10f1b44$var$R, 0);
};
function $848ee774e10f1b44$var$I(a) {
    $848ee774e10f1b44$var$O = a;
    $848ee774e10f1b44$var$N || ($848ee774e10f1b44$var$N = !0, $848ee774e10f1b44$var$S());
}
function $848ee774e10f1b44$var$K(a, b) {
    $848ee774e10f1b44$var$L = $848ee774e10f1b44$var$D(function() {
        a($848ee774e10f1b44$export$c4744153514ff05d());
    }, b);
}
$848ee774e10f1b44$export$3e506c1ccc9cc1a7 = 5;
$848ee774e10f1b44$export$e26fe2ed2fa76875 = 1;
$848ee774e10f1b44$export$502329bbf4b505b1 = 4;
$848ee774e10f1b44$export$6e3807111c4874c4 = 3;
$848ee774e10f1b44$export$c27134553091fb3a = null;
$848ee774e10f1b44$export$33ee1acdc04fd2a2 = 2;
$848ee774e10f1b44$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$848ee774e10f1b44$export$8352ce38b91d0c62 = function() {
    $848ee774e10f1b44$var$A || $848ee774e10f1b44$var$z || ($848ee774e10f1b44$var$A = !0, $848ee774e10f1b44$var$I($848ee774e10f1b44$var$J));
};
$848ee774e10f1b44$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $848ee774e10f1b44$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$848ee774e10f1b44$export$d3dfb8e4810cb555 = function() {
    return $848ee774e10f1b44$var$y;
};
$848ee774e10f1b44$export$839f9183b0465a69 = function() {
    return $848ee774e10f1b44$var$h($848ee774e10f1b44$var$r);
};
$848ee774e10f1b44$export$72fdf0e06517287b = function(a) {
    switch($848ee774e10f1b44$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $848ee774e10f1b44$var$y;
    }
    var c = $848ee774e10f1b44$var$y;
    $848ee774e10f1b44$var$y = b;
    try {
        return a();
    } finally{
        $848ee774e10f1b44$var$y = c;
    }
};
$848ee774e10f1b44$export$4b844e58a3e414b4 = function() {};
$848ee774e10f1b44$export$816d2913ae6b83b1 = function() {};
$848ee774e10f1b44$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $848ee774e10f1b44$var$y;
    $848ee774e10f1b44$var$y = a;
    try {
        return b();
    } finally{
        $848ee774e10f1b44$var$y = c;
    }
};
$848ee774e10f1b44$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $848ee774e10f1b44$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $848ee774e10f1b44$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $848ee774e10f1b44$var$f($848ee774e10f1b44$var$t, a), null === $848ee774e10f1b44$var$h($848ee774e10f1b44$var$r) && a === $848ee774e10f1b44$var$h($848ee774e10f1b44$var$t) && ($848ee774e10f1b44$var$B ? ($848ee774e10f1b44$var$E($848ee774e10f1b44$var$L), $848ee774e10f1b44$var$L = -1) : $848ee774e10f1b44$var$B = !0, $848ee774e10f1b44$var$K($848ee774e10f1b44$var$H, c - d))) : (a.sortIndex = e, $848ee774e10f1b44$var$f($848ee774e10f1b44$var$r, a), $848ee774e10f1b44$var$A || $848ee774e10f1b44$var$z || ($848ee774e10f1b44$var$A = !0, $848ee774e10f1b44$var$I($848ee774e10f1b44$var$J)));
    return a;
};
$848ee774e10f1b44$export$b5836b71941fa3ed = $848ee774e10f1b44$var$M;
$848ee774e10f1b44$export$cf845f2c119da08a = function(a) {
    var b = $848ee774e10f1b44$var$y;
    return function() {
        var c = $848ee774e10f1b44$var$y;
        $848ee774e10f1b44$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $848ee774e10f1b44$var$y = c;
        }
    };
};

});




parcelRegister("5CkBj", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $41707b3d7bf12dbd$export$306c0aa65ff9ec16, (v) => $41707b3d7bf12dbd$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $41707b3d7bf12dbd$export$306c0aa65ff9ec16;
"use strict";

var $dhiZh = parcelRequire("dhiZh");
function $41707b3d7bf12dbd$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $41707b3d7bf12dbd$var$k = "function" === typeof Object.is ? Object.is : $41707b3d7bf12dbd$var$h, $41707b3d7bf12dbd$var$l = $dhiZh.useState, $41707b3d7bf12dbd$var$m = $dhiZh.useEffect, $41707b3d7bf12dbd$var$n = $dhiZh.useLayoutEffect, $41707b3d7bf12dbd$var$p = $dhiZh.useDebugValue;
function $41707b3d7bf12dbd$var$q(a, b) {
    var d = b(), f = $41707b3d7bf12dbd$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $41707b3d7bf12dbd$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $41707b3d7bf12dbd$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $41707b3d7bf12dbd$var$m(function() {
        $41707b3d7bf12dbd$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $41707b3d7bf12dbd$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $41707b3d7bf12dbd$var$p(d);
    return d;
}
function $41707b3d7bf12dbd$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$41707b3d7bf12dbd$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $41707b3d7bf12dbd$var$t(a, b) {
    return b();
}
var $41707b3d7bf12dbd$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $41707b3d7bf12dbd$var$t : $41707b3d7bf12dbd$var$q;
$41707b3d7bf12dbd$export$306c0aa65ff9ec16 = void 0 !== $dhiZh.useSyncExternalStore ? $dhiZh.useSyncExternalStore : $41707b3d7bf12dbd$var$u;

});

parcelRegister("1dSiq", function(module, exports) {
"use strict";
var $0e411f724575999d$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $9SbM1 = parcelRequire("9SbM1");
module.exports = function hasNativeSymbols() {
    if (typeof $0e411f724575999d$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $0e411f724575999d$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $9SbM1();
};

});
parcelRegister("9SbM1", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("gyRoX", function(module, exports) {
"use strict";
var $c0e93ec50b6fe691$var$test = {
    __proto__: null,
    foo: {}
};
var $c0e93ec50b6fe691$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $c0e93ec50b6fe691$var$test
    }).foo === $c0e93ec50b6fe691$var$test.foo && !($c0e93ec50b6fe691$var$test instanceof $c0e93ec50b6fe691$var$$Object);
};

});

parcelRegister("epnTX", function(module, exports) {
"use strict";

var $e83BP = parcelRequire("e83BP");
var $a7d5f0d5f131eec6$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$e83BP;
};
$a7d5f0d5f131eec6$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$e83BP) return null;
    try {
        return $e83BP([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $a7d5f0d5f131eec6$var$hasPropertyDescriptors;

});
parcelRegister("e83BP", function(module, exports) {
"use strict";

var $6azwx = parcelRequire("6azwx");
/** @type {import('.')} */ var $a4949cbbc0887c30$var$$defineProperty = $6azwx("%Object.defineProperty%", true) || false;
if ($a4949cbbc0887c30$var$$defineProperty) try {
    $a4949cbbc0887c30$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $a4949cbbc0887c30$var$$defineProperty = false;
}
module.exports = $a4949cbbc0887c30$var$$defineProperty;

});
parcelRegister("6azwx", function(module, exports) {
"use strict";
var $47df3b8d32fc9358$var$undefined1;

var $axh3H = parcelRequire("axh3H");

var $iaCkh = parcelRequire("iaCkh");

var $b0v3G = parcelRequire("b0v3G");

var $hMBub = parcelRequire("hMBub");

var $hqiKn = parcelRequire("hqiKn");

var $RHWZq = parcelRequire("RHWZq");

var $3b7CP = parcelRequire("3b7CP");
var $47df3b8d32fc9358$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $47df3b8d32fc9358$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $47df3b8d32fc9358$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $47df3b8d32fc9358$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($47df3b8d32fc9358$var$$gOPD) try {
    $47df3b8d32fc9358$var$$gOPD({}, "");
} catch (e) {
    $47df3b8d32fc9358$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $47df3b8d32fc9358$var$throwTypeError = function() {
    throw new $RHWZq();
};
var $47df3b8d32fc9358$var$ThrowTypeError = $47df3b8d32fc9358$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $47df3b8d32fc9358$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $47df3b8d32fc9358$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $47df3b8d32fc9358$var$throwTypeError;
        }
    }
}() : $47df3b8d32fc9358$var$throwTypeError;

var $47df3b8d32fc9358$var$hasSymbols = (parcelRequire("1dSiq"))();

var $47df3b8d32fc9358$var$hasProto = (parcelRequire("gyRoX"))();
var $47df3b8d32fc9358$var$getProto = Object.getPrototypeOf || ($47df3b8d32fc9358$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $47df3b8d32fc9358$var$needsEval = {};
var $47df3b8d32fc9358$var$TypedArray = typeof Uint8Array === "undefined" || !$47df3b8d32fc9358$var$getProto ? undefined : $47df3b8d32fc9358$var$getProto(Uint8Array);
var $47df3b8d32fc9358$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $47df3b8d32fc9358$var$hasSymbols && $47df3b8d32fc9358$var$getProto ? $47df3b8d32fc9358$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $47df3b8d32fc9358$var$needsEval,
    "%AsyncGenerator%": $47df3b8d32fc9358$var$needsEval,
    "%AsyncGeneratorFunction%": $47df3b8d32fc9358$var$needsEval,
    "%AsyncIteratorPrototype%": $47df3b8d32fc9358$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $axh3H,
    "%eval%": eval,
    "%EvalError%": $iaCkh,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $47df3b8d32fc9358$var$$Function,
    "%GeneratorFunction%": $47df3b8d32fc9358$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $47df3b8d32fc9358$var$hasSymbols && $47df3b8d32fc9358$var$getProto ? $47df3b8d32fc9358$var$getProto($47df3b8d32fc9358$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$47df3b8d32fc9358$var$hasSymbols || !$47df3b8d32fc9358$var$getProto ? undefined : $47df3b8d32fc9358$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $b0v3G,
    "%ReferenceError%": $hMBub,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$47df3b8d32fc9358$var$hasSymbols || !$47df3b8d32fc9358$var$getProto ? undefined : $47df3b8d32fc9358$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $47df3b8d32fc9358$var$hasSymbols && $47df3b8d32fc9358$var$getProto ? $47df3b8d32fc9358$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $47df3b8d32fc9358$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $hqiKn,
    "%ThrowTypeError%": $47df3b8d32fc9358$var$ThrowTypeError,
    "%TypedArray%": $47df3b8d32fc9358$var$TypedArray,
    "%TypeError%": $RHWZq,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $3b7CP,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($47df3b8d32fc9358$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $47df3b8d32fc9358$var$errorProto = $47df3b8d32fc9358$var$getProto($47df3b8d32fc9358$var$getProto(e));
    $47df3b8d32fc9358$var$INTRINSICS["%Error.prototype%"] = $47df3b8d32fc9358$var$errorProto;
}
var $47df3b8d32fc9358$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $47df3b8d32fc9358$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $47df3b8d32fc9358$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $47df3b8d32fc9358$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $47df3b8d32fc9358$var$getProto) value = $47df3b8d32fc9358$var$getProto(gen.prototype);
    }
    $47df3b8d32fc9358$var$INTRINSICS[name] = value;
    return value;
};
var $47df3b8d32fc9358$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $6JQ6Q = parcelRequire("6JQ6Q");

var $zakbE = parcelRequire("zakbE");
var $47df3b8d32fc9358$var$$concat = $6JQ6Q.call(Function.call, Array.prototype.concat);
var $47df3b8d32fc9358$var$$spliceApply = $6JQ6Q.call(Function.apply, Array.prototype.splice);
var $47df3b8d32fc9358$var$$replace = $6JQ6Q.call(Function.call, String.prototype.replace);
var $47df3b8d32fc9358$var$$strSlice = $6JQ6Q.call(Function.call, String.prototype.slice);
var $47df3b8d32fc9358$var$$exec = $6JQ6Q.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $47df3b8d32fc9358$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $47df3b8d32fc9358$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $47df3b8d32fc9358$var$stringToPath = function stringToPath(string) {
    var first = $47df3b8d32fc9358$var$$strSlice(string, 0, 1);
    var last = $47df3b8d32fc9358$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $hqiKn("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $hqiKn("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $47df3b8d32fc9358$var$$replace(string, $47df3b8d32fc9358$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $47df3b8d32fc9358$var$$replace(subString, $47df3b8d32fc9358$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $47df3b8d32fc9358$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($zakbE($47df3b8d32fc9358$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $47df3b8d32fc9358$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($zakbE($47df3b8d32fc9358$var$INTRINSICS, intrinsicName)) {
        var value = $47df3b8d32fc9358$var$INTRINSICS[intrinsicName];
        if (value === $47df3b8d32fc9358$var$needsEval) value = $47df3b8d32fc9358$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $RHWZq("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $hqiKn("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $RHWZq("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $RHWZq('"allowMissing" argument must be a boolean');
    if ($47df3b8d32fc9358$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $hqiKn("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $47df3b8d32fc9358$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $47df3b8d32fc9358$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $47df3b8d32fc9358$var$$spliceApply(parts, $47df3b8d32fc9358$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $47df3b8d32fc9358$var$$strSlice(part, 0, 1);
        var last = $47df3b8d32fc9358$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $hqiKn("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($zakbE($47df3b8d32fc9358$var$INTRINSICS, intrinsicRealName)) value = $47df3b8d32fc9358$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $RHWZq("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($47df3b8d32fc9358$var$$gOPD && i + 1 >= parts.length) {
                var desc = $47df3b8d32fc9358$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $zakbE(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $47df3b8d32fc9358$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("axh3H", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("iaCkh", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("b0v3G", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("hMBub", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("hqiKn", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("RHWZq", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("3b7CP", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("6JQ6Q", function(module, exports) {
"use strict";

var $jvOU7 = parcelRequire("jvOU7");
module.exports = Function.prototype.bind || $jvOU7;

});
parcelRegister("jvOU7", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $e3486618730a82bd$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $e3486618730a82bd$var$toStr = Object.prototype.toString;
var $e3486618730a82bd$var$max = Math.max;
var $e3486618730a82bd$var$funcType = "[object Function]";
var $e3486618730a82bd$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $e3486618730a82bd$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $e3486618730a82bd$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $e3486618730a82bd$var$toStr.apply(target) !== $e3486618730a82bd$var$funcType) throw new TypeError($e3486618730a82bd$var$ERROR_MESSAGE + target);
    var args = $e3486618730a82bd$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $e3486618730a82bd$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $e3486618730a82bd$var$concatty(args, arguments));
    };
    var boundLength = $e3486618730a82bd$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $e3486618730a82bd$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("zakbE", function(module, exports) {
"use strict";
var $069b473fa42be9bb$var$call = Function.prototype.call;
var $069b473fa42be9bb$var$$hasOwn = Object.prototype.hasOwnProperty;

var $6JQ6Q = parcelRequire("6JQ6Q");
/** @type {import('.')} */ module.exports = $6JQ6Q.call($069b473fa42be9bb$var$call, $069b473fa42be9bb$var$$hasOwn);

});




parcelRegister("3QoJP", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});

parcelRegister("6VCbT", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50b5b0d7ca06f04a$export$bf730a2d8bf68b42, (v) => $50b5b0d7ca06f04a$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50b5b0d7ca06f04a$export$bf730a2d8bf68b42;
"use strict";

var $dhiZh = parcelRequire("dhiZh");

var $l6BoB = parcelRequire("l6BoB");
function $50b5b0d7ca06f04a$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50b5b0d7ca06f04a$var$q = "function" === typeof Object.is ? Object.is : $50b5b0d7ca06f04a$var$p, $50b5b0d7ca06f04a$var$r = $l6BoB.useSyncExternalStore, $50b5b0d7ca06f04a$var$t = $dhiZh.useRef, $50b5b0d7ca06f04a$var$u = $dhiZh.useEffect, $50b5b0d7ca06f04a$var$v = $dhiZh.useMemo, $50b5b0d7ca06f04a$var$w = $dhiZh.useDebugValue;
$50b5b0d7ca06f04a$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50b5b0d7ca06f04a$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50b5b0d7ca06f04a$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50b5b0d7ca06f04a$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50b5b0d7ca06f04a$var$r(a, c[0], c[1]);
    $50b5b0d7ca06f04a$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50b5b0d7ca06f04a$var$w(d);
    return d;
};

});
parcelRegister("l6BoB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5CkBj"));

});


parcelRegister("bYZui", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("5PSKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $43fc2edc8a74b0e3$export$2e2bcd8739ae039);

var $cTk4s = parcelRequire("cTk4s");
// eslint-disable-next-line no-undef
var $43fc2edc8a74b0e3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $43fc2edc8a74b0e3$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cTk4s.default)(function(prop) {
    return $43fc2edc8a74b0e3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("cTk4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $962a30bfc04bbae5$export$2e2bcd8739ae039);
function $962a30bfc04bbae5$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("gPgNv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $c3fe7061c44e395c$var$_gtag = $c3fe7061c44e395c$var$_interopRequireDefault((parcelRequire("bw1gT")));

var $c3fe7061c44e395c$var$_format = $c3fe7061c44e395c$var$_interopRequireDefault((parcelRequire("6Oe0E")));
var $c3fe7061c44e395c$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $c3fe7061c44e395c$var$_excluded2 = [
    "title",
    "location"
], $c3fe7061c44e395c$var$_excluded3 = [
    "page",
    "hitType"
];
function $c3fe7061c44e395c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c3fe7061c44e395c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c3fe7061c44e395c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c3fe7061c44e395c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c3fe7061c44e395c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c3fe7061c44e395c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c3fe7061c44e395c$var$_typeof(obj);
}
function $c3fe7061c44e395c$var$_toConsumableArray(arr) {
    return $c3fe7061c44e395c$var$_arrayWithoutHoles(arr) || $c3fe7061c44e395c$var$_iterableToArray(arr) || $c3fe7061c44e395c$var$_unsupportedIterableToArray(arr) || $c3fe7061c44e395c$var$_nonIterableSpread();
}
function $c3fe7061c44e395c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c3fe7061c44e395c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c3fe7061c44e395c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c3fe7061c44e395c$var$_arrayLikeToArray(arr);
}
function $c3fe7061c44e395c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c3fe7061c44e395c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c3fe7061c44e395c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c3fe7061c44e395c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c3fe7061c44e395c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c3fe7061c44e395c$var$_slicedToArray(arr, i) {
    return $c3fe7061c44e395c$var$_arrayWithHoles(arr) || $c3fe7061c44e395c$var$_iterableToArrayLimit(arr, i) || $c3fe7061c44e395c$var$_unsupportedIterableToArray(arr, i) || $c3fe7061c44e395c$var$_nonIterableRest();
}
function $c3fe7061c44e395c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c3fe7061c44e395c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c3fe7061c44e395c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c3fe7061c44e395c$var$_arrayLikeToArray(o, minLen);
}
function $c3fe7061c44e395c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c3fe7061c44e395c$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c3fe7061c44e395c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c3fe7061c44e395c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c3fe7061c44e395c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c3fe7061c44e395c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c3fe7061c44e395c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c3fe7061c44e395c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c3fe7061c44e395c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c3fe7061c44e395c$var$_defineProperty(obj, key, value) {
    key = $c3fe7061c44e395c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c3fe7061c44e395c$var$_toPropertyKey(arg) {
    var key = $c3fe7061c44e395c$var$_toPrimitive(arg, "string");
    return $c3fe7061c44e395c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c3fe7061c44e395c$var$_toPrimitive(input, hint) {
    if ($c3fe7061c44e395c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c3fe7061c44e395c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $c3fe7061c44e395c$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $c3fe7061c44e395c$var$_classCallCheck(this, GA4);
        $c3fe7061c44e395c$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $c3fe7061c44e395c$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $c3fe7061c44e395c$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $c3fe7061c44e395c$var$_objectSpread($c3fe7061c44e395c$var$_objectSpread($c3fe7061c44e395c$var$_objectSpread({}, _this._toGtagOptions($c3fe7061c44e395c$var$_objectSpread($c3fe7061c44e395c$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $c3fe7061c44e395c$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $c3fe7061c44e395c$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($c3fe7061c44e395c$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $c3fe7061c44e395c$var$_objectSpread($c3fe7061c44e395c$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $c3fe7061c44e395c$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $c3fe7061c44e395c$var$_objectWithoutProperties(_args$, $c3fe7061c44e395c$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $c3fe7061c44e395c$var$_objectWithoutProperties(_this$_toGtagOptions, $c3fe7061c44e395c$var$_excluded2);
                _this._gtag("event", "page_view", $c3fe7061c44e395c$var$_objectSpread($c3fe7061c44e395c$var$_objectSpread($c3fe7061c44e395c$var$_objectSpread($c3fe7061c44e395c$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $c3fe7061c44e395c$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $c3fe7061c44e395c$var$_objectWithoutProperties(_args$2, $c3fe7061c44e395c$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $c3fe7061c44e395c$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $c3fe7061c44e395c$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $c3fe7061c44e395c$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $c3fe7061c44e395c$var$_format["default"])(category),
                    eventAction: (0, $c3fe7061c44e395c$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $c3fe7061c44e395c$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $c3fe7061c44e395c$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $c3fe7061c44e395c$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $c3fe7061c44e395c$var$GA4;
var $c3fe7061c44e395c$var$_default = new $c3fe7061c44e395c$var$GA4();
module.exports["default"] = $c3fe7061c44e395c$var$_default;

});
parcelRegister("bw1gT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $8623ab5cce7612a5$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $8623ab5cce7612a5$var$_default = $8623ab5cce7612a5$var$gtag;
module.exports["default"] = $8623ab5cce7612a5$var$_default;

});

parcelRegister("6Oe0E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4f524793ceea89ae$var$format;
var $4f524793ceea89ae$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $4f524793ceea89ae$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($4f524793ceea89ae$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $4f524793ceea89ae$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $4f524793ceea89ae$var$redacted = "REDACTED (Potential Email Address)";
function $4f524793ceea89ae$var$redactEmail(string) {
    if ($4f524793ceea89ae$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $4f524793ceea89ae$var$redacted;
    }
    return string;
}
function $4f524793ceea89ae$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $4f524793ceea89ae$var$toTitleCase(s);
    if (redactingEmail) _str = $4f524793ceea89ae$var$redactEmail(_str);
    return _str;
}

});


var $015932d6ce0d059e$exports = {};
"use strict";

$015932d6ce0d059e$exports = (parcelRequire("jK8PJ"));



var $dhiZh = parcelRequire("dhiZh");
var $fa54abf3c5b19ab2$exports = {};

$parcel$export($fa54abf3c5b19ab2$exports, "createRoot", () => $fa54abf3c5b19ab2$export$882461b6382ed46c, (v) => $fa54abf3c5b19ab2$export$882461b6382ed46c = v);
$parcel$export($fa54abf3c5b19ab2$exports, "hydrateRoot", () => $fa54abf3c5b19ab2$export$757ceba2d55c277e, (v) => $fa54abf3c5b19ab2$export$757ceba2d55c277e = v);
var $fa54abf3c5b19ab2$export$882461b6382ed46c;
var $fa54abf3c5b19ab2$export$757ceba2d55c277e;
"use strict";

var $b4Mpg = parcelRequire("b4Mpg");
var $fa54abf3c5b19ab2$var$i;
$fa54abf3c5b19ab2$export$882461b6382ed46c = $b4Mpg.createRoot;
$fa54abf3c5b19ab2$export$757ceba2d55c277e = $b4Mpg.hydrateRoot;





function $c9ab0f59dbc12b53$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $53825fa7fd9c8174$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}





var $dhiZh = parcelRequire("dhiZh");

var $l6BoB = parcelRequire("l6BoB");

function $01246c54742f6ed3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $01246c54742f6ed3$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $01246c54742f6ed3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $dhiZh = parcelRequire("dhiZh");
// Shared state between server components and client components
const $fadd97240ddadf43$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $fadd97240ddadf43$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $fadd97240ddadf43$export$8793edee2d425525();
const $fadd97240ddadf43$export$8b8a958a7f6f130c = Object;
const $fadd97240ddadf43$export$fce6876652108ab = (v)=>v === $fadd97240ddadf43$export$6db089fe7b26f5b6;
const $fadd97240ddadf43$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $fadd97240ddadf43$export$2321aea138b44780 = (a, b)=>(0, $53825fa7fd9c8174$export$71511d61b312f219)({}, a, b);
const $fadd97240ddadf43$export$ae936b9d47e5870e = (x)=>$fadd97240ddadf43$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $fadd97240ddadf43$var$table = new WeakMap();
// counter of the key
let $fadd97240ddadf43$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $fadd97240ddadf43$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($fadd97240ddadf43$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $fadd97240ddadf43$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$fadd97240ddadf43$var$counter + "~";
        $fadd97240ddadf43$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $fadd97240ddadf43$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $fadd97240ddadf43$var$table.set(arg, result);
        }
        if (constructor == $fadd97240ddadf43$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $fadd97240ddadf43$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$fadd97240ddadf43$export$fce6876652108ab(index = keys.pop()))if (!$fadd97240ddadf43$export$fce6876652108ab(arg[index])) result += index + ":" + $fadd97240ddadf43$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $fadd97240ddadf43$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $fadd97240ddadf43$export$b94ca9901c60634 = new WeakMap();
const $fadd97240ddadf43$var$EMPTY_CACHE = {};
const $fadd97240ddadf43$var$INITIAL_CACHE = {};
const $fadd97240ddadf43$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $fadd97240ddadf43$export$6e85fd745dc51282 = typeof window != $fadd97240ddadf43$var$STR_UNDEFINED;
const $fadd97240ddadf43$export$842dfe7a9f24298 = typeof document != $fadd97240ddadf43$var$STR_UNDEFINED;
const $fadd97240ddadf43$export$a9116928c9d15917 = ()=>$fadd97240ddadf43$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $fadd97240ddadf43$var$STR_UNDEFINED;
const $fadd97240ddadf43$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $fadd97240ddadf43$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$fadd97240ddadf43$export$fce6876652108ab(key) && cache.get(key) || $fadd97240ddadf43$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$fadd97240ddadf43$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $fadd97240ddadf43$var$INITIAL_CACHE)) $fadd97240ddadf43$var$INITIAL_CACHE[key] = prev;
                state[5](key, $fadd97240ddadf43$export$2321aea138b44780(prev, info), prev || $fadd97240ddadf43$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$fadd97240ddadf43$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $fadd97240ddadf43$var$INITIAL_CACHE) return $fadd97240ddadf43$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$fadd97240ddadf43$export$fce6876652108ab(key) && cache.get(key) || $fadd97240ddadf43$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $fadd97240ddadf43$var$online = true;
const $fadd97240ddadf43$var$isOnline = ()=>$fadd97240ddadf43$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$fadd97240ddadf43$var$onWindowEvent, $fadd97240ddadf43$var$offWindowEvent] = $fadd97240ddadf43$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $fadd97240ddadf43$export$8793edee2d425525,
    $fadd97240ddadf43$export$8793edee2d425525
];
const $fadd97240ddadf43$var$isVisible = ()=>{
    const visibilityState = $fadd97240ddadf43$export$842dfe7a9f24298 && document.visibilityState;
    return $fadd97240ddadf43$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $fadd97240ddadf43$var$initFocus = (callback)=>{
    // focus revalidate
    if ($fadd97240ddadf43$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $fadd97240ddadf43$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($fadd97240ddadf43$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $fadd97240ddadf43$var$offWindowEvent("focus", callback);
    };
};
const $fadd97240ddadf43$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $fadd97240ddadf43$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $fadd97240ddadf43$var$online = false;
    };
    $fadd97240ddadf43$var$onWindowEvent("online", onOnline);
    $fadd97240ddadf43$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $fadd97240ddadf43$var$offWindowEvent("online", onOnline);
        $fadd97240ddadf43$var$offWindowEvent("offline", onOffline);
    };
};
const $fadd97240ddadf43$export$f5ab8217e0edff04 = {
    isOnline: $fadd97240ddadf43$var$isOnline,
    isVisible: $fadd97240ddadf43$var$isVisible
};
const $fadd97240ddadf43$export$b1857f3440a65373 = {
    initFocus: $fadd97240ddadf43$var$initFocus,
    initReconnect: $fadd97240ddadf43$var$initReconnect
};
const $fadd97240ddadf43$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).useId;
const $fadd97240ddadf43$export$d2f4d8e74279c212 = !$fadd97240ddadf43$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $fadd97240ddadf43$export$eba6076d3d7d0c06 = (f)=>$fadd97240ddadf43$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $fadd97240ddadf43$export$700979bc83e7db82 = $fadd97240ddadf43$export$d2f4d8e74279c212 ? (0, $dhiZh.useEffect) : (0, $dhiZh.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $fadd97240ddadf43$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $fadd97240ddadf43$export$3723beb60427dc52 = !$fadd97240ddadf43$export$d2f4d8e74279c212 && $fadd97240ddadf43$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($fadd97240ddadf43$var$navigatorConnection.effectiveType) || $fadd97240ddadf43$var$navigatorConnection.saveData);
const $fadd97240ddadf43$export$dfdc1655ccc5b9cb = (key)=>{
    if ($fadd97240ddadf43$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $fadd97240ddadf43$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $fadd97240ddadf43$var$__timestamp = 0;
const $fadd97240ddadf43$export$3c95c4c8b671ef0 = ()=>++$fadd97240ddadf43$var$__timestamp;
const $fadd97240ddadf43$var$FOCUS_EVENT = 0;
const $fadd97240ddadf43$var$RECONNECT_EVENT = 1;
const $fadd97240ddadf43$var$MUTATE_EVENT = 2;
const $fadd97240ddadf43$var$ERROR_REVALIDATE_EVENT = 3;
var $fadd97240ddadf43$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $fadd97240ddadf43$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $fadd97240ddadf43$var$FOCUS_EVENT,
    MUTATE_EVENT: $fadd97240ddadf43$var$MUTATE_EVENT,
    RECONNECT_EVENT: $fadd97240ddadf43$var$RECONNECT_EVENT
};
async function $fadd97240ddadf43$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $fadd97240ddadf43$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($fadd97240ddadf43$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $fadd97240ddadf43$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $fadd97240ddadf43$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $fadd97240ddadf43$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $fadd97240ddadf43$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($fadd97240ddadf43$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $fadd97240ddadf43$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$fadd97240ddadf43$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $fadd97240ddadf43$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $fadd97240ddadf43$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($fadd97240ddadf43$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $fadd97240ddadf43$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $fadd97240ddadf43$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($fadd97240ddadf43$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $fadd97240ddadf43$export$6db089fe7b26f5b6,
                        _c: $fadd97240ddadf43$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $fadd97240ddadf43$export$6db089fe7b26f5b6,
                    _c: $fadd97240ddadf43$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $fadd97240ddadf43$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $fadd97240ddadf43$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $fadd97240ddadf43$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $fadd97240ddadf43$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$fadd97240ddadf43$export$b94ca9901c60634.has(provider)) {
        const opts = $fadd97240ddadf43$export$2321aea138b44780($fadd97240ddadf43$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $fadd97240ddadf43$export$c9d44e5bea4509be.bind($fadd97240ddadf43$export$6db089fe7b26f5b6, provider);
        let unmount = $fadd97240ddadf43$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$fadd97240ddadf43$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $fadd97240ddadf43$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$fadd97240ddadf43$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($fadd97240ddadf43$export$6db089fe7b26f5b6, $fadd97240ddadf43$var$revalidateAllKeys.bind($fadd97240ddadf43$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $fadd97240ddadf43$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($fadd97240ddadf43$export$6db089fe7b26f5b6, $fadd97240ddadf43$var$revalidateAllKeys.bind($fadd97240ddadf43$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $fadd97240ddadf43$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $fadd97240ddadf43$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $fadd97240ddadf43$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $fadd97240ddadf43$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$fadd97240ddadf43$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $fadd97240ddadf43$export$398604a469f7de9a = (currentData, newData)=>$fadd97240ddadf43$export$e9a4e06c7dfb0bd4(currentData) == $fadd97240ddadf43$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$fadd97240ddadf43$export$69a3209f1a06c04d, $fadd97240ddadf43$export$57e795267c26e600] = $fadd97240ddadf43$export$4008f5b66f9e0b3c(new Map());
// Default config
const $fadd97240ddadf43$export$f84bd70098573c5c = $fadd97240ddadf43$export$2321aea138b44780({
    // events
    onLoadingSlow: $fadd97240ddadf43$export$8793edee2d425525,
    onSuccess: $fadd97240ddadf43$export$8793edee2d425525,
    onError: $fadd97240ddadf43$export$8793edee2d425525,
    onErrorRetry: $fadd97240ddadf43$var$onErrorRetry,
    onDiscarded: $fadd97240ddadf43$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $fadd97240ddadf43$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $fadd97240ddadf43$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $fadd97240ddadf43$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $fadd97240ddadf43$export$69a3209f1a06c04d,
    mutate: $fadd97240ddadf43$export$57e795267c26e600,
    fallback: {}
}, $fadd97240ddadf43$export$f5ab8217e0edff04);
const $fadd97240ddadf43$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $fadd97240ddadf43$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $fadd97240ddadf43$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $fadd97240ddadf43$var$SWRConfigContext = (0, $dhiZh.createContext)({});
const $fadd97240ddadf43$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $dhiZh.useContext)($fadd97240ddadf43$var$SWRConfigContext);
    const isFunctionalConfig = $fadd97240ddadf43$export$f6e2535fb5126e54(value);
    const config = (0, $dhiZh.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $dhiZh.useMemo)(()=>isFunctionalConfig ? config : $fadd97240ddadf43$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $dhiZh.useRef)($fadd97240ddadf43$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $fadd97240ddadf43$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $fadd97240ddadf43$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $fadd97240ddadf43$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $dhiZh.createElement)($fadd97240ddadf43$var$SWRConfigContext.Provider, $fadd97240ddadf43$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $fadd97240ddadf43$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $fadd97240ddadf43$var$enableDevtools = $fadd97240ddadf43$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $fadd97240ddadf43$var$use = $fadd97240ddadf43$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $fadd97240ddadf43$var$setupDevTools = ()=>{
    if ($fadd97240ddadf43$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh)));
};
const $fadd97240ddadf43$export$a3295358bff77e = (args)=>{
    return $fadd97240ddadf43$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $fadd97240ddadf43$export$f1dc0e282d4c1c0 = ()=>{
    return $fadd97240ddadf43$export$2321aea138b44780($fadd97240ddadf43$export$f84bd70098573c5c, (0, $dhiZh.useContext)($fadd97240ddadf43$var$SWRConfigContext));
};
const $fadd97240ddadf43$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $fadd97240ddadf43$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $fadd97240ddadf43$export$b94ca9901c60634.get($fadd97240ddadf43$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $fadd97240ddadf43$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $fadd97240ddadf43$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $fadd97240ddadf43$export$b94ca9901c60634.get($fadd97240ddadf43$export$69a3209f1a06c04d);
            if (key.startsWith($fadd97240ddadf43$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($fadd97240ddadf43$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $fadd97240ddadf43$var$BUILT_IN_MIDDLEWARE = $fadd97240ddadf43$var$use.concat($fadd97240ddadf43$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $fadd97240ddadf43$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $fadd97240ddadf43$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $fadd97240ddadf43$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $fadd97240ddadf43$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($fadd97240ddadf43$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $fadd97240ddadf43$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $fadd97240ddadf43$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $fadd97240ddadf43$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, config), {
            use: uses
        }));
    };
};
$fadd97240ddadf43$var$setupDevTools();


const $16594a2605e0dfee$export$dbab534a48e651ef = (key)=>(0, $fadd97240ddadf43$export$dfdc1655ccc5b9cb)(key)[0];
/// <reference types="react/experimental" />
const $16594a2605e0dfee$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $16594a2605e0dfee$var$WITH_DEDUPE = {
    dedupe: true
};
const $16594a2605e0dfee$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $fadd97240ddadf43$export$b94ca9901c60634).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $fadd97240ddadf43$export$dfdc1655ccc5b9cb)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $dhiZh.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $dhiZh.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $dhiZh.useRef)(key);
    const fetcherRef = (0, $dhiZh.useRef)(fetcher);
    const configRef = (0, $dhiZh.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $fadd97240ddadf43$export$1251d51d9c571b45)(cache, key);
    const stateDependencies = (0, $dhiZh.useRef)({}).current;
    const fallback = (0, $fadd97240ddadf43$export$fce6876652108ab)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $fadd97240ddadf43$export$fce6876652108ab)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $dhiZh.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $fadd97240ddadf43$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $fadd97240ddadf43$export$fce6876652108ab)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $fadd97240ddadf43$export$2321aea138b44780)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return (0, $53825fa7fd9c8174$export$71511d61b312f219)({
                isValidating: true,
                isLoading: true
            }, snapshot);
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $l6BoB.useSyncExternalStore)((0, $dhiZh.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $fadd97240ddadf43$export$fce6876652108ab)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $dhiZh.useRef)(data);
    const returnedData = keepPreviousData ? (0, $fadd97240ddadf43$export$fce6876652108ab)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $fadd97240ddadf43$export$fce6876652108ab)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $fadd97240ddadf43$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $fadd97240ddadf43$export$fce6876652108ab)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $fadd97240ddadf43$export$fce6876652108ab)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $fadd97240ddadf43$export$fce6876652108ab)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $fadd97240ddadf43$export$fce6876652108ab)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $dhiZh.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $fadd97240ddadf43$export$ddb64fe6466374f7) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $fadd97240ddadf43$export$fce6876652108ab)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $fadd97240ddadf43$export$fce6876652108ab)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $fadd97240ddadf43$export$3c95c4c8b671ef0)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $fadd97240ddadf43$export$6db089fe7b26f5b6);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $fadd97240ddadf43$export$fce6876652108ab)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $fadd97240ddadf43$export$f6e2535fb5126e54)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $fadd97240ddadf43$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $dhiZh.useCallback)((...args)=>{
        return (0, $fadd97240ddadf43$export$c9d44e5bea4509be)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $fadd97240ddadf43$export$700979bc83e7db82)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $fadd97240ddadf43$export$fce6876652108ab)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $fadd97240ddadf43$export$700979bc83e7db82)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $fadd97240ddadf43$export$6db089fe7b26f5b6), $16594a2605e0dfee$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $fadd97240ddadf43$export$10213d6aa5ce32e6).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $fadd97240ddadf43$export$10213d6aa5ce32e6).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $fadd97240ddadf43$export$10213d6aa5ce32e6).MUTATE_EVENT) return revalidate();
            else if (type == (0, $fadd97240ddadf43$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $fadd97240ddadf43$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $fadd97240ddadf43$export$fce6876652108ab)(data) || (0, $fadd97240ddadf43$export$d2f4d8e74279c212)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $fadd97240ddadf43$export$eba6076d3d7d0c06)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $fadd97240ddadf43$export$700979bc83e7db82)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $fadd97240ddadf43$export$f6e2535fb5126e54)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($16594a2605e0dfee$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $dhiZh.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $fadd97240ddadf43$export$fce6876652108ab)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $fadd97240ddadf43$export$ddb64fe6466374f7) && (0, $fadd97240ddadf43$export$d2f4d8e74279c212)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $fadd97240ddadf43$export$fce6876652108ab)(req)) {
            const promise = boundMutate(req);
            $16594a2605e0dfee$var$use(promise);
        }
        if ((0, $fadd97240ddadf43$export$fce6876652108ab)(error)) {
            const promise = revalidate($16594a2605e0dfee$var$WITH_DEDUPE);
            if (!(0, $fadd97240ddadf43$export$fce6876652108ab)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $16594a2605e0dfee$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $16594a2605e0dfee$export$4c7bbecdacc3ca2c = (0, $fadd97240ddadf43$export$8b8a958a7f6f130c).defineProperty((0, $fadd97240ddadf43$export$4c7bbecdacc3ca2c), "defaultValue", {
    value: (0, $fadd97240ddadf43$export$f84bd70098573c5c)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $16594a2605e0dfee$export$2e2bcd8739ae039 = (0, $fadd97240ddadf43$export$84d44e54e14b0133)($16594a2605e0dfee$var$useSWRHandler);


/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $0069e026ae20dbcb$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $0069e026ae20dbcb$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var $0069e026ae20dbcb$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $0069e026ae20dbcb$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $0069e026ae20dbcb$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


function $548d1c09027c69cb$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $548d1c09027c69cb$export$2e2bcd8739ae039 = $548d1c09027c69cb$var$stylis_min;


var $fb6d5a28f419073f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $fb6d5a28f419073f$export$2e2bcd8739ae039 = $fb6d5a28f419073f$var$weakMemoize;


// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $678580cdbf37b277$var$delimiter = "/*|*/";
var $678580cdbf37b277$var$needle = $678580cdbf37b277$var$delimiter + "}";
function $678580cdbf37b277$var$toSheet(block) {
    if (block) $678580cdbf37b277$var$Sheet.current.insert(block + "}");
}
var $678580cdbf37b277$var$Sheet = {
    current: null
};
var $678580cdbf37b277$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $678580cdbf37b277$var$Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $678580cdbf37b277$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $678580cdbf37b277$var$Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? $678580cdbf37b277$var$delimiter : "");
            }
        case -2:
            content.split($678580cdbf37b277$var$needle).forEach($678580cdbf37b277$var$toSheet);
    }
};
var $678580cdbf37b277$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $548d1c09027c69cb$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($678580cdbf37b277$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $678580cdbf37b277$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $0069e026ae20dbcb$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $678580cdbf37b277$export$2e2bcd8739ae039 = $678580cdbf37b277$var$createCache;


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7519890e02374a30$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $7519890e02374a30$export$2e2bcd8739ae039 = $7519890e02374a30$var$murmur2;


var $a1d04a90b1c67912$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $a1d04a90b1c67912$export$2e2bcd8739ae039 = $a1d04a90b1c67912$var$unitlessKeys;


function $57defd6f840aa04a$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $57defd6f840aa04a$export$2e2bcd8739ae039 = $57defd6f840aa04a$var$memoize;


var $8912b92d98f6746e$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8912b92d98f6746e$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $8912b92d98f6746e$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8912b92d98f6746e$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8912b92d98f6746e$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8912b92d98f6746e$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $8912b92d98f6746e$var$processStyleName = (0, $57defd6f840aa04a$export$2e2bcd8739ae039)(function(styleName) {
    return $8912b92d98f6746e$var$isCustomProperty(styleName) ? styleName : styleName.replace($8912b92d98f6746e$var$hyphenateRegex, "-$&").toLowerCase();
});
var $8912b92d98f6746e$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($8912b92d98f6746e$var$animationRegex, function(match, p1, p2) {
                $8912b92d98f6746e$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8912b92d98f6746e$var$cursor
                };
                return p1;
            });
    }
    if ((0, $a1d04a90b1c67912$export$2e2bcd8739ae039)[key] !== 1 && !$8912b92d98f6746e$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $8912b92d98f6746e$var$contentValuePattern, $8912b92d98f6746e$var$contentValues, $8912b92d98f6746e$var$oldProcessStyleValue, $8912b92d98f6746e$var$msPattern, $8912b92d98f6746e$var$hyphenPattern, $8912b92d98f6746e$var$hyphenatedCache;
var $8912b92d98f6746e$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $8912b92d98f6746e$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $8912b92d98f6746e$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $8912b92d98f6746e$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8912b92d98f6746e$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8912b92d98f6746e$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $8912b92d98f6746e$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $8912b92d98f6746e$var$cursor;
                var result = interpolation(mergedProps);
                $8912b92d98f6746e$var$cursor = previousCursor;
                return $8912b92d98f6746e$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $8912b92d98f6746e$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8912b92d98f6746e$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($8912b92d98f6746e$var$isProcessableValue(value)) string += $8912b92d98f6746e$var$processStyleName(_key) + ":" + $8912b92d98f6746e$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($8912b92d98f6746e$var$isProcessableValue(value[_i])) string += $8912b92d98f6746e$var$processStyleName(_key) + ":" + $8912b92d98f6746e$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $8912b92d98f6746e$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $8912b92d98f6746e$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $8912b92d98f6746e$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $8912b92d98f6746e$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $8912b92d98f6746e$var$cursor;
var $8912b92d98f6746e$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $8912b92d98f6746e$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8912b92d98f6746e$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8912b92d98f6746e$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $8912b92d98f6746e$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8912b92d98f6746e$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $7519890e02374a30$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8912b92d98f6746e$var$cursor
    };
};


var $bafaa4cdf0f8e02f$var$isBrowser = true;
function $bafaa4cdf0f8e02f$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $bafaa4cdf0f8e02f$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $bafaa4cdf0f8e02f$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $0a3f93996b58bce9$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $0a3f93996b58bce9$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $bafaa4cdf0f8e02f$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $0a3f93996b58bce9$var$createEmotion = function createEmotion(options) {
    var cache = (0, $678580cdbf37b277$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8912b92d98f6746e$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $bafaa4cdf0f8e02f$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $8912b92d98f6746e$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $0a3f93996b58bce9$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $8912b92d98f6746e$export$6321afa313b251b5)(args, cache.registered);
        $0a3f93996b58bce9$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $0a3f93996b58bce9$var$merge(cache.registered, css, $0a3f93996b58bce9$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $bafaa4cdf0f8e02f$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $0a3f93996b58bce9$var$merge.bind(null, cache.registered, css)
    };
};
var $0a3f93996b58bce9$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
var $0a3f93996b58bce9$export$2e2bcd8739ae039 = $0a3f93996b58bce9$var$createEmotion;


var $caccab916c328344$var$_createEmotion = (0, $0a3f93996b58bce9$export$2e2bcd8739ae039)(), $caccab916c328344$export$4909b86c8034bf73 = $caccab916c328344$var$_createEmotion.flush, $caccab916c328344$export$fa8d919ba61d84db = $caccab916c328344$var$_createEmotion.hydrate, $caccab916c328344$export$a274e22fb40f762e = $caccab916c328344$var$_createEmotion.cx, $caccab916c328344$export$4950aa0f605343fb = $caccab916c328344$var$_createEmotion.merge, $caccab916c328344$export$95d99596f328fd52 = $caccab916c328344$var$_createEmotion.getRegisteredStyles, $caccab916c328344$export$efb9f5caaa2ca0c7 = $caccab916c328344$var$_createEmotion.injectGlobal, $caccab916c328344$export$d25ddfdf17c3ad3e = $caccab916c328344$var$_createEmotion.keyframes, $caccab916c328344$export$dbf350e5966cf602 = $caccab916c328344$var$_createEmotion.css, $caccab916c328344$export$995990c5c04c46f0 = $caccab916c328344$var$_createEmotion.sheet, $caccab916c328344$export$69a3209f1a06c04d = $caccab916c328344$var$_createEmotion.cache;



var $dhiZh = parcelRequire("dhiZh");
var $d70e60fbb1642334$exports = {};
Object.defineProperty($d70e60fbb1642334$exports, "__esModule", {
    value: true
});
$d70e60fbb1642334$exports = {
    "contentWidthDefault": "1280px",
    "contentWidthText": "768px",
    "contentWidthFull": "100%",
    "spacing2Xs": "0.25rem",
    "spacingXs": "0.5rem",
    "spacingS": "0.75rem",
    "spacingM": "1rem",
    "spacingL": "1.5rem",
    "spacingXl": "2rem",
    "spacing2Xl": "3rem",
    "spacing3Xl": "4rem",
    "spacing4Xl": "5rem",
    "zIndexNegative": -1,
    "zIndexWorkbench": 0,
    "zIndexDefault": 1,
    "zIndexWorkbenchHeader": 10,
    "zIndexModal": 100,
    "zIndexModalContent": 101,
    "zIndexDropdown": 1000,
    "zIndexTooltip": 10000,
    "zIndexNotification": 100000,
    "borderRadiusSmall": "4px",
    "borderRadiusMedium": "6px",
    "boxShadowPositive": "0px 1px 0px rgb(25, 37, 50, 0.1)",
    "boxShadowDefault": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px 3px 7px -3px rgba(25, 37, 50, 0.1), 0px 6px 12px -2px rgba(25, 37, 50, 0.1);",
    "boxShadowHeavy": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px -6px 16px -6px rgba(25, 37, 50, 0.03), 0px 8px 16px -8px rgba(25, 37, 50, 0.2), 0px 13px 27px -5px rgba(25, 37, 50, 0.15);",
    "insetBoxShadowDefault": "inset 0px 2px 0px rgba(225, 228, 232, 0.2);",
    "glowPrimary": "0px 0px 0px 3px #98CBFF",
    "glowNegative": "0px 0px 0px 3px #FFB1B2",
    "glowPositive": "0px 0px 0px 3px #9ED696",
    "glowWarning": "0px 0px 0px 3px #FDE5C0",
    "glowMuted": "0px 0px 0px 3px #E7EBEE",
    "colorBlack": "#0C141C",
    "colorBlueLightest": "#E8F5FF",
    "colorBlueLight": "#98CBFF",
    "colorBlueMid": "#036FE3",
    "colorBlueBase": "#0059C8",
    "colorBlueDark": "#0041AB",
    "blue100": "#E8F5FF",
    "blue200": "#CEECFF",
    "blue300": "#98CBFF",
    "blue400": "#40A0FF",
    "blue500": "#036FE3",
    "blue600": "#0059C8",
    "blue700": "#0041AB",
    "blue800": "#003298",
    "blue900": "#002A8E",
    "colorContrastDark": "#0C141C",
    "colorContrastMid": "#111B2B",
    "colorContrastLight": "#1B273A",
    "colorCoralDark": "#FFE0E0",
    "colorCoralMid": "#FFF2F2",
    "colorElementDarkest": "#67728A",
    "colorElementDark": "#AEC1CC",
    "colorElementMid": "#CFD9E0",
    "colorElementLight": "#E7EBEE",
    "colorElementLightest": "#F7F9FA",
    "gray100": "#F7F9FA",
    "gray200": "#E7EBEE",
    "gray300": "#CFD9E0",
    "gray400": "#AEC1CC",
    "gray500": "#67728A",
    "gray600": "#5A657C",
    "gray700": "#414D63",
    "gray800": "#1B273A",
    "gray900": "#111B2B",
    "colorGreenDark": "#00550C",
    "colorGreenBase": "#006D23",
    "colorGreenMid": "#008539",
    "colorGreenLight": "#9ED696",
    "colorGreenLightest": "#EAF9E8",
    "green100": "#EAF9E8",
    "green200": "#CDF3C6",
    "green300": "#9ED696",
    "green400": "#5DB057",
    "green500": "#008539",
    "green600": "#006D23",
    "green700": "#00550C",
    "green800": "#004700",
    "green900": "#003F00",
    "colorIceDark": "#CEECFF",
    "colorIceMid": "#E8F5FF",
    "colorMintDark": "#CDF3C6",
    "colorMintMid": "#EAF9E8",
    "colorOrangeDark": "#B12D00",
    "colorOrangeBase": "#CC4500",
    "colorOrangeMid": "#F07F23",
    "colorOrangeLight": "#FDE5C0",
    "colorOrangeLightest": "#FFF2E4",
    "orange100": "#FFF2E4",
    "orange200": "#FDE5C0",
    "orange300": "#FDB882",
    "orange400": "#F07F23",
    "orange500": "#CC4500",
    "orange600": "#B12D00",
    "orange700": "#892300",
    "orange800": "#731A00",
    "orange900": "#631C00",
    "colorPeachDark": "#FDE5C0",
    "colorPeachMid": "#FFF2E4",
    "colorPurpleDark": "#5127B5",
    "colorPurpleBase": "#6C3ECF",
    "colorPurpleMid": "#8553E7",
    "colorPurpleLight": "#D1BBFF",
    "colorPurpleLightest": "#F7F2FF",
    "purple100": "#F7F2FF",
    "purple200": "#EDE3FF",
    "purple300": "#D1BBFF",
    "purple400": "#AE89FF",
    "purple500": "#8553E7",
    "purple600": "#6C3ECF",
    "purple700": "#5127B5",
    "purple800": "#3E16A4",
    "purple900": "#340E9C",
    "colorRedDark": "#990017",
    "colorRedBase": "#BD002A",
    "colorRedMid": "#DA294A",
    "colorRedLight": "#FFB1B2",
    "colorRedLightest": "#FFF2F2",
    "red100": "#FFF2F2",
    "red200": "#FFE0E0",
    "red300": "#FFB1B2",
    "red400": "#FF707D",
    "red500": "#DA294A",
    "red600": "#BD002A",
    "red700": "#990017",
    "red800": "#7F0010",
    "red900": "#72000E",
    "colorPrimary": "#0059C8",
    "colorPositive": "#006D23",
    "colorNegative": "#BD002A",
    "colorWarning": "#CC4500",
    "colorTextDark": "#111B2B",
    "colorTextBase": "#1B273A",
    "colorTextMid": "#414D63",
    "colorTextLight": "#5A657C",
    "colorTextLightest": "#67728A",
    "colorWhite": "#ffffff",
    "colorYellowDark": "#956300",
    "colorYellowBase": "#EAAF09",
    "colorYellowMid": "#FFC835",
    "colorYellowLight": "#FFD960",
    "colorYellowLightest": "#FFF6CC",
    "yellow100": "#FEF9DF",
    "yellow200": "#FFF6CC",
    "yellow300": "#FFE993",
    "yellow400": "#FFD960",
    "yellow500": "#FFC835",
    "yellow600": "#EAAF09",
    "yellow700": "#B78300",
    "yellow800": "#956300",
    "yellow900": "#7F5200",
    "transitionDurationShort": "0.1s",
    "transitionDurationDefault": "0.2s",
    "transitionDurationLong": "0.3s",
    "transitionEasingDefault": "ease-in-out",
    "transitionEasingCubicBezier": "cubic-bezier(0.13, 0.62, 0.11, 0.99)",
    "fontBaseDefault": "16",
    "fontSize4Xl": "3rem",
    "fontSize3Xl": "2.25rem",
    "fontSize2Xl": "1.75rem",
    "fontSizeXl": "1.25rem",
    "fontSizeXlHigh": "1.125rem",
    "fontSizeL": "1rem",
    "fontSizeLHigh": "0.875rem",
    "fontSizeM": "0.875rem",
    "fontSizeMHigh": "0.75rem",
    "fontSizeS": "0.75rem",
    "fontSizeSHigh": "0.625rem",
    "fontStackPrimary": "-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "fontStackMonospace": "SFMono-Regular, Consolas, Liberation Mono, Menlo,monospace",
    "fontWeightNormal": 400,
    "fontWeightMedium": 500,
    "fontWeightDemiBold": 600,
    "letterSpacingDefault": "0rem",
    "letterSpacingWide": "0.1rem",
    "lineHeightDefault": "1.5",
    "lineHeightCondensed": "1.25",
    "lineHeight4Xl": "3.5rem",
    "lineHeight3Xl": "3rem",
    "lineHeight2Xl": "2.25rem",
    "lineHeightXl": "2rem",
    "lineHeightXlHigh": "1.5rem",
    "lineHeightL": "1.5rem",
    "lineHeightLHigh": "1.25rem",
    "lineHeightM": "1.25rem",
    "lineHeightMHigh": "1rem",
    "lineHeightS": "1rem",
    "lineHeightSHigh": "0.75rem"
};



var $dhiZh = parcelRequire("dhiZh");
function $82639cd547a0a9f0$export$2e2bcd8739ae039(t, e) {
    return $82639cd547a0a9f0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $82639cd547a0a9f0$export$2e2bcd8739ae039(t, e);
}


function $22c420178cb2dfc5$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $82639cd547a0a9f0$export$2e2bcd8739ae039)(t, o);
}



var $dhiZh = parcelRequire("dhiZh");

var $a50e9d7e42bd37a7$exports = {};
var $9e5558a80c230417$exports = {};
function $9e5558a80c230417$var$_setPrototypeOf(t, e) {
    return $9e5558a80c230417$exports = $9e5558a80c230417$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9e5558a80c230417$exports.__esModule = true, $9e5558a80c230417$exports["default"] = $9e5558a80c230417$exports, $9e5558a80c230417$var$_setPrototypeOf(t, e);
}
$9e5558a80c230417$exports = $9e5558a80c230417$var$_setPrototypeOf, $9e5558a80c230417$exports.__esModule = true, $9e5558a80c230417$exports["default"] = $9e5558a80c230417$exports;


function $a50e9d7e42bd37a7$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $9e5558a80c230417$exports(t, o);
}
$a50e9d7e42bd37a7$exports = $a50e9d7e42bd37a7$var$_inheritsLoose, $a50e9d7e42bd37a7$exports.__esModule = true, $a50e9d7e42bd37a7$exports["default"] = $a50e9d7e42bd37a7$exports;



var $dhiZh = parcelRequire("dhiZh");



var $f3768d1bc478f1bc$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $f3768d1bc478f1bc$var$EmotionCacheContext = /*#__PURE__*/ (0, $dhiZh.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? (0, $678580cdbf37b277$export$2e2bcd8739ae039)() : null);
var $f3768d1bc478f1bc$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $dhiZh.createContext)({});
var $f3768d1bc478f1bc$export$e7094788287c5e9b = $f3768d1bc478f1bc$var$EmotionCacheContext.Provider;
var $f3768d1bc478f1bc$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $dhiZh.createElement)($f3768d1bc478f1bc$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $dhiZh.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $f3768d1bc478f1bc$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $f3768d1bc478f1bc$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $f3768d1bc478f1bc$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $f3768d1bc478f1bc$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($f3768d1bc478f1bc$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$f3768d1bc478f1bc$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $f3768d1bc478f1bc$var$Noop = function Noop() {
    return null;
};
var $f3768d1bc478f1bc$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$f3768d1bc478f1bc$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $bafaa4cdf0f8e02f$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8912b92d98f6746e$export$6321afa313b251b5)(registeredStyles);
    var labelFromStack;
    var rules = (0, $bafaa4cdf0f8e02f$export$6f077d94b33a01aa)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($f3768d1bc478f1bc$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $f3768d1bc478f1bc$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $dhiZh.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $dhiZh.createElement)($f3768d1bc478f1bc$var$Noop, null);
    return /*#__PURE__*/ (0, $dhiZh.createElement)((0, $dhiZh.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $f3768d1bc478f1bc$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $f3768d1bc478f1bc$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === "function") return /*#__PURE__*/ (0, $dhiZh.createElement)($f3768d1bc478f1bc$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $f3768d1bc478f1bc$var$render(cache, props, theme, ref);
    });
    return $f3768d1bc478f1bc$var$render(cache, props, null, ref);
});






function $2a490c6296d9762f$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8912b92d98f6746e$export$6321afa313b251b5)(args);
}
var $2a490c6296d9762f$export$2e2bcd8739ae039 = $2a490c6296d9762f$var$css;


var $aa4a18235b340489$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $f3768d1bc478f1bc$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return (0, $dhiZh.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $f3768d1bc478f1bc$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $f3768d1bc478f1bc$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $dhiZh.createElement).apply(null, createElementArgArray);
};
var $aa4a18235b340489$var$warnedAboutCssPropForGlobal = false;
var $aa4a18235b340489$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $f3768d1bc478f1bc$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === "function") return /*#__PURE__*/ (0, $dhiZh.createElement)((0, $f3768d1bc478f1bc$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var serialized = (0, $8912b92d98f6746e$export$6321afa313b251b5)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $dhiZh.createElement)($aa4a18235b340489$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $8912b92d98f6746e$export$6321afa313b251b5)([
        styles
    ]);
    return /*#__PURE__*/ (0, $dhiZh.createElement)($aa4a18235b340489$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $aa4a18235b340489$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $22c420178cb2dfc5$export$2e2bcd8739ae039)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $0069e026ae20dbcb$export$9d753cd7ae895cce)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + '="' + this.props.serialized.name + '"]');
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $bafaa4cdf0f8e02f$export$6f077d94b33a01aa)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $dhiZh.Component));
var $aa4a18235b340489$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $2a490c6296d9762f$export$2e2bcd8739ae039).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $aa4a18235b340489$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $aa4a18235b340489$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $bafaa4cdf0f8e02f$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $aa4a18235b340489$var$Noop = function Noop() {
    return null;
};
var $aa4a18235b340489$export$9b9c0f9d9f3552b8 = (0, $f3768d1bc478f1bc$export$efccba1c4a2ef57b)(function(props, context) {
    return /*#__PURE__*/ (0, $dhiZh.createElement)((0, $f3768d1bc478f1bc$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $8912b92d98f6746e$export$6321afa313b251b5)(args, context.registered);
            (0, $bafaa4cdf0f8e02f$export$6f077d94b33a01aa)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $aa4a18235b340489$var$merge(context.registered, css, $aa4a18235b340489$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $dhiZh.createElement)($aa4a18235b340489$var$Noop, null);
        return /*#__PURE__*/ (0, $dhiZh.createElement)((0, $dhiZh.Fragment), null, possiblyStyleElement, ele);
    });
});




let $1f939aaca629584c$var$_ = (t)=>t, $1f939aaca629584c$var$t, $1f939aaca629584c$var$t1;
var $1f939aaca629584c$var$me = Object.defineProperty, $1f939aaca629584c$var$ce = Object.defineProperties;
var $1f939aaca629584c$var$de = Object.getOwnPropertyDescriptors;
var $1f939aaca629584c$var$A = Object.getOwnPropertySymbols;
var $1f939aaca629584c$var$v = Object.prototype.hasOwnProperty, $1f939aaca629584c$var$j = Object.prototype.propertyIsEnumerable;
var $1f939aaca629584c$var$X = (e, t, o)=>t in e ? $1f939aaca629584c$var$me(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : e[t] = o, $1f939aaca629584c$var$i = (e, t)=>{
    for(var o in t || (t = {}))$1f939aaca629584c$var$v.call(t, o) && $1f939aaca629584c$var$X(e, o, t[o]);
    if ($1f939aaca629584c$var$A) for (var o of $1f939aaca629584c$var$A(t))$1f939aaca629584c$var$j.call(t, o) && $1f939aaca629584c$var$X(e, o, t[o]);
    return e;
}, $1f939aaca629584c$var$p = (e, t)=>$1f939aaca629584c$var$ce(e, $1f939aaca629584c$var$de(t));
var $1f939aaca629584c$var$c = (e, t)=>{
    var o = {};
    for(var r in e)$1f939aaca629584c$var$v.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
    if (e != null && $1f939aaca629584c$var$A) for (var r of $1f939aaca629584c$var$A(e))t.indexOf(r) < 0 && $1f939aaca629584c$var$j.call(e, r) && (o[r] = e[r]);
    return o;
};
var $1f939aaca629584c$var$ye = (0, $2a490c6296d9762f$export$2e2bcd8739ae039)($1f939aaca629584c$var$t || ($1f939aaca629584c$var$t = $1f939aaca629584c$var$_`
  /* Remove default margin */
  /* Button has default margin in some browsers, like safari */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd,
  button {
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }

  /* Set core root defaults */
  html:focus-within {
    scroll-behavior: smooth;
  }

  /* Set core body defaults */
  body {
    text-rendering: optimizeSpeed;
    line-height: 1.5;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`)), $1f939aaca629584c$export$c507fb1c2e1ac13a = ({ withNormalize: e = !0, styles: t })=>$dhiZh.createElement((0, $aa4a18235b340489$export$98f03c5d19621d70), {
        styles: (0, $2a490c6296d9762f$export$2e2bcd8739ae039)($1f939aaca629584c$var$t1 || ($1f939aaca629584c$var$t1 = $1f939aaca629584c$var$_`
        ${0};
        html {
          border: 0;
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          color: ${0};
          font-family: ${0};
          font-size: ${0};
          line-height: ${0};
        }

        code {
          font-family: ${0};
        }

        fieldset {
          border: 0;
          margin: 0;
          padding: 0;
        }

        *,
        *::after,
        *::before {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
          box-sizing: inherit;
        }

        ${0};
      `), e ? $1f939aaca629584c$var$ye : void 0, (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).gray800, (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).fontStackPrimary, (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).fontSizeM, (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).lineHeightM, (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).fontStackMonospace, t)
    });
var $1f939aaca629584c$var$ge = {
    none: 0,
    spacing2Xs: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacing2Xs,
    spacingXs: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacingXs,
    spacingS: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacingS,
    spacingM: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacingM,
    spacingL: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacingL,
    spacingXl: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacingXl,
    spacing2Xl: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacing2Xl,
    spacing3Xl: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacing3Xl,
    spacing4Xl: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).spacing4Xl
};
function $1f939aaca629584c$var$m(e) {
    return $1f939aaca629584c$var$ge[e];
}
function $1f939aaca629584c$var$H(e) {
    return Object.assign({}, e.margin ? {
        margin: $1f939aaca629584c$var$m(e.margin)
    } : null, e.marginLeft ? {
        marginLeft: $1f939aaca629584c$var$m(e.marginLeft)
    } : null, e.marginRight ? {
        marginRight: $1f939aaca629584c$var$m(e.marginRight)
    } : null, e.marginTop ? {
        marginTop: $1f939aaca629584c$var$m(e.marginTop)
    } : null, e.marginBottom ? {
        marginBottom: $1f939aaca629584c$var$m(e.marginBottom)
    } : null, e.padding ? {
        padding: $1f939aaca629584c$var$m(e.padding)
    } : null, e.paddingLeft ? {
        paddingLeft: $1f939aaca629584c$var$m(e.paddingLeft)
    } : null, e.paddingRight ? {
        paddingRight: $1f939aaca629584c$var$m(e.paddingRight)
    } : null, e.paddingTop ? {
        paddingTop: $1f939aaca629584c$var$m(e.paddingTop)
    } : null, e.paddingBottom ? {
        paddingBottom: $1f939aaca629584c$var$m(e.paddingBottom)
    } : null);
}
var $1f939aaca629584c$var$ue = "div";
function $1f939aaca629584c$export$3c8fe9c3d6a8ef22(e) {
    let E = e, { display: t, className: o, margin: r, marginBottom: a, marginLeft: s, marginRight: n, marginTop: l, padding: d, paddingBottom: f, paddingLeft: y, paddingRight: x, paddingTop: u, testId: R, as: h = $1f939aaca629584c$var$ue } = E, T = $1f939aaca629584c$var$c(E, [
        "display",
        "className",
        "margin",
        "marginBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "padding",
        "paddingBottom",
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "testId",
        "as"
    ]);
    return {
        boxProps: $1f939aaca629584c$var$i({
            className: (0, $caccab916c328344$export$a274e22fb40f762e)((0, $caccab916c328344$export$dbf350e5966cf602)({
                display: t
            }), (0, $caccab916c328344$export$dbf350e5966cf602)($1f939aaca629584c$var$i({}, $1f939aaca629584c$var$H({
                margin: r,
                marginBottom: a,
                marginLeft: s,
                marginRight: n,
                marginTop: l,
                padding: d,
                paddingBottom: f,
                paddingLeft: y,
                paddingRight: x,
                paddingTop: u
            }))), o),
            "data-test-id": R
        }, T),
        Element: h
    };
}
function $1f939aaca629584c$var$K(e, t) {
    let { boxProps: o, Element: r } = $1f939aaca629584c$export$3c8fe9c3d6a8ef22(e);
    return $dhiZh.createElement(r, $1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, o), {
        ref: t
    }), e.children);
}
$1f939aaca629584c$var$K.displayName = "Box";
var $1f939aaca629584c$export$e71c4d32a2263218 = $dhiZh.forwardRef($1f939aaca629584c$var$K);
var $1f939aaca629584c$var$Ee = "div";
function $1f939aaca629584c$var$V(Ne, se) {
    var U = Ne, { isInline: e, alignItems: t, alignSelf: o, alignContent: r, flex: a, flexBasis: s, flexShrink: n, flexDirection: l, flexGrow: d, flexWrap: f, fullHeight: y, fullWidth: x, gap: u, justifyContent: R, justifyItems: h, justifySelf: T, order: b, children: E, as: I } = U, G = $1f939aaca629584c$var$c(U, [
        "isInline",
        "alignItems",
        "alignSelf",
        "alignContent",
        "flex",
        "flexBasis",
        "flexShrink",
        "flexDirection",
        "flexGrow",
        "flexWrap",
        "fullHeight",
        "fullWidth",
        "gap",
        "justifyContent",
        "justifyItems",
        "justifySelf",
        "order",
        "children",
        "as"
    ]);
    var N;
    let { boxProps: O, Element: le } = $1f939aaca629584c$export$3c8fe9c3d6a8ef22($1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, G), {
        as: I || $1f939aaca629584c$var$Ee
    }));
    return $dhiZh.createElement(le, $1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, O), {
        className: (0, $caccab916c328344$export$a274e22fb40f762e)((0, $caccab916c328344$export$dbf350e5966cf602)({
            display: e ? "inline-flex" : "flex",
            width: x ? "100%" : void 0,
            height: y ? "100%" : void 0,
            flex: a,
            flexBasis: s,
            flexShrink: n,
            flexDirection: l,
            gap: u === "none" ? 0 : (N = (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports)))[u]) != null ? N : u,
            justifyContent: R,
            justifyItems: h,
            justifySelf: T,
            alignItems: t,
            alignSelf: o,
            alignContent: r,
            order: b,
            flexWrap: f,
            flexGrow: d
        }), O.className),
        ref: se
    }), E);
}
$1f939aaca629584c$var$V.displayName = "Flex";
var $1f939aaca629584c$export$f51f4c4ede09e011 = $dhiZh.forwardRef($1f939aaca629584c$var$V);
var $1f939aaca629584c$var$Ge = "div";
function $1f939aaca629584c$var$Q(u, x) {
    var R = u, { alignContent: e, children: t, columnGap: o = "spacingM", columns: r = "auto", flow: a, isInline: s, justifyContent: n, rowGap: l = "none", rows: d = "auto", as: f } = R, y = $1f939aaca629584c$var$c(R, [
        "alignContent",
        "children",
        "columnGap",
        "columns",
        "flow",
        "isInline",
        "justifyContent",
        "rowGap",
        "rows",
        "as"
    ]);
    var E, I;
    let h = (G)=>typeof G == "number" ? `repeat(${G}, minmax(0, 1fr))` : G, { boxProps: T, Element: b } = $1f939aaca629584c$export$3c8fe9c3d6a8ef22($1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, y), {
        as: f || $1f939aaca629584c$var$Ge
    }));
    return $dhiZh.createElement(b, $1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, T), {
        className: (0, $caccab916c328344$export$a274e22fb40f762e)((0, $caccab916c328344$export$dbf350e5966cf602)({
            display: s ? "inline-grid" : "grid",
            gridTemplateColumns: h(r),
            gridTemplateRows: h(d),
            flow: a,
            justifyContent: n,
            alignContent: e,
            columnGap: (E = $1f939aaca629584c$var$m(o)) != null ? E : 0,
            rowGap: (I = $1f939aaca629584c$var$m(l)) != null ? I : 0
        }), T.className),
        ref: x
    }), t);
}
$1f939aaca629584c$var$Q.displayName = "Grid";
var $1f939aaca629584c$var$Y = $dhiZh.forwardRef($1f939aaca629584c$var$Q);
function $1f939aaca629584c$var$Z(f, d) {
    var y = f, { children: e, columnStart: t, columnEnd: o, rowStart: r, rowEnd: a, area: s, order: n } = y, l = $1f939aaca629584c$var$c(y, [
        "children",
        "columnStart",
        "columnEnd",
        "rowStart",
        "rowEnd",
        "area",
        "order"
    ]);
    let x = s || [
        r || "auto",
        t || "auto",
        a || "auto",
        o || "auto"
    ].join(" / "), { boxProps: u, Element: R } = $1f939aaca629584c$export$3c8fe9c3d6a8ef22(l);
    return $dhiZh.createElement(R, $1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, u), {
        className: (0, $caccab916c328344$export$a274e22fb40f762e)((0, $caccab916c328344$export$dbf350e5966cf602)({
            gridArea: x,
            order: n
        }), u.className),
        ref: d
    }), e);
}
$1f939aaca629584c$var$Z.displayName = "GridItem";
var $1f939aaca629584c$export$9eb849b9b922d396 = $dhiZh.forwardRef($1f939aaca629584c$var$Z);
var $1f939aaca629584c$export$ef2184bd89960b14 = $1f939aaca629584c$var$Y;
$1f939aaca629584c$export$ef2184bd89960b14.Item = $1f939aaca629584c$export$9eb849b9b922d396;
var $1f939aaca629584c$var$Ie = "div";
function $1f939aaca629584c$var$ee(d, l) {
    var f = d, { flexDirection: e = "row", alignItems: t = "center", isInline: o = !1, spacing: r = "spacingM", children: a, as: s } = f, n = $1f939aaca629584c$var$c(f, [
        "flexDirection",
        "alignItems",
        "isInline",
        "spacing",
        "children",
        "as"
    ]);
    let { boxProps: y, Element: x } = $1f939aaca629584c$export$3c8fe9c3d6a8ef22($1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, n), {
        as: s || $1f939aaca629584c$var$Ie
    }));
    return $dhiZh.createElement($1f939aaca629584c$export$f51f4c4ede09e011, $1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, y), {
        as: x,
        flexDirection: e,
        alignItems: t,
        isInline: o,
        className: y.className,
        gap: r,
        ref: l
    }), a);
}
$1f939aaca629584c$var$ee.displayName = "Stack";
var $1f939aaca629584c$export$694e0d28c7ffc90c = $dhiZh.forwardRef($1f939aaca629584c$var$ee);
function $1f939aaca629584c$var$oe() {
    return {
        screenReaderOnly: (0, $caccab916c328344$export$dbf350e5966cf602)({
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            border: 0
        })
    };
}
var $1f939aaca629584c$export$518e781dade4a416 = (s)=>{
    var n = s, { children: e, className: t, testId: o = "cf-ui-ScreenReaderOnly", as: r = "div" } = n, a = $1f939aaca629584c$var$c(n, [
        "children",
        "className",
        "testId",
        "as"
    ]);
    let l = $1f939aaca629584c$var$oe();
    return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement(r, $1f939aaca629584c$var$p($1f939aaca629584c$var$i({}, a), {
        "data-test-id": o,
        className: (0, $caccab916c328344$export$a274e22fb40f762e)(l.screenReaderOnly, t)
    }), e);
};
function $1f939aaca629584c$export$f680877a34711e37(e, t) {
    return (0, $dhiZh.useMemo)(()=>e || [
            t || "id",
            Math.round(Math.random() * 1e4)
        ].join("_"), []);
}
function $1f939aaca629584c$export$6f32135080cb4c3({ isOpen: e, defaultIsOpen: t, onOpen: o, onClose: r }) {
    let [a, s] = (0, $dhiZh.useState)(t || !1), n = e !== void 0, l = n ? e : a, d = (0, $dhiZh.useCallback)(()=>{
        n || s(!1), r == null || r();
    }, [
        n,
        r
    ]), f = (0, $dhiZh.useCallback)(()=>{
        n || s(!0), o == null || o();
    }, [
        n,
        o
    ]);
    return {
        isOpen: l,
        isControlled: n,
        handleClose: d,
        handleOpen: f
    };
}
function $1f939aaca629584c$export$2312e6e6009df96({ onLoad: e } = {}) {
    let [t, o] = (0, $dhiZh.useState)(!1), r = (0, $dhiZh.useRef)(), a = (0, $dhiZh.useCallback)(()=>{
        e == null || e(), o(!0);
    }, [
        e
    ]);
    return (0, $dhiZh.useEffect)(()=>{
        r.current && r.current.complete && a();
    }, [
        a
    ]), {
        ref: r,
        loaded: t,
        onLoad: a
    };
}
function $1f939aaca629584c$export$c9058316764c140e(...e) {
    return (t)=>{
        e.forEach((o)=>{
            typeof o == "function" ? o(t) : o != null && (o.current = t);
        });
    };
}
var $1f939aaca629584c$export$125b56fdc77c3731 = ({ status: e })=>{
    switch(e){
        case "published":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorGreenBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorGreenLightest
            };
        case "changed":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorBlueBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorBlueLightest
            };
        case "deleted":
        case "archived":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorRedBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorRedLightest
            };
        case "draft":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorOrangeDark,
                backgroundColor: "#ffefd5"
            };
        case "new":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorWhite,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).blue500
            };
        default:
            return console.warn(`Unknown EntityStatus: ${e}`), {};
    }
};
 //# sourceMappingURL=out.js.map


let $1b767d384492f23e$var$_ = (t)=>t, $1b767d384492f23e$var$t, $1b767d384492f23e$var$t1, $1b767d384492f23e$var$t2, $1b767d384492f23e$var$t3, $1b767d384492f23e$var$t4, $1b767d384492f23e$var$t5;
var $1b767d384492f23e$var$N = Object.defineProperty, $1b767d384492f23e$var$T = Object.defineProperties;
var $1b767d384492f23e$var$v = Object.getOwnPropertyDescriptors;
var $1b767d384492f23e$var$m = Object.getOwnPropertySymbols;
var $1b767d384492f23e$var$c = Object.prototype.hasOwnProperty, $1b767d384492f23e$var$x = Object.prototype.propertyIsEnumerable;
var $1b767d384492f23e$var$f = (r, a, t)=>a in r ? $1b767d384492f23e$var$N(r, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[a] = t, $1b767d384492f23e$var$S = (r, a)=>{
    for(var t in a || (a = {}))$1b767d384492f23e$var$c.call(a, t) && $1b767d384492f23e$var$f(r, t, a[t]);
    if ($1b767d384492f23e$var$m) for (var t of $1b767d384492f23e$var$m(a))$1b767d384492f23e$var$x.call(a, t) && $1b767d384492f23e$var$f(r, t, a[t]);
    return r;
}, $1b767d384492f23e$var$d = (r, a)=>$1b767d384492f23e$var$T(r, $1b767d384492f23e$var$v(a));
var $1b767d384492f23e$var$g = (r, a)=>{
    var t = {};
    for(var n in r)$1b767d384492f23e$var$c.call(r, n) && a.indexOf(n) < 0 && (t[n] = r[n]);
    if (r != null && $1b767d384492f23e$var$m) for (var n of $1b767d384492f23e$var$m(r))a.indexOf(n) < 0 && $1b767d384492f23e$var$x.call(r, n) && (t[n] = r[n]);
    return t;
};
var $1b767d384492f23e$var$h = {
    large: "36px",
    medium: "20px",
    small: "14px"
}, $1b767d384492f23e$var$y = ()=>{
    let r = {
        scale1: (0, $caccab916c328344$export$d25ddfdf17c3ad3e)($1b767d384492f23e$var$t || ($1b767d384492f23e$var$t = $1b767d384492f23e$var$_`
    0% {
      transform: scale(1, 1);
    }
    6.666667% {
      transform: scale(1.5, 0.5);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1.5, 0.5);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `)),
        scale2: (0, $caccab916c328344$export$d25ddfdf17c3ad3e)($1b767d384492f23e$var$t1 || ($1b767d384492f23e$var$t1 = $1b767d384492f23e$var$_`
    0% {
      transform: scale(1, 1);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    20% {
      transform: scale(1.5, 0.5);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    46.666667% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    73.333333% {
      transform: scale(1.5, 0.5);
    }
    80% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `)),
        scale3: (0, $caccab916c328344$export$d25ddfdf17c3ad3e)($1b767d384492f23e$var$t2 || ($1b767d384492f23e$var$t2 = $1b767d384492f23e$var$_`
    0% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1.5, 0.5);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    80% {
      transform: scale(1, 1);
    }
    86.666667% {
      transform: scale(1.5, 0.5);
    }
    93.333333% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `)),
        translate1: (0, $caccab916c328344$export$d25ddfdf17c3ad3e)($1b767d384492f23e$var$t3 || ($1b767d384492f23e$var$t3 = $1b767d384492f23e$var$_`
    0% {
      transform: translate(10px, 33.528168px);
    }
    6.666667% {
      transform: translate(10px, 41.764084px);
    }
    13.333333% {
      transform: translate(10px, 33.528168px);
    }
    26.666667% {
      transform: translate(10px, -2.651608px);
    }
    33.333333% {
      transform: translate(10px, -4.471832px);
    }
    40% {
      transform: translate(10px, -2.651608px);
    }
    53.333333% {
      transform: translate(10px, 33.528168px);
    }
    60% {
      transform: translate(10px, 41.764084px);
    }
    66.666667% {
      transform: translate(10px, 33.528168px);
    }
    100% {
      transform: translate(10px, 33.528168px);
    }
  `)),
        translate2: (0, $caccab916c328344$export$d25ddfdf17c3ad3e)($1b767d384492f23e$var$t4 || ($1b767d384492f23e$var$t4 = $1b767d384492f23e$var$_`
    0% {
      transform: translate(30px, 33.528168px);
    }
    13.333333% {
      transform: translate(30px, 33.528168px);
    }
    20% {
      transform: translate(30px, 41.764084px);
    }
    26.666667% {
      transform: translate(30px, 33.528168px);
    }
    40% {
      transform: translate(30px, -2.651608px);
    }
    46.666667% {
      transform: translate(30px, -4.471832px);
    }
    53.333333% {
      transform: translate(30px, -2.651608px);
    }
    66.666667% {
      transform: translate(30px, 33.528168px);
    }
    73.333333% {
      transform: translate(30px, 41.764084px);
    }
    80% {
      transform: translate(30px, 33.528168px);
    }
    100% {
      transform: translate(30px, 33.528168px);
    }
  `)),
        translate3: (0, $caccab916c328344$export$d25ddfdf17c3ad3e)($1b767d384492f23e$var$t5 || ($1b767d384492f23e$var$t5 = $1b767d384492f23e$var$_`
    0% {
      transform: translate(50px, 33.528168px);
    }
    26.666667% {
      transform: translate(50px, 33.528168px);
    }
    33.333333% {
      transform: translate(50px, 41.764084px);
    }
    40% {
      transform: translate(50px, 33.528168px);
    }
    53.333333% {
      transform: translate(50px, -2.651608px);
    }
    60% {
      transform: translate(50px, -4.471832px);
    }
    66.666667% {
      transform: translate(50px, -2.651608px);
    }
    80% {
      transform: translate(50px, 33.528168px);
    }
    86.666667% {
      transform: translate(50px, 41.764084px);
    }
    93.333333% {
      transform: translate(50px, 33.528168px);
    }
    100% {
      transform: translate(50px, 33.528168px);
    }
  `))
    };
    return {
        root: (a)=>(0, $caccab916c328344$export$dbf350e5966cf602)({
                height: a.customSize ? `${a.customSize}px` : void 0,
                verticalAlign: "middle",
                width: a.customSize ? `${a.customSize}px` : $1b767d384492f23e$var$h[a.size]
            }),
        circle1Scale: (0, $caccab916c328344$export$dbf350e5966cf602)({
            animation: `${r.scale1} 1s linear infinite normal forwards;`
        }),
        circle2Scale: (0, $caccab916c328344$export$dbf350e5966cf602)({
            animation: `${r.scale2} 1s linear infinite normal forwards;`
        }),
        circle3Scale: (0, $caccab916c328344$export$dbf350e5966cf602)({
            animation: `${r.scale3} 1s linear infinite normal forwards;`
        }),
        circle1Translate: (0, $caccab916c328344$export$dbf350e5966cf602)({
            animation: `${r.translate1} 1s linear infinite normal forwards;`
        }),
        circle2Translate: (0, $caccab916c328344$export$dbf350e5966cf602)({
            animation: `${r.translate2} 1s linear infinite normal forwards;`
        }),
        circle3Translate: (0, $caccab916c328344$export$dbf350e5966cf602)({
            animation: `${r.translate3} 1s linear infinite normal forwards;`
        })
    };
};
var $1b767d384492f23e$var$L = "div", $1b767d384492f23e$var$I = {
    default: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).gray700,
    primary: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).blue500,
    white: (0, (/*@__PURE__*/$parcel$interopDefault($d70e60fbb1642334$exports))).colorWhite
}, $1b767d384492f23e$export$7f7cbe89f1eacd2 = (0, $dhiZh.forwardRef)((A, P)=>{
    var p = A, { className: r, customSize: a, size: t = "medium", variant: n = "default", testId: z = "cf-ui-spinner" } = p, w = $1b767d384492f23e$var$g(p, [
        "className",
        "customSize",
        "size",
        "variant",
        "testId"
    ]);
    let e = $1b767d384492f23e$var$y();
    return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $1f939aaca629584c$export$e71c4d32a2263218), $1b767d384492f23e$var$d($1b767d384492f23e$var$S({
        as: $1b767d384492f23e$var$L,
        display: "inline-block"
    }, w), {
        className: (0, $caccab916c328344$export$a274e22fb40f762e)(e.root({
            size: t,
            customSize: a
        }), r),
        ref: P,
        testId: z
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("svg", {
        className: (0, $caccab916c328344$export$dbf350e5966cf602)({
            display: "block",
            fill: $1b767d384492f23e$var$I[n]
        }),
        viewBox: "0 0 60 51",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("title", null, "Loading\u2026"), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("g", {
        className: e.circle1Translate,
        transform: "translate(10,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("g", {
        className: e.circle1Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("g", {
        className: e.circle2Translate,
        transform: "translate(30,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("g", {
        className: e.circle2Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("g", {
        className: e.circle3Translate,
        transform: "translate(50,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("g", {
        className: e.circle3Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    })))));
});
$1b767d384492f23e$export$7f7cbe89f1eacd2.displayName = "Spinner";
 //# sourceMappingURL=out.js.map


"use strict";
function $932eaecd8eb37723$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $26305657c8dadcb2$exports = {};
// shim for using process in browser
var $26305657c8dadcb2$var$process = $26305657c8dadcb2$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $26305657c8dadcb2$var$cachedSetTimeout;
var $26305657c8dadcb2$var$cachedClearTimeout;
function $26305657c8dadcb2$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $26305657c8dadcb2$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $26305657c8dadcb2$var$cachedSetTimeout = setTimeout;
        else $26305657c8dadcb2$var$cachedSetTimeout = $26305657c8dadcb2$var$defaultSetTimout;
    } catch (e) {
        $26305657c8dadcb2$var$cachedSetTimeout = $26305657c8dadcb2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $26305657c8dadcb2$var$cachedClearTimeout = clearTimeout;
        else $26305657c8dadcb2$var$cachedClearTimeout = $26305657c8dadcb2$var$defaultClearTimeout;
    } catch (e) {
        $26305657c8dadcb2$var$cachedClearTimeout = $26305657c8dadcb2$var$defaultClearTimeout;
    }
})();
function $26305657c8dadcb2$var$runTimeout(fun) {
    if ($26305657c8dadcb2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($26305657c8dadcb2$var$cachedSetTimeout === $26305657c8dadcb2$var$defaultSetTimout || !$26305657c8dadcb2$var$cachedSetTimeout) && setTimeout) {
        $26305657c8dadcb2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $26305657c8dadcb2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $26305657c8dadcb2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $26305657c8dadcb2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $26305657c8dadcb2$var$runClearTimeout(marker) {
    if ($26305657c8dadcb2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($26305657c8dadcb2$var$cachedClearTimeout === $26305657c8dadcb2$var$defaultClearTimeout || !$26305657c8dadcb2$var$cachedClearTimeout) && clearTimeout) {
        $26305657c8dadcb2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $26305657c8dadcb2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $26305657c8dadcb2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $26305657c8dadcb2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $26305657c8dadcb2$var$queue = [];
var $26305657c8dadcb2$var$draining = false;
var $26305657c8dadcb2$var$currentQueue;
var $26305657c8dadcb2$var$queueIndex = -1;
function $26305657c8dadcb2$var$cleanUpNextTick() {
    if (!$26305657c8dadcb2$var$draining || !$26305657c8dadcb2$var$currentQueue) return;
    $26305657c8dadcb2$var$draining = false;
    if ($26305657c8dadcb2$var$currentQueue.length) $26305657c8dadcb2$var$queue = $26305657c8dadcb2$var$currentQueue.concat($26305657c8dadcb2$var$queue);
    else $26305657c8dadcb2$var$queueIndex = -1;
    if ($26305657c8dadcb2$var$queue.length) $26305657c8dadcb2$var$drainQueue();
}
function $26305657c8dadcb2$var$drainQueue() {
    if ($26305657c8dadcb2$var$draining) return;
    var timeout = $26305657c8dadcb2$var$runTimeout($26305657c8dadcb2$var$cleanUpNextTick);
    $26305657c8dadcb2$var$draining = true;
    var len = $26305657c8dadcb2$var$queue.length;
    while(len){
        $26305657c8dadcb2$var$currentQueue = $26305657c8dadcb2$var$queue;
        $26305657c8dadcb2$var$queue = [];
        while(++$26305657c8dadcb2$var$queueIndex < len)if ($26305657c8dadcb2$var$currentQueue) $26305657c8dadcb2$var$currentQueue[$26305657c8dadcb2$var$queueIndex].run();
        $26305657c8dadcb2$var$queueIndex = -1;
        len = $26305657c8dadcb2$var$queue.length;
    }
    $26305657c8dadcb2$var$currentQueue = null;
    $26305657c8dadcb2$var$draining = false;
    $26305657c8dadcb2$var$runClearTimeout(timeout);
}
$26305657c8dadcb2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $26305657c8dadcb2$var$queue.push(new $26305657c8dadcb2$var$Item(fun, args));
    if ($26305657c8dadcb2$var$queue.length === 1 && !$26305657c8dadcb2$var$draining) $26305657c8dadcb2$var$runTimeout($26305657c8dadcb2$var$drainQueue);
};
// v8 likes predictible objects
function $26305657c8dadcb2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$26305657c8dadcb2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$26305657c8dadcb2$var$process.title = "browser";
$26305657c8dadcb2$var$process.browser = true;
$26305657c8dadcb2$var$process.env = {};
$26305657c8dadcb2$var$process.argv = [];
$26305657c8dadcb2$var$process.version = ""; // empty string to avoid regexp issues
$26305657c8dadcb2$var$process.versions = {};
function $26305657c8dadcb2$var$noop() {}
$26305657c8dadcb2$var$process.on = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.addListener = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.once = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.off = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.removeListener = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.removeAllListeners = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.emit = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.prependListener = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.prependOnceListener = $26305657c8dadcb2$var$noop;
$26305657c8dadcb2$var$process.listeners = function(name) {
    return [];
};
$26305657c8dadcb2$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$26305657c8dadcb2$var$process.cwd = function() {
    return "/";
};
$26305657c8dadcb2$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$26305657c8dadcb2$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $e615e35db2201e65$var$toString } = Object.prototype;
const { getPrototypeOf: $e615e35db2201e65$var$getPrototypeOf } = Object;
const $e615e35db2201e65$var$kindOf = ((cache)=>(thing)=>{
        const str = $e615e35db2201e65$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $e615e35db2201e65$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$e615e35db2201e65$var$kindOf(thing) === type;
};
const $e615e35db2201e65$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $e615e35db2201e65$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $e615e35db2201e65$var$isUndefined = $e615e35db2201e65$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $e615e35db2201e65$var$isBuffer(val) {
    return val !== null && !$e615e35db2201e65$var$isUndefined(val) && val.constructor !== null && !$e615e35db2201e65$var$isUndefined(val.constructor) && $e615e35db2201e65$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $e615e35db2201e65$var$isArrayBuffer = $e615e35db2201e65$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $e615e35db2201e65$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $e615e35db2201e65$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $e615e35db2201e65$var$isString = $e615e35db2201e65$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $e615e35db2201e65$var$isFunction = $e615e35db2201e65$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $e615e35db2201e65$var$isNumber = $e615e35db2201e65$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $e615e35db2201e65$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $e615e35db2201e65$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $e615e35db2201e65$var$isPlainObject = (val)=>{
    if ($e615e35db2201e65$var$kindOf(val) !== "object") return false;
    const prototype = $e615e35db2201e65$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $e615e35db2201e65$var$isDate = $e615e35db2201e65$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $e615e35db2201e65$var$isFile = $e615e35db2201e65$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $e615e35db2201e65$var$isBlob = $e615e35db2201e65$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $e615e35db2201e65$var$isFileList = $e615e35db2201e65$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $e615e35db2201e65$var$isStream = (val)=>$e615e35db2201e65$var$isObject(val) && $e615e35db2201e65$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $e615e35db2201e65$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $e615e35db2201e65$var$isFunction(thing.append) && ((kind = $e615e35db2201e65$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $e615e35db2201e65$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $e615e35db2201e65$var$isURLSearchParams = $e615e35db2201e65$var$kindOfTest("URLSearchParams");
const [$e615e35db2201e65$var$isReadableStream, $e615e35db2201e65$var$isRequest, $e615e35db2201e65$var$isResponse, $e615e35db2201e65$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($e615e35db2201e65$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $e615e35db2201e65$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $e615e35db2201e65$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($e615e35db2201e65$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $e615e35db2201e65$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $e615e35db2201e65$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $e615e35db2201e65$var$isContextDefined = (context)=>!$e615e35db2201e65$var$isUndefined(context) && context !== $e615e35db2201e65$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $e615e35db2201e65$var$merge() {
    const { caseless: caseless } = $e615e35db2201e65$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $e615e35db2201e65$var$findKey(result, key) || key;
        if ($e615e35db2201e65$var$isPlainObject(result[targetKey]) && $e615e35db2201e65$var$isPlainObject(val)) result[targetKey] = $e615e35db2201e65$var$merge(result[targetKey], val);
        else if ($e615e35db2201e65$var$isPlainObject(val)) result[targetKey] = $e615e35db2201e65$var$merge({}, val);
        else if ($e615e35db2201e65$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $e615e35db2201e65$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $e615e35db2201e65$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $e615e35db2201e65$var$forEach(b, (val, key)=>{
        if (thisArg && $e615e35db2201e65$var$isFunction(val)) a[key] = (0, $932eaecd8eb37723$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $e615e35db2201e65$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $e615e35db2201e65$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $e615e35db2201e65$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $e615e35db2201e65$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $e615e35db2201e65$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $e615e35db2201e65$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($e615e35db2201e65$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$e615e35db2201e65$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $e615e35db2201e65$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $e615e35db2201e65$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $e615e35db2201e65$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $e615e35db2201e65$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $e615e35db2201e65$var$isHTMLForm = $e615e35db2201e65$var$kindOfTest("HTMLFormElement");
const $e615e35db2201e65$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $e615e35db2201e65$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $e615e35db2201e65$var$isRegExp = $e615e35db2201e65$var$kindOfTest("RegExp");
const $e615e35db2201e65$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $e615e35db2201e65$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $e615e35db2201e65$var$freezeMethods = (obj)=>{
    $e615e35db2201e65$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($e615e35db2201e65$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$e615e35db2201e65$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $e615e35db2201e65$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $e615e35db2201e65$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $e615e35db2201e65$var$noop = ()=>{};
const $e615e35db2201e65$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $e615e35db2201e65$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $e615e35db2201e65$var$DIGIT = "0123456789";
const $e615e35db2201e65$var$ALPHABET = {
    DIGIT: $e615e35db2201e65$var$DIGIT,
    ALPHA: $e615e35db2201e65$var$ALPHA,
    ALPHA_DIGIT: $e615e35db2201e65$var$ALPHA + $e615e35db2201e65$var$ALPHA.toUpperCase() + $e615e35db2201e65$var$DIGIT
};
const $e615e35db2201e65$var$generateString = (size = 16, alphabet = $e615e35db2201e65$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $e615e35db2201e65$var$isSpecCompliantForm(thing) {
    return !!(thing && $e615e35db2201e65$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $e615e35db2201e65$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($e615e35db2201e65$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $e615e35db2201e65$var$isArray(source) ? [] : {};
                $e615e35db2201e65$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$e615e35db2201e65$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $e615e35db2201e65$var$isAsyncFn = $e615e35db2201e65$var$kindOfTest("AsyncFunction");
const $e615e35db2201e65$var$isThenable = (thing)=>thing && ($e615e35db2201e65$var$isObject(thing) || $e615e35db2201e65$var$isFunction(thing)) && $e615e35db2201e65$var$isFunction(thing.then) && $e615e35db2201e65$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $e615e35db2201e65$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $e615e35db2201e65$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $e615e35db2201e65$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $e615e35db2201e65$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $e615e35db2201e65$var$isFunction($e615e35db2201e65$var$_global.postMessage));
const $e615e35db2201e65$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($e615e35db2201e65$var$_global) : typeof $26305657c8dadcb2$exports !== "undefined" && $26305657c8dadcb2$exports.nextTick || $e615e35db2201e65$var$_setImmediate;
var // *********************
$e615e35db2201e65$export$2e2bcd8739ae039 = {
    isArray: $e615e35db2201e65$var$isArray,
    isArrayBuffer: $e615e35db2201e65$var$isArrayBuffer,
    isBuffer: $e615e35db2201e65$var$isBuffer,
    isFormData: $e615e35db2201e65$var$isFormData,
    isArrayBufferView: $e615e35db2201e65$var$isArrayBufferView,
    isString: $e615e35db2201e65$var$isString,
    isNumber: $e615e35db2201e65$var$isNumber,
    isBoolean: $e615e35db2201e65$var$isBoolean,
    isObject: $e615e35db2201e65$var$isObject,
    isPlainObject: $e615e35db2201e65$var$isPlainObject,
    isReadableStream: $e615e35db2201e65$var$isReadableStream,
    isRequest: $e615e35db2201e65$var$isRequest,
    isResponse: $e615e35db2201e65$var$isResponse,
    isHeaders: $e615e35db2201e65$var$isHeaders,
    isUndefined: $e615e35db2201e65$var$isUndefined,
    isDate: $e615e35db2201e65$var$isDate,
    isFile: $e615e35db2201e65$var$isFile,
    isBlob: $e615e35db2201e65$var$isBlob,
    isRegExp: $e615e35db2201e65$var$isRegExp,
    isFunction: $e615e35db2201e65$var$isFunction,
    isStream: $e615e35db2201e65$var$isStream,
    isURLSearchParams: $e615e35db2201e65$var$isURLSearchParams,
    isTypedArray: $e615e35db2201e65$var$isTypedArray,
    isFileList: $e615e35db2201e65$var$isFileList,
    forEach: $e615e35db2201e65$var$forEach,
    merge: $e615e35db2201e65$var$merge,
    extend: $e615e35db2201e65$var$extend,
    trim: $e615e35db2201e65$var$trim,
    stripBOM: $e615e35db2201e65$var$stripBOM,
    inherits: $e615e35db2201e65$var$inherits,
    toFlatObject: $e615e35db2201e65$var$toFlatObject,
    kindOf: $e615e35db2201e65$var$kindOf,
    kindOfTest: $e615e35db2201e65$var$kindOfTest,
    endsWith: $e615e35db2201e65$var$endsWith,
    toArray: $e615e35db2201e65$var$toArray,
    forEachEntry: $e615e35db2201e65$var$forEachEntry,
    matchAll: $e615e35db2201e65$var$matchAll,
    isHTMLForm: $e615e35db2201e65$var$isHTMLForm,
    hasOwnProperty: $e615e35db2201e65$var$hasOwnProperty,
    hasOwnProp: $e615e35db2201e65$var$hasOwnProperty,
    reduceDescriptors: $e615e35db2201e65$var$reduceDescriptors,
    freezeMethods: $e615e35db2201e65$var$freezeMethods,
    toObjectSet: $e615e35db2201e65$var$toObjectSet,
    toCamelCase: $e615e35db2201e65$var$toCamelCase,
    noop: $e615e35db2201e65$var$noop,
    toFiniteNumber: $e615e35db2201e65$var$toFiniteNumber,
    findKey: $e615e35db2201e65$var$findKey,
    global: $e615e35db2201e65$var$_global,
    isContextDefined: $e615e35db2201e65$var$isContextDefined,
    ALPHABET: $e615e35db2201e65$var$ALPHABET,
    generateString: $e615e35db2201e65$var$generateString,
    isSpecCompliantForm: $e615e35db2201e65$var$isSpecCompliantForm,
    toJSONObject: $e615e35db2201e65$var$toJSONObject,
    isAsyncFn: $e615e35db2201e65$var$isAsyncFn,
    isThenable: $e615e35db2201e65$var$isThenable,
    setImmediate: $e615e35db2201e65$var$_setImmediate,
    asap: $e615e35db2201e65$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $fe49f4f3b6d88c51$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $e615e35db2201e65$export$2e2bcd8739ae039).inherits($fe49f4f3b6d88c51$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $e615e35db2201e65$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $fe49f4f3b6d88c51$var$prototype = $fe49f4f3b6d88c51$var$AxiosError.prototype;
const $fe49f4f3b6d88c51$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $fe49f4f3b6d88c51$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($fe49f4f3b6d88c51$var$AxiosError, $fe49f4f3b6d88c51$var$descriptors);
Object.defineProperty($fe49f4f3b6d88c51$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$fe49f4f3b6d88c51$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($fe49f4f3b6d88c51$var$prototype);
    (0, $e615e35db2201e65$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $fe49f4f3b6d88c51$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $fe49f4f3b6d88c51$export$2e2bcd8739ae039 = $fe49f4f3b6d88c51$var$AxiosError;


// eslint-disable-next-line strict
var $61b2de7d28775a46$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8feaa3793ae94581$export$a143d493d941bafc;
var $8feaa3793ae94581$export$e4cf37d7f6fb9e0a;
var $8feaa3793ae94581$export$f99ded8fe4b79145;
var $8feaa3793ae94581$export$599f31c3813fae4d;
"use strict";
var $7a7f2798d8e093db$export$a48f0734ac7c2329;
var $7a7f2798d8e093db$export$d622b2ad8d90c771;
var $7a7f2798d8e093db$export$6100ba28696e12de;
"use strict";
$7a7f2798d8e093db$export$a48f0734ac7c2329 = $7a7f2798d8e093db$var$byteLength;
$7a7f2798d8e093db$export$d622b2ad8d90c771 = $7a7f2798d8e093db$var$toByteArray;
$7a7f2798d8e093db$export$6100ba28696e12de = $7a7f2798d8e093db$var$fromByteArray;
var $7a7f2798d8e093db$var$lookup = [];
var $7a7f2798d8e093db$var$revLookup = [];
var $7a7f2798d8e093db$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $7a7f2798d8e093db$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $7a7f2798d8e093db$var$i = 0, $7a7f2798d8e093db$var$len = $7a7f2798d8e093db$var$code.length; $7a7f2798d8e093db$var$i < $7a7f2798d8e093db$var$len; ++$7a7f2798d8e093db$var$i){
    $7a7f2798d8e093db$var$lookup[$7a7f2798d8e093db$var$i] = $7a7f2798d8e093db$var$code[$7a7f2798d8e093db$var$i];
    $7a7f2798d8e093db$var$revLookup[$7a7f2798d8e093db$var$code.charCodeAt($7a7f2798d8e093db$var$i)] = $7a7f2798d8e093db$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7a7f2798d8e093db$var$revLookup["-".charCodeAt(0)] = 62;
$7a7f2798d8e093db$var$revLookup["_".charCodeAt(0)] = 63;
function $7a7f2798d8e093db$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7a7f2798d8e093db$var$byteLength(b64) {
    var lens = $7a7f2798d8e093db$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7a7f2798d8e093db$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7a7f2798d8e093db$var$toByteArray(b64) {
    var tmp;
    var lens = $7a7f2798d8e093db$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7a7f2798d8e093db$var$Arr($7a7f2798d8e093db$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i)] << 18 | $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i)] << 2 | $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i)] << 10 | $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7a7f2798d8e093db$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7a7f2798d8e093db$var$tripletToBase64(num) {
    return $7a7f2798d8e093db$var$lookup[num >> 18 & 0x3F] + $7a7f2798d8e093db$var$lookup[num >> 12 & 0x3F] + $7a7f2798d8e093db$var$lookup[num >> 6 & 0x3F] + $7a7f2798d8e093db$var$lookup[num & 0x3F];
}
function $7a7f2798d8e093db$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7a7f2798d8e093db$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $7a7f2798d8e093db$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7a7f2798d8e093db$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7a7f2798d8e093db$var$lookup[tmp >> 2] + $7a7f2798d8e093db$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7a7f2798d8e093db$var$lookup[tmp >> 10] + $7a7f2798d8e093db$var$lookup[tmp >> 4 & 0x3F] + $7a7f2798d8e093db$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $2de49dbd53ae4d29$export$aafa59e2e03f2942;
var $2de49dbd53ae4d29$export$68d8715fc104d294;
$2de49dbd53ae4d29$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$2de49dbd53ae4d29$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $8feaa3793ae94581$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8feaa3793ae94581$export$a143d493d941bafc = $8feaa3793ae94581$var$Buffer;
$8feaa3793ae94581$export$e4cf37d7f6fb9e0a = $8feaa3793ae94581$var$SlowBuffer;
$8feaa3793ae94581$export$f99ded8fe4b79145 = 50;
var $8feaa3793ae94581$var$K_MAX_LENGTH = 0x7fffffff;
$8feaa3793ae94581$export$599f31c3813fae4d = $8feaa3793ae94581$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8feaa3793ae94581$var$Buffer.TYPED_ARRAY_SUPPORT = $8feaa3793ae94581$var$typedArraySupport();
if (!$8feaa3793ae94581$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8feaa3793ae94581$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8feaa3793ae94581$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8feaa3793ae94581$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8feaa3793ae94581$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8feaa3793ae94581$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8feaa3793ae94581$var$createBuffer(length) {
    if (length > $8feaa3793ae94581$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8feaa3793ae94581$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8feaa3793ae94581$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8feaa3793ae94581$var$allocUnsafe(arg);
    }
    return $8feaa3793ae94581$var$from(arg, encodingOrOffset, length);
}
$8feaa3793ae94581$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8feaa3793ae94581$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8feaa3793ae94581$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8feaa3793ae94581$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8feaa3793ae94581$var$isInstance(value, ArrayBuffer) || value && $8feaa3793ae94581$var$isInstance(value.buffer, ArrayBuffer)) return $8feaa3793ae94581$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8feaa3793ae94581$var$isInstance(value, SharedArrayBuffer) || value && $8feaa3793ae94581$var$isInstance(value.buffer, SharedArrayBuffer))) return $8feaa3793ae94581$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8feaa3793ae94581$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $8feaa3793ae94581$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8feaa3793ae94581$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8feaa3793ae94581$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8feaa3793ae94581$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8feaa3793ae94581$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8feaa3793ae94581$var$Buffer, Uint8Array);
function $8feaa3793ae94581$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8feaa3793ae94581$var$alloc(size, fill, encoding) {
    $8feaa3793ae94581$var$assertSize(size);
    if (size <= 0) return $8feaa3793ae94581$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8feaa3793ae94581$var$createBuffer(size).fill(fill, encoding) : $8feaa3793ae94581$var$createBuffer(size).fill(fill);
    return $8feaa3793ae94581$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8feaa3793ae94581$var$Buffer.alloc = function(size, fill, encoding) {
    return $8feaa3793ae94581$var$alloc(size, fill, encoding);
};
function $8feaa3793ae94581$var$allocUnsafe(size) {
    $8feaa3793ae94581$var$assertSize(size);
    return $8feaa3793ae94581$var$createBuffer(size < 0 ? 0 : $8feaa3793ae94581$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8feaa3793ae94581$var$Buffer.allocUnsafe = function(size) {
    return $8feaa3793ae94581$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8feaa3793ae94581$var$Buffer.allocUnsafeSlow = function(size) {
    return $8feaa3793ae94581$var$allocUnsafe(size);
};
function $8feaa3793ae94581$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8feaa3793ae94581$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $8feaa3793ae94581$var$byteLength(string, encoding) | 0;
    var buf = $8feaa3793ae94581$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8feaa3793ae94581$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $8feaa3793ae94581$var$checked(array.length) | 0;
    var buf = $8feaa3793ae94581$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8feaa3793ae94581$var$fromArrayView(arrayView) {
    if ($8feaa3793ae94581$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $8feaa3793ae94581$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8feaa3793ae94581$var$fromArrayLike(arrayView);
}
function $8feaa3793ae94581$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8feaa3793ae94581$var$Buffer.prototype);
    return buf;
}
function $8feaa3793ae94581$var$fromObject(obj) {
    if ($8feaa3793ae94581$var$Buffer.isBuffer(obj)) {
        var len = $8feaa3793ae94581$var$checked(obj.length) | 0;
        var buf = $8feaa3793ae94581$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8feaa3793ae94581$var$numberIsNaN(obj.length)) return $8feaa3793ae94581$var$createBuffer(0);
        return $8feaa3793ae94581$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8feaa3793ae94581$var$fromArrayLike(obj.data);
}
function $8feaa3793ae94581$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8feaa3793ae94581$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8feaa3793ae94581$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8feaa3793ae94581$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8feaa3793ae94581$var$Buffer.alloc(+length);
}
$8feaa3793ae94581$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8feaa3793ae94581$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8feaa3793ae94581$var$Buffer.compare = function compare(a, b) {
    if ($8feaa3793ae94581$var$isInstance(a, Uint8Array)) a = $8feaa3793ae94581$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8feaa3793ae94581$var$isInstance(b, Uint8Array)) b = $8feaa3793ae94581$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8feaa3793ae94581$var$Buffer.isBuffer(a) || !$8feaa3793ae94581$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8feaa3793ae94581$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8feaa3793ae94581$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8feaa3793ae94581$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $8feaa3793ae94581$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($8feaa3793ae94581$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $8feaa3793ae94581$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8feaa3793ae94581$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8feaa3793ae94581$var$byteLength(string, encoding) {
    if ($8feaa3793ae94581$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8feaa3793ae94581$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8feaa3793ae94581$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8feaa3793ae94581$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8feaa3793ae94581$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8feaa3793ae94581$var$Buffer.byteLength = $8feaa3793ae94581$var$byteLength;
function $8feaa3793ae94581$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8feaa3793ae94581$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8feaa3793ae94581$var$utf8Slice(this, start, end);
        case "ascii":
            return $8feaa3793ae94581$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8feaa3793ae94581$var$latin1Slice(this, start, end);
        case "base64":
            return $8feaa3793ae94581$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8feaa3793ae94581$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8feaa3793ae94581$var$Buffer.prototype._isBuffer = true;
function $8feaa3793ae94581$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8feaa3793ae94581$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$8feaa3793ae94581$var$swap(this, i, i + 1);
    return this;
};
$8feaa3793ae94581$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $8feaa3793ae94581$var$swap(this, i, i + 3);
        $8feaa3793ae94581$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8feaa3793ae94581$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $8feaa3793ae94581$var$swap(this, i, i + 7);
        $8feaa3793ae94581$var$swap(this, i + 1, i + 6);
        $8feaa3793ae94581$var$swap(this, i + 2, i + 5);
        $8feaa3793ae94581$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8feaa3793ae94581$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8feaa3793ae94581$var$utf8Slice(this, 0, length);
    return $8feaa3793ae94581$var$slowToString.apply(this, arguments);
};
$8feaa3793ae94581$var$Buffer.prototype.toLocaleString = $8feaa3793ae94581$var$Buffer.prototype.toString;
$8feaa3793ae94581$var$Buffer.prototype.equals = function equals(b) {
    if (!$8feaa3793ae94581$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8feaa3793ae94581$var$Buffer.compare(this, b) === 0;
};
$8feaa3793ae94581$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $8feaa3793ae94581$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8feaa3793ae94581$var$customInspectSymbol) $8feaa3793ae94581$var$Buffer.prototype[$8feaa3793ae94581$var$customInspectSymbol] = $8feaa3793ae94581$var$Buffer.prototype.inspect;
$8feaa3793ae94581$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8feaa3793ae94581$var$isInstance(target, Uint8Array)) target = $8feaa3793ae94581$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8feaa3793ae94581$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8feaa3793ae94581$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8feaa3793ae94581$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8feaa3793ae94581$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8feaa3793ae94581$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8feaa3793ae94581$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8feaa3793ae94581$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8feaa3793ae94581$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8feaa3793ae94581$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8feaa3793ae94581$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8feaa3793ae94581$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8feaa3793ae94581$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8feaa3793ae94581$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8feaa3793ae94581$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8feaa3793ae94581$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8feaa3793ae94581$var$utf8Write(buf, string, offset, length) {
    return $8feaa3793ae94581$var$blitBuffer($8feaa3793ae94581$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8feaa3793ae94581$var$asciiWrite(buf, string, offset, length) {
    return $8feaa3793ae94581$var$blitBuffer($8feaa3793ae94581$var$asciiToBytes(string), buf, offset, length);
}
function $8feaa3793ae94581$var$base64Write(buf, string, offset, length) {
    return $8feaa3793ae94581$var$blitBuffer($8feaa3793ae94581$var$base64ToBytes(string), buf, offset, length);
}
function $8feaa3793ae94581$var$ucs2Write(buf, string, offset, length) {
    return $8feaa3793ae94581$var$blitBuffer($8feaa3793ae94581$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8feaa3793ae94581$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8feaa3793ae94581$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8feaa3793ae94581$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8feaa3793ae94581$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8feaa3793ae94581$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8feaa3793ae94581$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8feaa3793ae94581$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8feaa3793ae94581$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7a7f2798d8e093db$export$6100ba28696e12de(buf);
    else return $7a7f2798d8e093db$export$6100ba28696e12de(buf.slice(start, end));
}
function $8feaa3793ae94581$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8feaa3793ae94581$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $8feaa3793ae94581$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8feaa3793ae94581$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $8feaa3793ae94581$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8feaa3793ae94581$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8feaa3793ae94581$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8feaa3793ae94581$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8feaa3793ae94581$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $8feaa3793ae94581$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8feaa3793ae94581$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8feaa3793ae94581$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8feaa3793ae94581$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8feaa3793ae94581$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8feaa3793ae94581$var$Buffer.prototype.readUintLE = $8feaa3793ae94581$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8feaa3793ae94581$var$Buffer.prototype.readUintBE = $8feaa3793ae94581$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8feaa3793ae94581$var$Buffer.prototype.readUint8 = $8feaa3793ae94581$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8feaa3793ae94581$var$Buffer.prototype.readUint16LE = $8feaa3793ae94581$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8feaa3793ae94581$var$Buffer.prototype.readUint16BE = $8feaa3793ae94581$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8feaa3793ae94581$var$Buffer.prototype.readUint32LE = $8feaa3793ae94581$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8feaa3793ae94581$var$Buffer.prototype.readUint32BE = $8feaa3793ae94581$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8feaa3793ae94581$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8feaa3793ae94581$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8feaa3793ae94581$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8feaa3793ae94581$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8feaa3793ae94581$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8feaa3793ae94581$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8feaa3793ae94581$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8feaa3793ae94581$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 4, this.length);
    return $2de49dbd53ae4d29$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8feaa3793ae94581$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 4, this.length);
    return $2de49dbd53ae4d29$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8feaa3793ae94581$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 8, this.length);
    return $2de49dbd53ae4d29$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8feaa3793ae94581$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkOffset(offset, 8, this.length);
    return $2de49dbd53ae4d29$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8feaa3793ae94581$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8feaa3793ae94581$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8feaa3793ae94581$var$Buffer.prototype.writeUintLE = $8feaa3793ae94581$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8feaa3793ae94581$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8feaa3793ae94581$var$Buffer.prototype.writeUintBE = $8feaa3793ae94581$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8feaa3793ae94581$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8feaa3793ae94581$var$Buffer.prototype.writeUint8 = $8feaa3793ae94581$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8feaa3793ae94581$var$Buffer.prototype.writeUint16LE = $8feaa3793ae94581$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8feaa3793ae94581$var$Buffer.prototype.writeUint16BE = $8feaa3793ae94581$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8feaa3793ae94581$var$Buffer.prototype.writeUint32LE = $8feaa3793ae94581$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8feaa3793ae94581$var$Buffer.prototype.writeUint32BE = $8feaa3793ae94581$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8feaa3793ae94581$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8feaa3793ae94581$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8feaa3793ae94581$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8feaa3793ae94581$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8feaa3793ae94581$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8feaa3793ae94581$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8feaa3793ae94581$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8feaa3793ae94581$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8feaa3793ae94581$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8feaa3793ae94581$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8feaa3793ae94581$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $2de49dbd53ae4d29$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8feaa3793ae94581$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8feaa3793ae94581$var$writeFloat(this, value, offset, true, noAssert);
};
$8feaa3793ae94581$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8feaa3793ae94581$var$writeFloat(this, value, offset, false, noAssert);
};
function $8feaa3793ae94581$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8feaa3793ae94581$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $2de49dbd53ae4d29$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8feaa3793ae94581$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8feaa3793ae94581$var$writeDouble(this, value, offset, true, noAssert);
};
$8feaa3793ae94581$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8feaa3793ae94581$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8feaa3793ae94581$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8feaa3793ae94581$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8feaa3793ae94581$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8feaa3793ae94581$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $8feaa3793ae94581$var$Buffer.isBuffer(val) ? val : $8feaa3793ae94581$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $8feaa3793ae94581$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8feaa3793ae94581$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8feaa3793ae94581$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8feaa3793ae94581$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8feaa3793ae94581$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8feaa3793ae94581$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8feaa3793ae94581$var$base64ToBytes(str) {
    return $7a7f2798d8e093db$export$d622b2ad8d90c771($8feaa3793ae94581$var$base64clean(str));
}
function $8feaa3793ae94581$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8feaa3793ae94581$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8feaa3793ae94581$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $8feaa3793ae94581$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $20f3c4d449d2b89f$require$Buffer = $8feaa3793ae94581$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $20f3c4d449d2b89f$var$isVisitable(thing) {
    return (0, $e615e35db2201e65$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $20f3c4d449d2b89f$var$removeBrackets(key) {
    return (0, $e615e35db2201e65$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $20f3c4d449d2b89f$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $20f3c4d449d2b89f$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $20f3c4d449d2b89f$var$isFlatArray(arr) {
    return (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(arr) && !arr.some($20f3c4d449d2b89f$var$isVisitable);
}
const $20f3c4d449d2b89f$var$predicates = (0, $e615e35db2201e65$export$2e2bcd8739ae039).toFlatObject((0, $e615e35db2201e65$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $20f3c4d449d2b89f$var$toFormData(obj, formData, options) {
    if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $61b2de7d28775a46$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $e615e35db2201e65$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $20f3c4d449d2b89f$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(value) && $20f3c4d449d2b89f$var$isFlatArray(value) || ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isFileList(value) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $e615e35db2201e65$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $20f3c4d449d2b89f$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $20f3c4d449d2b89f$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($20f3c4d449d2b89f$var$isVisitable(value)) return true;
        formData.append($20f3c4d449d2b89f$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($20f3c4d449d2b89f$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $20f3c4d449d2b89f$var$isVisitable
    });
    function build(value, path) {
        if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $20f3c4d449d2b89f$export$2e2bcd8739ae039 = $20f3c4d449d2b89f$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $b507230f3fa01f1e$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $b507230f3fa01f1e$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $20f3c4d449d2b89f$export$2e2bcd8739ae039)(params, this, options);
}
const $b507230f3fa01f1e$var$prototype = $b507230f3fa01f1e$var$AxiosURLSearchParams.prototype;
$b507230f3fa01f1e$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$b507230f3fa01f1e$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $b507230f3fa01f1e$var$encode);
    } : $b507230f3fa01f1e$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $b507230f3fa01f1e$export$2e2bcd8739ae039 = $b507230f3fa01f1e$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $cddfb001737e7567$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $cddfb001737e7567$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $cddfb001737e7567$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $e615e35db2201e65$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $b507230f3fa01f1e$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $e50e89fc01be7fc7$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $e50e89fc01be7fc7$export$2e2bcd8739ae039 = $e50e89fc01be7fc7$var$InterceptorManager;





"use strict";
var $402eae7cfab1bae3$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};







"use strict";
var $8bb18a6bca92b491$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $b507230f3fa01f1e$export$2e2bcd8739ae039);


"use strict";
var $a85bfa83a96be5e9$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $66597be1ab847621$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $3a5d9cfcab61a238$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $8bb18a6bca92b491$export$2e2bcd8739ae039,
        FormData: $a85bfa83a96be5e9$export$2e2bcd8739ae039,
        Blob: $66597be1ab847621$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $a49eea7114999da8$exports = {};

$parcel$export($a49eea7114999da8$exports, "hasBrowserEnv", () => $a49eea7114999da8$export$c4996c4b7b93b0bf);
$parcel$export($a49eea7114999da8$exports, "navigator", () => $a49eea7114999da8$export$ec7c8efa7f5790ae);
$parcel$export($a49eea7114999da8$exports, "hasStandardBrowserEnv", () => $a49eea7114999da8$export$c0bcc9250309d66);
$parcel$export($a49eea7114999da8$exports, "hasStandardBrowserWebWorkerEnv", () => $a49eea7114999da8$export$c81692cf5af97dac);
$parcel$export($a49eea7114999da8$exports, "origin", () => $a49eea7114999da8$export$f710a83a91838a36);
const $a49eea7114999da8$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $a49eea7114999da8$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $a49eea7114999da8$export$c0bcc9250309d66 = $a49eea7114999da8$export$c4996c4b7b93b0bf && (!$a49eea7114999da8$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($a49eea7114999da8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $a49eea7114999da8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $a49eea7114999da8$export$f710a83a91838a36 = $a49eea7114999da8$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $2160b4ca9caa1a7c$export$2e2bcd8739ae039 = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, $a49eea7114999da8$exports, (0, $3a5d9cfcab61a238$export$2e2bcd8739ae039));


"use strict";
function $034ff16ef7efcf80$export$2e2bcd8739ae039(data, options) {
    return (0, $20f3c4d449d2b89f$export$2e2bcd8739ae039)(data, new (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).isNode && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $7897485f2508a65c$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $e615e35db2201e65$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $7897485f2508a65c$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $7897485f2508a65c$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $e615e35db2201e65$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $7897485f2508a65c$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isFormData(formData) && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($7897485f2508a65c$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $7897485f2508a65c$export$2e2bcd8739ae039 = $7897485f2508a65c$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f4f35daad55027f1$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $e615e35db2201e65$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f4f35daad55027f1$var$defaults = {
    transitional: (0, $402eae7cfab1bae3$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $e615e35db2201e65$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $e615e35db2201e65$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $7897485f2508a65c$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isBuffer(data) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isStream(data) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isFile(data) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isBlob(data) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $034ff16ef7efcf80$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $e615e35db2201e65$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $20f3c4d449d2b89f$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f4f35daad55027f1$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f4f35daad55027f1$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isResponse(data) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).from(e, (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f4f35daad55027f1$var$defaults.headers[method] = {};
});
var $f4f35daad55027f1$export$2e2bcd8739ae039 = $f4f35daad55027f1$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $30e9cedc677d8f10$var$ignoreDuplicateOf = (0, $e615e35db2201e65$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $30e9cedc677d8f10$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $30e9cedc677d8f10$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $2cc632eb892baefc$var$$internals = Symbol("internals");
function $2cc632eb892baefc$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2cc632eb892baefc$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(value) ? value.map($2cc632eb892baefc$var$normalizeValue) : String(value);
}
function $2cc632eb892baefc$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2cc632eb892baefc$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2cc632eb892baefc$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $2cc632eb892baefc$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2cc632eb892baefc$var$buildAccessors(obj, header) {
    const accessorName = (0, $e615e35db2201e65$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2cc632eb892baefc$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2cc632eb892baefc$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $e615e35db2201e65$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2cc632eb892baefc$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$2cc632eb892baefc$var$isValidHeaderName(header)) setHeaders((0, $30e9cedc677d8f10$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2cc632eb892baefc$var$normalizeHeader(header);
        if (header) {
            const key = (0, $e615e35db2201e65$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2cc632eb892baefc$var$parseTokens(value);
                if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $2cc632eb892baefc$var$normalizeHeader(header);
        if (header) {
            const key = (0, $e615e35db2201e65$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2cc632eb892baefc$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2cc632eb892baefc$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $e615e35db2201e65$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $2cc632eb892baefc$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2cc632eb892baefc$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $e615e35db2201e65$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $2cc632eb892baefc$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2cc632eb892baefc$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2cc632eb892baefc$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2cc632eb892baefc$var$$internals] = this[$2cc632eb892baefc$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2cc632eb892baefc$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2cc632eb892baefc$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$2cc632eb892baefc$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $e615e35db2201e65$export$2e2bcd8739ae039).reduceDescriptors($2cc632eb892baefc$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $e615e35db2201e65$export$2e2bcd8739ae039).freezeMethods($2cc632eb892baefc$var$AxiosHeaders);
var $2cc632eb892baefc$export$2e2bcd8739ae039 = $2cc632eb892baefc$var$AxiosHeaders;


"use strict";
function $72f6e4e28dd1945e$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f4f35daad55027f1$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $a825c096ae0e1e0b$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $846159c3dae5a2bc$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $e615e35db2201e65$export$2e2bcd8739ae039).inherits($846159c3dae5a2bc$var$CanceledError, (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $846159c3dae5a2bc$export$2e2bcd8739ae039 = $846159c3dae5a2bc$var$CanceledError;







"use strict";
function $ee170bff81f15732$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $7425dada0ac403d1$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $44ea8509079feb1b$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $44ea8509079feb1b$export$2e2bcd8739ae039 = $44ea8509079feb1b$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $c2b23ba66b7f6f7b$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $c2b23ba66b7f6f7b$export$2e2bcd8739ae039 = $c2b23ba66b7f6f7b$var$throttle;



const $c9f907fd582ac454$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $44ea8509079feb1b$export$2e2bcd8739ae039)(50, 250);
    return (0, $c2b23ba66b7f6f7b$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $c9f907fd582ac454$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $c9f907fd582ac454$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $e615e35db2201e65$export$2e2bcd8739ae039).asap(()=>fn(...args));






"use strict";
var $a8176a1e5c21b35d$export$2e2bcd8739ae039 = (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $959098f38702ff50$export$2e2bcd8739ae039 = (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $0370277ba6b1a534$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $50bef935c5e6c27a$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $02b2edc7ba3b82d1$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $0370277ba6b1a534$export$2e2bcd8739ae039)(requestedURL)) return (0, $50bef935c5e6c27a$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





"use strict";
const $0a9ba4ac8ecccc52$var$headersToObject = (thing)=>thing instanceof (0, $2cc632eb892baefc$export$2e2bcd8739ae039) ? (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, thing) : thing;
function $0a9ba4ac8ecccc52$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isPlainObject(target) && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $e615e35db2201e65$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $e615e35db2201e65$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($0a9ba4ac8ecccc52$var$headersToObject(a), $0a9ba4ac8ecccc52$var$headersToObject(b), true)
    };
    (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $41af344c0fa1a980$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $0a9ba4ac8ecccc52$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $cddfb001737e7567$export$2e2bcd8739ae039)((0, $02b2edc7ba3b82d1$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $a8176a1e5c21b35d$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $959098f38702ff50$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $450cf8f551926566$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $450cf8f551926566$export$2e2bcd8739ae039 = $450cf8f551926566$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $41af344c0fa1a980$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ee170bff81f15732$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("Request aborted", (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("Network Error", (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $402eae7cfab1bae3$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ETIMEDOUT : (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $c9f907fd582ac454$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $c9f907fd582ac454$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $846159c3dae5a2bc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $7425dada0ac403d1$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};










const $685864c657981c59$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039) ? err : new (0, $846159c3dae5a2bc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $e615e35db2201e65$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $685864c657981c59$export$2e2bcd8739ae039 = $685864c657981c59$var$composeSignals;


const $5daaa5bd1998a942$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $5daaa5bd1998a942$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $5daaa5bd1998a942$var$readStream(iterable))yield* $5daaa5bd1998a942$export$71b051935044bd5d(chunk, chunkSize);
};
const $5daaa5bd1998a942$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $5daaa5bd1998a942$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $5daaa5bd1998a942$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e3b2f29b8cabb5fa$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $e3b2f29b8cabb5fa$var$isReadableStreamSupported = $e3b2f29b8cabb5fa$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $e3b2f29b8cabb5fa$var$encodeText = $e3b2f29b8cabb5fa$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e3b2f29b8cabb5fa$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e3b2f29b8cabb5fa$var$supportsRequestStream = $e3b2f29b8cabb5fa$var$isReadableStreamSupported && $e3b2f29b8cabb5fa$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $e3b2f29b8cabb5fa$var$DEFAULT_CHUNK_SIZE = 65536;
const $e3b2f29b8cabb5fa$var$supportsResponseStream = $e3b2f29b8cabb5fa$var$isReadableStreamSupported && $e3b2f29b8cabb5fa$var$test(()=>(0, $e615e35db2201e65$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $e3b2f29b8cabb5fa$var$resolvers = {
    stream: $e3b2f29b8cabb5fa$var$supportsResponseStream && ((res)=>res.body)
};
$e3b2f29b8cabb5fa$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$e3b2f29b8cabb5fa$var$resolvers[type] && ($e3b2f29b8cabb5fa$var$resolvers[type] = (0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e3b2f29b8cabb5fa$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $2160b4ca9caa1a7c$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(body)) return (await $e3b2f29b8cabb5fa$var$encodeText(body)).byteLength;
};
const $e3b2f29b8cabb5fa$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $e615e35db2201e65$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e3b2f29b8cabb5fa$var$getBodyLength(body) : length;
};
var $e3b2f29b8cabb5fa$export$2e2bcd8739ae039 = $e3b2f29b8cabb5fa$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $41af344c0fa1a980$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $685864c657981c59$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e3b2f29b8cabb5fa$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $e3b2f29b8cabb5fa$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $c9f907fd582ac454$export$d9fadd12586c18d6)(requestContentLength, (0, $c9f907fd582ac454$export$c1b28109d46c3592)((0, $c9f907fd582ac454$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $5daaa5bd1998a942$export$b0119225647bd83)(_request.body, $e3b2f29b8cabb5fa$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $e615e35db2201e65$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, fetchOptions), {
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        }));
        let response = await fetch(request);
        const isStreamResponse = $e3b2f29b8cabb5fa$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($e3b2f29b8cabb5fa$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $e615e35db2201e65$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $c9f907fd582ac454$export$d9fadd12586c18d6)(responseContentLength, (0, $c9f907fd582ac454$export$c1b28109d46c3592)((0, $c9f907fd582ac454$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $5daaa5bd1998a942$export$b0119225647bd83)(response.body, $e3b2f29b8cabb5fa$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $e3b2f29b8cabb5fa$var$resolvers[(0, $e615e35db2201e65$export$2e2bcd8739ae039).findKey($e3b2f29b8cabb5fa$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $ee170bff81f15732$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("Network Error", (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $293263b2d5939ee1$var$knownAdapters = {
    http: (0, $61b2de7d28775a46$export$2e2bcd8739ae039),
    xhr: (0, $450cf8f551926566$export$2e2bcd8739ae039),
    fetch: (0, $e3b2f29b8cabb5fa$export$2e2bcd8739ae039)
};
(0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach($293263b2d5939ee1$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $293263b2d5939ee1$var$renderReason = (reason)=>`- ${reason}`;
const $293263b2d5939ee1$var$isResolvedHandle = (adapter)=>(0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $293263b2d5939ee1$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $e615e35db2201e65$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$293263b2d5939ee1$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $293263b2d5939ee1$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($293263b2d5939ee1$var$renderReason).join("\n") : " " + $293263b2d5939ee1$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $293263b2d5939ee1$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $654c4a13073292ce$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $846159c3dae5a2bc$export$2e2bcd8739ae039)(null, config);
}
function $654c4a13073292ce$export$2e2bcd8739ae039(config) {
    $654c4a13073292ce$var$throwIfCancellationRequested(config);
    config.headers = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $72f6e4e28dd1945e$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $293263b2d5939ee1$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f4f35daad55027f1$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $654c4a13073292ce$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $72f6e4e28dd1945e$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $a825c096ae0e1e0b$export$2e2bcd8739ae039)(reason)) {
            $654c4a13073292ce$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $72f6e4e28dd1945e$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $1084ef018eae50b7$export$a4ad2735b021c132 = "1.7.7";



"use strict";
const $b67332801494b21e$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $b67332801494b21e$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $b67332801494b21e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $b67332801494b21e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $1084ef018eae50b7$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$b67332801494b21e$var$deprecatedWarnings[opt]) {
            $b67332801494b21e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $b67332801494b21e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("options must be an object", (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $b67332801494b21e$export$2e2bcd8739ae039 = {
    assertOptions: $b67332801494b21e$var$assertOptions,
    validators: $b67332801494b21e$var$validators
};



"use strict";
const $095ded9cbaf645a1$var$validators = (0, $b67332801494b21e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $095ded9cbaf645a1$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $0a9ba4ac8ecccc52$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $b67332801494b21e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $095ded9cbaf645a1$var$validators.transitional($095ded9cbaf645a1$var$validators.boolean),
            forcedJSONParsing: $095ded9cbaf645a1$var$validators.transitional($095ded9cbaf645a1$var$validators.boolean),
            clarifyTimeoutError: $095ded9cbaf645a1$var$validators.transitional($095ded9cbaf645a1$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $e615e35db2201e65$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $b67332801494b21e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $095ded9cbaf645a1$var$validators.function,
                serialize: $095ded9cbaf645a1$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $e615e35db2201e65$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $2cc632eb892baefc$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $654c4a13073292ce$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $654c4a13073292ce$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $0a9ba4ac8ecccc52$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $02b2edc7ba3b82d1$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $cddfb001737e7567$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $e50e89fc01be7fc7$export$2e2bcd8739ae039)(),
            response: new (0, $e50e89fc01be7fc7$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $095ded9cbaf645a1$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $0a9ba4ac8ecccc52$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $e615e35db2201e65$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $0a9ba4ac8ecccc52$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $095ded9cbaf645a1$var$Axios.prototype[method] = generateHTTPMethod();
    $095ded9cbaf645a1$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $095ded9cbaf645a1$export$2e2bcd8739ae039 = $095ded9cbaf645a1$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $d7885c87fa588e04$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $d7885c87fa588e04$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $846159c3dae5a2bc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $d7885c87fa588e04$export$2e2bcd8739ae039 = $d7885c87fa588e04$var$CancelToken;






"use strict";
function $e2ae6fa6fdcead76$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $5e064d2048dc783e$export$2e2bcd8739ae039(payload) {
    return (0, $e615e35db2201e65$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $86735d94a8d58e47$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($86735d94a8d58e47$var$HttpStatusCode).forEach(([key, value])=>{
    $86735d94a8d58e47$var$HttpStatusCode[value] = key;
});
var $86735d94a8d58e47$export$2e2bcd8739ae039 = $86735d94a8d58e47$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $0990a2a3ce225f89$var$createInstance(defaultConfig) {
    const context = new (0, $095ded9cbaf645a1$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $932eaecd8eb37723$export$2e2bcd8739ae039)((0, $095ded9cbaf645a1$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $e615e35db2201e65$export$2e2bcd8739ae039).extend(instance, (0, $095ded9cbaf645a1$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $e615e35db2201e65$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $0990a2a3ce225f89$var$createInstance((0, $0a9ba4ac8ecccc52$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $0990a2a3ce225f89$var$axios = $0990a2a3ce225f89$var$createInstance((0, $f4f35daad55027f1$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$0990a2a3ce225f89$var$axios.Axios = (0, $095ded9cbaf645a1$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$0990a2a3ce225f89$var$axios.CanceledError = (0, $846159c3dae5a2bc$export$2e2bcd8739ae039);
$0990a2a3ce225f89$var$axios.CancelToken = (0, $d7885c87fa588e04$export$2e2bcd8739ae039);
$0990a2a3ce225f89$var$axios.isCancel = (0, $a825c096ae0e1e0b$export$2e2bcd8739ae039);
$0990a2a3ce225f89$var$axios.VERSION = (0, $1084ef018eae50b7$export$a4ad2735b021c132);
$0990a2a3ce225f89$var$axios.toFormData = (0, $20f3c4d449d2b89f$export$2e2bcd8739ae039);
// Expose AxiosError class
$0990a2a3ce225f89$var$axios.AxiosError = (0, $fe49f4f3b6d88c51$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$0990a2a3ce225f89$var$axios.Cancel = $0990a2a3ce225f89$var$axios.CanceledError;
// Expose all/spread
$0990a2a3ce225f89$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$0990a2a3ce225f89$var$axios.spread = (0, $e2ae6fa6fdcead76$export$2e2bcd8739ae039);
// Expose isAxiosError
$0990a2a3ce225f89$var$axios.isAxiosError = (0, $5e064d2048dc783e$export$2e2bcd8739ae039);
// Expose mergeConfig
$0990a2a3ce225f89$var$axios.mergeConfig = (0, $0a9ba4ac8ecccc52$export$2e2bcd8739ae039);
$0990a2a3ce225f89$var$axios.AxiosHeaders = (0, $2cc632eb892baefc$export$2e2bcd8739ae039);
$0990a2a3ce225f89$var$axios.formToJSON = (thing)=>(0, $7897485f2508a65c$export$2e2bcd8739ae039)((0, $e615e35db2201e65$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$0990a2a3ce225f89$var$axios.getAdapter = (0, $293263b2d5939ee1$export$2e2bcd8739ae039).getAdapter;
$0990a2a3ce225f89$var$axios.HttpStatusCode = (0, $86735d94a8d58e47$export$2e2bcd8739ae039);
$0990a2a3ce225f89$var$axios.default = $0990a2a3ce225f89$var$axios;
var // this module should only have a default export
$0990a2a3ce225f89$export$2e2bcd8739ae039 = $0990a2a3ce225f89$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $77a77643637aecb7$export$1c00760e9e5a4e95, AxiosError: $77a77643637aecb7$export$c1fbed17c2f6a328, CanceledError: $77a77643637aecb7$export$1ab0c6b20d94fa14, isCancel: $77a77643637aecb7$export$3b22524397b493c6, CancelToken: $77a77643637aecb7$export$fd08e3cb425f0d61, VERSION: $77a77643637aecb7$export$a4ad2735b021c132, all: $77a77643637aecb7$export$84bf76cd7afc7469, Cancel: $77a77643637aecb7$export$848c9b7ead0df967, isAxiosError: $77a77643637aecb7$export$fbafdbe06a5b5a9a, spread: $77a77643637aecb7$export$3ae0fd4797ed47c8, toFormData: $77a77643637aecb7$export$10ae0d317ea97f8b, AxiosHeaders: $77a77643637aecb7$export$4e7d6ff0f3e6520, HttpStatusCode: $77a77643637aecb7$export$a972f69c851492b3, formToJSON: $77a77643637aecb7$export$86d7c59254d6a2c9, getAdapter: $77a77643637aecb7$export$17ddc20a97d669e2, mergeConfig: $77a77643637aecb7$export$7ec1ebcfa9d8bd6a } = (0, $0990a2a3ce225f89$export$2e2bcd8739ae039);


var $f0c6463d360a8232$exports = {};
(function(global1, factory) {
    $f0c6463d360a8232$exports = factory();
})($f0c6463d360a8232$exports, function() {
    "use strict";
    var toStringFunction = Function.prototype.toString;
    var create = Object.create, defineProperty = Object.defineProperty, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getPrototypeOf$1 = Object.getPrototypeOf;
    var _a = Object.prototype, hasOwnProperty = _a.hasOwnProperty, propertyIsEnumerable = _a.propertyIsEnumerable;
    var SYMBOL_PROPERTIES = typeof getOwnPropertySymbols === "function";
    var WEAK_MAP = typeof WeakMap === "function";
    /**
     * @function createCache
     *
     * @description
     * get a new cache object to prevent circular references
     *
     * @returns the new cache object
     */ var createCache = function() {
        if (WEAK_MAP) return function() {
            return new WeakMap();
        };
        var Cache = /** @class */ function() {
            function Cache() {
                this._keys = [];
                this._values = [];
            }
            Cache.prototype.has = function(key) {
                return !!~this._keys.indexOf(key);
            };
            Cache.prototype.get = function(key) {
                return this._values[this._keys.indexOf(key)];
            };
            Cache.prototype.set = function(key, value) {
                this._keys.push(key);
                this._values.push(value);
            };
            return Cache;
        }();
        return function() {
            return new Cache();
        };
    }();
    /**
     * @function getCleanClone
     *
     * @description
     * get an empty version of the object with the same prototype it has
     *
     * @param object the object to build a clean clone from
     * @param realm the realm the object resides in
     * @returns the empty cloned object
     */ var getCleanClone = function(object, realm) {
        var prototype = object.__proto__ || getPrototypeOf$1(object);
        if (!prototype) return create(null);
        var Constructor = prototype.constructor;
        if (Constructor === realm.Object) return prototype === realm.Object.prototype ? {} : create(prototype);
        if (~toStringFunction.call(Constructor).indexOf("[native code]")) try {
            return new Constructor();
        } catch (_a) {}
        return create(prototype);
    };
    /**
     * @function getObjectCloneLoose
     *
     * @description
     * get a copy of the object based on loose rules, meaning all enumerable keys
     * and symbols are copied, but property descriptors are not considered
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneLoose = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        for(var key in object)if (hasOwnProperty.call(object, key)) clone[key] = handleCopy(object[key], cache);
        if (SYMBOL_PROPERTIES) {
            var symbols = getOwnPropertySymbols(object);
            for(var index = 0, length_1 = symbols.length, symbol = void 0; index < length_1; ++index){
                symbol = symbols[index];
                if (propertyIsEnumerable.call(object, symbol)) clone[symbol] = handleCopy(object[symbol], cache);
            }
        }
        return clone;
    };
    /**
     * @function getObjectCloneStrict
     *
     * @description
     * get a copy of the object based on strict rules, meaning all keys and symbols
     * are copied based on the original property descriptors
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneStrict = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        var properties = SYMBOL_PROPERTIES ? getOwnPropertyNames(object).concat(getOwnPropertySymbols(object)) : getOwnPropertyNames(object);
        for(var index = 0, length_2 = properties.length, property = void 0, descriptor = void 0; index < length_2; ++index){
            property = properties[index];
            if (property !== "callee" && property !== "caller") {
                descriptor = getOwnPropertyDescriptor(object, property);
                if (descriptor) {
                    // Only clone the value if actually a value, not a getter / setter.
                    if (!descriptor.get && !descriptor.set) descriptor.value = handleCopy(object[property], cache);
                    try {
                        defineProperty(clone, property, descriptor);
                    } catch (error) {
                        // Tee above can fail on node in edge cases, so fall back to the loose assignment.
                        clone[property] = descriptor.value;
                    }
                } else // In extra edge cases where the property descriptor cannot be retrived, fall back to
                // the loose assignment.
                clone[property] = handleCopy(object[property], cache);
            }
        }
        return clone;
    };
    /**
     * @function getRegExpFlags
     *
     * @description
     * get the flags to apply to the copied regexp
     *
     * @param regExp the regexp to get the flags of
     * @returns the flags for the regexp
     */ var getRegExpFlags = function(regExp) {
        var flags = "";
        if (regExp.global) flags += "g";
        if (regExp.ignoreCase) flags += "i";
        if (regExp.multiline) flags += "m";
        if (regExp.unicode) flags += "u";
        if (regExp.sticky) flags += "y";
        return flags;
    };
    // utils
    var isArray = Array.isArray;
    var getPrototypeOf = Object.getPrototypeOf;
    var GLOBAL_THIS = function() {
        if (typeof globalThis !== "undefined") return globalThis;
        if (typeof self !== "undefined") return self;
        if (typeof window !== "undefined") return window;
        if (typeof $parcel$global !== "undefined") return $parcel$global;
        if (console && console.error) console.error('Unable to locate global object, returning "this".');
        return this;
    }();
    /**
     * @function copy
     *
     * @description
     * copy an value deeply as much as possible
     *
     * If `strict` is applied, then all properties (including non-enumerable ones)
     * are copied with their original property descriptors on both objects and arrays.
     *
     * The value is compared to the global constructors in the `realm` provided,
     * and the native constructor is always used to ensure that extensions of native
     * objects (allows in ES2015+) are maintained.
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.isStrict] should the copy be strict
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ function copy(value, options) {
        // manually coalesced instead of default parameters for performance
        var isStrict = !!(options && options.isStrict);
        var realm = options && options.realm || GLOBAL_THIS;
        var getObjectClone = isStrict ? getObjectCloneStrict : getObjectCloneLoose;
        /**
         * @function handleCopy
         *
         * @description
         * copy the value recursively based on its type
         *
         * @param value the value to copy
         * @returns the copied value
         */ var handleCopy = function(value, cache) {
            if (!value || typeof value !== "object") return value;
            if (cache.has(value)) return cache.get(value);
            var prototype = value.__proto__ || getPrototypeOf(value);
            var Constructor = prototype && prototype.constructor;
            // plain objects
            if (!Constructor || Constructor === realm.Object) return getObjectClone(value, realm, handleCopy, cache);
            var clone;
            // arrays
            if (isArray(value)) {
                // if strict, include non-standard properties
                if (isStrict) return getObjectCloneStrict(value, realm, handleCopy, cache);
                clone = new Constructor();
                cache.set(value, clone);
                for(var index = 0, length_1 = value.length; index < length_1; ++index)clone[index] = handleCopy(value[index], cache);
                return clone;
            }
            // dates
            if (value instanceof realm.Date) return new Constructor(value.getTime());
            // regexps
            if (value instanceof realm.RegExp) {
                clone = new Constructor(value.source, value.flags || getRegExpFlags(value));
                clone.lastIndex = value.lastIndex;
                return clone;
            }
            // maps
            if (realm.Map && value instanceof realm.Map) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value, key) {
                    clone.set(key, handleCopy(value, cache));
                });
                return clone;
            }
            // sets
            if (realm.Set && value instanceof realm.Set) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value) {
                    clone.add(handleCopy(value, cache));
                });
                return clone;
            }
            // blobs
            if (realm.Blob && value instanceof realm.Blob) return value.slice(0, value.size, value.type);
            // buffers (node-only)
            if (realm.Buffer && realm.Buffer.isBuffer(value)) {
                clone = realm.Buffer.allocUnsafe ? realm.Buffer.allocUnsafe(value.length) : new Constructor(value.length);
                cache.set(value, clone);
                value.copy(clone);
                return clone;
            }
            // arraybuffers / dataviews
            if (realm.ArrayBuffer) {
                // dataviews
                if (realm.ArrayBuffer.isView(value)) {
                    clone = new Constructor(value.buffer.slice(0));
                    cache.set(value, clone);
                    return clone;
                }
                // arraybuffers
                if (value instanceof realm.ArrayBuffer) {
                    clone = value.slice(0);
                    cache.set(value, clone);
                    return clone;
                }
            }
            // if the value cannot / should not be cloned, don't
            if (// promise-like
            typeof value.then === "function" || // errors
            value instanceof Error || // weakmaps
            realm.WeakMap && value instanceof realm.WeakMap || // weaksets
            realm.WeakSet && value instanceof realm.WeakSet) return value;
            // assume anything left is a custom constructor
            return getObjectClone(value, realm, handleCopy, cache);
        };
        return handleCopy(value, createCache());
    }
    // Adding reference to allow usage in CommonJS libraries compiled using TSC, which
    // expects there to be a default property on the exported value. See
    // [#37](https://github.com/planttheidea/fast-copy/issues/37) for details.
    copy.default = copy;
    /**
     * @function strictCopy
     *
     * @description
     * copy the value with `strict` option pre-applied
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ copy.strict = function strictCopy(value, options) {
        return copy(value, {
            isStrict: true,
            realm: options ? options.realm : void 0
        });
    };
    return copy;
});


var $0200172ea6ee8917$exports = {};
"use strict";
var $a22047d7fbc233ac$exports = {};
"use strict";
var $99a7b2b2885c9d6d$exports = {};
"use strict";

var $6azwx = parcelRequire("6azwx");
var $c8d994c9e3459f9e$exports = {};
"use strict";

var $6azwx = parcelRequire("6azwx");
var $35a6076f290c8bbf$exports = {};
"use strict";

var $6JQ6Q = parcelRequire("6JQ6Q");

var $6azwx = parcelRequire("6azwx");
var $ef33c448b72ca721$exports = {};
"use strict";

var $6azwx = parcelRequire("6azwx");
var $f591a58be95bec76$exports = {};
"use strict";

var $e83BP = parcelRequire("e83BP");

var $hqiKn = parcelRequire("hqiKn");

var $RHWZq = parcelRequire("RHWZq");
var $afe9495371c9a742$exports = {};
"use strict";

var $6azwx = parcelRequire("6azwx");
var $afe9495371c9a742$var$$gOPD = $6azwx("%Object.getOwnPropertyDescriptor%", true);
if ($afe9495371c9a742$var$$gOPD) try {
    $afe9495371c9a742$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $afe9495371c9a742$var$$gOPD = null;
}
$afe9495371c9a742$exports = $afe9495371c9a742$var$$gOPD;


/** @type {import('.')} */ $f591a58be95bec76$exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $RHWZq("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $RHWZq("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $RHWZq("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $RHWZq("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $RHWZq("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $RHWZq("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$afe9495371c9a742$exports && $afe9495371c9a742$exports(obj, property);
    if ($e83BP) $e83BP(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $hqiKn("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};



var $ef33c448b72ca721$var$hasDescriptors = (parcelRequire("epnTX"))();


var $RHWZq = parcelRequire("RHWZq");
var $ef33c448b72ca721$var$$floor = $6azwx("%Math.floor%");
/** @type {import('.')} */ $ef33c448b72ca721$exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $RHWZq("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $ef33c448b72ca721$var$$floor(length) !== length) throw new $RHWZq("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $afe9495371c9a742$exports) {
        var desc = $afe9495371c9a742$exports(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($ef33c448b72ca721$var$hasDescriptors) $f591a58be95bec76$exports(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $f591a58be95bec76$exports(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};



var $RHWZq = parcelRequire("RHWZq");
var $35a6076f290c8bbf$var$$apply = $6azwx("%Function.prototype.apply%");
var $35a6076f290c8bbf$var$$call = $6azwx("%Function.prototype.call%");
var $35a6076f290c8bbf$var$$reflectApply = $6azwx("%Reflect.apply%", true) || $6JQ6Q.call($35a6076f290c8bbf$var$$call, $35a6076f290c8bbf$var$$apply);

var $e83BP = parcelRequire("e83BP");
var $35a6076f290c8bbf$var$$max = $6azwx("%Math.max%");
$35a6076f290c8bbf$exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $RHWZq("a function is required");
    var func = $35a6076f290c8bbf$var$$reflectApply($6JQ6Q, $35a6076f290c8bbf$var$$call, arguments);
    return $ef33c448b72ca721$exports(func, 1 + $35a6076f290c8bbf$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $35a6076f290c8bbf$var$applyBind = function applyBind() {
    return $35a6076f290c8bbf$var$$reflectApply($6JQ6Q, $35a6076f290c8bbf$var$$apply, arguments);
};
if ($e83BP) $e83BP($35a6076f290c8bbf$exports, "apply", {
    value: $35a6076f290c8bbf$var$applyBind
});
else $35a6076f290c8bbf$exports.apply = $35a6076f290c8bbf$var$applyBind;


var $c8d994c9e3459f9e$var$$indexOf = $35a6076f290c8bbf$exports($6azwx("String.prototype.indexOf"));
$c8d994c9e3459f9e$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $6azwx(name, !!allowMissing);
    if (typeof intrinsic === "function" && $c8d994c9e3459f9e$var$$indexOf(name, ".prototype.") > -1) return $35a6076f290c8bbf$exports(intrinsic);
    return intrinsic;
};


var $533115660d4eae6a$exports = {};
var $533115660d4eae6a$var$hasMap = typeof Map === "function" && Map.prototype;
var $533115660d4eae6a$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $533115660d4eae6a$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $533115660d4eae6a$var$mapSize = $533115660d4eae6a$var$hasMap && $533115660d4eae6a$var$mapSizeDescriptor && typeof $533115660d4eae6a$var$mapSizeDescriptor.get === "function" ? $533115660d4eae6a$var$mapSizeDescriptor.get : null;
var $533115660d4eae6a$var$mapForEach = $533115660d4eae6a$var$hasMap && Map.prototype.forEach;
var $533115660d4eae6a$var$hasSet = typeof Set === "function" && Set.prototype;
var $533115660d4eae6a$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $533115660d4eae6a$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $533115660d4eae6a$var$setSize = $533115660d4eae6a$var$hasSet && $533115660d4eae6a$var$setSizeDescriptor && typeof $533115660d4eae6a$var$setSizeDescriptor.get === "function" ? $533115660d4eae6a$var$setSizeDescriptor.get : null;
var $533115660d4eae6a$var$setForEach = $533115660d4eae6a$var$hasSet && Set.prototype.forEach;
var $533115660d4eae6a$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $533115660d4eae6a$var$weakMapHas = $533115660d4eae6a$var$hasWeakMap ? WeakMap.prototype.has : null;
var $533115660d4eae6a$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $533115660d4eae6a$var$weakSetHas = $533115660d4eae6a$var$hasWeakSet ? WeakSet.prototype.has : null;
var $533115660d4eae6a$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $533115660d4eae6a$var$weakRefDeref = $533115660d4eae6a$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $533115660d4eae6a$var$booleanValueOf = Boolean.prototype.valueOf;
var $533115660d4eae6a$var$objectToString = Object.prototype.toString;
var $533115660d4eae6a$var$functionToString = Function.prototype.toString;
var $533115660d4eae6a$var$$match = String.prototype.match;
var $533115660d4eae6a$var$$slice = String.prototype.slice;
var $533115660d4eae6a$var$$replace = String.prototype.replace;
var $533115660d4eae6a$var$$toUpperCase = String.prototype.toUpperCase;
var $533115660d4eae6a$var$$toLowerCase = String.prototype.toLowerCase;
var $533115660d4eae6a$var$$test = RegExp.prototype.test;
var $533115660d4eae6a$var$$concat = Array.prototype.concat;
var $533115660d4eae6a$var$$join = Array.prototype.join;
var $533115660d4eae6a$var$$arrSlice = Array.prototype.slice;
var $533115660d4eae6a$var$$floor = Math.floor;
var $533115660d4eae6a$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $533115660d4eae6a$var$gOPS = Object.getOwnPropertySymbols;
var $533115660d4eae6a$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $533115660d4eae6a$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $533115660d4eae6a$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $533115660d4eae6a$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $533115660d4eae6a$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $533115660d4eae6a$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $533115660d4eae6a$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $533115660d4eae6a$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$533115660d4eae6a$var$$floor(-num) : $533115660d4eae6a$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $533115660d4eae6a$var$$slice.call(str, intStr.length + 1);
            return $533115660d4eae6a$var$$replace.call(intStr, sepRegex, "$&_") + "." + $533115660d4eae6a$var$$replace.call($533115660d4eae6a$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $533115660d4eae6a$var$$replace.call(str, sepRegex, "$&_");
}
var $0e21e93f7f3dbd20$exports = {};
"use strict";


var $533115660d4eae6a$var$inspectCustom = $0e21e93f7f3dbd20$exports.custom;
var $533115660d4eae6a$var$inspectSymbol = $533115660d4eae6a$var$isSymbol($533115660d4eae6a$var$inspectCustom) ? $533115660d4eae6a$var$inspectCustom : null;
$533115660d4eae6a$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($533115660d4eae6a$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($533115660d4eae6a$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $533115660d4eae6a$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($533115660d4eae6a$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($533115660d4eae6a$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $533115660d4eae6a$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $533115660d4eae6a$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $533115660d4eae6a$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $533115660d4eae6a$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $533115660d4eae6a$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($533115660d4eae6a$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $533115660d4eae6a$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($533115660d4eae6a$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$533115660d4eae6a$var$isRegExp(obj)) {
        var name = $533115660d4eae6a$var$nameOf(obj);
        var keys = $533115660d4eae6a$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $533115660d4eae6a$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($533115660d4eae6a$var$isSymbol(obj)) {
        var symString = $533115660d4eae6a$var$hasShammedSymbols ? $533115660d4eae6a$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $533115660d4eae6a$var$symToString.call(obj);
        return typeof obj === "object" && !$533115660d4eae6a$var$hasShammedSymbols ? $533115660d4eae6a$var$markBoxed(symString) : symString;
    }
    if ($533115660d4eae6a$var$isElement(obj)) {
        var s = "<" + $533115660d4eae6a$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $533115660d4eae6a$var$wrapQuotes($533115660d4eae6a$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $533115660d4eae6a$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($533115660d4eae6a$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $533115660d4eae6a$var$arrObjKeys(obj, inspect);
        if (indent && !$533115660d4eae6a$var$singleLineValues(xs)) return "[" + $533115660d4eae6a$var$indentedJoin(xs, indent) + "]";
        return "[ " + $533115660d4eae6a$var$$join.call(xs, ", ") + " ]";
    }
    if ($533115660d4eae6a$var$isError(obj)) {
        var parts = $533115660d4eae6a$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$533115660d4eae6a$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $533115660d4eae6a$var$$join.call($533115660d4eae6a$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $533115660d4eae6a$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($533115660d4eae6a$var$inspectSymbol && typeof obj[$533115660d4eae6a$var$inspectSymbol] === "function" && $0e21e93f7f3dbd20$exports) return $0e21e93f7f3dbd20$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($533115660d4eae6a$var$isMap(obj)) {
        var mapParts = [];
        if ($533115660d4eae6a$var$mapForEach) $533115660d4eae6a$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $533115660d4eae6a$var$collectionOf("Map", $533115660d4eae6a$var$mapSize.call(obj), mapParts, indent);
    }
    if ($533115660d4eae6a$var$isSet(obj)) {
        var setParts = [];
        if ($533115660d4eae6a$var$setForEach) $533115660d4eae6a$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $533115660d4eae6a$var$collectionOf("Set", $533115660d4eae6a$var$setSize.call(obj), setParts, indent);
    }
    if ($533115660d4eae6a$var$isWeakMap(obj)) return $533115660d4eae6a$var$weakCollectionOf("WeakMap");
    if ($533115660d4eae6a$var$isWeakSet(obj)) return $533115660d4eae6a$var$weakCollectionOf("WeakSet");
    if ($533115660d4eae6a$var$isWeakRef(obj)) return $533115660d4eae6a$var$weakCollectionOf("WeakRef");
    if ($533115660d4eae6a$var$isNumber(obj)) return $533115660d4eae6a$var$markBoxed(inspect(Number(obj)));
    if ($533115660d4eae6a$var$isBigInt(obj)) return $533115660d4eae6a$var$markBoxed(inspect($533115660d4eae6a$var$bigIntValueOf.call(obj)));
    if ($533115660d4eae6a$var$isBoolean(obj)) return $533115660d4eae6a$var$markBoxed($533115660d4eae6a$var$booleanValueOf.call(obj));
    if ($533115660d4eae6a$var$isString(obj)) return $533115660d4eae6a$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof $parcel$global !== "undefined" && obj === $parcel$global) return "{ [object globalThis] }";
    if (!$533115660d4eae6a$var$isDate(obj) && !$533115660d4eae6a$var$isRegExp(obj)) {
        var ys = $533115660d4eae6a$var$arrObjKeys(obj, inspect);
        var isPlainObject = $533115660d4eae6a$var$gPO ? $533115660d4eae6a$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $533115660d4eae6a$var$toStringTag && Object(obj) === obj && $533115660d4eae6a$var$toStringTag in obj ? $533115660d4eae6a$var$$slice.call($533115660d4eae6a$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $533115660d4eae6a$var$$join.call($533115660d4eae6a$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $533115660d4eae6a$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $533115660d4eae6a$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $533115660d4eae6a$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $533115660d4eae6a$var$quote(s) {
    return $533115660d4eae6a$var$$replace.call(String(s), /"/g, "&quot;");
}
function $533115660d4eae6a$var$isArray(obj) {
    return $533115660d4eae6a$var$toStr(obj) === "[object Array]" && (!$533115660d4eae6a$var$toStringTag || !(typeof obj === "object" && $533115660d4eae6a$var$toStringTag in obj));
}
function $533115660d4eae6a$var$isDate(obj) {
    return $533115660d4eae6a$var$toStr(obj) === "[object Date]" && (!$533115660d4eae6a$var$toStringTag || !(typeof obj === "object" && $533115660d4eae6a$var$toStringTag in obj));
}
function $533115660d4eae6a$var$isRegExp(obj) {
    return $533115660d4eae6a$var$toStr(obj) === "[object RegExp]" && (!$533115660d4eae6a$var$toStringTag || !(typeof obj === "object" && $533115660d4eae6a$var$toStringTag in obj));
}
function $533115660d4eae6a$var$isError(obj) {
    return $533115660d4eae6a$var$toStr(obj) === "[object Error]" && (!$533115660d4eae6a$var$toStringTag || !(typeof obj === "object" && $533115660d4eae6a$var$toStringTag in obj));
}
function $533115660d4eae6a$var$isString(obj) {
    return $533115660d4eae6a$var$toStr(obj) === "[object String]" && (!$533115660d4eae6a$var$toStringTag || !(typeof obj === "object" && $533115660d4eae6a$var$toStringTag in obj));
}
function $533115660d4eae6a$var$isNumber(obj) {
    return $533115660d4eae6a$var$toStr(obj) === "[object Number]" && (!$533115660d4eae6a$var$toStringTag || !(typeof obj === "object" && $533115660d4eae6a$var$toStringTag in obj));
}
function $533115660d4eae6a$var$isBoolean(obj) {
    return $533115660d4eae6a$var$toStr(obj) === "[object Boolean]" && (!$533115660d4eae6a$var$toStringTag || !(typeof obj === "object" && $533115660d4eae6a$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $533115660d4eae6a$var$isSymbol(obj) {
    if ($533115660d4eae6a$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$533115660d4eae6a$var$symToString) return false;
    try {
        $533115660d4eae6a$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $533115660d4eae6a$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$533115660d4eae6a$var$bigIntValueOf) return false;
    try {
        $533115660d4eae6a$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $533115660d4eae6a$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $533115660d4eae6a$var$has(obj, key) {
    return $533115660d4eae6a$var$hasOwn.call(obj, key);
}
function $533115660d4eae6a$var$toStr(obj) {
    return $533115660d4eae6a$var$objectToString.call(obj);
}
function $533115660d4eae6a$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $533115660d4eae6a$var$$match.call($533115660d4eae6a$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $533115660d4eae6a$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $533115660d4eae6a$var$isMap(x) {
    if (!$533115660d4eae6a$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $533115660d4eae6a$var$mapSize.call(x);
        try {
            $533115660d4eae6a$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $533115660d4eae6a$var$isWeakMap(x) {
    if (!$533115660d4eae6a$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $533115660d4eae6a$var$weakMapHas.call(x, $533115660d4eae6a$var$weakMapHas);
        try {
            $533115660d4eae6a$var$weakSetHas.call(x, $533115660d4eae6a$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $533115660d4eae6a$var$isWeakRef(x) {
    if (!$533115660d4eae6a$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $533115660d4eae6a$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $533115660d4eae6a$var$isSet(x) {
    if (!$533115660d4eae6a$var$setSize || !x || typeof x !== "object") return false;
    try {
        $533115660d4eae6a$var$setSize.call(x);
        try {
            $533115660d4eae6a$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $533115660d4eae6a$var$isWeakSet(x) {
    if (!$533115660d4eae6a$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $533115660d4eae6a$var$weakSetHas.call(x, $533115660d4eae6a$var$weakSetHas);
        try {
            $533115660d4eae6a$var$weakMapHas.call(x, $533115660d4eae6a$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $533115660d4eae6a$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $533115660d4eae6a$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $533115660d4eae6a$var$inspectString($533115660d4eae6a$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $533115660d4eae6a$var$$replace.call($533115660d4eae6a$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $533115660d4eae6a$var$lowbyte);
    return $533115660d4eae6a$var$wrapQuotes(s, "single", opts);
}
function $533115660d4eae6a$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $533115660d4eae6a$var$$toUpperCase.call(n.toString(16));
}
function $533115660d4eae6a$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $533115660d4eae6a$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $533115660d4eae6a$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $533115660d4eae6a$var$indentedJoin(entries, indent) : $533115660d4eae6a$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $533115660d4eae6a$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($533115660d4eae6a$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $533115660d4eae6a$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $533115660d4eae6a$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $533115660d4eae6a$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $533115660d4eae6a$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $533115660d4eae6a$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $533115660d4eae6a$var$arrObjKeys(obj, inspect) {
    var isArr = $533115660d4eae6a$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $533115660d4eae6a$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $533115660d4eae6a$var$gOPS === "function" ? $533115660d4eae6a$var$gOPS(obj) : [];
    var symMap;
    if ($533115660d4eae6a$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$533115660d4eae6a$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($533115660d4eae6a$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($533115660d4eae6a$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $533115660d4eae6a$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($533115660d4eae6a$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}



var $RHWZq = parcelRequire("RHWZq");
var $99a7b2b2885c9d6d$var$$WeakMap = $6azwx("%WeakMap%", true);
var $99a7b2b2885c9d6d$var$$Map = $6azwx("%Map%", true);
var $99a7b2b2885c9d6d$var$$weakMapGet = $c8d994c9e3459f9e$exports("WeakMap.prototype.get", true);
var $99a7b2b2885c9d6d$var$$weakMapSet = $c8d994c9e3459f9e$exports("WeakMap.prototype.set", true);
var $99a7b2b2885c9d6d$var$$weakMapHas = $c8d994c9e3459f9e$exports("WeakMap.prototype.has", true);
var $99a7b2b2885c9d6d$var$$mapGet = $c8d994c9e3459f9e$exports("Map.prototype.get", true);
var $99a7b2b2885c9d6d$var$$mapSet = $c8d994c9e3459f9e$exports("Map.prototype.set", true);
var $99a7b2b2885c9d6d$var$$mapHas = $c8d994c9e3459f9e$exports("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $99a7b2b2885c9d6d$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $99a7b2b2885c9d6d$var$listGet = function(objects, key) {
    var node = $99a7b2b2885c9d6d$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $99a7b2b2885c9d6d$var$listSet = function(objects, key, value) {
    var node = $99a7b2b2885c9d6d$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $99a7b2b2885c9d6d$var$listHas = function(objects, key) {
    return !!$99a7b2b2885c9d6d$var$listGetNode(objects, key);
};
/** @type {import('.')} */ $99a7b2b2885c9d6d$exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $RHWZq("Side channel does not contain " + $533115660d4eae6a$exports(key));
        },
        get: function(key) {
            if ($99a7b2b2885c9d6d$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $99a7b2b2885c9d6d$var$$weakMapGet($wm, key);
            } else if ($99a7b2b2885c9d6d$var$$Map) {
                if ($m) return $99a7b2b2885c9d6d$var$$mapGet($m, key);
            } else {
                if ($o) return $99a7b2b2885c9d6d$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($99a7b2b2885c9d6d$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $99a7b2b2885c9d6d$var$$weakMapHas($wm, key);
            } else if ($99a7b2b2885c9d6d$var$$Map) {
                if ($m) return $99a7b2b2885c9d6d$var$$mapHas($m, key);
            } else {
                if ($o) return $99a7b2b2885c9d6d$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($99a7b2b2885c9d6d$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $99a7b2b2885c9d6d$var$$WeakMap();
                $99a7b2b2885c9d6d$var$$weakMapSet($wm, key, value);
            } else if ($99a7b2b2885c9d6d$var$$Map) {
                if (!$m) $m = new $99a7b2b2885c9d6d$var$$Map();
                $99a7b2b2885c9d6d$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $99a7b2b2885c9d6d$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};


var $1dfb587a5082c46f$exports = {};
"use strict";
var $6bb6d14fe1e22731$exports = {};
"use strict";
var $6bb6d14fe1e22731$var$replace = String.prototype.replace;
var $6bb6d14fe1e22731$var$percentTwenties = /%20/g;
var $6bb6d14fe1e22731$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$6bb6d14fe1e22731$exports = {
    "default": $6bb6d14fe1e22731$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $6bb6d14fe1e22731$var$replace.call(value, $6bb6d14fe1e22731$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $6bb6d14fe1e22731$var$Format.RFC1738,
    RFC3986: $6bb6d14fe1e22731$var$Format.RFC3986
};


var $1dfb587a5082c46f$var$has = Object.prototype.hasOwnProperty;
var $1dfb587a5082c46f$var$isArray = Array.isArray;
var $1dfb587a5082c46f$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $1dfb587a5082c46f$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($1dfb587a5082c46f$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $1dfb587a5082c46f$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $1dfb587a5082c46f$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($1dfb587a5082c46f$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$1dfb587a5082c46f$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($1dfb587a5082c46f$var$isArray(target) && !$1dfb587a5082c46f$var$isArray(source)) mergeTarget = $1dfb587a5082c46f$var$arrayToObject(target, options);
    if ($1dfb587a5082c46f$var$isArray(target) && $1dfb587a5082c46f$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($1dfb587a5082c46f$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($1dfb587a5082c46f$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $1dfb587a5082c46f$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $1dfb587a5082c46f$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $1dfb587a5082c46f$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $1dfb587a5082c46f$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $1dfb587a5082c46f$var$limit){
        var segment = string.length >= $1dfb587a5082c46f$var$limit ? string.slice(j, j + $1dfb587a5082c46f$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $6bb6d14fe1e22731$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $1dfb587a5082c46f$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $1dfb587a5082c46f$var$hexTable[0xC0 | c >> 6] + $1dfb587a5082c46f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $1dfb587a5082c46f$var$hexTable[0xE0 | c >> 12] + $1dfb587a5082c46f$var$hexTable[0x80 | c >> 6 & 0x3F] + $1dfb587a5082c46f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $1dfb587a5082c46f$var$hexTable[0xF0 | c >> 18] + $1dfb587a5082c46f$var$hexTable[0x80 | c >> 12 & 0x3F] + $1dfb587a5082c46f$var$hexTable[0x80 | c >> 6 & 0x3F] + $1dfb587a5082c46f$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $1dfb587a5082c46f$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $1dfb587a5082c46f$var$compactQueue(queue);
    return value;
};
var $1dfb587a5082c46f$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $1dfb587a5082c46f$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $1dfb587a5082c46f$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $1dfb587a5082c46f$var$maybeMap = function maybeMap(val, fn) {
    if ($1dfb587a5082c46f$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$1dfb587a5082c46f$exports = {
    arrayToObject: $1dfb587a5082c46f$var$arrayToObject,
    assign: $1dfb587a5082c46f$var$assign,
    combine: $1dfb587a5082c46f$var$combine,
    compact: $1dfb587a5082c46f$var$compact,
    decode: $1dfb587a5082c46f$var$decode,
    encode: $1dfb587a5082c46f$var$encode,
    isBuffer: $1dfb587a5082c46f$var$isBuffer,
    isRegExp: $1dfb587a5082c46f$var$isRegExp,
    maybeMap: $1dfb587a5082c46f$var$maybeMap,
    merge: $1dfb587a5082c46f$var$merge
};



var $a22047d7fbc233ac$var$has = Object.prototype.hasOwnProperty;
var $a22047d7fbc233ac$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $a22047d7fbc233ac$var$isArray = Array.isArray;
var $a22047d7fbc233ac$var$push = Array.prototype.push;
var $a22047d7fbc233ac$var$pushToArray = function(arr, valueOrArray) {
    $a22047d7fbc233ac$var$push.apply(arr, $a22047d7fbc233ac$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $a22047d7fbc233ac$var$toISO = Date.prototype.toISOString;
var $a22047d7fbc233ac$var$defaultFormat = $6bb6d14fe1e22731$exports.default;
var $a22047d7fbc233ac$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $1dfb587a5082c46f$exports.encode,
    encodeValuesOnly: false,
    format: $a22047d7fbc233ac$var$defaultFormat,
    formatter: $6bb6d14fe1e22731$exports.formatters[$a22047d7fbc233ac$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $a22047d7fbc233ac$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $a22047d7fbc233ac$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $a22047d7fbc233ac$var$sentinel = {};
var $a22047d7fbc233ac$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($a22047d7fbc233ac$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($a22047d7fbc233ac$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $a22047d7fbc233ac$var$isArray(obj)) obj = $1dfb587a5082c46f$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $a22047d7fbc233ac$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($a22047d7fbc233ac$var$isNonNullishPrimitive(obj) || $1dfb587a5082c46f$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $a22047d7fbc233ac$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $a22047d7fbc233ac$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $a22047d7fbc233ac$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $1dfb587a5082c46f$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($a22047d7fbc233ac$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $a22047d7fbc233ac$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $a22047d7fbc233ac$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $a22047d7fbc233ac$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $99a7b2b2885c9d6d$exports();
        valueSideChannel.set($a22047d7fbc233ac$var$sentinel, sideChannel);
        $a22047d7fbc233ac$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $a22047d7fbc233ac$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $a22047d7fbc233ac$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $a22047d7fbc233ac$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $a22047d7fbc233ac$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $6bb6d14fe1e22731$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$a22047d7fbc233ac$var$has.call($6bb6d14fe1e22731$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $6bb6d14fe1e22731$exports.formatters[format];
    var filter = $a22047d7fbc233ac$var$defaults.filter;
    if (typeof opts.filter === "function" || $a22047d7fbc233ac$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $a22047d7fbc233ac$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $a22047d7fbc233ac$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $a22047d7fbc233ac$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $a22047d7fbc233ac$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $a22047d7fbc233ac$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $a22047d7fbc233ac$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $a22047d7fbc233ac$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $a22047d7fbc233ac$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $a22047d7fbc233ac$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $a22047d7fbc233ac$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $a22047d7fbc233ac$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $a22047d7fbc233ac$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $a22047d7fbc233ac$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $a22047d7fbc233ac$var$defaults.strictNullHandling
    };
};
$a22047d7fbc233ac$exports = function(object, opts) {
    var obj = object;
    var options = $a22047d7fbc233ac$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($a22047d7fbc233ac$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $a22047d7fbc233ac$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $99a7b2b2885c9d6d$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $a22047d7fbc233ac$var$pushToArray(keys, $a22047d7fbc233ac$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $481dcc10abb5c313$exports = {};
"use strict";

var $481dcc10abb5c313$var$has = Object.prototype.hasOwnProperty;
var $481dcc10abb5c313$var$isArray = Array.isArray;
var $481dcc10abb5c313$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $1dfb587a5082c46f$exports.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $481dcc10abb5c313$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $481dcc10abb5c313$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $481dcc10abb5c313$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $481dcc10abb5c313$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $481dcc10abb5c313$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $481dcc10abb5c313$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $481dcc10abb5c313$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $481dcc10abb5c313$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $481dcc10abb5c313$var$defaults.decoder, charset, "key");
            val = $1dfb587a5082c46f$exports.maybeMap($481dcc10abb5c313$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $481dcc10abb5c313$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $481dcc10abb5c313$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $481dcc10abb5c313$var$isArray(val) ? [
            val
        ] : val;
        var existing = $481dcc10abb5c313$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $1dfb587a5082c46f$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $481dcc10abb5c313$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $481dcc10abb5c313$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $481dcc10abb5c313$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $481dcc10abb5c313$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $481dcc10abb5c313$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $481dcc10abb5c313$var$parseObject(keys, val, options, valuesParsed);
};
var $481dcc10abb5c313$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $481dcc10abb5c313$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $481dcc10abb5c313$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $481dcc10abb5c313$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $481dcc10abb5c313$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $481dcc10abb5c313$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $481dcc10abb5c313$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $481dcc10abb5c313$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $481dcc10abb5c313$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $481dcc10abb5c313$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $481dcc10abb5c313$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $481dcc10abb5c313$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $481dcc10abb5c313$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $1dfb587a5082c46f$exports.isRegExp(opts.delimiter) ? opts.delimiter : $481dcc10abb5c313$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $481dcc10abb5c313$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $481dcc10abb5c313$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $481dcc10abb5c313$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $481dcc10abb5c313$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $481dcc10abb5c313$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $481dcc10abb5c313$var$defaults.strictNullHandling
    };
};
$481dcc10abb5c313$exports = function(str, opts) {
    var options = $481dcc10abb5c313$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $481dcc10abb5c313$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $481dcc10abb5c313$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $1dfb587a5082c46f$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $1dfb587a5082c46f$exports.compact(obj);
};



$0200172ea6ee8917$exports = {
    formats: $6bb6d14fe1e22731$exports,
    parse: $481dcc10abb5c313$exports,
    stringify: $a22047d7fbc233ac$exports
};


var $dfddb7c99ff13074$exports = {};
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $dfddb7c99ff13074$var$stringTag = "[object String]";
/** Used for built-in method references. */ var $dfddb7c99ff13074$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dfddb7c99ff13074$var$objectToString = $dfddb7c99ff13074$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $dfddb7c99ff13074$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $dfddb7c99ff13074$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $dfddb7c99ff13074$var$isString(value) {
    return typeof value == "string" || !$dfddb7c99ff13074$var$isArray(value) && $dfddb7c99ff13074$var$isObjectLike(value) && $dfddb7c99ff13074$var$objectToString.call(value) == $dfddb7c99ff13074$var$stringTag;
}
$dfddb7c99ff13074$exports = $dfddb7c99ff13074$var$isString;


var $c6cef168aa5d5637$exports = {};
"use strict";
class $c6cef168aa5d5637$var$AbortError extends Error {
    constructor(){
        super("Throttled function aborted");
        this.name = "AbortError";
    }
}
const $c6cef168aa5d5637$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError("Expected `limit` to be a finite number");
    if (!Number.isFinite(interval)) throw new TypeError("Expected `interval` to be a finite number");
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $c6cef168aa5d5637$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
$c6cef168aa5d5637$exports = $c6cef168aa5d5637$var$pThrottle;
$c6cef168aa5d5637$exports.AbortError = $c6cef168aa5d5637$var$AbortError;


var $474f2c52e99c0e96$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $474f2c52e99c0e96$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $474f2c52e99c0e96$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $474f2c52e99c0e96$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $474f2c52e99c0e96$var$funcProto = Function.prototype, $474f2c52e99c0e96$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $474f2c52e99c0e96$var$funcToString = $474f2c52e99c0e96$var$funcProto.toString;
/** Used to check objects for own properties. */ var $474f2c52e99c0e96$var$hasOwnProperty = $474f2c52e99c0e96$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $474f2c52e99c0e96$var$objectCtorString = $474f2c52e99c0e96$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $474f2c52e99c0e96$var$objectToString = $474f2c52e99c0e96$var$objectProto.toString;
/** Built-in value references. */ var $474f2c52e99c0e96$var$getPrototype = $474f2c52e99c0e96$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $474f2c52e99c0e96$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $474f2c52e99c0e96$var$isPlainObject(value) {
    if (!$474f2c52e99c0e96$var$isObjectLike(value) || $474f2c52e99c0e96$var$objectToString.call(value) != $474f2c52e99c0e96$var$objectTag || $474f2c52e99c0e96$var$isHostObject(value)) return false;
    var proto = $474f2c52e99c0e96$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $474f2c52e99c0e96$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $474f2c52e99c0e96$var$funcToString.call(Ctor) == $474f2c52e99c0e96$var$objectCtorString;
}
$474f2c52e99c0e96$exports = $474f2c52e99c0e96$var$isPlainObject;



function $3c72d7d74cd67182$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3c72d7d74cd67182$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $3c72d7d74cd67182$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $3c72d7d74cd67182$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $3c72d7d74cd67182$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $3c72d7d74cd67182$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $3c72d7d74cd67182$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3c72d7d74cd67182$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = !0, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3c72d7d74cd67182$var$_defineProperty(e, r, t) {
    return (r = $3c72d7d74cd67182$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3c72d7d74cd67182$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $3c72d7d74cd67182$var$_setPrototypeOf(t, e);
}
function $3c72d7d74cd67182$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3c72d7d74cd67182$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3c72d7d74cd67182$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c72d7d74cd67182$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c72d7d74cd67182$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3c72d7d74cd67182$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c72d7d74cd67182$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c72d7d74cd67182$var$_regeneratorRuntime() {
    $3c72d7d74cd67182$var$_regeneratorRuntime = function() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(typeof e + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $3c72d7d74cd67182$var$_setPrototypeOf(t, e) {
    return $3c72d7d74cd67182$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3c72d7d74cd67182$var$_setPrototypeOf(t, e);
}
function $3c72d7d74cd67182$var$_slicedToArray(r, e) {
    return $3c72d7d74cd67182$var$_arrayWithHoles(r) || $3c72d7d74cd67182$var$_iterableToArrayLimit(r, e) || $3c72d7d74cd67182$var$_unsupportedIterableToArray(r, e) || $3c72d7d74cd67182$var$_nonIterableRest();
}
function $3c72d7d74cd67182$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3c72d7d74cd67182$var$_toPropertyKey(t) {
    var i = $3c72d7d74cd67182$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3c72d7d74cd67182$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3c72d7d74cd67182$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3c72d7d74cd67182$var$_typeof(o);
}
function $3c72d7d74cd67182$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3c72d7d74cd67182$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3c72d7d74cd67182$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3c72d7d74cd67182$var$_wrapRegExp() {
    $3c72d7d74cd67182$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $3c72d7d74cd67182$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $3c72d7d74cd67182$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $3c72d7d74cd67182$var$_wrapRegExp.apply(this, arguments);
}
function $3c72d7d74cd67182$var$asyncToken(instance, getToken) {
    instance.interceptors.request.use(function(config) {
        return getToken().then(function(accessToken) {
            config.headers.set("Authorization", "Bearer ".concat(accessToken));
            return config;
        });
    });
}
function $3c72d7d74cd67182$var$isNode() {
    /**
   * Polyfills of 'process' might set process.browser === true
   *
   * See:
   * https://github.com/webpack/node-libs-browser/blob/master/mock/process.js#L8
   * https://github.com/defunctzombie/node-process/blob/master/browser.js#L156
   **/ return typeof $26305657c8dadcb2$exports !== "undefined" && false;
}
function $3c72d7d74cd67182$var$isReactNative() {
    return typeof window !== "undefined" && "navigator" in window && "product" in window.navigator && window.navigator.product === "ReactNative";
}
function $3c72d7d74cd67182$var$getNodeVersion() {
    return $26305657c8dadcb2$exports.versions && $26305657c8dadcb2$exports.versions.node ? "v".concat($26305657c8dadcb2$exports.versions.node) : $26305657c8dadcb2$exports.version;
}
function $3c72d7d74cd67182$var$getWindow() {
    return window;
}
function $3c72d7d74cd67182$var$noop() {
    return undefined;
}
var $3c72d7d74cd67182$var$delay = function delay(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $3c72d7d74cd67182$var$defaultWait = function defaultWait(attempts) {
    return Math.pow(Math.SQRT2, attempts);
};
function $3c72d7d74cd67182$var$rateLimit(instance) {
    var maxRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    var _instance$defaults = instance.defaults, _instance$defaults$re = _instance$defaults.responseLogger, responseLogger = _instance$defaults$re === void 0 ? $3c72d7d74cd67182$var$noop : _instance$defaults$re, _instance$defaults$re2 = _instance$defaults.requestLogger, requestLogger = _instance$defaults$re2 === void 0 ? $3c72d7d74cd67182$var$noop : _instance$defaults$re2;
    instance.interceptors.request.use(function(config) {
        requestLogger(config);
        return config;
    }, function(error) {
        requestLogger(error);
        return Promise.reject(error);
    });
    instance.interceptors.response.use(function(response) {
        // we don't need to do anything here
        responseLogger(response);
        return response;
    }, /*#__PURE__*/ function() {
        var _ref = $3c72d7d74cd67182$var$_asyncToGenerator(/*#__PURE__*/ $3c72d7d74cd67182$var$_regeneratorRuntime().mark(function _callee(error) {
            var response, config, doneAttempts, retryErrorType, wait;
            return $3c72d7d74cd67182$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        response = error.response;
                        config = error.config;
                        responseLogger(error);
                        // Do not retry if it is disabled or no request config exists (not an axios error)
                        if (!(!config || !instance.defaults.retryOnError)) {
                            _context.next = 5;
                            break;
                        }
                        return _context.abrupt("return", Promise.reject(error));
                    case 5:
                        // Retried already for max attempts
                        doneAttempts = config.attempts || 1;
                        if (!(doneAttempts > maxRetry)) {
                            _context.next = 9;
                            break;
                        }
                        error.attempts = config.attempts;
                        return _context.abrupt("return", Promise.reject(error));
                    case 9:
                        retryErrorType = null;
                        wait = $3c72d7d74cd67182$var$defaultWait(doneAttempts); // Errors without response did not receive anything from the server
                        if (!response) retryErrorType = "Connection";
                        else if (response.status >= 500 && response.status < 600) // 5** errors are server related
                        retryErrorType = "Server ".concat(response.status);
                        else if (response.status === 429) {
                            // 429 errors are exceeded rate limit exceptions
                            retryErrorType = "Rate limit";
                            // all headers are lowercased by axios https://github.com/mzabriskie/axios/issues/413
                            if (response.headers && error.response.headers["x-contentful-ratelimit-reset"]) wait = response.headers["x-contentful-ratelimit-reset"];
                        }
                        if (!retryErrorType) {
                            _context.next = 19;
                            break;
                        }
                        // convert to ms and add jitter
                        wait = Math.floor(wait * 1000 + Math.random() * 200 + 500);
                        instance.defaults.logHandler("warning", "".concat(retryErrorType, " error occurred. Waiting for ").concat(wait, " ms before retrying..."));
                        // increase attempts counter
                        config.attempts = doneAttempts + 1;
                        /* Somehow between the interceptor and retrying the request the httpAgent/httpsAgent gets transformed from an Agent-like object
             to a regular object, causing failures on retries after rate limits. Removing these properties here fixes the error, but retry
             requests still use the original http/httpsAgent property */ delete config.httpAgent;
                        delete config.httpsAgent;
                        return _context.abrupt("return", $3c72d7d74cd67182$var$delay(wait).then(function() {
                            return instance(config);
                        }));
                    case 19:
                        return _context.abrupt("return", Promise.reject(error));
                    case 20:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }());
}
var $3c72d7d74cd67182$var$PERCENTAGE_REGEX = /*#__PURE__*/ $3c72d7d74cd67182$var$_wrapRegExp(/(\d+)(%)/, {
    value: 1
});
function $3c72d7d74cd67182$var$calculateLimit(type) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
    var limit = max;
    if ($3c72d7d74cd67182$var$PERCENTAGE_REGEX.test(type)) {
        var _type$match;
        var groups = (_type$match = type.match($3c72d7d74cd67182$var$PERCENTAGE_REGEX)) === null || _type$match === void 0 ? void 0 : _type$match.groups;
        if (groups && groups.value) {
            var percentage = parseInt(groups.value) / 100;
            limit = Math.round(max * percentage);
        }
    }
    return Math.min(30, Math.max(1, limit));
}
function $3c72d7d74cd67182$var$createThrottle(limit, logger) {
    logger("info", "Throttle request to ".concat(limit, "/s"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($c6cef168aa5d5637$exports)))({
        limit: limit,
        interval: 1000,
        strict: false
    });
}
var $3c72d7d74cd67182$var$rateLimitThrottle = function(axiosInstance) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
    var _axiosInstance$defaul = axiosInstance.defaults.logHandler, logHandler = _axiosInstance$defaul === void 0 ? $3c72d7d74cd67182$var$noop : _axiosInstance$defaul;
    var limit = (0, (/*@__PURE__*/$parcel$interopDefault($dfddb7c99ff13074$exports)))(type) ? $3c72d7d74cd67182$var$calculateLimit(type) : $3c72d7d74cd67182$var$calculateLimit("auto", type);
    var throttle = $3c72d7d74cd67182$var$createThrottle(limit, logHandler);
    var isCalculated = false;
    var requestInterceptorId = axiosInstance.interceptors.request.use(function(config) {
        return throttle(function() {
            return config;
        })();
    }, function(error) {
        return Promise.reject(error);
    });
    var responseInterceptorId = axiosInstance.interceptors.response.use(function(response) {
        if (!isCalculated && (0, (/*@__PURE__*/$parcel$interopDefault($dfddb7c99ff13074$exports)))(type) && (type === "auto" || $3c72d7d74cd67182$var$PERCENTAGE_REGEX.test(type)) && response.headers && response.headers["x-contentful-ratelimit-second-limit"]) {
            var rawLimit = parseInt(response.headers["x-contentful-ratelimit-second-limit"]);
            var nextLimit = $3c72d7d74cd67182$var$calculateLimit(type, rawLimit);
            if (nextLimit !== limit) {
                if (requestInterceptorId) axiosInstance.interceptors.request.eject(requestInterceptorId);
                limit = nextLimit;
                throttle = $3c72d7d74cd67182$var$createThrottle(nextLimit, logHandler);
                requestInterceptorId = axiosInstance.interceptors.request.use(function(config) {
                    return throttle(function() {
                        return config;
                    })();
                }, function(error) {
                    return Promise.reject(error);
                });
            }
            isCalculated = true;
        }
        return response;
    }, function(error) {
        return Promise.reject(error);
    });
    return function() {
        axiosInstance.interceptors.request.eject(requestInterceptorId);
        axiosInstance.interceptors.response.eject(responseInterceptorId);
    };
};
// Matches 'sub.host:port' or 'host:port' and extracts hostname and port
// Also enforces toplevel domain specified, no spaces and no protocol
var $3c72d7d74cd67182$var$HOST_REGEX = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
/**
 * Create pre-configured axios instance
 * @private
 * @param {AxiosStatic} axios - Axios library
 * @param {CreateHttpClientParams} options - Initialization parameters for the HTTP client
 * @return {AxiosInstance} Initialized axios instance
 */ function $3c72d7d74cd67182$export$5ff1805767bd358a(axios, options) {
    var defaultConfig = {
        insecure: false,
        retryOnError: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logHandler: function logHandler(level, data) {
            if (level === "error" && data) {
                var title = [
                    data.name,
                    data.message
                ].filter(function(a) {
                    return a;
                }).join(" - ");
                console.error("[error] ".concat(title));
                console.error(data);
                return;
            }
            console.log("[".concat(level, "] ").concat(data));
        },
        // Passed to axios
        headers: {},
        httpAgent: false,
        httpsAgent: false,
        timeout: 30000,
        throttle: 0,
        basePath: "",
        adapter: undefined,
        maxContentLength: 1073741824,
        // 1GB
        maxBodyLength: 1073741824 // 1GB
    };
    var config = $3c72d7d74cd67182$var$_objectSpread2($3c72d7d74cd67182$var$_objectSpread2({}, defaultConfig), options);
    if (!config.accessToken) {
        var missingAccessTokenError = new TypeError("Expected parameter accessToken");
        config.logHandler("error", missingAccessTokenError);
        throw missingAccessTokenError;
    }
    // Construct axios baseURL option
    var protocol = config.insecure ? "http" : "https";
    var space = config.space ? "".concat(config.space, "/") : "";
    var hostname = config.defaultHostname;
    var port = config.insecure ? 80 : 443;
    if (config.host && $3c72d7d74cd67182$var$HOST_REGEX.test(config.host)) {
        var parsed = config.host.split(":");
        if (parsed.length === 2) {
            var _parsed = $3c72d7d74cd67182$var$_slicedToArray(parsed, 2);
            hostname = _parsed[0];
            port = _parsed[1];
        } else hostname = parsed[0];
    }
    // Ensure that basePath does start but not end with a slash
    if (config.basePath) config.basePath = "/".concat(config.basePath.split("/").filter(Boolean).join("/"));
    var baseURL = options.baseURL || "".concat(protocol, "://").concat(hostname, ":").concat(port).concat(config.basePath, "/spaces/").concat(space);
    if (!config.headers.Authorization && typeof config.accessToken !== "function") config.headers.Authorization = "Bearer " + config.accessToken;
    var axiosOptions = {
        // Axios
        baseURL: baseURL,
        headers: config.headers,
        httpAgent: config.httpAgent,
        httpsAgent: config.httpsAgent,
        proxy: config.proxy,
        timeout: config.timeout,
        adapter: config.adapter,
        maxContentLength: config.maxContentLength,
        maxBodyLength: config.maxBodyLength,
        paramsSerializer: {
            serialize: function serialize(params) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($0200172ea6ee8917$exports))).stringify(params);
            }
        },
        // Contentful
        logHandler: config.logHandler,
        responseLogger: config.responseLogger,
        requestLogger: config.requestLogger,
        retryOnError: config.retryOnError
    };
    var instance = axios.create(axiosOptions);
    instance.httpClientParams = options;
    /**
   * Creates a new axios instance with the same default base parameters as the
   * current one, and with any overrides passed to the newParams object
   * This is useful as the SDKs use dependency injection to get the axios library
   * and the version of the library comes from different places depending
   * on whether it's a browser build or a node.js build.
   * @private
   * @param {CreateHttpClientParams} newParams - Initialization parameters for the HTTP client
   * @return {AxiosInstance} Initialized axios instance
   */ instance.cloneWithNewParams = function(newParams) {
        return $3c72d7d74cd67182$export$5ff1805767bd358a(axios, $3c72d7d74cd67182$var$_objectSpread2($3c72d7d74cd67182$var$_objectSpread2({}, (0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(options)), newParams));
    };
    /**
   * Apply interceptors.
   * Please note that the order of interceptors is important
   */ if (config.onBeforeRequest) instance.interceptors.request.use(config.onBeforeRequest);
    if (typeof config.accessToken === "function") $3c72d7d74cd67182$var$asyncToken(instance, config.accessToken);
    if (config.throttle) $3c72d7d74cd67182$var$rateLimitThrottle(instance, config.throttle);
    $3c72d7d74cd67182$var$rateLimit(instance, config.retryLimit);
    if (config.onError) instance.interceptors.response.use(function(response) {
        return response;
    }, config.onError);
    return instance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Creates request parameters configuration by parsing an existing query object
 * @private
 * @param {Object} query
 * @return {Object} Config object with `params` property, ready to be used in axios
 */ function $3c72d7d74cd67182$export$b9eda6f1d11bafa2(_ref) {
    var query = _ref.query;
    var config = {};
    delete query.resolveLinks;
    config.params = (0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(query);
    return config;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3c72d7d74cd67182$export$2d463bb1e491631d(obj, path) {
    if (!(path in obj)) {
        var err = new Error();
        err.name = "PropertyMissing";
        err.message = "Required property ".concat(path, " missing from:\n\n").concat(JSON.stringify(obj), "\n\n");
        throw err;
    }
    return true;
}
// copied from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
function $3c72d7d74cd67182$var$deepFreeze(object) {
    var propNames = Object.getOwnPropertyNames(object);
    var _iterator = $3c72d7d74cd67182$var$_createForOfIteratorHelper(propNames), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var name = _step.value;
            var value = object[name];
            if (value && $3c72d7d74cd67182$var$_typeof(value) === "object") $3c72d7d74cd67182$var$deepFreeze(value);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return Object.freeze(object);
}
function $3c72d7d74cd67182$export$5f59ea1ba3499740(obj) {
    $3c72d7d74cd67182$var$deepFreeze(obj.sys || {});
    return obj;
}
function $3c72d7d74cd67182$var$getBrowserOS() {
    var win = $3c72d7d74cd67182$var$getWindow();
    if (!win) return null;
    var userAgent = win.navigator.userAgent;
    // TODO: platform is deprecated.
    var platform = win.navigator.platform;
    var macosPlatforms = [
        "Macintosh",
        "MacIntel",
        "MacPPC",
        "Mac68K"
    ];
    var windowsPlatforms = [
        "Win32",
        "Win64",
        "Windows",
        "WinCE"
    ];
    var iosPlatforms = [
        "iPhone",
        "iPad",
        "iPod"
    ];
    if (macosPlatforms.indexOf(platform) !== -1) return "macOS";
    else if (iosPlatforms.indexOf(platform) !== -1) return "iOS";
    else if (windowsPlatforms.indexOf(platform) !== -1) return "Windows";
    else if (/Android/.test(userAgent)) return "Android";
    else if (/Linux/.test(platform)) return "Linux";
    return null;
}
function $3c72d7d74cd67182$var$getNodeOS() {
    var platform = $26305657c8dadcb2$exports.platform || "linux";
    var version = $26305657c8dadcb2$exports.version || "0.0.0";
    var platformMap = {
        android: "Android",
        aix: "Linux",
        darwin: "macOS",
        freebsd: "Linux",
        linux: "Linux",
        openbsd: "Linux",
        sunos: "Linux",
        win32: "Windows"
    };
    if (platform in platformMap) return "".concat(platformMap[platform] || "Linux", "/").concat(version);
    return null;
}
function $3c72d7d74cd67182$export$56c7340f89ca57c5(sdk, application, integration, feature) {
    var headerParts = [];
    if (application) headerParts.push("app ".concat(application));
    if (integration) headerParts.push("integration ".concat(integration));
    if (feature) headerParts.push("feature " + feature);
    headerParts.push("sdk ".concat(sdk));
    var platform = null;
    try {
        if ($3c72d7d74cd67182$var$isReactNative()) {
            platform = $3c72d7d74cd67182$var$getBrowserOS();
            headerParts.push("platform ReactNative");
        } else if ($3c72d7d74cd67182$var$isNode()) {
            platform = $3c72d7d74cd67182$var$getNodeOS();
            headerParts.push("platform node.js/".concat($3c72d7d74cd67182$var$getNodeVersion()));
        } else {
            platform = $3c72d7d74cd67182$var$getBrowserOS();
            headerParts.push("platform browser");
        }
    } catch (e) {
        platform = null;
    }
    if (platform) headerParts.push("os ".concat(platform));
    return "".concat(headerParts.filter(function(item) {
        return item !== "";
    }).join("; "), ";");
}
/**
 * Mixes in a method to return just a plain object with no additional methods
 * @private
 * @param data - Any plain JSON response returned from the API
 * @return Enhanced object with toPlainObject method
 */ function $3c72d7d74cd67182$export$8530f7b85295aab2(data) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return Object.defineProperty(data, "toPlainObject", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function value() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(this);
        }
    });
}
/**
 * Handles errors received from the server. Parses the error into a more useful
 * format, places it in an exception and throws it.
 * See https://www.contentful.com/developers/docs/references/errors/
 * for more details on the data received on the errorResponse.data property
 * and the expected error codes.
 * @private
 */ function $3c72d7d74cd67182$export$cc3fdd528b56c4a9(errorResponse) {
    var config = errorResponse.config, response = errorResponse.response;
    var errorName;
    // Obscure the Management token
    if (config && config.headers && config.headers["Authorization"]) {
        var token = "...".concat(config.headers["Authorization"].toString().substr(-5));
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($474f2c52e99c0e96$exports)))(response) || !(0, (/*@__PURE__*/$parcel$interopDefault($474f2c52e99c0e96$exports)))(config)) throw errorResponse;
    var data = response === null || response === void 0 ? void 0 : response.data;
    var errorData = {
        status: response === null || response === void 0 ? void 0 : response.status,
        statusText: response === null || response === void 0 ? void 0 : response.statusText,
        message: "",
        details: {}
    };
    if (config && (0, (/*@__PURE__*/$parcel$interopDefault($474f2c52e99c0e96$exports)))(config)) errorData.request = {
        url: config.url,
        headers: config.headers,
        method: config.method,
        payloadData: config.data
    };
    if (data && $3c72d7d74cd67182$var$_typeof(data) === "object") {
        var _data$sys;
        if ("requestId" in data) errorData.requestId = data.requestId || "UNKNOWN";
        if ("message" in data) errorData.message = data.message || "";
        if ("details" in data) errorData.details = data.details || {};
        errorName = (_data$sys = data.sys) === null || _data$sys === void 0 ? void 0 : _data$sys.id;
    }
    var error = new Error();
    error.name = errorName && errorName !== "Unknown" ? errorName : "".concat(response === null || response === void 0 ? void 0 : response.status, " ").concat(response === null || response === void 0 ? void 0 : response.statusText);
    try {
        error.message = JSON.stringify(errorData, null, "  ");
    } catch (_unused) {
        var _errorData$message;
        error.message = (_errorData$message = errorData === null || errorData === void 0 ? void 0 : errorData.message) !== null && _errorData$message !== void 0 ? _errorData$message : "";
    }
    throw error;
}



var $1748b2ea35f1f1e8$exports = {};

$parcel$export($1748b2ea35f1f1e8$exports, "wrapSpace", () => $1748b2ea35f1f1e8$export$cb5ff1eae4996863);

function $1748b2ea35f1f1e8$export$cb5ff1eae4996863(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)(data));
}


var $469a9bd37e6fe0bd$exports = {};

$parcel$export($469a9bd37e6fe0bd$exports, "wrapEntry", () => $469a9bd37e6fe0bd$export$3c25ec50ddfd858c);
$parcel$export($469a9bd37e6fe0bd$exports, "wrapEntryCollection", () => $469a9bd37e6fe0bd$export$d5eecd09c78a1741);



var $3QoJP = parcelRequire("3QoJP");
function $5a076583a4828ac3$export$2e2bcd8739ae039(data) {
    return Object.defineProperty(data, "stringifySafe", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function() {
            let serializer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            let indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            return (0, (/*@__PURE__*/$parcel$interopDefault($3QoJP)))(this, serializer, indent, (key, value)=>{
                return {
                    sys: {
                        type: "Link",
                        linkType: "Entry",
                        id: value.sys.id,
                        circular: true
                    }
                };
            });
        }
    });
}



var $4e78154b8ff5834d$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $4e78154b8ff5834d$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
function $4e78154b8ff5834d$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $4e78154b8ff5834d$var$UNRESOLVED_LINK = {}; // unique object to avoid polyfill bloat using Symbol()
/**
 * isLink Function
 * Checks if the object has sys.type "Link"
 * @param object
 */ var $4e78154b8ff5834d$var$isLink = function isLink(object) {
    return object && object.sys && object.sys.type === "Link";
};
/**
 * isResourceLink Function
 * Checks if the object has sys.type "ResourceLink"
 * @param object
 */ var $4e78154b8ff5834d$var$isResourceLink = function isResourceLink(object) {
    return object && object.sys && object.sys.type === "ResourceLink";
};
/**
 * Creates a key with spaceId and a key without for entityMap
 *
 * @param {*} sys
 * @param {String} sys.type
 * @param {String} sys.id
 * @param {*} sys.space
 * @param {*} sys.space.sys
 * @param {String} sys.space.id
 * @return {string[]}
 */ var $4e78154b8ff5834d$var$makeEntityMapKeys = function makeEntityMapKeys(sys) {
    if (sys.space && sys.environment) return [
        sys.type + "!" + sys.id,
        sys.space.sys.id + "!" + sys.environment.sys.id + "!" + sys.type + "!" + sys.id
    ];
    return [
        sys.type + "!" + sys.id
    ];
};
/**
 * Looks up in entityMap
 *
 * @param entityMap
 * @param {*} linkData
 * @param {String} linkData.type
 * @param {String} linkData.linkType
 * @param {String} linkData.id
 * @param {String} linkData.urn
 * @return {String}
 */ var $4e78154b8ff5834d$var$lookupInEntityMap = function lookupInEntityMap(entityMap, linkData) {
    var entryId = linkData.entryId, linkType = linkData.linkType, spaceId = linkData.spaceId, environmentId = linkData.environmentId;
    if (spaceId && environmentId) return entityMap.get(spaceId + "!" + environmentId + "!" + linkType + "!" + entryId);
    return entityMap.get(linkType + "!" + entryId);
};
var $4e78154b8ff5834d$var$getIdsFromUrn = function getIdsFromUrn(urn) {
    var regExp = /.*:spaces\/([^/]+)(?:\/environments\/([^/]+))?\/entries\/([^/]+)$/;
    if (!regExp.test(urn)) return undefined;
    var _urn$match = urn.match(regExp), _urn$match2 = $4e78154b8ff5834d$var$_slicedToArray(_urn$match, 4), _ = _urn$match2[0], spaceId = _urn$match2[1], _urn$match2$ = _urn$match2[2], environmentId = _urn$match2$ === undefined ? "master" : _urn$match2$, entryId = _urn$match2[3];
    return {
        spaceId: spaceId,
        environmentId: environmentId,
        entryId: entryId
    };
};
/**
 * getResolvedLink Function
 *
 * @param entityMap
 * @param link
 * @return {undefined}
 */ var $4e78154b8ff5834d$var$getResolvedLink = function getResolvedLink(entityMap, link) {
    var _link$sys = link.sys, type = _link$sys.type, linkType = _link$sys.linkType;
    if (type === "ResourceLink") {
        if (!linkType.startsWith("Contentful:")) return link;
        var urn = link.sys.urn;
        var _getIdsFromUrn = $4e78154b8ff5834d$var$getIdsFromUrn(urn), spaceId = _getIdsFromUrn.spaceId, environmentId = _getIdsFromUrn.environmentId, _entryId = _getIdsFromUrn.entryId;
        var extractedLinkType = linkType.split(":")[1];
        return $4e78154b8ff5834d$var$lookupInEntityMap(entityMap, {
            linkType: extractedLinkType,
            entryId: _entryId,
            spaceId: spaceId,
            environmentId: environmentId
        }) || $4e78154b8ff5834d$var$UNRESOLVED_LINK;
    }
    var entryId = link.sys.id;
    return $4e78154b8ff5834d$var$lookupInEntityMap(entityMap, {
        linkType: linkType,
        entryId: entryId
    }) || $4e78154b8ff5834d$var$UNRESOLVED_LINK;
};
/**
 * cleanUpLinks Function
 * - Removes unresolvable links from Arrays and Objects
 *
 * @param {Object[]|Object} input
 */ var $4e78154b8ff5834d$var$cleanUpLinks = function cleanUpLinks(input) {
    if (Array.isArray(input)) return input.filter(function(val) {
        return val !== $4e78154b8ff5834d$var$UNRESOLVED_LINK;
    });
    for(var key in input)if (input[key] === $4e78154b8ff5834d$var$UNRESOLVED_LINK) delete input[key];
    return input;
};
/**
 * walkMutate Function
 * @param input
 * @param predicate
 * @param mutator
 * @param removeUnresolved
 * @return {*}
 */ var $4e78154b8ff5834d$var$walkMutate = function walkMutate(input, predicate, mutator, removeUnresolved) {
    if (predicate(input)) return mutator(input);
    if (input && (typeof input === "undefined" ? "undefined" : $4e78154b8ff5834d$var$_typeof(input)) === "object") {
        for(var key in input)// eslint-disable-next-line no-prototype-builtins
        if (input.hasOwnProperty(key)) input[key] = walkMutate(input[key], predicate, mutator, removeUnresolved);
        if (removeUnresolved) input = $4e78154b8ff5834d$var$cleanUpLinks(input);
    }
    return input;
};
var $4e78154b8ff5834d$var$normalizeLink = function normalizeLink(entityMap, link, removeUnresolved) {
    var resolvedLink = $4e78154b8ff5834d$var$getResolvedLink(entityMap, link);
    if (resolvedLink === $4e78154b8ff5834d$var$UNRESOLVED_LINK) return removeUnresolved ? resolvedLink : link;
    return resolvedLink;
};
var $4e78154b8ff5834d$var$makeEntryObject = function makeEntryObject(item, itemEntryPoints) {
    if (!Array.isArray(itemEntryPoints)) return item;
    var entryPoints = Object.keys(item).filter(function(ownKey) {
        return itemEntryPoints.indexOf(ownKey) !== -1;
    });
    return entryPoints.reduce(function(entryObj, entryPoint) {
        entryObj[entryPoint] = item[entryPoint];
        return entryObj;
    }, {});
};
/**
 * resolveResponse Function
 * Resolves contentful response to normalized form.
 * @param {Object} response Contentful response
 * @param {{removeUnresolved: Boolean, itemEntryPoints: Array<String>}|{}} options
 * @param {Boolean} options.removeUnresolved - Remove unresolved links default:false
 * @param {Array<String>} options.itemEntryPoints - Resolve links only in those item properties
 * @return {Object}
 */ var $4e78154b8ff5834d$var$resolveResponse = function resolveResponse(response, options) {
    options = options || {};
    if (!response.items) return [];
    var responseClone = (0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(response);
    var allIncludes = Object.keys(responseClone.includes || {}).reduce(function(all, type) {
        return [].concat($4e78154b8ff5834d$var$_toConsumableArray(all), $4e78154b8ff5834d$var$_toConsumableArray(response.includes[type]));
    }, []);
    var allEntries = [].concat($4e78154b8ff5834d$var$_toConsumableArray(responseClone.items), $4e78154b8ff5834d$var$_toConsumableArray(allIncludes)).filter(function(entity) {
        return Boolean(entity.sys);
    });
    var entityMap = new Map(allEntries.reduce(function(acc, entity) {
        var entries = $4e78154b8ff5834d$var$makeEntityMapKeys(entity.sys).map(function(key) {
            return [
                key,
                entity
            ];
        });
        acc.push.apply(acc, $4e78154b8ff5834d$var$_toConsumableArray(entries));
        return acc;
    }, []));
    allEntries.forEach(function(item) {
        var entryObject = $4e78154b8ff5834d$var$makeEntryObject(item, options.itemEntryPoints);
        Object.assign(item, $4e78154b8ff5834d$var$walkMutate(entryObject, function(x) {
            return $4e78154b8ff5834d$var$isLink(x) || $4e78154b8ff5834d$var$isResourceLink(x);
        }, function(link) {
            return $4e78154b8ff5834d$var$normalizeLink(entityMap, link, options.removeUnresolved);
        }, options.removeUnresolved));
    });
    return responseClone.items;
};
var $4e78154b8ff5834d$export$2e2bcd8739ae039 = $4e78154b8ff5834d$var$resolveResponse;


function $469a9bd37e6fe0bd$export$3c25ec50ddfd858c(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}
function $469a9bd37e6fe0bd$export$d5eecd09c78a1741(data, _ref) {
    let { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = _ref;
    const wrappedData = (0, $5a076583a4828ac3$export$2e2bcd8739ae039)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
    if (resolveLinks) wrappedData.items = (0, $4e78154b8ff5834d$export$2e2bcd8739ae039)(wrappedData, {
        removeUnresolved: removeUnresolved,
        itemEntryPoints: [
            "fields"
        ]
    });
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)(wrappedData);
}


var $ea15c91cf36133ba$exports = {};

$parcel$export($ea15c91cf36133ba$exports, "wrapAsset", () => $ea15c91cf36133ba$export$a0be037962933a64);
$parcel$export($ea15c91cf36133ba$exports, "wrapAssetCollection", () => $ea15c91cf36133ba$export$703c04942b452817);


function $ea15c91cf36133ba$export$a0be037962933a64(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}
function $ea15c91cf36133ba$export$703c04942b452817(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}


var $070228915220ff93$exports = {};

$parcel$export($070228915220ff93$exports, "wrapAssetKey", () => $070228915220ff93$export$c3716da8516cbd37);


function $070228915220ff93$export$c3716da8516cbd37(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}


var $1c60d1baed176b0f$exports = {};

$parcel$export($1c60d1baed176b0f$exports, "wrapContentType", () => $1c60d1baed176b0f$export$8ffdd5df20b16d17);
$parcel$export($1c60d1baed176b0f$exports, "wrapContentTypeCollection", () => $1c60d1baed176b0f$export$3d2cfb0ebcba8025);


function $1c60d1baed176b0f$export$8ffdd5df20b16d17(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}
function $1c60d1baed176b0f$export$3d2cfb0ebcba8025(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}


var $265c1141b0c9beeb$exports = {};

$parcel$export($265c1141b0c9beeb$exports, "wrapLocale", () => $265c1141b0c9beeb$export$8dc16501d170823d);
$parcel$export($265c1141b0c9beeb$exports, "wrapLocaleCollection", () => $265c1141b0c9beeb$export$7e4340f6ba44035a);


function $265c1141b0c9beeb$export$8dc16501d170823d(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}
function $265c1141b0c9beeb$export$7e4340f6ba44035a(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}


var $16b99610d3af066f$exports = {};

$parcel$export($16b99610d3af066f$exports, "wrapTag", () => $16b99610d3af066f$export$e1decaf6a8504f95);
$parcel$export($16b99610d3af066f$exports, "wrapTagCollection", () => $16b99610d3af066f$export$6dec601a1a726211);


function $16b99610d3af066f$export$e1decaf6a8504f95(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}
function $16b99610d3af066f$export$6dec601a1a726211(data) {
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($f0c6463d360a8232$exports)))(data)));
}


var $8d9d540aaf005fcf$export$2e2bcd8739ae039 = {
    space: $1748b2ea35f1f1e8$exports,
    entry: $469a9bd37e6fe0bd$exports,
    asset: $ea15c91cf36133ba$exports,
    assetKey: $070228915220ff93$exports,
    contentType: $1c60d1baed176b0f$exports,
    locale: $265c1141b0c9beeb$exports,
    tag: $16b99610d3af066f$exports
};





function $03569d24899dec4c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $03569d24899dec4c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $03569d24899dec4c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $03569d24899dec4c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $03569d24899dec4c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $03569d24899dec4c$var$_defineProperty(obj, key, value) {
    key = $03569d24899dec4c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $03569d24899dec4c$var$_toPropertyKey(arg) {
    var key = $03569d24899dec4c$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $03569d24899dec4c$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
async function $03569d24899dec4c$export$2e2bcd8739ae039(http, query) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!query || !query.initial && !query.nextSyncToken && !query.nextPageToken) throw new Error("Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing");
    if (query && query.content_type && !query.type) query.type = "Entry";
    else if (query && query.content_type && query.type && query.type !== "Entry") throw new Error("When using the `content_type` filter your `type` parameter cannot be different from `Entry`.");
    const defaultOptions = {
        resolveLinks: true,
        removeUnresolved: false,
        paginate: true
    };
    const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved, paginate: paginate } = $03569d24899dec4c$var$_objectSpread($03569d24899dec4c$var$_objectSpread({}, defaultOptions), options);
    const syncOptions = {
        paginate: paginate
    };
    const response = await $03569d24899dec4c$var$getSyncPage(http, [], query, syncOptions);
    // clones response.items used in includes because we don't want these to be mutated
    if (resolveLinks) response.items = (0, $4e78154b8ff5834d$export$2e2bcd8739ae039)(response, {
        removeUnresolved: removeUnresolved,
        itemEntryPoints: [
            "fields"
        ]
    });
    // maps response items again after getters are attached
    const mappedResponseItems = $03569d24899dec4c$var$mapResponseItems(response.items);
    if (response.nextSyncToken) mappedResponseItems.nextSyncToken = response.nextSyncToken;
    if (response.nextPageToken) mappedResponseItems.nextPageToken = response.nextPageToken;
    return (0, $3c72d7d74cd67182$export$5f59ea1ba3499740)((0, $5a076583a4828ac3$export$2e2bcd8739ae039)((0, $3c72d7d74cd67182$export$8530f7b85295aab2)(mappedResponseItems)));
}
/**
 * @private
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @return {Object} Entities mapped to an object for each entity type
 */ function $03569d24899dec4c$var$mapResponseItems(items) {
    const reducer = (type)=>{
        return (accumulated, item)=>{
            if (item.sys.type === type) accumulated.push((0, $3c72d7d74cd67182$export$8530f7b85295aab2)(item));
            return accumulated;
        };
    };
    return {
        entries: items.reduce(reducer("Entry"), []),
        assets: items.reduce(reducer("Asset"), []),
        deletedEntries: items.reduce(reducer("DeletedEntry"), []),
        deletedAssets: items.reduce(reducer("DeletedAsset"), [])
    };
}
/**
 * If the response contains a nextPageUrl, extracts the sync token to get the
 * next page and calls itself again with that token.
 * Otherwise, if the response contains a nextSyncUrl, extracts the sync token
 * and returns it.
 * On each call of this function, any retrieved items are collected in the
 * supplied items array, which gets returned in the end
 * @private
 * @param {Object} http
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @param {Object} query
 * @param {Object} options - Sync page options object
 * @param {boolean} [options.paginate = true] - If further sync pages should automatically be crawled
 * @return {Promise<{items: Array, nextSyncToken: string}>}
 */ async function $03569d24899dec4c$var$getSyncPage(http, items, query, _ref) {
    let { paginate: paginate } = _ref;
    if (query.nextSyncToken) {
        query.sync_token = query.nextSyncToken;
        delete query.nextSyncToken;
    }
    if (query.nextPageToken) {
        query.sync_token = query.nextPageToken;
        delete query.nextPageToken;
    }
    if (query.sync_token) {
        delete query.initial;
        delete query.type;
        delete query.content_type;
        delete query.limit;
    }
    const response = await http.get("sync", (0, $3c72d7d74cd67182$export$b9eda6f1d11bafa2)({
        query: query
    }));
    const data = response.data || {};
    items = items.concat(data.items || []);
    if (data.nextPageUrl) {
        if (paginate) {
            delete query.initial;
            query.sync_token = $03569d24899dec4c$var$getToken(data.nextPageUrl);
            return $03569d24899dec4c$var$getSyncPage(http, items, query, {
                paginate: paginate
            });
        }
        return {
            items: items,
            nextPageToken: $03569d24899dec4c$var$getToken(data.nextPageUrl)
        };
    } else if (data.nextSyncUrl) return {
        items: items,
        nextSyncToken: $03569d24899dec4c$var$getToken(data.nextSyncUrl)
    };
    else return {
        items: []
    };
}
/**
 * Extracts token out of an url
 * @private
 */ function $03569d24899dec4c$var$getToken(url) {
    const urlParts = url.split("?");
    return urlParts.length > 0 ? urlParts[1].replace("sync_token=", "") : "";
}


function $08765e568fd72f0f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $08765e568fd72f0f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $08765e568fd72f0f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $08765e568fd72f0f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $08765e568fd72f0f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $08765e568fd72f0f$var$_defineProperty(obj, key, value) {
    key = $08765e568fd72f0f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $08765e568fd72f0f$var$_toPropertyKey(arg) {
    var key = $08765e568fd72f0f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $08765e568fd72f0f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $08765e568fd72f0f$export$2e2bcd8739ae039(query) {
    if (!query.select) return query;
    // The selection of fields for the query is limited
    // Get the different parts that are listed for selection
    const allSelects = Array.isArray(query.select) ? query.select : query.select.split(",").map((q)=>q.trim());
    // Move the parts into a set for easy access and deduplication
    const selectedSet = new Set(allSelects);
    // If we already select all of `sys` we can just return
    // since we're anyway fetching everything that is needed
    if (selectedSet.has("sys")) return query;
    // We don't select `sys` so we need to ensure the minimum set
    selectedSet.add("sys.id");
    selectedSet.add("sys.type");
    // Reassign the normalized sys properties
    return $08765e568fd72f0f$var$_objectSpread($08765e568fd72f0f$var$_objectSpread({}, query), {}, {
        select: [
            ...selectedSet
        ].join(",")
    });
}


class $ad3387e5dc64817f$export$2191b9da168c6cf0 extends Error {
    constructor(name, message){
        super(`Invalid "${name}" provided, ` + message);
        this.name = "ValidationError";
    }
}
function $ad3387e5dc64817f$export$2e2bcd8739ae039(name, timestamp, options) {
    options = options || {};
    if (typeof timestamp !== "number") throw new $ad3387e5dc64817f$export$2191b9da168c6cf0(name, `only numeric values are allowed for timestamps, provided type was "${typeof timestamp}"`);
    if (options.maximum && timestamp > options.maximum) throw new $ad3387e5dc64817f$export$2191b9da168c6cf0(name, `value (${timestamp}) cannot be further in the future than expected maximum (${options.maximum})`);
    if (options.now && timestamp < options.now) throw new $ad3387e5dc64817f$export$2191b9da168c6cf0(name, `value (${timestamp}) cannot be in the past, current time was ${options.now}`);
}


function $964de4734259dd04$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $964de4734259dd04$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $964de4734259dd04$var$ownKeys(Object(source), !0).forEach(function(key) {
            $964de4734259dd04$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $964de4734259dd04$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $964de4734259dd04$var$_defineProperty(obj, key, value) {
    key = $964de4734259dd04$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $964de4734259dd04$var$_toPropertyKey(arg) {
    var key = $964de4734259dd04$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $964de4734259dd04$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $964de4734259dd04$var$ASSET_KEY_MAX_LIFETIME = 172800;
function $964de4734259dd04$export$2e2bcd8739ae039(_ref) {
    let { http: http, getGlobalOptions: getGlobalOptions } = _ref;
    const { wrapSpace: wrapSpace } = (0, $8d9d540aaf005fcf$export$2e2bcd8739ae039).space;
    const { wrapContentType: wrapContentType, wrapContentTypeCollection: wrapContentTypeCollection } = (0, $8d9d540aaf005fcf$export$2e2bcd8739ae039).contentType;
    const { wrapEntry: wrapEntry, wrapEntryCollection: wrapEntryCollection } = (0, $8d9d540aaf005fcf$export$2e2bcd8739ae039).entry;
    const { wrapAsset: wrapAsset, wrapAssetCollection: wrapAssetCollection } = (0, $8d9d540aaf005fcf$export$2e2bcd8739ae039).asset;
    const { wrapTag: wrapTag, wrapTagCollection: wrapTagCollection } = (0, $8d9d540aaf005fcf$export$2e2bcd8739ae039).tag;
    const { wrapAssetKey: wrapAssetKey } = (0, $8d9d540aaf005fcf$export$2e2bcd8739ae039).assetKey;
    const { wrapLocaleCollection: wrapLocaleCollection } = (0, $8d9d540aaf005fcf$export$2e2bcd8739ae039).locale;
    const notFoundError = (id)=>{
        const error = new Error("The resource could not be found.");
        error.sys = {
            type: "Error",
            id: "NotFound"
        };
        error.details = {
            type: "Entry",
            id: id,
            environment: getGlobalOptions().environment,
            space: getGlobalOptions().space
        };
        return error;
    };
    /**
   * Gets the Space which the client is currently configured to use
   * @memberof ContentfulClientAPI
   * @return {Promise<Entities.Space>} Promise for a Space
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   * // returns the space object with the above <space-id>
   * const space = await client.getSpace()
   * console.log(space)
   */ async function getSpace() {
        switchToSpace(http);
        try {
            const response = await http.get("/");
            return wrapSpace(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a Content Type
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.ContentType>} Promise for a Content Type
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const contentType = await client.getContentType('<content_type_id>')
   * console.log(contentType)
   */ async function getContentType(id) {
        switchToEnvironment(http);
        try {
            const response = await http.get(`content_types/${id}`);
            return wrapContentType(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Content Types
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.ContentTypeCollection>} Promise for a collection of Content Types
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getContentTypes()
   * console.log(response.items)
   */ async function getContentTypes() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        try {
            const response = await http.get("content_types", (0, $3c72d7d74cd67182$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapContentTypeCollection(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets an Entry
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Entry>} Promise for an Entry
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const entry = await client.getEntry('<entry_id>')
   * console.log(entry)
   */ async function getEntry(id) {
        let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!id) throw notFoundError(id);
        try {
            const response = await this.getEntries($964de4734259dd04$var$_objectSpread({
                "sys.id": id
            }, query));
            if (response.items.length > 0) return wrapEntry(response.items[0]);
            else throw notFoundError(id);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Entries
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.EntryCollection>} Promise for a collection of Entries
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getEntries()
   * console.log(response.items)
   */ async function getEntries() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions(query);
        query = (0, $08765e568fd72f0f$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get("entries", (0, $3c72d7d74cd67182$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapEntryCollection(response.data, {
                resolveLinks: resolveLinks,
                removeUnresolved: removeUnresolved
            });
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets an Asset
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Asset>} Promise for an Asset
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const asset = await client.getAsset('<asset_id>')
   * console.log(asset)
   */ async function getAsset(id) {
        let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        switchToEnvironment(http);
        query = (0, $08765e568fd72f0f$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get(`assets/${id}`, (0, $3c72d7d74cd67182$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapAsset(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Assets
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.AssetCollection>} Promise for a collection of Assets
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getAssets()
   * console.log(response.items)
   */ async function getAssets() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        query = (0, $08765e568fd72f0f$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get("assets", (0, $3c72d7d74cd67182$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapAssetCollection(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a Tag
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.Tag>} Promise for a Tag
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const tag = await client.getTag('<asset_id>')
   * console.log(tag)
   */ async function getTag(id) {
        switchToEnvironment(http);
        try {
            const response = await http.get(`tags/${id}`);
            return wrapTag(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Tags
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters.
   * @return {Promise<Entities.TagCollection>} Promise for a collection of Tags
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getTags()
   * console.log(response.items)
   */ async function getTags() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        query = (0, $08765e568fd72f0f$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get("tags", (0, $3c72d7d74cd67182$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapTagCollection(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Creates an asset key for signing asset URLs (Embargoed Assets)
   * @memberof ContentfulClientAPI
   * @param {number} expiresAt - UNIX timestamp in the future, maximum of 48h from now
   * @return {Promise<Entities.AssetKey>} Promise for an AssetKey
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const assetKey = await client.getAssetKey(<UNIX timestamp>)
   * console.log(assetKey)
   */ async function createAssetKey(expiresAt) {
        switchToEnvironment(http);
        try {
            const now = Math.floor(Date.now() / 1000);
            const currentMaxLifetime = now + $964de4734259dd04$var$ASSET_KEY_MAX_LIFETIME;
            (0, $ad3387e5dc64817f$export$2e2bcd8739ae039)("expiresAt", expiresAt, {
                maximum: currentMaxLifetime,
                now: now
            });
            const params = {
                expiresAt: expiresAt
            };
            const response = await http.post("asset_keys", params);
            return wrapAssetKey(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Locale
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.LocaleCollection>} Promise for a collection of Locale
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getLocales()
   * console.log(response.items)
   */ async function getLocales() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        try {
            const response = await http.get("locales", (0, $3c72d7d74cd67182$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapLocaleCollection(response.data);
        } catch (error) {
            (0, $3c72d7d74cd67182$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Synchronizes either all the content or only new content since last sync
   * See <a href="https://www.contentful.com/developers/docs/concepts/sync/">Synchronization</a> for more information.
   * <strong> Important note: </strong> The the sync api endpoint does not support include or link resolution.
   * However contentful.js is doing link resolution client side if you only make an initial sync.
   * For the delta sync (using nextSyncToken) it is not possible since the sdk wont have access to all the data to make such an operation.
   * @memberof ContentfulClientAPI
   * @param  {Object} query - Query object for the sync call. One of initial or nextSyncToken always needs to be specified, but not both.
   * @param  {boolean?} query.initial - Indicates if this is the first sync. Use it if you don't have a sync token.
   * @param  {string?} query.nextSyncToken - The token you got the last time you used this method. Ensures you only get changed content.
   * @param  {string=} query.type - Filter by this type (all (default), Entry, Asset, Deletion, DeletedAsset or DeletedEntry)
   * @param  {string=} query.content_type - Filter by this content type id
   * @param  {boolean=} query.resolveLinks - When true, links to other Entries or Assets are resolved. Default: true.
   * @param  {Object} options
   * @param  {boolean=} [options.paginate = true] - Set to false to disable pagination
   * @return {Promise<Sync.SyncCollection>} Promise for the collection resulting of a sync operation
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.sync({
   *   initial: true
   * })
   * console.log({
   *   entries: response.entries,
   *   assets: response.assets,
   *   nextSyncToken: response.nextSyncToken
   * })
   */ async function sync() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            paginate: true
        };
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions(query);
        switchToEnvironment(http);
        return (0, $03569d24899dec4c$export$2e2bcd8739ae039)(http, query, $964de4734259dd04$var$_objectSpread({
            resolveLinks: resolveLinks,
            removeUnresolved: removeUnresolved
        }, options));
    }
    /**
  * Parse raw json data into collection of entry objects.Links will be resolved also
  * @memberof ContentfulClientAPI
  * @param {Object} raw json data
  * @example
  * let data = {items: [
  *    {
  *    sys: {type: 'Entry', locale: 'en-US'},
  *    fields: {
  *      animal: {sys: {type: 'Link', linkType: 'Animal', id: 'oink'}},
  *      anotheranimal: {sys: {type: 'Link', linkType: 'Animal', id: 'middle-parrot'}}
  *    }
  *  }
  * ],
  * includes: {
  *  Animal: [
  *    {
  *      sys: {type: 'Animal', id: 'oink', locale: 'en-US'},
  *      fields: {
  *        name: 'Pig',
  *        friend: {sys: {type: 'Link', linkType: 'Animal', id: 'groundhog'}}
  *      }
  *    }
  *   ]
  *  }
  * }
  * console.log( data.items[0].fields.foo ); // undefined
  * let parsedData = client.parseEntries(data);
  * console.log( parsedData.items[0].fields.foo ); // foo
  */ function parseEntries(data) {
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions({});
        return wrapEntryCollection(data, {
            resolveLinks: resolveLinks,
            removeUnresolved: removeUnresolved
        });
    }
    /*
   * Switches BaseURL to use /environments path
   * */ function switchToEnvironment(http) {
        http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
    }
    /*
   * Switches BaseURL to use /spaces path
   * */ function switchToSpace(http) {
        http.defaults.baseURL = getGlobalOptions().spaceBaseUrl;
    }
    return {
        getSpace: getSpace,
        getContentType: getContentType,
        getContentTypes: getContentTypes,
        getEntry: getEntry,
        getEntries: getEntries,
        getAsset: getAsset,
        getAssets: getAssets,
        getTag: getTag,
        getTags: getTags,
        createAssetKey: createAssetKey,
        getLocales: getLocales,
        parseEntries: parseEntries,
        sync: sync
    };
}


/**
 * Link resolution can be set globally, or it can be turned off for the methods
 * which make use of it. The local setting always overrides the global setting.
 * @private
 * @param {boolean} globalSetting - Global library setting for link resolution
 * @returns {function} Link resolver method preconfigured with global setting
 */ function $43e50a14feb69526$export$2e2bcd8739ae039(globalSettings) {
    /**
   * Link resolver method
   * @param {Object} query - regular query object used for collection endpoints
   */ return function getGlobalOptions(query) {
        return Object.assign({}, globalSettings, query);
    };
}


function $1d80c4c551df3035$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1d80c4c551df3035$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1d80c4c551df3035$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1d80c4c551df3035$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1d80c4c551df3035$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1d80c4c551df3035$var$_defineProperty(obj, key, value) {
    key = $1d80c4c551df3035$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1d80c4c551df3035$var$_toPropertyKey(arg) {
    var key = $1d80c4c551df3035$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $1d80c4c551df3035$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1d80c4c551df3035$export$5d730b7aed1a3eb0(params) {
    if (!params.accessToken) throw new TypeError("Expected parameter accessToken");
    if (!params.space) throw new TypeError("Expected parameter space");
    const defaultConfig = {
        resolveLinks: true,
        removeUnresolved: false,
        defaultHostname: "cdn.contentful.com",
        environment: "master"
    };
    const config = $1d80c4c551df3035$var$_objectSpread($1d80c4c551df3035$var$_objectSpread({}, defaultConfig), params);
    const userAgentHeader = (0, $3c72d7d74cd67182$export$56c7340f89ca57c5)(`contentful.js/${"9.3.7"}`, config.application, config.integration);
    config.headers = $1d80c4c551df3035$var$_objectSpread($1d80c4c551df3035$var$_objectSpread({}, config.headers), {}, {
        "Content-Type": "application/vnd.contentful.delivery.v1+json",
        "X-Contentful-User-Agent": userAgentHeader
    });
    const http = (0, $3c72d7d74cd67182$export$5ff1805767bd358a)((0, $0990a2a3ce225f89$export$2e2bcd8739ae039), config);
    const getGlobalOptions = (0, $43e50a14feb69526$export$2e2bcd8739ae039)({
        resolveLinks: config.resolveLinks,
        environment: config.environment,
        removeUnresolved: config.removeUnresolved,
        spaceBaseUrl: http.defaults.baseURL,
        environmentBaseUrl: `${http.defaults.baseURL}environments/${config.environment}`
    });
    // Append environment to baseURL
    http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
    return (0, $964de4734259dd04$export$2e2bcd8739ae039)({
        http: http,
        getGlobalOptions: getGlobalOptions
    });
}



var $dhiZh = parcelRequire("dhiZh");
var $fcdc7a5a8020c7eb$export$2e2bcd8739ae039 = "undefined" != typeof window && new /*#__PURE__*/ (function() {
    function r() {
        var r = this;
        this.raf = function(t) {
            requestAnimationFrame(r.raf);
            var a = t - r.now;
            r.now = t;
            for(var n = 0; n < r.callbacks.length; n++)r.callbacks[n].callback(t, a);
        }, this.callbacks = [], this.now = performance.now(), requestAnimationFrame(this.raf);
    }
    var t = r.prototype;
    return t.add = function(r, t) {
        var a = this;
        return void 0 === t && (t = 0), this.callbacks.push({
            callback: r,
            priority: t
        }), this.callbacks.sort(function(r, t) {
            return r.priority - t.priority;
        }), function() {
            return a.remove(r);
        };
    }, t.remove = function(r) {
        this.callbacks = this.callbacks.filter(function(t) {
            return r !== t.callback;
        });
    }, r;
}());


var $005dd15d7b61c343$exports = {};
$005dd15d7b61c343$exports = $005dd15d7b61c343$var$debounce;
function $005dd15d7b61c343$var$debounce(fn, wait, callFirst) {
    var timeout = null;
    var debouncedFn = null;
    var clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            debouncedFn = null;
            timeout = null;
        }
    };
    var flush = function() {
        var call = debouncedFn;
        clear();
        if (call) call();
    };
    var debounceWrapper = function() {
        if (!wait) return fn.apply(this, arguments);
        var context = this;
        var args = arguments;
        var callNow = callFirst && !timeout;
        clear();
        debouncedFn = function() {
            fn.apply(context, args);
        };
        timeout = setTimeout(function() {
            timeout = null;
            if (!callNow) {
                var call = debouncedFn;
                debouncedFn = null;
                return call();
            }
        }, wait);
        if (callNow) return debouncedFn();
    };
    debounceWrapper.cancel = clear;
    debounceWrapper.flush = flush;
    return debounceWrapper;
}


let $ea004eac1a5b57bd$export$c944a4526d4ed4f3 = ()=>({
        emit (event, ...args) {
            for(let i = 0, callbacks = this.events[event] || [], length = callbacks.length; i < length; i++)callbacks[i](...args);
        },
        events: {},
        on (event, cb) {
            var _this_events, _event;
            ((_this_events = this.events)[_event = event] || (_this_events[_event] = [])).push(cb);
            return ()=>{
                var _this_events_event;
                this.events[event] = (_this_events_event = this.events[event]) === null || _this_events_event === void 0 ? void 0 : _this_events_event.filter((i)=>cb !== i);
            };
        }
    });


function $bf4080a7da01e87e$export$677ee3f2ebbfb618(e, r) {
    var o = (0, $dhiZh.useCallback)(function(n) {
        e.current && !e.current.contains(n.target) && r();
    }, [
        e,
        r
    ]);
    (0, $dhiZh.useEffect)(function() {
        if (e.current) return document.addEventListener("mousedown", o), function() {
            document.removeEventListener("mousedown", o);
        };
    }, [
        o,
        e
    ]);
}
function $bf4080a7da01e87e$export$7c8949515a63d2a1() {
    var n = (0, $dhiZh.useState)(!1), r = n[0], o = n[1];
    return (0, $dhiZh.useEffect)(function() {
        o(!0);
    }, []), r;
}
function $bf4080a7da01e87e$export$9bbb1d105c7ffc3c() {
    var n = $bf4080a7da01e87e$export$7c8949515a63d2a1();
    return (0, $dhiZh.useMemo)(function() {
        if (n) {
            var t = window.location, e = t.href, r = new URLSearchParams(t.search), o = e.includes("#debug") || e.includes("/_debug") || r.has("debug") || false, i = e.includes("#production") || r.has("production");
            return o && !i;
        }
    }, [
        n
    ]);
}
function $bf4080a7da01e87e$export$3f890914a8672362() {
    var n = (0, $dhiZh.useState)(), r = n[0], o = n[1];
    return (0, $dhiZh.useEffect)(function() {
        function n() {
            o(document.readyState);
        }
        return document.addEventListener("readystatechange", n, !1), n(), function() {
            return document.removeEventListener("readystatechange", n, !1);
        };
    }, []), r;
}
function $bf4080a7da01e87e$export$82cf2c2b26f73925(n, e) {
    void 0 === e && (e = 0), (0, $dhiZh.useEffect)(function() {
        if (n) return (0, $fcdc7a5a8020c7eb$export$2e2bcd8739ae039).add(n, e), function() {
            return (0, $fcdc7a5a8020c7eb$export$2e2bcd8739ae039).remove(n);
        };
    }, [
        n,
        e
    ]);
}
function $bf4080a7da01e87e$export$a7395f9832c00176(r, i) {
    var u = void 0 === r ? {} : r, c = u.root, a = void 0 === c ? null : c, f = u.rootMargin, d = void 0 === f ? "0px" : f, v = u.threshold, s = void 0 === v ? 0 : v, l = u.once, h = void 0 !== l && l, m = u.lazy, w = void 0 !== m && m, g = u.callback, p = void 0 === g ? function() {} : g;
    void 0 === i && (i = []);
    var b = (0, $dhiZh.useRef)({}), y = (0, $dhiZh.useState)({}), z = y[0], P = y[1], E = (0, $dhiZh.useState)(), L = E[0], k = E[1];
    (0, $dhiZh.useEffect)(function() {
        if (L) {
            var n = new IntersectionObserver(function(t) {
                var e = t[0];
                w ? b.current = e : P(e), p(e), h && e.isIntersecting && n.disconnect();
            }, {
                root: a,
                rootMargin: d,
                threshold: s
            });
            return n.observe(L), function() {
                n.disconnect();
            };
        }
    }, [
        L,
        a,
        d,
        s,
        w,
        h
    ].concat(i));
    var x = (0, $dhiZh.useCallback)(function() {
        return b.current;
    }, []);
    return [
        k,
        w ? x : z
    ];
}
function $bf4080a7da01e87e$export$f4b266cd2aae9cb1(n, e, r) {
    void 0 === e && (e = 1e3), void 0 === r && (r = []), (0, $dhiZh.useEffect)(function() {
        var t = setInterval(n, e);
        return function() {
            return clearInterval(t);
        };
    }, [
        e
    ].concat(r));
}
function $bf4080a7da01e87e$export$2706b359107dd58d() {
    var n = (0, $dhiZh.useState)(), r = n[0], o = n[1];
    return (0, $dhiZh.useEffect)(function() {
        function n() {
            o("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
        }
        return window.addEventListener("resize", n, !1), n(), function() {
            window.removeEventListener("resize", n, !1);
        };
    }, []), r;
}
function $bf4080a7da01e87e$export$32d5543ab307c01(n) {
    var r = (0, $dhiZh.useState)(), o = r[0], i = r[1];
    return (0, $dhiZh.useEffect)(function() {
        var t = window.matchMedia(n);
        function e() {
            i(t.matches);
        }
        return t.addEventListener("change", e, !1), e(), function() {
            return t.removeEventListener("change", e, !1);
        };
    }, [
        n
    ]), o;
}
function $bf4080a7da01e87e$var$g() {
    return $bf4080a7da01e87e$var$g = Object.assign ? Object.assign.bind() : function(n) {
        for(var t = 1; t < arguments.length; t++){
            var e = arguments[t];
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
        }
        return n;
    }, $bf4080a7da01e87e$var$g.apply(this, arguments);
}
function $bf4080a7da01e87e$var$p(n) {
    "sticky" === getComputedStyle(n).position && (n.style.setProperty("position", "static"), n.dataset.sticky = "true"), n.offsetParent && $bf4080a7da01e87e$var$p(n.offsetParent);
}
function $bf4080a7da01e87e$var$b(n) {
    var t;
    "true" === (null == n || null == (t = n.dataset) ? void 0 : t.sticky) && (n.style.removeProperty("position"), n.dataset.sticky = "true", delete n.dataset.sticky), n.parentNode && $bf4080a7da01e87e$var$b(n.parentNode);
}
function $bf4080a7da01e87e$var$y(n, t) {
    void 0 === t && (t = 0);
    var e = t + n.offsetTop;
    return n.offsetParent ? $bf4080a7da01e87e$var$y(n.offsetParent, e) : e;
}
function $bf4080a7da01e87e$var$z(n, t) {
    void 0 === t && (t = 0);
    var e = t + n.offsetLeft;
    return n.offsetParent ? $bf4080a7da01e87e$var$z(n.offsetParent, e) : e;
}
function $bf4080a7da01e87e$var$P(n, t) {
    void 0 === t && (t = 0);
    var e = t + n.scrollTop;
    return n.offsetParent ? $bf4080a7da01e87e$var$P(n.offsetParent, e) : e + window.scrollY;
}
function $bf4080a7da01e87e$var$E(n, t) {
    void 0 === t && (t = 0);
    var e = t + n.scrollLeft;
    return n.offsetParent ? $bf4080a7da01e87e$var$E(n.offsetParent, e) : e + window.scrollX;
}
var $bf4080a7da01e87e$var$L = (0, $ea004eac1a5b57bd$export$c944a4526d4ed4f3)();
function $bf4080a7da01e87e$export$9823a655542017cd(r) {
    var i = void 0 === r ? {} : r, c = i.ignoreTransform, a = void 0 !== c && c, f = i.ignoreSticky, d = void 0 === f || f, v = i.debounce, s = void 0 === v ? 500 : v, l = i.lazy, h = void 0 !== l && l, m = i.callback, w = (0, $dhiZh.useState)(), k = w[0], x = w[1], O = (0, $dhiZh.useRef)({}), S = (0, $dhiZh.useState)({}), R = S[0], M = S[1], B = (0, $dhiZh.useCallback)(function(n) {
        var t, e, r, o, i, u = n.top, c = n.left, a = n.width, f = n.height, d = n.element;
        u = null != (t = u) ? t : O.current.top, c = null != (e = c) ? e : O.current.left, a = null != (r = a) ? r : O.current.width, f = null != (o = f) ? o : O.current.height, d = null != (i = d) ? i : O.current.element, u === O.current.top && c === O.current.left && a === O.current.width && f === O.current.height && d === O.current.element || (O.current.top = u, O.current.y = u, O.current.width = a, O.current.height = f, O.current.left = c, O.current.x = c, O.current.bottom = u + f, O.current.right = c + a, O.current.element = d, null == m || m(O.current), h || M($bf4080a7da01e87e$var$g({}, O.current)));
    }, [
        h
    ]);
    (0, $dhiZh.useEffect)(function() {
        if (k) {
            var n = k.getBoundingClientRect();
            B({
                width: n.width,
                height: n.height
            });
            var t = (0, (/*@__PURE__*/$parcel$interopDefault($005dd15d7b61c343$exports)))(function(n) {
                var t = n[0];
                B({
                    width: t.borderBoxSize[0].inlineSize,
                    height: t.borderBoxSize[0].blockSize
                });
            }, s), e = new ResizeObserver(t);
            return e.observe(k), function() {
                e.disconnect(), t.cancel();
            };
        }
    }, [
        k,
        s,
        B
    ]);
    var T = (0, $dhiZh.useState)(), j = T[0], C = T[1], I = (0, $dhiZh.useCallback)(function() {
        if (k) {
            var n, t;
            if (d && $bf4080a7da01e87e$var$p(k), a) n = $bf4080a7da01e87e$var$y(k), t = $bf4080a7da01e87e$var$z(k);
            else {
                var e = k.getBoundingClientRect();
                n = e.top + $bf4080a7da01e87e$var$P(k), t = e.left + $bf4080a7da01e87e$var$E(k);
            }
            d && $bf4080a7da01e87e$var$b(k), B({
                top: n,
                left: t,
                element: k
            });
        }
    }, [
        a,
        d,
        k,
        B
    ]);
    (0, $dhiZh.useEffect)(function() {
        I();
        var n = (0, (/*@__PURE__*/$parcel$interopDefault($005dd15d7b61c343$exports)))(I, s), t = new ResizeObserver(n);
        return t.observe(null != j ? j : document.body), function() {
            t.disconnect(), n.cancel();
        };
    }, [
        j,
        s,
        I
    ]), (0, $dhiZh.useEffect)(function() {
        return $bf4080a7da01e87e$var$L.on("resize", function() {
            if (k) {
                var n = k.getBoundingClientRect();
                B({
                    width: n.width,
                    height: n.height
                }), I();
            }
        });
    }, [
        k,
        I,
        B
    ]);
    var N = (0, $dhiZh.useCallback)(function() {
        return O.current;
    }, []);
    return [
        x,
        h ? N : R,
        C
    ];
}
function $bf4080a7da01e87e$export$683480f191c0e3ea(r) {
    var i = void 0 === r ? {} : r, c = i.lazy, a = void 0 !== c && c, f = i.debounce, d = void 0 === f ? 500 : f, v = i.box, s = void 0 === v ? "border-box" : v, l = i.callback, h = void 0 === l ? function() {} : l, m = (0, $dhiZh.useRef)({}), w = (0, $dhiZh.useState)({}), g = w[0], p = w[1], b = (0, $dhiZh.useState)(), y = b[0], z = b[1];
    (0, $dhiZh.useEffect)(function() {
        if (y) {
            var n = (0, (/*@__PURE__*/$parcel$interopDefault($005dd15d7b61c343$exports)))(function(n) {
                var t = n[0];
                m.current = t, h(t), a || p(t);
            }, d, !0), t = new ResizeObserver(n);
            return t.observe(y, {
                box: s
            }), function() {
                t.disconnect(), n.cancel();
            };
        }
    }, [
        y,
        a,
        d,
        s
    ]);
    var P = (0, $dhiZh.useCallback)(function() {
        return m.current;
    }, []);
    return [
        z,
        a ? P : g
    ];
}
function $bf4080a7da01e87e$export$9203a8e84125433c(n, t) {
    void 0 === n && (n = []), void 0 === t && (t = []);
    var e = (0, $dhiZh.useMemo)(function() {
        return t && [
            t
        ].flat();
    }, [
        t
    ]), o = (0, $dhiZh.useMemo)(function() {
        return n && [
            n
        ].flat();
    }, [
        n
    ]);
    return (0, $dhiZh.useMemo)(function() {
        if (e && o) {
            var t = o.map(function(n) {
                var t;
                return null == (t = e.find(function(t) {
                    return t.type === n;
                })) ? void 0 : t.props.children;
            });
            return n[0] ? t : t[0];
        }
    }, [
        e,
        o
    ]);
}
function $bf4080a7da01e87e$export$42c02f33970a2afa(n) {
    void 0 === n && (n = 500);
    var r = (0, $dhiZh.useState)(), o = r[0], i = r[1], c = (0, $dhiZh.useState)(), a = c[0], f = c[1];
    return (0, $dhiZh.useEffect)(function() {
        var t = (0, (/*@__PURE__*/$parcel$interopDefault($005dd15d7b61c343$exports)))(function() {
            i(Math.min(window.innerWidth, document.documentElement.clientWidth)), f(Math.min(window.innerHeight, document.documentElement.clientHeight));
        }, n);
        return window.addEventListener("resize", t, !1), t(), function() {
            return window.removeEventListener("resize", t, !1);
        };
    }, [
        n
    ]), {
        width: o,
        height: a
    };
}
$bf4080a7da01e87e$export$9823a655542017cd.resize = function() {
    $bf4080a7da01e87e$var$L.emit("resize");
};



function $f1ab3552fe1bc7f5$var$t(t, e, i) {
    return Math.max(t, Math.min(e, i));
}
class $f1ab3552fe1bc7f5$var$Animate {
    advance(e) {
        var _this_onUpdate, _this;
        if (!this.isRunning) return;
        let i = !1;
        if (this.lerp) this.value = (s = this.value, o = this.to, n = 60 * this.lerp, r = e, function(t, e, i) {
            return (1 - i) * t + i * e;
        }(s, o, 1 - Math.exp(-n * r))), Math.round(this.value) === this.to && (this.value = this.to, i = !0);
        else {
            this.currentTime += e;
            const s = $f1ab3552fe1bc7f5$var$t(0, this.currentTime / this.duration, 1);
            i = s >= 1;
            const o = i ? 1 : this.easing(s);
            this.value = this.from + (this.to - this.from) * o;
        }
        var s, o, n, r;
        (_this_onUpdate = (_this = this).onUpdate) === null || _this_onUpdate === void 0 ? void 0 : _this_onUpdate.call(_this, this.value, i), i && this.stop();
    }
    stop() {
        this.isRunning = !1;
    }
    fromTo(t, e, { lerp: i = .1, duration: s = 1, easing: o = (t)=>t, onStart: n, onUpdate: r }) {
        this.from = this.value = t, this.to = e, this.lerp = i, this.duration = s, this.easing = o, this.currentTime = 0, this.isRunning = !0, n === null || n === void 0 ? void 0 : n(), this.onUpdate = r;
    }
}
class $f1ab3552fe1bc7f5$var$Dimensions {
    destroy() {
        var _this_wrapperResizeObserver, _this_contentResizeObserver;
        (_this_wrapperResizeObserver = this.wrapperResizeObserver) === null || _this_wrapperResizeObserver === void 0 ? void 0 : _this_wrapperResizeObserver.disconnect(), (_this_contentResizeObserver = this.contentResizeObserver) === null || _this_contentResizeObserver === void 0 ? void 0 : _this_contentResizeObserver.disconnect(), window.removeEventListener("resize", this.debouncedResize, !1);
    }
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
    constructor({ wrapper: t, content: e, autoResize: i = !0, debounce: s = 250 } = {}){
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "resize", ()=>{
            this.onWrapperResize(), this.onContentResize();
        });
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "onWrapperResize", ()=>{
            this.wrapper === window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
        });
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "onContentResize", ()=>{
            this.wrapper === window ? (this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth) : (this.scrollHeight = this.wrapper.scrollHeight, this.scrollWidth = this.wrapper.scrollWidth);
        });
        this.wrapper = t, this.content = e, i && (this.debouncedResize = function(t, e) {
            let i;
            return function() {
                let s = arguments, o = this;
                clearTimeout(i), i = setTimeout(function() {
                    t.apply(o, s);
                }, e);
            };
        }(this.resize, s), this.wrapper === window ? window.addEventListener("resize", this.debouncedResize, !1) : (this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(this.debouncedResize), this.contentResizeObserver.observe(this.content)), this.resize();
    }
}
class $f1ab3552fe1bc7f5$var$Emitter {
    emit(t, ...e) {
        let i = this.events[t] || [];
        for(let t = 0, s = i.length; t < s; t++)i[t](...e);
    }
    on(t, e) {
        var _this_events_t;
        return ((_this_events_t = this.events[t]) === null || _this_events_t === void 0 ? void 0 : _this_events_t.push(e)) || (this.events[t] = [
            e
        ]), ()=>{
            var _this_events_t;
            this.events[t] = (_this_events_t = this.events[t]) === null || _this_events_t === void 0 ? void 0 : _this_events_t.filter((t)=>e !== t);
        };
    }
    off(t, e) {
        var _this_events_t;
        this.events[t] = (_this_events_t = this.events[t]) === null || _this_events_t === void 0 ? void 0 : _this_events_t.filter((t)=>e !== t);
    }
    destroy() {
        this.events = {};
    }
    constructor(){
        this.events = {};
    }
}
const $f1ab3552fe1bc7f5$var$e = 100 / 6;
class $f1ab3552fe1bc7f5$var$VirtualScroll {
    on(t, e) {
        return this.emitter.on(t, e);
    }
    destroy() {
        this.emitter.destroy(), window.removeEventListener("resize", this.onWindowResize, !1), this.element.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.element.removeEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), this.element.removeEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), this.element.removeEventListener("touchend", this.onTouchEnd, {
            passive: !1
        });
    }
    constructor(t, { wheelMultiplier: e1 = 1, touchMultiplier: i = 1 }){
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "onTouchStart", (t)=>{
            const { clientX: e, clientY: i } = t.targetTouches ? t.targetTouches[0] : t;
            this.touchStart.x = e, this.touchStart.y = i, this.lastDelta = {
                x: 0,
                y: 0
            }, this.emitter.emit("scroll", {
                deltaX: 0,
                deltaY: 0,
                event: t
            });
        });
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "onTouchMove", (t)=>{
            const { clientX: e, clientY: i } = t.targetTouches ? t.targetTouches[0] : t, s = -(e - this.touchStart.x) * this.touchMultiplier, o = -(i - this.touchStart.y) * this.touchMultiplier;
            this.touchStart.x = e, this.touchStart.y = i, this.lastDelta = {
                x: s,
                y: o
            }, this.emitter.emit("scroll", {
                deltaX: s,
                deltaY: o,
                event: t
            });
        });
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "onTouchEnd", (t)=>{
            this.emitter.emit("scroll", {
                deltaX: this.lastDelta.x,
                deltaY: this.lastDelta.y,
                event: t
            });
        });
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "onWheel", (t)=>{
            let { deltaX: i, deltaY: s, deltaMode: o } = t;
            i *= 1 === o ? $f1ab3552fe1bc7f5$var$e : 2 === o ? this.windowWidth : 1, s *= 1 === o ? $f1ab3552fe1bc7f5$var$e : 2 === o ? this.windowHeight : 1, i *= this.wheelMultiplier, s *= this.wheelMultiplier, this.emitter.emit("scroll", {
                deltaX: i,
                deltaY: s,
                event: t
            });
        });
        (0, $c9ab0f59dbc12b53$export$71511d61b312f219)(this, "onWindowResize", ()=>{
            this.windowWidth = window.innerWidth, this.windowHeight = window.innerHeight;
        });
        this.element = t, this.wheelMultiplier = e1, this.touchMultiplier = i, this.touchStart = {
            x: null,
            y: null
        }, this.emitter = new $f1ab3552fe1bc7f5$var$Emitter, window.addEventListener("resize", this.onWindowResize, !1), this.onWindowResize(), this.element.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.element.addEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), this.element.addEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), this.element.addEventListener("touchend", this.onTouchEnd, {
            passive: !1
        });
    }
}
class $f1ab3552fe1bc7f5$export$2e2bcd8739ae039 {
    destroy() {
        this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, !1), this.virtualScroll.destroy(), this.dimensions.destroy(), this.toggleClassName("lenis", !1), this.toggleClassName("lenis-smooth", !1), this.toggleClassName("lenis-scrolling", !1), this.toggleClassName("lenis-stopped", !1), this.toggleClassName("lenis-locked", !1);
    }
    on(t, e) {
        return this.emitter.on(t, e);
    }
    off(t, e) {
        return this.emitter.off(t, e);
    }
    setScroll(t) {
        this.isHorizontal ? this.rootElement.scrollLeft = t : this.rootElement.scrollTop = t;
    }
    resize() {
        this.dimensions.resize();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    reset() {
        this.isLocked = !1, this.isScrolling = !1, this.animatedScroll = this.targetScroll = this.actualScroll, this.velocity = 0, this.animate.stop();
    }
    start() {
        this.isStopped && (this.isStopped = !1, this.reset());
    }
    stop() {
        this.isStopped || (this.isStopped = !0, this.animate.stop(), this.reset());
    }
    raf(t) {
        const e = t - (this.time || t);
        this.time = t, this.animate.advance(.001 * e);
    }
    scrollTo(e, { offset: i = 0, immediate: s = !1, lock: o = !1, duration: n = this.options.duration, easing: r = this.options.easing, lerp: l = !n && this.options.lerp, onComplete: h, force: a = !1, programmatic: c = !0 } = {}) {
        if (!this.isStopped && !this.isLocked || a) {
            if ([
                "top",
                "left",
                "start"
            ].includes(e)) e = 0;
            else if ([
                "bottom",
                "right",
                "end"
            ].includes(e)) e = this.limit;
            else {
                let t;
                if ("string" == typeof e ? t = document.querySelector(e) : (null == e ? void 0 : e.nodeType) && (t = e), t) {
                    if (this.options.wrapper !== window) {
                        const t = this.options.wrapper.getBoundingClientRect();
                        i -= this.isHorizontal ? t.left : t.top;
                    }
                    const s = t.getBoundingClientRect();
                    e = (this.isHorizontal ? s.left : s.top) + this.animatedScroll;
                }
            }
            if ("number" == typeof e) {
                if (e += i, e = Math.round(e), this.options.infinite ? c && (this.targetScroll = this.animatedScroll = this.scroll) : e = $f1ab3552fe1bc7f5$var$t(0, e, this.limit), s) return this.animatedScroll = this.targetScroll = e, this.setScroll(this.scroll), this.reset(), void (null == h || h(this));
                if (!c) {
                    if (e === this.targetScroll) return;
                    this.targetScroll = e;
                }
                this.animate.fromTo(this.animatedScroll, e, {
                    duration: n,
                    easing: r,
                    lerp: l,
                    onStart: ()=>{
                        o && (this.isLocked = !0), this.isScrolling = !0;
                    },
                    onUpdate: (t, e)=>{
                        this.isScrolling = !0, this.velocity = t - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = t, this.setScroll(this.scroll), c && (this.targetScroll = t), e || this.emit(), e && (this.reset(), this.emit(), null == h || h(this), this.__preventNextScrollEvent = !0, requestAnimationFrame(()=>{
                            delete this.__preventNextScrollEvent;
                        }));
                    }
                });
            }
        }
    }
    get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
        return this.options.__experimental__naiveDimensions ? this.isHorizontal ? this.rootElement.scrollWidth - this.rootElement.clientWidth : this.rootElement.scrollHeight - this.rootElement.clientHeight : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
        return "horizontal" === this.options.orientation;
    }
    get actualScroll() {
        return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
    }
    get scroll() {
        var t, e;
        return this.options.infinite ? (t = this.animatedScroll, e = this.limit, (t % e + e) % e) : this.animatedScroll;
    }
    get progress() {
        return 0 === this.limit ? 1 : this.scroll / this.limit;
    }
    get isSmooth() {
        return this.__isSmooth;
    }
    set isSmooth(t) {
        this.__isSmooth !== t && (this.__isSmooth = t, this.toggleClassName("lenis-smooth", t));
    }
    get isScrolling() {
        return this.__isScrolling;
    }
    set isScrolling(t) {
        this.__isScrolling !== t && (this.__isScrolling = t, this.toggleClassName("lenis-scrolling", t));
    }
    get isStopped() {
        return this.__isStopped;
    }
    set isStopped(t) {
        this.__isStopped !== t && (this.__isStopped = t, this.toggleClassName("lenis-stopped", t));
    }
    get isLocked() {
        return this.__isLocked;
    }
    set isLocked(t) {
        this.__isLocked !== t && (this.__isLocked = t, this.toggleClassName("lenis-locked", t));
    }
    get className() {
        let t = "lenis";
        return this.isStopped && (t += " lenis-stopped"), this.isLocked && (t += " lenis-locked"), this.isScrolling && (t += " lenis-scrolling"), this.isSmooth && (t += " lenis-smooth"), t;
    }
    toggleClassName(t, e) {
        this.rootElement.classList.toggle(t, e), this.emitter.emit("className change", this);
    }
    constructor({ wrapper: t = window, content: e = document.documentElement, wheelEventsTarget: i = t, eventsTarget: s = i, smoothWheel: o = !0, syncTouch: n = !1, syncTouchLerp: r = .075, touchInertiaMultiplier: l = 35, duration: h, easing: a = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t)), lerp: c = !h && .1, infinite: d = !1, orientation: p = "vertical", gestureOrientation: u = "vertical", touchMultiplier: m = 1, wheelMultiplier: v = 1, autoResize: g = !0, __experimental__naiveDimensions: S = !1 } = {}){
        this.__isSmooth = !1, this.__isScrolling = !1, this.__isStopped = !1, this.__isLocked = !1, this.onVirtualScroll = ({ deltaX: t, deltaY: e, event: i })=>{
            if (i.ctrlKey) return;
            const s = i.type.includes("touch"), o = i.type.includes("wheel");
            if (this.options.syncTouch && s && "touchstart" === i.type && !this.isStopped && !this.isLocked) return void this.reset();
            const n = 0 === t && 0 === e, r = "vertical" === this.options.gestureOrientation && 0 === e || "horizontal" === this.options.gestureOrientation && 0 === t;
            if (n || r) return;
            let l = i.composedPath();
            if (l = l.slice(0, l.indexOf(this.rootElement)), l.find((t)=>{
                var e, i, n, r, l;
                return (null === (e = t.hasAttribute) || void 0 === e ? void 0 : e.call(t, "data-lenis-prevent")) || s && (null === (i = t.hasAttribute) || void 0 === i ? void 0 : i.call(t, "data-lenis-prevent-touch")) || o && (null === (n = t.hasAttribute) || void 0 === n ? void 0 : n.call(t, "data-lenis-prevent-wheel")) || (null === (r = t.classList) || void 0 === r ? void 0 : r.contains("lenis")) && !(null === (l = t.classList) || void 0 === l ? void 0 : l.contains("lenis-stopped"));
            })) return;
            if (this.isStopped || this.isLocked) return void i.preventDefault();
            if (this.isSmooth = this.options.syncTouch && s || this.options.smoothWheel && o, !this.isSmooth) return this.isScrolling = !1, void this.animate.stop();
            i.preventDefault();
            let h = e;
            "both" === this.options.gestureOrientation ? h = Math.abs(e) > Math.abs(t) ? e : t : "horizontal" === this.options.gestureOrientation && (h = t);
            const a = s && this.options.syncTouch, c = s && "touchend" === i.type && Math.abs(h) > 5;
            c && (h = this.velocity * this.options.touchInertiaMultiplier), this.scrollTo(this.targetScroll + h, Object.assign({
                programmatic: !1
            }, a ? {
                lerp: c ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }));
        }, this.onNativeScroll = ()=>{
            if (!this.__preventNextScrollEvent && !this.isScrolling) {
                const t = this.animatedScroll;
                this.animatedScroll = this.targetScroll = this.actualScroll, this.velocity = 0, this.direction = Math.sign(this.animatedScroll - t), this.emit();
            }
        }, window.lenisVersion = "1.0.42", t !== document.documentElement && t !== document.body || (t = window), this.options = {
            wrapper: t,
            content: e,
            wheelEventsTarget: i,
            eventsTarget: s,
            smoothWheel: o,
            syncTouch: n,
            syncTouchLerp: r,
            touchInertiaMultiplier: l,
            duration: h,
            easing: a,
            lerp: c,
            infinite: d,
            gestureOrientation: u,
            orientation: p,
            touchMultiplier: m,
            wheelMultiplier: v,
            autoResize: g,
            __experimental__naiveDimensions: S
        }, this.animate = new $f1ab3552fe1bc7f5$var$Animate, this.emitter = new $f1ab3552fe1bc7f5$var$Emitter, this.dimensions = new $f1ab3552fe1bc7f5$var$Dimensions({
            wrapper: t,
            content: e,
            autoResize: g
        }), this.toggleClassName("lenis", !0), this.velocity = 0, this.isLocked = !1, this.isStopped = !1, this.isSmooth = n || o, this.isScrolling = !1, this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll, !1), this.virtualScroll = new $f1ab3552fe1bc7f5$var$VirtualScroll(s, {
            touchMultiplier: m,
            wheelMultiplier: v
        }), this.virtualScroll.on("scroll", this.onVirtualScroll);
    }
}


function $5fe1d20aa3d34be2$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $5fe1d20aa3d34be2$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $5fe1d20aa3d34be2$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $5fe1d20aa3d34be2$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5fe1d20aa3d34be2$export$2e2bcd8739ae039 = $5fe1d20aa3d34be2$export$4f5d2d50c9deca37;



var $dhiZh = parcelRequire("dhiZh");
var $7d36cc7653b28d89$exports = {};
"use strict";
var $8e2bb89c4ea25468$exports = {};
"use strict";
var $8e2bb89c4ea25468$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $8e2bb89c4ea25468$var$createStore = function createStore(createState) {
    return createState ? $8e2bb89c4ea25468$var$createStoreImpl(createState) : $8e2bb89c4ea25468$var$createStoreImpl;
};
var $8e2bb89c4ea25468$var$vanilla = function(createState) {
    return $8e2bb89c4ea25468$var$createStore(createState);
};
$8e2bb89c4ea25468$exports.createStore = $8e2bb89c4ea25468$var$createStore;
$8e2bb89c4ea25468$exports.default = $8e2bb89c4ea25468$var$vanilla;
$8e2bb89c4ea25468$exports = $8e2bb89c4ea25468$var$vanilla;
$8e2bb89c4ea25468$exports.createStore = $8e2bb89c4ea25468$var$createStore;
$8e2bb89c4ea25468$exports.default = $8e2bb89c4ea25468$exports;



var $dhiZh = parcelRequire("dhiZh");
var $898b1b729a1112af$exports = {};
"use strict";

$898b1b729a1112af$exports = (parcelRequire("6VCbT"));


var $7d36cc7653b28d89$var$useDebugValue = $dhiZh.useDebugValue;
var $7d36cc7653b28d89$var$useSyncExternalStoreWithSelector = $898b1b729a1112af$exports.useSyncExternalStoreWithSelector;
var $7d36cc7653b28d89$var$didWarnAboutEqualityFn = false;
var $7d36cc7653b28d89$var$identity = function identity(arg) {
    return arg;
};
function $7d36cc7653b28d89$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $7d36cc7653b28d89$var$identity;
    var slice = $7d36cc7653b28d89$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $7d36cc7653b28d89$var$useDebugValue(slice);
    return slice;
}
var $7d36cc7653b28d89$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $8e2bb89c4ea25468$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $7d36cc7653b28d89$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $7d36cc7653b28d89$var$create = function create(createState) {
    return createState ? $7d36cc7653b28d89$var$createImpl(createState) : $7d36cc7653b28d89$var$createImpl;
};
var $7d36cc7653b28d89$var$react = function(createState) {
    return $7d36cc7653b28d89$var$create(createState);
};
$7d36cc7653b28d89$exports.create = $7d36cc7653b28d89$var$create;
$7d36cc7653b28d89$exports.default = $7d36cc7653b28d89$var$react;
$7d36cc7653b28d89$exports.useStore = $7d36cc7653b28d89$var$useStore;
Object.keys($8e2bb89c4ea25468$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($7d36cc7653b28d89$exports, k)) Object.defineProperty($7d36cc7653b28d89$exports, k, {
        enumerable: true,
        get: function() {
            return $8e2bb89c4ea25468$exports[k];
        }
    });
});
$7d36cc7653b28d89$exports = $7d36cc7653b28d89$var$react;
$7d36cc7653b28d89$exports.create = $7d36cc7653b28d89$var$create;
$7d36cc7653b28d89$exports.useStore = $7d36cc7653b28d89$var$useStore;
$7d36cc7653b28d89$exports.createStore = $8e2bb89c4ea25468$exports.createStore;
$7d36cc7653b28d89$exports.default = $7d36cc7653b28d89$exports;


"function" == typeof SuppressedError && SuppressedError;
"undefined" != typeof window && (window.reactLenisVersion = "0.0.47");
const $69a63ea936e703ee$export$1ef8c6637254aab6 = (0, $dhiZh.createContext)(null), $69a63ea936e703ee$var$m = (0, $7d36cc7653b28d89$exports.create)(()=>({}));
function $69a63ea936e703ee$export$69a110ee5442c47(r, e = [], t = 0) {
    const { lenis: n, addCallback: o, removeCallback: a } = function() {
        const r = (0, $dhiZh.useContext)($69a63ea936e703ee$export$1ef8c6637254aab6), e = $69a63ea936e703ee$var$m();
        return null != r ? r : e;
    }();
    return (0, $dhiZh.useEffect)(()=>{
        if (r && o && a && n) return o(r, t), r(n), ()=>{
            a(r);
        };
    }, [
        n,
        o,
        a,
        t,
        ...e
    ]), n;
}
const $69a63ea936e703ee$export$4be146f3ae50d23a = (0, $dhiZh.forwardRef)((o, a)=>{
    var { children: f, root: p = !1, options: b = {}, autoRaf: y = !0, rafPriority: v = 0, className: O } = o, g = function(r, e) {
        var t = {};
        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
        if (null != r && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for(n = Object.getOwnPropertySymbols(r); o < n.length; o++)e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[o]) && (t[n[o]] = r[n[o]]);
        }
        return t;
    }(o, [
        "children",
        "root",
        "options",
        "autoRaf",
        "rafPriority",
        "className"
    ]);
    const h = (0, $dhiZh.useRef)(null), w = (0, $dhiZh.useRef)(null), [k, N] = (0, $dhiZh.useState)(void 0), j = (0, $dhiZh.useRef)([]), C = (0, $dhiZh.useCallback)((r, e)=>{
        j.current.push({
            callback: r,
            priority: e
        }), j.current.sort((r, e)=>r.priority - e.priority);
    }, []), E = (0, $dhiZh.useCallback)((r)=>{
        j.current = j.current.filter((e)=>e.callback !== r);
    }, []);
    (0, $dhiZh.useImperativeHandle)(a, ()=>({
            wrapper: h.current,
            content: w.current,
            lenis: k
        }), [
        k
    ]), (0, $dhiZh.useEffect)(()=>{
        const r = new (0, $f1ab3552fe1bc7f5$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, b), !p && {
            wrapper: h.current,
            content: w.current
        }));
        return N(r), ()=>{
            r.destroy(), N(void 0);
        };
    }, [
        p,
        JSON.stringify(b)
    ]), (0, $bf4080a7da01e87e$export$82cf2c2b26f73925)((r)=>{
        y && (null == k || k.raf(r));
    }, v), (0, $dhiZh.useEffect)(()=>{
        p && k && $69a63ea936e703ee$var$m.setState({
            lenis: k,
            addCallback: C,
            removeCallback: E
        });
    }, [
        p,
        k,
        C,
        E
    ]);
    const P = (0, $dhiZh.useCallback)((r)=>{
        for(let e = 0; e < j.current.length; e++)j.current[e].callback(r);
    }, []);
    (0, $dhiZh.useEffect)(()=>(null == k || k.on("scroll", P), ()=>{
            null == k || k.off("scroll", P);
        }), [
        k,
        P
    ]);
    const S = (0, $dhiZh.useCallback)(()=>{
        h.current && (h.current.className = (0, $5fe1d20aa3d34be2$export$2e2bcd8739ae039)(null == k ? void 0 : k.className, O));
    }, [
        k,
        O
    ]);
    return (0, $dhiZh.useEffect)(()=>(S(), null == k || k.on("className change", S), ()=>{
            null == k || k.off("className change", S);
        }), [
        k,
        S
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement($69a63ea936e703ee$export$1ef8c6637254aab6.Provider, {
        value: {
            lenis: k,
            addCallback: C,
            removeCallback: E
        }
    }, p ? f : (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("div", Object.assign({
        ref: h,
        className: (0, $5fe1d20aa3d34be2$export$2e2bcd8739ae039)(null == k ? void 0 : k.className, O)
    }, g), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("div", {
        ref: w
    }, f)));
});



parcelRequire("dhiZh");
/**
 * React Router DOM v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dhiZh = parcelRequire("dhiZh");

var $b4Mpg = parcelRequire("b4Mpg");
/**
 * @remix-run/router v1.19.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $fb53f4cc03531a2e$var$_extends() {
    $fb53f4cc03531a2e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb53f4cc03531a2e$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $fb53f4cc03531a2e$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($fb53f4cc03531a2e$export$e19cd5f9376f8cee || ($fb53f4cc03531a2e$export$e19cd5f9376f8cee = {}));
const $fb53f4cc03531a2e$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $fb53f4cc03531a2e$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $fb53f4cc03531a2e$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $fb53f4cc03531a2e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $fb53f4cc03531a2e$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $fb53f4cc03531a2e$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $fb53f4cc03531a2e$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $fb53f4cc03531a2e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $fb53f4cc03531a2e$export$fe53371bee54353d(to);
    }
    return $fb53f4cc03531a2e$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $fb53f4cc03531a2e$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $fb53f4cc03531a2e$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $fb53f4cc03531a2e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $fb53f4cc03531a2e$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $fb53f4cc03531a2e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $fb53f4cc03531a2e$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $fb53f4cc03531a2e$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $fb53f4cc03531a2e$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $fb53f4cc03531a2e$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $fb53f4cc03531a2e$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $fb53f4cc03531a2e$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $fb53f4cc03531a2e$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $fb53f4cc03531a2e$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $fb53f4cc03531a2e$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $fb53f4cc03531a2e$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $fb53f4cc03531a2e$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $fb53f4cc03531a2e$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($fb53f4cc03531a2e$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Push;
        let location = $fb53f4cc03531a2e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $fb53f4cc03531a2e$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Replace;
        let location = $fb53f4cc03531a2e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $fb53f4cc03531a2e$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $fb53f4cc03531a2e$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $fb53f4cc03531a2e$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($fb53f4cc03531a2e$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($fb53f4cc03531a2e$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $fb53f4cc03531a2e$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($fb53f4cc03531a2e$var$ResultType || ($fb53f4cc03531a2e$var$ResultType = {}));
const $fb53f4cc03531a2e$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $fb53f4cc03531a2e$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $fb53f4cc03531a2e$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $fb53f4cc03531a2e$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $fb53f4cc03531a2e$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($fb53f4cc03531a2e$var$isIndexRoute(route)) {
            let indexRoute = $fb53f4cc03531a2e$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $fb53f4cc03531a2e$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $fb53f4cc03531a2e$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $fb53f4cc03531a2e$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $fb53f4cc03531a2e$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $fb53f4cc03531a2e$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $fb53f4cc03531a2e$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $fb53f4cc03531a2e$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $fb53f4cc03531a2e$var$flattenRoutes(routes);
    $fb53f4cc03531a2e$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $fb53f4cc03531a2e$export$30d21fd6d7295f52(pathname);
        matches = $fb53f4cc03531a2e$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $fb53f4cc03531a2e$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $fb53f4cc03531a2e$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $fb53f4cc03531a2e$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $fb53f4cc03531a2e$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $fb53f4cc03531a2e$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $fb53f4cc03531a2e$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $fb53f4cc03531a2e$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $fb53f4cc03531a2e$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $fb53f4cc03531a2e$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $fb53f4cc03531a2e$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $fb53f4cc03531a2e$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $fb53f4cc03531a2e$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $fb53f4cc03531a2e$var$paramRe = /^:[\w-]+$/;
const $fb53f4cc03531a2e$var$dynamicSegmentValue = 3;
const $fb53f4cc03531a2e$var$indexRouteValue = 2;
const $fb53f4cc03531a2e$var$emptySegmentValue = 1;
const $fb53f4cc03531a2e$var$staticSegmentValue = 10;
const $fb53f4cc03531a2e$var$splatPenalty = -2;
const $fb53f4cc03531a2e$var$isSplat = (s)=>s === "*";
function $fb53f4cc03531a2e$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($fb53f4cc03531a2e$var$isSplat)) initialScore += $fb53f4cc03531a2e$var$splatPenalty;
    if (index) initialScore += $fb53f4cc03531a2e$var$indexRouteValue;
    return segments.filter((s)=>!$fb53f4cc03531a2e$var$isSplat(s)).reduce((score, segment)=>score + ($fb53f4cc03531a2e$var$paramRe.test(segment) ? $fb53f4cc03531a2e$var$dynamicSegmentValue : segment === "" ? $fb53f4cc03531a2e$var$emptySegmentValue : $fb53f4cc03531a2e$var$staticSegmentValue), initialScore);
}
function $fb53f4cc03531a2e$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $fb53f4cc03531a2e$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $fb53f4cc03531a2e$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $fb53f4cc03531a2e$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $fb53f4cc03531a2e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $fb53f4cc03531a2e$export$a5c6d149b50c1d86($fb53f4cc03531a2e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $fb53f4cc03531a2e$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $fb53f4cc03531a2e$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $fb53f4cc03531a2e$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $fb53f4cc03531a2e$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $fb53f4cc03531a2e$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $fb53f4cc03531a2e$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $fb53f4cc03531a2e$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $fb53f4cc03531a2e$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $fb53f4cc03531a2e$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $fb53f4cc03531a2e$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $fb53f4cc03531a2e$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $fb53f4cc03531a2e$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $fb53f4cc03531a2e$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $fb53f4cc03531a2e$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $fb53f4cc03531a2e$var$normalizeSearch(search),
        hash: $fb53f4cc03531a2e$var$normalizeHash(hash)
    };
}
function $fb53f4cc03531a2e$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $fb53f4cc03531a2e$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $fb53f4cc03531a2e$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $fb53f4cc03531a2e$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $fb53f4cc03531a2e$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $fb53f4cc03531a2e$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $fb53f4cc03531a2e$export$8ccf933b0513f8d0(toArg);
    else {
        to = $fb53f4cc03531a2e$var$_extends({}, toArg);
        $fb53f4cc03531a2e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $fb53f4cc03531a2e$var$getInvalidPathError("?", "pathname", "search", to));
        $fb53f4cc03531a2e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $fb53f4cc03531a2e$var$getInvalidPathError("#", "pathname", "hash", to));
        $fb53f4cc03531a2e$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $fb53f4cc03531a2e$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $fb53f4cc03531a2e$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $fb53f4cc03531a2e$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $fb53f4cc03531a2e$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $fb53f4cc03531a2e$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $fb53f4cc03531a2e$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $fb53f4cc03531a2e$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $fb53f4cc03531a2e$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $fb53f4cc03531a2e$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $fb53f4cc03531a2e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $fb53f4cc03531a2e$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $fb53f4cc03531a2e$export$480182c6abbb2ff6(data, init) {
    return new $fb53f4cc03531a2e$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $fb53f4cc03531a2e$export$42a99a7a4bc0e76a extends Error {
}
class $fb53f4cc03531a2e$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $fb53f4cc03531a2e$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $fb53f4cc03531a2e$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $fb53f4cc03531a2e$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $fb53f4cc03531a2e$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $fb53f4cc03531a2e$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $fb53f4cc03531a2e$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $fb53f4cc03531a2e$var$unwrapTrackedPromise(value) {
    if (!$fb53f4cc03531a2e$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $fb53f4cc03531a2e$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $fb53f4cc03531a2e$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fb53f4cc03531a2e$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $fb53f4cc03531a2e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fb53f4cc03531a2e$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $fb53f4cc03531a2e$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fb53f4cc03531a2e$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $fb53f4cc03531a2e$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $fb53f4cc03531a2e$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $fb53f4cc03531a2e$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $fb53f4cc03531a2e$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $fb53f4cc03531a2e$var$validMutationMethods = new Set($fb53f4cc03531a2e$var$validMutationMethodsArr);
const $fb53f4cc03531a2e$var$validRequestMethodsArr = [
    "get",
    ...$fb53f4cc03531a2e$var$validMutationMethodsArr
];
const $fb53f4cc03531a2e$var$validRequestMethods = new Set($fb53f4cc03531a2e$var$validRequestMethodsArr);
const $fb53f4cc03531a2e$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $fb53f4cc03531a2e$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $fb53f4cc03531a2e$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fb53f4cc03531a2e$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fb53f4cc03531a2e$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $fb53f4cc03531a2e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $fb53f4cc03531a2e$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $fb53f4cc03531a2e$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $fb53f4cc03531a2e$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $fb53f4cc03531a2e$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fb53f4cc03531a2e$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $fb53f4cc03531a2e$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $fb53f4cc03531a2e$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $fb53f4cc03531a2e$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $fb53f4cc03531a2e$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $fb53f4cc03531a2e$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $fb53f4cc03531a2e$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $fb53f4cc03531a2e$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $fb53f4cc03531a2e$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $fb53f4cc03531a2e$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $fb53f4cc03531a2e$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$fb53f4cc03531a2e$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $fb53f4cc03531a2e$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $fb53f4cc03531a2e$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $fb53f4cc03531a2e$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $fb53f4cc03531a2e$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $fb53f4cc03531a2e$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($fb53f4cc03531a2e$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $fb53f4cc03531a2e$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $fb53f4cc03531a2e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $fb53f4cc03531a2e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $fb53f4cc03531a2e$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $fb53f4cc03531a2e$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $fb53f4cc03531a2e$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $fb53f4cc03531a2e$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $fb53f4cc03531a2e$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $fb53f4cc03531a2e$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $fb53f4cc03531a2e$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $fb53f4cc03531a2e$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $fb53f4cc03531a2e$var$findNearestBoundary(matches).route.id,
            {
                type: $fb53f4cc03531a2e$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $fb53f4cc03531a2e$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($fb53f4cc03531a2e$var$isErrorResult(result) && $fb53f4cc03531a2e$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $fb53f4cc03531a2e$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $fb53f4cc03531a2e$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $fb53f4cc03531a2e$var$_extends({
            matches: updatedMatches || matches
        }, $fb53f4cc03531a2e$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $fb53f4cc03531a2e$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $fb53f4cc03531a2e$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $fb53f4cc03531a2e$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $fb53f4cc03531a2e$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $fb53f4cc03531a2e$var$ResultType.error,
            error: $fb53f4cc03531a2e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($fb53f4cc03531a2e$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $fb53f4cc03531a2e$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($fb53f4cc03531a2e$var$isDeferredResult(result)) throw $fb53f4cc03531a2e$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($fb53f4cc03531a2e$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $fb53f4cc03531a2e$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $fb53f4cc03531a2e$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $fb53f4cc03531a2e$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($fb53f4cc03531a2e$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $fb53f4cc03531a2e$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $fb53f4cc03531a2e$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $fb53f4cc03531a2e$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $fb53f4cc03531a2e$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $fb53f4cc03531a2e$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fb53f4cc03531a2e$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $fb53f4cc03531a2e$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $fb53f4cc03531a2e$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $fb53f4cc03531a2e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $fb53f4cc03531a2e$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $fb53f4cc03531a2e$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $fb53f4cc03531a2e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $fb53f4cc03531a2e$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $fb53f4cc03531a2e$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $fb53f4cc03531a2e$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fb53f4cc03531a2e$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fb53f4cc03531a2e$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fb53f4cc03531a2e$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $fb53f4cc03531a2e$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($fb53f4cc03531a2e$var$isRedirectResult(actionResult) || $fb53f4cc03531a2e$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $fb53f4cc03531a2e$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($fb53f4cc03531a2e$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $fb53f4cc03531a2e$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $fb53f4cc03531a2e$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($fb53f4cc03531a2e$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($fb53f4cc03531a2e$var$isDeferredResult(actionResult)) throw $fb53f4cc03531a2e$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $fb53f4cc03531a2e$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $fb53f4cc03531a2e$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $fb53f4cc03531a2e$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $fb53f4cc03531a2e$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $fb53f4cc03531a2e$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $fb53f4cc03531a2e$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $fb53f4cc03531a2e$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false);
        redirect = $fb53f4cc03531a2e$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fb53f4cc03531a2e$var$processLoaderData(state, matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $fb53f4cc03531a2e$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $fb53f4cc03531a2e$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $fb53f4cc03531a2e$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fb53f4cc03531a2e$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fb53f4cc03531a2e$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fb53f4cc03531a2e$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $fb53f4cc03531a2e$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($fb53f4cc03531a2e$var$isDeferredResult(result)) result = await $fb53f4cc03531a2e$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $fb53f4cc03531a2e$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($fb53f4cc03531a2e$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $fb53f4cc03531a2e$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($fb53f4cc03531a2e$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $fb53f4cc03531a2e$export$3e9cee6b33872309(!$fb53f4cc03531a2e$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $fb53f4cc03531a2e$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $fb53f4cc03531a2e$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $fb53f4cc03531a2e$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $fb53f4cc03531a2e$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($fb53f4cc03531a2e$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $fb53f4cc03531a2e$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Replace : $fb53f4cc03531a2e$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $fb53f4cc03531a2e$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($fb53f4cc03531a2e$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $fb53f4cc03531a2e$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $fb53f4cc03531a2e$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $fb53f4cc03531a2e$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $fb53f4cc03531a2e$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $fb53f4cc03531a2e$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($fb53f4cc03531a2e$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $fb53f4cc03531a2e$var$ResultType.redirect,
                response: $fb53f4cc03531a2e$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $fb53f4cc03531a2e$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $fb53f4cc03531a2e$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $fb53f4cc03531a2e$var$ResultType.error,
                    error: $fb53f4cc03531a2e$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $fb53f4cc03531a2e$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $fb53f4cc03531a2e$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $fb53f4cc03531a2e$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $fb53f4cc03531a2e$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $fb53f4cc03531a2e$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $fb53f4cc03531a2e$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $fb53f4cc03531a2e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $fb53f4cc03531a2e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $fb53f4cc03531a2e$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $fb53f4cc03531a2e$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $fb53f4cc03531a2e$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $fb53f4cc03531a2e$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $fb53f4cc03531a2e$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $fb53f4cc03531a2e$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $fb53f4cc03531a2e$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $fb53f4cc03531a2e$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $fb53f4cc03531a2e$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$fb53f4cc03531a2e$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                let fogMatches = $fb53f4cc03531a2e$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $fb53f4cc03531a2e$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $fb53f4cc03531a2e$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $fb53f4cc03531a2e$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = $fb53f4cc03531a2e$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $fb53f4cc03531a2e$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $fb53f4cc03531a2e$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $fb53f4cc03531a2e$export$4d0306f8f6a4585b = Symbol("deferred");
function $fb53f4cc03531a2e$export$3336b097a6fbc59a(routes, opts) {
    $fb53f4cc03531a2e$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fb53f4cc03531a2e$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $fb53f4cc03531a2e$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $fb53f4cc03531a2e$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fb53f4cc03531a2e$var$createLocation("", $fb53f4cc03531a2e$export$fe53371bee54353d(url), null, "default");
        let matches = $fb53f4cc03531a2e$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fb53f4cc03531a2e$var$isValidMethod(method) && method !== "HEAD") {
            let error = $fb53f4cc03531a2e$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $fb53f4cc03531a2e$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $fb53f4cc03531a2e$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $fb53f4cc03531a2e$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($fb53f4cc03531a2e$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $fb53f4cc03531a2e$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fb53f4cc03531a2e$var$createLocation("", $fb53f4cc03531a2e$export$fe53371bee54353d(url), null, "default");
        let matches = $fb53f4cc03531a2e$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fb53f4cc03531a2e$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $fb53f4cc03531a2e$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $fb53f4cc03531a2e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $fb53f4cc03531a2e$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $fb53f4cc03531a2e$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $fb53f4cc03531a2e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($fb53f4cc03531a2e$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$fb53f4cc03531a2e$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $fb53f4cc03531a2e$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($fb53f4cc03531a2e$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $fb53f4cc03531a2e$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $fb53f4cc03531a2e$var$isResponse(result) ? result : $fb53f4cc03531a2e$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($fb53f4cc03531a2e$var$isDataStrategyResult(e) && $fb53f4cc03531a2e$var$isResponse(e.result)) {
                if (e.type === $fb53f4cc03531a2e$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($fb53f4cc03531a2e$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $fb53f4cc03531a2e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fb53f4cc03531a2e$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $fb53f4cc03531a2e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($fb53f4cc03531a2e$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($fb53f4cc03531a2e$var$isDeferredResult(result)) {
            let error = $fb53f4cc03531a2e$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fb53f4cc03531a2e$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($fb53f4cc03531a2e$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($fb53f4cc03531a2e$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fb53f4cc03531a2e$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $fb53f4cc03531a2e$var$_extends({}, context, {
                statusCode: $fb53f4cc03531a2e$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $fb53f4cc03531a2e$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $fb53f4cc03531a2e$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $fb53f4cc03531a2e$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1]) ? $fb53f4cc03531a2e$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $fb53f4cc03531a2e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $fb53f4cc03531a2e$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $fb53f4cc03531a2e$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $fb53f4cc03531a2e$var$callDataStrategyImpl(unstable_dataStrategy || $fb53f4cc03531a2e$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($fb53f4cc03531a2e$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $fb53f4cc03531a2e$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($fb53f4cc03531a2e$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $fb53f4cc03531a2e$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $fb53f4cc03531a2e$export$fec11da027c70692(routes, context, error) {
    let newContext = $fb53f4cc03531a2e$var$_extends({}, context, {
        statusCode: $fb53f4cc03531a2e$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $fb53f4cc03531a2e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $fb53f4cc03531a2e$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $fb53f4cc03531a2e$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $fb53f4cc03531a2e$export$cae722b0cc860f13(to ? to : ".", $fb53f4cc03531a2e$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $fb53f4cc03531a2e$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$fb53f4cc03531a2e$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $fb53f4cc03531a2e$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $fb53f4cc03531a2e$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $fb53f4cc03531a2e$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$fb53f4cc03531a2e$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$fb53f4cc03531a2e$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $fb53f4cc03531a2e$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $fb53f4cc03531a2e$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $fb53f4cc03531a2e$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$fb53f4cc03531a2e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$fb53f4cc03531a2e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $fb53f4cc03531a2e$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $fb53f4cc03531a2e$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $fb53f4cc03531a2e$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $fb53f4cc03531a2e$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $fb53f4cc03531a2e$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($fb53f4cc03531a2e$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $fb53f4cc03531a2e$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $fb53f4cc03531a2e$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $fb53f4cc03531a2e$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $fb53f4cc03531a2e$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $fb53f4cc03531a2e$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $fb53f4cc03531a2e$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($fb53f4cc03531a2e$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $fb53f4cc03531a2e$var$shouldRevalidateLoader(match, $fb53f4cc03531a2e$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $fb53f4cc03531a2e$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $fb53f4cc03531a2e$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $fb53f4cc03531a2e$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $fb53f4cc03531a2e$var$shouldRevalidateLoader(fetcherMatch, $fb53f4cc03531a2e$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $fb53f4cc03531a2e$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $fb53f4cc03531a2e$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $fb53f4cc03531a2e$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $fb53f4cc03531a2e$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $fb53f4cc03531a2e$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $fb53f4cc03531a2e$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $fb53f4cc03531a2e$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $fb53f4cc03531a2e$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $fb53f4cc03531a2e$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $fb53f4cc03531a2e$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $fb53f4cc03531a2e$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $fb53f4cc03531a2e$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $fb53f4cc03531a2e$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$fb53f4cc03531a2e$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $fb53f4cc03531a2e$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $fb53f4cc03531a2e$var$defaultDataStrategy(_ref6) {
    let { matches: matches } = _ref6;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $fb53f4cc03531a2e$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $fb53f4cc03531a2e$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $fb53f4cc03531a2e$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $fb53f4cc03531a2e$var$ResultType.data,
                result: undefined
            });
        };
        return $fb53f4cc03531a2e$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $fb53f4cc03531a2e$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $fb53f4cc03531a2e$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $fb53f4cc03531a2e$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $fb53f4cc03531a2e$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $fb53f4cc03531a2e$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $fb53f4cc03531a2e$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $fb53f4cc03531a2e$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($fb53f4cc03531a2e$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $fb53f4cc03531a2e$var$ResultType.error,
                error: e
            };
        }
        if (type === $fb53f4cc03531a2e$var$ResultType.error) return {
            type: $fb53f4cc03531a2e$var$ResultType.error,
            error: new $fb53f4cc03531a2e$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $fb53f4cc03531a2e$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $fb53f4cc03531a2e$var$ResultType.error) {
        if ($fb53f4cc03531a2e$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $fb53f4cc03531a2e$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $fb53f4cc03531a2e$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $fb53f4cc03531a2e$var$ResultType.error,
            error: result,
            statusCode: $fb53f4cc03531a2e$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($fb53f4cc03531a2e$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $fb53f4cc03531a2e$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($fb53f4cc03531a2e$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $fb53f4cc03531a2e$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $fb53f4cc03531a2e$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $fb53f4cc03531a2e$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $fb53f4cc03531a2e$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$fb53f4cc03531a2e$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $fb53f4cc03531a2e$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $fb53f4cc03531a2e$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($fb53f4cc03531a2e$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $fb53f4cc03531a2e$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $fb53f4cc03531a2e$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($fb53f4cc03531a2e$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $fb53f4cc03531a2e$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $fb53f4cc03531a2e$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $fb53f4cc03531a2e$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $fb53f4cc03531a2e$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $fb53f4cc03531a2e$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $fb53f4cc03531a2e$export$3e9cee6b33872309(!$fb53f4cc03531a2e$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($fb53f4cc03531a2e$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $fb53f4cc03531a2e$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $fb53f4cc03531a2e$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($fb53f4cc03531a2e$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $fb53f4cc03531a2e$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $fb53f4cc03531a2e$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $fb53f4cc03531a2e$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($fb53f4cc03531a2e$var$isErrorResult(result)) {
            let boundaryMatch = $fb53f4cc03531a2e$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $fb53f4cc03531a2e$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($fb53f4cc03531a2e$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $fb53f4cc03531a2e$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($fb53f4cc03531a2e$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $fb53f4cc03531a2e$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $fb53f4cc03531a2e$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $fb53f4cc03531a2e$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $fb53f4cc03531a2e$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $fb53f4cc03531a2e$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $fb53f4cc03531a2e$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $fb53f4cc03531a2e$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $fb53f4cc03531a2e$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $fb53f4cc03531a2e$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $fb53f4cc03531a2e$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $fb53f4cc03531a2e$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($fb53f4cc03531a2e$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $fb53f4cc03531a2e$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $fb53f4cc03531a2e$export$8ccf933b0513f8d0(path) : path;
    return $fb53f4cc03531a2e$export$fe53371bee54353d($fb53f4cc03531a2e$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $fb53f4cc03531a2e$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $fb53f4cc03531a2e$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $fb53f4cc03531a2e$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $fb53f4cc03531a2e$var$ResultType.data || result.type === $fb53f4cc03531a2e$var$ResultType.error);
}
function $fb53f4cc03531a2e$var$isRedirectDataStrategyResultResult(result) {
    return $fb53f4cc03531a2e$var$isResponse(result.result) && $fb53f4cc03531a2e$var$redirectStatusCodes.has(result.result.status);
}
function $fb53f4cc03531a2e$var$isDeferredResult(result) {
    return result.type === $fb53f4cc03531a2e$var$ResultType.deferred;
}
function $fb53f4cc03531a2e$var$isErrorResult(result) {
    return result.type === $fb53f4cc03531a2e$var$ResultType.error;
}
function $fb53f4cc03531a2e$var$isRedirectResult(result) {
    return (result && result.type) === $fb53f4cc03531a2e$var$ResultType.redirect;
}
function $fb53f4cc03531a2e$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $fb53f4cc03531a2e$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $fb53f4cc03531a2e$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $fb53f4cc03531a2e$var$isRedirectResponse(result) {
    if (!$fb53f4cc03531a2e$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $fb53f4cc03531a2e$var$isValidMethod(method) {
    return $fb53f4cc03531a2e$var$validRequestMethods.has(method.toLowerCase());
}
function $fb53f4cc03531a2e$var$isMutationMethod(method) {
    return $fb53f4cc03531a2e$var$validMutationMethods.has(method.toLowerCase());
}
async function $fb53f4cc03531a2e$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$fb53f4cc03531a2e$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($fb53f4cc03531a2e$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $fb53f4cc03531a2e$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $fb53f4cc03531a2e$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($fb53f4cc03531a2e$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $fb53f4cc03531a2e$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $fb53f4cc03531a2e$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $fb53f4cc03531a2e$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $fb53f4cc03531a2e$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $fb53f4cc03531a2e$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $fb53f4cc03531a2e$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $fb53f4cc03531a2e$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $fb53f4cc03531a2e$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $fb53f4cc03531a2e$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $fb53f4cc03531a2e$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $fb53f4cc03531a2e$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $fb53f4cc03531a2e$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $fb53f4cc03531a2e$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $fb53f4cc03531a2e$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $fb53f4cc03531a2e$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $fb53f4cc03531a2e$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $fb53f4cc03531a2e$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $fb53f4cc03531a2e$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($fb53f4cc03531a2e$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $fb53f4cc03531a2e$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($fb53f4cc03531a2e$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $fb53f4cc03531a2e$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dhiZh = parcelRequire("dhiZh");

function $5687d04bb9f2cada$var$_extends() {
    $5687d04bb9f2cada$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5687d04bb9f2cada$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $5687d04bb9f2cada$export$3add0d5dce533e2e = /*#__PURE__*/ $dhiZh.createContext(null);
const $5687d04bb9f2cada$export$145dfa71566a64dc = /*#__PURE__*/ $dhiZh.createContext(null);
const $5687d04bb9f2cada$var$AwaitContext = /*#__PURE__*/ $dhiZh.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $5687d04bb9f2cada$export$26749e8557646306 = /*#__PURE__*/ $dhiZh.createContext(null);
const $5687d04bb9f2cada$export$c7914228fb69b0f5 = /*#__PURE__*/ $dhiZh.createContext(null);
const $5687d04bb9f2cada$export$9072aa6dd1f93057 = /*#__PURE__*/ $dhiZh.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $5687d04bb9f2cada$var$RouteErrorContext = /*#__PURE__*/ $dhiZh.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $5687d04bb9f2cada$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5687d04bb9f2cada$export$9c954a9d03d32f4a() && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $dhiZh.useContext($5687d04bb9f2cada$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5687d04bb9f2cada$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $fb53f4cc03531a2e$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $5687d04bb9f2cada$export$9c954a9d03d32f4a() {
    return $dhiZh.useContext($5687d04bb9f2cada$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $5687d04bb9f2cada$export$45d76561a5302f2b() {
    !$5687d04bb9f2cada$export$9c954a9d03d32f4a() && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    return $dhiZh.useContext($5687d04bb9f2cada$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $5687d04bb9f2cada$export$1b3f31771c5d07c() {
    return $dhiZh.useContext($5687d04bb9f2cada$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $5687d04bb9f2cada$export$6c330e8992e8a295(pattern) {
    !$5687d04bb9f2cada$export$9c954a9d03d32f4a() && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $5687d04bb9f2cada$export$45d76561a5302f2b();
    return $dhiZh.useMemo(()=>(0, $fb53f4cc03531a2e$export$81336c211d5ff295)(pattern, (0, $fb53f4cc03531a2e$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $5687d04bb9f2cada$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $5687d04bb9f2cada$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $dhiZh.useContext($5687d04bb9f2cada$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dhiZh.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $5687d04bb9f2cada$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $5687d04bb9f2cada$var$useNavigateStable() : $5687d04bb9f2cada$var$useNavigateUnstable();
}
function $5687d04bb9f2cada$var$useNavigateUnstable() {
    !$5687d04bb9f2cada$export$9c954a9d03d32f4a() && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    let dataRouterContext = $dhiZh.useContext($5687d04bb9f2cada$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $dhiZh.useContext($5687d04bb9f2cada$export$26749e8557646306);
    let { matches: matches } = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5687d04bb9f2cada$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fb53f4cc03531a2e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $dhiZh.useRef(false);
    $5687d04bb9f2cada$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dhiZh.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $fb53f4cc03531a2e$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fb53f4cc03531a2e$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $5687d04bb9f2cada$var$OutletContext = /*#__PURE__*/ $dhiZh.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $5687d04bb9f2cada$export$4138103a3ae699cc() {
    return $dhiZh.useContext($5687d04bb9f2cada$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $5687d04bb9f2cada$export$a3be3530d8e40d0b(context) {
    let outlet = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $5687d04bb9f2cada$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $5687d04bb9f2cada$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $dhiZh.useContext($5687d04bb9f2cada$export$26749e8557646306);
    let { matches: matches } = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5687d04bb9f2cada$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fb53f4cc03531a2e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $dhiZh.useMemo(()=>(0, $fb53f4cc03531a2e$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $5687d04bb9f2cada$export$5d3fca4a98652595(routes, locationArg) {
    return $5687d04bb9f2cada$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $5687d04bb9f2cada$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$5687d04bb9f2cada$export$9c954a9d03d32f4a() && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $dhiZh.useContext($5687d04bb9f2cada$export$26749e8557646306);
    let { matches: parentMatches } = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $5687d04bb9f2cada$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fb53f4cc03531a2e$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $fb53f4cc03531a2e$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $5687d04bb9f2cada$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $fb53f4cc03531a2e$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $fb53f4cc03531a2e$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5687d04bb9f2cada$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $fb53f4cc03531a2e$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5687d04bb9f2cada$var$DefaultErrorComponent() {
    let error = $5687d04bb9f2cada$export$ed527bf60f6e05f2();
    let message = (0, $fb53f4cc03531a2e$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $dhiZh.createElement($dhiZh.Fragment, null, /*#__PURE__*/ $dhiZh.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dhiZh.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dhiZh.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $5687d04bb9f2cada$var$defaultErrorElement = /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$DefaultErrorComponent, null);
class $5687d04bb9f2cada$var$RenderErrorBoundary extends $dhiZh.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $5687d04bb9f2cada$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $dhiZh.useContext($5687d04bb9f2cada$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5687d04bb9f2cada$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $5687d04bb9f2cada$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5687d04bb9f2cada$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dhiZh.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $5687d04bb9f2cada$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($5687d04bb9f2cada$var$DataRouterHook || {});
var $5687d04bb9f2cada$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($5687d04bb9f2cada$var$DataRouterStateHook || {});
function $5687d04bb9f2cada$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5687d04bb9f2cada$var$useDataRouterContext(hookName) {
    let ctx = $dhiZh.useContext($5687d04bb9f2cada$export$3add0d5dce533e2e);
    !ctx && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    return ctx;
}
function $5687d04bb9f2cada$var$useDataRouterState(hookName) {
    let state = $dhiZh.useContext($5687d04bb9f2cada$export$145dfa71566a64dc);
    !state && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    return state;
}
function $5687d04bb9f2cada$var$useRouteContext(hookName) {
    let route = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057);
    !route && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $5687d04bb9f2cada$var$useCurrentRouteId(hookName) {
    let route = $5687d04bb9f2cada$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $5687d04bb9f2cada$export$5fc8298006ad9e58() {
    return $5687d04bb9f2cada$var$useCurrentRouteId($5687d04bb9f2cada$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5687d04bb9f2cada$export$d0fd4b7106de2769() {
    let state = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5687d04bb9f2cada$export$600dc272ed516c15() {
    let dataRouterContext = $5687d04bb9f2cada$var$useDataRouterContext($5687d04bb9f2cada$var$DataRouterHook.UseRevalidator);
    let state = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseRevalidator);
    return $dhiZh.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5687d04bb9f2cada$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseMatches);
    return $dhiZh.useMemo(()=>matches.map((m)=>(0, $fb53f4cc03531a2e$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5687d04bb9f2cada$export$1448a5050d252c4d() {
    let state = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseLoaderData);
    let routeId = $5687d04bb9f2cada$var$useCurrentRouteId($5687d04bb9f2cada$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5687d04bb9f2cada$export$fd5d37484eab868d(routeId) {
    let state = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5687d04bb9f2cada$export$fdc00f3f26066d5e() {
    let state = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseActionData);
    let routeId = $5687d04bb9f2cada$var$useCurrentRouteId($5687d04bb9f2cada$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $5687d04bb9f2cada$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $dhiZh.useContext($5687d04bb9f2cada$var$RouteErrorContext);
    let state = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseRouteError);
    let routeId = $5687d04bb9f2cada$var$useCurrentRouteId($5687d04bb9f2cada$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $5687d04bb9f2cada$export$78a72ddb39bdd145() {
    let value = $dhiZh.useContext($5687d04bb9f2cada$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $5687d04bb9f2cada$export$17f53340677d5831() {
    let value = $dhiZh.useContext($5687d04bb9f2cada$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $5687d04bb9f2cada$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $5687d04bb9f2cada$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5687d04bb9f2cada$var$useDataRouterContext($5687d04bb9f2cada$var$DataRouterHook.UseBlocker);
    let state = $5687d04bb9f2cada$var$useDataRouterState($5687d04bb9f2cada$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $dhiZh.useState("");
    let blockerFunction = $dhiZh.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $5687d04bb9f2cada$var$_extends({}, currentLocation, {
                pathname: (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $5687d04bb9f2cada$var$_extends({}, nextLocation, {
                pathname: (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dhiZh.useEffect(()=>{
        let key = String(++$5687d04bb9f2cada$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dhiZh.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $fb53f4cc03531a2e$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $5687d04bb9f2cada$var$useNavigateStable() {
    let { router: router } = $5687d04bb9f2cada$var$useDataRouterContext($5687d04bb9f2cada$var$DataRouterHook.UseNavigateStable);
    let id = $5687d04bb9f2cada$var$useCurrentRouteId($5687d04bb9f2cada$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $dhiZh.useRef(false);
    $5687d04bb9f2cada$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dhiZh.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $5687d04bb9f2cada$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $5687d04bb9f2cada$var$alreadyWarned = {};
function $5687d04bb9f2cada$var$warningOnce(key, cond, message) {
    if (!cond && !$5687d04bb9f2cada$var$alreadyWarned[key]) $5687d04bb9f2cada$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5687d04bb9f2cada$var$START_TRANSITION = "startTransition";
const $5687d04bb9f2cada$var$startTransitionImpl = $dhiZh[$5687d04bb9f2cada$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5687d04bb9f2cada$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dhiZh.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dhiZh.useCallback((newState)=>{
        if (v7_startTransition && $5687d04bb9f2cada$var$startTransitionImpl) $5687d04bb9f2cada$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dhiZh.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $dhiZh.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dhiZh.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dhiZh.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dhiZh.createElement($dhiZh.Fragment, null, /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $5687d04bb9f2cada$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $5687d04bb9f2cada$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $5687d04bb9f2cada$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $dhiZh.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fb53f4cc03531a2e$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dhiZh.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dhiZh.useCallback((newState)=>{
        v7_startTransition && $5687d04bb9f2cada$var$startTransitionImpl ? $5687d04bb9f2cada$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dhiZh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $5687d04bb9f2cada$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$5687d04bb9f2cada$export$9c954a9d03d32f4a() && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $dhiZh.useContext($5687d04bb9f2cada$export$26749e8557646306);
    let { matches: matches } = $dhiZh.useContext($5687d04bb9f2cada$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5687d04bb9f2cada$export$45d76561a5302f2b();
    let navigate = $5687d04bb9f2cada$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $fb53f4cc03531a2e$export$cae722b0cc860f13)(to, (0, $fb53f4cc03531a2e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $dhiZh.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $5687d04bb9f2cada$export$910ae8079b2c2852(props) {
    return $5687d04bb9f2cada$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $5687d04bb9f2cada$export$e7b0ac011bb776c6(_props) {
    (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $5687d04bb9f2cada$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fb53f4cc03531a2e$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$5687d04bb9f2cada$export$9c954a9d03d32f4a() && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $dhiZh.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $5687d04bb9f2cada$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fb53f4cc03531a2e$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $dhiZh.useMemo(()=>{
        let trailingPathname = (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $5687d04bb9f2cada$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $5687d04bb9f2cada$export$5d3fca4a98652595($5687d04bb9f2cada$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5687d04bb9f2cada$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$ResolveAwait, null, children));
}
var $5687d04bb9f2cada$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($5687d04bb9f2cada$var$AwaitRenderStatus || {});
const $5687d04bb9f2cada$var$neverSettledPromise = new Promise(()=>{});
class $5687d04bb9f2cada$var$AwaitErrorBoundary extends $dhiZh.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5687d04bb9f2cada$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5687d04bb9f2cada$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5687d04bb9f2cada$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $5687d04bb9f2cada$var$AwaitRenderStatus.error : "_data" in promise ? $5687d04bb9f2cada$var$AwaitRenderStatus.success : $5687d04bb9f2cada$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5687d04bb9f2cada$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5687d04bb9f2cada$var$AwaitRenderStatus.error && promise._error instanceof (0, $fb53f4cc03531a2e$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $5687d04bb9f2cada$var$neverSettledPromise;
        if (status === $5687d04bb9f2cada$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5687d04bb9f2cada$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5687d04bb9f2cada$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $dhiZh.createElement($5687d04bb9f2cada$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $5687d04bb9f2cada$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $5687d04bb9f2cada$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dhiZh.createElement($dhiZh.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $5687d04bb9f2cada$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $dhiZh.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $dhiZh.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $dhiZh.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5687d04bb9f2cada$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $5687d04bb9f2cada$export$e7b0ac011bb776c6) && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5687d04bb9f2cada$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5687d04bb9f2cada$export$daf73786167a7f72(matches) {
    return $5687d04bb9f2cada$var$_renderMatches(matches);
}
function $5687d04bb9f2cada$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dhiZh.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dhiZh.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dhiZh.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $5687d04bb9f2cada$export$f30f7e456d254e83(routes, opts) {
    return (0, $fb53f4cc03531a2e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5687d04bb9f2cada$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fb53f4cc03531a2e$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $5687d04bb9f2cada$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}



function $ff12a13c25436077$var$_extends() {
    $ff12a13c25436077$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff12a13c25436077$var$_extends.apply(this, arguments);
}
function $ff12a13c25436077$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $ff12a13c25436077$var$defaultMethod = "get";
const $ff12a13c25436077$var$defaultEncType = "application/x-www-form-urlencoded";
function $ff12a13c25436077$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ff12a13c25436077$var$isButtonElement(object) {
    return $ff12a13c25436077$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ff12a13c25436077$var$isFormElement(object) {
    return $ff12a13c25436077$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ff12a13c25436077$var$isInputElement(object) {
    return $ff12a13c25436077$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ff12a13c25436077$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ff12a13c25436077$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ff12a13c25436077$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ff12a13c25436077$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ff12a13c25436077$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ff12a13c25436077$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $ff12a13c25436077$var$_formDataSupportsSubmitter = null;
function $ff12a13c25436077$var$isFormDataSubmitterSupported() {
    if ($ff12a13c25436077$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ff12a13c25436077$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ff12a13c25436077$var$_formDataSupportsSubmitter = true;
    }
    return $ff12a13c25436077$var$_formDataSupportsSubmitter;
}
const $ff12a13c25436077$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ff12a13c25436077$var$getFormEncType(encType) {
    if (encType != null && !$ff12a13c25436077$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ff12a13c25436077$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ff12a13c25436077$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $ff12a13c25436077$var$defaultMethod;
        encType = $ff12a13c25436077$var$getFormEncType(target.getAttribute("enctype")) || $ff12a13c25436077$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ff12a13c25436077$var$isButtonElement(target) || $ff12a13c25436077$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ff12a13c25436077$var$defaultMethod;
        encType = $ff12a13c25436077$var$getFormEncType(target.getAttribute("formenctype")) || $ff12a13c25436077$var$getFormEncType(form.getAttribute("enctype")) || $ff12a13c25436077$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ff12a13c25436077$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ff12a13c25436077$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ff12a13c25436077$var$defaultMethod;
        action = null;
        encType = $ff12a13c25436077$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $ff12a13c25436077$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $ff12a13c25436077$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $ff12a13c25436077$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $ff12a13c25436077$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $ff12a13c25436077$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $ff12a13c25436077$export$1f3f55432a00e06d(routes, opts) {
    return (0, $fb53f4cc03531a2e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ff12a13c25436077$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fb53f4cc03531a2e$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ff12a13c25436077$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5687d04bb9f2cada$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ff12a13c25436077$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $fb53f4cc03531a2e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ff12a13c25436077$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fb53f4cc03531a2e$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ff12a13c25436077$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5687d04bb9f2cada$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ff12a13c25436077$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ff12a13c25436077$var$_extends({}, state, {
        errors: $ff12a13c25436077$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ff12a13c25436077$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $fb53f4cc03531a2e$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $ff12a13c25436077$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dhiZh.createContext({
    isTransitioning: false
});
const $ff12a13c25436077$export$148fd98d095596d4 = /*#__PURE__*/ $dhiZh.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ff12a13c25436077$var$START_TRANSITION = "startTransition";
const $ff12a13c25436077$var$startTransitionImpl = $dhiZh[$ff12a13c25436077$var$START_TRANSITION];
const $ff12a13c25436077$var$FLUSH_SYNC = "flushSync";
const $ff12a13c25436077$var$flushSyncImpl = $b4Mpg[$ff12a13c25436077$var$FLUSH_SYNC];
const $ff12a13c25436077$var$USE_ID = "useId";
const $ff12a13c25436077$var$useIdImpl = $dhiZh[$ff12a13c25436077$var$USE_ID];
function $ff12a13c25436077$var$startTransitionSafe(cb) {
    if ($ff12a13c25436077$var$startTransitionImpl) $ff12a13c25436077$var$startTransitionImpl(cb);
    else cb();
}
function $ff12a13c25436077$var$flushSyncSafe(cb) {
    if ($ff12a13c25436077$var$flushSyncImpl) $ff12a13c25436077$var$flushSyncImpl(cb);
    else cb();
}
class $ff12a13c25436077$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ff12a13c25436077$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dhiZh.useState(router.state);
    let [pendingState, setPendingState] = $dhiZh.useState();
    let [vtContext, setVtContext] = $dhiZh.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $dhiZh.useState();
    let [transition, setTransition] = $dhiZh.useState();
    let [interruption, setInterruption] = $dhiZh.useState();
    let fetcherData = $dhiZh.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $dhiZh.useCallback((cb)=>{
        if (v7_startTransition) $ff12a13c25436077$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $dhiZh.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $ff12a13c25436077$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $ff12a13c25436077$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $ff12a13c25436077$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $ff12a13c25436077$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $ff12a13c25436077$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dhiZh.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dhiZh.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ff12a13c25436077$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dhiZh.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dhiZh.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dhiZh.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dhiZh.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dhiZh.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dhiZh.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $dhiZh.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dhiZh.createElement($dhiZh.Fragment, null, /*#__PURE__*/ $dhiZh.createElement((0, $5687d04bb9f2cada$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dhiZh.createElement((0, $5687d04bb9f2cada$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $dhiZh.createElement($ff12a13c25436077$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dhiZh.createElement($ff12a13c25436077$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dhiZh.createElement((0, $5687d04bb9f2cada$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dhiZh.createElement($ff12a13c25436077$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $ff12a13c25436077$var$MemoizedDataRoutes = /*#__PURE__*/ $dhiZh.memo($ff12a13c25436077$var$DataRoutes);
function $ff12a13c25436077$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5687d04bb9f2cada$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ff12a13c25436077$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $dhiZh.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fb53f4cc03531a2e$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dhiZh.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dhiZh.useCallback((newState)=>{
        v7_startTransition && $ff12a13c25436077$var$startTransitionImpl ? $ff12a13c25436077$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dhiZh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dhiZh.createElement((0, $5687d04bb9f2cada$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ff12a13c25436077$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $dhiZh.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fb53f4cc03531a2e$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dhiZh.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dhiZh.useCallback((newState)=>{
        v7_startTransition && $ff12a13c25436077$var$startTransitionImpl ? $ff12a13c25436077$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dhiZh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dhiZh.createElement((0, $5687d04bb9f2cada$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ff12a13c25436077$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $dhiZh.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dhiZh.useCallback((newState)=>{
        v7_startTransition && $ff12a13c25436077$var$startTransitionImpl ? $ff12a13c25436077$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dhiZh.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dhiZh.createElement((0, $5687d04bb9f2cada$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $ff12a13c25436077$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $ff12a13c25436077$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $ff12a13c25436077$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dhiZh.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $ff12a13c25436077$var$_objectWithoutPropertiesLoose(_ref7, $ff12a13c25436077$var$_excluded);
    let { basename: basename } = $dhiZh.useContext((0, $5687d04bb9f2cada$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $ff12a13c25436077$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ff12a13c25436077$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5687d04bb9f2cada$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $ff12a13c25436077$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dhiZh.createElement("a", $ff12a13c25436077$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $ff12a13c25436077$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dhiZh.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $ff12a13c25436077$var$_objectWithoutPropertiesLoose(_ref8, $ff12a13c25436077$var$_excluded2);
    let path = (0, $5687d04bb9f2cada$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $5687d04bb9f2cada$export$45d76561a5302f2b)();
    let routerState = $dhiZh.useContext((0, $5687d04bb9f2cada$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $dhiZh.useContext((0, $5687d04bb9f2cada$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ff12a13c25436077$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dhiZh.createElement($ff12a13c25436077$export$a6c7ac8248d6e38a, $ff12a13c25436077$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $ff12a13c25436077$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dhiZh.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $ff12a13c25436077$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $ff12a13c25436077$var$_objectWithoutPropertiesLoose(_ref9, $ff12a13c25436077$var$_excluded3);
    let submit = $ff12a13c25436077$export$47c85c6e3a081d3();
    let formAction = $ff12a13c25436077$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $dhiZh.createElement("form", $ff12a13c25436077$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ff12a13c25436077$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $ff12a13c25436077$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ff12a13c25436077$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ff12a13c25436077$var$DataRouterHook || ($ff12a13c25436077$var$DataRouterHook = {}));
var $ff12a13c25436077$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ff12a13c25436077$var$DataRouterStateHook || ($ff12a13c25436077$var$DataRouterStateHook = {}));
// Internal hooks
function $ff12a13c25436077$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $ff12a13c25436077$var$useDataRouterContext(hookName) {
    let ctx = $dhiZh.useContext((0, $5687d04bb9f2cada$export$3add0d5dce533e2e));
    !ctx && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ff12a13c25436077$var$useDataRouterState(hookName) {
    let state = $dhiZh.useContext((0, $5687d04bb9f2cada$export$145dfa71566a64dc));
    !state && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ff12a13c25436077$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5687d04bb9f2cada$export$9770f232ac06a008)();
    let location = (0, $5687d04bb9f2cada$export$45d76561a5302f2b)();
    let path = (0, $5687d04bb9f2cada$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $dhiZh.useCallback((event)=>{
        if ($ff12a13c25436077$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $fb53f4cc03531a2e$export$fe53371bee54353d)(location) === (0, $fb53f4cc03531a2e$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ff12a13c25436077$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $dhiZh.useRef($ff12a13c25436077$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $dhiZh.useRef(false);
    let location = (0, $5687d04bb9f2cada$export$45d76561a5302f2b)();
    let searchParams = $dhiZh.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ff12a13c25436077$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5687d04bb9f2cada$export$9770f232ac06a008)();
    let setSearchParams = $dhiZh.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ff12a13c25436077$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ff12a13c25436077$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $ff12a13c25436077$var$fetcherId = 0;
let $ff12a13c25436077$var$getUniqueFetcherId = ()=>"__" + String(++$ff12a13c25436077$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ff12a13c25436077$export$47c85c6e3a081d3() {
    let { router: router } = $ff12a13c25436077$var$useDataRouterContext($ff12a13c25436077$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $dhiZh.useContext((0, $5687d04bb9f2cada$export$26749e8557646306));
    let currentRouteId = (0, $5687d04bb9f2cada$export$5fc8298006ad9e58)();
    return $dhiZh.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ff12a13c25436077$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ff12a13c25436077$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ff12a13c25436077$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ff12a13c25436077$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $dhiZh.useContext((0, $5687d04bb9f2cada$export$26749e8557646306));
    let routeContext = $dhiZh.useContext((0, $5687d04bb9f2cada$export$9072aa6dd1f93057));
    !routeContext && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $ff12a13c25436077$var$_extends({}, (0, $5687d04bb9f2cada$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5687d04bb9f2cada$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fb53f4cc03531a2e$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $fb53f4cc03531a2e$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ff12a13c25436077$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $ff12a13c25436077$var$useDataRouterContext($ff12a13c25436077$var$DataRouterHook.UseFetcher);
    let state = $ff12a13c25436077$var$useDataRouterState($ff12a13c25436077$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $dhiZh.useContext($ff12a13c25436077$export$148fd98d095596d4);
    let route = $dhiZh.useContext((0, $5687d04bb9f2cada$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    !route && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $ff12a13c25436077$var$useIdImpl ? $ff12a13c25436077$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $dhiZh.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($ff12a13c25436077$var$getUniqueFetcherId());
    // Registration/cleanup
    $dhiZh.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $dhiZh.useCallback((href, opts)=>{
        !routeId && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ff12a13c25436077$export$47c85c6e3a081d3();
    let submit = $dhiZh.useCallback((target, opts)=>{
        submitImpl(target, $ff12a13c25436077$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $dhiZh.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $dhiZh.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $dhiZh.createElement($ff12a13c25436077$export$a7fed597f4b8afd8, $ff12a13c25436077$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $fb53f4cc03531a2e$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $dhiZh.useMemo(()=>$ff12a13c25436077$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ff12a13c25436077$export$fa996778a3a31087() {
    let state = $ff12a13c25436077$var$useDataRouterState($ff12a13c25436077$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $ff12a13c25436077$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $ff12a13c25436077$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $ff12a13c25436077$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ff12a13c25436077$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $ff12a13c25436077$var$useDataRouterContext($ff12a13c25436077$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ff12a13c25436077$var$useDataRouterState($ff12a13c25436077$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $dhiZh.useContext((0, $5687d04bb9f2cada$export$26749e8557646306));
    let location = (0, $5687d04bb9f2cada$export$45d76561a5302f2b)();
    let matches = (0, $5687d04bb9f2cada$export$2378eb7f5ff86053)();
    let navigation = (0, $5687d04bb9f2cada$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $dhiZh.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ff12a13c25436077$var$usePageHide($dhiZh.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $ff12a13c25436077$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ff12a13c25436077$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ff12a13c25436077$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dhiZh.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ff12a13c25436077$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ff12a13c25436077$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dhiZh.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($ff12a13c25436077$var$_extends({}, location, {
                    pathname: (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ff12a13c25436077$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dhiZh.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ff12a13c25436077$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $dhiZh.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ff12a13c25436077$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $dhiZh.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ff12a13c25436077$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5687d04bb9f2cada$export$b273b3273281a049)(when);
    $dhiZh.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dhiZh.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ff12a13c25436077$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $dhiZh.useContext($ff12a13c25436077$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $fb53f4cc03531a2e$export$3e9cee6b33872309)(false);
    let { basename: basename } = $ff12a13c25436077$var$useDataRouterContext($ff12a13c25436077$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5687d04bb9f2cada$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $fb53f4cc03531a2e$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $fb53f4cc03531a2e$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $fb53f4cc03531a2e$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $dhiZh = parcelRequire("dhiZh");


parcelRequire("dhiZh");


const $01d6e97cae1259ec$var$Header = ({ menuList: menuList, caseProp: caseProp })=>{
    const lenis = (0, $69a63ea936e703ee$export$69a110ee5442c47)();
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h1", {
                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                    href: "/#reel",
                    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("svg", {
                        className: "makerlab-logo makerlab-logo--desktop",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 163.87 22.84",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                d: "M3.63 4.3c.15-.17.3-.35.46-.52 1.47-1.59 3.35-2.07 5.42-1.92 1.54.11 2.95.61 4.15 1.61.42.35.78.74 1.05 1.21.17.29.27.25.45 0 .97-1.39 2.28-2.3 3.96-2.63 2.29-.45 4.52-.31 6.57.91 1.94 1.16 2.89 2.98 3.26 5.15.13.76.17 1.52.17 2.29v10.83q0 .63-.63.63c-.86 0-1.71-.02-2.57 0-.41.01-.52-.14-.51-.53.01-3.42.02-6.84 0-10.26 0-.88-.09-1.76-.32-2.62-.59-2.2-2.27-3.39-4.77-3.15-1.37.13-2.5.62-3.18 1.88-.4.74-.57 1.54-.64 2.37-.16 1.77-.06 3.53-.07 5.3-.02 2.14-.01 4.29 0 6.43 0 .42-.1.6-.56.58-.87-.03-1.74-.03-2.61 0-.42.01-.55-.13-.55-.55.01-3.54 0-7.07 0-10.61 0-.86-.06-1.71-.3-2.54-.65-2.27-2.37-3.02-4.46-2.89-.48.03-.95.11-1.41.27-1.51.54-2.25 1.7-2.59 3.19-.18.77-.21 1.55-.2 2.33v10c0 .53-.27.79-.82.79-.8 0-1.6-.02-2.39 0-.42.05-.54-.11-.54-.52.01-2.48 0-4.95 0-7.43V2.98c0-.62.01-.62.64-.62h2.4c.34 0 .47.13.46.46-.02.47 0 .95 0 1.42.05.02.09.04.14.06ZM163.63 9.99c-.91-4.49-4.77-7.99-9.26-8.35-3.01-.24-5.59.63-7.58 2.97-.04.04-.07.1-.15.06-.08-.14-.04-.31-.04-.46-.01-1.23-.01-2.47 0-3.7 0-.36-.11-.52-.5-.51-.98.02-1.95.02-2.92 0-.34 0-.46.11-.46.45.02.84.01 1.69.01 2.52v18.66c0 .58 0 .59.58.59.91 0 1.83-.01 2.74 0 .35.01.49-.12.48-.48-.02-.75 0-1.5 0-2.34.11.1.14.13.17.16 2.22 2.6 5.11 3.46 8.41 3.05 2.4-.29 4.4-1.43 5.99-3.24 2.36-2.71 3.24-5.85 2.53-9.38ZM154.69 19c-.5.12-1 .16-1.33.16-3.63-.02-6.55-2.76-6.84-6.22-.24-2.75.71-4.97 2.93-6.58 3.03-2.19 7.02-1.41 9.26 1.74 2.84 3.99.72 9.75-4.02 10.9ZM52.35 1.82c-.94.02-1.88.02-2.82 0-.4-.01-.55.1-.53.51.03.72.01 1.43.01 2.25-.68-.87-1.37-1.57-2.23-2.09-1.66-.99-3.48-1.29-5.39-1.19-2.01.11-3.87.68-5.48 1.88-3.49 2.6-4.81 6.19-4.27 10.4.79 6.18 6.8 9.55 12.12 8.68 2.19-.35 3.92-1.44 5.25-3.28 0 .79.02 1.58-.01 2.37-.01.39.11.54.52.53.89-.02 1.8 0 2.69 0 .45-.01.67-.23.67-.68V4.37c0-.66-.01-1.33.01-2 0-.4-.1-.57-.54-.55Zm-9.49 16.99c-2.72.24-4.8-.88-6.29-3.09-2.3-3.41-1.1-8.2 2.5-10.13 3.65-1.95 8.85-.21 9.85 4.84.1.47.11.95.11 1.42.13 3.36-2.58 6.64-6.17 6.96ZM139.75 2.26c-.96.02-1.92.02-2.88 0-.39-.01-.5.15-.49.52.02.69 0 1.38 0 2.11-.09-.03-.11-.03-.12-.04l-.17-.2c-.88-1.06-1.94-1.87-3.24-2.35-1.59-.58-3.23-.69-4.89-.47-2.69.35-4.93 1.56-6.64 3.68-1.76 2.18-2.46 4.71-2.38 7.49.07 2.5.97 4.67 2.68 6.47 2.39 2.53 5.4 3.6 8.85 3.33 2.39-.18 4.36-1.21 5.74-3.24.03-.04.06-.11.17-.06 0 .78.01 1.57 0 2.37 0 .33.11.46.46.46.98-.02 1.97-.02 2.95 0 .38 0 .47-.15.47-.5-.01-6.35-.01-12.72 0-19.08 0-.38-.15-.49-.51-.49Zm-7.83 16.63c-4.15 1.53-8.23-1.25-8.98-5.2-.67-3.5 1.16-6.78 4.36-8.01.73-.28 1.5-.43 2.37-.41 3.48 0 6.27 2.56 6.73 6.12.42 3.2-1.47 6.38-4.48 7.5ZM86.61 10.02C85.46 3.46 78.76.21 73.22 2.17c-4.75 1.67-7.39 6.6-6.71 11.52.7 5.01 5.5 9.44 11.04 8.8 4.06-.48 6.81-2.7 8.45-6.38.14-.31.03-.38-.27-.38-.97 0-1.94.02-2.92 0-.36-.01-.57.1-.77.41-1.41 2.2-4.06 3.32-6.6 2.77-2.54-.55-4.11-2.19-5-4.56-.2-.52-.17-.57.39-.57h7.63c2.57 0 5.14 0 7.7.01.35 0 .52-.09.55-.48.11-1.1.09-2.2-.1-3.29Zm-4.52.77H70.87c-.44 0-.62-.21-.53-.64.51-2.49 2.69-4.54 5.25-4.95 3.19-.5 6.39 1.59 7.17 4.7.15.59-.07.89-.67.89ZM102.75 6.76v-3.6q0-.61.59-.62h2.61c.54 0 .57.02.57.56v6.47c.01 3.27 1.52 5.7 4.23 7.42 1.54.98 3.26 1.4 5.09 1.38h2.65c.37 0 .52.12.5.5-.02.9 0 1.8 0 2.69 0 .23-.04.4-.33.4-2.04-.03-4.1.19-6.11-.35-5-1.36-8.31-4.43-9.59-9.53-.27-1.09-.25-2.21-.24-3.33v-2ZM92.7 4.32c1.19-1.57 2.8-2.06 4.56-2.23.37-.04.51.07.5.47-.03.99-.02 1.97 0 2.96 0 .3-.09.43-.42.46-2.6.25-4.02 1.68-4.31 4.28-.05.44-.07.86-.07 1.3v10.08q0 .6-.61.6h-2.52c-.65 0-.65 0-.65-.64V3.03c0-.28.08-.43.4-.43.91.01 1.83.01 2.74 0 .31 0 .4.14.39.42-.01.39 0 .78 0 1.29Z"
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                d: "M65.31 21.97c-.61 0-1.22-.01-1.83 0-.3 0-.51-.09-.7-.33-2.42-3.15-4.85-6.29-7.28-9.43-.18-.23-.16-.39 0-.61 2.15-2.91 4.3-5.83 6.44-8.75.17-.24.38-.32.66-.32h3.44c.14 0 .32-.07.4.09.07.15-.09.26-.18.37-2.09 2.73-4.19 5.45-6.28 8.17-.46.61-.46.47 0 1.04l7.38 9.3c.09.12.29.23.19.4-.07.13-.27.06-.41.06h-1.83Z"
                            })
                        ]
                    })
                })
            }),
            !caseProp ? /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("ul", {
                children: menuList.fields.menuItem.map((item, index)=>{
                    var _item_fields_itemUrl;
                    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("li", {
                        children: ((_item_fields_itemUrl = item.fields.itemUrl) === null || _item_fields_itemUrl === void 0 ? void 0 : _item_fields_itemUrl.includes("http")) ? /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                            href: item.fields.itemUrl,
                            className: "roboto-regular",
                            target: "_blank",
                            children: item.fields.itemText
                        }) : /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                            onClick: ()=>{
                                lenis === null || lenis === void 0 ? void 0 : lenis.scrollTo(item.fields.itemUrl);
                            },
                            className: "roboto-regular",
                            children: item.fields.itemText
                        })
                    }, index);
                })
            }) : /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                href: "/#work",
                children: "Back to cases"
            })
        ]
    });
};
var $01d6e97cae1259ec$export$2e2bcd8739ae039 = $01d6e97cae1259ec$var$Header;



parcelRequire("dhiZh");
var $38678b7cfd831c39$exports = {};

(()=>{
    "use strict";
    var e = {
        n: (t)=>{
            var r = t && t.__esModule ? ()=>t.default : ()=>t;
            return e.d(r, {
                a: r
            }), r;
        },
        d: (t, r)=>{
            for(var n in r)e.o(r, n) && !e.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: r[n]
            });
        },
        o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t),
        r: (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }
    }, t = {};
    e.r(t), e.d(t, {
        default: ()=>c
    });
    const r = (parcelRequire("dhiZh"));
    var n = e.n(r), o = [
        "children",
        "width"
    ];
    function a() {
        return a = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, a.apply(this, arguments);
    }
    function l(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
        return n;
    }
    var i = function(e) {
        var t, o, a = e.children, i = e.width, c = void 0 === i ? "200px" : i, d = e.duration, u = void 0 === d ? 40 : d, s = e.toRight, f = void 0 !== s && s, m = e.pauseOnHover, y = void 0 !== m && m, p = e.blurBorders, g = void 0 !== p && p, v = e.blurBoderColor, h = void 0 === v ? "#fff" : v, b = (t = (0, r.useState)(""), o = 2, function(e) {
            if (Array.isArray(e)) return e;
        }(t) || function(e, t) {
            var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != r) {
                var n, o, a, l, i = [], c = !0, d = !1;
                try {
                    if (a = (r = r.call(e)).next, 0 === t) {
                        if (Object(r) !== r) return;
                        c = !1;
                    } else for(; !(c = (n = a.call(r)).done) && (i.push(n.value), i.length !== t); c = !0);
                } catch (e) {
                    d = !0, o = e;
                } finally{
                    try {
                        if (!c && null != r.return && (l = r.return(), Object(l) !== l)) return;
                    } finally{
                        if (d) throw o;
                    }
                }
                return i;
            }
        }(t, o) || function(e, t) {
            if (e) {
                if ("string" == typeof e) return l(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? l(e, t) : void 0;
            }
        }(t, o) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }()), E = b[0], w = b[1];
        return (0, r.useEffect)(function() {
            w(function() {
                for(var e = "", t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = 0; r < 10; r++)e += t.charAt(Math.floor(Math.random() * t.length));
                return e;
            }());
        }, []), (0, r.useEffect)(function() {
            var e = document.createElement("style");
            e.type = "text/css", e.innerHTML = "        @-webkit-keyframes slider_logo_slider {            0% {                transform: translateX(0);            }            100% {                transform: translateX(A_DYNAMIC_VALUE);            }        }        @-moz-keyframes slider_logo_slider {            0% {                transform: translateX(0);            }            100% {                transform: translateX(A_DYNAMIC_VALUE);            }        }".replace(/A_DYNAMIC_VALUE/g, "calc(".concat(f ? "" : "-").concat(c, " * ").concat(null == a ? void 0 : a.length, ")")), document.getElementsByTagName("head")[0].appendChild(e);
        }, [
            f,
            c,
            a
        ]), n().createElement("div", {
            style: {
                position: "relative"
            }
        }, n().createElement("div", {
            style: {
                width: "100%",
                height: "auto",
                margin: "auto",
                top: 0,
                overflow: "hidden"
            },
            onMouseEnter: function() {
                return y && void (document.getElementById("slider_".concat(E)).style.animationPlayState = "paused");
            },
            onMouseLeave: function() {
                return y && void (document.getElementById("slider_".concat(E)).style.animationPlayState = "running");
            },
            id: "slider_wrapper_".concat(E)
        }, n().createElement("div", {
            style: {
                display: "flex",
                animation: "slider_logo_slider ".concat(u, "s linear infinite"),
                width: "calc(".concat(c, " * ").concat(3 * (null == a ? void 0 : a.length), ")"),
                top: 0
            },
            id: "slider_".concat(E)
        }, null == a ? void 0 : a.map(function(e, t) {
            return n().createElement(n().Fragment, {
                key: t
            }, n().cloneElement(e, {
                width: c
            }));
        }), null == a ? void 0 : a.map(function(e, t) {
            return n().createElement(n().Fragment, {
                key: t
            }, n().cloneElement(e, {
                width: c
            }));
        }), null == a ? void 0 : a.map(function(e, t) {
            return n().createElement(n().Fragment, {
                key: t
            }, n().cloneElement(e, {
                width: c
            }));
        }))), g && n().createElement(n().Fragment, null, n().createElement("div", {
            style: {
                position: "absolute",
                right: 0,
                top: "0px",
                width: "180px",
                transform: "rotate(180deg)",
                zIndex: 10,
                height: "105%",
                background: "linear-gradient(90deg, ".concat(h, " 10%, rgba(255, 255, 255, 0) 80%)")
            }
        }), n().createElement("div", {
            style: {
                position: "absolute",
                left: 0,
                top: "0px",
                width: "180px",
                zIndex: 10,
                height: "120%",
                background: "linear-gradient(90deg, ".concat(h, " 10%, rgba(255, 255, 255, 0) 80%)")
            }
        })));
    };
    i.Slide = function(e) {
        var t = e.children, r = e.width, l = void 0 === r ? "200px" : r, i = function(e, t) {
            if (null == e) return {};
            var r, n, o = function(e, t) {
                if (null == e) return {};
                var r, n, o = {}, a = Object.keys(e);
                for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }
            return o;
        }(e, o);
        return n().createElement("div", a({
            style: {
                width: l,
                alignItems: "center",
                display: "flex"
            }
        }, i), t);
    };
    const c = i;
    $38678b7cfd831c39$exports = t;
})();


const $e2c2f54d2fe66d4f$var$Logos = ({ logos: logos })=>{
    // console.log("Data: ", logos)
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        className: "makerlab-logos-wrapper",
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($38678b7cfd831c39$exports))), {
            width: "170px",
            duration: 20,
            pauseOnHover: false,
            children: logos.map((item, index)=>{
                return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($38678b7cfd831c39$exports))).Slide, {
                    className: "makerlab-logos-item",
                    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("img", {
                        src: item.fields.file.url,
                        alt: "Client Logo"
                    })
                }, index);
            })
        })
    });
};
var $e2c2f54d2fe66d4f$export$2e2bcd8739ae039 = $e2c2f54d2fe66d4f$var$Logos;




var $dhiZh = parcelRequire("dhiZh");

function $4a8810f27717d480$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $710949f8d1eb100c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $4a8810f27717d480$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $dhiZh = parcelRequire("dhiZh");
"use client";
var $74bd4cb969e9d802$var$__defProp = Object.defineProperty;
var $74bd4cb969e9d802$var$__defNormalProp = (obj, key, value)=>key in obj ? $74bd4cb969e9d802$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $74bd4cb969e9d802$var$__publicField = (obj, key, value)=>$74bd4cb969e9d802$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $74bd4cb969e9d802$var$observerMap = /* @__PURE__ */ new Map();
var $74bd4cb969e9d802$var$RootIds = /* @__PURE__ */ new WeakMap();
var $74bd4cb969e9d802$var$rootId = 0;
var $74bd4cb969e9d802$var$unsupportedValue = void 0;
function $74bd4cb969e9d802$export$2ef3a60ee1f37bec(inView) {
    $74bd4cb969e9d802$var$unsupportedValue = inView;
}
function $74bd4cb969e9d802$var$getRootId(root) {
    if (!root) return "0";
    if ($74bd4cb969e9d802$var$RootIds.has(root)) return $74bd4cb969e9d802$var$RootIds.get(root);
    $74bd4cb969e9d802$var$rootId += 1;
    $74bd4cb969e9d802$var$RootIds.set(root, $74bd4cb969e9d802$var$rootId.toString());
    return $74bd4cb969e9d802$var$RootIds.get(root);
}
function $74bd4cb969e9d802$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $74bd4cb969e9d802$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $74bd4cb969e9d802$var$createObserver(options) {
    const id = $74bd4cb969e9d802$var$optionsToId(options);
    let instance = $74bd4cb969e9d802$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $74bd4cb969e9d802$var$observerMap.set(id, instance);
    }
    return instance;
}
function $74bd4cb969e9d802$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $74bd4cb969e9d802$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $74bd4cb969e9d802$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $74bd4cb969e9d802$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $74bd4cb969e9d802$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $74bd4cb969e9d802$export$a62107ca74432f44 = class extends $dhiZh.Component {
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $74bd4cb969e9d802$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const _this_props = this.props, { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView } = _this_props, props = (0, $710949f8d1eb100c$export$71511d61b312f219)(_this_props, [
            "as",
            "triggerOnce",
            "threshold",
            "root",
            "rootMargin",
            "onChange",
            "skip",
            "trackVisibility",
            "delay",
            "initialInView",
            "fallbackInView"
        ]);
        return $dhiZh.createElement(as || "div", (0, $53825fa7fd9c8174$export$71511d61b312f219)({
            ref: this.handleNode
        }, props), children);
    }
    constructor(props){
        super(props);
        $74bd4cb969e9d802$var$__publicField(this, "node", null);
        $74bd4cb969e9d802$var$__publicField(this, "_unobserveCb", null);
        $74bd4cb969e9d802$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $74bd4cb969e9d802$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$74bd4cb969e9d802$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
};
function $74bd4cb969e9d802$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $dhiZh.useState(null);
    const callback = $dhiZh.useRef();
    const [state, setState] = $dhiZh.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $dhiZh.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $74bd4cb969e9d802$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $dhiZh.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map


var $6ed23f9f312890d4$export$4a295a2b4ab66da6;
"use strict";

var $dhiZh = parcelRequire("dhiZh");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $6ed23f9f312890d4$var$__assign = function() {
    $6ed23f9f312890d4$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ed23f9f312890d4$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
var $6ed23f9f312890d4$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $6ed23f9f312890d4$var$dist = {};
var $6ed23f9f312890d4$var$blocks = {};
Object.defineProperty($6ed23f9f312890d4$var$blocks, "__esModule", {
    value: true
});
$6ed23f9f312890d4$var$blocks.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $6ed23f9f312890d4$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($6ed23f9f312890d4$var$BLOCKS || ($6ed23f9f312890d4$var$blocks.BLOCKS = $6ed23f9f312890d4$var$BLOCKS = {}));
var $6ed23f9f312890d4$var$inlines = {};
Object.defineProperty($6ed23f9f312890d4$var$inlines, "__esModule", {
    value: true
});
$6ed23f9f312890d4$var$inlines.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $6ed23f9f312890d4$var$INLINES;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($6ed23f9f312890d4$var$INLINES || ($6ed23f9f312890d4$var$inlines.INLINES = $6ed23f9f312890d4$var$INLINES = {}));
var $6ed23f9f312890d4$var$marks = {};
Object.defineProperty($6ed23f9f312890d4$var$marks, "__esModule", {
    value: true
});
$6ed23f9f312890d4$var$marks.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */ var $6ed23f9f312890d4$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($6ed23f9f312890d4$var$MARKS || ($6ed23f9f312890d4$var$marks.MARKS = $6ed23f9f312890d4$var$MARKS = {}));
var $6ed23f9f312890d4$var$schemaConstraints = {};
(function(exports1) {
    var __spreadArray = $6ed23f9f312890d4$var$commonjsGlobal && $6ed23f9f312890d4$var$commonjsGlobal.__spreadArray || function(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };
    var _a;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.V1_MARKS = exports1.V1_NODE_TYPES = exports1.TEXT_CONTAINERS = exports1.HEADINGS = exports1.CONTAINERS = exports1.VOID_BLOCKS = exports1.TABLE_BLOCKS = exports1.LIST_ITEM_BLOCKS = exports1.TOP_LEVEL_BLOCKS = void 0;
    var blocks_1 = $6ed23f9f312890d4$var$blocks;
    var inlines_1 = $6ed23f9f312890d4$var$inlines;
    var marks_1 = $6ed23f9f312890d4$var$marks;
    /**
	 * Array of all top level block types.
	 * Only these block types can be the direct children of the document.
	 */ exports1.TOP_LEVEL_BLOCKS = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE,
        blocks_1.BLOCKS.TABLE
    ];
    /**
	 * Array of all allowed block types inside list items
	 */ exports1.LIST_ITEM_BLOCKS = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE
    ];
    exports1.TABLE_BLOCKS = [
        blocks_1.BLOCKS.TABLE,
        blocks_1.BLOCKS.TABLE_ROW,
        blocks_1.BLOCKS.TABLE_CELL,
        blocks_1.BLOCKS.TABLE_HEADER_CELL
    ];
    /**
	 * Array of all void block types
	 */ exports1.VOID_BLOCKS = [
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE
    ];
    /**
	 * Dictionary of all container block types, and the set block types they accept as children.
	 *
	 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
	 */ exports1.CONTAINERS = (_a = {}, _a[blocks_1.BLOCKS.OL_LIST] = [
        blocks_1.BLOCKS.LIST_ITEM
    ], _a[blocks_1.BLOCKS.UL_LIST] = [
        blocks_1.BLOCKS.LIST_ITEM
    ], _a[blocks_1.BLOCKS.LIST_ITEM] = exports1.LIST_ITEM_BLOCKS, _a[blocks_1.BLOCKS.QUOTE] = [
        blocks_1.BLOCKS.PARAGRAPH
    ], _a[blocks_1.BLOCKS.TABLE] = [
        blocks_1.BLOCKS.TABLE_ROW
    ], _a[blocks_1.BLOCKS.TABLE_ROW] = [
        blocks_1.BLOCKS.TABLE_CELL,
        blocks_1.BLOCKS.TABLE_HEADER_CELL
    ], _a[blocks_1.BLOCKS.TABLE_CELL] = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.OL_LIST
    ], _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [
        blocks_1.BLOCKS.PARAGRAPH
    ], _a);
    /**
	 * Array of all heading levels
	 */ exports1.HEADINGS = [
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6
    ];
    /**
	 * Array of all block types that may contain text and inline nodes.
	 */ exports1.TEXT_CONTAINERS = __spreadArray([
        blocks_1.BLOCKS.PARAGRAPH
    ], exports1.HEADINGS, true);
    /**
	 * Node types before `tables` release.
	 */ exports1.V1_NODE_TYPES = [
        blocks_1.BLOCKS.DOCUMENT,
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.LIST_ITEM,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        inlines_1.INLINES.HYPERLINK,
        inlines_1.INLINES.ENTRY_HYPERLINK,
        inlines_1.INLINES.ASSET_HYPERLINK,
        inlines_1.INLINES.EMBEDDED_ENTRY,
        "text"
    ];
    /**
	 * Marks before `superscript` & `subscript` release.
	 */ exports1.V1_MARKS = [
        marks_1.MARKS.BOLD,
        marks_1.MARKS.CODE,
        marks_1.MARKS.ITALIC,
        marks_1.MARKS.UNDERLINE
    ];
})($6ed23f9f312890d4$var$schemaConstraints);
var $6ed23f9f312890d4$var$types = {};
Object.defineProperty($6ed23f9f312890d4$var$types, "__esModule", {
    value: true
});
var $6ed23f9f312890d4$var$nodeTypes = {};
Object.defineProperty($6ed23f9f312890d4$var$nodeTypes, "__esModule", {
    value: true
});
var $6ed23f9f312890d4$var$emptyDocument = {};
Object.defineProperty($6ed23f9f312890d4$var$emptyDocument, "__esModule", {
    value: true
});
$6ed23f9f312890d4$var$emptyDocument.EMPTY_DOCUMENT = void 0;
var $6ed23f9f312890d4$var$blocks_1$1 = $6ed23f9f312890d4$var$blocks;
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ $6ed23f9f312890d4$var$emptyDocument.EMPTY_DOCUMENT = {
    nodeType: $6ed23f9f312890d4$var$blocks_1$1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $6ed23f9f312890d4$var$blocks_1$1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: "text",
                    value: "",
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
var $6ed23f9f312890d4$var$helpers = {};
Object.defineProperty($6ed23f9f312890d4$var$helpers, "__esModule", {
    value: true
});
$6ed23f9f312890d4$var$helpers.isInline = $6ed23f9f312890d4$var$isInline;
$6ed23f9f312890d4$var$helpers.isBlock = $6ed23f9f312890d4$var$isBlock;
$6ed23f9f312890d4$var$helpers.isText = $6ed23f9f312890d4$var$isText;
var $6ed23f9f312890d4$var$blocks_1 = $6ed23f9f312890d4$var$blocks;
var $6ed23f9f312890d4$var$inlines_1 = $6ed23f9f312890d4$var$inlines;
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $6ed23f9f312890d4$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $6ed23f9f312890d4$var$isInline(node) {
    return $6ed23f9f312890d4$var$hasValue($6ed23f9f312890d4$var$inlines_1.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $6ed23f9f312890d4$var$isBlock(node) {
    return $6ed23f9f312890d4$var$hasValue($6ed23f9f312890d4$var$blocks_1.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $6ed23f9f312890d4$var$isText(node) {
    return node.nodeType === "text";
}
function $6ed23f9f312890d4$var$commonjsRequire(path) {
    throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $6ed23f9f312890d4$var$schemas = {};
Object.defineProperty($6ed23f9f312890d4$var$schemas, "__esModule", {
    value: true
});
$6ed23f9f312890d4$var$schemas.getSchemaWithNodeType = $6ed23f9f312890d4$var$getSchemaWithNodeType;
function $6ed23f9f312890d4$var$getSchemaWithNodeType(nodeType) {
    try {
        return $6ed23f9f312890d4$var$commonjsRequire("./generated/".concat(nodeType, ".json"));
    } catch (error) {
        throw new Error('Schema for nodeType "'.concat(nodeType, '" was not found.'));
    }
}
(function(exports1) {
    var __createBinding = $6ed23f9f312890d4$var$commonjsGlobal && $6ed23f9f312890d4$var$commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m[k];
            }
        };
        Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var __setModuleDefault = $6ed23f9f312890d4$var$commonjsGlobal && $6ed23f9f312890d4$var$commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
        Object.defineProperty(o, "default", {
            enumerable: true,
            value: v
        });
    } : function(o, v) {
        o["default"] = v;
    });
    var __exportStar = $6ed23f9f312890d4$var$commonjsGlobal && $6ed23f9f312890d4$var$commonjsGlobal.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
    };
    var __importStar = $6ed23f9f312890d4$var$commonjsGlobal && $6ed23f9f312890d4$var$commonjsGlobal.__importStar || function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.getSchemaWithNodeType = exports1.helpers = exports1.EMPTY_DOCUMENT = exports1.MARKS = exports1.INLINES = exports1.BLOCKS = void 0;
    var blocks_1 = $6ed23f9f312890d4$var$blocks;
    Object.defineProperty(exports1, "BLOCKS", {
        enumerable: true,
        get: function() {
            return blocks_1.BLOCKS;
        }
    });
    var inlines_1 = $6ed23f9f312890d4$var$inlines;
    Object.defineProperty(exports1, "INLINES", {
        enumerable: true,
        get: function() {
            return inlines_1.INLINES;
        }
    });
    var marks_1 = $6ed23f9f312890d4$var$marks;
    Object.defineProperty(exports1, "MARKS", {
        enumerable: true,
        get: function() {
            return marks_1.MARKS;
        }
    });
    __exportStar($6ed23f9f312890d4$var$schemaConstraints, exports1);
    __exportStar($6ed23f9f312890d4$var$types, exports1);
    __exportStar($6ed23f9f312890d4$var$nodeTypes, exports1);
    var emptyDocument_1 = $6ed23f9f312890d4$var$emptyDocument;
    Object.defineProperty(exports1, "EMPTY_DOCUMENT", {
        enumerable: true,
        get: function() {
            return emptyDocument_1.EMPTY_DOCUMENT;
        }
    });
    var helpers$1 = __importStar($6ed23f9f312890d4$var$helpers);
    exports1.helpers = helpers$1;
    var schemas_1 = $6ed23f9f312890d4$var$schemas;
    Object.defineProperty(exports1, "getSchemaWithNodeType", {
        enumerable: true,
        get: function() {
            return schemas_1.getSchemaWithNodeType;
        }
    });
})($6ed23f9f312890d4$var$dist);
function $6ed23f9f312890d4$var$appendKeyToValidElement(element, key) {
    if ($dhiZh.isValidElement(element) && element.key === null) return $dhiZh.cloneElement(element, {
        key: key
    });
    return element;
}
function $6ed23f9f312890d4$var$nodeListToReactComponents(nodes, options) {
    return nodes.map(function(node, index) {
        return $6ed23f9f312890d4$var$appendKeyToValidElement($6ed23f9f312890d4$var$nodeToReactComponent(node, options), index);
    });
}
function $6ed23f9f312890d4$var$nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText, preserveWhitespace = options.preserveWhitespace;
    if ($6ed23f9f312890d4$var$dist.helpers.isText(node)) {
        var nodeValue = renderText ? renderText(node.value) : node.value;
        // Preserving whitespace is only supported with the default transformations.
        if (preserveWhitespace && !renderText) {
            // Preserve multiple spaces.
            nodeValue = nodeValue.replace(/ {2,}/g, function(match) {
                return "\xa0".repeat(match.length);
            });
            // Preserve line breaks.
            var lines_1 = nodeValue.split("\n");
            var jsxLines_1 = [];
            lines_1.forEach(function(line, index) {
                jsxLines_1.push(line);
                if (index !== lines_1.length - 1) jsxLines_1.push($dhiZh.createElement("br", null));
            });
            nodeValue = jsxLines_1;
        }
        return node.marks.reduce(function(value, mark) {
            if (!renderMark[mark.type]) return value;
            return renderMark[mark.type](value);
        }, nodeValue);
    } else {
        var children = $6ed23f9f312890d4$var$nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) return $dhiZh.createElement($dhiZh.Fragment, null, children);
        return renderNode[node.nodeType](node, children);
    }
}
var $6ed23f9f312890d4$var$_a, $6ed23f9f312890d4$var$_b;
var $6ed23f9f312890d4$var$defaultNodeRenderers = ($6ed23f9f312890d4$var$_a = {}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.DOCUMENT] = function(node, children) {
    return children;
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.PARAGRAPH] = function(node, children) {
    return $dhiZh.createElement("p", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.HEADING_1] = function(node, children) {
    return $dhiZh.createElement("h1", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.HEADING_2] = function(node, children) {
    return $dhiZh.createElement("h2", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.HEADING_3] = function(node, children) {
    return $dhiZh.createElement("h3", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.HEADING_4] = function(node, children) {
    return $dhiZh.createElement("h4", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.HEADING_5] = function(node, children) {
    return $dhiZh.createElement("h5", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.HEADING_6] = function(node, children) {
    return $dhiZh.createElement("h6", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.EMBEDDED_ENTRY] = function(node, children) {
    return $dhiZh.createElement("div", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.EMBEDDED_RESOURCE] = function(node, children) {
    return $dhiZh.createElement("div", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.UL_LIST] = function(node, children) {
    return $dhiZh.createElement("ul", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.OL_LIST] = function(node, children) {
    return $dhiZh.createElement("ol", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.LIST_ITEM] = function(node, children) {
    return $dhiZh.createElement("li", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.QUOTE] = function(node, children) {
    return $dhiZh.createElement("blockquote", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.HR] = function() {
    return $dhiZh.createElement("hr", null);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.TABLE] = function(node, children) {
    return $dhiZh.createElement("table", null, $dhiZh.createElement("tbody", null, children));
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.TABLE_ROW] = function(node, children) {
    return $dhiZh.createElement("tr", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.TABLE_HEADER_CELL] = function(node, children) {
    return $dhiZh.createElement("th", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.BLOCKS.TABLE_CELL] = function(node, children) {
    return $dhiZh.createElement("td", null, children);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.INLINES.ASSET_HYPERLINK] = function(node) {
    return $6ed23f9f312890d4$var$defaultInline($6ed23f9f312890d4$var$dist.INLINES.ASSET_HYPERLINK, node);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.INLINES.ENTRY_HYPERLINK] = function(node) {
    return $6ed23f9f312890d4$var$defaultInline($6ed23f9f312890d4$var$dist.INLINES.ENTRY_HYPERLINK, node);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.INLINES.RESOURCE_HYPERLINK] = function(node) {
    return $6ed23f9f312890d4$var$defaultInlineResource($6ed23f9f312890d4$var$dist.INLINES.RESOURCE_HYPERLINK, node);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.INLINES.EMBEDDED_ENTRY] = function(node) {
    return $6ed23f9f312890d4$var$defaultInline($6ed23f9f312890d4$var$dist.INLINES.EMBEDDED_ENTRY, node);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.INLINES.EMBEDDED_RESOURCE] = function(node, _children) {
    return $6ed23f9f312890d4$var$defaultInlineResource($6ed23f9f312890d4$var$dist.INLINES.EMBEDDED_RESOURCE, node);
}, $6ed23f9f312890d4$var$_a[$6ed23f9f312890d4$var$dist.INLINES.HYPERLINK] = function(node, children) {
    return $dhiZh.createElement("a", {
        href: node.data.uri
    }, children);
}, $6ed23f9f312890d4$var$_a);
var $6ed23f9f312890d4$var$defaultMarkRenderers = ($6ed23f9f312890d4$var$_b = {}, $6ed23f9f312890d4$var$_b[$6ed23f9f312890d4$var$dist.MARKS.BOLD] = function(text) {
    return $dhiZh.createElement("b", null, text);
}, $6ed23f9f312890d4$var$_b[$6ed23f9f312890d4$var$dist.MARKS.ITALIC] = function(text) {
    return $dhiZh.createElement("i", null, text);
}, $6ed23f9f312890d4$var$_b[$6ed23f9f312890d4$var$dist.MARKS.UNDERLINE] = function(text) {
    return $dhiZh.createElement("u", null, text);
}, $6ed23f9f312890d4$var$_b[$6ed23f9f312890d4$var$dist.MARKS.CODE] = function(text) {
    return $dhiZh.createElement("code", null, text);
}, $6ed23f9f312890d4$var$_b[$6ed23f9f312890d4$var$dist.MARKS.SUPERSCRIPT] = function(text) {
    return $dhiZh.createElement("sup", null, text);
}, $6ed23f9f312890d4$var$_b[$6ed23f9f312890d4$var$dist.MARKS.SUBSCRIPT] = function(text) {
    return $dhiZh.createElement("sub", null, text);
}, $6ed23f9f312890d4$var$_b[$6ed23f9f312890d4$var$dist.MARKS.STRIKETHROUGH] = function(text) {
    return $dhiZh.createElement("s", null, text);
}, $6ed23f9f312890d4$var$_b);
function $6ed23f9f312890d4$var$defaultInline(type, node) {
    return $dhiZh.createElement("span", {
        key: node.data.target.sys.id
    }, "type: ", node.nodeType, " id: ", node.data.target.sys.id);
}
function $6ed23f9f312890d4$var$defaultInlineResource(type, node) {
    return $dhiZh.createElement("span", {
        key: node.data.target.sys.urn
    }, "type: ", node.nodeType, " urn: ", node.data.target.sys.urn);
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */ function $6ed23f9f312890d4$var$documentToReactComponents(richTextDocument, options) {
    if (options === void 0) options = {};
    if (!richTextDocument) return null;
    return $6ed23f9f312890d4$var$nodeToReactComponent(richTextDocument, {
        renderNode: $6ed23f9f312890d4$var$__assign($6ed23f9f312890d4$var$__assign({}, $6ed23f9f312890d4$var$defaultNodeRenderers), options.renderNode),
        renderMark: $6ed23f9f312890d4$var$__assign($6ed23f9f312890d4$var$__assign({}, $6ed23f9f312890d4$var$defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
        preserveWhitespace: options.preserveWhitespace
    });
}
$6ed23f9f312890d4$export$4a295a2b4ab66da6 = $6ed23f9f312890d4$var$documentToReactComponents;



var $bYZui = parcelRequire("bYZui");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $bYZui = parcelRequire("bYZui");
var $2f5a9112cdc5daa6$var$_win, $2f5a9112cdc5daa6$var$_doc, $2f5a9112cdc5daa6$var$_docElement, $2f5a9112cdc5daa6$var$_pluginInitted, $2f5a9112cdc5daa6$var$_tempDiv, $2f5a9112cdc5daa6$var$_tempDivStyler, $2f5a9112cdc5daa6$var$_recentSetterPlugin, $2f5a9112cdc5daa6$var$_reverting, $2f5a9112cdc5daa6$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $2f5a9112cdc5daa6$var$_transformProps = {}, $2f5a9112cdc5daa6$var$_RAD2DEG = 180 / Math.PI, $2f5a9112cdc5daa6$var$_DEG2RAD = Math.PI / 180, $2f5a9112cdc5daa6$var$_atan2 = Math.atan2, $2f5a9112cdc5daa6$var$_bigNum = 1e8, $2f5a9112cdc5daa6$var$_capsExp = /([A-Z])/g, $2f5a9112cdc5daa6$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $2f5a9112cdc5daa6$var$_complexExp = /[\s,\(]\S/, $2f5a9112cdc5daa6$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $2f5a9112cdc5daa6$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $2f5a9112cdc5daa6$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $2f5a9112cdc5daa6$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$2f5a9112cdc5daa6$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $2f5a9112cdc5daa6$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $2f5a9112cdc5daa6$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $2f5a9112cdc5daa6$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $2f5a9112cdc5daa6$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $2f5a9112cdc5daa6$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $2f5a9112cdc5daa6$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $2f5a9112cdc5daa6$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $2f5a9112cdc5daa6$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $2f5a9112cdc5daa6$var$_transformProp = "transform", $2f5a9112cdc5daa6$var$_transformOriginProp = $2f5a9112cdc5daa6$var$_transformProp + "Origin", $2f5a9112cdc5daa6$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $2f5a9112cdc5daa6$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $2f5a9112cdc5daa6$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $2f5a9112cdc5daa6$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $2f5a9112cdc5daa6$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $2f5a9112cdc5daa6$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $2f5a9112cdc5daa6$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($2f5a9112cdc5daa6$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($2f5a9112cdc5daa6$var$_transformOriginProp, isNotCSS, "");
        }
        property = $2f5a9112cdc5daa6$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $2f5a9112cdc5daa6$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $2f5a9112cdc5daa6$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($2f5a9112cdc5daa6$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $2f5a9112cdc5daa6$var$_reverting();
        if ((!i || !i.isStart) && !style[$2f5a9112cdc5daa6$var$_transformProp]) {
            $2f5a9112cdc5daa6$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$2f5a9112cdc5daa6$var$_transformOriginProp]) {
                style[$2f5a9112cdc5daa6$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $2f5a9112cdc5daa6$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $2f5a9112cdc5daa6$var$_revertStyle,
        save: $2f5a9112cdc5daa6$var$_saveStyle
    };
    target._gsap || (0, $bYZui.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $2f5a9112cdc5daa6$var$_supports3D, $2f5a9112cdc5daa6$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $2f5a9112cdc5daa6$var$_doc.createElementNS ? $2f5a9112cdc5daa6$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $2f5a9112cdc5daa6$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $2f5a9112cdc5daa6$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $2f5a9112cdc5daa6$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($2f5a9112cdc5daa6$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $2f5a9112cdc5daa6$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $2f5a9112cdc5daa6$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $2f5a9112cdc5daa6$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $2f5a9112cdc5daa6$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($2f5a9112cdc5daa6$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $2f5a9112cdc5daa6$var$_prefixes[i] : "") + property;
}, $2f5a9112cdc5daa6$var$_initCore = function _initCore() {
    if ($2f5a9112cdc5daa6$var$_windowExists() && window.document) {
        $2f5a9112cdc5daa6$var$_win = window;
        $2f5a9112cdc5daa6$var$_doc = $2f5a9112cdc5daa6$var$_win.document;
        $2f5a9112cdc5daa6$var$_docElement = $2f5a9112cdc5daa6$var$_doc.documentElement;
        $2f5a9112cdc5daa6$var$_tempDiv = $2f5a9112cdc5daa6$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $2f5a9112cdc5daa6$var$_tempDivStyler = $2f5a9112cdc5daa6$export$a232bb0480ae674a("div");
        $2f5a9112cdc5daa6$var$_transformProp = $2f5a9112cdc5daa6$export$8cbef5dd49a09c8b($2f5a9112cdc5daa6$var$_transformProp);
        $2f5a9112cdc5daa6$var$_transformOriginProp = $2f5a9112cdc5daa6$var$_transformProp + "Origin";
        $2f5a9112cdc5daa6$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $2f5a9112cdc5daa6$var$_supports3D = !!$2f5a9112cdc5daa6$export$8cbef5dd49a09c8b("perspective");
        $2f5a9112cdc5daa6$var$_reverting = (0, $bYZui.gsap).core.reverting;
        $2f5a9112cdc5daa6$var$_pluginInitted = 1;
    }
}, $2f5a9112cdc5daa6$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $2f5a9112cdc5daa6$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $2f5a9112cdc5daa6$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $2f5a9112cdc5daa6$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $2f5a9112cdc5daa6$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $2f5a9112cdc5daa6$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $2f5a9112cdc5daa6$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $2f5a9112cdc5daa6$var$_getBBoxHack || (bounds = $2f5a9112cdc5daa6$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$2f5a9112cdc5daa6$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$2f5a9112cdc5daa6$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $2f5a9112cdc5daa6$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $2f5a9112cdc5daa6$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$2f5a9112cdc5daa6$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $2f5a9112cdc5daa6$var$_transformProps && property !== $2f5a9112cdc5daa6$var$_transformOriginProp) property = $2f5a9112cdc5daa6$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($2f5a9112cdc5daa6$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $2f5a9112cdc5daa6$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bYZui.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $2f5a9112cdc5daa6$var$_renderNonTweeningValueOnlyAtEnd : $2f5a9112cdc5daa6$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $2f5a9112cdc5daa6$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $2f5a9112cdc5daa6$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$2f5a9112cdc5daa6$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $2f5a9112cdc5daa6$var$_tempDiv.style, horizontal = $2f5a9112cdc5daa6$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $2f5a9112cdc5daa6$var$_nonConvertibleUnits[unit] || $2f5a9112cdc5daa6$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $2f5a9112cdc5daa6$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($2f5a9112cdc5daa6$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bYZui._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $2f5a9112cdc5daa6$var$_doc || !parent.appendChild) parent = $2f5a9112cdc5daa6$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bYZui._ticker).time && !cache.uncache) return (0, $bYZui._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $2f5a9112cdc5daa6$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$2f5a9112cdc5daa6$var$_nonStandardLayouts[$2f5a9112cdc5daa6$var$_getComputedProperty(parent, "display")] && (style.position = $2f5a9112cdc5daa6$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($2f5a9112cdc5daa6$var$_tempDiv);
            px = $2f5a9112cdc5daa6$var$_tempDiv[measureProperty];
            parent.removeChild($2f5a9112cdc5daa6$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bYZui._getCache)(parent);
            cache.time = (0, $bYZui._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bYZui._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $2f5a9112cdc5daa6$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $2f5a9112cdc5daa6$var$_pluginInitted || $2f5a9112cdc5daa6$var$_initCore();
    if (property in $2f5a9112cdc5daa6$var$_propertyAliases && property !== "transform") {
        property = $2f5a9112cdc5daa6$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($2f5a9112cdc5daa6$var$_transformProps[property] && property !== "transform") {
        value = $2f5a9112cdc5daa6$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $2f5a9112cdc5daa6$var$_firstTwoOnly($2f5a9112cdc5daa6$var$_getComputedProperty(target, $2f5a9112cdc5daa6$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $2f5a9112cdc5daa6$var$_specialProps[property] && $2f5a9112cdc5daa6$var$_specialProps[property](target, property, unit) || $2f5a9112cdc5daa6$var$_getComputedProperty(target, property) || (0, $bYZui._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $2f5a9112cdc5daa6$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $2f5a9112cdc5daa6$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $2f5a9112cdc5daa6$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $2f5a9112cdc5daa6$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $2f5a9112cdc5daa6$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bYZui.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bYZui._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $2f5a9112cdc5daa6$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $2f5a9112cdc5daa6$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bYZui._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bYZui._numWithUnitExp)) || [];
    endValues = end.match((0, $bYZui._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bYZui._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bYZui._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bYZui._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bYZui._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $2f5a9112cdc5daa6$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $2f5a9112cdc5daa6$var$_renderNonTweeningValueOnlyAtEnd : $2f5a9112cdc5daa6$var$_renderNonTweeningValue;
    (0, $bYZui._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $2f5a9112cdc5daa6$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $2f5a9112cdc5daa6$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $2f5a9112cdc5daa6$var$_keywordToPercent[x] || x;
    split[1] = $2f5a9112cdc5daa6$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $2f5a9112cdc5daa6$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($2f5a9112cdc5daa6$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $2f5a9112cdc5daa6$var$_transformOriginProp : $2f5a9112cdc5daa6$var$_transformProp;
                }
                $2f5a9112cdc5daa6$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $2f5a9112cdc5daa6$var$_removeProperty(target, $2f5a9112cdc5daa6$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $2f5a9112cdc5daa6$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $2f5a9112cdc5daa6$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$2f5a9112cdc5daa6$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bYZui.PropTween)(plugin._pt, target, property, 0, 0, $2f5a9112cdc5daa6$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $2f5a9112cdc5daa6$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $2f5a9112cdc5daa6$var$_rotationalProperties = {}, $2f5a9112cdc5daa6$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $2f5a9112cdc5daa6$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $2f5a9112cdc5daa6$var$_getComputedProperty(target, $2f5a9112cdc5daa6$var$_transformProp);
    return $2f5a9112cdc5daa6$var$_isNullTransform(matrixString) ? $2f5a9112cdc5daa6$var$_identity2DMatrix : matrixString.substr(7).match((0, $bYZui._numExp)).map((0, $bYZui._round));
}, $2f5a9112cdc5daa6$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bYZui._getCache)(target), style = target.style, matrix = $2f5a9112cdc5daa6$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $2f5a9112cdc5daa6$var$_identity2DMatrix : matrix;
    } else if (matrix === $2f5a9112cdc5daa6$var$_identity2DMatrix && !target.offsetParent && target !== $2f5a9112cdc5daa6$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $2f5a9112cdc5daa6$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $2f5a9112cdc5daa6$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $2f5a9112cdc5daa6$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $2f5a9112cdc5daa6$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $2f5a9112cdc5daa6$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $2f5a9112cdc5daa6$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $2f5a9112cdc5daa6$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $2f5a9112cdc5daa6$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$2f5a9112cdc5daa6$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $2f5a9112cdc5daa6$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $2f5a9112cdc5daa6$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $2f5a9112cdc5daa6$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $2f5a9112cdc5daa6$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $2f5a9112cdc5daa6$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bYZui.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $2f5a9112cdc5daa6$var$_getComputedProperty(target, $2f5a9112cdc5daa6$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $2f5a9112cdc5daa6$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$2f5a9112cdc5daa6$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$2f5a9112cdc5daa6$var$_transformProp] !== "none" ? cs[$2f5a9112cdc5daa6$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $2f5a9112cdc5daa6$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $2f5a9112cdc5daa6$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $2f5a9112cdc5daa6$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $2f5a9112cdc5daa6$var$_atan2(b, a) * $2f5a9112cdc5daa6$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $2f5a9112cdc5daa6$var$_atan2(c, d) * $2f5a9112cdc5daa6$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $2f5a9112cdc5daa6$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $2f5a9112cdc5daa6$var$_atan2(a32, a33);
            rotationX = angle * $2f5a9112cdc5daa6$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $2f5a9112cdc5daa6$var$_atan2(-c, a33);
            rotationY = angle * $2f5a9112cdc5daa6$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $2f5a9112cdc5daa6$var$_atan2(b, a);
            rotation = angle * $2f5a9112cdc5daa6$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bYZui._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bYZui._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $2f5a9112cdc5daa6$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $2f5a9112cdc5daa6$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$2f5a9112cdc5daa6$var$_isNullTransform($2f5a9112cdc5daa6$var$_getComputedProperty(target, $2f5a9112cdc5daa6$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bYZui._round)(scaleX);
    cache.scaleY = (0, $bYZui._round)(scaleY);
    cache.rotation = (0, $bYZui._round)(rotation) + deg;
    cache.rotationX = (0, $bYZui._round)(rotationX) + deg;
    cache.rotationY = (0, $bYZui._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$2f5a9112cdc5daa6$var$_transformOriginProp] = $2f5a9112cdc5daa6$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bYZui._config).force3D;
    cache.renderTransform = cache.svg ? $2f5a9112cdc5daa6$var$_renderSVGTransforms : $2f5a9112cdc5daa6$var$_supports3D ? $2f5a9112cdc5daa6$var$_renderCSSTransforms : $2f5a9112cdc5daa6$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $2f5a9112cdc5daa6$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$2f5a9112cdc5daa6$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bYZui.getUnit)(start);
    return (0, $bYZui._round)(parseFloat(start) + parseFloat($2f5a9112cdc5daa6$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $2f5a9112cdc5daa6$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $2f5a9112cdc5daa6$var$_renderCSSTransforms(ratio, cache);
}, $2f5a9112cdc5daa6$var$_zeroDeg = "0deg", $2f5a9112cdc5daa6$var$_zeroPx = "0px", $2f5a9112cdc5daa6$var$_endParenthesis = ") ", $2f5a9112cdc5daa6$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $2f5a9112cdc5daa6$var$_zeroDeg || rotationY !== $2f5a9112cdc5daa6$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $2f5a9112cdc5daa6$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $2f5a9112cdc5daa6$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $2f5a9112cdc5daa6$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $2f5a9112cdc5daa6$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $2f5a9112cdc5daa6$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $2f5a9112cdc5daa6$var$_zeroPx) transforms += "perspective(" + transformPerspective + $2f5a9112cdc5daa6$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $2f5a9112cdc5daa6$var$_zeroPx || y !== $2f5a9112cdc5daa6$var$_zeroPx || z !== $2f5a9112cdc5daa6$var$_zeroPx) transforms += z !== $2f5a9112cdc5daa6$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $2f5a9112cdc5daa6$var$_endParenthesis;
    if (rotation !== $2f5a9112cdc5daa6$var$_zeroDeg) transforms += "rotate(" + rotation + $2f5a9112cdc5daa6$var$_endParenthesis;
    if (rotationY !== $2f5a9112cdc5daa6$var$_zeroDeg) transforms += "rotateY(" + rotationY + $2f5a9112cdc5daa6$var$_endParenthesis;
    if (rotationX !== $2f5a9112cdc5daa6$var$_zeroDeg) transforms += "rotateX(" + rotationX + $2f5a9112cdc5daa6$var$_endParenthesis;
    if (skewX !== $2f5a9112cdc5daa6$var$_zeroDeg || skewY !== $2f5a9112cdc5daa6$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $2f5a9112cdc5daa6$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $2f5a9112cdc5daa6$var$_endParenthesis;
    target.style[$2f5a9112cdc5daa6$var$_transformProp] = transforms || "translate(0, 0)";
}, $2f5a9112cdc5daa6$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $2f5a9112cdc5daa6$var$_DEG2RAD;
        skewX *= $2f5a9112cdc5daa6$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $2f5a9112cdc5daa6$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bYZui._round)(a11);
        a21 = (0, $bYZui._round)(a21);
        a12 = (0, $bYZui._round)(a12);
        a22 = (0, $bYZui._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $2f5a9112cdc5daa6$var$_convertToUnit(target, "x", x, "px");
        ty = $2f5a9112cdc5daa6$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bYZui._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bYZui._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bYZui._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bYZui._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$2f5a9112cdc5daa6$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $2f5a9112cdc5daa6$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bYZui._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $2f5a9112cdc5daa6$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $2f5a9112cdc5daa6$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $2f5a9112cdc5daa6$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bYZui.PropTween)(plugin._pt, target, property, startNum, change, $2f5a9112cdc5daa6$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $2f5a9112cdc5daa6$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $2f5a9112cdc5daa6$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $2f5a9112cdc5daa6$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$2f5a9112cdc5daa6$var$_transformProp] = transforms;
        endCache = $2f5a9112cdc5daa6$var$_parseTransform(target, 1);
        $2f5a9112cdc5daa6$var$_removeProperty(target, $2f5a9112cdc5daa6$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$2f5a9112cdc5daa6$var$_transformProp];
        style[$2f5a9112cdc5daa6$var$_transformProp] = transforms;
        endCache = $2f5a9112cdc5daa6$var$_parseTransform(target, 1);
        style[$2f5a9112cdc5daa6$var$_transformProp] = startValue;
    }
    for(p in $2f5a9112cdc5daa6$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bYZui.getUnit)(startValue);
            endUnit = (0, $bYZui.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $2f5a9112cdc5daa6$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bYZui.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $2f5a9112cdc5daa6$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $2f5a9112cdc5daa6$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bYZui._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $2f5a9112cdc5daa6$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $2f5a9112cdc5daa6$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $2f5a9112cdc5daa6$export$855822f522f18eef = {
    name: "css",
    register: $2f5a9112cdc5daa6$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $2f5a9112cdc5daa6$var$_pluginInitted || $2f5a9112cdc5daa6$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $2f5a9112cdc5daa6$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bYZui._plugins)[p] && (0, $bYZui._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $2f5a9112cdc5daa6$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bYZui._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bYZui._colorExp).lastIndex = 0;
                if (!(0, $bYZui._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bYZui.getUnit)(startValue);
                    endUnit = (0, $bYZui.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $2f5a9112cdc5daa6$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bYZui._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bYZui._replaceRandom)(startValue));
                    (0, $bYZui.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bYZui._config).units[p] || (0, $bYZui.getUnit)($2f5a9112cdc5daa6$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $2f5a9112cdc5daa6$var$_get(target, p)); // can't work with relative values
                } else startValue = $2f5a9112cdc5daa6$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $2f5a9112cdc5daa6$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $2f5a9112cdc5daa6$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $2f5a9112cdc5daa6$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $2f5a9112cdc5daa6$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $2f5a9112cdc5daa6$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $2f5a9112cdc5daa6$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bYZui.PropTween)(this._pt, style, $2f5a9112cdc5daa6$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bYZui.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bYZui._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $2f5a9112cdc5daa6$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($2f5a9112cdc5daa6$var$_transformOriginProp, 0, style[$2f5a9112cdc5daa6$var$_transformOriginProp]);
                        endValue = $2f5a9112cdc5daa6$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $2f5a9112cdc5daa6$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $2f5a9112cdc5daa6$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $2f5a9112cdc5daa6$var$_addNonTweeningPT(this, style, p, $2f5a9112cdc5daa6$var$_firstTwoOnly(startValue), $2f5a9112cdc5daa6$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $2f5a9112cdc5daa6$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $2f5a9112cdc5daa6$var$_rotationalProperties) {
                        $2f5a9112cdc5daa6$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bYZui._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $2f5a9112cdc5daa6$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $2f5a9112cdc5daa6$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $2f5a9112cdc5daa6$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$2f5a9112cdc5daa6$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bYZui.getUnit)(endValue) || (p in (0, $bYZui._config).units ? (0, $bYZui._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $2f5a9112cdc5daa6$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bYZui.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bYZui._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $2f5a9112cdc5daa6$var$_renderRoundedCSSProp : $2f5a9112cdc5daa6$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $2f5a9112cdc5daa6$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bYZui._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $2f5a9112cdc5daa6$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bYZui._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$2f5a9112cdc5daa6$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $2f5a9112cdc5daa6$var$_get,
    aliases: $2f5a9112cdc5daa6$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $2f5a9112cdc5daa6$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $2f5a9112cdc5daa6$var$_transformProps && property !== $2f5a9112cdc5daa6$var$_transformOriginProp && (target._gsap.x || $2f5a9112cdc5daa6$var$_get(target, "x")) ? plugin && $2f5a9112cdc5daa6$var$_recentSetterPlugin === plugin ? property === "scale" ? $2f5a9112cdc5daa6$var$_setterScale : $2f5a9112cdc5daa6$var$_setterTransform : ($2f5a9112cdc5daa6$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $2f5a9112cdc5daa6$var$_setterScaleWithRender : $2f5a9112cdc5daa6$var$_setterTransformWithRender) : target.style && !(0, $bYZui._isUndefined)(target.style[property]) ? $2f5a9112cdc5daa6$var$_setterCSSStyle : ~property.indexOf("-") ? $2f5a9112cdc5daa6$var$_setterCSSProp : (0, $bYZui._getSetter)(target, property);
    },
    core: {
        _removeProperty: $2f5a9112cdc5daa6$var$_removeProperty,
        _getMatrix: $2f5a9112cdc5daa6$var$_getMatrix
    }
};
(0, $bYZui.gsap).utils.checkPrefix = $2f5a9112cdc5daa6$export$8cbef5dd49a09c8b;
(0, $bYZui.gsap).core.getStyleSaver = $2f5a9112cdc5daa6$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bYZui._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $2f5a9112cdc5daa6$var$_transformProps[name] = 1;
    });
    (0, $bYZui._forEachName)(rotation, function(name) {
        (0, $bYZui._config).units[name] = "deg";
        $2f5a9112cdc5daa6$var$_rotationalProperties[name] = 1;
    });
    $2f5a9112cdc5daa6$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bYZui._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $2f5a9112cdc5daa6$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bYZui._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bYZui._config).units[name] = "px";
});
(0, $bYZui.gsap).registerPlugin($2f5a9112cdc5daa6$export$855822f522f18eef);


var $310c7edeeb54bee4$export$99ee26438460406a = (0, $bYZui.gsap).registerPlugin((0, $2f5a9112cdc5daa6$export$855822f522f18eef)) || (0, $bYZui.gsap), // to protect from tree shaking
$310c7edeeb54bee4$export$7b23975ad686bf91 = $310c7edeeb54bee4$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $c54226a072d7e33d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c54226a072d7e33d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c54226a072d7e33d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c54226a072d7e33d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $c54226a072d7e33d$var$gsap, $c54226a072d7e33d$var$_coreInitted, $c54226a072d7e33d$var$_clamp, $c54226a072d7e33d$var$_win, $c54226a072d7e33d$var$_doc, $c54226a072d7e33d$var$_docEl, $c54226a072d7e33d$var$_body, $c54226a072d7e33d$var$_isTouch, $c54226a072d7e33d$var$_pointerType, $c54226a072d7e33d$var$ScrollTrigger, $c54226a072d7e33d$var$_root, $c54226a072d7e33d$var$_normalizer, $c54226a072d7e33d$var$_eventTypes, $c54226a072d7e33d$var$_context, $c54226a072d7e33d$var$_getGSAP = function _getGSAP() {
    return $c54226a072d7e33d$var$gsap || typeof window !== "undefined" && ($c54226a072d7e33d$var$gsap = window.gsap) && $c54226a072d7e33d$var$gsap.registerPlugin && $c54226a072d7e33d$var$gsap;
}, $c54226a072d7e33d$var$_startup = 1, $c54226a072d7e33d$var$_observers = [], $c54226a072d7e33d$export$3cd1cee43d19b683 = [], $c54226a072d7e33d$export$d8e56d510a804d0a = [], $c54226a072d7e33d$var$_getTime = Date.now, $c54226a072d7e33d$var$_bridge = function _bridge(name, value) {
    return value;
}, $c54226a072d7e33d$var$_integrate = function _integrate() {
    var core = $c54226a072d7e33d$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $c54226a072d7e33d$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $c54226a072d7e33d$export$d8e56d510a804d0a);
    $c54226a072d7e33d$export$3cd1cee43d19b683 = scrollers;
    $c54226a072d7e33d$export$d8e56d510a804d0a = proxies;
    $c54226a072d7e33d$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $c54226a072d7e33d$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$c54226a072d7e33d$export$d8e56d510a804d0a.indexOf(element) && $c54226a072d7e33d$export$d8e56d510a804d0a[$c54226a072d7e33d$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $c54226a072d7e33d$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$c54226a072d7e33d$var$_root.indexOf(el);
}, $c54226a072d7e33d$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $c54226a072d7e33d$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $c54226a072d7e33d$var$_scrollLeft = "scrollLeft", $c54226a072d7e33d$var$_scrollTop = "scrollTop", $c54226a072d7e33d$var$_onScroll = function _onScroll() {
    return $c54226a072d7e33d$var$_normalizer && $c54226a072d7e33d$var$_normalizer.isPressed || $c54226a072d7e33d$export$3cd1cee43d19b683.cache++;
}, $c54226a072d7e33d$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $c54226a072d7e33d$var$_startup && ($c54226a072d7e33d$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $c54226a072d7e33d$var$_normalizer && $c54226a072d7e33d$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($c54226a072d7e33d$var$_normalizer && $c54226a072d7e33d$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $c54226a072d7e33d$export$3cd1cee43d19b683.cache;
            isNormalizing && $c54226a072d7e33d$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $c54226a072d7e33d$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $c54226a072d7e33d$var$_bridge("ref")) {
            cachingFunc.cacheID = $c54226a072d7e33d$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $c54226a072d7e33d$export$b2cabb342cb0ebe1 = {
    s: $c54226a072d7e33d$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $c54226a072d7e33d$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $c54226a072d7e33d$var$_win.scrollTo(value, $c54226a072d7e33d$export$8e40fc98ff518e9d.sc()) : $c54226a072d7e33d$var$_win.pageXOffset || $c54226a072d7e33d$var$_doc[$c54226a072d7e33d$var$_scrollLeft] || $c54226a072d7e33d$var$_docEl[$c54226a072d7e33d$var$_scrollLeft] || $c54226a072d7e33d$var$_body[$c54226a072d7e33d$var$_scrollLeft] || 0;
    })
}, $c54226a072d7e33d$export$8e40fc98ff518e9d = {
    s: $c54226a072d7e33d$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $c54226a072d7e33d$export$b2cabb342cb0ebe1,
    sc: $c54226a072d7e33d$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $c54226a072d7e33d$var$_win.scrollTo($c54226a072d7e33d$export$b2cabb342cb0ebe1.sc(), value) : $c54226a072d7e33d$var$_win.pageYOffset || $c54226a072d7e33d$var$_doc[$c54226a072d7e33d$var$_scrollTop] || $c54226a072d7e33d$var$_docEl[$c54226a072d7e33d$var$_scrollTop] || $c54226a072d7e33d$var$_body[$c54226a072d7e33d$var$_scrollTop] || 0;
    })
}, $c54226a072d7e33d$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $c54226a072d7e33d$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $c54226a072d7e33d$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $c54226a072d7e33d$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $c54226a072d7e33d$export$4330f3a92e5d2e94(element) && (element = $c54226a072d7e33d$var$_doc.scrollingElement || $c54226a072d7e33d$var$_docEl);
    var i = $c54226a072d7e33d$export$3cd1cee43d19b683.indexOf(element), offset = sc === $c54226a072d7e33d$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $c54226a072d7e33d$export$3cd1cee43d19b683.push(element) - 1);
    $c54226a072d7e33d$export$3cd1cee43d19b683[i + offset] || $c54226a072d7e33d$var$_addListener(element, "scroll", $c54226a072d7e33d$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $c54226a072d7e33d$export$3cd1cee43d19b683[i + offset], func = prev || ($c54226a072d7e33d$export$3cd1cee43d19b683[i + offset] = $c54226a072d7e33d$var$_scrollCacheFunc($c54226a072d7e33d$export$6078f1ef08b38af9(element, s), true) || ($c54226a072d7e33d$export$4330f3a92e5d2e94(element) ? sc : $c54226a072d7e33d$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $c54226a072d7e33d$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $c54226a072d7e33d$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $c54226a072d7e33d$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $c54226a072d7e33d$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $c54226a072d7e33d$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $c54226a072d7e33d$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $c54226a072d7e33d$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $c54226a072d7e33d$var$_setScrollTrigger = function _setScrollTrigger() {
    $c54226a072d7e33d$var$ScrollTrigger = $c54226a072d7e33d$var$gsap.core.globals().ScrollTrigger;
    $c54226a072d7e33d$var$ScrollTrigger && $c54226a072d7e33d$var$ScrollTrigger.core && $c54226a072d7e33d$var$_integrate();
}, $c54226a072d7e33d$var$_initCore = function _initCore(core) {
    $c54226a072d7e33d$var$gsap = core || $c54226a072d7e33d$var$_getGSAP();
    if (!$c54226a072d7e33d$var$_coreInitted && $c54226a072d7e33d$var$gsap && typeof document !== "undefined" && document.body) {
        $c54226a072d7e33d$var$_win = window;
        $c54226a072d7e33d$var$_doc = document;
        $c54226a072d7e33d$var$_docEl = $c54226a072d7e33d$var$_doc.documentElement;
        $c54226a072d7e33d$var$_body = $c54226a072d7e33d$var$_doc.body;
        $c54226a072d7e33d$var$_root = [
            $c54226a072d7e33d$var$_win,
            $c54226a072d7e33d$var$_doc,
            $c54226a072d7e33d$var$_docEl,
            $c54226a072d7e33d$var$_body
        ];
        $c54226a072d7e33d$var$_clamp = $c54226a072d7e33d$var$gsap.utils.clamp;
        $c54226a072d7e33d$var$_context = $c54226a072d7e33d$var$gsap.core.context || function() {};
        $c54226a072d7e33d$var$_pointerType = "onpointerenter" in $c54226a072d7e33d$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $c54226a072d7e33d$var$_isTouch = $c54226a072d7e33d$export$c1cbdee04e18ea8b.isTouch = $c54226a072d7e33d$var$_win.matchMedia && $c54226a072d7e33d$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $c54226a072d7e33d$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $c54226a072d7e33d$var$_eventTypes = $c54226a072d7e33d$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $c54226a072d7e33d$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $c54226a072d7e33d$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $c54226a072d7e33d$var$_startup = 0;
        }, 500);
        $c54226a072d7e33d$var$_setScrollTrigger();
        $c54226a072d7e33d$var$_coreInitted = 1;
    }
    return $c54226a072d7e33d$var$_coreInitted;
};
$c54226a072d7e33d$export$b2cabb342cb0ebe1.op = $c54226a072d7e33d$export$8e40fc98ff518e9d;
$c54226a072d7e33d$export$3cd1cee43d19b683.cache = 0;
var $c54226a072d7e33d$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $c54226a072d7e33d$var$_coreInitted || $c54226a072d7e33d$var$_initCore($c54226a072d7e33d$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $c54226a072d7e33d$var$ScrollTrigger || $c54226a072d7e33d$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $c54226a072d7e33d$export$937374fea3f88711(target) || $c54226a072d7e33d$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $c54226a072d7e33d$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($c54226a072d7e33d$var$_win.getComputedStyle($c54226a072d7e33d$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault, scrollFuncX = $c54226a072d7e33d$export$8665aac53dad5647(target, $c54226a072d7e33d$export$b2cabb342cb0ebe1), scrollFuncY = $c54226a072d7e33d$export$8665aac53dad5647(target, $c54226a072d7e33d$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $c54226a072d7e33d$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $c54226a072d7e33d$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $c54226a072d7e33d$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $c54226a072d7e33d$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $c54226a072d7e33d$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $c54226a072d7e33d$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $c54226a072d7e33d$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $c54226a072d7e33d$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $c54226a072d7e33d$var$_addListener(isNormalizer ? target : ownerDoc, $c54226a072d7e33d$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $c54226a072d7e33d$var$_removeListener(isNormalizer ? target : ownerDoc, $c54226a072d7e33d$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $c54226a072d7e33d$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $c54226a072d7e33d$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($c54226a072d7e33d$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $c54226a072d7e33d$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $c54226a072d7e33d$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $c54226a072d7e33d$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $c54226a072d7e33d$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $c54226a072d7e33d$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $c54226a072d7e33d$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $c54226a072d7e33d$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $c54226a072d7e33d$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $c54226a072d7e33d$var$_addListener(isViewport ? ownerDoc : target, "scroll", $c54226a072d7e33d$var$_onScroll);
                type.indexOf("scroll") >= 0 && $c54226a072d7e33d$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $c54226a072d7e33d$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $c54226a072d7e33d$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $c54226a072d7e33d$var$_addListener(target, $c54226a072d7e33d$var$_eventTypes[0], _onPress, passive, capture);
                    $c54226a072d7e33d$var$_addListener(ownerDoc, $c54226a072d7e33d$var$_eventTypes[2], _onRelease);
                    $c54226a072d7e33d$var$_addListener(ownerDoc, $c54226a072d7e33d$var$_eventTypes[3], _onRelease);
                    allowClicks && $c54226a072d7e33d$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $c54226a072d7e33d$var$_addListener(target, "click", _onClick);
                    onGestureStart && $c54226a072d7e33d$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $c54226a072d7e33d$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $c54226a072d7e33d$var$_addListener(target, $c54226a072d7e33d$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $c54226a072d7e33d$var$_addListener(target, $c54226a072d7e33d$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $c54226a072d7e33d$var$_addListener(target, $c54226a072d7e33d$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $c54226a072d7e33d$var$_observers.filter(function(o) {
                    return o !== self && $c54226a072d7e33d$export$4330f3a92e5d2e94(o.target);
                }).length || $c54226a072d7e33d$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $c54226a072d7e33d$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $c54226a072d7e33d$var$_removeListener(isNormalizer ? target : ownerDoc, $c54226a072d7e33d$var$_eventTypes[1], _onDrag, true);
                }
                $c54226a072d7e33d$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $c54226a072d7e33d$var$_removeListener(target, "wheel", _onWheel, capture);
                $c54226a072d7e33d$var$_removeListener(target, $c54226a072d7e33d$var$_eventTypes[0], _onPress, capture);
                $c54226a072d7e33d$var$_removeListener(ownerDoc, $c54226a072d7e33d$var$_eventTypes[2], _onRelease);
                $c54226a072d7e33d$var$_removeListener(ownerDoc, $c54226a072d7e33d$var$_eventTypes[3], _onRelease);
                $c54226a072d7e33d$var$_removeListener(target, "click", clickCapture, true);
                $c54226a072d7e33d$var$_removeListener(target, "click", _onClick);
                $c54226a072d7e33d$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $c54226a072d7e33d$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $c54226a072d7e33d$var$_removeListener(target, $c54226a072d7e33d$var$_pointerType + "enter", _onHover);
                $c54226a072d7e33d$var$_removeListener(target, $c54226a072d7e33d$var$_pointerType + "leave", _onHoverEnd);
                $c54226a072d7e33d$var$_removeListener(target, $c54226a072d7e33d$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $c54226a072d7e33d$var$_observers.indexOf(self);
            i >= 0 && $c54226a072d7e33d$var$_observers.splice(i, 1);
            $c54226a072d7e33d$var$_normalizer === self && ($c54226a072d7e33d$var$_normalizer = 0);
        };
        $c54226a072d7e33d$var$_observers.push(self);
        isNormalizer && $c54226a072d7e33d$export$4330f3a92e5d2e94(target) && ($c54226a072d7e33d$var$_normalizer = self);
        self.enable(event);
    };
    $c54226a072d7e33d$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$c54226a072d7e33d$export$c1cbdee04e18ea8b.version = "3.12.5";
$c54226a072d7e33d$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $c54226a072d7e33d$export$c1cbdee04e18ea8b(vars);
};
$c54226a072d7e33d$export$c1cbdee04e18ea8b.register = $c54226a072d7e33d$var$_initCore;
$c54226a072d7e33d$export$c1cbdee04e18ea8b.getAll = function() {
    return $c54226a072d7e33d$var$_observers.slice();
};
$c54226a072d7e33d$export$c1cbdee04e18ea8b.getById = function(id) {
    return $c54226a072d7e33d$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$c54226a072d7e33d$var$_getGSAP() && $c54226a072d7e33d$var$gsap.registerPlugin($c54226a072d7e33d$export$c1cbdee04e18ea8b);


var $4fdec5228fea4ed1$var$gsap, $4fdec5228fea4ed1$var$_coreInitted, $4fdec5228fea4ed1$var$_win, $4fdec5228fea4ed1$var$_doc, $4fdec5228fea4ed1$var$_docEl, $4fdec5228fea4ed1$var$_body, $4fdec5228fea4ed1$var$_root, $4fdec5228fea4ed1$var$_resizeDelay, $4fdec5228fea4ed1$var$_toArray, $4fdec5228fea4ed1$var$_clamp, $4fdec5228fea4ed1$var$_time2, $4fdec5228fea4ed1$var$_syncInterval, $4fdec5228fea4ed1$var$_refreshing, $4fdec5228fea4ed1$var$_pointerIsDown, $4fdec5228fea4ed1$var$_transformProp, $4fdec5228fea4ed1$var$_i, $4fdec5228fea4ed1$var$_prevWidth, $4fdec5228fea4ed1$var$_prevHeight, $4fdec5228fea4ed1$var$_autoRefresh, $4fdec5228fea4ed1$var$_sort, $4fdec5228fea4ed1$var$_suppressOverwrites, $4fdec5228fea4ed1$var$_ignoreResize, $4fdec5228fea4ed1$var$_normalizer, $4fdec5228fea4ed1$var$_ignoreMobileResize, $4fdec5228fea4ed1$var$_baseScreenHeight, $4fdec5228fea4ed1$var$_baseScreenWidth, $4fdec5228fea4ed1$var$_fixIOSBug, $4fdec5228fea4ed1$var$_context, $4fdec5228fea4ed1$var$_scrollRestoration, $4fdec5228fea4ed1$var$_div100vh, $4fdec5228fea4ed1$var$_100vh, $4fdec5228fea4ed1$var$_isReverted, $4fdec5228fea4ed1$var$_clampingMax, $4fdec5228fea4ed1$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$4fdec5228fea4ed1$var$_startup = 1, $4fdec5228fea4ed1$var$_getTime = Date.now, $4fdec5228fea4ed1$var$_time1 = $4fdec5228fea4ed1$var$_getTime(), $4fdec5228fea4ed1$var$_lastScrollTime = 0, $4fdec5228fea4ed1$var$_enabled = 0, $4fdec5228fea4ed1$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $4fdec5228fea4ed1$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $4fdec5228fea4ed1$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$4fdec5228fea4ed1$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $4fdec5228fea4ed1$var$_rafBugFix = function _rafBugFix() {
    return $4fdec5228fea4ed1$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$4fdec5228fea4ed1$var$_pointerDownHandler = function _pointerDownHandler() {
    return $4fdec5228fea4ed1$var$_pointerIsDown = 1;
}, $4fdec5228fea4ed1$var$_pointerUpHandler = function _pointerUpHandler() {
    return $4fdec5228fea4ed1$var$_pointerIsDown = 0;
}, $4fdec5228fea4ed1$var$_passThrough = function _passThrough(v) {
    return v;
}, $4fdec5228fea4ed1$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $4fdec5228fea4ed1$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $4fdec5228fea4ed1$var$_getGSAP = function _getGSAP() {
    return $4fdec5228fea4ed1$var$gsap || $4fdec5228fea4ed1$var$_windowExists() && ($4fdec5228fea4ed1$var$gsap = window.gsap) && $4fdec5228fea4ed1$var$gsap.registerPlugin && $4fdec5228fea4ed1$var$gsap;
}, $4fdec5228fea4ed1$var$_isViewport = function _isViewport(e) {
    return !!~$4fdec5228fea4ed1$var$_root.indexOf(e);
}, $4fdec5228fea4ed1$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $4fdec5228fea4ed1$var$_100vh : $4fdec5228fea4ed1$var$_win["inner" + dimensionProperty]) || $4fdec5228fea4ed1$var$_docEl["client" + dimensionProperty] || $4fdec5228fea4ed1$var$_body["client" + dimensionProperty];
}, $4fdec5228fea4ed1$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $c54226a072d7e33d$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($4fdec5228fea4ed1$var$_isViewport(element) ? function() {
        $4fdec5228fea4ed1$var$_winOffsets.width = $4fdec5228fea4ed1$var$_win.innerWidth;
        $4fdec5228fea4ed1$var$_winOffsets.height = $4fdec5228fea4ed1$var$_100vh;
        return $4fdec5228fea4ed1$var$_winOffsets;
    } : function() {
        return $4fdec5228fea4ed1$var$_getBounds(element);
    });
}, $4fdec5228fea4ed1$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $c54226a072d7e33d$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $4fdec5228fea4ed1$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $4fdec5228fea4ed1$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $c54226a072d7e33d$export$d8e56d510a804d0a).indexOf(element) ? $4fdec5228fea4ed1$var$_getBoundsFunc(element) : function() {
        return $4fdec5228fea4ed1$var$_winOffsets;
    };
}, $4fdec5228fea4ed1$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $c54226a072d7e33d$export$6078f1ef08b38af9)(element, s)) ? a() - $4fdec5228fea4ed1$var$_getBoundsFunc(element)()[d] : $4fdec5228fea4ed1$var$_isViewport(element) ? ($4fdec5228fea4ed1$var$_docEl[s] || $4fdec5228fea4ed1$var$_body[s]) - $4fdec5228fea4ed1$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $4fdec5228fea4ed1$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $4fdec5228fea4ed1$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($4fdec5228fea4ed1$var$_autoRefresh[i + 1])) && func($4fdec5228fea4ed1$var$_autoRefresh[i], $4fdec5228fea4ed1$var$_autoRefresh[i + 1], $4fdec5228fea4ed1$var$_autoRefresh[i + 2]);
}, $4fdec5228fea4ed1$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $4fdec5228fea4ed1$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $4fdec5228fea4ed1$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $4fdec5228fea4ed1$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $4fdec5228fea4ed1$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $4fdec5228fea4ed1$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $4fdec5228fea4ed1$var$_abs = Math.abs, $4fdec5228fea4ed1$var$_left = "left", $4fdec5228fea4ed1$var$_top = "top", $4fdec5228fea4ed1$var$_right = "right", $4fdec5228fea4ed1$var$_bottom = "bottom", $4fdec5228fea4ed1$var$_width = "width", $4fdec5228fea4ed1$var$_height = "height", $4fdec5228fea4ed1$var$_Right = "Right", $4fdec5228fea4ed1$var$_Left = "Left", $4fdec5228fea4ed1$var$_Top = "Top", $4fdec5228fea4ed1$var$_Bottom = "Bottom", $4fdec5228fea4ed1$var$_padding = "padding", $4fdec5228fea4ed1$var$_margin = "margin", $4fdec5228fea4ed1$var$_Width = "Width", $4fdec5228fea4ed1$var$_Height = "Height", $4fdec5228fea4ed1$var$_px = "px", $4fdec5228fea4ed1$var$_getComputedStyle = function _getComputedStyle(element) {
    return $4fdec5228fea4ed1$var$_win.getComputedStyle(element);
}, $4fdec5228fea4ed1$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $4fdec5228fea4ed1$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $4fdec5228fea4ed1$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $4fdec5228fea4ed1$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $4fdec5228fea4ed1$var$_getComputedStyle(element)[$4fdec5228fea4ed1$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $4fdec5228fea4ed1$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $4fdec5228fea4ed1$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $4fdec5228fea4ed1$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $4fdec5228fea4ed1$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $4fdec5228fea4ed1$var$gsap.utils.snap($4fdec5228fea4ed1$var$_getLabelRatioArray(animation), value);
    };
}, $4fdec5228fea4ed1$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $4fdec5228fea4ed1$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $4fdec5228fea4ed1$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $4fdec5228fea4ed1$var$_snapDirectional($4fdec5228fea4ed1$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $4fdec5228fea4ed1$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $4fdec5228fea4ed1$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $4fdec5228fea4ed1$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $4fdec5228fea4ed1$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $4fdec5228fea4ed1$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $4fdec5228fea4ed1$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $4fdec5228fea4ed1$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $4fdec5228fea4ed1$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($4fdec5228fea4ed1$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $4fdec5228fea4ed1$var$_keywords ? $4fdec5228fea4ed1$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $4fdec5228fea4ed1$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $4fdec5228fea4ed1$var$_doc.createElement("div"), useFixedPosition = $4fdec5228fea4ed1$var$_isViewport(container) || (0, $c54226a072d7e33d$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $4fdec5228fea4ed1$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $c54226a072d7e33d$export$8e40fc98ff518e9d) ? $4fdec5228fea4ed1$var$_right : $4fdec5228fea4ed1$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $4fdec5228fea4ed1$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $4fdec5228fea4ed1$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $4fdec5228fea4ed1$var$_Width] = 1;
    vars["border" + oppositeSide + $4fdec5228fea4ed1$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $4fdec5228fea4ed1$var$gsap.set(marker, vars);
}, $4fdec5228fea4ed1$var$_triggers = [], $4fdec5228fea4ed1$var$_ids = {}, $4fdec5228fea4ed1$var$_rafID, $4fdec5228fea4ed1$var$_sync = function _sync() {
    return $4fdec5228fea4ed1$var$_getTime() - $4fdec5228fea4ed1$var$_lastScrollTime > 34 && ($4fdec5228fea4ed1$var$_rafID || ($4fdec5228fea4ed1$var$_rafID = requestAnimationFrame($4fdec5228fea4ed1$var$_updateAll)));
}, $4fdec5228fea4ed1$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$4fdec5228fea4ed1$var$_normalizer || !$4fdec5228fea4ed1$var$_normalizer.isPressed || $4fdec5228fea4ed1$var$_normalizer.startX > $4fdec5228fea4ed1$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $c54226a072d7e33d$export$3cd1cee43d19b683).cache++;
        if ($4fdec5228fea4ed1$var$_normalizer) $4fdec5228fea4ed1$var$_rafID || ($4fdec5228fea4ed1$var$_rafID = requestAnimationFrame($4fdec5228fea4ed1$var$_updateAll));
        else $4fdec5228fea4ed1$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $4fdec5228fea4ed1$var$_lastScrollTime || $4fdec5228fea4ed1$var$_dispatch("scrollStart");
        $4fdec5228fea4ed1$var$_lastScrollTime = $4fdec5228fea4ed1$var$_getTime();
    }
}, $4fdec5228fea4ed1$var$_setBaseDimensions = function _setBaseDimensions() {
    $4fdec5228fea4ed1$var$_baseScreenWidth = $4fdec5228fea4ed1$var$_win.innerWidth;
    $4fdec5228fea4ed1$var$_baseScreenHeight = $4fdec5228fea4ed1$var$_win.innerHeight;
}, $4fdec5228fea4ed1$var$_onResize = function _onResize() {
    (0, $c54226a072d7e33d$export$3cd1cee43d19b683).cache++;
    !$4fdec5228fea4ed1$var$_refreshing && !$4fdec5228fea4ed1$var$_ignoreResize && !$4fdec5228fea4ed1$var$_doc.fullscreenElement && !$4fdec5228fea4ed1$var$_doc.webkitFullscreenElement && (!$4fdec5228fea4ed1$var$_ignoreMobileResize || $4fdec5228fea4ed1$var$_baseScreenWidth !== $4fdec5228fea4ed1$var$_win.innerWidth || Math.abs($4fdec5228fea4ed1$var$_win.innerHeight - $4fdec5228fea4ed1$var$_baseScreenHeight) > $4fdec5228fea4ed1$var$_win.innerHeight * 0.25) && $4fdec5228fea4ed1$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$4fdec5228fea4ed1$var$_listeners = {}, $4fdec5228fea4ed1$var$_emptyArray = [], $4fdec5228fea4ed1$var$_softRefresh = function _softRefresh() {
    return $4fdec5228fea4ed1$var$_removeListener($4fdec5228fea4ed1$export$875bcbe48555930, "scrollEnd", _softRefresh) || $4fdec5228fea4ed1$var$_refreshAll(true);
}, $4fdec5228fea4ed1$var$_dispatch = function _dispatch(type) {
    return $4fdec5228fea4ed1$var$_listeners[type] && $4fdec5228fea4ed1$var$_listeners[type].map(function(f) {
        return f();
    }) || $4fdec5228fea4ed1$var$_emptyArray;
}, $4fdec5228fea4ed1$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$4fdec5228fea4ed1$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $4fdec5228fea4ed1$var$_savedStyles.length; i += 5)if (!media || $4fdec5228fea4ed1$var$_savedStyles[i + 4] && $4fdec5228fea4ed1$var$_savedStyles[i + 4].query === media) {
        $4fdec5228fea4ed1$var$_savedStyles[i].style.cssText = $4fdec5228fea4ed1$var$_savedStyles[i + 1];
        $4fdec5228fea4ed1$var$_savedStyles[i].getBBox && $4fdec5228fea4ed1$var$_savedStyles[i].setAttribute("transform", $4fdec5228fea4ed1$var$_savedStyles[i + 2] || "");
        $4fdec5228fea4ed1$var$_savedStyles[i + 3].uncache = 1;
    }
}, $4fdec5228fea4ed1$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($4fdec5228fea4ed1$var$_i = 0; $4fdec5228fea4ed1$var$_i < $4fdec5228fea4ed1$var$_triggers.length; $4fdec5228fea4ed1$var$_i++){
        trigger = $4fdec5228fea4ed1$var$_triggers[$4fdec5228fea4ed1$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $4fdec5228fea4ed1$var$_isReverted = true;
    media && $4fdec5228fea4ed1$var$_revertRecorded(media);
    media || $4fdec5228fea4ed1$var$_dispatch("revert");
}, $4fdec5228fea4ed1$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $c54226a072d7e33d$export$3cd1cee43d19b683).cache++;
    (force || !$4fdec5228fea4ed1$var$_refreshingAll) && (0, $c54226a072d7e33d$export$3cd1cee43d19b683).forEach(function(obj) {
        return $4fdec5228fea4ed1$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $4fdec5228fea4ed1$var$_isString(scrollRestoration) && ($4fdec5228fea4ed1$var$_win.history.scrollRestoration = $4fdec5228fea4ed1$var$_scrollRestoration = scrollRestoration);
}, $4fdec5228fea4ed1$var$_refreshingAll, $4fdec5228fea4ed1$var$_refreshID = 0, $4fdec5228fea4ed1$var$_queueRefreshID, $4fdec5228fea4ed1$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($4fdec5228fea4ed1$var$_queueRefreshID !== $4fdec5228fea4ed1$var$_refreshID) {
        var id = $4fdec5228fea4ed1$var$_queueRefreshID = $4fdec5228fea4ed1$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $4fdec5228fea4ed1$var$_refreshID && $4fdec5228fea4ed1$var$_refreshAll(true);
        });
    }
}, $4fdec5228fea4ed1$var$_refresh100vh = function _refresh100vh() {
    $4fdec5228fea4ed1$var$_body.appendChild($4fdec5228fea4ed1$var$_div100vh);
    $4fdec5228fea4ed1$var$_100vh = !$4fdec5228fea4ed1$var$_normalizer && $4fdec5228fea4ed1$var$_div100vh.offsetHeight || $4fdec5228fea4ed1$var$_win.innerHeight;
    $4fdec5228fea4ed1$var$_body.removeChild($4fdec5228fea4ed1$var$_div100vh);
}, $4fdec5228fea4ed1$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $4fdec5228fea4ed1$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $4fdec5228fea4ed1$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($4fdec5228fea4ed1$var$_lastScrollTime && !force && !$4fdec5228fea4ed1$var$_isReverted) {
        $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$export$875bcbe48555930, "scrollEnd", $4fdec5228fea4ed1$var$_softRefresh);
        return;
    }
    $4fdec5228fea4ed1$var$_refresh100vh();
    $4fdec5228fea4ed1$var$_refreshingAll = $4fdec5228fea4ed1$export$875bcbe48555930.isRefreshing = true;
    (0, $c54226a072d7e33d$export$3cd1cee43d19b683).forEach(function(obj) {
        return $4fdec5228fea4ed1$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $4fdec5228fea4ed1$var$_dispatch("refreshInit");
    $4fdec5228fea4ed1$var$_sort && $4fdec5228fea4ed1$export$875bcbe48555930.sort();
    skipRevert || $4fdec5228fea4ed1$var$_revertAll();
    (0, $c54226a072d7e33d$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($4fdec5228fea4ed1$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $4fdec5228fea4ed1$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $4fdec5228fea4ed1$var$_isReverted = false;
    $4fdec5228fea4ed1$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $4fdec5228fea4ed1$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $4fdec5228fea4ed1$var$_hideAllMarkers(true);
    $4fdec5228fea4ed1$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $4fdec5228fea4ed1$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $4fdec5228fea4ed1$var$_hideAllMarkers(false);
    $4fdec5228fea4ed1$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $c54226a072d7e33d$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($4fdec5228fea4ed1$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $4fdec5228fea4ed1$var$_clearScrollMemory($4fdec5228fea4ed1$var$_scrollRestoration, 1);
    $4fdec5228fea4ed1$var$_resizeDelay.pause();
    $4fdec5228fea4ed1$var$_refreshID++;
    $4fdec5228fea4ed1$var$_refreshingAll = 2;
    $4fdec5228fea4ed1$var$_updateAll(2);
    $4fdec5228fea4ed1$var$_triggers.forEach(function(t) {
        return $4fdec5228fea4ed1$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $4fdec5228fea4ed1$var$_refreshingAll = $4fdec5228fea4ed1$export$875bcbe48555930.isRefreshing = false;
    $4fdec5228fea4ed1$var$_dispatch("refresh");
}, $4fdec5228fea4ed1$var$_lastScroll = 0, $4fdec5228fea4ed1$var$_direction = 1, $4fdec5228fea4ed1$var$_primary, $4fdec5228fea4ed1$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$4fdec5228fea4ed1$var$_refreshingAll && !$4fdec5228fea4ed1$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $4fdec5228fea4ed1$export$875bcbe48555930.isUpdating = true;
        $4fdec5228fea4ed1$var$_primary && $4fdec5228fea4ed1$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $4fdec5228fea4ed1$var$_triggers.length, time = $4fdec5228fea4ed1$var$_getTime(), recordVelocity = time - $4fdec5228fea4ed1$var$_time1 >= 50, scroll = l && $4fdec5228fea4ed1$var$_triggers[0].scroll();
        $4fdec5228fea4ed1$var$_direction = $4fdec5228fea4ed1$var$_lastScroll > scroll ? -1 : 1;
        $4fdec5228fea4ed1$var$_refreshingAll || ($4fdec5228fea4ed1$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($4fdec5228fea4ed1$var$_lastScrollTime && !$4fdec5228fea4ed1$var$_pointerIsDown && time - $4fdec5228fea4ed1$var$_lastScrollTime > 200) {
                $4fdec5228fea4ed1$var$_lastScrollTime = 0;
                $4fdec5228fea4ed1$var$_dispatch("scrollEnd");
            }
            $4fdec5228fea4ed1$var$_time2 = $4fdec5228fea4ed1$var$_time1;
            $4fdec5228fea4ed1$var$_time1 = time;
        }
        if ($4fdec5228fea4ed1$var$_direction < 0) {
            $4fdec5228fea4ed1$var$_i = l;
            while($4fdec5228fea4ed1$var$_i-- > 0)$4fdec5228fea4ed1$var$_triggers[$4fdec5228fea4ed1$var$_i] && $4fdec5228fea4ed1$var$_triggers[$4fdec5228fea4ed1$var$_i].update(0, recordVelocity);
            $4fdec5228fea4ed1$var$_direction = 1;
        } else for($4fdec5228fea4ed1$var$_i = 0; $4fdec5228fea4ed1$var$_i < l; $4fdec5228fea4ed1$var$_i++)$4fdec5228fea4ed1$var$_triggers[$4fdec5228fea4ed1$var$_i] && $4fdec5228fea4ed1$var$_triggers[$4fdec5228fea4ed1$var$_i].update(0, recordVelocity);
        $4fdec5228fea4ed1$export$875bcbe48555930.isUpdating = false;
    }
    $4fdec5228fea4ed1$var$_rafID = 0;
}, $4fdec5228fea4ed1$var$_propNamesToCopy = [
    $4fdec5228fea4ed1$var$_left,
    $4fdec5228fea4ed1$var$_top,
    $4fdec5228fea4ed1$var$_bottom,
    $4fdec5228fea4ed1$var$_right,
    $4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Bottom,
    $4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Right,
    $4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Top,
    $4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $4fdec5228fea4ed1$var$_stateProps = $4fdec5228fea4ed1$var$_propNamesToCopy.concat([
    $4fdec5228fea4ed1$var$_width,
    $4fdec5228fea4ed1$var$_height,
    "boxSizing",
    "max" + $4fdec5228fea4ed1$var$_Width,
    "max" + $4fdec5228fea4ed1$var$_Height,
    "position",
    $4fdec5228fea4ed1$var$_margin,
    $4fdec5228fea4ed1$var$_padding,
    $4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Top,
    $4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Right,
    $4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Bottom,
    $4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Left
]), $4fdec5228fea4ed1$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $4fdec5228fea4ed1$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $4fdec5228fea4ed1$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $4fdec5228fea4ed1$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $4fdec5228fea4ed1$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $4fdec5228fea4ed1$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$4fdec5228fea4ed1$var$_bottom] = pinStyle[$4fdec5228fea4ed1$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$4fdec5228fea4ed1$var$_width] = $4fdec5228fea4ed1$var$_getSize(pin, (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1)) + $4fdec5228fea4ed1$var$_px;
        spacerStyle[$4fdec5228fea4ed1$var$_height] = $4fdec5228fea4ed1$var$_getSize(pin, (0, $c54226a072d7e33d$export$8e40fc98ff518e9d)) + $4fdec5228fea4ed1$var$_px;
        spacerStyle[$4fdec5228fea4ed1$var$_padding] = pinStyle[$4fdec5228fea4ed1$var$_margin] = pinStyle[$4fdec5228fea4ed1$var$_top] = pinStyle[$4fdec5228fea4ed1$var$_left] = "0";
        $4fdec5228fea4ed1$var$_setState(spacerState);
        pinStyle[$4fdec5228fea4ed1$var$_width] = pinStyle["max" + $4fdec5228fea4ed1$var$_Width] = cs[$4fdec5228fea4ed1$var$_width];
        pinStyle[$4fdec5228fea4ed1$var$_height] = pinStyle["max" + $4fdec5228fea4ed1$var$_Height] = cs[$4fdec5228fea4ed1$var$_height];
        pinStyle[$4fdec5228fea4ed1$var$_padding] = cs[$4fdec5228fea4ed1$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $4fdec5228fea4ed1$var$_capsExp = /([A-Z])/g, $4fdec5228fea4ed1$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $4fdec5228fea4ed1$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($4fdec5228fea4ed1$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $4fdec5228fea4ed1$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $4fdec5228fea4ed1$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($4fdec5228fea4ed1$var$_stateProps[i], style[$4fdec5228fea4ed1$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $4fdec5228fea4ed1$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $4fdec5228fea4ed1$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$4fdec5228fea4ed1$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $4fdec5228fea4ed1$var$_isFunction(value) && (value = value(self));
    if ($4fdec5228fea4ed1$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $4fdec5228fea4ed1$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$4fdec5228fea4ed1$var$_isNumber(value)) {
        $4fdec5228fea4ed1$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $c54226a072d7e33d$export$937374fea3f88711)(trigger, self) || $4fdec5228fea4ed1$var$_body;
        bounds = $4fdec5228fea4ed1$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $4fdec5228fea4ed1$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $4fdec5228fea4ed1$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $4fdec5228fea4ed1$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $4fdec5228fea4ed1$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $4fdec5228fea4ed1$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $4fdec5228fea4ed1$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $4fdec5228fea4ed1$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $4fdec5228fea4ed1$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($4fdec5228fea4ed1$var$_body[p1], $4fdec5228fea4ed1$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $4fdec5228fea4ed1$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $4fdec5228fea4ed1$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $4fdec5228fea4ed1$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $4fdec5228fea4ed1$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $4fdec5228fea4ed1$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $4fdec5228fea4ed1$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $4fdec5228fea4ed1$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $4fdec5228fea4ed1$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$4fdec5228fea4ed1$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $4fdec5228fea4ed1$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $4fdec5228fea4ed1$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $4fdec5228fea4ed1$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $4fdec5228fea4ed1$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$4fdec5228fea4ed1$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $c54226a072d7e33d$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $4fdec5228fea4ed1$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $c54226a072d7e33d$export$3cd1cee43d19b683).cache++;
            getTween.tween && $4fdec5228fea4ed1$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $4fdec5228fea4ed1$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $4fdec5228fea4ed1$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $4fdec5228fea4ed1$export$875bcbe48555930.isTouch && $4fdec5228fea4ed1$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $4fdec5228fea4ed1$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $4fdec5228fea4ed1$var$_coreInitted || ScrollTrigger.register($4fdec5228fea4ed1$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $4fdec5228fea4ed1$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$4fdec5228fea4ed1$var$_enabled) {
            this.update = this.refresh = this.kill = $4fdec5228fea4ed1$var$_passThrough;
            return;
        }
        vars = $4fdec5228fea4ed1$var$_setDefaults($4fdec5228fea4ed1$var$_isString(vars) || $4fdec5228fea4ed1$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $4fdec5228fea4ed1$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1) : (0, $c54226a072d7e33d$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $c54226a072d7e33d$export$937374fea3f88711)(vars.scroller || $4fdec5228fea4ed1$var$_win), scrollerCache = $4fdec5228fea4ed1$var$gsap.core.getCache(scroller), isViewport = $4fdec5228fea4ed1$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $c54226a072d7e33d$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $4fdec5228fea4ed1$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($4fdec5228fea4ed1$var$_getComputedStyle(scroller)["border" + direction.p2 + $4fdec5228fea4ed1$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $4fdec5228fea4ed1$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $4fdec5228fea4ed1$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $c54226a072d7e33d$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $4fdec5228fea4ed1$var$_sort = 1;
            vars.refreshPriority === -9999 && ($4fdec5228fea4ed1$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $4fdec5228fea4ed1$var$_getTweenCreator(scroller, (0, $c54226a072d7e33d$export$8e40fc98ff518e9d)),
            left: $4fdec5228fea4ed1$var$_getTweenCreator(scroller, (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $4fdec5228fea4ed1$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $4fdec5228fea4ed1$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$4fdec5228fea4ed1$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $4fdec5228fea4ed1$var$_body.style && $4fdec5228fea4ed1$var$gsap.set(isViewport ? [
                $4fdec5228fea4ed1$var$_body,
                $4fdec5228fea4ed1$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $c54226a072d7e33d$export$3cd1cee43d19b683).forEach(function(o) {
                return $4fdec5228fea4ed1$var$_isFunction(o) && o.target === (isViewport ? $4fdec5228fea4ed1$var$_doc.scrollingElement || $4fdec5228fea4ed1$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $4fdec5228fea4ed1$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $4fdec5228fea4ed1$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $4fdec5228fea4ed1$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $4fdec5228fea4ed1$var$_snapDirectional(snap.snapTo)(value, $4fdec5228fea4ed1$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $4fdec5228fea4ed1$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $4fdec5228fea4ed1$var$_isObject(snapDurClamp) ? $4fdec5228fea4ed1$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $4fdec5228fea4ed1$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $4fdec5228fea4ed1$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $4fdec5228fea4ed1$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$4fdec5228fea4ed1$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($4fdec5228fea4ed1$var$_getTime() - $4fdec5228fea4ed1$var$_time2) * 1000 || 0, change1 = $4fdec5228fea4ed1$var$gsap.utils.clamp(-progress, 1 - progress, $4fdec5228fea4ed1$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $4fdec5228fea4ed1$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.round(start + endValue * change);
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $4fdec5228fea4ed1$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($4fdec5228fea4ed1$var$_abs(Math.max($4fdec5228fea4ed1$var$_abs(naturalEnd - totalProgress), $4fdec5228fea4ed1$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $4fdec5228fea4ed1$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($4fdec5228fea4ed1$var$_ids[id] = self);
        trigger = self.trigger = (0, $c54226a072d7e33d$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $c54226a072d7e33d$export$937374fea3f88711)(pin);
        $4fdec5228fea4ed1$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $4fdec5228fea4ed1$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $4fdec5228fea4ed1$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $4fdec5228fea4ed1$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $4fdec5228fea4ed1$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $c54226a072d7e33d$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $4fdec5228fea4ed1$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $4fdec5228fea4ed1$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $4fdec5228fea4ed1$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $4fdec5228fea4ed1$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $4fdec5228fea4ed1$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $4fdec5228fea4ed1$var$gsap.getProperty(pin);
            pinSetter = $4fdec5228fea4ed1$var$gsap.quickSetter(pin, direction.a, $4fdec5228fea4ed1$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $4fdec5228fea4ed1$var$_swapPinIn(pin, spacer, cs);
            pinState = $4fdec5228fea4ed1$var$_getState(pin);
        }
        if (markers) {
            markerVars = $4fdec5228fea4ed1$var$_isObject(markers) ? $4fdec5228fea4ed1$var$_setDefaults(markers, $4fdec5228fea4ed1$var$_markerDefaults) : $4fdec5228fea4ed1$var$_markerDefaults;
            markerStartTrigger = $4fdec5228fea4ed1$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $4fdec5228fea4ed1$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $c54226a072d7e33d$export$937374fea3f88711)((0, $c54226a072d7e33d$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $4fdec5228fea4ed1$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $4fdec5228fea4ed1$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $4fdec5228fea4ed1$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $4fdec5228fea4ed1$var$_px));
            if (!useFixedPosition && !((0, $c54226a072d7e33d$export$d8e56d510a804d0a).length && (0, $c54226a072d7e33d$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $4fdec5228fea4ed1$var$_makePositionable(isViewport ? $4fdec5228fea4ed1$var$_body : scroller);
                $4fdec5228fea4ed1$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $4fdec5228fea4ed1$var$gsap.quickSetter(markerStartTrigger, direction.a, $4fdec5228fea4ed1$var$_px);
                markerEndSetter = $4fdec5228fea4ed1$var$gsap.quickSetter(markerEndTrigger, direction.a, $4fdec5228fea4ed1$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $4fdec5228fea4ed1$var$_triggers[$4fdec5228fea4ed1$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $4fdec5228fea4ed1$var$_triggers[$4fdec5228fea4ed1$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $4fdec5228fea4ed1$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $4fdec5228fea4ed1$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $4fdec5228fea4ed1$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $4fdec5228fea4ed1$var$_swapPinIn(pin, spacer, $4fdec5228fea4ed1$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $4fdec5228fea4ed1$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($4fdec5228fea4ed1$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $4fdec5228fea4ed1$var$_lastScrollTime) {
                $4fdec5228fea4ed1$var$_addListener(ScrollTrigger, "scrollEnd", $4fdec5228fea4ed1$var$_softRefresh);
                return;
            }
            !$4fdec5228fea4ed1$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $4fdec5228fea4ed1$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $4fdec5228fea4ed1$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $4fdec5228fea4ed1$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $4fdec5228fea4ed1$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $c54226a072d7e33d$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $4fdec5228fea4ed1$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $4fdec5228fea4ed1$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $4fdec5228fea4ed1$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $4fdec5228fea4ed1$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $4fdec5228fea4ed1$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($4fdec5228fea4ed1$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $4fdec5228fea4ed1$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $4fdec5228fea4ed1$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $4fdec5228fea4ed1$var$_parseClamp(parsedStart, "start", self);
            start = $4fdec5228fea4ed1$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $4fdec5228fea4ed1$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($4fdec5228fea4ed1$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($4fdec5228fea4ed1$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $4fdec5228fea4ed1$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $4fdec5228fea4ed1$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $4fdec5228fea4ed1$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $4fdec5228fea4ed1$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $4fdec5228fea4ed1$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $4fdec5228fea4ed1$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$4fdec5228fea4ed1$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $4fdec5228fea4ed1$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $4fdec5228fea4ed1$var$gsap.utils.clamp(0, 1, $4fdec5228fea4ed1$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $4fdec5228fea4ed1$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($4fdec5228fea4ed1$var$_clampingMax && self.end >= $4fdec5228fea4ed1$var$_maxScroll(scroller, direction))) {
                cs = $4fdec5228fea4ed1$var$_getComputedStyle(pin);
                isVertical = direction === (0, $c54226a072d7e33d$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $4fdec5228fea4ed1$var$_doc.scrollingElement || $4fdec5228fea4ed1$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $4fdec5228fea4ed1$var$_getComputedStyle($4fdec5228fea4ed1$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $4fdec5228fea4ed1$var$_swapPinIn(pin, spacer, cs);
                pinState = $4fdec5228fea4ed1$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $4fdec5228fea4ed1$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $c54226a072d7e33d$export$8665aac53dad5647)(scroller, isVertical ? (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1) : (0, $c54226a072d7e33d$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $4fdec5228fea4ed1$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $4fdec5228fea4ed1$var$_padding ? $4fdec5228fea4ed1$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $4fdec5228fea4ed1$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $4fdec5228fea4ed1$var$_px);
                    }
                    $4fdec5228fea4ed1$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $4fdec5228fea4ed1$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $4fdec5228fea4ed1$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $4fdec5228fea4ed1$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $4fdec5228fea4ed1$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $4fdec5228fea4ed1$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$4fdec5228fea4ed1$var$_width] = override["max" + $4fdec5228fea4ed1$var$_Width] = Math.ceil(bounds.width) + $4fdec5228fea4ed1$var$_px;
                    override[$4fdec5228fea4ed1$var$_height] = override["max" + $4fdec5228fea4ed1$var$_Height] = Math.ceil(bounds.height) + $4fdec5228fea4ed1$var$_px;
                    override[$4fdec5228fea4ed1$var$_margin] = override[$4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Top] = override[$4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Right] = override[$4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Bottom] = override[$4fdec5228fea4ed1$var$_margin + $4fdec5228fea4ed1$var$_Left] = "0";
                    override[$4fdec5228fea4ed1$var$_padding] = cs[$4fdec5228fea4ed1$var$_padding];
                    override[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Top] = cs[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Top];
                    override[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Right] = cs[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Right];
                    override[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Bottom] = cs[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Bottom];
                    override[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Left] = cs[$4fdec5228fea4ed1$var$_padding + $4fdec5228fea4ed1$var$_Left];
                    pinActiveState = $4fdec5228fea4ed1$var$_copyState(pinOriginalState, override, pinReparent);
                    $4fdec5228fea4ed1$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $4fdec5228fea4ed1$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $4fdec5228fea4ed1$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $4fdec5228fea4ed1$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $4fdec5228fea4ed1$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$4fdec5228fea4ed1$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $4fdec5228fea4ed1$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $4fdec5228fea4ed1$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $4fdec5228fea4ed1$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $4fdec5228fea4ed1$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $4fdec5228fea4ed1$var$gsap.getProperty(markerEndTrigger, direction.p);
                $4fdec5228fea4ed1$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $4fdec5228fea4ed1$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $4fdec5228fea4ed1$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $4fdec5228fea4ed1$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$4fdec5228fea4ed1$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$4fdec5228fea4ed1$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($4fdec5228fea4ed1$var$_getTime() - $4fdec5228fea4ed1$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $4fdec5228fea4ed1$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $4fdec5228fea4ed1$var$_endAnimation(animation, animation.reversed()) : isToggle || $4fdec5228fea4ed1$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $4fdec5228fea4ed1$var$_triggers.indexOf(self), a = self.direction > 0 ? $4fdec5228fea4ed1$var$_triggers.slice(0, i).reverse() : $4fdec5228fea4ed1$var$_triggers.slice(i + 1);
            return ($4fdec5228fea4ed1$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $4fdec5228fea4ed1$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$4fdec5228fea4ed1$var$_refreshing && !$4fdec5228fea4ed1$var$_startup && $4fdec5228fea4ed1$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($4fdec5228fea4ed1$var$_getTime() - $4fdec5228fea4ed1$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($4fdec5228fea4ed1$var$_getTime() - $4fdec5228fea4ed1$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$4fdec5228fea4ed1$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($4fdec5228fea4ed1$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$4fdec5228fea4ed1$var$_refreshing && !$4fdec5228fea4ed1$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($4fdec5228fea4ed1$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($4fdec5228fea4ed1$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $4fdec5228fea4ed1$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $4fdec5228fea4ed1$var$_getBounds(pin, true), _offset = scroll - start;
                                $4fdec5228fea4ed1$var$_reparent(pin, $4fdec5228fea4ed1$var$_body, bounds.top + (direction === (0, $c54226a072d7e33d$export$8e40fc98ff518e9d) ? _offset : 0) + $4fdec5228fea4ed1$var$_px, bounds.left + (direction === (0, $c54226a072d7e33d$export$8e40fc98ff518e9d) ? 0 : _offset) + $4fdec5228fea4ed1$var$_px);
                            } else $4fdec5228fea4ed1$var$_reparent(pin, spacer);
                        }
                        $4fdec5228fea4ed1$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$4fdec5228fea4ed1$var$_refreshing && !$4fdec5228fea4ed1$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$4fdec5228fea4ed1$var$_limitCallbacks)) && $4fdec5228fea4ed1$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$4fdec5228fea4ed1$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$4fdec5228fea4ed1$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $4fdec5228fea4ed1$var$_callback(self, onToggle);
                        callbacks[toggleState] && $4fdec5228fea4ed1$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $4fdec5228fea4ed1$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($4fdec5228fea4ed1$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $4fdec5228fea4ed1$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $4fdec5228fea4ed1$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$4fdec5228fea4ed1$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $4fdec5228fea4ed1$var$_addListener(scroller, "resize", $4fdec5228fea4ed1$var$_onResize);
                isViewport || $4fdec5228fea4ed1$var$_addListener(scroller, "scroll", $4fdec5228fea4ed1$var$_onScroll);
                onRefreshInit && $4fdec5228fea4ed1$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $4fdec5228fea4ed1$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $4fdec5228fea4ed1$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $4fdec5228fea4ed1$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $4fdec5228fea4ed1$var$_px;
                $4fdec5228fea4ed1$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $4fdec5228fea4ed1$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $4fdec5228fea4ed1$var$_triggers.length;
                    while(i--){
                        if ($4fdec5228fea4ed1$var$_triggers[i].scroller === scroller && $4fdec5228fea4ed1$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $4fdec5228fea4ed1$var$_removeListener(scroller, "resize", $4fdec5228fea4ed1$var$_onResize);
                    isViewport || $4fdec5228fea4ed1$var$_removeListener(scroller, "scroll", $4fdec5228fea4ed1$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $4fdec5228fea4ed1$var$_ids[id];
            var i = $4fdec5228fea4ed1$var$_triggers.indexOf(self);
            i >= 0 && $4fdec5228fea4ed1$var$_triggers.splice(i, 1);
            i === $4fdec5228fea4ed1$var$_i && $4fdec5228fea4ed1$var$_direction > 0 && $4fdec5228fea4ed1$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $4fdec5228fea4ed1$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $4fdec5228fea4ed1$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $4fdec5228fea4ed1$var$_primary === self && ($4fdec5228fea4ed1$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $4fdec5228fea4ed1$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $4fdec5228fea4ed1$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $4fdec5228fea4ed1$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $4fdec5228fea4ed1$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$4fdec5228fea4ed1$var$_coreInitted) {
            $4fdec5228fea4ed1$var$gsap = core || $4fdec5228fea4ed1$var$_getGSAP();
            $4fdec5228fea4ed1$var$_windowExists() && window.document && ScrollTrigger.enable();
            $4fdec5228fea4ed1$var$_coreInitted = $4fdec5228fea4ed1$var$_enabled;
        }
        return $4fdec5228fea4ed1$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$4fdec5228fea4ed1$var$_defaults[p] = config[p];
        return $4fdec5228fea4ed1$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $4fdec5228fea4ed1$var$_enabled = 0;
        $4fdec5228fea4ed1$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $4fdec5228fea4ed1$var$_removeListener($4fdec5228fea4ed1$var$_win, "wheel", $4fdec5228fea4ed1$var$_onScroll);
        $4fdec5228fea4ed1$var$_removeListener($4fdec5228fea4ed1$var$_doc, "scroll", $4fdec5228fea4ed1$var$_onScroll);
        clearInterval($4fdec5228fea4ed1$var$_syncInterval);
        $4fdec5228fea4ed1$var$_removeListener($4fdec5228fea4ed1$var$_doc, "touchcancel", $4fdec5228fea4ed1$var$_passThrough);
        $4fdec5228fea4ed1$var$_removeListener($4fdec5228fea4ed1$var$_body, "touchstart", $4fdec5228fea4ed1$var$_passThrough);
        $4fdec5228fea4ed1$var$_multiListener($4fdec5228fea4ed1$var$_removeListener, $4fdec5228fea4ed1$var$_doc, "pointerdown,touchstart,mousedown", $4fdec5228fea4ed1$var$_pointerDownHandler);
        $4fdec5228fea4ed1$var$_multiListener($4fdec5228fea4ed1$var$_removeListener, $4fdec5228fea4ed1$var$_doc, "pointerup,touchend,mouseup", $4fdec5228fea4ed1$var$_pointerUpHandler);
        $4fdec5228fea4ed1$var$_resizeDelay.kill();
        $4fdec5228fea4ed1$var$_iterateAutoRefresh($4fdec5228fea4ed1$var$_removeListener);
        for(var i = 0; i < (0, $c54226a072d7e33d$export$3cd1cee43d19b683).length; i += 3){
            $4fdec5228fea4ed1$var$_wheelListener($4fdec5228fea4ed1$var$_removeListener, (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i], (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i + 1]);
            $4fdec5228fea4ed1$var$_wheelListener($4fdec5228fea4ed1$var$_removeListener, (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i], (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $4fdec5228fea4ed1$var$_win = window;
        $4fdec5228fea4ed1$var$_doc = document;
        $4fdec5228fea4ed1$var$_docEl = $4fdec5228fea4ed1$var$_doc.documentElement;
        $4fdec5228fea4ed1$var$_body = $4fdec5228fea4ed1$var$_doc.body;
        if ($4fdec5228fea4ed1$var$gsap) {
            $4fdec5228fea4ed1$var$_toArray = $4fdec5228fea4ed1$var$gsap.utils.toArray;
            $4fdec5228fea4ed1$var$_clamp = $4fdec5228fea4ed1$var$gsap.utils.clamp;
            $4fdec5228fea4ed1$var$_context = $4fdec5228fea4ed1$var$gsap.core.context || $4fdec5228fea4ed1$var$_passThrough;
            $4fdec5228fea4ed1$var$_suppressOverwrites = $4fdec5228fea4ed1$var$gsap.core.suppressOverwrites || $4fdec5228fea4ed1$var$_passThrough;
            $4fdec5228fea4ed1$var$_scrollRestoration = $4fdec5228fea4ed1$var$_win.history.scrollRestoration || "auto";
            $4fdec5228fea4ed1$var$_lastScroll = $4fdec5228fea4ed1$var$_win.pageYOffset;
            $4fdec5228fea4ed1$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($4fdec5228fea4ed1$var$_body) {
                $4fdec5228fea4ed1$var$_enabled = 1;
                $4fdec5228fea4ed1$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $4fdec5228fea4ed1$var$_div100vh.style.height = "100vh";
                $4fdec5228fea4ed1$var$_div100vh.style.position = "absolute";
                $4fdec5228fea4ed1$var$_refresh100vh();
                $4fdec5228fea4ed1$var$_rafBugFix();
                (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).register($4fdec5228fea4ed1$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).isTouch;
                $4fdec5228fea4ed1$var$_fixIOSBug = (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $4fdec5228fea4ed1$var$_ignoreMobileResize = (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).isTouch === 1;
                $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$var$_win, "wheel", $4fdec5228fea4ed1$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $4fdec5228fea4ed1$var$_root = [
                    $4fdec5228fea4ed1$var$_win,
                    $4fdec5228fea4ed1$var$_doc,
                    $4fdec5228fea4ed1$var$_docEl,
                    $4fdec5228fea4ed1$var$_body
                ];
                if ($4fdec5228fea4ed1$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $4fdec5228fea4ed1$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $4fdec5228fea4ed1$var$gsap.addEventListener("matchMediaInit", function() {
                        return $4fdec5228fea4ed1$var$_revertAll();
                    });
                    $4fdec5228fea4ed1$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $4fdec5228fea4ed1$var$_revertRecorded();
                    });
                    $4fdec5228fea4ed1$var$gsap.addEventListener("matchMedia", function() {
                        $4fdec5228fea4ed1$var$_refreshAll(0, 1);
                        $4fdec5228fea4ed1$var$_dispatch("matchMedia");
                    });
                    $4fdec5228fea4ed1$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $4fdec5228fea4ed1$var$_setBaseDimensions();
                        return $4fdec5228fea4ed1$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $4fdec5228fea4ed1$var$_setBaseDimensions();
                $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$var$_doc, "scroll", $4fdec5228fea4ed1$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $4fdec5228fea4ed1$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $4fdec5228fea4ed1$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $4fdec5228fea4ed1$var$_getBounds($4fdec5228fea4ed1$var$_body);
                (0, $c54226a072d7e33d$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $c54226a072d7e33d$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $4fdec5228fea4ed1$var$_syncInterval = setInterval($4fdec5228fea4ed1$var$_sync, 250);
                $4fdec5228fea4ed1$var$gsap.delayedCall(0.5, function() {
                    return $4fdec5228fea4ed1$var$_startup = 0;
                });
                $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$var$_doc, "touchcancel", $4fdec5228fea4ed1$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$var$_body, "touchstart", $4fdec5228fea4ed1$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $4fdec5228fea4ed1$var$_multiListener($4fdec5228fea4ed1$var$_addListener, $4fdec5228fea4ed1$var$_doc, "pointerdown,touchstart,mousedown", $4fdec5228fea4ed1$var$_pointerDownHandler);
                $4fdec5228fea4ed1$var$_multiListener($4fdec5228fea4ed1$var$_addListener, $4fdec5228fea4ed1$var$_doc, "pointerup,touchend,mouseup", $4fdec5228fea4ed1$var$_pointerUpHandler);
                $4fdec5228fea4ed1$var$_transformProp = $4fdec5228fea4ed1$var$gsap.utils.checkPrefix("transform");
                $4fdec5228fea4ed1$var$_stateProps.push($4fdec5228fea4ed1$var$_transformProp);
                $4fdec5228fea4ed1$var$_coreInitted = $4fdec5228fea4ed1$var$_getTime();
                $4fdec5228fea4ed1$var$_resizeDelay = $4fdec5228fea4ed1$var$gsap.delayedCall(0.2, $4fdec5228fea4ed1$var$_refreshAll).pause();
                $4fdec5228fea4ed1$var$_autoRefresh = [
                    $4fdec5228fea4ed1$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $4fdec5228fea4ed1$var$_win.innerWidth, h = $4fdec5228fea4ed1$var$_win.innerHeight;
                        if ($4fdec5228fea4ed1$var$_doc.hidden) {
                            $4fdec5228fea4ed1$var$_prevWidth = w;
                            $4fdec5228fea4ed1$var$_prevHeight = h;
                        } else if ($4fdec5228fea4ed1$var$_prevWidth !== w || $4fdec5228fea4ed1$var$_prevHeight !== h) $4fdec5228fea4ed1$var$_onResize();
                    },
                    $4fdec5228fea4ed1$var$_doc,
                    "DOMContentLoaded",
                    $4fdec5228fea4ed1$var$_refreshAll,
                    $4fdec5228fea4ed1$var$_win,
                    "load",
                    $4fdec5228fea4ed1$var$_refreshAll,
                    $4fdec5228fea4ed1$var$_win,
                    "resize",
                    $4fdec5228fea4ed1$var$_onResize
                ];
                $4fdec5228fea4ed1$var$_iterateAutoRefresh($4fdec5228fea4ed1$var$_addListener);
                $4fdec5228fea4ed1$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $c54226a072d7e33d$export$3cd1cee43d19b683).length; i += 3){
                    $4fdec5228fea4ed1$var$_wheelListener($4fdec5228fea4ed1$var$_removeListener, (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i], (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i + 1]);
                    $4fdec5228fea4ed1$var$_wheelListener($4fdec5228fea4ed1$var$_removeListener, (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i], (0, $c54226a072d7e33d$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($4fdec5228fea4ed1$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($4fdec5228fea4ed1$var$_syncInterval) || ($4fdec5228fea4ed1$var$_syncInterval = ms) && setInterval($4fdec5228fea4ed1$var$_sync, ms);
        "ignoreMobileResize" in vars && ($4fdec5228fea4ed1$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $4fdec5228fea4ed1$var$_iterateAutoRefresh($4fdec5228fea4ed1$var$_removeListener) || $4fdec5228fea4ed1$var$_iterateAutoRefresh($4fdec5228fea4ed1$var$_addListener, vars.autoRefreshEvents || "none");
            $4fdec5228fea4ed1$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $c54226a072d7e33d$export$937374fea3f88711)(target), i = (0, $c54226a072d7e33d$export$3cd1cee43d19b683).indexOf(t), isViewport = $4fdec5228fea4ed1$var$_isViewport(t);
        if (~i) (0, $c54226a072d7e33d$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $c54226a072d7e33d$export$d8e56d510a804d0a).unshift($4fdec5228fea4ed1$var$_win, vars, $4fdec5228fea4ed1$var$_body, vars, $4fdec5228fea4ed1$var$_docEl, vars) : (0, $c54226a072d7e33d$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $4fdec5228fea4ed1$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($4fdec5228fea4ed1$var$_isString(element) ? (0, $c54226a072d7e33d$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $4fdec5228fea4ed1$var$_width : $4fdec5228fea4ed1$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $4fdec5228fea4ed1$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $4fdec5228fea4ed1$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $4fdec5228fea4ed1$var$_isString(element) && (element = (0, $c54226a072d7e33d$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $4fdec5228fea4ed1$var$_width : $4fdec5228fea4ed1$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $4fdec5228fea4ed1$var$_keywords ? $4fdec5228fea4ed1$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $4fdec5228fea4ed1$var$_win.innerWidth : (bounds.top + offset) / $4fdec5228fea4ed1$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $4fdec5228fea4ed1$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $4fdec5228fea4ed1$var$_listeners.killAll || [];
            $4fdec5228fea4ed1$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$4fdec5228fea4ed1$export$875bcbe48555930.version = "3.12.5";
$4fdec5228fea4ed1$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $4fdec5228fea4ed1$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $4fdec5228fea4ed1$var$_savedStyles.indexOf(target);
            i >= 0 && $4fdec5228fea4ed1$var$_savedStyles.splice(i, 5);
            $4fdec5228fea4ed1$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $4fdec5228fea4ed1$var$gsap.core.getCache(target), $4fdec5228fea4ed1$var$_context());
        }
    }) : $4fdec5228fea4ed1$var$_savedStyles;
};
$4fdec5228fea4ed1$export$875bcbe48555930.revert = function(soft, media) {
    return $4fdec5228fea4ed1$var$_revertAll(!soft, media);
};
$4fdec5228fea4ed1$export$875bcbe48555930.create = function(vars, animation) {
    return new $4fdec5228fea4ed1$export$875bcbe48555930(vars, animation);
};
$4fdec5228fea4ed1$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $4fdec5228fea4ed1$var$_onResize() : ($4fdec5228fea4ed1$var$_coreInitted || $4fdec5228fea4ed1$export$875bcbe48555930.register()) && $4fdec5228fea4ed1$var$_refreshAll(true);
};
$4fdec5228fea4ed1$export$875bcbe48555930.update = function(force) {
    return ++(0, $c54226a072d7e33d$export$3cd1cee43d19b683).cache && $4fdec5228fea4ed1$var$_updateAll(force === true ? 2 : 0);
};
$4fdec5228fea4ed1$export$875bcbe48555930.clearScrollMemory = $4fdec5228fea4ed1$var$_clearScrollMemory;
$4fdec5228fea4ed1$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $4fdec5228fea4ed1$var$_maxScroll(element, horizontal ? (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1) : (0, $c54226a072d7e33d$export$8e40fc98ff518e9d));
};
$4fdec5228fea4ed1$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $c54226a072d7e33d$export$8665aac53dad5647)((0, $c54226a072d7e33d$export$937374fea3f88711)(element), horizontal ? (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1) : (0, $c54226a072d7e33d$export$8e40fc98ff518e9d));
};
$4fdec5228fea4ed1$export$875bcbe48555930.getById = function(id) {
    return $4fdec5228fea4ed1$var$_ids[id];
};
$4fdec5228fea4ed1$export$875bcbe48555930.getAll = function() {
    return $4fdec5228fea4ed1$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$4fdec5228fea4ed1$export$875bcbe48555930.isScrolling = function() {
    return !!$4fdec5228fea4ed1$var$_lastScrollTime;
};
$4fdec5228fea4ed1$export$875bcbe48555930.snapDirectional = $4fdec5228fea4ed1$var$_snapDirectional;
$4fdec5228fea4ed1$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $4fdec5228fea4ed1$var$_listeners[type] || ($4fdec5228fea4ed1$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$4fdec5228fea4ed1$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $4fdec5228fea4ed1$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$4fdec5228fea4ed1$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $4fdec5228fea4ed1$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $4fdec5228fea4ed1$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($4fdec5228fea4ed1$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $4fdec5228fea4ed1$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($4fdec5228fea4ed1$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $4fdec5228fea4ed1$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $4fdec5228fea4ed1$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $4fdec5228fea4ed1$var$_docEl && _allowNativePanning($4fdec5228fea4ed1$var$_body, direction);
}, $4fdec5228fea4ed1$var$_overflow = {
    auto: 1,
    scroll: 1
}, $4fdec5228fea4ed1$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $4fdec5228fea4ed1$var$gsap.core.getCache(node), time = $4fdec5228fea4ed1$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $4fdec5228fea4ed1$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($4fdec5228fea4ed1$var$_overflow[(cs = $4fdec5228fea4ed1$var$_getComputedStyle(node)).overflowY] || $4fdec5228fea4ed1$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$4fdec5228fea4ed1$var$_isViewport(node) && ($4fdec5228fea4ed1$var$_overflow[(cs = $4fdec5228fea4ed1$var$_getComputedStyle(node)).overflowY] || $4fdec5228fea4ed1$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$4fdec5228fea4ed1$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $4fdec5228fea4ed1$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$var$_doc, (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).eventTypes[0], $4fdec5228fea4ed1$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $4fdec5228fea4ed1$var$_removeListener($4fdec5228fea4ed1$var$_doc, (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).eventTypes[0], $4fdec5228fea4ed1$var$_captureInputs, true);
        }
    });
}, $4fdec5228fea4ed1$var$_inputExp = /(input|label|select|textarea)/i, $4fdec5228fea4ed1$var$_inputIsFocused, $4fdec5228fea4ed1$var$_captureInputs = function _captureInputs(e) {
    var isInput = $4fdec5228fea4ed1$var$_inputExp.test(e.target.tagName);
    if (isInput || $4fdec5228fea4ed1$var$_inputIsFocused) {
        e._gsapAllow = true;
        $4fdec5228fea4ed1$var$_inputIsFocused = isInput;
    }
}, $4fdec5228fea4ed1$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $4fdec5228fea4ed1$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $c54226a072d7e33d$export$937374fea3f88711)(vars.target) || $4fdec5228fea4ed1$var$_docEl, smoother = $4fdec5228fea4ed1$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $4fdec5228fea4ed1$var$_fixIOSBug && (vars.content && (0, $c54226a072d7e33d$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $c54226a072d7e33d$export$8665aac53dad5647)(target, (0, $c54226a072d7e33d$export$8e40fc98ff518e9d)), scrollFuncX = (0, $c54226a072d7e33d$export$8665aac53dad5647)(target, (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $c54226a072d7e33d$export$c1cbdee04e18ea8b).isTouch && $4fdec5228fea4ed1$var$_win.visualViewport ? $4fdec5228fea4ed1$var$_win.visualViewport.scale * $4fdec5228fea4ed1$var$_win.visualViewport.width : $4fdec5228fea4ed1$var$_win.outerWidth) / $4fdec5228fea4ed1$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $4fdec5228fea4ed1$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $4fdec5228fea4ed1$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $4fdec5228fea4ed1$var$_passThrough, scrollClampY = $4fdec5228fea4ed1$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $4fdec5228fea4ed1$var$_maxScroll(target, (0, $c54226a072d7e33d$export$8e40fc98ff518e9d));
        scrollClampY = $4fdec5228fea4ed1$var$_clamp($4fdec5228fea4ed1$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $4fdec5228fea4ed1$var$_clamp(0, $4fdec5228fea4ed1$var$_maxScroll(target, (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1))));
        lastRefreshID = $4fdec5228fea4ed1$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $4fdec5228fea4ed1$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $4fdec5228fea4ed1$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $4fdec5228fea4ed1$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $c54226a072d7e33d$export$3cd1cee43d19b683).cache;
                $4fdec5228fea4ed1$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $4fdec5228fea4ed1$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $4fdec5228fea4ed1$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $4fdec5228fea4ed1$var$_round(($4fdec5228fea4ed1$var$_win.visualViewport && $4fdec5228fea4ed1$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $4fdec5228fea4ed1$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $4fdec5228fea4ed1$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $c54226a072d7e33d$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $4fdec5228fea4ed1$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $4fdec5228fea4ed1$var$_maxScroll(target, (0, $c54226a072d7e33d$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $4fdec5228fea4ed1$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $4fdec5228fea4ed1$var$_maxScroll(target, (0, $c54226a072d7e33d$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($4fdec5228fea4ed1$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $4fdec5228fea4ed1$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($4fdec5228fea4ed1$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $4fdec5228fea4ed1$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $4fdec5228fea4ed1$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $4fdec5228fea4ed1$var$_updateAll();
    };
    vars.onEnable = function() {
        $4fdec5228fea4ed1$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $4fdec5228fea4ed1$export$875bcbe48555930.addEventListener("refresh", onResize);
        $4fdec5228fea4ed1$var$_addListener($4fdec5228fea4ed1$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $4fdec5228fea4ed1$var$_allowNativePanning(target, true);
        $4fdec5228fea4ed1$var$_removeListener($4fdec5228fea4ed1$var$_win, "resize", onResize);
        $4fdec5228fea4ed1$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $4fdec5228fea4ed1$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $4fdec5228fea4ed1$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $4fdec5228fea4ed1$var$_fixIOSBug && $4fdec5228fea4ed1$var$gsap.ticker.add($4fdec5228fea4ed1$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $4fdec5228fea4ed1$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $4fdec5228fea4ed1$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $4fdec5228fea4ed1$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$4fdec5228fea4ed1$export$875bcbe48555930.sort = function(func) {
    return $4fdec5228fea4ed1$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$4fdec5228fea4ed1$export$875bcbe48555930.observe = function(vars) {
    return new (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b)(vars);
};
$4fdec5228fea4ed1$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $4fdec5228fea4ed1$var$_normalizer;
    if (vars === true && $4fdec5228fea4ed1$var$_normalizer) return $4fdec5228fea4ed1$var$_normalizer.enable();
    if (vars === false) {
        $4fdec5228fea4ed1$var$_normalizer && $4fdec5228fea4ed1$var$_normalizer.kill();
        $4fdec5228fea4ed1$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $c54226a072d7e33d$export$c1cbdee04e18ea8b) ? vars : $4fdec5228fea4ed1$var$_getScrollNormalizer(vars);
    $4fdec5228fea4ed1$var$_normalizer && $4fdec5228fea4ed1$var$_normalizer.target === normalizer.target && $4fdec5228fea4ed1$var$_normalizer.kill();
    $4fdec5228fea4ed1$var$_isViewport(normalizer.target) && ($4fdec5228fea4ed1$var$_normalizer = normalizer);
    return normalizer;
};
$4fdec5228fea4ed1$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $c54226a072d7e33d$export$5de019f4480f0f8d),
    _inputObserver: $4fdec5228fea4ed1$var$_inputObserver,
    _scrollers: (0, $c54226a072d7e33d$export$3cd1cee43d19b683),
    _proxies: (0, $c54226a072d7e33d$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $4fdec5228fea4ed1$var$_lastScrollTime || $4fdec5228fea4ed1$var$_dispatch("scrollStart");
            $4fdec5228fea4ed1$var$_lastScrollTime = $4fdec5228fea4ed1$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $4fdec5228fea4ed1$var$_refreshing;
        }
    }
};
$4fdec5228fea4ed1$var$_getGSAP() && $4fdec5228fea4ed1$var$gsap.registerPlugin($4fdec5228fea4ed1$export$875bcbe48555930);


(0, $310c7edeeb54bee4$export$99ee26438460406a).registerPlugin((0, $4fdec5228fea4ed1$export$875bcbe48555930));
function $fe4c4a426df04f81$var$isMobile() {
    return /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 800;
}
const $fe4c4a426df04f81$var$Talent = ({ data: data })=>{
    const [currentItemIndex, setCurrentItemIndex] = (0, $dhiZh.useState)(0);
    const prevScrollY = (0, $dhiZh.useRef)(0);
    const containerRef = (0, $dhiZh.useRef)(null);
    const { ref: ref } = (0, $74bd4cb969e9d802$export$2f62ee6831462844)({
        threshold: Array.from({
            length: 101
        }, (_, i)=>i / 100)
    });
    (0, $dhiZh.useEffect)(()=>{
        const endScroll = $fe4c4a426df04f81$var$isMobile() ? 2500 : 1500;
        let tl = (0, $310c7edeeb54bee4$export$99ee26438460406a).timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: containerRef.current,
                pin: true,
                start: "top top",
                end: `+=${endScroll}`,
                scrub: 1,
                markers: false,
                onUpdate: (self)=>{
                    const items = Array.from(document.querySelectorAll(".benefit-item"));
                    const totalItems = items.length;
                    const progress = self.progress.toFixed(3);
                    // Calculate the index of the element to highlight
                    const indexToHighlight = Math.min(Math.floor(progress * totalItems), totalItems - 1 // ensure the index is within bounds
                    );
                    // Update the currentItemIndex state
                    setCurrentItemIndex(indexToHighlight);
                    if (progress === 1) setCurrentItemIndex(totalItems - 1);
                    if (progress === 0) setCurrentItemIndex(0);
                // console.log(
                //   'progress:', progress,
                //   'direction:', self.direction,
                //   'velocity', self.getVelocity(),
                //   'highlight index:', indexToHighlight
                // );
                }
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
            ref: ref,
            id: "intro",
            className: "makerlab-talent-wrapper",
            children: [
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h3", {
                    children: data.title
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("ul", {
                    children: data.benefitsList.map((item, index)=>{
                        const isHighlighted = index === currentItemIndex;
                        return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("li", {
                            className: `benefit-item ${isHighlighted ? "highlight" : ""}`,
                            children: item.fields.title
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h4", {
                    children: (0, $6ed23f9f312890d4$export$4a295a2b4ab66da6)(data[`description${currentItemIndex + 1}`])
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                    className: "makerlab-scrolltobottom",
                    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("svg", {
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 63 36",
                        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                            d: "M61 2 30.878 33 2 2",
                            stroke: "#181917",
                            strokeOpacity: ".15",
                            strokeWidth: "4",
                            strokeLinecap: "round"
                        })
                    })
                })
            ]
        })
    });
};
var $fe4c4a426df04f81$export$2e2bcd8739ae039 = $fe4c4a426df04f81$var$Talent;




var $dhiZh = parcelRequire("dhiZh");

const $9a168c4a5080b636$var$mockData = [
    {
        title: "Expert Talent, Pre-Vetted for Quality",
        text: "We've handpicked the best talent, so you get Makers you can trust every time."
    },
    {
        title: "Quick to Respond, Ready to Scale",
        text: "Whether you need help now or later, our global network is ready to jump in and deliver."
    },
    {
        title: "AI-Powered Precision",
        text: "We use AI to match you with the perfect fit, tailored to your needs, without the hassle."
    }
];
const $9a168c4a5080b636$var$Map = ({ data: data })=>{
    const [showMapPins, setShowMapPins] = (0, $dhiZh.useState)(false);
    const { ref: ref, inView: inView } = (0, $74bd4cb969e9d802$export$2f62ee6831462844)({
        threshold: 0.8
    });
    (0, $dhiZh.useEffect)(()=>{
        if (inView) setShowMapPins(inView);
    }, [
        inView
    ]);
    (0, $dhiZh.useEffect)(()=>{
        if (showMapPins) {
            const gElements = document.querySelectorAll(".makerlab-map-svg .g-group");
            gElements.forEach((gElement)=>{
                const delay = Math.random() * 1; // Random delay between 0 and 2 seconds
                gElement.style.transition = `opacity 0.5s ease ${delay}s`;
                gElement.style.opacity = 1;
            });
        } else {
            const gElements = document.querySelectorAll(".makerlab-map-svg .g-group");
            gElements.forEach((gElement)=>{
                gElement.style.transition = "opacity 0.5s ease";
                gElement.style.opacity = 0;
            });
        }
    }, [
        showMapPins
    ]);
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
        ref: ref,
        className: "makerlab-section makerlab-map-wrapper",
        children: [
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h3", {
                children: "Global talent on tap"
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                className: "makerlab-map-svg",
                "data-active": showMapPins,
                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("svg", {
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 1029 504",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("g", {
                            id: "m-g-map",
                            stroke: "#D5FD00",
                            strokeWidth: "2",
                            strokeMiterlimit: "10",
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m504.473 363.452 42.499-20.838-23.812 85.322-18.687-64.484ZM495.457 300.199l51.514 42.415-42.499 20.838-9.015-63.253ZM598.489 309.058l-103.032-8.859 51.514 42.415 51.518-33.556ZM610.047 252.941l-11.558 56.117 39.591-52.177-28.033-3.94ZM610.046 252.942l-59.017-5.415 47.46 61.531 11.557-56.116Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m570.212 179.352 39.834 73.59-59.017-5.415 19.183-68.175Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m504.473 170.984 65.739 8.368-19.182 68.175-46.557-76.543ZM478.243 242.196l72.787 5.331-55.573 52.672-17.214-58.003Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m437.259 278.294 40.984-36.098 17.214 58.003-58.198-21.905Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m504.472 170.984-26.229 71.213 72.787 5.33-46.558-76.543ZM450.21 162.369l54.262 8.615-26.229 71.212-28.033-79.827Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m410.866 211.593 39.344-49.224 28.033 79.827-67.377-30.603ZM413.078 252.941l65.165-10.745-67.377-30.603 2.212 41.348Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m437.259 278.294-24.181-25.353 65.165-10.745-40.984 36.098ZM495.458 154.741l9.014 16.243-54.262-8.615 45.248-7.628ZM570.212 179.351l11.638-22.152 40.165 26.584-51.803-4.432Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m613.983 245.641-43.771-66.289 51.803 4.431-8.032 61.858Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m638.08 205.603-16.065-21.821-8.033 61.859 24.098-40.038ZM653.981 225.622l-15.901-20.018-24.098 40.037 39.999-20.019Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m649.612 196.472-11.532 9.132 15.901 20.018-4.369-29.15ZM662.509 211.047l-12.897-14.575 4.37 29.15 8.527-14.575ZM581.849 157.199l-22.514-17.939-8.306 14.44 30.82 3.499Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m596.114 137.73-36.779 1.53 22.515 17.94 14.264-19.47ZM539.145 156.136l6.231-16.876-17.134 3.174 10.903 13.702ZM559.335 139.26l1.204-20.783-15.163 20.783h13.959ZM622.016 183.783l44.098 13.945-8.524-56.444-35.574 42.499ZM596.114 137.73l25.901 46.053L581.85 157.2l14.264-19.47Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m657.59 141.284-61.477-3.554 25.902 46.053 35.575-42.499ZM666.113 197.728l61.313-43.482-21.311 64.32-40.002-20.838ZM735.295 233.99l-29.18-15.424 18.197 46.107 10.983-30.683Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m766.115 208.557-60 10.009 29.18 15.424 30.82-25.433Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m727.426 154.246 38.689 54.311-60 10.009 21.311-64.32ZM657.59 141.284l69.836 12.962-61.312 43.482-8.524-56.444ZM528.242 142.435l-17.869-20.565 29.292-15.533-11.423 36.098Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m545.376 139.26-5.711-32.923-11.423 36.098 17.134-3.175Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m560.539 118.477-20.874-12.14 5.711 32.923 15.163-20.783ZM596.114 137.73l-35.575-19.253 33.523-39.051 2.052 58.304ZM539.665 106.337l-28.47-13.785-.822 29.318 29.292-15.533Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m476.821 102.397 17.378-17.062 16.174 36.535-33.552-19.473Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m511.195 92.552-16.996-7.217 16.174 36.535.822-29.318Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m491.795 129.527 18.578-7.657-33.552-19.473 14.974 27.13Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m517.586 149.654-25.792-20.128 18.579-7.657 7.213 27.785ZM507.313 151.73l10.274-1.53-3.169 5.141-7.105-3.611ZM457.26 112.898l19.561-10.501 14.973 27.13-34.534-16.629Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m463.379 130.946-6.119-18.049 34.534 16.629-28.415 1.42ZM440.864 132.014l22.515-1.067-2.678 24.395-19.837-23.328Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m491.794 129.526-31.093 25.816 2.678-24.395 28.415-1.421Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m438.652 154.741 22.05.601-19.838-23.328-2.212 22.727ZM457.998 105.598l16.527-8.368-15.545-3.12-.982 11.488Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m457.998 75.242 8.264 3.364-7.282 15.505-.982-18.869Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m474.525 97.23-8.263-18.624-7.282 15.504 15.545 3.12ZM444.036 89.435l9.288-.82-2.241 9.515-7.047-8.695Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m441.468 99.335 9.615-1.205-7.047-8.695-2.568 9.9ZM416.192 49.317l-.902 7.22 10.575 1.723-9.673-8.943Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m437.67 51.695-11.805 6.565-9.673-8.943 21.478 2.378ZM511.195 92.552l38.089-21.002-9.619 34.787-28.47-13.785ZM529.609 66.08l19.674 5.47 12.02-20.893-31.694 15.424Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m594.062 79.426-54.397 26.911 20.874 12.14 33.523-39.051Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m549.283 71.55 44.779 7.876-54.397 26.911 9.618-34.787ZM535.375 50.137l-5.766 15.944 31.694-15.424-25.928-.52ZM525.019 37.53l10.356 12.606 14.727-14.357-25.083 1.752Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m561.303 50.657-11.201-14.878-14.726 14.357 25.927.52ZM500.539 56.563l34.836-6.426-10.356-12.606-24.48 19.032Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m517.956 68.16-17.417-11.597 34.836-6.426-17.419 18.023ZM500.539 71.55V56.564l-13.772 8.862 13.772 6.124Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m489.826 76.581 10.713-5.032-13.772-6.124 3.059 11.156Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m517.956 68.16-17.417 3.39V56.564l17.417 11.596ZM509.246 85.335l-8.707-13.785 17.417-3.39-8.238 17.175M561.303 50.657l32.759 28.769-44.779-7.876 12.02-20.893Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m622.288 38.296-60.985 12.361 32.759 28.769 28.226-41.13ZM633.984 98.953l-39.922-19.527 2.052 58.304 37.87-38.777Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m657.59 141.284-23.607-42.332-37.87 38.778 61.477 3.554ZM766.115 208.557l31.474-43.81-70.163-10.501 38.689 54.311ZM788.739 237.711l-22.624-29.154 49.29 12.088-26.666 17.066ZM794.202 264.455l-5.464-26.744 16.64 22.535-11.176 4.209Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m805.378 260.245-16.64-22.535 26.666-17.065-10.026 39.6Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m831.8 253.68-16.396-33.035-10.026 39.6 26.422-6.565ZM797.59 164.747l17.815 55.898-49.29-12.088 31.475-43.81Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m860.215 183.455-62.625-18.708 17.815 55.898 44.81-37.19ZM838.985 143.173l21.23 40.281-62.625-18.707 41.395-21.574ZM736.113 78.606l-8.687 75.641 70.163 10.501-61.476-86.142Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m657.59 141.284 78.523-62.678-8.687 75.641-69.836-12.963ZM633.984 98.953l-11.696-60.657-28.226 41.13 39.922 19.527ZM700.211 15.76l-77.923 22.535 11.696 60.657 66.227-83.191Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m736.113 78.606-102.13 20.347 23.607 42.331 78.523-62.678Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m838.985 143.174 12.703-54.23-115.575-10.338 102.872 64.568Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m797.59 164.748 41.395-21.574-102.872-64.568 61.477 86.142ZM700.211 15.76l35.902 62.846-102.13 20.346 66.228-83.191Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m817.102 28.56-116.891-12.8 35.902 62.846 80.989-50.047Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M851.688 88.943 817.103 28.56l-80.99 50.046 115.575 10.337ZM882.836 109.454l-31.147-20.51-12.704 54.23 43.851-33.72Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m867.263 137.675 15.573-28.222-43.851 33.72 28.278-5.498ZM869.886 161.631l-30.901-18.457 28.278-5.498 2.623 23.955ZM882.836 109.453l-6.72-17.393 21.638 22.971-14.918-5.578ZM851.688 88.943l22.708-52.096-57.293-8.287 34.585 60.383Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m904.15 62.2-52.462 26.743 22.708-52.096 29.754 25.352Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m951.61 48.906-77.214-12.06L904.151 62.2l47.459-13.293Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m924.315 100.592 27.295-51.686L904.15 62.2l20.165 38.392ZM894.641 121.677l5.245 17.036 12.023-9.077-17.268-7.959ZM911.143 163.314l-11.256-24.601-3.496 19.144 14.752 5.457ZM884.04 165.405l12.351-7.548 14.751 5.457-27.102 2.091ZM889.722 172.845l-5.682-7.439-.546 10.173 6.228-2.734ZM863.821 198.441l-5.792 9.515 6.447 3.502-.655-13.017ZM597.15 30.092l9.51-1.31 2.732 6.233-12.242-4.923Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M614.856 16.639 597.15 30.093l9.51-1.311 8.196-12.143ZM502.697 8.544l10.739 8.094-.549-8.094h-10.19Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m521.304 10.183-8.417-1.639.549 8.094 7.868-6.455ZM531.604 6.205l-13.237.411 10.861 3.075 2.376-3.486ZM581.359 4.604l-9.128 1.424 6.286 1.639 2.842-3.063ZM594.637 2.69c-.655.327-5.409 3.444-5.409 3.444l6.337-.546-.928-2.899ZM604.747 3.676l-5.737 2.898 8.087-.765-2.35-2.133ZM676.169 4.168l-8.306 1.697 8.633 2.953-.327-4.65Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m687.043 7.886-10.874-3.718.327 4.65 10.547-.932ZM693.3 9.062l-1.474 3.284 10.274-.987-8.8-2.297ZM795.735 17.73l-12.132 1.424 9.178 2.79 2.954-4.213ZM806.852 18.387l-2.006 3.036h8.893l-6.887-3.036ZM815.405 290.871l-10.026-30.626-11.176 4.21 21.202 26.416ZM785.625 274.027l32.965 30.192-10.836 7.712-22.129-37.904Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m819.803 316.934-1.214-12.715-10.835 7.712 12.049 5.003ZM831.8 290.871l27.102-21.33 1.641 28.222-28.743-6.892Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m836.936 306.626 23.607-8.862-28.743-6.893 5.136 15.755ZM854.311 310.575l6.232-12.811-23.606 8.862 17.374 3.949ZM819.803 316.934l10.138 11.021 11.038-7.548-21.176-3.473Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m848.738 327.3-7.759-6.893-11.038 7.548 18.797-.655ZM863.166 326.313l-14.428.987 11.805 3.718 2.623-4.705ZM869.503 325.33l-3.714 4.814 11.256-1.479-7.542-3.335ZM891.035 327.736l-10.931 2.407v5.797l10.931-8.204ZM598.489 309.058l2.052 45.04-53.569-11.484 51.517-33.556ZM546.972 342.614l-23.812 85.322 36.288-6.455-12.476-78.867Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m559.447 421.481 41.094-67.383-53.569-11.484 12.475 78.867ZM630.866 342.614l-18.36 15.916 8.524 31.338 9.836-47.254Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m609.229 389.868 3.277-31.339 8.524 31.339h-11.801ZM734.393 258.439v15.588l6.639-5.006-6.639-10.582ZM865.378 224.803l7.214 6.317-8.608 6.07 1.394-12.387ZM828.493 218.322l-3.608 6.481 6.395.572-2.787-7.053Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m833.001 219.225-4.508-.903 2.787 7.053 1.721-6.15ZM873.41 243.919l-.818-12.799-8.608 6.07 9.426 6.729Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m884.64 248.678-11.23-4.759 9.59 12.879 1.64-8.12ZM883.575 272.961l6.475-6.482-7.05-9.681.575 16.163ZM873.41 250.728l2.543 9.598 2.132-4.801-4.675-4.797ZM866.28 316.933l11.311-6.359-10.983-8.245-.328 14.604Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m872.592 290.871-5.985 11.459 10.983 8.245-4.998-19.704ZM896.391 286.606l-3.172 8.75 5.904-.874-2.732-7.876ZM885.568 289.287l-12.976 1.584 9.262 3.066 3.714-4.65ZM903.383 306.625l-8.087.546 9.837 3.403-1.75-3.949ZM928.739 301.484l-9.754 10.199 35.636.678-25.882-10.877ZM916.115 298.31l2.87 13.373-12.048-10.96 9.178-2.413ZM937.837 330.144l-18.852-18.46 30.191 12.496-11.339 5.964Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m918.985 311.684 35.636.678-5.445 11.818-30.191-12.496Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m968.849 335.503-14.228-23.142-5.445 11.819 19.673 11.323ZM976.719 312.361l-13.333 4.573 7.214 3.255 6.119-7.828ZM941.69 335.94l-10.165 26.854 23.096 7.22-12.931-34.074ZM908.41 389.213l23.115-26.42-24.588-23.463 1.473 49.883Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m866.607 369.03 40.33-29.7 1.473 49.883-41.803-20.183Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m837.756 389.213 28.852-20.183 12.296 32.981-41.148-12.798ZM836.937 429.247l.818-40.034 41.148 12.798-41.966 27.236Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m895.623 418.964-16.72-16.953-41.966 27.235 58.686-10.282ZM895.623 418.964l12.787-29.751-29.507 12.798 16.72 16.953ZM908.41 389.213l-29.507 12.798-12.296-32.981 41.803 20.183Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m965.462 398.563-10.841-28.549-46.211 19.199 57.052 9.35ZM931.525 362.793l-23.115 26.419 46.211-19.199-23.096-7.22ZM939.066 436.795l-13.933-24.119 40.329-14.113-26.396 38.232ZM908.41 389.213l16.723 23.463 40.329-14.113-57.052-9.35Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m895.623 418.964 29.51-6.288-16.723-23.463-12.787 29.751ZM912.182 441.553l12.951-28.877-29.51 6.288 16.559 22.589ZM939.067 436.795l-26.884 4.758 12.95-28.877 13.934 24.119ZM913.986 450.907l11.638 1.803-11.638 8.207v-10.01ZM1016.39 426.512l8.96 16.628-11.86-1.667 2.9-14.961ZM1003.82 452.986l-21.201 7.931-4.591 12.522 25.792-20.453Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m967.755 466.222 14.864-5.305-4.591 12.522-10.273-7.217ZM1007.35 452.466l6.14-10.992 11.86 1.667-18 9.325ZM353.98 69.088l-13.936-17.062 31.969-1.369-18.033 18.431Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m348.24 21.507-8.196 30.52 31.969-1.37-23.773-29.15Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m417.094 36.767-68.854-15.26 23.773 29.15 45.081-13.89ZM388.406 1.815 348.24 21.506l-1.473-16.574 41.639-3.117Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m322.339 15.928 24.428-10.995 1.474 16.574-25.902-5.579Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m417.094 36.766-28.688-34.95-40.166 19.69 68.854 15.26ZM445.292 3.621l-56.886-1.806 28.689 34.951 28.197-33.145ZM551.029 247.527l-55.572 52.672 103.032 8.859-47.46-61.531ZM247.421 88.124l48.525-17.066-29.837-9.026-18.688 26.092ZM293.159 104.694l2.787-33.636 13.769 25.433-16.556 8.203Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m247.421 88.123 45.739 16.571 2.786-33.636-48.525 17.065ZM309.716 96.491l-13.77 20.674 15.738 1.147-1.968-21.82ZM247.421 88.124l16.229 37.9 29.51-21.329-45.739-16.571ZM236.929 101.742l26.72 24.282-16.229-37.9-10.491 13.618Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m227.092 148.34 36.557-22.316-26.72-24.283-9.837 46.599ZM215.123 73.847l21.806 27.894-45.575 6.892 23.769-34.786ZM203.813 44.97l11.311 28.877L232.174 43l-28.361 1.97ZM254.798 50.657 232.175 43l-17.051 30.847 39.674-23.19Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M250.618 32.17 232.174 43l22.624 7.657-4.18-18.486Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m270.863 42.016-20.245-9.845 4.18 18.486 16.065-8.64ZM203.813 44.97l-40.657-6.893 2.787 35.77 37.87-28.877ZM191.354 108.634l35.738 39.706 9.837-46.599-45.575 6.893Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M165.943 73.847h49.181L203.813 44.97l-37.87 28.877ZM191.354 108.633l-25.411-34.786h49.181l-23.77 34.786ZM187.913 180.335l20.492-3.937-23.279-38.231 2.787 42.168Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m227.093 148.34-41.967-10.173 23.279 38.231 18.688-28.058ZM203.268 199.971l5.136-23.573-20.492 3.937 15.356 19.636ZM191.354 108.634l-6.228 29.533 41.967 10.173-35.739-39.706ZM163.157 38.078l-43.196-1.311 15.49 35.522 27.706-34.211ZM94.085 71.004l25.876-34.237 15.49 35.522-41.366-1.285ZM64.469 43.656l29.616 27.348 25.876-34.237-55.492 6.889Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m45.014 78.224 49.07-7.22L64.47 43.654 45.014 78.224ZM29.821 69.69l15.192 8.534 19.455-34.569L29.821 69.69Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M5.015 89.927 29.82 69.689l15.192 8.535L5.015 89.927ZM94.085 71.004l8.581 43.045 32.785-41.76-41.366-1.285ZM165.944 73.847l-30.493-1.558 27.706-34.212 2.787 35.77ZM149.551 119.299l16.393-45.452-30.493-1.558 14.1 47.01Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m82.09 146.862 20.576-32.814 39.919 31.339-60.494 1.475ZM102.255 177.381l-20.164-30.519 60.494-1.475-40.33 31.994Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m149.551 119.299-46.885-5.25 32.785-41.76 14.1 47.01ZM191.354 108.633l-41.803 10.665 16.392-45.451 25.411 34.786ZM185.125 138.167l-35.574-18.868 41.803-10.665-6.229 29.533Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m142.584 145.387 6.967-26.089-46.885-5.25 39.918 31.339Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m185.125 138.167-42.541 7.22 6.967-26.088 35.574 18.868ZM187.912 180.335l-45.328-34.948 42.541-7.22 2.787 42.168Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m144.632 195.925 43.28-15.591-45.328-34.947 2.048 50.538Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m102.255 177.381 42.377 18.544-2.048-50.538-40.329 31.994ZM118.24 222.833l26.392-26.907-42.377-18.544 15.985 45.451Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m150.697 224.803-6.065-28.877-26.393 26.908 32.458 1.969Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m156.764 239.24-6.067-14.437-32.458-1.97 38.525 16.407ZM177.748 214.302l-27.051 10.501 6.068 14.437 20.983-24.938Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m173.321 236.451-16.556 2.789 20.983-24.938-4.427 22.149Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m177.748 254.118-4.427-17.667-16.556 2.789 20.983 14.878Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m187.913 238.585-14.592-2.134 4.427 17.667 10.165-15.533Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m193.103 261.447-15.355-7.329 10.164-15.533 5.191 22.862Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m196.163 267.902-3.06-6.455-15.355-7.33 18.415 13.785Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m207.419 263.308-14.315-1.861 3.059 6.456 11.256-4.595Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m202.282 289.232-6.119-21.329 11.256-4.595-5.137 25.924Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m240.974 291.202-33.555-27.894-5.137 25.924 38.692 1.97Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m236.165 251.93-28.746 11.378 33.555 27.894-4.809-39.272ZM191.463 314.502l10.819-25.27 48.991 30.655-59.81-5.385Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m231.108 364.435-39.645-49.934 59.81 5.385-20.165 44.549ZM291.192 278.786l-55.027-26.856 4.809 39.272 50.218-12.416Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m251.273 319.887-10.299-28.685-38.692-1.97 48.991 30.655ZM302.01 300.935l-10.819-22.149-50.217 12.416 61.036 9.733Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m251.273 319.887 50.737-18.952-61.036-9.733 10.299 28.685ZM348.16 318.656l-46.15-17.721-1.31 44.548 47.46-26.827Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M327.748 381.665 300.7 345.484l47.46-26.828-20.412 63.009ZM251.273 319.886l49.428 25.597 1.31-44.548-50.738 18.951Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m231.108 364.435 69.593-18.951-49.428-25.597-20.165 44.548Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m273.649 396.677 27.051-51.194 27.048 36.182-54.099 15.012Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m231.108 364.435 42.542 32.242 27.051-51.194-69.593 18.952Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m286.928 440.734-13.279-44.057 54.099-15.012-40.82 59.069Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m237.256 434.825 36.394-38.148-42.542-32.241 6.148 70.389Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m286.927 440.734-49.671-5.909 36.393-38.148 13.278 44.057ZM245.616 469.776l41.311-29.042-49.671-5.909 8.36 34.951Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m271.492 493.403-25.876-23.627 41.312-29.042-15.436 52.669Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m268.622 501.224 2.87-7.821-25.876-23.628 23.006 31.449Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m285.454 502.538-13.962-9.136-2.87 7.821 16.832 1.315ZM204.388 207.901l-17.433 2.626 13.988 2.789 3.445-5.415Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m219.715 217.911-15.327-10.01-3.445 5.415 18.772 4.595ZM228.405 220.124l-8.69 5.334 8.69 1.314v-6.648ZM238.977 223.9l-10.572-3.776v6.648l10.572-2.872ZM206.108 225.295l6.119.983-4.423 1.861-1.696-2.844ZM242.788 224.925l6.026.247-3.525 2.789-2.501-3.036ZM179.553 29.873l24.261 11.54 4.591-17.664-28.852 6.125Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m229.824 27.248-21.42-3.499-4.591 17.663 26.011-14.164ZM222.829 13.795l-14.425 4.264 25.902 3.393-11.477-7.657ZM294.305 43l-18.197 12.962 23.77 6.729L294.305 43ZM311.684 36.082 294.306 43l5.573 19.691 11.805-26.609ZM283.978 25.935l27.705 10.147L294.305 43l-10.327-17.065Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M264.799 33.319 294.306 43l-10.328-17.065-19.179 7.384ZM299.879 2.635l11.805 11.16 35.083-12.47-46.888 1.31Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m280.536 15.433 31.148-1.639-11.805-11.16-19.343 12.8Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m276.818 4.932 23.061-2.297-19.343 12.798-3.718-10.5ZM236.056 27.959l13.551-3.008-3.387 6.125-10.164-3.117Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m239.77 32.172-3.714-4.213 10.164 3.117-6.45 1.096ZM274.963 16.475h-8.855l9.073 6.343-.218-6.343ZM253.157 24.951h13.388l-10.219 4.65-3.169-4.65ZM246.711 17.075h12.623l-6.559 3.827-6.064-3.827ZM255.289 9.309l7.323.874-2.761 3.884-4.562-4.758ZM267.64 10.292v3.284l4.918-2.516-4.918-.768ZM232.174 11.934l8.305-1.642-4.424 4.65-3.881-3.008ZM261.63 18.332l-4.591 3.12h6.665l-2.074-3.12Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m294.306 21.725-19.343-5.25.218 6.343 19.125-1.093Z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                            className: "g-group",
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M800 243c-10.493 0-19 8.552-19 19.102 0 .851.154 1.884.377 2.935a28.395 28.395 0 0 0 3.417 8.655c4.35 7.29 15.215 25.308 15.215 25.308s10.676-17.744 14.841-24.672a31.711 31.711 0 0 0 3.567-8.49c.338-1.322.583-2.655.583-3.736 0-10.55-8.506-19.102-19-19.102Z",
                                    fill: "#D5FD00"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                            className: "g-group",
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M839 246c-10.493 0-19 8.552-19 19.102 0 .851.154 1.884.377 2.935a28.395 28.395 0 0 0 3.417 8.655c4.35 7.29 15.215 25.308 15.215 25.308s10.676-17.744 14.841-24.672a31.711 31.711 0 0 0 3.567-8.49c.338-1.322.583-2.655.583-3.736 0-10.55-8.506-19.102-19-19.102Z",
                                    fill: "#D5FD00"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                            className: "g-group",
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M878 195c-10.493 0-19 8.552-19 19.102 0 .851.154 1.884.377 2.935a28.395 28.395 0 0 0 3.417 8.655c4.35 7.29 15.215 25.308 15.215 25.308s10.676-17.744 14.841-24.672a31.711 31.711 0 0 0 3.567-8.49c.338-1.322.583-2.655.583-3.736 0-10.55-8.506-19.102-19-19.102Z",
                                    fill: "#D5FD00"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                            className: "g-group",
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M462 38c-10.493 0-19 8.552-19 19.102 0 .85.154 1.884.377 2.935a28.399 28.399 0 0 0 3.417 8.655C451.144 75.982 462.009 94 462.009 94s10.676-17.744 14.841-24.672a31.724 31.724 0 0 0 3.567-8.49c.338-1.322.583-2.656.583-3.736C481 46.552 472.494 38 462 38Z",
                                    fill: "#D5FD00"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                            className: "g-group",
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                d: "M116 166c-10.493 0-19 8.552-19 19.102 0 .851.154 1.884.377 2.935a28.403 28.403 0 0 0 3.417 8.655c4.35 7.29 15.215 25.308 15.215 25.308s10.676-17.744 14.841-24.672a31.711 31.711 0 0 0 3.567-8.49c.338-1.322.583-2.655.583-3.736 0-10.55-8.506-19.102-19-19.102Z",
                                fill: "#D5FD00"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                className: "makerlab-map-texts",
                "data-show": showMapPins,
                children: $9a168c4a5080b636$var$mockData.map((data, index)=>/*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                        className: "makerlab-map-text",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h4", {
                                children: data.title
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("p", {
                                children: data.text
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $9a168c4a5080b636$export$2e2bcd8739ae039 = $9a168c4a5080b636$var$Map;



parcelRequire("dhiZh");
const $4d1796e773ded861$var$Cases = ({ data: data })=>{
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
        id: "work",
        className: "makerlab-cases",
        children: [
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h3", {
                children: data.title
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                className: "makerlab-cases-wrapper",
                children: data.cases.map((item, index)=>{
                    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("a", {
                        href: "case/" + item.fields.slug,
                        className: "makerlab-cases-item",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("img", {
                                src: item.fields.caseLogo.fields.file.url,
                                alt: item.fields.caseLogo.fields.file.fileName
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h4", {
                                children: item.fields.caseDescription
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var $4d1796e773ded861$export$2e2bcd8739ae039 = $4d1796e773ded861$var$Cases;




var $dhiZh = parcelRequire("dhiZh");


(0, $310c7edeeb54bee4$export$99ee26438460406a).registerPlugin((0, $4fdec5228fea4ed1$export$875bcbe48555930));
const $8ad3ddd758769fa0$var$Champions = (data)=>{
    const championsScreen = data.data;
    const containerRef = (0, $dhiZh.useRef)(null);
    const carouselRef = (0, $dhiZh.useRef)(null);
    (0, $dhiZh.useEffect)(()=>{
        const container = containerRef.current;
        const carousel = carouselRef.current;
        let scrollWidth = carousel.scrollWidth;
        let containerWidth = container.offsetWidth;
        let endScroll;
        function isMobile() {
            return window.innerWidth <= 768;
        }
        function calculateValues() {
            scrollWidth = carousel.scrollWidth;
            containerWidth = container.offsetWidth;
            endScroll = isMobile() ? scrollWidth - containerWidth + 1000 : scrollWidth - containerWidth;
        }
        calculateValues(); // Initial calculation
        // Handle window resize to recalculate scroll values
        const handleResize = ()=>{
            calculateValues();
            (0, $4fdec5228fea4ed1$export$875bcbe48555930).refresh(); // Refresh GSAP ScrollTrigger
        };
        window.addEventListener("resize", handleResize);
        let tl = (0, $310c7edeeb54bee4$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: container,
                pin: true,
                pinSpacing: true,
                scrub: 0.01,
                start: "top top",
                end: ()=>`+=${endScroll}`,
                markers: false,
                invalidateOnRefresh: true,
                onRefresh: calculateValues
            }
        });
        tl.to(carousel, {
            x: ()=>-(scrollWidth - containerWidth),
            ease: "none"
        });
        // Cleanup on component unmount
        return ()=>{
            window.removeEventListener("resize", handleResize);
            (0, $4fdec5228fea4ed1$export$875bcbe48555930).getAll().forEach((trigger)=>trigger.kill());
        };
    }, []);
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        ref: containerRef,
        className: "makerlab-section makerlab-section-champions-wrapper",
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("ul", {
            ref: carouselRef,
            className: "makerlab-carousel-wrapper",
            children: championsScreen.fields.makerLabChampions.map((item, index)=>{
                var _item_fields_profilePicture_fields_file, _item_fields_profilePicture_fields, _item_fields_profilePicture, _item_fields, _item_fields_linkedIn, _item_fields1;
                return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("li", {
                    className: "makerlab-carousel-item",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                            className: "carousel-overlay"
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                            className: "makerlab-carousel-item--bottom",
                            children: [
                                ((_item_fields = item.fields) === null || _item_fields === void 0 ? void 0 : (_item_fields_profilePicture = _item_fields.profilePicture) === null || _item_fields_profilePicture === void 0 ? void 0 : (_item_fields_profilePicture_fields = _item_fields_profilePicture.fields) === null || _item_fields_profilePicture_fields === void 0 ? void 0 : (_item_fields_profilePicture_fields_file = _item_fields_profilePicture_fields.file) === null || _item_fields_profilePicture_fields_file === void 0 ? void 0 : _item_fields_profilePicture_fields_file.url) && /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("img", {
                                    src: item.fields.profilePicture.fields.file.url,
                                    alt: item.fields.profilePicture.fields.file.fileName
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("span", {
                                    className: "makerlab-carousel-item-text-column",
                                    "data-dark": item.fields.textDarkMode,
                                    children: [
                                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                            className: "makerlab-carousel-item-text makerlab-carousel-item-text--bold",
                                            children: item.fields.name
                                        }),
                                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                            className: "makerlab-carousel-item-text",
                                            children: item.fields.title
                                        }),
                                        ((_item_fields1 = item.fields) === null || _item_fields1 === void 0 ? void 0 : (_item_fields_linkedIn = _item_fields1.linkedIn) === null || _item_fields_linkedIn === void 0 ? void 0 : _item_fields_linkedIn.length) > 0 && /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                                            href: item.fields.linkedIn,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("svg", {
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 31 32",
                                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                                                    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                                        d: "M15.5.64C6.94.64 0 7.58 0 16.14c0 8.561 6.94 15.5 15.5 15.5 8.56 0 15.5-6.939 15.5-15.5C31 7.58 24.06.64 15.5.64Zm-4.135 22.994H7.96V12.64h3.404v10.995ZM9.647 11.2a2.02 2.02 0 0 1-2.013-2.03 2.02 2.02 0 0 1 2.013-2.028 2.02 2.02 0 0 1 2.012 2.029A2.02 2.02 0 0 1 9.647 11.2Zm14.471 12.434h-3.387v-5.771c0-1.583-.601-2.467-1.853-2.467-1.362 0-2.073.92-2.073 2.467v5.771H13.54V12.64h3.265v1.481s.981-1.816 3.313-1.816c2.331 0 4 1.423 4 4.368v6.962Z",
                                                        fill: "#1851D7"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, index);
            })
        })
    });
};
var $8ad3ddd758769fa0$export$2e2bcd8739ae039 = $8ad3ddd758769fa0$var$Champions;



parcelRequire("dhiZh");



var $dhiZh = parcelRequire("dhiZh");
const $5f43d2ebf56d0d60$var$EmailRestAPI = ()=>{
    const [email, setEmail] = (0, $dhiZh.useState)("");
    const [message, setMessage] = (0, $dhiZh.useState)("");
    const [region, setRegion] = (0, $dhiZh.useState)("N/A");
    const [wasSentSuccessfully, setWasSentSuccessfully] = (0, $dhiZh.useState)(false);
    const [isSending, setIsSending] = (0, $dhiZh.useState)(false);
    const [submitText, setSubmitText] = (0, $dhiZh.useState)("Submit");
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // set button text
        setSubmitText("Sending...");
        setIsSending(true);
        // Your EmailJS service ID, template ID, and Public Key
        const serviceId = "service_tp8azya";
        const templateIdAPAC = "template_czkn2a7"; // APAC
        const templateIdEMEA = "template_f7vli7h"; // EMEA
        const publicKey = "7-VBs0Z92r9ZNHlwh";
        // Data for APAC and EMEA
        const dataAPAC = {
            service_id: serviceId,
            template_id: templateIdAPAC,
            user_id: publicKey,
            template_params: {
                from_email: email,
                region: region,
                to_name: "Web Wizard",
                message: message
            }
        };
        const dataEMEA = {
            service_id: serviceId,
            template_id: templateIdEMEA,
            user_id: publicKey,
            template_params: {
                from_email: email,
                region: region,
                to_name: "Web Wizard",
                message: message
            }
        };
        try {
            if (region === "APAC") // Send the email for APAC
            await (0, $0990a2a3ce225f89$export$2e2bcd8739ae039).post("https://api.emailjs.com/api/v1.0/email/send", dataAPAC);
            else if (region === "EMEA") // Send the email for EMEA
            await (0, $0990a2a3ce225f89$export$2e2bcd8739ae039).post("https://api.emailjs.com/api/v1.0/email/send", dataEMEA);
            else if (region === "Global") // Send two requests, one for APAC and one for EMEA
            await Promise.all([
                (0, $0990a2a3ce225f89$export$2e2bcd8739ae039).post("https://api.emailjs.com/api/v1.0/email/send", dataAPAC),
                (0, $0990a2a3ce225f89$export$2e2bcd8739ae039).post("https://api.emailjs.com/api/v1.0/email/send", dataEMEA)
            ]);
            // Clear the form and set success
            setEmail("");
            setMessage("");
            setRegion("");
            setWasSentSuccessfully(true);
        } catch (error) {
            console.error(error);
            setIsSending(false);
            setSubmitText("Send");
        }
    };
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "makerlab-emailForm",
        "data-ty": wasSentSuccessfully,
        children: [
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                className: "makerlab-emailForm-group",
                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("input", {
                    type: "email",
                    placeholder: "Your Email",
                    value: email,
                    onChange: (e)=>setEmail(e.target.value),
                    required: true,
                    disabled: isSending
                })
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h4", {
                children: "Select your region"
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                className: "makerlab-emailForm-group",
                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("fieldset", {
                    className: "fieldset-region",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("input", {
                                    type: "radio",
                                    name: "region",
                                    value: "EMEA",
                                    onChange: (e)=>setRegion(e.target.value),
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                    className: "checkmark"
                                }),
                                "EMEA"
                            ]
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("input", {
                                    type: "radio",
                                    name: "region",
                                    value: "Global",
                                    onChange: (e)=>setRegion(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                    className: "checkmark"
                                }),
                                "Global"
                            ]
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("input", {
                                    type: "radio",
                                    name: "region",
                                    value: "APAC",
                                    onChange: (e)=>setRegion(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                    className: "checkmark"
                                }),
                                "APAC"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("textarea", {
                cols: "30",
                rows: "1",
                placeholder: "Message (Optional)",
                value: message,
                onChange: (e)=>setMessage(e.target.value),
                disabled: isSending
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("button", {
                type: "submit",
                children: !wasSentSuccessfully ? submitText : "Thank you for your submission"
            })
        ]
    });
};
var $5f43d2ebf56d0d60$export$2e2bcd8739ae039 = $5f43d2ebf56d0d60$var$EmailRestAPI;


const $2e0b63450ba28dd7$var$TalkToUs = ()=>{
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        id: "contact",
        className: "makerlab-contact-wrapper",
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
            className: "makerlab-contact-content",
            children: [
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h3", {
                    children: "Talk to us"
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $5f43d2ebf56d0d60$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $2e0b63450ba28dd7$export$2e2bcd8739ae039 = $2e0b63450ba28dd7$var$TalkToUs;



parcelRequire("dhiZh");

const $0315981ce3006dd3$var$Footer = ({ menuList: menuList, footerData: footerData })=>{
    const currentYear = new Date().getFullYear();
    const lenis = (0, $69a63ea936e703ee$export$69a110ee5442c47)();
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                className: "makerlab-footer-top",
                children: [
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                        className: "makerlab-miroma",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("span", {
                                children: [
                                    "Part of the",
                                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                                        href: "https://www.miromagroup.com/",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("svg", {
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 332 29",
                                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                                                clipPath: "url(#a)",
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                fill: "#fff",
                                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                                    d: "M202.862 14.496h10.89v.87a17.26 17.26 0 0 1-.708 5.228 11.373 11.373 0 0 1-2.295 3.947 11.954 11.954 0 0 1-9.337 4.117 12.873 12.873 0 0 1-9.474-3.98c-2.571-2.529-4.004-5.997-3.935-9.585a13.148 13.148 0 0 1 4.004-9.686c4.09-4.049 10.286-5.125 15.532-2.733a16.909 16.909 0 0 1 5.005 4.066l-2.831 2.699c-2.157-2.87-4.797-4.288-7.886-4.288a9.363 9.363 0 0 0-7.007 2.87 9.54 9.54 0 0 0-2.83 7.107 9.333 9.333 0 0 0 3.158 7.226 9.387 9.387 0 0 0 6.402 2.597 8.03 8.03 0 0 0 5.264-1.965 7.006 7.006 0 0 0 2.589-4.766h-6.524v-3.724h-.017ZM289.667 1.512v16.144c0 2.255.363 3.895 1.105 4.937 2.019 2.545 5.747 3.007 8.335 1.008.38-.29.725-.632 1.018-1.008.742-1.008 1.122-2.665 1.122-4.937V1.512l3.987.034v17.169a9.427 9.427 0 0 1-2.606 6.833c-3.849 3.913-10.182 3.998-14.151.205-.018 0-.035-.034-.052-.05l-.156-.155a9.422 9.422 0 0 1-2.605-6.833V1.512h4.003ZM321.249 13.453h1.484c3.624 0 5.453-1.4 5.453-4.202 0-2.717-1.881-4.066-5.626-4.066h-1.294v8.268h-.017Zm0 3.656-.035 11.43h-3.917V1.528h4.487c1.656-.051 3.33.085 4.952.427a6.602 6.602 0 0 1 2.986 1.743 7.523 7.523 0 0 1 2.261 5.569 7.124 7.124 0 0 1-2.416 5.706c-1.605 1.4-3.78 2.118-6.506 2.101h-1.812v.034ZM36.258 1.631h3.866v26.685h-3.866V1.63ZM54.344 13.573h1.26c3.745 0 5.608-1.418 5.608-4.254 0-2.665-1.812-3.998-5.453-3.98h-1.398v8.25l-.017-.016Zm4.918 2.972 6.506 11.89h-4.556L55.017 16.99h-.656V28.4H50.41V1.631h4.625c3.469 0 5.971.65 7.49 1.948a7.041 7.041 0 0 1 2.537 5.689 7.383 7.383 0 0 1-1.588 4.749 7.13 7.13 0 0 1-4.194 2.545l-.017-.017ZM78.142 14.99c-.138 5.296 4.09 9.704 9.457 9.84a9.72 9.72 0 0 0 7.076-2.784 9.515 9.515 0 0 0 2.83-6.953c.138-5.279-4.09-9.67-9.423-9.789a9.682 9.682 0 0 0-7.11 2.836 9.347 9.347 0 0 0-2.83 6.902V14.99Zm-3.97-.034a12.71 12.71 0 0 1 4.039-9.396 13.278 13.278 0 0 1 9.664-3.929 13.087 13.087 0 0 1 9.578 3.964 12.938 12.938 0 0 1 4.004 9.532 12.698 12.698 0 0 1-4.021 9.499c-5.177 5.04-13.41 5.227-18.81.444a12.73 12.73 0 0 1-4.453-10.114ZM159.649 18.322l-3.883-8.866-4.021 8.866h7.904Zm1.605 3.69h-11.148l-2.934 6.407h-4.263L155.853.64l12.459 27.795h-4.297l-2.761-6.424ZM130.346 28.418V8.926l-9.164 19.048-12.977-26.462h4.262l8.819 18.228 8.818-18.228h4.505v26.924l-4.263-.018ZM113.278 25.582c0 1.453-1.19 2.631-2.657 2.631s-2.658-1.178-2.658-2.63c0-1.453 1.191-2.631 2.658-2.631 1.467 0 2.657 1.178 2.657 2.63ZM22.28 28.418V8.858l-9.164 19.116L.104 1.426h4.28l8.8 18.28 8.837-18.297h4.504v27.026l-4.246-.017ZM5.298 25.685c.052-1.452-1.087-2.665-2.537-2.733C1.294 22.9.07 24.028 0 25.463a2.641 2.641 0 0 0 2.537 2.733 2.651 2.651 0 0 0 2.778-2.51h-.017ZM251.563 14.973c-.138 5.296 4.09 9.704 9.44 9.84a9.748 9.748 0 0 0 7.075-2.784 9.548 9.548 0 0 0 2.813-6.987c.138-5.279-4.09-9.67-9.422-9.806a9.643 9.643 0 0 0-7.093 2.836 9.35 9.35 0 0 0-2.831 6.902h.018Zm-3.969-.05c-.035-3.554 1.432-6.97 4.038-9.43a13.334 13.334 0 0 1 9.664-3.947 13 13 0 0 1 9.561 3.98 12.975 12.975 0 0 1 4.003 9.55 12.694 12.694 0 0 1-4.021 9.498c-5.16 5.057-13.391 5.245-18.793.428-2.986-2.563-4.47-5.928-4.47-10.097h.035l-.017.017Zm-19.432-1.35h1.294c3.797 0 5.695-1.452 5.695-4.34 0-2.716-1.847-4.065-5.54-4.065h-1.432v8.405h-.017Zm4.987 3.04 6.558 11.925h-4.642l-6.179-11.463h-.724v11.463h-4.039V1.409h4.712c3.52 0 6.04.65 7.61 1.965a7.196 7.196 0 0 1 2.589 5.808 7.553 7.553 0 0 1-1.622 4.835 7.322 7.322 0 0 1-4.263 2.597Z"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("small", {
                                children: [
                                    "\xa9 Maker Lab ",
                                    currentYear,
                                    ". All rights reserved."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                        className: "makerlab-footer-nav",
                        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("ul", {
                            children: menuList.fields.menuItem.map((item, index)=>{
                                var _item_fields_itemUrl;
                                return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("li", {
                                    children: ((_item_fields_itemUrl = item.fields.itemUrl) === null || _item_fields_itemUrl === void 0 ? void 0 : _item_fields_itemUrl.includes("http")) ? /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                                        href: item.fields.itemUrl,
                                        className: "roboto-regular",
                                        target: "_blank",
                                        children: item.fields.itemText
                                    }) : /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                        onClick: ()=>{
                                            lenis === null || lenis === void 0 ? void 0 : lenis.scrollTo(item.fields.itemUrl);
                                        },
                                        className: "roboto-regular",
                                        children: item.fields.itemText
                                    })
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("span", {
                        onClick: ()=>{
                            lenis === null || lenis === void 0 ? void 0 : lenis.scrollTo("#reel");
                        },
                        className: "makerlab-footer-backtotop",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("svg", {
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 32 19",
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m1 17.785 15.317-16 14.683 16",
                                    stroke: "#D5FD00",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            }),
                            "Back to top"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("svg", {
                className: "makerlab-logo makerlab-logo--desktop",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 163.87 22.84",
                children: [
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                        d: "M3.63 4.3c.15-.17.3-.35.46-.52 1.47-1.59 3.35-2.07 5.42-1.92 1.54.11 2.95.61 4.15 1.61.42.35.78.74 1.05 1.21.17.29.27.25.45 0 .97-1.39 2.28-2.3 3.96-2.63 2.29-.45 4.52-.31 6.57.91 1.94 1.16 2.89 2.98 3.26 5.15.13.76.17 1.52.17 2.29v10.83q0 .63-.63.63c-.86 0-1.71-.02-2.57 0-.41.01-.52-.14-.51-.53.01-3.42.02-6.84 0-10.26 0-.88-.09-1.76-.32-2.62-.59-2.2-2.27-3.39-4.77-3.15-1.37.13-2.5.62-3.18 1.88-.4.74-.57 1.54-.64 2.37-.16 1.77-.06 3.53-.07 5.3-.02 2.14-.01 4.29 0 6.43 0 .42-.1.6-.56.58-.87-.03-1.74-.03-2.61 0-.42.01-.55-.13-.55-.55.01-3.54 0-7.07 0-10.61 0-.86-.06-1.71-.3-2.54-.65-2.27-2.37-3.02-4.46-2.89-.48.03-.95.11-1.41.27-1.51.54-2.25 1.7-2.59 3.19-.18.77-.21 1.55-.2 2.33v10c0 .53-.27.79-.82.79-.8 0-1.6-.02-2.39 0-.42.05-.54-.11-.54-.52.01-2.48 0-4.95 0-7.43V2.98c0-.62.01-.62.64-.62h2.4c.34 0 .47.13.46.46-.02.47 0 .95 0 1.42.05.02.09.04.14.06ZM163.63 9.99c-.91-4.49-4.77-7.99-9.26-8.35-3.01-.24-5.59.63-7.58 2.97-.04.04-.07.1-.15.06-.08-.14-.04-.31-.04-.46-.01-1.23-.01-2.47 0-3.7 0-.36-.11-.52-.5-.51-.98.02-1.95.02-2.92 0-.34 0-.46.11-.46.45.02.84.01 1.69.01 2.52v18.66c0 .58 0 .59.58.59.91 0 1.83-.01 2.74 0 .35.01.49-.12.48-.48-.02-.75 0-1.5 0-2.34.11.1.14.13.17.16 2.22 2.6 5.11 3.46 8.41 3.05 2.4-.29 4.4-1.43 5.99-3.24 2.36-2.71 3.24-5.85 2.53-9.38ZM154.69 19c-.5.12-1 .16-1.33.16-3.63-.02-6.55-2.76-6.84-6.22-.24-2.75.71-4.97 2.93-6.58 3.03-2.19 7.02-1.41 9.26 1.74 2.84 3.99.72 9.75-4.02 10.9ZM52.35 1.82c-.94.02-1.88.02-2.82 0-.4-.01-.55.1-.53.51.03.72.01 1.43.01 2.25-.68-.87-1.37-1.57-2.23-2.09-1.66-.99-3.48-1.29-5.39-1.19-2.01.11-3.87.68-5.48 1.88-3.49 2.6-4.81 6.19-4.27 10.4.79 6.18 6.8 9.55 12.12 8.68 2.19-.35 3.92-1.44 5.25-3.28 0 .79.02 1.58-.01 2.37-.01.39.11.54.52.53.89-.02 1.8 0 2.69 0 .45-.01.67-.23.67-.68V4.37c0-.66-.01-1.33.01-2 0-.4-.1-.57-.54-.55Zm-9.49 16.99c-2.72.24-4.8-.88-6.29-3.09-2.3-3.41-1.1-8.2 2.5-10.13 3.65-1.95 8.85-.21 9.85 4.84.1.47.11.95.11 1.42.13 3.36-2.58 6.64-6.17 6.96ZM139.75 2.26c-.96.02-1.92.02-2.88 0-.39-.01-.5.15-.49.52.02.69 0 1.38 0 2.11-.09-.03-.11-.03-.12-.04l-.17-.2c-.88-1.06-1.94-1.87-3.24-2.35-1.59-.58-3.23-.69-4.89-.47-2.69.35-4.93 1.56-6.64 3.68-1.76 2.18-2.46 4.71-2.38 7.49.07 2.5.97 4.67 2.68 6.47 2.39 2.53 5.4 3.6 8.85 3.33 2.39-.18 4.36-1.21 5.74-3.24.03-.04.06-.11.17-.06 0 .78.01 1.57 0 2.37 0 .33.11.46.46.46.98-.02 1.97-.02 2.95 0 .38 0 .47-.15.47-.5-.01-6.35-.01-12.72 0-19.08 0-.38-.15-.49-.51-.49Zm-7.83 16.63c-4.15 1.53-8.23-1.25-8.98-5.2-.67-3.5 1.16-6.78 4.36-8.01.73-.28 1.5-.43 2.37-.41 3.48 0 6.27 2.56 6.73 6.12.42 3.2-1.47 6.38-4.48 7.5ZM86.61 10.02C85.46 3.46 78.76.21 73.22 2.17c-4.75 1.67-7.39 6.6-6.71 11.52.7 5.01 5.5 9.44 11.04 8.8 4.06-.48 6.81-2.7 8.45-6.38.14-.31.03-.38-.27-.38-.97 0-1.94.02-2.92 0-.36-.01-.57.1-.77.41-1.41 2.2-4.06 3.32-6.6 2.77-2.54-.55-4.11-2.19-5-4.56-.2-.52-.17-.57.39-.57h7.63c2.57 0 5.14 0 7.7.01.35 0 .52-.09.55-.48.11-1.1.09-2.2-.1-3.29Zm-4.52.77H70.87c-.44 0-.62-.21-.53-.64.51-2.49 2.69-4.54 5.25-4.95 3.19-.5 6.39 1.59 7.17 4.7.15.59-.07.89-.67.89ZM102.75 6.76v-3.6q0-.61.59-.62h2.61c.54 0 .57.02.57.56v6.47c.01 3.27 1.52 5.7 4.23 7.42 1.54.98 3.26 1.4 5.09 1.38h2.65c.37 0 .52.12.5.5-.02.9 0 1.8 0 2.69 0 .23-.04.4-.33.4-2.04-.03-4.1.19-6.11-.35-5-1.36-8.31-4.43-9.59-9.53-.27-1.09-.25-2.21-.24-3.33v-2ZM92.7 4.32c1.19-1.57 2.8-2.06 4.56-2.23.37-.04.51.07.5.47-.03.99-.02 1.97 0 2.96 0 .3-.09.43-.42.46-2.6.25-4.02 1.68-4.31 4.28-.05.44-.07.86-.07 1.3v10.08q0 .6-.61.6h-2.52c-.65 0-.65 0-.65-.64V3.03c0-.28.08-.43.4-.43.91.01 1.83.01 2.74 0 .31 0 .4.14.39.42-.01.39 0 .78 0 1.29Z"
                    }),
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                        d: "M65.31 21.97c-.61 0-1.22-.01-1.83 0-.3 0-.51-.09-.7-.33-2.42-3.15-4.85-6.29-7.28-9.43-.18-.23-.16-.39 0-.61 2.15-2.91 4.3-5.83 6.44-8.75.17-.24.38-.32.66-.32h3.44c.14 0 .32-.07.4.09.07.15-.09.26-.18.37-2.09 2.73-4.19 5.45-6.28 8.17-.46.61-.46.47 0 1.04l7.38 9.3c.09.12.29.23.19.4-.07.13-.27.06-.41.06h-1.83Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                className: "makerlab-footer-bottom",
                children: [
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("a", {
                        href: "https://www.linkedin.com/company/wearemakerlab/posts/?feedView=all",
                        target: "_blank",
                        className: "footer-linkedin",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("svg", {
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 31 32",
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("g", {
                                    clipPath: "url(#a)",
                                    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                        d: "M15.5.785C6.94.785 0 7.725 0 16.285c0 8.56 6.94 15.5 15.5 15.5 8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5ZM11.365 23.78H7.96V12.784h3.404v10.995ZM9.647 11.344a2.02 2.02 0 0 1-2.013-2.029 2.02 2.02 0 0 1 2.013-2.028 2.02 2.02 0 0 1 2.012 2.028 2.02 2.02 0 0 1-2.012 2.03ZM24.118 23.78h-3.387v-5.772c0-1.583-.601-2.466-1.853-2.466-1.362 0-2.073.92-2.073 2.466v5.772H13.54V12.784h3.265v1.48s.981-1.816 3.313-1.816c2.331 0 4 1.424 4 4.369v6.962Z",
                                        fill: "#D3D3D3"
                                    })
                                })
                            }),
                            "LinkedIn"
                        ]
                    }),
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                        className: "footer-links",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                                href: "https://www.miromagroup.com/privacy/",
                                target: "_blank",
                                children: "Privacy Notice"
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("a", {
                                href: footerData.fields.termsOfService.fields.file.url,
                                target: "_blank",
                                children: "Terms of service"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0315981ce3006dd3$export$2e2bcd8739ae039 = $0315981ce3006dd3$var$Footer;




var $dhiZh = parcelRequire("dhiZh");


var $100aaf8d1bb47840$exports = {};
"use strict";
Object.defineProperty($100aaf8d1bb47840$exports, "__esModule", {
    value: true
});

var $dhiZh = parcelRequire("dhiZh");
var $6faf709b2b132f24$var$t = function() {
    return $6faf709b2b132f24$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $6faf709b2b132f24$var$t.apply(this, arguments);
}, $6faf709b2b132f24$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.8.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $6faf709b2b132f24$var$t($6faf709b2b132f24$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


function $100aaf8d1bb47840$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $100aaf8d1bb47840$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $100aaf8d1bb47840$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $100aaf8d1bb47840$var$ownKeys(Object(t), !0).forEach(function(r) {
            $100aaf8d1bb47840$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $100aaf8d1bb47840$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $100aaf8d1bb47840$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $100aaf8d1bb47840$var$_toPropertyKey(t) {
    var i = $100aaf8d1bb47840$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $100aaf8d1bb47840$var$_defineProperty(obj, key, value) {
    key = $100aaf8d1bb47840$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $100aaf8d1bb47840$var$_extends() {
    $100aaf8d1bb47840$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $100aaf8d1bb47840$var$_extends.apply(this, arguments);
}
function $100aaf8d1bb47840$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $100aaf8d1bb47840$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $100aaf8d1bb47840$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $100aaf8d1bb47840$var$_slicedToArray(arr, i) {
    return $100aaf8d1bb47840$var$_arrayWithHoles(arr) || $100aaf8d1bb47840$var$_iterableToArrayLimit(arr, i) || $100aaf8d1bb47840$var$_unsupportedIterableToArray(arr, i) || $100aaf8d1bb47840$var$_nonIterableRest();
}
function $100aaf8d1bb47840$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $100aaf8d1bb47840$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $100aaf8d1bb47840$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $100aaf8d1bb47840$var$_arrayLikeToArray(o, minLen);
}
function $100aaf8d1bb47840$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $100aaf8d1bb47840$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */ var $100aaf8d1bb47840$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? $dhiZh.useLayoutEffect : $dhiZh.useEffect;
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */ function $100aaf8d1bb47840$var$useEventCallback(fn) {
    var ref = $dhiZh.useRef(fn);
    // we copy a ref to the callback scoped to the current state/props on each render
    $100aaf8d1bb47840$var$useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return $dhiZh.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
var $100aaf8d1bb47840$var$createCountUpInstance = function createCountUpInstance(el, props) {
    var decimal = props.decimal, decimals = props.decimals, duration = props.duration, easingFn = props.easingFn, end = props.end, formattingFn = props.formattingFn, numerals = props.numerals, prefix = props.prefix, separator = props.separator, start = props.start, suffix = props.suffix, useEasing = props.useEasing, useGrouping = props.useGrouping, useIndianSeparators = props.useIndianSeparators, enableScrollSpy = props.enableScrollSpy, scrollSpyDelay = props.scrollSpyDelay, scrollSpyOnce = props.scrollSpyOnce, plugin = props.plugin;
    return new $6faf709b2b132f24$export$1567cc001e3d0c1d(el, end, {
        startVal: start,
        duration: duration,
        decimal: decimal,
        decimalPlaces: decimals,
        easingFn: easingFn,
        formattingFn: formattingFn,
        numerals: numerals,
        separator: separator,
        prefix: prefix,
        suffix: suffix,
        plugin: plugin,
        useEasing: useEasing,
        useIndianSeparators: useIndianSeparators,
        useGrouping: useGrouping,
        enableScrollSpy: enableScrollSpy,
        scrollSpyDelay: scrollSpyDelay,
        scrollSpyOnce: scrollSpyOnce
    });
};
var $100aaf8d1bb47840$var$_excluded$1 = [
    "ref",
    "startOnMount",
    "enableReinitialize",
    "delay",
    "onEnd",
    "onStart",
    "onPauseResume",
    "onReset",
    "onUpdate"
];
var $100aaf8d1bb47840$var$DEFAULTS = {
    decimal: ".",
    separator: ",",
    delay: null,
    prefix: "",
    suffix: "",
    duration: 2,
    start: 0,
    decimals: 0,
    startOnMount: true,
    enableReinitialize: true,
    useEasing: true,
    useGrouping: true,
    useIndianSeparators: false
};
var $100aaf8d1bb47840$var$useCountUp = function useCountUp(props) {
    var filteredProps = Object.fromEntries(Object.entries(props).filter(function(_ref) {
        var _ref2 = $100aaf8d1bb47840$var$_slicedToArray(_ref, 2), value = _ref2[1];
        return value !== undefined;
    }));
    var _useMemo = $dhiZh.useMemo(function() {
        return $100aaf8d1bb47840$var$_objectSpread2($100aaf8d1bb47840$var$_objectSpread2({}, $100aaf8d1bb47840$var$DEFAULTS), filteredProps);
    }, [
        props
    ]), ref = _useMemo.ref, startOnMount = _useMemo.startOnMount, enableReinitialize = _useMemo.enableReinitialize, delay = _useMemo.delay, onEnd = _useMemo.onEnd, onStart = _useMemo.onStart, onPauseResume = _useMemo.onPauseResume, onReset = _useMemo.onReset, onUpdate = _useMemo.onUpdate, instanceProps = $100aaf8d1bb47840$var$_objectWithoutProperties(_useMemo, $100aaf8d1bb47840$var$_excluded$1);
    var countUpRef = $dhiZh.useRef();
    var timerRef = $dhiZh.useRef();
    var isInitializedRef = $dhiZh.useRef(false);
    var createInstance = $100aaf8d1bb47840$var$useEventCallback(function() {
        return $100aaf8d1bb47840$var$createCountUpInstance(typeof ref === "string" ? ref : ref.current, instanceProps);
    });
    var getCountUp = $100aaf8d1bb47840$var$useEventCallback(function(recreate) {
        var countUp = countUpRef.current;
        if (countUp && !recreate) return countUp;
        var newCountUp = createInstance();
        countUpRef.current = newCountUp;
        return newCountUp;
    });
    var start = $100aaf8d1bb47840$var$useEventCallback(function() {
        var run = function run() {
            return getCountUp(true).start(function() {
                onEnd === null || onEnd === void 0 || onEnd({
                    pauseResume: pauseResume,
                    reset: reset,
                    start: restart,
                    update: update
                });
            });
        };
        if (delay && delay > 0) timerRef.current = setTimeout(run, delay * 1000);
        else run();
        onStart === null || onStart === void 0 || onStart({
            pauseResume: pauseResume,
            reset: reset,
            update: update
        });
    });
    var pauseResume = $100aaf8d1bb47840$var$useEventCallback(function() {
        getCountUp().pauseResume();
        onPauseResume === null || onPauseResume === void 0 || onPauseResume({
            reset: reset,
            start: restart,
            update: update
        });
    });
    var reset = $100aaf8d1bb47840$var$useEventCallback(function() {
        // Quick fix for https://github.com/glennreyes/react-countup/issues/736 - should be investigated
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (getCountUp().el) {
            timerRef.current && clearTimeout(timerRef.current);
            getCountUp().reset();
            onReset === null || onReset === void 0 || onReset({
                pauseResume: pauseResume,
                start: restart,
                update: update
            });
        }
    });
    var update = $100aaf8d1bb47840$var$useEventCallback(function(newEnd) {
        getCountUp().update(newEnd);
        onUpdate === null || onUpdate === void 0 || onUpdate({
            pauseResume: pauseResume,
            reset: reset,
            start: restart
        });
    });
    var restart = $100aaf8d1bb47840$var$useEventCallback(function() {
        reset();
        start();
    });
    var maybeInitialize = $100aaf8d1bb47840$var$useEventCallback(function(shouldReset) {
        if (startOnMount) {
            if (shouldReset) reset();
            start();
        }
    });
    $dhiZh.useEffect(function() {
        if (!isInitializedRef.current) {
            isInitializedRef.current = true;
            maybeInitialize();
        } else if (enableReinitialize) maybeInitialize(true);
    }, [
        enableReinitialize,
        isInitializedRef,
        maybeInitialize,
        delay,
        props.start,
        props.suffix,
        props.prefix,
        props.duration,
        props.separator,
        props.decimals,
        props.decimal,
        props.formattingFn
    ]);
    $dhiZh.useEffect(function() {
        return function() {
            reset();
        };
    }, [
        reset
    ]);
    return {
        start: restart,
        pauseResume: pauseResume,
        reset: reset,
        update: update,
        getCountUp: getCountUp
    };
};
var $100aaf8d1bb47840$var$_excluded = [
    "className",
    "redraw",
    "containerProps",
    "children",
    "style"
];
var $100aaf8d1bb47840$var$CountUp = function CountUp(props) {
    var className = props.className, redraw = props.redraw, containerProps = props.containerProps, children = props.children, style = props.style, useCountUpProps = $100aaf8d1bb47840$var$_objectWithoutProperties(props, $100aaf8d1bb47840$var$_excluded);
    var containerRef = $dhiZh.useRef(null);
    var isInitializedRef = $dhiZh.useRef(false);
    var _useCountUp = $100aaf8d1bb47840$var$useCountUp($100aaf8d1bb47840$var$_objectSpread2($100aaf8d1bb47840$var$_objectSpread2({}, useCountUpProps), {}, {
        ref: containerRef,
        startOnMount: typeof children !== "function" || props.delay === 0,
        // component manually restarts
        enableReinitialize: false
    })), start = _useCountUp.start, reset = _useCountUp.reset, updateCountUp = _useCountUp.update, pauseResume = _useCountUp.pauseResume, getCountUp = _useCountUp.getCountUp;
    var restart = $100aaf8d1bb47840$var$useEventCallback(function() {
        start();
    });
    var update = $100aaf8d1bb47840$var$useEventCallback(function(end) {
        if (!props.preserveValue) reset();
        updateCountUp(end);
    });
    var initializeOnMount = $100aaf8d1bb47840$var$useEventCallback(function() {
        if (typeof props.children === "function") // Warn when user didn't use containerRef at all
        {
            if (!(containerRef.current instanceof Element)) {
                console.error('Couldn\'t find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.');
                return;
            }
        }
        // unlike the hook, the CountUp component initializes on mount
        getCountUp();
    });
    $dhiZh.useEffect(function() {
        initializeOnMount();
    }, [
        initializeOnMount
    ]);
    $dhiZh.useEffect(function() {
        if (isInitializedRef.current) update(props.end);
    }, [
        props.end,
        update
    ]);
    var redrawDependencies = redraw && props;
    // if props.redraw, call this effect on every props change
    $dhiZh.useEffect(function() {
        if (redraw && isInitializedRef.current) restart();
    }, [
        restart,
        redraw,
        redrawDependencies
    ]);
    // if not props.redraw, call this effect only when certain props are changed
    $dhiZh.useEffect(function() {
        if (!redraw && isInitializedRef.current) restart();
    }, [
        restart,
        redraw,
        props.start,
        props.suffix,
        props.prefix,
        props.duration,
        props.separator,
        props.decimals,
        props.decimal,
        props.className,
        props.formattingFn
    ]);
    $dhiZh.useEffect(function() {
        isInitializedRef.current = true;
    }, []);
    if (typeof children === "function") // TypeScript forces functional components to return JSX.Element | null.
    return children({
        countUpRef: containerRef,
        start: start,
        reset: reset,
        update: updateCountUp,
        pauseResume: pauseResume,
        getCountUp: getCountUp
    });
    return /*#__PURE__*/ $dhiZh.createElement("span", $100aaf8d1bb47840$var$_extends({
        className: className,
        ref: containerRef,
        style: style
    }, containerProps), typeof props.start !== "undefined" ? getCountUp().formattingFn(props.start) : "");
};
$100aaf8d1bb47840$exports.default = $100aaf8d1bb47840$var$CountUp;
$100aaf8d1bb47840$exports.useCountUp = $100aaf8d1bb47840$var$useCountUp;


var $9d552c44c761fe4b$exports = {};


(function webpackUniversalModuleDefinition(root, factory) {
    $9d552c44c761fe4b$exports = factory((parcelRequire("dhiZh")), (parcelRequire("b4Mpg")));
})($9d552c44c761fe4b$exports, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 4);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            var throwOnDirectAccess, ReactIs;
            // By explicitly using `prop-types` you are opting into new production behavior.
            // http://fb.me/prop-types-in-prod
            module1.exports = __webpack_require__(5)();
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__1__;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__2__;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            // Tell whether the rect is visible, given an offset
            //
            // return: boolean
            module1.exports = function(offset, rect, containmentRect) {
                var offsetDir = offset.direction;
                var offsetVal = offset.value; // Rules for checking different kind of offsets. In example if the element is
                // 90px below viewport and offsetTop is 100, it is considered visible.
                switch(offsetDir){
                    case "top":
                        return containmentRect.top + offsetVal < rect.top && containmentRect.bottom > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right;
                    case "left":
                        return containmentRect.left + offsetVal < rect.left && containmentRect.bottom > rect.bottom && containmentRect.top < rect.top && containmentRect.right > rect.right;
                    case "bottom":
                        return containmentRect.bottom - offsetVal > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right && containmentRect.top < rect.top;
                    case "right":
                        return containmentRect.right - offsetVal > rect.right && containmentRect.left < rect.left && containmentRect.top < rect.top && containmentRect.bottom > rect.bottom;
                }
            };
        /***/ },
        /* 4 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() {
                return VisibilitySensor;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
            /* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
            /* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__);
            function _typeof(obj) {
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function normalizeRect(rect) {
                if (rect.width === undefined) rect.width = rect.right - rect.left;
                if (rect.height === undefined) rect.height = rect.bottom - rect.top;
                return rect;
            }
            var VisibilitySensor = /*#__PURE__*/ function(_React$Component) {
                _inherits(VisibilitySensor, _React$Component);
                function VisibilitySensor(props) {
                    var _this;
                    _classCallCheck(this, VisibilitySensor);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(VisibilitySensor).call(this, props));
                    _defineProperty(_assertThisInitialized(_this), "getContainer", function() {
                        return _this.props.containment || window;
                    });
                    _defineProperty(_assertThisInitialized(_this), "addEventListener", function(target, event, delay, throttle) {
                        if (!_this.debounceCheck) _this.debounceCheck = {};
                        var timeout;
                        var func;
                        var later = function later() {
                            timeout = null;
                            _this.check();
                        };
                        if (throttle > -1) func = function func() {
                            if (!timeout) timeout = setTimeout(later, throttle || 0);
                        };
                        else func = function func() {
                            clearTimeout(timeout);
                            timeout = setTimeout(later, delay || 0);
                        };
                        var info = {
                            target: target,
                            fn: func,
                            getLastTimeout: function getLastTimeout() {
                                return timeout;
                            }
                        };
                        target.addEventListener(event, info.fn);
                        _this.debounceCheck[event] = info;
                    });
                    _defineProperty(_assertThisInitialized(_this), "startWatching", function() {
                        if (_this.debounceCheck || _this.interval) return;
                        if (_this.props.intervalCheck) _this.interval = setInterval(_this.check, _this.props.intervalDelay);
                        if (_this.props.scrollCheck) _this.addEventListener(_this.getContainer(), "scroll", _this.props.scrollDelay, _this.props.scrollThrottle);
                        if (_this.props.resizeCheck) _this.addEventListener(window, "resize", _this.props.resizeDelay, _this.props.resizeThrottle);
                         // if dont need delayed call, check on load ( before the first interval fires )
                        !_this.props.delayedCall && _this.check();
                    });
                    _defineProperty(_assertThisInitialized(_this), "stopWatching", function() {
                        if (_this.debounceCheck) {
                            // clean up event listeners and their debounce callers
                            for(var debounceEvent in _this.debounceCheck)if (_this.debounceCheck.hasOwnProperty(debounceEvent)) {
                                var debounceInfo = _this.debounceCheck[debounceEvent];
                                clearTimeout(debounceInfo.getLastTimeout());
                                debounceInfo.target.removeEventListener(debounceEvent, debounceInfo.fn);
                                _this.debounceCheck[debounceEvent] = null;
                            }
                        }
                        _this.debounceCheck = null;
                        if (_this.interval) _this.interval = clearInterval(_this.interval);
                    });
                    _defineProperty(_assertThisInitialized(_this), "check", function() {
                        var el = _this.node;
                        var rect;
                        var containmentRect; // if the component has rendered to null, dont update visibility
                        if (!el) return _this.state;
                        rect = normalizeRect(_this.roundRectDown(el.getBoundingClientRect()));
                        if (_this.props.containment) {
                            var containmentDOMRect = _this.props.containment.getBoundingClientRect();
                            containmentRect = {
                                top: containmentDOMRect.top,
                                left: containmentDOMRect.left,
                                bottom: containmentDOMRect.bottom,
                                right: containmentDOMRect.right
                            };
                        } else containmentRect = {
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight || document.documentElement.clientHeight,
                            right: window.innerWidth || document.documentElement.clientWidth
                        };
                         // Check if visibility is wanted via offset?
                        var offset = _this.props.offset || {};
                        var hasValidOffset = _typeof(offset) === "object";
                        if (hasValidOffset) {
                            containmentRect.top += offset.top || 0;
                            containmentRect.left += offset.left || 0;
                            containmentRect.bottom -= offset.bottom || 0;
                            containmentRect.right -= offset.right || 0;
                        }
                        var visibilityRect = {
                            top: rect.top >= containmentRect.top,
                            left: rect.left >= containmentRect.left,
                            bottom: rect.bottom <= containmentRect.bottom,
                            right: rect.right <= containmentRect.right
                        }; // https://github.com/joshwnj/react-visibility-sensor/pull/114
                        var hasSize = rect.height > 0 && rect.width > 0;
                        var isVisible = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right; // check for partial visibility
                        if (hasSize && _this.props.partialVisibility) {
                            var partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left; // account for partial visibility on a single edge
                            if (typeof _this.props.partialVisibility === "string") partialVisible = visibilityRect[_this.props.partialVisibility];
                             // if we have minimum top visibility set by props, lets check, if it meets the passed value
                            // so if for instance element is at least 200px in viewport, then show it.
                            isVisible = _this.props.minTopValue ? partialVisible && rect.top <= containmentRect.bottom - _this.props.minTopValue : partialVisible;
                        } // Deprecated options for calculating offset.
                        if (typeof offset.direction === "string" && typeof offset.value === "number") {
                            console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", offset.direction, offset.value);
                            isVisible = _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default()(offset, rect, containmentRect);
                        }
                        var state = _this.state; // notify the parent when the value changes
                        if (_this.state.isVisible !== isVisible) {
                            state = {
                                isVisible: isVisible,
                                visibilityRect: visibilityRect
                            };
                            _this.setState(state);
                            if (_this.props.onChange) _this.props.onChange(isVisible);
                        }
                        return state;
                    });
                    _this.state = {
                        isVisible: null,
                        visibilityRect: {}
                    };
                    return _this;
                }
                _createClass(VisibilitySensor, [
                    {
                        key: "componentDidMount",
                        value: function componentDidMount() {
                            this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);
                            if (this.props.active) this.startWatching();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            this.stopWatching();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function componentDidUpdate(prevProps) {
                            // re-register node in componentDidUpdate if children diffs [#103]
                            this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);
                            if (this.props.active && !prevProps.active) {
                                this.setState({
                                    isVisible: null,
                                    visibilityRect: {}
                                });
                                this.startWatching();
                            } else if (!this.props.active) this.stopWatching();
                        }
                    },
                    {
                        key: "roundRectDown",
                        value: function roundRectDown(rect) {
                            return {
                                top: Math.floor(rect.top),
                                left: Math.floor(rect.left),
                                bottom: Math.floor(rect.bottom),
                                right: Math.floor(rect.right)
                            };
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            if (this.props.children instanceof Function) return this.props.children({
                                isVisible: this.state.isVisible,
                                visibilityRect: this.state.visibilityRect
                            });
                            return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(this.props.children);
                        }
                    }
                ]);
                return VisibilitySensor;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _defineProperty(VisibilitySensor, "defaultProps", {
                active: true,
                partialVisibility: false,
                minTopValue: 0,
                scrollCheck: false,
                scrollDelay: 250,
                scrollThrottle: -1,
                resizeCheck: false,
                resizeDelay: 250,
                resizeThrottle: -1,
                intervalCheck: true,
                intervalDelay: 100,
                delayedCall: false,
                offset: {},
                containment: null,
                children: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null)
            });
            _defineProperty(VisibilitySensor, "propTypes", {
                onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
                active: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                partialVisibility: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([
                        "top",
                        "right",
                        "bottom",
                        "left"
                    ])
                ]),
                delayedCall: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                offset: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
                        top: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                        left: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                        bottom: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                        right: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
                    }),
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
                        direction: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([
                            "top",
                            "right",
                            "bottom",
                            "left"
                        ]),
                        value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
                    })
                ]),
                scrollCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                scrollDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                scrollThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                resizeCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                resizeDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                resizeThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                intervalCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                containment: typeof window !== "undefined" ? prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(window.Element) : prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
                children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.element,
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func
                ]),
                minTopValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
            });
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = __webpack_require__(6);
            function emptyFunction() {}
            function emptyFunctionWithReset() {}
            emptyFunctionWithReset.resetWarningCache = emptyFunction;
            module1.exports = function() {
                function shim(props, propName, componentName, location, propFullName, secret) {
                    if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                    return;
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                }
                shim.isRequired = shim;
                function getShim() {
                    return shim;
                }
                // Important!
                // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
                var ReactPropTypes = {
                    array: shim,
                    bool: shim,
                    func: shim,
                    number: shim,
                    object: shim,
                    string: shim,
                    symbol: shim,
                    any: shim,
                    arrayOf: getShim,
                    element: shim,
                    elementType: shim,
                    instanceOf: getShim,
                    node: shim,
                    objectOf: getShim,
                    oneOf: getShim,
                    oneOfType: getShim,
                    shape: getShim,
                    exact: getShim,
                    checkPropTypes: emptyFunctionWithReset,
                    resetWarningCache: emptyFunction
                };
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            module1.exports = ReactPropTypesSecret;
        /***/ }
    ]);
});





function $2941d5494daa997e$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}



function $76d44f33f5bacac8$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}





const $e1159cff4d669686$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $9917bdf3c851b19a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $4eb40b3f84ead7c9$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $35c10bd5ca3e7200$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $35c10bd5ca3e7200$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $35c10bd5ca3e7200$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $35c10bd5ca3e7200$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $13556512a6b18d3d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $35c10bd5ca3e7200$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $a900be932221b872$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $a900be932221b872$export$1405a65085f40b9 = [
    "initial",
    ...$a900be932221b872$export$16e45afcc206d3a8
];





/**
 * Generate a list of every possible transform key.
 */ const $3426faf2300f9708$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $3426faf2300f9708$export$7b42a0094fb00b6e = new Set($3426faf2300f9708$export$280dc01950909d86);




/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $4cb119001e9619f2$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $4cb119001e9619f2$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $4cb119001e9619f2$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $4cb119001e9619f2$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $4cb119001e9619f2$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $4cb119001e9619f2$var$keyframesTransition;
    else if ((0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $4cb119001e9619f2$var$criticallyDampedSpring(keyframes[1]) : $4cb119001e9619f2$var$underDampedSpring;
    return $4cb119001e9619f2$var$ease;
};


function $59fbf04090be2906$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}


const $98ba7f8a276ed8b6$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


const $326903cf40995d63$export$888a3d84909f9e3d = {
    current: false
};


const $bc93dcad6e052de2$var$isNotNull = (value)=>value !== null;
function $bc93dcad6e052de2$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($bc93dcad6e052de2$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


const $07a0e4e0a0c5ffd5$export$8793edee2d425525 = (any)=>any;



function $4aec1b91f8009e25$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $754ad0a158adc4dd$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $754ad0a158adc4dd$var$maxElapsed = 40;
function $754ad0a158adc4dd$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $754ad0a158adc4dd$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $4aec1b91f8009e25$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $98ba7f8a276ed8b6$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $754ad0a158adc4dd$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $754ad0a158adc4dd$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $754ad0a158adc4dd$export$71ecace0a033b35a.length; i++)steps[$754ad0a158adc4dd$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $0021ce5a851bb8fe$export$2cef06c20297c17d, cancel: $0021ce5a851bb8fe$export$ec99c0ef4978dccb, state: $0021ce5a851bb8fe$export$fff89137e9e818ce, steps: $0021ce5a851bb8fe$export$1811c3a7e3af92f0 } = (0, $754ad0a158adc4dd$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525), true);






/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $f2e3cbc9f77e5f50$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $f2e3cbc9f77e5f50$var$subdivisionPrecision = 0.0000001;
const $f2e3cbc9f77e5f50$var$subdivisionMaxIterations = 12;
function $f2e3cbc9f77e5f50$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $f2e3cbc9f77e5f50$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $f2e3cbc9f77e5f50$var$subdivisionPrecision && ++i < $f2e3cbc9f77e5f50$var$subdivisionMaxIterations);
    return currentT;
}
function $f2e3cbc9f77e5f50$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $07a0e4e0a0c5ffd5$export$8793edee2d425525;
    const getTForX = (aX)=>$f2e3cbc9f77e5f50$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $f2e3cbc9f77e5f50$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $5ff3ab69aa7f23e7$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $d1cf2f320f998abc$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $21de1078a51e8b1a$export$77edfce482316a60 = /*@__PURE__*/ (0, $f2e3cbc9f77e5f50$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $21de1078a51e8b1a$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $d1cf2f320f998abc$export$2c07eeff45156d4d)($21de1078a51e8b1a$export$77edfce482316a60);
const $21de1078a51e8b1a$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $5ff3ab69aa7f23e7$export$f946554fb8aeaf0d)($21de1078a51e8b1a$export$b01116c84cdfe1a2);


const $19e67d28fd3493b7$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $21de1078a51e8b1a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $c592d6b6e1630f41$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $c592d6b6e1630f41$export$c8d67a19199d1a50 = (0, $d1cf2f320f998abc$export$2c07eeff45156d4d)($c592d6b6e1630f41$export$e444123e42d03385);
const $c592d6b6e1630f41$export$30d3455eee55bed5 = (0, $5ff3ab69aa7f23e7$export$f946554fb8aeaf0d)($c592d6b6e1630f41$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $e1f673da0d9109f5$export$ade84c85e44a6cb1 = (v)=>RegExp("^0[^.\\s]+$", "u").test(v);


function $0caefbca022a839f$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $e1f673da0d9109f5$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $0bf56566d0420529$export$491112666e282270 = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
let $0bf56566d0420529$export$f5708dca728d7177 = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
var $0bf56566d0420529$var$check, $0bf56566d0420529$var$message, $0bf56566d0420529$var$check1, $0bf56566d0420529$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $164d72162e74bc62$export$65583ed5a868f2d9 = (v)=>RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);


const $d82567b698546f16$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $d82567b698546f16$export$9de1236619d9e756 = /*@__PURE__*/ $d82567b698546f16$var$checkStringStartsWith("--");
const $d82567b698546f16$var$startsAsVariableToken = /*@__PURE__*/ $d82567b698546f16$var$checkStringStartsWith("var(--");
const $d82567b698546f16$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $d82567b698546f16$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $d82567b698546f16$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $d82567b698546f16$var$singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $15ef5d87f7b68d08$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function $15ef5d87f7b68d08$export$b9f0c1f373aee2b0(current) {
    const match = $15ef5d87f7b68d08$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $15ef5d87f7b68d08$var$maxDepth = 4;
function $15ef5d87f7b68d08$export$289398774300c991(current, element, depth = 1) {
    (0, $0bf56566d0420529$export$f5708dca728d7177)(depth <= $15ef5d87f7b68d08$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $15ef5d87f7b68d08$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $164d72162e74bc62$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $d82567b698546f16$export$31f9caa2600b5723)(fallback) ? $15ef5d87f7b68d08$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






const $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $8edaab95c0e1c156$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $8edaab95c0e1c156$export$58f0f39f63f3cf42 = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, $8edaab95c0e1c156$export$98e628dec113755e), {
    transform: (v)=>(0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)(0, 1, v)
});
const $8edaab95c0e1c156$export$dcdf75081b88279d = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, $8edaab95c0e1c156$export$98e628dec113755e), {
    default: 1
});




const $466b351ccb90577e$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $466b351ccb90577e$export$41fc368e1a942b97 = /*@__PURE__*/ $466b351ccb90577e$var$createUnitType("deg");
const $466b351ccb90577e$export$626336c2cd4b14de = /*@__PURE__*/ $466b351ccb90577e$var$createUnitType("%");
const $466b351ccb90577e$export$91c0eda1d06bf008 = /*@__PURE__*/ $466b351ccb90577e$var$createUnitType("px");
const $466b351ccb90577e$export$f91e8c45a95a32f2 = /*@__PURE__*/ $466b351ccb90577e$var$createUnitType("vh");
const $466b351ccb90577e$export$aed3d7b7d206c196 = /*@__PURE__*/ $466b351ccb90577e$var$createUnitType("vw");
const $466b351ccb90577e$export$44e2e1705876d7ed = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, $466b351ccb90577e$export$626336c2cd4b14de), {
    parse: (v)=>$466b351ccb90577e$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$466b351ccb90577e$export$626336c2cd4b14de.transform(v * 100)
});


const $4539b0e8c8492ad2$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $4539b0e8c8492ad2$export$8e5250d1aa9bf370 = (v)=>v === (0, $8edaab95c0e1c156$export$98e628dec113755e) || v === (0, $466b351ccb90577e$export$91c0eda1d06bf008);
const $4539b0e8c8492ad2$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $4539b0e8c8492ad2$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(RegExp("^matrix3d\\((.+)\\)$", "u"));
        if (matrix3d) return $4539b0e8c8492ad2$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(RegExp("^matrix\\((.+)\\)$", "u"));
            if (matrix) return $4539b0e8c8492ad2$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $4539b0e8c8492ad2$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $4539b0e8c8492ad2$var$nonTranslationalTransformKeys = (0, $3426faf2300f9708$export$280dc01950909d86).filter((key)=>!$4539b0e8c8492ad2$var$transformKeys.has(key));
function $4539b0e8c8492ad2$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $4539b0e8c8492ad2$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $4539b0e8c8492ad2$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $4539b0e8c8492ad2$var$getTranslateFromMatrix(4, 13),
    y: $4539b0e8c8492ad2$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$4539b0e8c8492ad2$export$781d46a8aa670d52.translateX = $4539b0e8c8492ad2$export$781d46a8aa670d52.x;
$4539b0e8c8492ad2$export$781d46a8aa670d52.translateY = $4539b0e8c8492ad2$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $af3300fd8199fc98$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $0f69d9d384224fd5$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $29391efaf924774d$export$d176691c1998a1f5 = [
    (0, $8edaab95c0e1c156$export$98e628dec113755e),
    (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    (0, $466b351ccb90577e$export$626336c2cd4b14de),
    (0, $466b351ccb90577e$export$41fc368e1a942b97),
    (0, $466b351ccb90577e$export$aed3d7b7d206c196),
    (0, $466b351ccb90577e$export$f91e8c45a95a32f2),
    (0, $0f69d9d384224fd5$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $29391efaf924774d$export$eefdd52e3ccae428 = (v)=>$29391efaf924774d$export$d176691c1998a1f5.find((0, $af3300fd8199fc98$export$6eae4d0a6a7ca7cd)(v));




const $17b7e623b4b7cd35$var$toResolve = new Set();
let $17b7e623b4b7cd35$var$isScheduled = false;
let $17b7e623b4b7cd35$var$anyNeedsMeasurement = false;
function $17b7e623b4b7cd35$var$measureAllKeyframes() {
    if ($17b7e623b4b7cd35$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($17b7e623b4b7cd35$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $4539b0e8c8492ad2$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $17b7e623b4b7cd35$var$anyNeedsMeasurement = false;
    $17b7e623b4b7cd35$var$isScheduled = false;
    $17b7e623b4b7cd35$var$toResolve.forEach((resolver)=>resolver.complete());
    $17b7e623b4b7cd35$var$toResolve.clear();
}
function $17b7e623b4b7cd35$var$readAllKeyframes() {
    $17b7e623b4b7cd35$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $17b7e623b4b7cd35$var$anyNeedsMeasurement = true;
    });
}
function $17b7e623b4b7cd35$export$78b96d2a12593b05() {
    $17b7e623b4b7cd35$var$readAllKeyframes();
    $17b7e623b4b7cd35$var$measureAllKeyframes();
}
class $17b7e623b4b7cd35$export$74d34ca3182f1750 {
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $17b7e623b4b7cd35$var$toResolve.add(this);
            if (!$17b7e623b4b7cd35$var$isScheduled) {
                $17b7e623b4b7cd35$var$isScheduled = true;
                (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).read($17b7e623b4b7cd35$var$readAllKeyframes);
                (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).resolveKeyframes($17b7e623b4b7cd35$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $17b7e623b4b7cd35$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $17b7e623b4b7cd35$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
}






// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $8d8ab2a78180931e$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $5b83819a9c38cd92$export$2444ca58c08448e4 = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");


function $ae3e11e927a43169$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $9dfc755d7b7869f4$export$ed808ff6ecd39e8d = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $4434a5047125d20c$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $9dfc755d7b7869f4$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $ae3e11e927a43169$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $4434a5047125d20c$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $5b83819a9c38cd92$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $66837bffde226b94$var$clampRgbUnit = (v)=>(0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)(0, 255, v);
const $66837bffde226b94$export$7a99c86b5b1f4c9e = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $8edaab95c0e1c156$export$98e628dec113755e)), {
    transform: (v)=>Math.round($66837bffde226b94$var$clampRgbUnit(v))
});
const $66837bffde226b94$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $4434a5047125d20c$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $4434a5047125d20c$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $66837bffde226b94$export$7a99c86b5b1f4c9e.transform(red) + ", " + $66837bffde226b94$export$7a99c86b5b1f4c9e.transform(green) + ", " + $66837bffde226b94$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $8d8ab2a78180931e$export$83d2e9e3e4ee39ed)((0, $8edaab95c0e1c156$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $78af0d5c09147b9d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $78af0d5c09147b9d$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $4434a5047125d20c$export$2c8400d58aca05e)("#"),
    parse: $78af0d5c09147b9d$var$parseHex,
    transform: (0, $66837bffde226b94$export$4e46ac54fc82cf3b).transform
};






const $0febb5ba8a17fe15$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $4434a5047125d20c$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $4434a5047125d20c$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $466b351ccb90577e$export$626336c2cd4b14de).transform((0, $8d8ab2a78180931e$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $466b351ccb90577e$export$626336c2cd4b14de).transform((0, $8d8ab2a78180931e$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $8d8ab2a78180931e$export$83d2e9e3e4ee39ed)((0, $8edaab95c0e1c156$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d4307911857d9fd9$export$35e9368ef982300f = {
    test: (v)=>(0, $66837bffde226b94$export$4e46ac54fc82cf3b).test(v) || (0, $78af0d5c09147b9d$export$834dfc94dde4b3d8).test(v) || (0, $0febb5ba8a17fe15$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $66837bffde226b94$export$4e46ac54fc82cf3b).test(v)) return (0, $66837bffde226b94$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $0febb5ba8a17fe15$export$810b04175080204c).test(v)) return (0, $0febb5ba8a17fe15$export$810b04175080204c).parse(v);
        else return (0, $78af0d5c09147b9d$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $66837bffde226b94$export$4e46ac54fc82cf3b).transform(v) : (0, $0febb5ba8a17fe15$export$810b04175080204c).transform(v);
    }
};


const $8889a37e396d51c5$export$740b69c5fad25dba = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");




function $c83dae9c221f4080$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $5b83819a9c38cd92$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $8889a37e396d51c5$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $c83dae9c221f4080$var$NUMBER_TOKEN = "number";
const $c83dae9c221f4080$var$COLOR_TOKEN = "color";
const $c83dae9c221f4080$var$VAR_TOKEN = "var";
const $c83dae9c221f4080$var$VAR_FUNCTION_TOKEN = "var(";
const $c83dae9c221f4080$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $c83dae9c221f4080$var$complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function $c83dae9c221f4080$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($c83dae9c221f4080$var$complexRegex, (parsedValue)=>{
        if ((0, $d4307911857d9fd9$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($c83dae9c221f4080$var$COLOR_TOKEN);
            values.push((0, $d4307911857d9fd9$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($c83dae9c221f4080$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($c83dae9c221f4080$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($c83dae9c221f4080$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $c83dae9c221f4080$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($c83dae9c221f4080$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $c83dae9c221f4080$var$parseComplexValue(v) {
    return $c83dae9c221f4080$export$b61fc7c44bf646d5(v).values;
}
function $c83dae9c221f4080$var$createTransformer(source) {
    const { split: split, types: types } = $c83dae9c221f4080$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $c83dae9c221f4080$var$NUMBER_TOKEN) output += (0, $8d8ab2a78180931e$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $c83dae9c221f4080$var$COLOR_TOKEN) output += (0, $d4307911857d9fd9$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $c83dae9c221f4080$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $c83dae9c221f4080$var$getAnimatableNone(v) {
    const parsed = $c83dae9c221f4080$var$parseComplexValue(v);
    const transformer = $c83dae9c221f4080$var$createTransformer(v);
    return transformer(parsed.map($c83dae9c221f4080$var$convertNumbersToZero));
}
const $c83dae9c221f4080$export$83a0e34f1302825b = {
    test: $c83dae9c221f4080$var$test,
    parse: $c83dae9c221f4080$var$parseComplexValue,
    createTransformer: $c83dae9c221f4080$var$createTransformer,
    getAnimatableNone: $c83dae9c221f4080$var$getAnimatableNone
};







/**
 * Properties that should default to 1 or 100%
 */ const $bf2e652540760c1c$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $bf2e652540760c1c$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $5b83819a9c38cd92$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $bf2e652540760c1c$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $bf2e652540760c1c$var$functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
const $bf2e652540760c1c$export$3dea766d36a8935f = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $c83dae9c221f4080$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($bf2e652540760c1c$var$functionRegex);
        return functions ? functions.map($bf2e652540760c1c$var$applyDefaultFilter).join(" ") : v;
    }
});











const $2f90ac88e1857457$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderTopWidth: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderRightWidth: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderRadius: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    radius: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    maxWidth: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    height: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    maxHeight: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    top: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    right: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    bottom: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    left: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    paddingTop: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    paddingRight: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    paddingBottom: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    paddingLeft: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    margin: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    marginTop: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    marginRight: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    marginBottom: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    marginLeft: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $466b351ccb90577e$export$91c0eda1d06bf008)
};




const $246c888152624f78$export$f2e4285fee37e26 = {
    rotate: (0, $466b351ccb90577e$export$41fc368e1a942b97),
    rotateX: (0, $466b351ccb90577e$export$41fc368e1a942b97),
    rotateY: (0, $466b351ccb90577e$export$41fc368e1a942b97),
    rotateZ: (0, $466b351ccb90577e$export$41fc368e1a942b97),
    scale: $8edaab95c0e1c156$export$dcdf75081b88279d,
    scaleX: (0, $8edaab95c0e1c156$export$dcdf75081b88279d),
    scaleY: (0, $8edaab95c0e1c156$export$dcdf75081b88279d),
    scaleZ: (0, $8edaab95c0e1c156$export$dcdf75081b88279d),
    skew: (0, $466b351ccb90577e$export$41fc368e1a942b97),
    skewX: (0, $466b351ccb90577e$export$41fc368e1a942b97),
    skewY: (0, $466b351ccb90577e$export$41fc368e1a942b97),
    distance: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    translateX: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    translateY: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    translateZ: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    x: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    y: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    z: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    perspective: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    transformPerspective: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    opacity: (0, $8edaab95c0e1c156$export$58f0f39f63f3cf42),
    originX: (0, $466b351ccb90577e$export$44e2e1705876d7ed),
    originY: (0, $466b351ccb90577e$export$44e2e1705876d7ed),
    originZ: (0, $466b351ccb90577e$export$91c0eda1d06bf008)
};





const $297d8862b82d975e$export$7d260a2a5f8bc19e = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $8edaab95c0e1c156$export$98e628dec113755e)), {
    transform: Math.round
});


const $72850fda29c9ffae$export$eec14432cd1cb67b = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $2f90ac88e1857457$export$2fb74b0a4e7d7c4a), (0, $246c888152624f78$export$f2e4285fee37e26)), {
    zIndex: (0, $297d8862b82d975e$export$7d260a2a5f8bc19e),
    size: (0, $466b351ccb90577e$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $8edaab95c0e1c156$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $8edaab95c0e1c156$export$58f0f39f63f3cf42),
    numOctaves: (0, $297d8862b82d975e$export$7d260a2a5f8bc19e)
});


/**
 * A map of default value types for common values
 */ const $ce5ddd2901c6c02a$export$98cd7c72c5a731fb = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $72850fda29c9ffae$export$eec14432cd1cb67b)), {
    color: // Color props
    $d4307911857d9fd9$export$35e9368ef982300f,
    backgroundColor: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    outlineColor: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    fill: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    stroke: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    borderTopColor: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    borderRightColor: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    borderBottomColor: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    borderLeftColor: (0, $d4307911857d9fd9$export$35e9368ef982300f),
    filter: $bf2e652540760c1c$export$3dea766d36a8935f,
    WebkitFilter: (0, $bf2e652540760c1c$export$3dea766d36a8935f)
});
/**
 * Gets the default ValueType for the provided value key
 */ const $ce5ddd2901c6c02a$export$67d1babe0338d23b = (key)=>$ce5ddd2901c6c02a$export$98cd7c72c5a731fb[key];


function $2da3ae4237fff8f0$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $ce5ddd2901c6c02a$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $bf2e652540760c1c$export$3dea766d36a8935f)) defaultValueType = (0, $c83dae9c221f4080$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $969a7a65a92fd145$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $969a7a65a92fd145$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$969a7a65a92fd145$var$invalidTemplates.has(keyframe) && (0, $c83dae9c221f4080$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $2da3ae4237fff8f0$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $e73b51d260ff45a8$export$4983792d11b61017 extends (0, $17b7e623b4b7cd35$export$74d34ca3182f1750) {
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $d82567b698546f16$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $15ef5d87f7b68d08$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $4539b0e8c8492ad2$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $29391efaf924774d$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $29391efaf924774d$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $4539b0e8c8492ad2$export$8e5250d1aa9bf370)(originType) && (0, $4539b0e8c8492ad2$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $0caefbca022a839f$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $969a7a65a92fd145$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $4539b0e8c8492ad2$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $4539b0e8c8492ad2$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
}




function $3300ab4946b7a42d$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}






let $b5695bf0b45e0558$var$now;
function $b5695bf0b45e0558$var$clearTime() {
    $b5695bf0b45e0558$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $b5695bf0b45e0558$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($b5695bf0b45e0558$var$now === undefined) $b5695bf0b45e0558$export$2da9be4cfdb689b1.set((0, $0021ce5a851bb8fe$export$fff89137e9e818ce).isProcessing || (0, $98ba7f8a276ed8b6$export$dd826089e3c5e502).useManualTiming ? (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).timestamp : performance.now());
        return $b5695bf0b45e0558$var$now;
    },
    set: (newTime)=>{
        $b5695bf0b45e0558$var$now = newTime;
        queueMicrotask($b5695bf0b45e0558$var$clearTime);
    }
};







/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $85d672e1cd233870$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $c83dae9c221f4080$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $d6eb740cffc6425a$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $d6eb740cffc6425a$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $85d672e1cd233870$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $85d672e1cd233870$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $0bf56566d0420529$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $d6eb740cffc6425a$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $3300ab4946b7a42d$export$6ab7812f1bac68be)(type)) && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $7ee5533cc61687dd$var$MAX_RESOLVE_DELAY = 40;
class $7ee5533cc61687dd$export$d1e4f34b9c2550c1 {
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $7ee5533cc61687dd$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $17b7e623b4b7cd35$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $d6eb740cffc6425a$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $326903cf40995d63$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $bc93dcad6e052de2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = (0, $53825fa7fd9c8174$export$71511d61b312f219)({
            keyframes: keyframes,
            finalKeyframe: finalKeyframe
        }, resolvedAnimation);
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
    constructor(_param){
        var { autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop" } = _param, options = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType"
        ]);
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
        this.options = (0, $53825fa7fd9c8174$export$71511d61b312f219)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType
        }, options);
        this.updateFinishedPromise();
    }
}









/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $25a71bc41668433f$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $36b3de1e104586a1$var$velocitySampleDuration = 5; // ms
function $36b3de1e104586a1$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $36b3de1e104586a1$var$velocitySampleDuration, 0);
    return (0, $25a71bc41668433f$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $675cf862135ba907$var$safeMin = 0.001;
const $675cf862135ba907$export$a3cdb76e84ee608e = 0.01;
const $675cf862135ba907$export$1824b851fad8862b = 10.0;
const $675cf862135ba907$export$ff08f2d53484465 = 0.05;
const $675cf862135ba907$export$201ca48e54038115 = 1;
function $675cf862135ba907$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $0bf56566d0420529$export$491112666e282270)(duration <= (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)($675cf862135ba907$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)($675cf862135ba907$export$ff08f2d53484465, $675cf862135ba907$export$201ca48e54038115, dampingRatio);
    duration = (0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)($675cf862135ba907$export$a3cdb76e84ee608e, $675cf862135ba907$export$1824b851fad8862b, (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $675cf862135ba907$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $675cf862135ba907$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $675cf862135ba907$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $675cf862135ba907$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$675cf862135ba907$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $675cf862135ba907$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $675cf862135ba907$var$rootIterations = 12;
function $675cf862135ba907$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $675cf862135ba907$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $675cf862135ba907$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $b80c8a023cf6a8b1$var$durationKeys = [
    "duration",
    "bounce"
];
const $b80c8a023cf6a8b1$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $b80c8a023cf6a8b1$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $b80c8a023cf6a8b1$var$getSpringOptions(options) {
    let springOptions = (0, $53825fa7fd9c8174$export$71511d61b312f219)({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$b80c8a023cf6a8b1$var$isSpringType(options, $b80c8a023cf6a8b1$var$physicsKeys) && $b80c8a023cf6a8b1$var$isSpringType(options, $b80c8a023cf6a8b1$var$durationKeys)) {
        const derived = (0, $675cf862135ba907$export$b15f158dc6d6f458)(options);
        springOptions = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, springOptions, derived), {
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $b80c8a023cf6a8b1$export$b36281d89752ae66(_param) {
    var { keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed } = _param, options = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "keyframes",
        "restDelta",
        "restSpeed"
    ]);
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $b80c8a023cf6a8b1$var$getSpringOptions((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, options), {
        velocity: -(0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(options.velocity || 0)
    }));
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $675cf862135ba907$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $36b3de1e104586a1$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $f269b9ed7d0bb260$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $b80c8a023cf6a8b1$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $36b3de1e104586a1$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $13eb63cdbcdc1634$export$929e5a82286172a6 = /*@__PURE__*/ (0, $f2e3cbc9f77e5f50$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $13eb63cdbcdc1634$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $f2e3cbc9f77e5f50$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $13eb63cdbcdc1634$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $f2e3cbc9f77e5f50$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $ac1e65c2d99a509f$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};









const $ff3e059d6f7b4693$var$easingLookup = {
    linear: (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525),
    easeIn: $13eb63cdbcdc1634$export$929e5a82286172a6,
    easeInOut: $13eb63cdbcdc1634$export$c07234257a03d5e9,
    easeOut: $13eb63cdbcdc1634$export$57636bb43b1ccbb0,
    circIn: $c592d6b6e1630f41$export$e444123e42d03385,
    circInOut: $c592d6b6e1630f41$export$30d3455eee55bed5,
    circOut: $c592d6b6e1630f41$export$c8d67a19199d1a50,
    backIn: $21de1078a51e8b1a$export$b01116c84cdfe1a2,
    backInOut: $21de1078a51e8b1a$export$ddc5fd596f6c71b2,
    backOut: $21de1078a51e8b1a$export$77edfce482316a60,
    anticipate: $19e67d28fd3493b7$export$6b0af63b873d419e
};
const $ff3e059d6f7b4693$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $0bf56566d0420529$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $f2e3cbc9f77e5f50$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $0bf56566d0420529$export$f5708dca728d7177)($ff3e059d6f7b4693$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $ff3e059d6f7b4693$var$easingLookup[definition];
    }
    return definition;
};




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $58b815715a40cea1$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $58b815715a40cea1$export$a4627e546088548d = (...transformers)=>transformers.reduce($58b815715a40cea1$var$combineFunctions);


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $5e0ab4a000bd2f6a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};




/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};





// Adapted from https://gist.github.com/mjackson/5311256
function $7c58070ca55b2c9a$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $7c58070ca55b2c9a$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $7c58070ca55b2c9a$var$hueToRgb(p, q, hue + 1 / 3);
        green = $7c58070ca55b2c9a$var$hueToRgb(p, q, hue);
        blue = $7c58070ca55b2c9a$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $4876cf5addee1682$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $ca36e75709b47d7d$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $ca36e75709b47d7d$var$colorTypes = [
    (0, $78af0d5c09147b9d$export$834dfc94dde4b3d8),
    (0, $66837bffde226b94$export$4e46ac54fc82cf3b),
    (0, $0febb5ba8a17fe15$export$810b04175080204c)
];
const $ca36e75709b47d7d$var$getColorType = (v)=>$ca36e75709b47d7d$var$colorTypes.find((type)=>type.test(v));
function $ca36e75709b47d7d$var$asRGBA(color) {
    const type = $ca36e75709b47d7d$var$getColorType(color);
    (0, $0bf56566d0420529$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $0febb5ba8a17fe15$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $7c58070ca55b2c9a$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $ca36e75709b47d7d$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $ca36e75709b47d7d$var$asRGBA(from);
    const toRGBA = $ca36e75709b47d7d$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $4876cf5addee1682$export$a6f92d4bae65c0f1)(from, to);
    const blended = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, fromRGBA);
    return (v)=>{
        blended.red = $ca36e75709b47d7d$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $ca36e75709b47d7d$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $ca36e75709b47d7d$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $66837bffde226b94$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $daadd54a505ea8a6$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $daadd54a505ea8a6$export$fed62ccc3fb1a568(origin, target) {
    if ($daadd54a505ea8a6$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $9a2fb305a16644e0$var$mixNumber(a, b) {
    return (p)=>(0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $9a2fb305a16644e0$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $9a2fb305a16644e0$var$mixNumber;
    else if (typeof a === "string") return (0, $d82567b698546f16$export$31f9caa2600b5723)(a) ? (0, $4876cf5addee1682$export$a6f92d4bae65c0f1) : (0, $d4307911857d9fd9$export$35e9368ef982300f).test(a) ? (0, $ca36e75709b47d7d$export$51e568cf5c039bac) : $9a2fb305a16644e0$export$65516310a87d8205;
    else if (Array.isArray(a)) return $9a2fb305a16644e0$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $d4307911857d9fd9$export$35e9368ef982300f).test(a) ? (0, $ca36e75709b47d7d$export$51e568cf5c039bac) : $9a2fb305a16644e0$export$ebc23b6840c51ba1;
    return 0, $4876cf5addee1682$export$a6f92d4bae65c0f1;
}
function $9a2fb305a16644e0$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$9a2fb305a16644e0$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $9a2fb305a16644e0$export$ebc23b6840c51ba1(a, b) {
    const output = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, a, b);
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $9a2fb305a16644e0$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $9a2fb305a16644e0$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $9a2fb305a16644e0$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $c83dae9c221f4080$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $c83dae9c221f4080$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $c83dae9c221f4080$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $daadd54a505ea8a6$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $daadd54a505ea8a6$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $daadd54a505ea8a6$export$fed62ccc3fb1a568)(origin, target);
        return (0, $58b815715a40cea1$export$a4627e546088548d)($9a2fb305a16644e0$export$3bbefa2f402845c4($9a2fb305a16644e0$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $0bf56566d0420529$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $4876cf5addee1682$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $cb557f622417bf0e$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $9a2fb305a16644e0$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $647a982091808df3$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $cb557f622417bf0e$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525) : ease;
            mixer = (0, $58b815715a40cea1$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $647a982091808df3$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $0bf56566d0420529$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $647a982091808df3$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $5e0ab4a000bd2f6a$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a6ae9ab879477057$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $5e0ab4a000bd2f6a$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $41aab01038871732$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a6ae9ab879477057$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $18cac768810758ec$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $ea4533f43161763c$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $13eb63cdbcdc1634$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $ea4533f43161763c$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $ac1e65c2d99a509f$export$216948827bbdc797)(ease) ? ease.map((0, $ff3e059d6f7b4693$export$ef97fe084f156ca4)) : (0, $ff3e059d6f7b4693$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $18cac768810758ec$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $41aab01038871732$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $647a982091808df3$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $ea4533f43161763c$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $f6c6d5975cab2048$export$f4ff70a5b4808fd8 = 20000;
function $f6c6d5975cab2048$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $f6c6d5975cab2048$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $f6c6d5975cab2048$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $d94044b3e9896441$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $0021ce5a851bb8fe$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $0021ce5a851bb8fe$export$fff89137e9e818ce).isProcessing ? (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).timestamp : (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now()
    };
};




const $4531cdfa5a358436$var$generators = {
    decay: (0, $f269b9ed7d0bb260$export$ee3ff3a17106998),
    inertia: $f269b9ed7d0bb260$export$ee3ff3a17106998,
    tween: (0, $ea4533f43161763c$export$d25ddfdf17c3ad3e),
    keyframes: (0, $ea4533f43161763c$export$d25ddfdf17c3ad3e),
    spring: $b80c8a023cf6a8b1$export$b36281d89752ae66
};
const $4531cdfa5a358436$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $4531cdfa5a358436$export$fd98d9cca67a58bc extends (0, $7ee5533cc61687dd$export$d1e4f34b9c2550c1) {
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $3300ab4946b7a42d$export$6ab7812f1bac68be)(type) ? type : $4531cdfa5a358436$var$generators[type] || (0, $ea4533f43161763c$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $ea4533f43161763c$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $58b815715a40cea1$export$a4627e546088548d)($4531cdfa5a358436$var$percentToProgress, (0, $cb557f622417bf0e$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, this.options), {
            keyframes: keyframes$1
        }));
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, this.options), {
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        }));
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $f6c6d5975cab2048$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $bc93dcad6e052de2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $d94044b3e9896441$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $17b7e623b4b7cd35$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
}
// Legacy interface
function $4531cdfa5a358436$export$ee9b76de7353d815(options) {
    return new $4531cdfa5a358436$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $f007c280c22fba8a$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);


const $ce92dec0d3bf6c61$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



// Create a linear easing point for every 10 ms
const $7f778a8f0cb7b13f$var$resolution = 10;
const $7f778a8f0cb7b13f$export$66d3851e2b1ec912 = (easing, duration // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / $7f778a8f0cb7b13f$var$resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $5e0ab4a000bd2f6a$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


function $7967534fc4875ae4$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $3446b95d0b2b2fd6$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $d0601a67e29f295e$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $7967534fc4875ae4$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $3446b95d0b2b2fd6$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $bf0dc57bcec30fea$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $d0601a67e29f295e$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


function $40b10c73dc38ae92$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $bf0dc57bcec30fea$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $40b10c73dc38ae92$export$2cf569f5e2221176 || (0, $bf0dc57bcec30fea$export$866c1d07a1ac2ab)()) || (0, $ce92dec0d3bf6c61$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($40b10c73dc38ae92$export$fcdd8f3f2160beda));
}
const $40b10c73dc38ae92$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $40b10c73dc38ae92$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $40b10c73dc38ae92$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $40b10c73dc38ae92$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $40b10c73dc38ae92$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $40b10c73dc38ae92$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $40b10c73dc38ae92$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $bf0dc57bcec30fea$export$866c1d07a1ac2ab)()) return (0, $7f778a8f0cb7b13f$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $ce92dec0d3bf6c61$export$ff43f99925d7366b)(easing)) return $40b10c73dc38ae92$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$40b10c73dc38ae92$export$916ea73bcd3a6030(segmentEasing, duration) || $40b10c73dc38ae92$export$2cf569f5e2221176.easeOut);
    else return $40b10c73dc38ae92$export$2cf569f5e2221176[easing];
}


function $fff3087c71ace913$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $40b10c73dc38ae92$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $582c4fc582b329fe$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}





const $e98aed5fb079e992$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $7967534fc4875ae4$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $83aad8c61b7fbdb1$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $83aad8c61b7fbdb1$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $83aad8c61b7fbdb1$var$requiresPregeneratedKeyframes(options) {
    return (0, $3300ab4946b7a42d$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $40b10c73dc38ae92$export$fcdd8f3f2160beda)(options.ease);
}
function $83aad8c61b7fbdb1$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $4531cdfa5a358436$export$fd98d9cca67a58bc)((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, options), {
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    }));
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $83aad8c61b7fbdb1$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $83aad8c61b7fbdb1$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $83aad8c61b7fbdb1$var$sampleDelta,
        ease: "linear"
    };
}
const $83aad8c61b7fbdb1$var$unsupportedEasingFunctions = {
    anticipate: $19e67d28fd3493b7$export$6b0af63b873d419e,
    backInOut: $21de1078a51e8b1a$export$ddc5fd596f6c71b2,
    circInOut: $c592d6b6e1630f41$export$30d3455eee55bed5
};
function $83aad8c61b7fbdb1$var$isUnsupportedEase(key) {
    return key in $83aad8c61b7fbdb1$var$unsupportedEasingFunctions;
}
class $83aad8c61b7fbdb1$export$2a45abb4e6513325 extends (0, $7ee5533cc61687dd$export$d1e4f34b9c2550c1) {
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $bf0dc57bcec30fea$export$866c1d07a1ac2ab)() && $83aad8c61b7fbdb1$var$isUnsupportedEase(ease)) ease = $83aad8c61b7fbdb1$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($83aad8c61b7fbdb1$var$requiresPregeneratedKeyframes(this.options)) {
            const _this_options = this.options, { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element } = _this_options, options = (0, $710949f8d1eb100c$export$71511d61b312f219)(_this_options, [
                "onComplete",
                "onUpdate",
                "motionValue",
                "element"
            ]);
            const pregeneratedAnimation = $83aad8c61b7fbdb1$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $fff3087c71ace913$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, this.options), {
            duration: duration,
            times: times,
            ease: ease
        }));
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $582c4fc582b329fe$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $bc93dcad6e052de2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $07a0e4e0a0c5ffd5$export$8793edee2d425525;
            const { animation: animation } = resolved;
            (0, $582c4fc582b329fe$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $07a0e4e0a0c5ffd5$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const _this_options = this.options, { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element } = _this_options, options = (0, $710949f8d1eb100c$export$71511d61b312f219)(_this_options, [
                "motionValue",
                "onUpdate",
                "onComplete",
                "element"
            ]);
            const sampleAnimation = new (0, $4531cdfa5a358436$export$fd98d9cca67a58bc)((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, options), {
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            }));
            const sampleTime = (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $83aad8c61b7fbdb1$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $83aad8c61b7fbdb1$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return (0, $e98aed5fb079e992$export$51ea9b46fb7a8c5d)() && name && (0, $f007c280c22fba8a$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $e73b51d260ff45a8$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
}




const $7153c13baced5bba$export$20d68f04f30763a5 = (0, $7967534fc4875ae4$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $e01ab984f5b88657$export$c1e41718f71efe41 {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $7153c13baced5bba$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ 
function $741f34451e7d00b4$export$ca8e47dc8ed5a9d7(_param) {
    var { when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed } = _param, transition = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from",
        "elapsed"
    ]);
    return !!Object.keys(transition).length;
}


const $b10c3a9e3a6e4437$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $59fbf04090be2906$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(delay);
        let options = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $741f34451e7d00b4$export$ca8e47dc8ed5a9d7)(valueTransition)) options = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, options, (0, $4cb119001e9619f2$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $326903cf40995d63$export$888a3d84909f9e3d).current || (0, $98ba7f8a276ed8b6$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $bc93dcad6e052de2$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $e01ab984f5b88657$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $83aad8c61b7fbdb1$export$2a45abb4e6513325).supports(options)) return new (0, $83aad8c61b7fbdb1$export$2a45abb4e6513325)(options);
        else return new (0, $4531cdfa5a358436$export$fd98d9cca67a58bc)(options);
    };





const $b799a260239c0954$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $b799a260239c0954$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $e1159cff4d669686$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $4669f7fb2b05c17b$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $4669f7fb2b05c17b$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $4669f7fb2b05c17b$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ee537df6d44e221d$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $4669f7fb2b05c17b$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $4669f7fb2b05c17b$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $cbf8219c4cd22b55$var$MAX_VELOCITY_DELTA = 30;
const $cbf8219c4cd22b55$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $cbf8219c4cd22b55$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $cbf8219c4cd22b55$export$8cea36d14ee64562 {
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $cbf8219c4cd22b55$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ee537df6d44e221d$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($cbf8219c4cd22b55$export$67fcd818a264039d.current) $cbf8219c4cd22b55$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $cbf8219c4cd22b55$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $cbf8219c4cd22b55$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $25a71bc41668433f$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.9.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
}
function $cbf8219c4cd22b55$export$ce8bdc721e76545f(init, options) {
    return new $cbf8219c4cd22b55$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $c4f7aaa144c018a3$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $cbf8219c4cd22b55$export$ce8bdc721e76545f)(value));
}
function $c4f7aaa144c018a3$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $13556512a6b18d3d$export$7b1b1c981f4f0558)(visualElement, definition);
    let _ref = resolved || {}, { transitionEnd: transitionEnd = {}, transition: transition = {} } = _ref, target = (0, $710949f8d1eb100c$export$71511d61b312f219)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, target, transitionEnd);
    for(const key in target){
        const value = (0, $b799a260239c0954$export$5485128c47bd48bb)(target[key]);
        $c4f7aaa144c018a3$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $dda5bbc784b11029$export$9fd24a634729c672 = (str)=>str.replace(RegExp("([a-z])([A-Z])", "gu"), "$1-$2").toLowerCase();


const $432344e8f5b4d433$export$ed7b8fa9dbf0105d = "framerAppearId";
const $432344e8f5b4d433$export$8592e1c077c890a6 = "data-" + (0, $dda5bbc784b11029$export$9fd24a634729c672)($432344e8f5b4d433$export$ed7b8fa9dbf0105d);


function $bec36e612dcd20ca$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $432344e8f5b4d433$export$8592e1c077c890a6];
}






function $7e218ab9ae002793$export$b3f9dd865b560c6(name) {
    if ((0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(name)) return "transform";
    else if ((0, $f007c280c22fba8a$export$a27eefbd8fb5e404).has(name)) return (0, $dda5bbc784b11029$export$9fd24a634729c672)(name);
}



class $dc185db66dd3fd2e$export$3fe5fa490af65f85 extends (0, $cbf8219c4cd22b55$export$8cea36d14ee64562) {
    add(name) {
        const styleName = (0, $7e218ab9ae002793$export$b3f9dd865b560c6)(name);
        if (styleName) {
            (0, $4669f7fb2b05c17b$export$20e507e47fae79fd)(this.values, styleName);
            this.update();
        }
    }
    update() {
        this.set(this.values.length ? this.values.join(", ") : "auto");
    }
    constructor(){
        super(...arguments);
        this.values = [];
    }
}


const $ca6e4b7e54f70d9e$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $aa75991a689e45f4$export$98397f3adbf6259f(value) {
    return Boolean((0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(value) && value.add);
}


function $a1ce770227994aac$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $dc185db66dd3fd2e$export$3fe5fa490af65f85)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $aa75991a689e45f4$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $fa2a94ae17af3e06$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $fa2a94ae17af3e06$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd } = targetAndTransition, target = (0, $710949f8d1eb100c$export$71511d61b312f219)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $fa2a94ae17af3e06$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = (0, $53825fa7fd9c8174$export$71511d61b312f219)({
            delay: delay
        }, (0, $59fbf04090be2906$export$7c1391340308742e)(transition || {}, key));
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $bec36e612dcd20ca$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $0021ce5a851bb8fe$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $a1ce770227994aac$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $b10c3a9e3a6e4437$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $c4f7aaa144c018a3$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}






function $ef19c9704daeeaac$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $13556512a6b18d3d$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $fa2a94ae17af3e06$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $ef19c9704daeeaac$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $ef19c9704daeeaac$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($ef19c9704daeeaac$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($ef19c9704daeeaac$export$4709dc300705b2af(child, variant, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $ef19c9704daeeaac$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $b30f67fd15b6931a$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $ef19c9704daeeaac$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $ef19c9704daeeaac$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $13556512a6b18d3d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $fa2a94ae17af3e06$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




const $1e8801e54f316dea$var$numVariantProps = (0, $a900be932221b872$export$1405a65085f40b9).length;
function $1e8801e54f316dea$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $1e8801e54f316dea$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $1e8801e54f316dea$var$numVariantProps; i++){
        const name = (0, $a900be932221b872$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $4eb40b3f84ead7c9$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}


const $fa12ea461bd95ced$var$reversePriorityOrder = [
    ...(0, $a900be932221b872$export$16e45afcc206d3a8)
].reverse();
const $fa12ea461bd95ced$var$numAnimationTypes = (0, $a900be932221b872$export$16e45afcc206d3a8).length;
function $fa12ea461bd95ced$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $b30f67fd15b6931a$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $fa12ea461bd95ced$export$bb53502b7a672aa8(visualElement) {
    let animate = $fa12ea461bd95ced$var$animateList(visualElement);
    let state = $fa12ea461bd95ced$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $13556512a6b18d3d$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd } = resolved, target = (0, $710949f8d1eb100c$export$71511d61b312f219)(resolved, [
                    "transition",
                    "transitionEnd"
                ]);
                acc = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, acc, target, transitionEnd);
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $1e8801e54f316dea$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $fa12ea461bd95ced$var$numAnimationTypes; i++){
            const type = $fa12ea461bd95ced$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $4eb40b3f84ead7c9$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $76d44f33f5bacac8$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $fa12ea461bd95ced$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, prevResolvedValues, resolvedValues);
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $e1159cff4d669686$export$9153ad4c4999f4a0)(next) && (0, $e1159cff4d669686$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $9917bdf3c851b19a$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, encounteredKeys, resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $fa12ea461bd95ced$var$createState();
            isInitialRender = true;
        }
    };
}
function $fa12ea461bd95ced$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $9917bdf3c851b19a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $fa12ea461bd95ced$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $fa12ea461bd95ced$var$createState() {
    return {
        animate: $fa12ea461bd95ced$var$createTypeState(true),
        whileInView: $fa12ea461bd95ced$var$createTypeState(),
        whileHover: $fa12ea461bd95ced$var$createTypeState(),
        whileTap: $fa12ea461bd95ced$var$createTypeState(),
        whileDrag: $fa12ea461bd95ced$var$createTypeState(),
        whileFocus: $fa12ea461bd95ced$var$createTypeState(),
        exit: $fa12ea461bd95ced$var$createTypeState()
    };
}


class $f8d83fc4e5c8b78a$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}


class $df530d43bded6212$export$b45b3fe5caabdca extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $76d44f33f5bacac8$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $fa12ea461bd95ced$export$bb53502b7a672aa8)(node));
    }
}



let $5899595ea5bb547d$var$id = 0;
class $5899595ea5bb547d$export$4989d1eb6104cc6c extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $5899595ea5bb547d$var$id++;
    }
}


const $420f9c3dfd569a1b$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $df530d43bded6212$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $5899595ea5bb547d$export$4989d1eb6104cc6c)
    }
};









const $df0eac9ed1be7bfc$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $1c3d95765b20c334$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $1c3d95765b20c334$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $df0eac9ed1be7bfc$export$a4cf9c8a4b063a6e)(event) && handler(event, $1c3d95765b20c334$export$12f84bb882d06e1a(event));
};



function $169f17ed058fff3a$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $63f463dff945fade$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $169f17ed058fff3a$export$b1d829ddf82884aa)(target, eventName, (0, $1c3d95765b20c334$export$c404e80f92c98d29)(handler), options);
}



const $1ea6aa63de7cbf6e$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $1ea6aa63de7cbf6e$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $1ea6aa63de7cbf6e$export$9f17032d917177de(a.x, b.x);
    const yDelta = $1ea6aa63de7cbf6e$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $7e33e14632a6acd6$export$d9c66232c9c4689c {
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $7e33e14632a6acd6$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $1ea6aa63de7cbf6e$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $0021ce5a851bb8fe$export$fff89137e9e818ce);
            this.history.push((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            }));
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $7e33e14632a6acd6$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $7e33e14632a6acd6$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $7e33e14632a6acd6$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $df0eac9ed1be7bfc$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $1c3d95765b20c334$export$12f84bb882d06e1a)(event);
        const initialInfo = $7e33e14632a6acd6$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $0021ce5a851bb8fe$export$fff89137e9e818ce);
        this.history = [
            (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            })
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $7e33e14632a6acd6$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $58b815715a40cea1$export$a4627e546088548d)((0, $63f463dff945fade$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $63f463dff945fade$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $63f463dff945fade$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
}
function $7e33e14632a6acd6$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $7e33e14632a6acd6$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $7e33e14632a6acd6$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $7e33e14632a6acd6$var$subtractPoint(point, $7e33e14632a6acd6$var$lastDevicePoint(history)),
        offset: $7e33e14632a6acd6$var$subtractPoint(point, $7e33e14632a6acd6$var$startDevicePoint(history)),
        velocity: $7e33e14632a6acd6$var$getVelocity(history, 0.1)
    };
}
function $7e33e14632a6acd6$var$startDevicePoint(history) {
    return history[0];
}
function $7e33e14632a6acd6$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $7e33e14632a6acd6$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $7e33e14632a6acd6$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $4e9af06dc94b7b6b$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $4e9af06dc94b7b6b$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $fbf6985c7c3ad332$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $fbf6985c7c3ad332$var$globalHorizontalLock = $fbf6985c7c3ad332$export$518c5fc2dcb7974b("dragHorizontal");
const $fbf6985c7c3ad332$var$globalVerticalLock = $fbf6985c7c3ad332$export$518c5fc2dcb7974b("dragVertical");
function $fbf6985c7c3ad332$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $fbf6985c7c3ad332$var$globalVerticalLock();
    else if (drag === "x") lock = $fbf6985c7c3ad332$var$globalHorizontalLock();
    else {
        const openHorizontal = $fbf6985c7c3ad332$var$globalHorizontalLock();
        const openVertical = $fbf6985c7c3ad332$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $fbf6985c7c3ad332$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $fbf6985c7c3ad332$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $f1b0b38fbe6c3a7c$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $0cf765b3f0b01e1a$var$SCALE_PRECISION = 0.0001;
const $0cf765b3f0b01e1a$var$SCALE_MIN = 1 - $0cf765b3f0b01e1a$var$SCALE_PRECISION;
const $0cf765b3f0b01e1a$var$SCALE_MAX = 1 + $0cf765b3f0b01e1a$var$SCALE_PRECISION;
const $0cf765b3f0b01e1a$var$TRANSLATE_PRECISION = 0.01;
const $0cf765b3f0b01e1a$var$TRANSLATE_MIN = 0 - $0cf765b3f0b01e1a$var$TRANSLATE_PRECISION;
const $0cf765b3f0b01e1a$var$TRANSLATE_MAX = 0 + $0cf765b3f0b01e1a$var$TRANSLATE_PRECISION;
function $0cf765b3f0b01e1a$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $0cf765b3f0b01e1a$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $0cf765b3f0b01e1a$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $0cf765b3f0b01e1a$export$c1c127004b72a37(target) / $0cf765b3f0b01e1a$export$c1c127004b72a37(source);
    delta.translate = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $0cf765b3f0b01e1a$var$SCALE_MIN && delta.scale <= $0cf765b3f0b01e1a$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $0cf765b3f0b01e1a$var$TRANSLATE_MIN && delta.translate <= $0cf765b3f0b01e1a$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $0cf765b3f0b01e1a$export$c0d25e96fc67d310(delta, source, target, origin) {
    $0cf765b3f0b01e1a$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $0cf765b3f0b01e1a$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $0cf765b3f0b01e1a$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $0cf765b3f0b01e1a$export$c1c127004b72a37(relative);
}
function $0cf765b3f0b01e1a$export$426154f9d100f99(target, relative, parent) {
    $0cf765b3f0b01e1a$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $0cf765b3f0b01e1a$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $0cf765b3f0b01e1a$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $0cf765b3f0b01e1a$export$c1c127004b72a37(layout);
}
function $0cf765b3f0b01e1a$export$2785bfcc929c5650(target, layout, parent) {
    $0cf765b3f0b01e1a$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $0cf765b3f0b01e1a$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $57b5994992ae20b6$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $57b5994992ae20b6$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $57b5994992ae20b6$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $57b5994992ae20b6$export$690c180aa5775042(layoutBox.x, left, right),
        y: $57b5994992ae20b6$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $57b5994992ae20b6$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $57b5994992ae20b6$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $57b5994992ae20b6$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $57b5994992ae20b6$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $57b5994992ae20b6$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(source);
    const targetLength = (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $5e0ab4a000bd2f6a$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $5e0ab4a000bd2f6a$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $57b5994992ae20b6$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $57b5994992ae20b6$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $57b5994992ae20b6$export$7c5eaef8f4723d22(dragElastic = $57b5994992ae20b6$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $57b5994992ae20b6$export$a3366d3bac43a742;
    return {
        x: $57b5994992ae20b6$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $57b5994992ae20b6$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $57b5994992ae20b6$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $57b5994992ae20b6$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $57b5994992ae20b6$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $57b5994992ae20b6$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $88298c1cbb5b129a$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $88298c1cbb5b129a$export$3d227df54007d73a = ()=>({
        x: $88298c1cbb5b129a$export$ff25708b37f72782(),
        y: $88298c1cbb5b129a$export$ff25708b37f72782()
    });
const $88298c1cbb5b129a$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $88298c1cbb5b129a$export$6459fc9e86be362e = ()=>({
        x: $88298c1cbb5b129a$export$6db76765312617ac(),
        y: $88298c1cbb5b129a$export$6db76765312617ac()
    });


function $83b6561adb7561f3$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $bc8b8fad2a17fc1a$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $bc8b8fad2a17fc1a$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $bc8b8fad2a17fc1a$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $dd4c041ed9016899$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $dd4c041ed9016899$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$dd4c041ed9016899$var$isIdentityScale(scale) || !$dd4c041ed9016899$var$isIdentityScale(scaleX) || !$dd4c041ed9016899$var$isIdentityScale(scaleY);
}
function $dd4c041ed9016899$export$a545127cf1fbb600(values) {
    return $dd4c041ed9016899$export$bdf30dca883ea463(values) || $dd4c041ed9016899$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $dd4c041ed9016899$export$bf80f5f8f4dc327f(values) {
    return $dd4c041ed9016899$var$is2DTranslate(values.x) || $dd4c041ed9016899$var$is2DTranslate(values.y);
}
function $dd4c041ed9016899$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $51d3283d6981f76e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $51d3283d6981f76e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $51d3283d6981f76e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $51d3283d6981f76e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $51d3283d6981f76e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $51d3283d6981f76e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $51d3283d6981f76e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $51d3283d6981f76e$export$d80074982803af5c(box, { x: x, y: y }) {
    $51d3283d6981f76e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $51d3283d6981f76e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $51d3283d6981f76e$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $51d3283d6981f76e$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $51d3283d6981f76e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $51d3283d6981f76e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $51d3283d6981f76e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $dd4c041ed9016899$export$a545127cf1fbb600)(node.latestValues)) $51d3283d6981f76e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $51d3283d6981f76e$var$TREE_SCALE_SNAP_MAX && treeScale.x > $51d3283d6981f76e$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $51d3283d6981f76e$var$TREE_SCALE_SNAP_MAX && treeScale.y > $51d3283d6981f76e$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $51d3283d6981f76e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $51d3283d6981f76e$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $51d3283d6981f76e$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $51d3283d6981f76e$export$58b16271041fbfb(box, transform) {
    $51d3283d6981f76e$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $51d3283d6981f76e$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $c20b0ffa70c85eeb$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $bc8b8fad2a17fc1a$export$d3955c6a8f65a36b)((0, $bc8b8fad2a17fc1a$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $c20b0ffa70c85eeb$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $c20b0ffa70c85eeb$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $51d3283d6981f76e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $51d3283d6981f76e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $73e64f6883f59bc5$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $ef1e96b73aa191bd$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $ef1e96b73aa191bd$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $1c3d95765b20c334$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $fbf6985c7c3ad332$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $466b351ccb90577e$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $a1ce770227994aac$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $ef1e96b73aa191bd$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $7e33e14632a6acd6$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $73e64f6883f59bc5$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$ef1e96b73aa191bd$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $57b5994992ae20b6$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $f1b0b38fbe6c3a7c$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $57b5994992ae20b6$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $57b5994992ae20b6$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $57b5994992ae20b6$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $f1b0b38fbe6c3a7c$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $0bf56566d0420529$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $c20b0ffa70c85eeb$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $57b5994992ae20b6$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $bc8b8fad2a17fc1a$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $bc8b8fad2a17fc1a$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            if (!$ef1e96b73aa191bd$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = (0, $53825fa7fd9c8174$export$71511d61b312f219)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition, transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $a1ce770227994aac$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $b10c3a9e3a6e4437$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$ef1e96b73aa191bd$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $f1b0b38fbe6c3a7c$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $57b5994992ae20b6$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            if (!$ef1e96b73aa191bd$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $ef1e96b73aa191bd$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $63f463dff945fade$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $f1b0b38fbe6c3a7c$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $169f17ed058fff3a$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $57b5994992ae20b6$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    }
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
}
function $ef1e96b73aa191bd$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $ef1e96b73aa191bd$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $6510d698ce81b10f$export$5d97dc2872682820 extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
        this.removeListeners = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
        this.controls = new (0, $ef1e96b73aa191bd$export$86bff71f18910307)(node);
    }
}








const $f1b82d4471e6080d$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $f1b82d4471e6080d$export$b4f8f1ee75ce5859 extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $7e33e14632a6acd6$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $73e64f6883f59bc5$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $f1b82d4471e6080d$var$asyncHandler(onPanSessionStart),
            onStart: $f1b82d4471e6080d$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $63f463dff945fade$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
    }
}






var $dhiZh = parcelRequire("dhiZh");

var $dhiZh = parcelRequire("dhiZh");

var $dhiZh = parcelRequire("dhiZh");
"use client";
/**
 * @public
 */ const $82d6504736c5d906$export$f224e4635b6f8ce2 = (0, $dhiZh.createContext)(null);


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $6308545ef5332ea8$export$2a8c16d82a0a0e26() {
    const context = (0, $dhiZh.useContext)((0, $82d6504736c5d906$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $dhiZh.useId)();
    (0, $dhiZh.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $dhiZh.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $6308545ef5332ea8$export$8249053f690ea39a() {
    return $6308545ef5332ea8$export$ee27c052bca048fb((0, $dhiZh.useContext)((0, $82d6504736c5d906$export$f224e4635b6f8ce2)));
}
function $6308545ef5332ea8$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $dhiZh = parcelRequire("dhiZh");
"use client";
const $fb43a55f154d4e51$export$a3579ca508007a95 = (0, $dhiZh.createContext)({});



var $dhiZh = parcelRequire("dhiZh");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $738ffe883427242d$export$da5f7b802957459a = (0, $dhiZh.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $3622e2d40204532d$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $7b5d22e20d51dfc2$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $7b5d22e20d51dfc2$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $466b351ccb90577e$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $7b5d22e20d51dfc2$export$fafff692be55225d(latest, node.target.x);
        const y = $7b5d22e20d51dfc2$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $f33f9a16e7fc92f4$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $c83dae9c221f4080$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $c83dae9c221f4080$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $425ba11852cd4364$export$91ddd985b97788d1 = {};
function $425ba11852cd4364$export$de9e7791c71225fd(correctors) {
    Object.assign($425ba11852cd4364$export$91ddd985b97788d1, correctors);
}



const { schedule: $96f4119d45f34c45$export$bb76eed83315504c, cancel: $96f4119d45f34c45$export$3252729004b8456e } = (0, $754ad0a158adc4dd$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $f5369510addf5808$var$MeasureLayoutWithContext extends (0, $dhiZh.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $425ba11852cd4364$export$de9e7791c71225fd)($f5369510addf5808$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, projection.options), {
                onExitComplete: ()=>this.safeToRemove()
            }));
        }
        (0, $3622e2d40204532d$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $96f4119d45f34c45$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $f5369510addf5808$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $6308545ef5332ea8$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $dhiZh.useContext)((0, $fb43a55f154d4e51$export$a3579ca508007a95));
    return (0, $015932d6ce0d059e$exports.jsx)($f5369510addf5808$var$MeasureLayoutWithContext, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $dhiZh.useContext)((0, $738ffe883427242d$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
const $f5369510addf5808$var$defaultScaleCorrectors = {
    borderRadius: (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $7b5d22e20d51dfc2$export$5eafb6257a5844c)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $7b5d22e20d51dfc2$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $7b5d22e20d51dfc2$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $7b5d22e20d51dfc2$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $7b5d22e20d51dfc2$export$5eafb6257a5844c),
    boxShadow: (0, $f33f9a16e7fc92f4$export$eb0bc629e74dcf8)
};










const $11410095994cd914$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $11410095994cd914$var$numBorders = $11410095994cd914$var$borders.length;
const $11410095994cd914$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $11410095994cd914$var$isPx = (value)=>typeof value === "number" || (0, $466b351ccb90577e$export$91c0eda1d06bf008).test(value);
function $11410095994cd914$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $11410095994cd914$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $11410095994cd914$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $11410095994cd914$var$numBorders; i++){
        const borderLabel = `border${$11410095994cd914$var$borders[i]}Radius`;
        let followRadius = $11410095994cd914$var$getRadius(follow, borderLabel);
        let leadRadius = $11410095994cd914$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $11410095994cd914$var$isPx(followRadius) === $11410095994cd914$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)($11410095994cd914$var$asNumber(followRadius), $11410095994cd914$var$asNumber(leadRadius), progress), 0);
            if ((0, $466b351ccb90577e$export$626336c2cd4b14de).test(leadRadius) || (0, $466b351ccb90577e$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $11410095994cd914$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $11410095994cd914$var$easeCrossfadeIn = /*@__PURE__*/ $11410095994cd914$var$compress(0, 0.5, (0, $c592d6b6e1630f41$export$c8d67a19199d1a50));
const $11410095994cd914$var$easeCrossfadeOut = /*@__PURE__*/ $11410095994cd914$var$compress(0.5, 0.95, (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525));
function $11410095994cd914$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $5e0ab4a000bd2f6a$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cd205e12c0b9b697$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cd205e12c0b9b697$export$c53fd88f45d77e4b(box, originBox) {
    $cd205e12c0b9b697$export$a0230ae482601ae8(box.x, originBox.x);
    $cd205e12c0b9b697$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cd205e12c0b9b697$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $37292078fd441118$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $51d3283d6981f76e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $51d3283d6981f76e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $37292078fd441118$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $466b351ccb90577e$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $37292078fd441118$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $37292078fd441118$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $37292078fd441118$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $37292078fd441118$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $37292078fd441118$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $37292078fd441118$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $37292078fd441118$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $37292078fd441118$export$42b76f1d0d16d5b(box.x, transforms, $37292078fd441118$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $37292078fd441118$export$42b76f1d0d16d5b(box.y, transforms, $37292078fd441118$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $73f7c6397d9a0779$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $73f7c6397d9a0779$export$a7ec7642fe550fb6(delta) {
    return $73f7c6397d9a0779$var$isAxisDeltaZero(delta.x) && $73f7c6397d9a0779$var$isAxisDeltaZero(delta.y);
}
function $73f7c6397d9a0779$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $73f7c6397d9a0779$export$8d5cf76bb7daff09(a, b) {
    return $73f7c6397d9a0779$export$7a9a6f114ddd0fdb(a.x, b.x) && $73f7c6397d9a0779$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $73f7c6397d9a0779$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $73f7c6397d9a0779$export$ef641b782d85522(a, b) {
    return $73f7c6397d9a0779$export$22adf28bfca1c186(a.x, b.x) && $73f7c6397d9a0779$export$22adf28bfca1c186(a.y, b.y);
}
function $73f7c6397d9a0779$export$c5706146bc63213(box) {
    return (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(box.x) / (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(box.y);
}
function $73f7c6397d9a0779$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $ec3802a5199d725e$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $4669f7fb2b05c17b$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $4669f7fb2b05c17b$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}



function $56fe685731400aa6$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $6d01fbe330a086b8$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $8ee0da0771bc04e1$export$1465d17e3de78a96 {
    add(child) {
        (0, $4669f7fb2b05c17b$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $4669f7fb2b05c17b$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $6d01fbe330a086b8$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $b014fa523de8065c$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $b799a260239c0954$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}





/**
 * Timeout defined in ms
 */ function $08a342f5aa8df1e5$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(checkElapsed);
}



function $8c4a6e915be14019$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $635e2e8d3b4d2912$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(value) ? value : (0, $cbf8219c4cd22b55$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b10c3a9e3a6e4437$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $1593a406e3022076$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $1593a406e3022076$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $1593a406e3022076$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $1593a406e3022076$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $1593a406e3022076$var$animationTarget = 1000;
let $1593a406e3022076$var$id = 0;
function $1593a406e3022076$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $1593a406e3022076$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $bec36e612dcd20ca$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $0021ce5a851bb8fe$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $1593a406e3022076$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $1593a406e3022076$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ee537df6d44e221d$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $8c4a6e915be14019$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $08a342f5aa8df1e5$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $3622e2d40204532d$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $3622e2d40204532d$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($1593a406e3022076$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $1593a406e3022076$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $73f7c6397d9a0779$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $59fbf04090be2906$export$7c1391340308742e)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $1593a406e3022076$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($1593a406e3022076$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $1593a406e3022076$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($1593a406e3022076$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($1593a406e3022076$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($1593a406e3022076$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($1593a406e3022076$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($1593a406e3022076$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
            (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).delta = (0, $540ceda0bcfe75ac$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).timestamp);
            (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).timestamp = now;
            (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).isProcessing = true;
            (0, $0021ce5a851bb8fe$export$1811c3a7e3af92f0).update.process((0, $0021ce5a851bb8fe$export$fff89137e9e818ce));
            (0, $0021ce5a851bb8fe$export$1811c3a7e3af92f0).preRender.process((0, $0021ce5a851bb8fe$export$fff89137e9e818ce));
            (0, $0021ce5a851bb8fe$export$1811c3a7e3af92f0).render.process((0, $0021ce5a851bb8fe$export$fff89137e9e818ce));
            (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $96f4119d45f34c45$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($1593a406e3022076$var$clearSnapshot);
            this.sharedNodes.forEach($1593a406e3022076$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $73f7c6397d9a0779$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $dd4c041ed9016899$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $1593a406e3022076$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($1593a406e3022076$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $51d3283d6981f76e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $51d3283d6981f76e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $51d3283d6981f76e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $51d3283d6981f76e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $51d3283d6981f76e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $dd4c041ed9016899$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $51d3283d6981f76e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $dd4c041ed9016899$export$a545127cf1fbb600)(this.latestValues)) (0, $51d3283d6981f76e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $dd4c041ed9016899$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $dd4c041ed9016899$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $37292078fd441118$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $dd4c041ed9016899$export$a545127cf1fbb600)(this.latestValues)) (0, $37292078fd441118$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, this.options, options), {
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            });
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                    (0, $0cf765b3f0b01e1a$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $0cf765b3f0b01e1a$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $51d3283d6981f76e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                    (0, $0cf765b3f0b01e1a$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($1593a406e3022076$var$isDebug) $1593a406e3022076$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $dd4c041ed9016899$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $dd4c041ed9016899$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $0021ce5a851bb8fe$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $51d3283d6981f76e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $cd205e12c0b9b697$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $cd205e12c0b9b697$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $0cf765b3f0b01e1a$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $73f7c6397d9a0779$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $73f7c6397d9a0779$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($1593a406e3022076$var$isDebug) $1593a406e3022076$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $88298c1cbb5b129a$export$3d227df54007d73a)();
            this.projectionDelta = (0, $88298c1cbb5b129a$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $88298c1cbb5b129a$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, this.latestValues);
            const targetDelta = (0, $88298c1cbb5b129a$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($1593a406e3022076$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $1593a406e3022076$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $1593a406e3022076$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $0cf765b3f0b01e1a$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $1593a406e3022076$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $73f7c6397d9a0779$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                    (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $11410095994cd914$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).update(()=>{
                (0, $3622e2d40204532d$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $635e2e8d3b4d2912$export$335a17c977067b99)(0, $1593a406e3022076$var$animationTarget, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, options), {
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                }));
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($1593a406e3022076$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $1593a406e3022076$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                const xLength = (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $cd205e12c0b9b697$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $51d3283d6981f76e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $0cf765b3f0b01e1a$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $ec3802a5199d725e$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $1593a406e3022076$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $1593a406e3022076$var$transformAxes.length; i++){
                $1593a406e3022076$var$resetDistortingTransform(`rotate${$1593a406e3022076$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $1593a406e3022076$var$resetDistortingTransform(`skew${$1593a406e3022076$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $1593a406e3022076$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $b014fa523de8065c$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $b014fa523de8065c$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $dd4c041ed9016899$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $56fe685731400aa6$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $425ba11852cd4364$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $425ba11852cd4364$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $b014fa523de8065c$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($1593a406e3022076$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $1593a406e3022076$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($1593a406e3022076$var$isDebug) $1593a406e3022076$var$metrics.totalNodes = $1593a406e3022076$var$metrics.resolvedTargetDeltas = $1593a406e3022076$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($1593a406e3022076$export$131f2f0cc5fe9609);
                this.nodes.forEach($1593a406e3022076$var$resolveTargetDelta);
                this.nodes.forEach($1593a406e3022076$var$calcProjection);
                this.nodes.forEach($1593a406e3022076$export$c2664f37bc951031);
                if ($1593a406e3022076$var$isDebug) window.MotionDebug.record($1593a406e3022076$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $8ee0da0771bc04e1$export$1465d17e3de78a96)();
        }
    };
}
function $1593a406e3022076$var$updateLayout(node) {
    node.updateLayout();
}
function $1593a406e3022076$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($1593a406e3022076$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $83b6561adb7561f3$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $0cf765b3f0b01e1a$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $88298c1cbb5b129a$export$3d227df54007d73a)();
        (0, $0cf765b3f0b01e1a$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $88298c1cbb5b129a$export$3d227df54007d73a)();
        if (isShared) (0, $0cf765b3f0b01e1a$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $0cf765b3f0b01e1a$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $73f7c6397d9a0779$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                    (0, $0cf765b3f0b01e1a$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
                    (0, $0cf765b3f0b01e1a$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $73f7c6397d9a0779$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $1593a406e3022076$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($1593a406e3022076$var$isDebug) $1593a406e3022076$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $1593a406e3022076$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $1593a406e3022076$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $1593a406e3022076$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $1593a406e3022076$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $1593a406e3022076$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $1593a406e3022076$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $1593a406e3022076$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $1593a406e3022076$var$calcProjection(node) {
    node.calcProjection();
}
function $1593a406e3022076$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $1593a406e3022076$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $1593a406e3022076$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $1593a406e3022076$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $f5c8f7ca81fa323a$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $1593a406e3022076$export$6ffd3e6ae339a132(output, from, to, p) {
    $1593a406e3022076$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $1593a406e3022076$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $1593a406e3022076$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $1593a406e3022076$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $1593a406e3022076$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $1593a406e3022076$var$roundPoint = $1593a406e3022076$var$userAgentContains("applewebkit/") && !$1593a406e3022076$var$userAgentContains("chrome/") ? Math.round : (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
function $1593a406e3022076$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $1593a406e3022076$var$roundPoint(axis.min);
    axis.max = $1593a406e3022076$var$roundPoint(axis.max);
}
function $1593a406e3022076$var$roundBox(box) {
    $1593a406e3022076$var$roundAxis(box.x);
    $1593a406e3022076$var$roundAxis(box.y);
}
function $1593a406e3022076$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $0cf765b3f0b01e1a$export$28d0384c4b79bde2)((0, $73f7c6397d9a0779$export$c5706146bc63213)(snapshot), (0, $73f7c6397d9a0779$export$c5706146bc63213)(layout), 0.2);
}
function $1593a406e3022076$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $db36ee21ca25c493$export$2d029a49a09b6177 = (0, $1593a406e3022076$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $169f17ed058fff3a$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $3fb321e12a969182$export$b91509fcf893b648 = {
    current: undefined
};
const $3fb321e12a969182$export$b61a9eb3dbde8858 = (0, $1593a406e3022076$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$3fb321e12a969182$export$b91509fcf893b648.current) {
            const documentNode = new (0, $db36ee21ca25c493$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $3fb321e12a969182$export$b91509fcf893b648.current = documentNode;
        }
        return $3fb321e12a969182$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $adac3cfcc4fdf4b6$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $f1b82d4471e6080d$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $6510d698ce81b10f$export$5d97dc2872682820),
        ProjectionNode: (0, $3fb321e12a969182$export$b61a9eb3dbde8858),
        MeasureLayout: $f5369510addf5808$export$779f5fb01ad751cd
    }
};







function $d25594588020c870$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $fbf6985c7c3ad332$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $63f463dff945fade$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $d25594588020c870$export$93a81ea037eac456 extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $58b815715a40cea1$export$a4627e546088548d)($d25594588020c870$var$addHoverEvent(this.node, true), $d25594588020c870$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $bb560a473fa466b1$export$d4826db40d47595b extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $58b815715a40cea1$export$a4627e546088548d)((0, $169f17ed058fff3a$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $169f17ed058fff3a$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $12e340a14d8893f6$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $12e340a14d8893f6$export$e841ada32ff745b(parent, child.parentElement);
};




function $c2010e2d5a89e3b1$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $1c3d95765b20c334$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $c2010e2d5a89e3b1$export$f026abdbba7f0c9e extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $fbf6985c7c3ad332$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $63f463dff945fade$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $169f17ed058fff3a$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $58b815715a40cea1$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
        this.removeEndListeners = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $07a0e4e0a0c5ffd5$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $12e340a14d8893f6$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $63f463dff945fade$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $63f463dff945fade$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $58b815715a40cea1$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $c2010e2d5a89e3b1$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $169f17ed058fff3a$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $c2010e2d5a89e3b1$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $169f17ed058fff3a$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $c2010e2d5a89e3b1$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $169f17ed058fff3a$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $58b815715a40cea1$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ 

const $b493f1002e2b3d4d$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $b493f1002e2b3d4d$var$observers = new WeakMap();
const $b493f1002e2b3d4d$var$fireObserverCallback = (entry)=>{
    const callback = $b493f1002e2b3d4d$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $b493f1002e2b3d4d$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($b493f1002e2b3d4d$var$fireObserverCallback);
};
function $b493f1002e2b3d4d$var$initIntersectionObserver(_param) {
    var { root: root } = _param, options = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "root"
    ]);
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$b493f1002e2b3d4d$var$observers.has(lookupRoot)) $b493f1002e2b3d4d$var$observers.set(lookupRoot, {});
    const rootObservers = $b493f1002e2b3d4d$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($b493f1002e2b3d4d$var$fireAllObserverCallbacks, (0, $53825fa7fd9c8174$export$71511d61b312f219)({
        root: root
    }, options));
    return rootObservers[key];
}
function $b493f1002e2b3d4d$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $b493f1002e2b3d4d$var$initIntersectionObserver(options);
    $b493f1002e2b3d4d$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $b493f1002e2b3d4d$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $6cadb9cd51fb3f3d$var$thresholdNames = {
    some: 0,
    all: 1
};
class $6cadb9cd51fb3f3d$export$150851c8cc2f0c72 extends (0, $f8d83fc4e5c8b78a$export$6e91cf7616333d5) {
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $6cadb9cd51fb3f3d$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $b493f1002e2b3d4d$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($6cadb9cd51fb3f3d$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $6cadb9cd51fb3f3d$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $9cd50bbf31ec2c8a$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $6cadb9cd51fb3f3d$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $c2010e2d5a89e3b1$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $bb560a473fa466b1$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $d25594588020c870$export$93a81ea037eac456)
    }
};




const $112659d62f678aa1$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $3fb321e12a969182$export$b61a9eb3dbde8858),
        MeasureLayout: $f5369510addf5808$export$779f5fb01ad751cd
    }
};








var $dhiZh = parcelRequire("dhiZh");

var $dhiZh = parcelRequire("dhiZh");
"use client";
/**
 * @public
 */ const $52379f8b95f6ee3e$export$22a697fb29aac98d = (0, $dhiZh.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $dhiZh = parcelRequire("dhiZh");
"use client";
const $015cbda9f4c97ae6$export$2285bbca2c666415 = (0, $dhiZh.createContext)({});



var $dhiZh = parcelRequire("dhiZh");



var $dhiZh = parcelRequire("dhiZh");
const $dcf2b4c48733d6ab$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $a85aebc6a42ac55f$export$700979bc83e7db82 = (0, $dcf2b4c48733d6ab$export$4e09c449d6c407f7) ? (0, $dhiZh.useLayoutEffect) : (0, $dhiZh.useEffect);



var $dhiZh = parcelRequire("dhiZh");
"use client";
const $ff9985abd260f30e$export$40f10139ecf1f171 = (0, $dhiZh.createContext)({
    strict: false
});







let $82bc8785ca167b15$var$scheduleHandoffComplete = false;
function $82bc8785ca167b15$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a;
    const { visualElement: parent } = (0, $dhiZh.useContext)((0, $015cbda9f4c97ae6$export$2285bbca2c666415));
    const lazyContext = (0, $dhiZh.useContext)((0, $ff9985abd260f30e$export$40f10139ecf1f171));
    const presenceContext = (0, $dhiZh.useContext)((0, $82d6504736c5d906$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $dhiZh.useContext)((0, $52379f8b95f6ee3e$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $dhiZh.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $dhiZh.useContext)((0, $738ffe883427242d$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $82bc8785ca167b15$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $dhiZh.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $432344e8f5b4d433$export$8592e1c077c890a6];
    const wantsHandoff = (0, $dhiZh.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete && ((_a = window.MotionHasOptimisedAnimation) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)));
    (0, $a85aebc6a42ac55f$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $96f4119d45f34c45$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $dhiZh.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        wantsHandoff.current = false;
        // This ensures all future calls to animateChanges() will run in useEffect
        if (!$82bc8785ca167b15$var$scheduleHandoffComplete) {
            $82bc8785ca167b15$var$scheduleHandoffComplete = true;
            queueMicrotask($82bc8785ca167b15$var$completeHandoff);
        }
    });
    return visualElement;
}
function $82bc8785ca167b15$var$completeHandoff() {
    window.MotionHandoffIsComplete = true;
}
function $82bc8785ca167b15$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $82bc8785ca167b15$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $f1b0b38fbe6c3a7c$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $82bc8785ca167b15$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $82bc8785ca167b15$var$getClosestProjectingNode(visualElement.parent);
}



var $dhiZh = parcelRequire("dhiZh");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $22c18b7475650f43$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $dhiZh.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $f1b0b38fbe6c3a7c$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $dhiZh = parcelRequire("dhiZh");





function $fb22fadf5d7870bf$export$4b3c3bd8d910d78d(props) {
    return (0, $76d44f33f5bacac8$export$aa71198ceeaf53ce)(props.animate) || (0, $a900be932221b872$export$1405a65085f40b9).some((name)=>(0, $4eb40b3f84ead7c9$export$720b90e312cea233)(props[name]));
}
function $fb22fadf5d7870bf$export$ce46fa4165cdec40(props) {
    return Boolean($fb22fadf5d7870bf$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $53209621b7f72194$export$12fc32fc096a04a3(props, context) {
    if ((0, $fb22fadf5d7870bf$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $4eb40b3f84ead7c9$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $4eb40b3f84ead7c9$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $0e8282c7de6c6a70$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $53209621b7f72194$export$12fc32fc096a04a3)(props, (0, $dhiZh.useContext)((0, $015cbda9f4c97ae6$export$2285bbca2c666415)));
    return (0, $dhiZh.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $0e8282c7de6c6a70$var$variantLabelsAsDependency(initial),
        $0e8282c7de6c6a70$var$variantLabelsAsDependency(animate)
    ]);
}
function $0e8282c7de6c6a70$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



const $0730b8a53cd8b595$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $0730b8a53cd8b595$export$65570e08d843624d = {};
for(const key in $0730b8a53cd8b595$var$featureProps)$0730b8a53cd8b595$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$0730b8a53cd8b595$var$featureProps[key].some((name)=>!!props[name])
};


function $deb87b76bb9b13b3$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $0730b8a53cd8b595$export$65570e08d843624d)[key] = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $0730b8a53cd8b595$export$65570e08d843624d)[key], features[key]);
}





const $854bffc9fd66bf8d$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $7810551701feb9d5$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $deb87b76bb9b13b3$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $dhiZh.useContext)((0, $52379f8b95f6ee3e$export$22a697fb29aac98d)), props), {
            layoutId: $7810551701feb9d5$var$useLayoutId(props)
        });
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $0e8282c7de6c6a70$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $dcf2b4c48733d6ab$export$4e09c449d6c407f7)) {
            $7810551701feb9d5$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $7810551701feb9d5$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $82bc8785ca167b15$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $015932d6ce0d059e$exports.jsxs)((0, $015cbda9f4c97ae6$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $015932d6ce0d059e$exports.jsx)(MeasureLayout, (0, $53825fa7fd9c8174$export$71511d61b312f219)({
                    visualElement: context.visualElement
                }, configAndProps)) : null,
                useRender(Component, props, (0, $22c18b7475650f43$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $dhiZh.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $854bffc9fd66bf8d$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $7810551701feb9d5$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $dhiZh.useContext)((0, $fb43a55f154d4e51$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $7810551701feb9d5$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $dhiZh.useContext)((0, $ff9985abd260f30e$export$40f10139ecf1f171)).strict;
}
function $7810551701feb9d5$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $0730b8a53cd8b595$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, drag, layout);
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $9198c8cf3d81bedf$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $751a5e63a0d73d5b$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $9198c8cf3d81bedf$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ RegExp("[A-Z]", "u").test(Component)) return true;
    return false;
}



function $df8e8bd9b1025ccd$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $33813c4148c0fa2b$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $d07580477a844349$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $df8e8bd9b1025ccd$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $33813c4148c0fa2b$export$28931db5d57958e5).has(key) ? (0, $dda5bbc784b11029$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $48ad9add22e65587$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $425ba11852cd4364$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $2296d76cb2fbaa66$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(prevProps.style[key]) || (0, $48ad9add22e65587$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}



function $1c092d5f9fc3a4d7$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $2296d76cb2fbaa66$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(props[key]) || (0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $3426faf2300f9708$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




var $dhiZh = parcelRequire("dhiZh");




var $dhiZh = parcelRequire("dhiZh");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $8428c659cadfec5a$export$fe4300aa8eebea86(init) {
    const ref = (0, $dhiZh.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}







function $b82b2cd7f50bcff0$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $b82b2cd7f50bcff0$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $b82b2cd7f50bcff0$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $dhiZh.useContext)((0, $015cbda9f4c97ae6$export$2285bbca2c666415));
        const presenceContext = (0, $dhiZh.useContext)((0, $82d6504736c5d906$export$f224e4635b6f8ce2));
        const make = ()=>$b82b2cd7f50bcff0$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $8428c659cadfec5a$export$fe4300aa8eebea86)(make);
    };
function $b82b2cd7f50bcff0$var$addWillChange(willChange, name) {
    const memberName = (0, $7e218ab9ae002793$export$b3f9dd865b560c6)(name);
    if (memberName) (0, $4669f7fb2b05c17b$export$20e507e47fae79fd)(willChange, memberName);
}
function $b82b2cd7f50bcff0$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $35c10bd5ca3e7200$export$d68f140c4d9b48bc)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition } = resolved, target = (0, $710949f8d1eb100c$export$71511d61b312f219)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            callback(target, transitionEnd);
        }
    }
}
function $b82b2cd7f50bcff0$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $b014fa523de8065c$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $fb22fadf5d7870bf$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $fb22fadf5d7870bf$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $76d44f33f5bacac8$export$aa71198ceeaf53ce)(variantToSet)) $b82b2cd7f50bcff0$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $76d44f33f5bacac8$export$aa71198ceeaf53ce)(animate)) $b82b2cd7f50bcff0$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$b82b2cd7f50bcff0$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}




const $f74f718ec5a3352b$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $55684d3765f4dec7$export$41be8b43e1c4d4f9 = ()=>(0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $f74f718ec5a3352b$export$8940b483cf52eeda)()), {
        attrs: {}
    });




/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $c154b0c506a50a93$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $3fb3d4742a3e7375$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $3fb3d4742a3e7375$var$numTransforms = (0, $3426faf2300f9708$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $3fb3d4742a3e7375$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $3fb3d4742a3e7375$var$numTransforms; i++){
        const key = (0, $3426faf2300f9708$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $c154b0c506a50a93$export$453ef540a9a1bd6b)(value, (0, $72850fda29c9ffae$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $3fb3d4742a3e7375$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $e2d85f1e32232f06$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $d82567b698546f16$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $c154b0c506a50a93$export$453ef540a9a1bd6b)(value, (0, $72850fda29c9ffae$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $3fb3d4742a3e7375$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $63604ad7543ac5e4$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $466b351ccb90577e$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $63604ad7543ac5e4$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $63604ad7543ac5e4$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $63604ad7543ac5e4$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $e3a9a15e1558fd79$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $e3a9a15e1558fd79$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $e3a9a15e1558fd79$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $e3a9a15e1558fd79$var$dashKeys : $e3a9a15e1558fd79$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $466b351ccb90577e$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $466b351ccb90577e$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $466b351ccb90577e$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $a88804e4cf6010f4$export$5475d24f125d7053(state, _param, isSVGTag, transformTemplate) {
    var { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0 } = _param, latest = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $e2d85f1e32232f06$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $63604ad7543ac5e4$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $e3a9a15e1558fd79$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $01d0469a8d8fa49c$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



const $04c1ca0a27a13e8c$export$44dabd3fae512e85 = {
    useVisualState: (0, $b82b2cd7f50bcff0$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $1c092d5f9fc3a4d7$export$16da615486abaa45),
        createRenderState: (0, $55684d3765f4dec7$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).render(()=>{
                (0, $a88804e4cf6010f4$export$5475d24f125d7053)(renderState, latestValues, (0, $01d0469a8d8fa49c$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $d07580477a844349$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $8999b218f5429671$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $b82b2cd7f50bcff0$export$e91e107bc6d03a8e)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $2296d76cb2fbaa66$export$16da615486abaa45,
        createRenderState: (0, $f74f718ec5a3352b$export$8940b483cf52eeda)
    })
};





var $dhiZh = parcelRequire("dhiZh");

var $dhiZh = parcelRequire("dhiZh");




function $57fe06dcf432c032$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(source[key]) && !(0, $48ad9add22e65587$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $57fe06dcf432c032$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $dhiZh.useMemo)(()=>{
        const state = (0, $f74f718ec5a3352b$export$8940b483cf52eeda)();
        (0, $e2d85f1e32232f06$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $57fe06dcf432c032$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $57fe06dcf432c032$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $57fe06dcf432c032$var$useInitialMotionValues(props, visualState));
    return style;
}
function $57fe06dcf432c032$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $57fe06dcf432c032$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $f59acfa87056b2d7$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $f59acfa87056b2d7$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $f59acfa87056b2d7$var$validMotionProps.has(key);
}


let $ef3e9899e7a806a3$var$shouldForward = (key)=>!(0, $f59acfa87056b2d7$export$2f9c46555243bf04)(key);
function $ef3e9899e7a806a3$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $ef3e9899e7a806a3$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $f59acfa87056b2d7$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $ef3e9899e7a806a3$export$59d6962c470509a5((parcelRequire("5PSKo")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $ef3e9899e7a806a3$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($ef3e9899e7a806a3$var$shouldForward(key) || forwardMotionProps === true && (0, $f59acfa87056b2d7$export$2f9c46555243bf04)(key) || !isDom && !(0, $f59acfa87056b2d7$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}






var $dhiZh = parcelRequire("dhiZh");




function $642086de2a878c5e$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $dhiZh.useMemo)(()=>{
        const state = (0, $55684d3765f4dec7$export$41be8b43e1c4d4f9)();
        (0, $a88804e4cf6010f4$export$5475d24f125d7053)(state, visualState, (0, $01d0469a8d8fa49c$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, state.attrs), {
            style: (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $57fe06dcf432c032$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}



function $ada62e076bb079eb$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $751a5e63a0d73d5b$export$88f3fc2fd3766989)(Component) ? (0, $642086de2a878c5e$export$84309c4f53cb1bd5) : (0, $57fe06dcf432c032$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $ef3e9899e7a806a3$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $dhiZh.Fragment) ? (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, filteredProps, visualProps), {
            ref: ref
        }) : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $dhiZh.useMemo)(()=>(0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $dhiZh.createElement)(Component, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, elementProps), {
            children: renderedChildren
        }));
    };
    return useRender;
}


function $bbbd3ed1d3242fa4$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $751a5e63a0d73d5b$export$88f3fc2fd3766989)(Component) ? (0, $04c1ca0a27a13e8c$export$44dabd3fae512e85) : (0, $8999b218f5429671$export$e13ea21d87ea57c8);
        const config = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, baseConfig), {
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $ada62e076bb079eb$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        });
        return (0, $7810551701feb9d5$export$c3ad4a902bccc2d8)(config);
    };
}



var $dhiZh = parcelRequire("dhiZh");










// Does this device prefer reduced motion? Returns `null` server-side.
const $c8edf8fab1e1c9dc$export$ff7706047246b98b = {
    current: null
};
const $c8edf8fab1e1c9dc$export$6476d16e2fd2d0db = {
    current: false
};


function $d607ae95dabce307$export$ca9f41fb23dded3d() {
    (0, $c8edf8fab1e1c9dc$export$6476d16e2fd2d0db).current = true;
    if (!(0, $dcf2b4c48733d6ab$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $c8edf8fab1e1c9dc$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $c8edf8fab1e1c9dc$export$ff7706047246b98b).current = false;
}











function $362982b4640a3ffd$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $cbf8219c4cd22b55$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $cbf8219c4cd22b55$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}





const $a5934f4f71f6610a$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $d1b4f9ad6547092f$var$valueTypes = [
    ...(0, $29391efaf924774d$export$d176691c1998a1f5),
    (0, $d4307911857d9fd9$export$35e9368ef982300f),
    (0, $c83dae9c221f4080$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $d1b4f9ad6547092f$export$950e7e59ea1ffed7 = (v)=>$d1b4f9ad6547092f$var$valueTypes.find((0, $af3300fd8199fc98$export$6eae4d0a6a7ca7cd)(v));







const $92c8d66b1914aa71$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $92c8d66b1914aa71$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $a5934f4f71f6610a$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $c8edf8fab1e1c9dc$export$6476d16e2fd2d0db).current) (0, $d607ae95dabce307$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $c8edf8fab1e1c9dc$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a5934f4f71f6610a$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $0021ce5a851bb8fe$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $0730b8a53cd8b595$export$65570e08d843624d){
            const featureDefinition = (0, $0730b8a53cd8b595$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $88298c1cbb5b129a$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $92c8d66b1914aa71$var$propEventHandlers.length; i++){
            const key = $92c8d66b1914aa71$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $362982b4640a3ffd$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $cbf8219c4cd22b55$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $164d72162e74bc62$export$65583ed5a868f2d9)(value) || (0, $e1f673da0d9109f5$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $d1b4f9ad6547092f$export$950e7e59ea1ffed7)(value) && (0, $c83dae9c221f4080$export$83a0e34f1302825b).test(target)) value = (0, $2da3ae4237fff8f0$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $35c10bd5ca3e7200$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ee537df6d44e221d$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $17b7e623b4b7cd35$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $b5695bf0b45e0558$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $0021ce5a851bb8fe$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, latestValues);
        this.initialValues = props.initial ? (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $fb22fadf5d7870bf$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $fb22fadf5d7870bf$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), { willChange: willChange } = _this_scrapeMotionValuesFromProps, initialMotionValues = (0, $710949f8d1eb100c$export$71511d61b312f219)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
}



class $4912fc8f91208972$export$e49735c2a366bdc7 extends (0, $92c8d66b1914aa71$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $e73b51d260ff45a8$export$4983792d11b61017);
    }
}



function $4293f148741d9906$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $4293f148741d9906$export$23fea75b03ac16b3 extends (0, $4912fc8f91208972$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $ce5ddd2901c6c02a$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $4293f148741d9906$export$3735103072e4a80(instance);
            const value = ((0, $d82567b698546f16$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $c20b0ffa70c85eeb$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $e2d85f1e32232f06$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $2296d76cb2fbaa66$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $ca6e4b7e54f70d9e$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
        this.renderInstance = (0, $df8e8bd9b1025ccd$export$1a32bf6229c258c0);
    }
}












class $340abfe05488dbe3$export$86bcdffbaf733d84 extends (0, $4912fc8f91208972$export$e49735c2a366bdc7) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $3426faf2300f9708$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $ce5ddd2901c6c02a$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $33813c4148c0fa2b$export$28931db5d57958e5).has(key) ? (0, $dda5bbc784b11029$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $1c092d5f9fc3a4d7$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $a88804e4cf6010f4$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $d07580477a844349$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $01d0469a8d8fa49c$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $88298c1cbb5b129a$export$6459fc9e86be362e);
    }
}



const $2a8c1ee019667480$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $751a5e63a0d73d5b$export$88f3fc2fd3766989)(Component) ? new (0, $340abfe05488dbe3$export$86bcdffbaf733d84)(options) : new (0, $4293f148741d9906$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $dhiZh.Fragment)
    });
};


const $6c7b06faf54bf861$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $bbbd3ed1d3242fa4$export$d86feac869a7f0d5)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, (0, $420f9c3dfd569a1b$export$7f9953c70dacfd7f), (0, $9cd50bbf31ec2c8a$export$e5b72898e5a201f1), (0, $adac3cfcc4fdf4b6$export$d7d5d435647ed5a0), (0, $112659d62f678aa1$export$b3219800bda33a1f)), (0, $2a8c1ee019667480$export$56ba0183203348f5));


const $db5bb82597f1f0b4$export$e25e478948902b8b = /*@__PURE__*/ (0, $2941d5494daa997e$export$3af29c0efb268f04)((0, $6c7b06faf54bf861$export$46b7e4b9dc6110c3));




function $60b7b397c61550f4$var$stopAnimation(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
function $60b7b397c61550f4$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && (0, $c4f7aaa144c018a3$export$1f61c53461aff4a5)(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $60b7b397c61550f4$var$setVariants(child, variantLabels);
        });
    });
}
function $60b7b397c61550f4$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $60b7b397c61550f4$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $60b7b397c61550f4$var$setVariants(visualElement, [
        definition
    ]);
    else (0, $c4f7aaa144c018a3$export$1f61c53461aff4a5)(visualElement, definition);
}
/**
 * @public
 */ function $60b7b397c61550f4$export$e2858afe37bd256a() {
    /**
     * Track whether the host component has mounted.
     */ let hasMounted = false;
    /**
     * A collection of linked component animation controls.
     */ const subscribers = new Set();
    const controls = {
        subscribe (visualElement) {
            subscribers.add(visualElement);
            return ()=>void subscribers.delete(visualElement);
        },
        start (definition, transitionOverride) {
            (0, $0bf56566d0420529$export$f5708dca728d7177)(hasMounted, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            const animations = [];
            subscribers.forEach((visualElement)=>{
                animations.push((0, $b30f67fd15b6931a$export$ff62cf473653f109)(visualElement, definition, {
                    transitionOverride: transitionOverride
                }));
            });
            return Promise.all(animations);
        },
        set (definition) {
            (0, $0bf56566d0420529$export$f5708dca728d7177)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement)=>{
                $60b7b397c61550f4$export$b7771d60d308862f(visualElement, definition);
            });
        },
        stop () {
            subscribers.forEach((visualElement)=>{
                $60b7b397c61550f4$var$stopAnimation(visualElement);
            });
        },
        mount () {
            hasMounted = true;
            return ()=>{
                hasMounted = false;
                controls.stop();
            };
        }
    };
    return controls;
}




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */ function $44d86ae641e1b5f8$export$c705d7acb130fe23() {
    const controls = (0, $8428c659cadfec5a$export$fe4300aa8eebea86)((0, $60b7b397c61550f4$export$e2858afe37bd256a));
    (0, $a85aebc6a42ac55f$export$700979bc83e7db82)(controls.mount, []);
    return controls;
}
const $44d86ae641e1b5f8$export$9e2608686d4ad846 = $44d86ae641e1b5f8$export$c705d7acb130fe23;


var $dhiZh = parcelRequire("dhiZh");

function $1a3053776180a3ae$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $0bf56566d0420529$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


const $b8bd99f945a0ad7d$var$thresholds = {
    some: 0,
    all: 1
};
function $b8bd99f945a0ad7d$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "some" } = {}) {
    const elements = (0, $1a3053776180a3ae$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $b8bd99f945a0ad7d$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


function $a93ad9da627e0211$export$2f62ee6831462844(ref, { root: root, margin: margin, amount: amount, once: once = false } = {}) {
    const [isInView, setInView] = (0, $dhiZh.useState)(false);
    (0, $dhiZh.useEffect)(()=>{
        if (!ref.current || once && isInView) return;
        const onEnter = ()=>{
            setInView(true);
            return once ? undefined : ()=>setInView(false);
        };
        const options = {
            root: root && root.current || undefined,
            margin: margin,
            amount: amount
        };
        return (0, $b8bd99f945a0ad7d$export$acb1e9cb9ce4ca56)(ref.current, onEnter, options);
    }, [
        root,
        ref,
        margin,
        once,
        amount
    ]);
    return isInView;
}


var $f5fcaf5cd8fda82a$exports = {};
/*
Breaks a Javascript string into individual user-perceived "characters" 
called extended grapheme clusters by implementing the Unicode UAX-29 standard, version 10.0.0

Usage:
var splitter = new GraphemeSplitter();
//returns an array of strings, one string for each grapheme cluster
var graphemes = splitter.splitGraphemes(string); 

*/ function $f5fcaf5cd8fda82a$var$GraphemeSplitter() {
    var CR = 0, LF = 1, Control = 2, Extend = 3, Regional_Indicator = 4, SpacingMark = 5, L = 6, V = 7, T = 8, LV = 9, LVT = 10, Other = 11, Prepend = 12, E_Base = 13, E_Modifier = 14, ZWJ = 15, Glue_After_Zwj = 16, E_Base_GAZ = 17;
    // BreakTypes
    var NotBreak = 0, BreakStart = 1, Break = 2, BreakLastRegional = 3, BreakPenultimateRegional = 4;
    function isSurrogate(str, pos) {
        return 0xd800 <= str.charCodeAt(pos) && str.charCodeAt(pos) <= 0xdbff && 0xdc00 <= str.charCodeAt(pos + 1) && str.charCodeAt(pos + 1) <= 0xdfff;
    }
    // Private function, gets a Unicode code point from a JavaScript UTF-16 string
    // handling surrogate pairs appropriately
    function codePointAt(str, idx) {
        if (idx === undefined) idx = 0;
        var code = str.charCodeAt(idx);
        // if a high surrogate
        if (0xD800 <= code && code <= 0xDBFF && idx < str.length - 1) {
            var hi = code;
            var low = str.charCodeAt(idx + 1);
            if (0xDC00 <= low && low <= 0xDFFF) return (hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000;
            return hi;
        }
        // if a low surrogate
        if (0xDC00 <= code && code <= 0xDFFF && idx >= 1) {
            var hi = str.charCodeAt(idx - 1);
            var low = code;
            if (0xD800 <= hi && hi <= 0xDBFF) return (hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000;
            return low;
        }
        //just return the char if an unmatched surrogate half or a 
        //single-char codepoint
        return code;
    }
    // Private function, returns whether a break is allowed between the 
    // two given grapheme breaking classes
    function shouldBreak(start, mid, end) {
        var all = [
            start
        ].concat(mid).concat([
            end
        ]);
        var previous = all[all.length - 2];
        var next = end;
        // Lookahead termintor for:
        // GB10. (E_Base | EBG) Extend* ?	E_Modifier
        var eModifierIndex = all.lastIndexOf(E_Modifier);
        if (eModifierIndex > 1 && all.slice(1, eModifierIndex).every(function(c) {
            return c == Extend;
        }) && [
            Extend,
            E_Base,
            E_Base_GAZ
        ].indexOf(start) == -1) return Break;
        // Lookahead termintor for:
        // GB12. ^ (RI RI)* RI	?	RI
        // GB13. [^RI] (RI RI)* RI	?	RI
        var rIIndex = all.lastIndexOf(Regional_Indicator);
        if (rIIndex > 0 && all.slice(1, rIIndex).every(function(c) {
            return c == Regional_Indicator;
        }) && [
            Prepend,
            Regional_Indicator
        ].indexOf(previous) == -1) {
            if (all.filter(function(c) {
                return c == Regional_Indicator;
            }).length % 2 == 1) return BreakLastRegional;
            else return BreakPenultimateRegional;
        }
        // GB3. CR X LF
        if (previous == CR && next == LF) return NotBreak;
        else if (previous == Control || previous == CR || previous == LF) {
            if (next == E_Modifier && mid.every(function(c) {
                return c == Extend;
            })) return Break;
            else return BreakStart;
        } else if (next == Control || next == CR || next == LF) return BreakStart;
        else if (previous == L && (next == L || next == V || next == LV || next == LVT)) return NotBreak;
        else if ((previous == LV || previous == V) && (next == V || next == T)) return NotBreak;
        else if ((previous == LVT || previous == T) && next == T) return NotBreak;
        else if (next == Extend || next == ZWJ) return NotBreak;
        else if (next == SpacingMark) return NotBreak;
        else if (previous == Prepend) return NotBreak;
        // GB10. (E_Base | EBG) Extend* ?	E_Modifier
        var previousNonExtendIndex = all.indexOf(Extend) != -1 ? all.lastIndexOf(Extend) - 1 : all.length - 2;
        if ([
            E_Base,
            E_Base_GAZ
        ].indexOf(all[previousNonExtendIndex]) != -1 && all.slice(previousNonExtendIndex + 1, -1).every(function(c) {
            return c == Extend;
        }) && next == E_Modifier) return NotBreak;
        // GB11. ZWJ ? (Glue_After_Zwj | EBG)
        if (previous == ZWJ && [
            Glue_After_Zwj,
            E_Base_GAZ
        ].indexOf(next) != -1) return NotBreak;
        // GB12. ^ (RI RI)* RI ? RI
        // GB13. [^RI] (RI RI)* RI ? RI
        if (mid.indexOf(Regional_Indicator) != -1) return Break;
        if (previous == Regional_Indicator && next == Regional_Indicator) return NotBreak;
        // GB999. Any ? Any
        return BreakStart;
    }
    // Returns the next grapheme break in the string after the given index
    this.nextBreak = function(string, index) {
        if (index === undefined) index = 0;
        if (index < 0) return 0;
        if (index >= string.length - 1) return string.length;
        var prev = getGraphemeBreakProperty(codePointAt(string, index));
        var mid = [];
        for(var i = index + 1; i < string.length; i++){
            // check for already processed low surrogates
            if (isSurrogate(string, i - 1)) continue;
            var next = getGraphemeBreakProperty(codePointAt(string, i));
            if (shouldBreak(prev, mid, next)) return i;
            mid.push(next);
        }
        return string.length;
    };
    // Breaks the given string into an array of grapheme cluster strings
    this.splitGraphemes = function(str) {
        var res = [];
        var index = 0;
        var brk;
        while((brk = this.nextBreak(str, index)) < str.length){
            res.push(str.slice(index, brk));
            index = brk;
        }
        if (index < str.length) res.push(str.slice(index));
        return res;
    };
    // Returns the iterator of grapheme clusters there are in the given string
    this.iterateGraphemes = function(str) {
        var index = 0;
        var res = {
            next: (function() {
                var value;
                var brk;
                if ((brk = this.nextBreak(str, index)) < str.length) {
                    value = str.slice(index, brk);
                    index = brk;
                    return {
                        value: value,
                        done: false
                    };
                }
                if (index < str.length) {
                    value = str.slice(index);
                    index = str.length;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }).bind(this)
        };
        // ES2015 @@iterator method (iterable) for spread syntax and for...of statement
        if (typeof Symbol !== "undefined" && Symbol.iterator) res[Symbol.iterator] = function() {
            return res;
        };
        return res;
    };
    // Returns the number of grapheme clusters there are in the given string
    this.countGraphemes = function(str) {
        var count = 0;
        var index = 0;
        var brk;
        while((brk = this.nextBreak(str, index)) < str.length){
            index = brk;
            count++;
        }
        if (index < str.length) count++;
        return count;
    };
    //given a Unicode code point, determines this symbol's grapheme break property
    function getGraphemeBreakProperty(code) {
        //grapheme break property for Unicode 10.0.0, 
        //taken from http://www.unicode.org/Public/10.0.0/ucd/auxiliary/GraphemeBreakProperty.txt
        //and adapted to JavaScript rules
        if (0x0600 <= code && code <= 0x0605 || // Cf   [6] ARABIC NUMBER SIGN..ARABIC NUMBER MARK ABOVE
        0x06DD == code || // Cf       ARABIC END OF AYAH
        0x070F == code || // Cf       SYRIAC ABBREVIATION MARK
        0x08E2 == code || // Cf       ARABIC DISPUTED END OF AYAH
        0x0D4E == code || // Lo       MALAYALAM LETTER DOT REPH
        0x110BD == code || // Cf       KAITHI NUMBER SIGN
        0x111C2 <= code && code <= 0x111C3 || // Lo   [2] SHARADA SIGN JIHVAMULIYA..SHARADA SIGN UPADHMANIYA
        0x11A3A == code || // Lo       ZANABAZAR SQUARE CLUSTER-INITIAL LETTER RA
        0x11A86 <= code && code <= 0x11A89 || // Lo   [4] SOYOMBO CLUSTER-INITIAL LETTER RA..SOYOMBO CLUSTER-INITIAL LETTER SA
        0x11D46 == code // Lo       MASARAM GONDI REPHA
        ) return Prepend;
        if (0x000D == code // Cc       <control-000D>
        ) return CR;
        if (0x000A == code // Cc       <control-000A>
        ) return LF;
        if (0x0000 <= code && code <= 0x0009 || // Cc  [10] <control-0000>..<control-0009>
        0x000B <= code && code <= 0x000C || // Cc   [2] <control-000B>..<control-000C>
        0x000E <= code && code <= 0x001F || // Cc  [18] <control-000E>..<control-001F>
        0x007F <= code && code <= 0x009F || // Cc  [33] <control-007F>..<control-009F>
        0x00AD == code || // Cf       SOFT HYPHEN
        0x061C == code || // Cf       ARABIC LETTER MARK
        0x180E == code || // Cf       MONGOLIAN VOWEL SEPARATOR
        0x200B == code || // Cf       ZERO WIDTH SPACE
        0x200E <= code && code <= 0x200F || // Cf   [2] LEFT-TO-RIGHT MARK..RIGHT-TO-LEFT MARK
        0x2028 == code || // Zl       LINE SEPARATOR
        0x2029 == code || // Zp       PARAGRAPH SEPARATOR
        0x202A <= code && code <= 0x202E || // Cf   [5] LEFT-TO-RIGHT EMBEDDING..RIGHT-TO-LEFT OVERRIDE
        0x2060 <= code && code <= 0x2064 || // Cf   [5] WORD JOINER..INVISIBLE PLUS
        0x2065 == code || // Cn       <reserved-2065>
        0x2066 <= code && code <= 0x206F || // Cf  [10] LEFT-TO-RIGHT ISOLATE..NOMINAL DIGIT SHAPES
        0xD800 <= code && code <= 0xDFFF || // Cs [2048] <surrogate-D800>..<surrogate-DFFF>
        0xFEFF == code || // Cf       ZERO WIDTH NO-BREAK SPACE
        0xFFF0 <= code && code <= 0xFFF8 || // Cn   [9] <reserved-FFF0>..<reserved-FFF8>
        0xFFF9 <= code && code <= 0xFFFB || // Cf   [3] INTERLINEAR ANNOTATION ANCHOR..INTERLINEAR ANNOTATION TERMINATOR
        0x1BCA0 <= code && code <= 0x1BCA3 || // Cf   [4] SHORTHAND FORMAT LETTER OVERLAP..SHORTHAND FORMAT UP STEP
        0x1D173 <= code && code <= 0x1D17A || // Cf   [8] MUSICAL SYMBOL BEGIN BEAM..MUSICAL SYMBOL END PHRASE
        0xE0000 == code || // Cn       <reserved-E0000>
        0xE0001 == code || // Cf       LANGUAGE TAG
        0xE0002 <= code && code <= 0xE001F || // Cn  [30] <reserved-E0002>..<reserved-E001F>
        0xE0080 <= code && code <= 0xE00FF || // Cn [128] <reserved-E0080>..<reserved-E00FF>
        0xE01F0 <= code && code <= 0xE0FFF // Cn [3600] <reserved-E01F0>..<reserved-E0FFF>
        ) return Control;
        if (0x0300 <= code && code <= 0x036F || // Mn [112] COMBINING GRAVE ACCENT..COMBINING LATIN SMALL LETTER X
        0x0483 <= code && code <= 0x0487 || // Mn   [5] COMBINING CYRILLIC TITLO..COMBINING CYRILLIC POKRYTIE
        0x0488 <= code && code <= 0x0489 || // Me   [2] COMBINING CYRILLIC HUNDRED THOUSANDS SIGN..COMBINING CYRILLIC MILLIONS SIGN
        0x0591 <= code && code <= 0x05BD || // Mn  [45] HEBREW ACCENT ETNAHTA..HEBREW POINT METEG
        0x05BF == code || // Mn       HEBREW POINT RAFE
        0x05C1 <= code && code <= 0x05C2 || // Mn   [2] HEBREW POINT SHIN DOT..HEBREW POINT SIN DOT
        0x05C4 <= code && code <= 0x05C5 || // Mn   [2] HEBREW MARK UPPER DOT..HEBREW MARK LOWER DOT
        0x05C7 == code || // Mn       HEBREW POINT QAMATS QATAN
        0x0610 <= code && code <= 0x061A || // Mn  [11] ARABIC SIGN SALLALLAHOU ALAYHE WASSALLAM..ARABIC SMALL KASRA
        0x064B <= code && code <= 0x065F || // Mn  [21] ARABIC FATHATAN..ARABIC WAVY HAMZA BELOW
        0x0670 == code || // Mn       ARABIC LETTER SUPERSCRIPT ALEF
        0x06D6 <= code && code <= 0x06DC || // Mn   [7] ARABIC SMALL HIGH LIGATURE SAD WITH LAM WITH ALEF MAKSURA..ARABIC SMALL HIGH SEEN
        0x06DF <= code && code <= 0x06E4 || // Mn   [6] ARABIC SMALL HIGH ROUNDED ZERO..ARABIC SMALL HIGH MADDA
        0x06E7 <= code && code <= 0x06E8 || // Mn   [2] ARABIC SMALL HIGH YEH..ARABIC SMALL HIGH NOON
        0x06EA <= code && code <= 0x06ED || // Mn   [4] ARABIC EMPTY CENTRE LOW STOP..ARABIC SMALL LOW MEEM
        0x0711 == code || // Mn       SYRIAC LETTER SUPERSCRIPT ALAPH
        0x0730 <= code && code <= 0x074A || // Mn  [27] SYRIAC PTHAHA ABOVE..SYRIAC BARREKH
        0x07A6 <= code && code <= 0x07B0 || // Mn  [11] THAANA ABAFILI..THAANA SUKUN
        0x07EB <= code && code <= 0x07F3 || // Mn   [9] NKO COMBINING SHORT HIGH TONE..NKO COMBINING DOUBLE DOT ABOVE
        0x0816 <= code && code <= 0x0819 || // Mn   [4] SAMARITAN MARK IN..SAMARITAN MARK DAGESH
        0x081B <= code && code <= 0x0823 || // Mn   [9] SAMARITAN MARK EPENTHETIC YUT..SAMARITAN VOWEL SIGN A
        0x0825 <= code && code <= 0x0827 || // Mn   [3] SAMARITAN VOWEL SIGN SHORT A..SAMARITAN VOWEL SIGN U
        0x0829 <= code && code <= 0x082D || // Mn   [5] SAMARITAN VOWEL SIGN LONG I..SAMARITAN MARK NEQUDAA
        0x0859 <= code && code <= 0x085B || // Mn   [3] MANDAIC AFFRICATION MARK..MANDAIC GEMINATION MARK
        0x08D4 <= code && code <= 0x08E1 || // Mn  [14] ARABIC SMALL HIGH WORD AR-RUB..ARABIC SMALL HIGH SIGN SAFHA
        0x08E3 <= code && code <= 0x0902 || // Mn  [32] ARABIC TURNED DAMMA BELOW..DEVANAGARI SIGN ANUSVARA
        0x093A == code || // Mn       DEVANAGARI VOWEL SIGN OE
        0x093C == code || // Mn       DEVANAGARI SIGN NUKTA
        0x0941 <= code && code <= 0x0948 || // Mn   [8] DEVANAGARI VOWEL SIGN U..DEVANAGARI VOWEL SIGN AI
        0x094D == code || // Mn       DEVANAGARI SIGN VIRAMA
        0x0951 <= code && code <= 0x0957 || // Mn   [7] DEVANAGARI STRESS SIGN UDATTA..DEVANAGARI VOWEL SIGN UUE
        0x0962 <= code && code <= 0x0963 || // Mn   [2] DEVANAGARI VOWEL SIGN VOCALIC L..DEVANAGARI VOWEL SIGN VOCALIC LL
        0x0981 == code || // Mn       BENGALI SIGN CANDRABINDU
        0x09BC == code || // Mn       BENGALI SIGN NUKTA
        0x09BE == code || // Mc       BENGALI VOWEL SIGN AA
        0x09C1 <= code && code <= 0x09C4 || // Mn   [4] BENGALI VOWEL SIGN U..BENGALI VOWEL SIGN VOCALIC RR
        0x09CD == code || // Mn       BENGALI SIGN VIRAMA
        0x09D7 == code || // Mc       BENGALI AU LENGTH MARK
        0x09E2 <= code && code <= 0x09E3 || // Mn   [2] BENGALI VOWEL SIGN VOCALIC L..BENGALI VOWEL SIGN VOCALIC LL
        0x0A01 <= code && code <= 0x0A02 || // Mn   [2] GURMUKHI SIGN ADAK BINDI..GURMUKHI SIGN BINDI
        0x0A3C == code || // Mn       GURMUKHI SIGN NUKTA
        0x0A41 <= code && code <= 0x0A42 || // Mn   [2] GURMUKHI VOWEL SIGN U..GURMUKHI VOWEL SIGN UU
        0x0A47 <= code && code <= 0x0A48 || // Mn   [2] GURMUKHI VOWEL SIGN EE..GURMUKHI VOWEL SIGN AI
        0x0A4B <= code && code <= 0x0A4D || // Mn   [3] GURMUKHI VOWEL SIGN OO..GURMUKHI SIGN VIRAMA
        0x0A51 == code || // Mn       GURMUKHI SIGN UDAAT
        0x0A70 <= code && code <= 0x0A71 || // Mn   [2] GURMUKHI TIPPI..GURMUKHI ADDAK
        0x0A75 == code || // Mn       GURMUKHI SIGN YAKASH
        0x0A81 <= code && code <= 0x0A82 || // Mn   [2] GUJARATI SIGN CANDRABINDU..GUJARATI SIGN ANUSVARA
        0x0ABC == code || // Mn       GUJARATI SIGN NUKTA
        0x0AC1 <= code && code <= 0x0AC5 || // Mn   [5] GUJARATI VOWEL SIGN U..GUJARATI VOWEL SIGN CANDRA E
        0x0AC7 <= code && code <= 0x0AC8 || // Mn   [2] GUJARATI VOWEL SIGN E..GUJARATI VOWEL SIGN AI
        0x0ACD == code || // Mn       GUJARATI SIGN VIRAMA
        0x0AE2 <= code && code <= 0x0AE3 || // Mn   [2] GUJARATI VOWEL SIGN VOCALIC L..GUJARATI VOWEL SIGN VOCALIC LL
        0x0AFA <= code && code <= 0x0AFF || // Mn   [6] GUJARATI SIGN SUKUN..GUJARATI SIGN TWO-CIRCLE NUKTA ABOVE
        0x0B01 == code || // Mn       ORIYA SIGN CANDRABINDU
        0x0B3C == code || // Mn       ORIYA SIGN NUKTA
        0x0B3E == code || // Mc       ORIYA VOWEL SIGN AA
        0x0B3F == code || // Mn       ORIYA VOWEL SIGN I
        0x0B41 <= code && code <= 0x0B44 || // Mn   [4] ORIYA VOWEL SIGN U..ORIYA VOWEL SIGN VOCALIC RR
        0x0B4D == code || // Mn       ORIYA SIGN VIRAMA
        0x0B56 == code || // Mn       ORIYA AI LENGTH MARK
        0x0B57 == code || // Mc       ORIYA AU LENGTH MARK
        0x0B62 <= code && code <= 0x0B63 || // Mn   [2] ORIYA VOWEL SIGN VOCALIC L..ORIYA VOWEL SIGN VOCALIC LL
        0x0B82 == code || // Mn       TAMIL SIGN ANUSVARA
        0x0BBE == code || // Mc       TAMIL VOWEL SIGN AA
        0x0BC0 == code || // Mn       TAMIL VOWEL SIGN II
        0x0BCD == code || // Mn       TAMIL SIGN VIRAMA
        0x0BD7 == code || // Mc       TAMIL AU LENGTH MARK
        0x0C00 == code || // Mn       TELUGU SIGN COMBINING CANDRABINDU ABOVE
        0x0C3E <= code && code <= 0x0C40 || // Mn   [3] TELUGU VOWEL SIGN AA..TELUGU VOWEL SIGN II
        0x0C46 <= code && code <= 0x0C48 || // Mn   [3] TELUGU VOWEL SIGN E..TELUGU VOWEL SIGN AI
        0x0C4A <= code && code <= 0x0C4D || // Mn   [4] TELUGU VOWEL SIGN O..TELUGU SIGN VIRAMA
        0x0C55 <= code && code <= 0x0C56 || // Mn   [2] TELUGU LENGTH MARK..TELUGU AI LENGTH MARK
        0x0C62 <= code && code <= 0x0C63 || // Mn   [2] TELUGU VOWEL SIGN VOCALIC L..TELUGU VOWEL SIGN VOCALIC LL
        0x0C81 == code || // Mn       KANNADA SIGN CANDRABINDU
        0x0CBC == code || // Mn       KANNADA SIGN NUKTA
        0x0CBF == code || // Mn       KANNADA VOWEL SIGN I
        0x0CC2 == code || // Mc       KANNADA VOWEL SIGN UU
        0x0CC6 == code || // Mn       KANNADA VOWEL SIGN E
        0x0CCC <= code && code <= 0x0CCD || // Mn   [2] KANNADA VOWEL SIGN AU..KANNADA SIGN VIRAMA
        0x0CD5 <= code && code <= 0x0CD6 || // Mc   [2] KANNADA LENGTH MARK..KANNADA AI LENGTH MARK
        0x0CE2 <= code && code <= 0x0CE3 || // Mn   [2] KANNADA VOWEL SIGN VOCALIC L..KANNADA VOWEL SIGN VOCALIC LL
        0x0D00 <= code && code <= 0x0D01 || // Mn   [2] MALAYALAM SIGN COMBINING ANUSVARA ABOVE..MALAYALAM SIGN CANDRABINDU
        0x0D3B <= code && code <= 0x0D3C || // Mn   [2] MALAYALAM SIGN VERTICAL BAR VIRAMA..MALAYALAM SIGN CIRCULAR VIRAMA
        0x0D3E == code || // Mc       MALAYALAM VOWEL SIGN AA
        0x0D41 <= code && code <= 0x0D44 || // Mn   [4] MALAYALAM VOWEL SIGN U..MALAYALAM VOWEL SIGN VOCALIC RR
        0x0D4D == code || // Mn       MALAYALAM SIGN VIRAMA
        0x0D57 == code || // Mc       MALAYALAM AU LENGTH MARK
        0x0D62 <= code && code <= 0x0D63 || // Mn   [2] MALAYALAM VOWEL SIGN VOCALIC L..MALAYALAM VOWEL SIGN VOCALIC LL
        0x0DCA == code || // Mn       SINHALA SIGN AL-LAKUNA
        0x0DCF == code || // Mc       SINHALA VOWEL SIGN AELA-PILLA
        0x0DD2 <= code && code <= 0x0DD4 || // Mn   [3] SINHALA VOWEL SIGN KETTI IS-PILLA..SINHALA VOWEL SIGN KETTI PAA-PILLA
        0x0DD6 == code || // Mn       SINHALA VOWEL SIGN DIGA PAA-PILLA
        0x0DDF == code || // Mc       SINHALA VOWEL SIGN GAYANUKITTA
        0x0E31 == code || // Mn       THAI CHARACTER MAI HAN-AKAT
        0x0E34 <= code && code <= 0x0E3A || // Mn   [7] THAI CHARACTER SARA I..THAI CHARACTER PHINTHU
        0x0E47 <= code && code <= 0x0E4E || // Mn   [8] THAI CHARACTER MAITAIKHU..THAI CHARACTER YAMAKKAN
        0x0EB1 == code || // Mn       LAO VOWEL SIGN MAI KAN
        0x0EB4 <= code && code <= 0x0EB9 || // Mn   [6] LAO VOWEL SIGN I..LAO VOWEL SIGN UU
        0x0EBB <= code && code <= 0x0EBC || // Mn   [2] LAO VOWEL SIGN MAI KON..LAO SEMIVOWEL SIGN LO
        0x0EC8 <= code && code <= 0x0ECD || // Mn   [6] LAO TONE MAI EK..LAO NIGGAHITA
        0x0F18 <= code && code <= 0x0F19 || // Mn   [2] TIBETAN ASTROLOGICAL SIGN -KHYUD PA..TIBETAN ASTROLOGICAL SIGN SDONG TSHUGS
        0x0F35 == code || // Mn       TIBETAN MARK NGAS BZUNG NYI ZLA
        0x0F37 == code || // Mn       TIBETAN MARK NGAS BZUNG SGOR RTAGS
        0x0F39 == code || // Mn       TIBETAN MARK TSA -PHRU
        0x0F71 <= code && code <= 0x0F7E || // Mn  [14] TIBETAN VOWEL SIGN AA..TIBETAN SIGN RJES SU NGA RO
        0x0F80 <= code && code <= 0x0F84 || // Mn   [5] TIBETAN VOWEL SIGN REVERSED I..TIBETAN MARK HALANTA
        0x0F86 <= code && code <= 0x0F87 || // Mn   [2] TIBETAN SIGN LCI RTAGS..TIBETAN SIGN YANG RTAGS
        0x0F8D <= code && code <= 0x0F97 || // Mn  [11] TIBETAN SUBJOINED SIGN LCE TSA CAN..TIBETAN SUBJOINED LETTER JA
        0x0F99 <= code && code <= 0x0FBC || // Mn  [36] TIBETAN SUBJOINED LETTER NYA..TIBETAN SUBJOINED LETTER FIXED-FORM RA
        0x0FC6 == code || // Mn       TIBETAN SYMBOL PADMA GDAN
        0x102D <= code && code <= 0x1030 || // Mn   [4] MYANMAR VOWEL SIGN I..MYANMAR VOWEL SIGN UU
        0x1032 <= code && code <= 0x1037 || // Mn   [6] MYANMAR VOWEL SIGN AI..MYANMAR SIGN DOT BELOW
        0x1039 <= code && code <= 0x103A || // Mn   [2] MYANMAR SIGN VIRAMA..MYANMAR SIGN ASAT
        0x103D <= code && code <= 0x103E || // Mn   [2] MYANMAR CONSONANT SIGN MEDIAL WA..MYANMAR CONSONANT SIGN MEDIAL HA
        0x1058 <= code && code <= 0x1059 || // Mn   [2] MYANMAR VOWEL SIGN VOCALIC L..MYANMAR VOWEL SIGN VOCALIC LL
        0x105E <= code && code <= 0x1060 || // Mn   [3] MYANMAR CONSONANT SIGN MON MEDIAL NA..MYANMAR CONSONANT SIGN MON MEDIAL LA
        0x1071 <= code && code <= 0x1074 || // Mn   [4] MYANMAR VOWEL SIGN GEBA KAREN I..MYANMAR VOWEL SIGN KAYAH EE
        0x1082 == code || // Mn       MYANMAR CONSONANT SIGN SHAN MEDIAL WA
        0x1085 <= code && code <= 0x1086 || // Mn   [2] MYANMAR VOWEL SIGN SHAN E ABOVE..MYANMAR VOWEL SIGN SHAN FINAL Y
        0x108D == code || // Mn       MYANMAR SIGN SHAN COUNCIL EMPHATIC TONE
        0x109D == code || // Mn       MYANMAR VOWEL SIGN AITON AI
        0x135D <= code && code <= 0x135F || // Mn   [3] ETHIOPIC COMBINING GEMINATION AND VOWEL LENGTH MARK..ETHIOPIC COMBINING GEMINATION MARK
        0x1712 <= code && code <= 0x1714 || // Mn   [3] TAGALOG VOWEL SIGN I..TAGALOG SIGN VIRAMA
        0x1732 <= code && code <= 0x1734 || // Mn   [3] HANUNOO VOWEL SIGN I..HANUNOO SIGN PAMUDPOD
        0x1752 <= code && code <= 0x1753 || // Mn   [2] BUHID VOWEL SIGN I..BUHID VOWEL SIGN U
        0x1772 <= code && code <= 0x1773 || // Mn   [2] TAGBANWA VOWEL SIGN I..TAGBANWA VOWEL SIGN U
        0x17B4 <= code && code <= 0x17B5 || // Mn   [2] KHMER VOWEL INHERENT AQ..KHMER VOWEL INHERENT AA
        0x17B7 <= code && code <= 0x17BD || // Mn   [7] KHMER VOWEL SIGN I..KHMER VOWEL SIGN UA
        0x17C6 == code || // Mn       KHMER SIGN NIKAHIT
        0x17C9 <= code && code <= 0x17D3 || // Mn  [11] KHMER SIGN MUUSIKATOAN..KHMER SIGN BATHAMASAT
        0x17DD == code || // Mn       KHMER SIGN ATTHACAN
        0x180B <= code && code <= 0x180D || // Mn   [3] MONGOLIAN FREE VARIATION SELECTOR ONE..MONGOLIAN FREE VARIATION SELECTOR THREE
        0x1885 <= code && code <= 0x1886 || // Mn   [2] MONGOLIAN LETTER ALI GALI BALUDA..MONGOLIAN LETTER ALI GALI THREE BALUDA
        0x18A9 == code || // Mn       MONGOLIAN LETTER ALI GALI DAGALGA
        0x1920 <= code && code <= 0x1922 || // Mn   [3] LIMBU VOWEL SIGN A..LIMBU VOWEL SIGN U
        0x1927 <= code && code <= 0x1928 || // Mn   [2] LIMBU VOWEL SIGN E..LIMBU VOWEL SIGN O
        0x1932 == code || // Mn       LIMBU SMALL LETTER ANUSVARA
        0x1939 <= code && code <= 0x193B || // Mn   [3] LIMBU SIGN MUKPHRENG..LIMBU SIGN SA-I
        0x1A17 <= code && code <= 0x1A18 || // Mn   [2] BUGINESE VOWEL SIGN I..BUGINESE VOWEL SIGN U
        0x1A1B == code || // Mn       BUGINESE VOWEL SIGN AE
        0x1A56 == code || // Mn       TAI THAM CONSONANT SIGN MEDIAL LA
        0x1A58 <= code && code <= 0x1A5E || // Mn   [7] TAI THAM SIGN MAI KANG LAI..TAI THAM CONSONANT SIGN SA
        0x1A60 == code || // Mn       TAI THAM SIGN SAKOT
        0x1A62 == code || // Mn       TAI THAM VOWEL SIGN MAI SAT
        0x1A65 <= code && code <= 0x1A6C || // Mn   [8] TAI THAM VOWEL SIGN I..TAI THAM VOWEL SIGN OA BELOW
        0x1A73 <= code && code <= 0x1A7C || // Mn  [10] TAI THAM VOWEL SIGN OA ABOVE..TAI THAM SIGN KHUEN-LUE KARAN
        0x1A7F == code || // Mn       TAI THAM COMBINING CRYPTOGRAMMIC DOT
        0x1AB0 <= code && code <= 0x1ABD || // Mn  [14] COMBINING DOUBLED CIRCUMFLEX ACCENT..COMBINING PARENTHESES BELOW
        0x1ABE == code || // Me       COMBINING PARENTHESES OVERLAY
        0x1B00 <= code && code <= 0x1B03 || // Mn   [4] BALINESE SIGN ULU RICEM..BALINESE SIGN SURANG
        0x1B34 == code || // Mn       BALINESE SIGN REREKAN
        0x1B36 <= code && code <= 0x1B3A || // Mn   [5] BALINESE VOWEL SIGN ULU..BALINESE VOWEL SIGN RA REPA
        0x1B3C == code || // Mn       BALINESE VOWEL SIGN LA LENGA
        0x1B42 == code || // Mn       BALINESE VOWEL SIGN PEPET
        0x1B6B <= code && code <= 0x1B73 || // Mn   [9] BALINESE MUSICAL SYMBOL COMBINING TEGEH..BALINESE MUSICAL SYMBOL COMBINING GONG
        0x1B80 <= code && code <= 0x1B81 || // Mn   [2] SUNDANESE SIGN PANYECEK..SUNDANESE SIGN PANGLAYAR
        0x1BA2 <= code && code <= 0x1BA5 || // Mn   [4] SUNDANESE CONSONANT SIGN PANYAKRA..SUNDANESE VOWEL SIGN PANYUKU
        0x1BA8 <= code && code <= 0x1BA9 || // Mn   [2] SUNDANESE VOWEL SIGN PAMEPET..SUNDANESE VOWEL SIGN PANEULEUNG
        0x1BAB <= code && code <= 0x1BAD || // Mn   [3] SUNDANESE SIGN VIRAMA..SUNDANESE CONSONANT SIGN PASANGAN WA
        0x1BE6 == code || // Mn       BATAK SIGN TOMPI
        0x1BE8 <= code && code <= 0x1BE9 || // Mn   [2] BATAK VOWEL SIGN PAKPAK E..BATAK VOWEL SIGN EE
        0x1BED == code || // Mn       BATAK VOWEL SIGN KARO O
        0x1BEF <= code && code <= 0x1BF1 || // Mn   [3] BATAK VOWEL SIGN U FOR SIMALUNGUN SA..BATAK CONSONANT SIGN H
        0x1C2C <= code && code <= 0x1C33 || // Mn   [8] LEPCHA VOWEL SIGN E..LEPCHA CONSONANT SIGN T
        0x1C36 <= code && code <= 0x1C37 || // Mn   [2] LEPCHA SIGN RAN..LEPCHA SIGN NUKTA
        0x1CD0 <= code && code <= 0x1CD2 || // Mn   [3] VEDIC TONE KARSHANA..VEDIC TONE PRENKHA
        0x1CD4 <= code && code <= 0x1CE0 || // Mn  [13] VEDIC SIGN YAJURVEDIC MIDLINE SVARITA..VEDIC TONE RIGVEDIC KASHMIRI INDEPENDENT SVARITA
        0x1CE2 <= code && code <= 0x1CE8 || // Mn   [7] VEDIC SIGN VISARGA SVARITA..VEDIC SIGN VISARGA ANUDATTA WITH TAIL
        0x1CED == code || // Mn       VEDIC SIGN TIRYAK
        0x1CF4 == code || // Mn       VEDIC TONE CANDRA ABOVE
        0x1CF8 <= code && code <= 0x1CF9 || // Mn   [2] VEDIC TONE RING ABOVE..VEDIC TONE DOUBLE RING ABOVE
        0x1DC0 <= code && code <= 0x1DF9 || // Mn  [58] COMBINING DOTTED GRAVE ACCENT..COMBINING WIDE INVERTED BRIDGE BELOW
        0x1DFB <= code && code <= 0x1DFF || // Mn   [5] COMBINING DELETION MARK..COMBINING RIGHT ARROWHEAD AND DOWN ARROWHEAD BELOW
        0x200C == code || // Cf       ZERO WIDTH NON-JOINER
        0x20D0 <= code && code <= 0x20DC || // Mn  [13] COMBINING LEFT HARPOON ABOVE..COMBINING FOUR DOTS ABOVE
        0x20DD <= code && code <= 0x20E0 || // Me   [4] COMBINING ENCLOSING CIRCLE..COMBINING ENCLOSING CIRCLE BACKSLASH
        0x20E1 == code || // Mn       COMBINING LEFT RIGHT ARROW ABOVE
        0x20E2 <= code && code <= 0x20E4 || // Me   [3] COMBINING ENCLOSING SCREEN..COMBINING ENCLOSING UPWARD POINTING TRIANGLE
        0x20E5 <= code && code <= 0x20F0 || // Mn  [12] COMBINING REVERSE SOLIDUS OVERLAY..COMBINING ASTERISK ABOVE
        0x2CEF <= code && code <= 0x2CF1 || // Mn   [3] COPTIC COMBINING NI ABOVE..COPTIC COMBINING SPIRITUS LENIS
        0x2D7F == code || // Mn       TIFINAGH CONSONANT JOINER
        0x2DE0 <= code && code <= 0x2DFF || // Mn  [32] COMBINING CYRILLIC LETTER BE..COMBINING CYRILLIC LETTER IOTIFIED BIG YUS
        0x302A <= code && code <= 0x302D || // Mn   [4] IDEOGRAPHIC LEVEL TONE MARK..IDEOGRAPHIC ENTERING TONE MARK
        0x302E <= code && code <= 0x302F || // Mc   [2] HANGUL SINGLE DOT TONE MARK..HANGUL DOUBLE DOT TONE MARK
        0x3099 <= code && code <= 0x309A || // Mn   [2] COMBINING KATAKANA-HIRAGANA VOICED SOUND MARK..COMBINING KATAKANA-HIRAGANA SEMI-VOICED SOUND MARK
        0xA66F == code || // Mn       COMBINING CYRILLIC VZMET
        0xA670 <= code && code <= 0xA672 || // Me   [3] COMBINING CYRILLIC TEN MILLIONS SIGN..COMBINING CYRILLIC THOUSAND MILLIONS SIGN
        0xA674 <= code && code <= 0xA67D || // Mn  [10] COMBINING CYRILLIC LETTER UKRAINIAN IE..COMBINING CYRILLIC PAYEROK
        0xA69E <= code && code <= 0xA69F || // Mn   [2] COMBINING CYRILLIC LETTER EF..COMBINING CYRILLIC LETTER IOTIFIED E
        0xA6F0 <= code && code <= 0xA6F1 || // Mn   [2] BAMUM COMBINING MARK KOQNDON..BAMUM COMBINING MARK TUKWENTIS
        0xA802 == code || // Mn       SYLOTI NAGRI SIGN DVISVARA
        0xA806 == code || // Mn       SYLOTI NAGRI SIGN HASANTA
        0xA80B == code || // Mn       SYLOTI NAGRI SIGN ANUSVARA
        0xA825 <= code && code <= 0xA826 || // Mn   [2] SYLOTI NAGRI VOWEL SIGN U..SYLOTI NAGRI VOWEL SIGN E
        0xA8C4 <= code && code <= 0xA8C5 || // Mn   [2] SAURASHTRA SIGN VIRAMA..SAURASHTRA SIGN CANDRABINDU
        0xA8E0 <= code && code <= 0xA8F1 || // Mn  [18] COMBINING DEVANAGARI DIGIT ZERO..COMBINING DEVANAGARI SIGN AVAGRAHA
        0xA926 <= code && code <= 0xA92D || // Mn   [8] KAYAH LI VOWEL UE..KAYAH LI TONE CALYA PLOPHU
        0xA947 <= code && code <= 0xA951 || // Mn  [11] REJANG VOWEL SIGN I..REJANG CONSONANT SIGN R
        0xA980 <= code && code <= 0xA982 || // Mn   [3] JAVANESE SIGN PANYANGGA..JAVANESE SIGN LAYAR
        0xA9B3 == code || // Mn       JAVANESE SIGN CECAK TELU
        0xA9B6 <= code && code <= 0xA9B9 || // Mn   [4] JAVANESE VOWEL SIGN WULU..JAVANESE VOWEL SIGN SUKU MENDUT
        0xA9BC == code || // Mn       JAVANESE VOWEL SIGN PEPET
        0xA9E5 == code || // Mn       MYANMAR SIGN SHAN SAW
        0xAA29 <= code && code <= 0xAA2E || // Mn   [6] CHAM VOWEL SIGN AA..CHAM VOWEL SIGN OE
        0xAA31 <= code && code <= 0xAA32 || // Mn   [2] CHAM VOWEL SIGN AU..CHAM VOWEL SIGN UE
        0xAA35 <= code && code <= 0xAA36 || // Mn   [2] CHAM CONSONANT SIGN LA..CHAM CONSONANT SIGN WA
        0xAA43 == code || // Mn       CHAM CONSONANT SIGN FINAL NG
        0xAA4C == code || // Mn       CHAM CONSONANT SIGN FINAL M
        0xAA7C == code || // Mn       MYANMAR SIGN TAI LAING TONE-2
        0xAAB0 == code || // Mn       TAI VIET MAI KANG
        0xAAB2 <= code && code <= 0xAAB4 || // Mn   [3] TAI VIET VOWEL I..TAI VIET VOWEL U
        0xAAB7 <= code && code <= 0xAAB8 || // Mn   [2] TAI VIET MAI KHIT..TAI VIET VOWEL IA
        0xAABE <= code && code <= 0xAABF || // Mn   [2] TAI VIET VOWEL AM..TAI VIET TONE MAI EK
        0xAAC1 == code || // Mn       TAI VIET TONE MAI THO
        0xAAEC <= code && code <= 0xAAED || // Mn   [2] MEETEI MAYEK VOWEL SIGN UU..MEETEI MAYEK VOWEL SIGN AAI
        0xAAF6 == code || // Mn       MEETEI MAYEK VIRAMA
        0xABE5 == code || // Mn       MEETEI MAYEK VOWEL SIGN ANAP
        0xABE8 == code || // Mn       MEETEI MAYEK VOWEL SIGN UNAP
        0xABED == code || // Mn       MEETEI MAYEK APUN IYEK
        0xFB1E == code || // Mn       HEBREW POINT JUDEO-SPANISH VARIKA
        0xFE00 <= code && code <= 0xFE0F || // Mn  [16] VARIATION SELECTOR-1..VARIATION SELECTOR-16
        0xFE20 <= code && code <= 0xFE2F || // Mn  [16] COMBINING LIGATURE LEFT HALF..COMBINING CYRILLIC TITLO RIGHT HALF
        0xFF9E <= code && code <= 0xFF9F || // Lm   [2] HALFWIDTH KATAKANA VOICED SOUND MARK..HALFWIDTH KATAKANA SEMI-VOICED SOUND MARK
        0x101FD == code || // Mn       PHAISTOS DISC SIGN COMBINING OBLIQUE STROKE
        0x102E0 == code || // Mn       COPTIC EPACT THOUSANDS MARK
        0x10376 <= code && code <= 0x1037A || // Mn   [5] COMBINING OLD PERMIC LETTER AN..COMBINING OLD PERMIC LETTER SII
        0x10A01 <= code && code <= 0x10A03 || // Mn   [3] KHAROSHTHI VOWEL SIGN I..KHAROSHTHI VOWEL SIGN VOCALIC R
        0x10A05 <= code && code <= 0x10A06 || // Mn   [2] KHAROSHTHI VOWEL SIGN E..KHAROSHTHI VOWEL SIGN O
        0x10A0C <= code && code <= 0x10A0F || // Mn   [4] KHAROSHTHI VOWEL LENGTH MARK..KHAROSHTHI SIGN VISARGA
        0x10A38 <= code && code <= 0x10A3A || // Mn   [3] KHAROSHTHI SIGN BAR ABOVE..KHAROSHTHI SIGN DOT BELOW
        0x10A3F == code || // Mn       KHAROSHTHI VIRAMA
        0x10AE5 <= code && code <= 0x10AE6 || // Mn   [2] MANICHAEAN ABBREVIATION MARK ABOVE..MANICHAEAN ABBREVIATION MARK BELOW
        0x11001 == code || // Mn       BRAHMI SIGN ANUSVARA
        0x11038 <= code && code <= 0x11046 || // Mn  [15] BRAHMI VOWEL SIGN AA..BRAHMI VIRAMA
        0x1107F <= code && code <= 0x11081 || // Mn   [3] BRAHMI NUMBER JOINER..KAITHI SIGN ANUSVARA
        0x110B3 <= code && code <= 0x110B6 || // Mn   [4] KAITHI VOWEL SIGN U..KAITHI VOWEL SIGN AI
        0x110B9 <= code && code <= 0x110BA || // Mn   [2] KAITHI SIGN VIRAMA..KAITHI SIGN NUKTA
        0x11100 <= code && code <= 0x11102 || // Mn   [3] CHAKMA SIGN CANDRABINDU..CHAKMA SIGN VISARGA
        0x11127 <= code && code <= 0x1112B || // Mn   [5] CHAKMA VOWEL SIGN A..CHAKMA VOWEL SIGN UU
        0x1112D <= code && code <= 0x11134 || // Mn   [8] CHAKMA VOWEL SIGN AI..CHAKMA MAAYYAA
        0x11173 == code || // Mn       MAHAJANI SIGN NUKTA
        0x11180 <= code && code <= 0x11181 || // Mn   [2] SHARADA SIGN CANDRABINDU..SHARADA SIGN ANUSVARA
        0x111B6 <= code && code <= 0x111BE || // Mn   [9] SHARADA VOWEL SIGN U..SHARADA VOWEL SIGN O
        0x111CA <= code && code <= 0x111CC || // Mn   [3] SHARADA SIGN NUKTA..SHARADA EXTRA SHORT VOWEL MARK
        0x1122F <= code && code <= 0x11231 || // Mn   [3] KHOJKI VOWEL SIGN U..KHOJKI VOWEL SIGN AI
        0x11234 == code || // Mn       KHOJKI SIGN ANUSVARA
        0x11236 <= code && code <= 0x11237 || // Mn   [2] KHOJKI SIGN NUKTA..KHOJKI SIGN SHADDA
        0x1123E == code || // Mn       KHOJKI SIGN SUKUN
        0x112DF == code || // Mn       KHUDAWADI SIGN ANUSVARA
        0x112E3 <= code && code <= 0x112EA || // Mn   [8] KHUDAWADI VOWEL SIGN U..KHUDAWADI SIGN VIRAMA
        0x11300 <= code && code <= 0x11301 || // Mn   [2] GRANTHA SIGN COMBINING ANUSVARA ABOVE..GRANTHA SIGN CANDRABINDU
        0x1133C == code || // Mn       GRANTHA SIGN NUKTA
        0x1133E == code || // Mc       GRANTHA VOWEL SIGN AA
        0x11340 == code || // Mn       GRANTHA VOWEL SIGN II
        0x11357 == code || // Mc       GRANTHA AU LENGTH MARK
        0x11366 <= code && code <= 0x1136C || // Mn   [7] COMBINING GRANTHA DIGIT ZERO..COMBINING GRANTHA DIGIT SIX
        0x11370 <= code && code <= 0x11374 || // Mn   [5] COMBINING GRANTHA LETTER A..COMBINING GRANTHA LETTER PA
        0x11438 <= code && code <= 0x1143F || // Mn   [8] NEWA VOWEL SIGN U..NEWA VOWEL SIGN AI
        0x11442 <= code && code <= 0x11444 || // Mn   [3] NEWA SIGN VIRAMA..NEWA SIGN ANUSVARA
        0x11446 == code || // Mn       NEWA SIGN NUKTA
        0x114B0 == code || // Mc       TIRHUTA VOWEL SIGN AA
        0x114B3 <= code && code <= 0x114B8 || // Mn   [6] TIRHUTA VOWEL SIGN U..TIRHUTA VOWEL SIGN VOCALIC LL
        0x114BA == code || // Mn       TIRHUTA VOWEL SIGN SHORT E
        0x114BD == code || // Mc       TIRHUTA VOWEL SIGN SHORT O
        0x114BF <= code && code <= 0x114C0 || // Mn   [2] TIRHUTA SIGN CANDRABINDU..TIRHUTA SIGN ANUSVARA
        0x114C2 <= code && code <= 0x114C3 || // Mn   [2] TIRHUTA SIGN VIRAMA..TIRHUTA SIGN NUKTA
        0x115AF == code || // Mc       SIDDHAM VOWEL SIGN AA
        0x115B2 <= code && code <= 0x115B5 || // Mn   [4] SIDDHAM VOWEL SIGN U..SIDDHAM VOWEL SIGN VOCALIC RR
        0x115BC <= code && code <= 0x115BD || // Mn   [2] SIDDHAM SIGN CANDRABINDU..SIDDHAM SIGN ANUSVARA
        0x115BF <= code && code <= 0x115C0 || // Mn   [2] SIDDHAM SIGN VIRAMA..SIDDHAM SIGN NUKTA
        0x115DC <= code && code <= 0x115DD || // Mn   [2] SIDDHAM VOWEL SIGN ALTERNATE U..SIDDHAM VOWEL SIGN ALTERNATE UU
        0x11633 <= code && code <= 0x1163A || // Mn   [8] MODI VOWEL SIGN U..MODI VOWEL SIGN AI
        0x1163D == code || // Mn       MODI SIGN ANUSVARA
        0x1163F <= code && code <= 0x11640 || // Mn   [2] MODI SIGN VIRAMA..MODI SIGN ARDHACANDRA
        0x116AB == code || // Mn       TAKRI SIGN ANUSVARA
        0x116AD == code || // Mn       TAKRI VOWEL SIGN AA
        0x116B0 <= code && code <= 0x116B5 || // Mn   [6] TAKRI VOWEL SIGN U..TAKRI VOWEL SIGN AU
        0x116B7 == code || // Mn       TAKRI SIGN NUKTA
        0x1171D <= code && code <= 0x1171F || // Mn   [3] AHOM CONSONANT SIGN MEDIAL LA..AHOM CONSONANT SIGN MEDIAL LIGATING RA
        0x11722 <= code && code <= 0x11725 || // Mn   [4] AHOM VOWEL SIGN I..AHOM VOWEL SIGN UU
        0x11727 <= code && code <= 0x1172B || // Mn   [5] AHOM VOWEL SIGN AW..AHOM SIGN KILLER
        0x11A01 <= code && code <= 0x11A06 || // Mn   [6] ZANABAZAR SQUARE VOWEL SIGN I..ZANABAZAR SQUARE VOWEL SIGN O
        0x11A09 <= code && code <= 0x11A0A || // Mn   [2] ZANABAZAR SQUARE VOWEL SIGN REVERSED I..ZANABAZAR SQUARE VOWEL LENGTH MARK
        0x11A33 <= code && code <= 0x11A38 || // Mn   [6] ZANABAZAR SQUARE FINAL CONSONANT MARK..ZANABAZAR SQUARE SIGN ANUSVARA
        0x11A3B <= code && code <= 0x11A3E || // Mn   [4] ZANABAZAR SQUARE CLUSTER-FINAL LETTER YA..ZANABAZAR SQUARE CLUSTER-FINAL LETTER VA
        0x11A47 == code || // Mn       ZANABAZAR SQUARE SUBJOINER
        0x11A51 <= code && code <= 0x11A56 || // Mn   [6] SOYOMBO VOWEL SIGN I..SOYOMBO VOWEL SIGN OE
        0x11A59 <= code && code <= 0x11A5B || // Mn   [3] SOYOMBO VOWEL SIGN VOCALIC R..SOYOMBO VOWEL LENGTH MARK
        0x11A8A <= code && code <= 0x11A96 || // Mn  [13] SOYOMBO FINAL CONSONANT SIGN G..SOYOMBO SIGN ANUSVARA
        0x11A98 <= code && code <= 0x11A99 || // Mn   [2] SOYOMBO GEMINATION MARK..SOYOMBO SUBJOINER
        0x11C30 <= code && code <= 0x11C36 || // Mn   [7] BHAIKSUKI VOWEL SIGN I..BHAIKSUKI VOWEL SIGN VOCALIC L
        0x11C38 <= code && code <= 0x11C3D || // Mn   [6] BHAIKSUKI VOWEL SIGN E..BHAIKSUKI SIGN ANUSVARA
        0x11C3F == code || // Mn       BHAIKSUKI SIGN VIRAMA
        0x11C92 <= code && code <= 0x11CA7 || // Mn  [22] MARCHEN SUBJOINED LETTER KA..MARCHEN SUBJOINED LETTER ZA
        0x11CAA <= code && code <= 0x11CB0 || // Mn   [7] MARCHEN SUBJOINED LETTER RA..MARCHEN VOWEL SIGN AA
        0x11CB2 <= code && code <= 0x11CB3 || // Mn   [2] MARCHEN VOWEL SIGN U..MARCHEN VOWEL SIGN E
        0x11CB5 <= code && code <= 0x11CB6 || // Mn   [2] MARCHEN SIGN ANUSVARA..MARCHEN SIGN CANDRABINDU
        0x11D31 <= code && code <= 0x11D36 || // Mn   [6] MASARAM GONDI VOWEL SIGN AA..MASARAM GONDI VOWEL SIGN VOCALIC R
        0x11D3A == code || // Mn       MASARAM GONDI VOWEL SIGN E
        0x11D3C <= code && code <= 0x11D3D || // Mn   [2] MASARAM GONDI VOWEL SIGN AI..MASARAM GONDI VOWEL SIGN O
        0x11D3F <= code && code <= 0x11D45 || // Mn   [7] MASARAM GONDI VOWEL SIGN AU..MASARAM GONDI VIRAMA
        0x11D47 == code || // Mn       MASARAM GONDI RA-KARA
        0x16AF0 <= code && code <= 0x16AF4 || // Mn   [5] BASSA VAH COMBINING HIGH TONE..BASSA VAH COMBINING HIGH-LOW TONE
        0x16B30 <= code && code <= 0x16B36 || // Mn   [7] PAHAWH HMONG MARK CIM TUB..PAHAWH HMONG MARK CIM TAUM
        0x16F8F <= code && code <= 0x16F92 || // Mn   [4] MIAO TONE RIGHT..MIAO TONE BELOW
        0x1BC9D <= code && code <= 0x1BC9E || // Mn   [2] DUPLOYAN THICK LETTER SELECTOR..DUPLOYAN DOUBLE MARK
        0x1D165 == code || // Mc       MUSICAL SYMBOL COMBINING STEM
        0x1D167 <= code && code <= 0x1D169 || // Mn   [3] MUSICAL SYMBOL COMBINING TREMOLO-1..MUSICAL SYMBOL COMBINING TREMOLO-3
        0x1D16E <= code && code <= 0x1D172 || // Mc   [5] MUSICAL SYMBOL COMBINING FLAG-1..MUSICAL SYMBOL COMBINING FLAG-5
        0x1D17B <= code && code <= 0x1D182 || // Mn   [8] MUSICAL SYMBOL COMBINING ACCENT..MUSICAL SYMBOL COMBINING LOURE
        0x1D185 <= code && code <= 0x1D18B || // Mn   [7] MUSICAL SYMBOL COMBINING DOIT..MUSICAL SYMBOL COMBINING TRIPLE TONGUE
        0x1D1AA <= code && code <= 0x1D1AD || // Mn   [4] MUSICAL SYMBOL COMBINING DOWN BOW..MUSICAL SYMBOL COMBINING SNAP PIZZICATO
        0x1D242 <= code && code <= 0x1D244 || // Mn   [3] COMBINING GREEK MUSICAL TRISEME..COMBINING GREEK MUSICAL PENTASEME
        0x1DA00 <= code && code <= 0x1DA36 || // Mn  [55] SIGNWRITING HEAD RIM..SIGNWRITING AIR SUCKING IN
        0x1DA3B <= code && code <= 0x1DA6C || // Mn  [50] SIGNWRITING MOUTH CLOSED NEUTRAL..SIGNWRITING EXCITEMENT
        0x1DA75 == code || // Mn       SIGNWRITING UPPER BODY TILTING FROM HIP JOINTS
        0x1DA84 == code || // Mn       SIGNWRITING LOCATION HEAD NECK
        0x1DA9B <= code && code <= 0x1DA9F || // Mn   [5] SIGNWRITING FILL MODIFIER-2..SIGNWRITING FILL MODIFIER-6
        0x1DAA1 <= code && code <= 0x1DAAF || // Mn  [15] SIGNWRITING ROTATION MODIFIER-2..SIGNWRITING ROTATION MODIFIER-16
        0x1E000 <= code && code <= 0x1E006 || // Mn   [7] COMBINING GLAGOLITIC LETTER AZU..COMBINING GLAGOLITIC LETTER ZHIVETE
        0x1E008 <= code && code <= 0x1E018 || // Mn  [17] COMBINING GLAGOLITIC LETTER ZEMLJA..COMBINING GLAGOLITIC LETTER HERU
        0x1E01B <= code && code <= 0x1E021 || // Mn   [7] COMBINING GLAGOLITIC LETTER SHTA..COMBINING GLAGOLITIC LETTER YATI
        0x1E023 <= code && code <= 0x1E024 || // Mn   [2] COMBINING GLAGOLITIC LETTER YU..COMBINING GLAGOLITIC LETTER SMALL YUS
        0x1E026 <= code && code <= 0x1E02A || // Mn   [5] COMBINING GLAGOLITIC LETTER YO..COMBINING GLAGOLITIC LETTER FITA
        0x1E8D0 <= code && code <= 0x1E8D6 || // Mn   [7] MENDE KIKAKUI COMBINING NUMBER TEENS..MENDE KIKAKUI COMBINING NUMBER MILLIONS
        0x1E944 <= code && code <= 0x1E94A || // Mn   [7] ADLAM ALIF LENGTHENER..ADLAM NUKTA
        0xE0020 <= code && code <= 0xE007F || // Cf  [96] TAG SPACE..CANCEL TAG
        0xE0100 <= code && code <= 0xE01EF // Mn [240] VARIATION SELECTOR-17..VARIATION SELECTOR-256
        ) return Extend;
        if (0x1F1E6 <= code && code <= 0x1F1FF // So  [26] REGIONAL INDICATOR SYMBOL LETTER A..REGIONAL INDICATOR SYMBOL LETTER Z
        ) return Regional_Indicator;
        if (0x0903 == code || // Mc       DEVANAGARI SIGN VISARGA
        0x093B == code || // Mc       DEVANAGARI VOWEL SIGN OOE
        0x093E <= code && code <= 0x0940 || // Mc   [3] DEVANAGARI VOWEL SIGN AA..DEVANAGARI VOWEL SIGN II
        0x0949 <= code && code <= 0x094C || // Mc   [4] DEVANAGARI VOWEL SIGN CANDRA O..DEVANAGARI VOWEL SIGN AU
        0x094E <= code && code <= 0x094F || // Mc   [2] DEVANAGARI VOWEL SIGN PRISHTHAMATRA E..DEVANAGARI VOWEL SIGN AW
        0x0982 <= code && code <= 0x0983 || // Mc   [2] BENGALI SIGN ANUSVARA..BENGALI SIGN VISARGA
        0x09BF <= code && code <= 0x09C0 || // Mc   [2] BENGALI VOWEL SIGN I..BENGALI VOWEL SIGN II
        0x09C7 <= code && code <= 0x09C8 || // Mc   [2] BENGALI VOWEL SIGN E..BENGALI VOWEL SIGN AI
        0x09CB <= code && code <= 0x09CC || // Mc   [2] BENGALI VOWEL SIGN O..BENGALI VOWEL SIGN AU
        0x0A03 == code || // Mc       GURMUKHI SIGN VISARGA
        0x0A3E <= code && code <= 0x0A40 || // Mc   [3] GURMUKHI VOWEL SIGN AA..GURMUKHI VOWEL SIGN II
        0x0A83 == code || // Mc       GUJARATI SIGN VISARGA
        0x0ABE <= code && code <= 0x0AC0 || // Mc   [3] GUJARATI VOWEL SIGN AA..GUJARATI VOWEL SIGN II
        0x0AC9 == code || // Mc       GUJARATI VOWEL SIGN CANDRA O
        0x0ACB <= code && code <= 0x0ACC || // Mc   [2] GUJARATI VOWEL SIGN O..GUJARATI VOWEL SIGN AU
        0x0B02 <= code && code <= 0x0B03 || // Mc   [2] ORIYA SIGN ANUSVARA..ORIYA SIGN VISARGA
        0x0B40 == code || // Mc       ORIYA VOWEL SIGN II
        0x0B47 <= code && code <= 0x0B48 || // Mc   [2] ORIYA VOWEL SIGN E..ORIYA VOWEL SIGN AI
        0x0B4B <= code && code <= 0x0B4C || // Mc   [2] ORIYA VOWEL SIGN O..ORIYA VOWEL SIGN AU
        0x0BBF == code || // Mc       TAMIL VOWEL SIGN I
        0x0BC1 <= code && code <= 0x0BC2 || // Mc   [2] TAMIL VOWEL SIGN U..TAMIL VOWEL SIGN UU
        0x0BC6 <= code && code <= 0x0BC8 || // Mc   [3] TAMIL VOWEL SIGN E..TAMIL VOWEL SIGN AI
        0x0BCA <= code && code <= 0x0BCC || // Mc   [3] TAMIL VOWEL SIGN O..TAMIL VOWEL SIGN AU
        0x0C01 <= code && code <= 0x0C03 || // Mc   [3] TELUGU SIGN CANDRABINDU..TELUGU SIGN VISARGA
        0x0C41 <= code && code <= 0x0C44 || // Mc   [4] TELUGU VOWEL SIGN U..TELUGU VOWEL SIGN VOCALIC RR
        0x0C82 <= code && code <= 0x0C83 || // Mc   [2] KANNADA SIGN ANUSVARA..KANNADA SIGN VISARGA
        0x0CBE == code || // Mc       KANNADA VOWEL SIGN AA
        0x0CC0 <= code && code <= 0x0CC1 || // Mc   [2] KANNADA VOWEL SIGN II..KANNADA VOWEL SIGN U
        0x0CC3 <= code && code <= 0x0CC4 || // Mc   [2] KANNADA VOWEL SIGN VOCALIC R..KANNADA VOWEL SIGN VOCALIC RR
        0x0CC7 <= code && code <= 0x0CC8 || // Mc   [2] KANNADA VOWEL SIGN EE..KANNADA VOWEL SIGN AI
        0x0CCA <= code && code <= 0x0CCB || // Mc   [2] KANNADA VOWEL SIGN O..KANNADA VOWEL SIGN OO
        0x0D02 <= code && code <= 0x0D03 || // Mc   [2] MALAYALAM SIGN ANUSVARA..MALAYALAM SIGN VISARGA
        0x0D3F <= code && code <= 0x0D40 || // Mc   [2] MALAYALAM VOWEL SIGN I..MALAYALAM VOWEL SIGN II
        0x0D46 <= code && code <= 0x0D48 || // Mc   [3] MALAYALAM VOWEL SIGN E..MALAYALAM VOWEL SIGN AI
        0x0D4A <= code && code <= 0x0D4C || // Mc   [3] MALAYALAM VOWEL SIGN O..MALAYALAM VOWEL SIGN AU
        0x0D82 <= code && code <= 0x0D83 || // Mc   [2] SINHALA SIGN ANUSVARAYA..SINHALA SIGN VISARGAYA
        0x0DD0 <= code && code <= 0x0DD1 || // Mc   [2] SINHALA VOWEL SIGN KETTI AEDA-PILLA..SINHALA VOWEL SIGN DIGA AEDA-PILLA
        0x0DD8 <= code && code <= 0x0DDE || // Mc   [7] SINHALA VOWEL SIGN GAETTA-PILLA..SINHALA VOWEL SIGN KOMBUVA HAA GAYANUKITTA
        0x0DF2 <= code && code <= 0x0DF3 || // Mc   [2] SINHALA VOWEL SIGN DIGA GAETTA-PILLA..SINHALA VOWEL SIGN DIGA GAYANUKITTA
        0x0E33 == code || // Lo       THAI CHARACTER SARA AM
        0x0EB3 == code || // Lo       LAO VOWEL SIGN AM
        0x0F3E <= code && code <= 0x0F3F || // Mc   [2] TIBETAN SIGN YAR TSHES..TIBETAN SIGN MAR TSHES
        0x0F7F == code || // Mc       TIBETAN SIGN RNAM BCAD
        0x1031 == code || // Mc       MYANMAR VOWEL SIGN E
        0x103B <= code && code <= 0x103C || // Mc   [2] MYANMAR CONSONANT SIGN MEDIAL YA..MYANMAR CONSONANT SIGN MEDIAL RA
        0x1056 <= code && code <= 0x1057 || // Mc   [2] MYANMAR VOWEL SIGN VOCALIC R..MYANMAR VOWEL SIGN VOCALIC RR
        0x1084 == code || // Mc       MYANMAR VOWEL SIGN SHAN E
        0x17B6 == code || // Mc       KHMER VOWEL SIGN AA
        0x17BE <= code && code <= 0x17C5 || // Mc   [8] KHMER VOWEL SIGN OE..KHMER VOWEL SIGN AU
        0x17C7 <= code && code <= 0x17C8 || // Mc   [2] KHMER SIGN REAHMUK..KHMER SIGN YUUKALEAPINTU
        0x1923 <= code && code <= 0x1926 || // Mc   [4] LIMBU VOWEL SIGN EE..LIMBU VOWEL SIGN AU
        0x1929 <= code && code <= 0x192B || // Mc   [3] LIMBU SUBJOINED LETTER YA..LIMBU SUBJOINED LETTER WA
        0x1930 <= code && code <= 0x1931 || // Mc   [2] LIMBU SMALL LETTER KA..LIMBU SMALL LETTER NGA
        0x1933 <= code && code <= 0x1938 || // Mc   [6] LIMBU SMALL LETTER TA..LIMBU SMALL LETTER LA
        0x1A19 <= code && code <= 0x1A1A || // Mc   [2] BUGINESE VOWEL SIGN E..BUGINESE VOWEL SIGN O
        0x1A55 == code || // Mc       TAI THAM CONSONANT SIGN MEDIAL RA
        0x1A57 == code || // Mc       TAI THAM CONSONANT SIGN LA TANG LAI
        0x1A6D <= code && code <= 0x1A72 || // Mc   [6] TAI THAM VOWEL SIGN OY..TAI THAM VOWEL SIGN THAM AI
        0x1B04 == code || // Mc       BALINESE SIGN BISAH
        0x1B35 == code || // Mc       BALINESE VOWEL SIGN TEDUNG
        0x1B3B == code || // Mc       BALINESE VOWEL SIGN RA REPA TEDUNG
        0x1B3D <= code && code <= 0x1B41 || // Mc   [5] BALINESE VOWEL SIGN LA LENGA TEDUNG..BALINESE VOWEL SIGN TALING REPA TEDUNG
        0x1B43 <= code && code <= 0x1B44 || // Mc   [2] BALINESE VOWEL SIGN PEPET TEDUNG..BALINESE ADEG ADEG
        0x1B82 == code || // Mc       SUNDANESE SIGN PANGWISAD
        0x1BA1 == code || // Mc       SUNDANESE CONSONANT SIGN PAMINGKAL
        0x1BA6 <= code && code <= 0x1BA7 || // Mc   [2] SUNDANESE VOWEL SIGN PANAELAENG..SUNDANESE VOWEL SIGN PANOLONG
        0x1BAA == code || // Mc       SUNDANESE SIGN PAMAAEH
        0x1BE7 == code || // Mc       BATAK VOWEL SIGN E
        0x1BEA <= code && code <= 0x1BEC || // Mc   [3] BATAK VOWEL SIGN I..BATAK VOWEL SIGN O
        0x1BEE == code || // Mc       BATAK VOWEL SIGN U
        0x1BF2 <= code && code <= 0x1BF3 || // Mc   [2] BATAK PANGOLAT..BATAK PANONGONAN
        0x1C24 <= code && code <= 0x1C2B || // Mc   [8] LEPCHA SUBJOINED LETTER YA..LEPCHA VOWEL SIGN UU
        0x1C34 <= code && code <= 0x1C35 || // Mc   [2] LEPCHA CONSONANT SIGN NYIN-DO..LEPCHA CONSONANT SIGN KANG
        0x1CE1 == code || // Mc       VEDIC TONE ATHARVAVEDIC INDEPENDENT SVARITA
        0x1CF2 <= code && code <= 0x1CF3 || // Mc   [2] VEDIC SIGN ARDHAVISARGA..VEDIC SIGN ROTATED ARDHAVISARGA
        0x1CF7 == code || // Mc       VEDIC SIGN ATIKRAMA
        0xA823 <= code && code <= 0xA824 || // Mc   [2] SYLOTI NAGRI VOWEL SIGN A..SYLOTI NAGRI VOWEL SIGN I
        0xA827 == code || // Mc       SYLOTI NAGRI VOWEL SIGN OO
        0xA880 <= code && code <= 0xA881 || // Mc   [2] SAURASHTRA SIGN ANUSVARA..SAURASHTRA SIGN VISARGA
        0xA8B4 <= code && code <= 0xA8C3 || // Mc  [16] SAURASHTRA CONSONANT SIGN HAARU..SAURASHTRA VOWEL SIGN AU
        0xA952 <= code && code <= 0xA953 || // Mc   [2] REJANG CONSONANT SIGN H..REJANG VIRAMA
        0xA983 == code || // Mc       JAVANESE SIGN WIGNYAN
        0xA9B4 <= code && code <= 0xA9B5 || // Mc   [2] JAVANESE VOWEL SIGN TARUNG..JAVANESE VOWEL SIGN TOLONG
        0xA9BA <= code && code <= 0xA9BB || // Mc   [2] JAVANESE VOWEL SIGN TALING..JAVANESE VOWEL SIGN DIRGA MURE
        0xA9BD <= code && code <= 0xA9C0 || // Mc   [4] JAVANESE CONSONANT SIGN KERET..JAVANESE PANGKON
        0xAA2F <= code && code <= 0xAA30 || // Mc   [2] CHAM VOWEL SIGN O..CHAM VOWEL SIGN AI
        0xAA33 <= code && code <= 0xAA34 || // Mc   [2] CHAM CONSONANT SIGN YA..CHAM CONSONANT SIGN RA
        0xAA4D == code || // Mc       CHAM CONSONANT SIGN FINAL H
        0xAAEB == code || // Mc       MEETEI MAYEK VOWEL SIGN II
        0xAAEE <= code && code <= 0xAAEF || // Mc   [2] MEETEI MAYEK VOWEL SIGN AU..MEETEI MAYEK VOWEL SIGN AAU
        0xAAF5 == code || // Mc       MEETEI MAYEK VOWEL SIGN VISARGA
        0xABE3 <= code && code <= 0xABE4 || // Mc   [2] MEETEI MAYEK VOWEL SIGN ONAP..MEETEI MAYEK VOWEL SIGN INAP
        0xABE6 <= code && code <= 0xABE7 || // Mc   [2] MEETEI MAYEK VOWEL SIGN YENAP..MEETEI MAYEK VOWEL SIGN SOUNAP
        0xABE9 <= code && code <= 0xABEA || // Mc   [2] MEETEI MAYEK VOWEL SIGN CHEINAP..MEETEI MAYEK VOWEL SIGN NUNG
        0xABEC == code || // Mc       MEETEI MAYEK LUM IYEK
        0x11000 == code || // Mc       BRAHMI SIGN CANDRABINDU
        0x11002 == code || // Mc       BRAHMI SIGN VISARGA
        0x11082 == code || // Mc       KAITHI SIGN VISARGA
        0x110B0 <= code && code <= 0x110B2 || // Mc   [3] KAITHI VOWEL SIGN AA..KAITHI VOWEL SIGN II
        0x110B7 <= code && code <= 0x110B8 || // Mc   [2] KAITHI VOWEL SIGN O..KAITHI VOWEL SIGN AU
        0x1112C == code || // Mc       CHAKMA VOWEL SIGN E
        0x11182 == code || // Mc       SHARADA SIGN VISARGA
        0x111B3 <= code && code <= 0x111B5 || // Mc   [3] SHARADA VOWEL SIGN AA..SHARADA VOWEL SIGN II
        0x111BF <= code && code <= 0x111C0 || // Mc   [2] SHARADA VOWEL SIGN AU..SHARADA SIGN VIRAMA
        0x1122C <= code && code <= 0x1122E || // Mc   [3] KHOJKI VOWEL SIGN AA..KHOJKI VOWEL SIGN II
        0x11232 <= code && code <= 0x11233 || // Mc   [2] KHOJKI VOWEL SIGN O..KHOJKI VOWEL SIGN AU
        0x11235 == code || // Mc       KHOJKI SIGN VIRAMA
        0x112E0 <= code && code <= 0x112E2 || // Mc   [3] KHUDAWADI VOWEL SIGN AA..KHUDAWADI VOWEL SIGN II
        0x11302 <= code && code <= 0x11303 || // Mc   [2] GRANTHA SIGN ANUSVARA..GRANTHA SIGN VISARGA
        0x1133F == code || // Mc       GRANTHA VOWEL SIGN I
        0x11341 <= code && code <= 0x11344 || // Mc   [4] GRANTHA VOWEL SIGN U..GRANTHA VOWEL SIGN VOCALIC RR
        0x11347 <= code && code <= 0x11348 || // Mc   [2] GRANTHA VOWEL SIGN EE..GRANTHA VOWEL SIGN AI
        0x1134B <= code && code <= 0x1134D || // Mc   [3] GRANTHA VOWEL SIGN OO..GRANTHA SIGN VIRAMA
        0x11362 <= code && code <= 0x11363 || // Mc   [2] GRANTHA VOWEL SIGN VOCALIC L..GRANTHA VOWEL SIGN VOCALIC LL
        0x11435 <= code && code <= 0x11437 || // Mc   [3] NEWA VOWEL SIGN AA..NEWA VOWEL SIGN II
        0x11440 <= code && code <= 0x11441 || // Mc   [2] NEWA VOWEL SIGN O..NEWA VOWEL SIGN AU
        0x11445 == code || // Mc       NEWA SIGN VISARGA
        0x114B1 <= code && code <= 0x114B2 || // Mc   [2] TIRHUTA VOWEL SIGN I..TIRHUTA VOWEL SIGN II
        0x114B9 == code || // Mc       TIRHUTA VOWEL SIGN E
        0x114BB <= code && code <= 0x114BC || // Mc   [2] TIRHUTA VOWEL SIGN AI..TIRHUTA VOWEL SIGN O
        0x114BE == code || // Mc       TIRHUTA VOWEL SIGN AU
        0x114C1 == code || // Mc       TIRHUTA SIGN VISARGA
        0x115B0 <= code && code <= 0x115B1 || // Mc   [2] SIDDHAM VOWEL SIGN I..SIDDHAM VOWEL SIGN II
        0x115B8 <= code && code <= 0x115BB || // Mc   [4] SIDDHAM VOWEL SIGN E..SIDDHAM VOWEL SIGN AU
        0x115BE == code || // Mc       SIDDHAM SIGN VISARGA
        0x11630 <= code && code <= 0x11632 || // Mc   [3] MODI VOWEL SIGN AA..MODI VOWEL SIGN II
        0x1163B <= code && code <= 0x1163C || // Mc   [2] MODI VOWEL SIGN O..MODI VOWEL SIGN AU
        0x1163E == code || // Mc       MODI SIGN VISARGA
        0x116AC == code || // Mc       TAKRI SIGN VISARGA
        0x116AE <= code && code <= 0x116AF || // Mc   [2] TAKRI VOWEL SIGN I..TAKRI VOWEL SIGN II
        0x116B6 == code || // Mc       TAKRI SIGN VIRAMA
        0x11720 <= code && code <= 0x11721 || // Mc   [2] AHOM VOWEL SIGN A..AHOM VOWEL SIGN AA
        0x11726 == code || // Mc       AHOM VOWEL SIGN E
        0x11A07 <= code && code <= 0x11A08 || // Mc   [2] ZANABAZAR SQUARE VOWEL SIGN AI..ZANABAZAR SQUARE VOWEL SIGN AU
        0x11A39 == code || // Mc       ZANABAZAR SQUARE SIGN VISARGA
        0x11A57 <= code && code <= 0x11A58 || // Mc   [2] SOYOMBO VOWEL SIGN AI..SOYOMBO VOWEL SIGN AU
        0x11A97 == code || // Mc       SOYOMBO SIGN VISARGA
        0x11C2F == code || // Mc       BHAIKSUKI VOWEL SIGN AA
        0x11C3E == code || // Mc       BHAIKSUKI SIGN VISARGA
        0x11CA9 == code || // Mc       MARCHEN SUBJOINED LETTER YA
        0x11CB1 == code || // Mc       MARCHEN VOWEL SIGN I
        0x11CB4 == code || // Mc       MARCHEN VOWEL SIGN O
        0x16F51 <= code && code <= 0x16F7E || // Mc  [46] MIAO SIGN ASPIRATION..MIAO VOWEL SIGN NG
        0x1D166 == code || // Mc       MUSICAL SYMBOL COMBINING SPRECHGESANG STEM
        0x1D16D == code // Mc       MUSICAL SYMBOL COMBINING AUGMENTATION DOT
        ) return SpacingMark;
        if (0x1100 <= code && code <= 0x115F || // Lo  [96] HANGUL CHOSEONG KIYEOK..HANGUL CHOSEONG FILLER
        0xA960 <= code && code <= 0xA97C // Lo  [29] HANGUL CHOSEONG TIKEUT-MIEUM..HANGUL CHOSEONG SSANGYEORINHIEUH
        ) return L;
        if (0x1160 <= code && code <= 0x11A7 || // Lo  [72] HANGUL JUNGSEONG FILLER..HANGUL JUNGSEONG O-YAE
        0xD7B0 <= code && code <= 0xD7C6 // Lo  [23] HANGUL JUNGSEONG O-YEO..HANGUL JUNGSEONG ARAEA-E
        ) return V;
        if (0x11A8 <= code && code <= 0x11FF || // Lo  [88] HANGUL JONGSEONG KIYEOK..HANGUL JONGSEONG SSANGNIEUN
        0xD7CB <= code && code <= 0xD7FB // Lo  [49] HANGUL JONGSEONG NIEUN-RIEUL..HANGUL JONGSEONG PHIEUPH-THIEUTH
        ) return T;
        if (0xAC00 == code || // Lo       HANGUL SYLLABLE GA
        0xAC1C == code || // Lo       HANGUL SYLLABLE GAE
        0xAC38 == code || // Lo       HANGUL SYLLABLE GYA
        0xAC54 == code || // Lo       HANGUL SYLLABLE GYAE
        0xAC70 == code || // Lo       HANGUL SYLLABLE GEO
        0xAC8C == code || // Lo       HANGUL SYLLABLE GE
        0xACA8 == code || // Lo       HANGUL SYLLABLE GYEO
        0xACC4 == code || // Lo       HANGUL SYLLABLE GYE
        0xACE0 == code || // Lo       HANGUL SYLLABLE GO
        0xACFC == code || // Lo       HANGUL SYLLABLE GWA
        0xAD18 == code || // Lo       HANGUL SYLLABLE GWAE
        0xAD34 == code || // Lo       HANGUL SYLLABLE GOE
        0xAD50 == code || // Lo       HANGUL SYLLABLE GYO
        0xAD6C == code || // Lo       HANGUL SYLLABLE GU
        0xAD88 == code || // Lo       HANGUL SYLLABLE GWEO
        0xADA4 == code || // Lo       HANGUL SYLLABLE GWE
        0xADC0 == code || // Lo       HANGUL SYLLABLE GWI
        0xADDC == code || // Lo       HANGUL SYLLABLE GYU
        0xADF8 == code || // Lo       HANGUL SYLLABLE GEU
        0xAE14 == code || // Lo       HANGUL SYLLABLE GYI
        0xAE30 == code || // Lo       HANGUL SYLLABLE GI
        0xAE4C == code || // Lo       HANGUL SYLLABLE GGA
        0xAE68 == code || // Lo       HANGUL SYLLABLE GGAE
        0xAE84 == code || // Lo       HANGUL SYLLABLE GGYA
        0xAEA0 == code || // Lo       HANGUL SYLLABLE GGYAE
        0xAEBC == code || // Lo       HANGUL SYLLABLE GGEO
        0xAED8 == code || // Lo       HANGUL SYLLABLE GGE
        0xAEF4 == code || // Lo       HANGUL SYLLABLE GGYEO
        0xAF10 == code || // Lo       HANGUL SYLLABLE GGYE
        0xAF2C == code || // Lo       HANGUL SYLLABLE GGO
        0xAF48 == code || // Lo       HANGUL SYLLABLE GGWA
        0xAF64 == code || // Lo       HANGUL SYLLABLE GGWAE
        0xAF80 == code || // Lo       HANGUL SYLLABLE GGOE
        0xAF9C == code || // Lo       HANGUL SYLLABLE GGYO
        0xAFB8 == code || // Lo       HANGUL SYLLABLE GGU
        0xAFD4 == code || // Lo       HANGUL SYLLABLE GGWEO
        0xAFF0 == code || // Lo       HANGUL SYLLABLE GGWE
        0xB00C == code || // Lo       HANGUL SYLLABLE GGWI
        0xB028 == code || // Lo       HANGUL SYLLABLE GGYU
        0xB044 == code || // Lo       HANGUL SYLLABLE GGEU
        0xB060 == code || // Lo       HANGUL SYLLABLE GGYI
        0xB07C == code || // Lo       HANGUL SYLLABLE GGI
        0xB098 == code || // Lo       HANGUL SYLLABLE NA
        0xB0B4 == code || // Lo       HANGUL SYLLABLE NAE
        0xB0D0 == code || // Lo       HANGUL SYLLABLE NYA
        0xB0EC == code || // Lo       HANGUL SYLLABLE NYAE
        0xB108 == code || // Lo       HANGUL SYLLABLE NEO
        0xB124 == code || // Lo       HANGUL SYLLABLE NE
        0xB140 == code || // Lo       HANGUL SYLLABLE NYEO
        0xB15C == code || // Lo       HANGUL SYLLABLE NYE
        0xB178 == code || // Lo       HANGUL SYLLABLE NO
        0xB194 == code || // Lo       HANGUL SYLLABLE NWA
        0xB1B0 == code || // Lo       HANGUL SYLLABLE NWAE
        0xB1CC == code || // Lo       HANGUL SYLLABLE NOE
        0xB1E8 == code || // Lo       HANGUL SYLLABLE NYO
        0xB204 == code || // Lo       HANGUL SYLLABLE NU
        0xB220 == code || // Lo       HANGUL SYLLABLE NWEO
        0xB23C == code || // Lo       HANGUL SYLLABLE NWE
        0xB258 == code || // Lo       HANGUL SYLLABLE NWI
        0xB274 == code || // Lo       HANGUL SYLLABLE NYU
        0xB290 == code || // Lo       HANGUL SYLLABLE NEU
        0xB2AC == code || // Lo       HANGUL SYLLABLE NYI
        0xB2C8 == code || // Lo       HANGUL SYLLABLE NI
        0xB2E4 == code || // Lo       HANGUL SYLLABLE DA
        0xB300 == code || // Lo       HANGUL SYLLABLE DAE
        0xB31C == code || // Lo       HANGUL SYLLABLE DYA
        0xB338 == code || // Lo       HANGUL SYLLABLE DYAE
        0xB354 == code || // Lo       HANGUL SYLLABLE DEO
        0xB370 == code || // Lo       HANGUL SYLLABLE DE
        0xB38C == code || // Lo       HANGUL SYLLABLE DYEO
        0xB3A8 == code || // Lo       HANGUL SYLLABLE DYE
        0xB3C4 == code || // Lo       HANGUL SYLLABLE DO
        0xB3E0 == code || // Lo       HANGUL SYLLABLE DWA
        0xB3FC == code || // Lo       HANGUL SYLLABLE DWAE
        0xB418 == code || // Lo       HANGUL SYLLABLE DOE
        0xB434 == code || // Lo       HANGUL SYLLABLE DYO
        0xB450 == code || // Lo       HANGUL SYLLABLE DU
        0xB46C == code || // Lo       HANGUL SYLLABLE DWEO
        0xB488 == code || // Lo       HANGUL SYLLABLE DWE
        0xB4A4 == code || // Lo       HANGUL SYLLABLE DWI
        0xB4C0 == code || // Lo       HANGUL SYLLABLE DYU
        0xB4DC == code || // Lo       HANGUL SYLLABLE DEU
        0xB4F8 == code || // Lo       HANGUL SYLLABLE DYI
        0xB514 == code || // Lo       HANGUL SYLLABLE DI
        0xB530 == code || // Lo       HANGUL SYLLABLE DDA
        0xB54C == code || // Lo       HANGUL SYLLABLE DDAE
        0xB568 == code || // Lo       HANGUL SYLLABLE DDYA
        0xB584 == code || // Lo       HANGUL SYLLABLE DDYAE
        0xB5A0 == code || // Lo       HANGUL SYLLABLE DDEO
        0xB5BC == code || // Lo       HANGUL SYLLABLE DDE
        0xB5D8 == code || // Lo       HANGUL SYLLABLE DDYEO
        0xB5F4 == code || // Lo       HANGUL SYLLABLE DDYE
        0xB610 == code || // Lo       HANGUL SYLLABLE DDO
        0xB62C == code || // Lo       HANGUL SYLLABLE DDWA
        0xB648 == code || // Lo       HANGUL SYLLABLE DDWAE
        0xB664 == code || // Lo       HANGUL SYLLABLE DDOE
        0xB680 == code || // Lo       HANGUL SYLLABLE DDYO
        0xB69C == code || // Lo       HANGUL SYLLABLE DDU
        0xB6B8 == code || // Lo       HANGUL SYLLABLE DDWEO
        0xB6D4 == code || // Lo       HANGUL SYLLABLE DDWE
        0xB6F0 == code || // Lo       HANGUL SYLLABLE DDWI
        0xB70C == code || // Lo       HANGUL SYLLABLE DDYU
        0xB728 == code || // Lo       HANGUL SYLLABLE DDEU
        0xB744 == code || // Lo       HANGUL SYLLABLE DDYI
        0xB760 == code || // Lo       HANGUL SYLLABLE DDI
        0xB77C == code || // Lo       HANGUL SYLLABLE RA
        0xB798 == code || // Lo       HANGUL SYLLABLE RAE
        0xB7B4 == code || // Lo       HANGUL SYLLABLE RYA
        0xB7D0 == code || // Lo       HANGUL SYLLABLE RYAE
        0xB7EC == code || // Lo       HANGUL SYLLABLE REO
        0xB808 == code || // Lo       HANGUL SYLLABLE RE
        0xB824 == code || // Lo       HANGUL SYLLABLE RYEO
        0xB840 == code || // Lo       HANGUL SYLLABLE RYE
        0xB85C == code || // Lo       HANGUL SYLLABLE RO
        0xB878 == code || // Lo       HANGUL SYLLABLE RWA
        0xB894 == code || // Lo       HANGUL SYLLABLE RWAE
        0xB8B0 == code || // Lo       HANGUL SYLLABLE ROE
        0xB8CC == code || // Lo       HANGUL SYLLABLE RYO
        0xB8E8 == code || // Lo       HANGUL SYLLABLE RU
        0xB904 == code || // Lo       HANGUL SYLLABLE RWEO
        0xB920 == code || // Lo       HANGUL SYLLABLE RWE
        0xB93C == code || // Lo       HANGUL SYLLABLE RWI
        0xB958 == code || // Lo       HANGUL SYLLABLE RYU
        0xB974 == code || // Lo       HANGUL SYLLABLE REU
        0xB990 == code || // Lo       HANGUL SYLLABLE RYI
        0xB9AC == code || // Lo       HANGUL SYLLABLE RI
        0xB9C8 == code || // Lo       HANGUL SYLLABLE MA
        0xB9E4 == code || // Lo       HANGUL SYLLABLE MAE
        0xBA00 == code || // Lo       HANGUL SYLLABLE MYA
        0xBA1C == code || // Lo       HANGUL SYLLABLE MYAE
        0xBA38 == code || // Lo       HANGUL SYLLABLE MEO
        0xBA54 == code || // Lo       HANGUL SYLLABLE ME
        0xBA70 == code || // Lo       HANGUL SYLLABLE MYEO
        0xBA8C == code || // Lo       HANGUL SYLLABLE MYE
        0xBAA8 == code || // Lo       HANGUL SYLLABLE MO
        0xBAC4 == code || // Lo       HANGUL SYLLABLE MWA
        0xBAE0 == code || // Lo       HANGUL SYLLABLE MWAE
        0xBAFC == code || // Lo       HANGUL SYLLABLE MOE
        0xBB18 == code || // Lo       HANGUL SYLLABLE MYO
        0xBB34 == code || // Lo       HANGUL SYLLABLE MU
        0xBB50 == code || // Lo       HANGUL SYLLABLE MWEO
        0xBB6C == code || // Lo       HANGUL SYLLABLE MWE
        0xBB88 == code || // Lo       HANGUL SYLLABLE MWI
        0xBBA4 == code || // Lo       HANGUL SYLLABLE MYU
        0xBBC0 == code || // Lo       HANGUL SYLLABLE MEU
        0xBBDC == code || // Lo       HANGUL SYLLABLE MYI
        0xBBF8 == code || // Lo       HANGUL SYLLABLE MI
        0xBC14 == code || // Lo       HANGUL SYLLABLE BA
        0xBC30 == code || // Lo       HANGUL SYLLABLE BAE
        0xBC4C == code || // Lo       HANGUL SYLLABLE BYA
        0xBC68 == code || // Lo       HANGUL SYLLABLE BYAE
        0xBC84 == code || // Lo       HANGUL SYLLABLE BEO
        0xBCA0 == code || // Lo       HANGUL SYLLABLE BE
        0xBCBC == code || // Lo       HANGUL SYLLABLE BYEO
        0xBCD8 == code || // Lo       HANGUL SYLLABLE BYE
        0xBCF4 == code || // Lo       HANGUL SYLLABLE BO
        0xBD10 == code || // Lo       HANGUL SYLLABLE BWA
        0xBD2C == code || // Lo       HANGUL SYLLABLE BWAE
        0xBD48 == code || // Lo       HANGUL SYLLABLE BOE
        0xBD64 == code || // Lo       HANGUL SYLLABLE BYO
        0xBD80 == code || // Lo       HANGUL SYLLABLE BU
        0xBD9C == code || // Lo       HANGUL SYLLABLE BWEO
        0xBDB8 == code || // Lo       HANGUL SYLLABLE BWE
        0xBDD4 == code || // Lo       HANGUL SYLLABLE BWI
        0xBDF0 == code || // Lo       HANGUL SYLLABLE BYU
        0xBE0C == code || // Lo       HANGUL SYLLABLE BEU
        0xBE28 == code || // Lo       HANGUL SYLLABLE BYI
        0xBE44 == code || // Lo       HANGUL SYLLABLE BI
        0xBE60 == code || // Lo       HANGUL SYLLABLE BBA
        0xBE7C == code || // Lo       HANGUL SYLLABLE BBAE
        0xBE98 == code || // Lo       HANGUL SYLLABLE BBYA
        0xBEB4 == code || // Lo       HANGUL SYLLABLE BBYAE
        0xBED0 == code || // Lo       HANGUL SYLLABLE BBEO
        0xBEEC == code || // Lo       HANGUL SYLLABLE BBE
        0xBF08 == code || // Lo       HANGUL SYLLABLE BBYEO
        0xBF24 == code || // Lo       HANGUL SYLLABLE BBYE
        0xBF40 == code || // Lo       HANGUL SYLLABLE BBO
        0xBF5C == code || // Lo       HANGUL SYLLABLE BBWA
        0xBF78 == code || // Lo       HANGUL SYLLABLE BBWAE
        0xBF94 == code || // Lo       HANGUL SYLLABLE BBOE
        0xBFB0 == code || // Lo       HANGUL SYLLABLE BBYO
        0xBFCC == code || // Lo       HANGUL SYLLABLE BBU
        0xBFE8 == code || // Lo       HANGUL SYLLABLE BBWEO
        0xC004 == code || // Lo       HANGUL SYLLABLE BBWE
        0xC020 == code || // Lo       HANGUL SYLLABLE BBWI
        0xC03C == code || // Lo       HANGUL SYLLABLE BBYU
        0xC058 == code || // Lo       HANGUL SYLLABLE BBEU
        0xC074 == code || // Lo       HANGUL SYLLABLE BBYI
        0xC090 == code || // Lo       HANGUL SYLLABLE BBI
        0xC0AC == code || // Lo       HANGUL SYLLABLE SA
        0xC0C8 == code || // Lo       HANGUL SYLLABLE SAE
        0xC0E4 == code || // Lo       HANGUL SYLLABLE SYA
        0xC100 == code || // Lo       HANGUL SYLLABLE SYAE
        0xC11C == code || // Lo       HANGUL SYLLABLE SEO
        0xC138 == code || // Lo       HANGUL SYLLABLE SE
        0xC154 == code || // Lo       HANGUL SYLLABLE SYEO
        0xC170 == code || // Lo       HANGUL SYLLABLE SYE
        0xC18C == code || // Lo       HANGUL SYLLABLE SO
        0xC1A8 == code || // Lo       HANGUL SYLLABLE SWA
        0xC1C4 == code || // Lo       HANGUL SYLLABLE SWAE
        0xC1E0 == code || // Lo       HANGUL SYLLABLE SOE
        0xC1FC == code || // Lo       HANGUL SYLLABLE SYO
        0xC218 == code || // Lo       HANGUL SYLLABLE SU
        0xC234 == code || // Lo       HANGUL SYLLABLE SWEO
        0xC250 == code || // Lo       HANGUL SYLLABLE SWE
        0xC26C == code || // Lo       HANGUL SYLLABLE SWI
        0xC288 == code || // Lo       HANGUL SYLLABLE SYU
        0xC2A4 == code || // Lo       HANGUL SYLLABLE SEU
        0xC2C0 == code || // Lo       HANGUL SYLLABLE SYI
        0xC2DC == code || // Lo       HANGUL SYLLABLE SI
        0xC2F8 == code || // Lo       HANGUL SYLLABLE SSA
        0xC314 == code || // Lo       HANGUL SYLLABLE SSAE
        0xC330 == code || // Lo       HANGUL SYLLABLE SSYA
        0xC34C == code || // Lo       HANGUL SYLLABLE SSYAE
        0xC368 == code || // Lo       HANGUL SYLLABLE SSEO
        0xC384 == code || // Lo       HANGUL SYLLABLE SSE
        0xC3A0 == code || // Lo       HANGUL SYLLABLE SSYEO
        0xC3BC == code || // Lo       HANGUL SYLLABLE SSYE
        0xC3D8 == code || // Lo       HANGUL SYLLABLE SSO
        0xC3F4 == code || // Lo       HANGUL SYLLABLE SSWA
        0xC410 == code || // Lo       HANGUL SYLLABLE SSWAE
        0xC42C == code || // Lo       HANGUL SYLLABLE SSOE
        0xC448 == code || // Lo       HANGUL SYLLABLE SSYO
        0xC464 == code || // Lo       HANGUL SYLLABLE SSU
        0xC480 == code || // Lo       HANGUL SYLLABLE SSWEO
        0xC49C == code || // Lo       HANGUL SYLLABLE SSWE
        0xC4B8 == code || // Lo       HANGUL SYLLABLE SSWI
        0xC4D4 == code || // Lo       HANGUL SYLLABLE SSYU
        0xC4F0 == code || // Lo       HANGUL SYLLABLE SSEU
        0xC50C == code || // Lo       HANGUL SYLLABLE SSYI
        0xC528 == code || // Lo       HANGUL SYLLABLE SSI
        0xC544 == code || // Lo       HANGUL SYLLABLE A
        0xC560 == code || // Lo       HANGUL SYLLABLE AE
        0xC57C == code || // Lo       HANGUL SYLLABLE YA
        0xC598 == code || // Lo       HANGUL SYLLABLE YAE
        0xC5B4 == code || // Lo       HANGUL SYLLABLE EO
        0xC5D0 == code || // Lo       HANGUL SYLLABLE E
        0xC5EC == code || // Lo       HANGUL SYLLABLE YEO
        0xC608 == code || // Lo       HANGUL SYLLABLE YE
        0xC624 == code || // Lo       HANGUL SYLLABLE O
        0xC640 == code || // Lo       HANGUL SYLLABLE WA
        0xC65C == code || // Lo       HANGUL SYLLABLE WAE
        0xC678 == code || // Lo       HANGUL SYLLABLE OE
        0xC694 == code || // Lo       HANGUL SYLLABLE YO
        0xC6B0 == code || // Lo       HANGUL SYLLABLE U
        0xC6CC == code || // Lo       HANGUL SYLLABLE WEO
        0xC6E8 == code || // Lo       HANGUL SYLLABLE WE
        0xC704 == code || // Lo       HANGUL SYLLABLE WI
        0xC720 == code || // Lo       HANGUL SYLLABLE YU
        0xC73C == code || // Lo       HANGUL SYLLABLE EU
        0xC758 == code || // Lo       HANGUL SYLLABLE YI
        0xC774 == code || // Lo       HANGUL SYLLABLE I
        0xC790 == code || // Lo       HANGUL SYLLABLE JA
        0xC7AC == code || // Lo       HANGUL SYLLABLE JAE
        0xC7C8 == code || // Lo       HANGUL SYLLABLE JYA
        0xC7E4 == code || // Lo       HANGUL SYLLABLE JYAE
        0xC800 == code || // Lo       HANGUL SYLLABLE JEO
        0xC81C == code || // Lo       HANGUL SYLLABLE JE
        0xC838 == code || // Lo       HANGUL SYLLABLE JYEO
        0xC854 == code || // Lo       HANGUL SYLLABLE JYE
        0xC870 == code || // Lo       HANGUL SYLLABLE JO
        0xC88C == code || // Lo       HANGUL SYLLABLE JWA
        0xC8A8 == code || // Lo       HANGUL SYLLABLE JWAE
        0xC8C4 == code || // Lo       HANGUL SYLLABLE JOE
        0xC8E0 == code || // Lo       HANGUL SYLLABLE JYO
        0xC8FC == code || // Lo       HANGUL SYLLABLE JU
        0xC918 == code || // Lo       HANGUL SYLLABLE JWEO
        0xC934 == code || // Lo       HANGUL SYLLABLE JWE
        0xC950 == code || // Lo       HANGUL SYLLABLE JWI
        0xC96C == code || // Lo       HANGUL SYLLABLE JYU
        0xC988 == code || // Lo       HANGUL SYLLABLE JEU
        0xC9A4 == code || // Lo       HANGUL SYLLABLE JYI
        0xC9C0 == code || // Lo       HANGUL SYLLABLE JI
        0xC9DC == code || // Lo       HANGUL SYLLABLE JJA
        0xC9F8 == code || // Lo       HANGUL SYLLABLE JJAE
        0xCA14 == code || // Lo       HANGUL SYLLABLE JJYA
        0xCA30 == code || // Lo       HANGUL SYLLABLE JJYAE
        0xCA4C == code || // Lo       HANGUL SYLLABLE JJEO
        0xCA68 == code || // Lo       HANGUL SYLLABLE JJE
        0xCA84 == code || // Lo       HANGUL SYLLABLE JJYEO
        0xCAA0 == code || // Lo       HANGUL SYLLABLE JJYE
        0xCABC == code || // Lo       HANGUL SYLLABLE JJO
        0xCAD8 == code || // Lo       HANGUL SYLLABLE JJWA
        0xCAF4 == code || // Lo       HANGUL SYLLABLE JJWAE
        0xCB10 == code || // Lo       HANGUL SYLLABLE JJOE
        0xCB2C == code || // Lo       HANGUL SYLLABLE JJYO
        0xCB48 == code || // Lo       HANGUL SYLLABLE JJU
        0xCB64 == code || // Lo       HANGUL SYLLABLE JJWEO
        0xCB80 == code || // Lo       HANGUL SYLLABLE JJWE
        0xCB9C == code || // Lo       HANGUL SYLLABLE JJWI
        0xCBB8 == code || // Lo       HANGUL SYLLABLE JJYU
        0xCBD4 == code || // Lo       HANGUL SYLLABLE JJEU
        0xCBF0 == code || // Lo       HANGUL SYLLABLE JJYI
        0xCC0C == code || // Lo       HANGUL SYLLABLE JJI
        0xCC28 == code || // Lo       HANGUL SYLLABLE CA
        0xCC44 == code || // Lo       HANGUL SYLLABLE CAE
        0xCC60 == code || // Lo       HANGUL SYLLABLE CYA
        0xCC7C == code || // Lo       HANGUL SYLLABLE CYAE
        0xCC98 == code || // Lo       HANGUL SYLLABLE CEO
        0xCCB4 == code || // Lo       HANGUL SYLLABLE CE
        0xCCD0 == code || // Lo       HANGUL SYLLABLE CYEO
        0xCCEC == code || // Lo       HANGUL SYLLABLE CYE
        0xCD08 == code || // Lo       HANGUL SYLLABLE CO
        0xCD24 == code || // Lo       HANGUL SYLLABLE CWA
        0xCD40 == code || // Lo       HANGUL SYLLABLE CWAE
        0xCD5C == code || // Lo       HANGUL SYLLABLE COE
        0xCD78 == code || // Lo       HANGUL SYLLABLE CYO
        0xCD94 == code || // Lo       HANGUL SYLLABLE CU
        0xCDB0 == code || // Lo       HANGUL SYLLABLE CWEO
        0xCDCC == code || // Lo       HANGUL SYLLABLE CWE
        0xCDE8 == code || // Lo       HANGUL SYLLABLE CWI
        0xCE04 == code || // Lo       HANGUL SYLLABLE CYU
        0xCE20 == code || // Lo       HANGUL SYLLABLE CEU
        0xCE3C == code || // Lo       HANGUL SYLLABLE CYI
        0xCE58 == code || // Lo       HANGUL SYLLABLE CI
        0xCE74 == code || // Lo       HANGUL SYLLABLE KA
        0xCE90 == code || // Lo       HANGUL SYLLABLE KAE
        0xCEAC == code || // Lo       HANGUL SYLLABLE KYA
        0xCEC8 == code || // Lo       HANGUL SYLLABLE KYAE
        0xCEE4 == code || // Lo       HANGUL SYLLABLE KEO
        0xCF00 == code || // Lo       HANGUL SYLLABLE KE
        0xCF1C == code || // Lo       HANGUL SYLLABLE KYEO
        0xCF38 == code || // Lo       HANGUL SYLLABLE KYE
        0xCF54 == code || // Lo       HANGUL SYLLABLE KO
        0xCF70 == code || // Lo       HANGUL SYLLABLE KWA
        0xCF8C == code || // Lo       HANGUL SYLLABLE KWAE
        0xCFA8 == code || // Lo       HANGUL SYLLABLE KOE
        0xCFC4 == code || // Lo       HANGUL SYLLABLE KYO
        0xCFE0 == code || // Lo       HANGUL SYLLABLE KU
        0xCFFC == code || // Lo       HANGUL SYLLABLE KWEO
        0xD018 == code || // Lo       HANGUL SYLLABLE KWE
        0xD034 == code || // Lo       HANGUL SYLLABLE KWI
        0xD050 == code || // Lo       HANGUL SYLLABLE KYU
        0xD06C == code || // Lo       HANGUL SYLLABLE KEU
        0xD088 == code || // Lo       HANGUL SYLLABLE KYI
        0xD0A4 == code || // Lo       HANGUL SYLLABLE KI
        0xD0C0 == code || // Lo       HANGUL SYLLABLE TA
        0xD0DC == code || // Lo       HANGUL SYLLABLE TAE
        0xD0F8 == code || // Lo       HANGUL SYLLABLE TYA
        0xD114 == code || // Lo       HANGUL SYLLABLE TYAE
        0xD130 == code || // Lo       HANGUL SYLLABLE TEO
        0xD14C == code || // Lo       HANGUL SYLLABLE TE
        0xD168 == code || // Lo       HANGUL SYLLABLE TYEO
        0xD184 == code || // Lo       HANGUL SYLLABLE TYE
        0xD1A0 == code || // Lo       HANGUL SYLLABLE TO
        0xD1BC == code || // Lo       HANGUL SYLLABLE TWA
        0xD1D8 == code || // Lo       HANGUL SYLLABLE TWAE
        0xD1F4 == code || // Lo       HANGUL SYLLABLE TOE
        0xD210 == code || // Lo       HANGUL SYLLABLE TYO
        0xD22C == code || // Lo       HANGUL SYLLABLE TU
        0xD248 == code || // Lo       HANGUL SYLLABLE TWEO
        0xD264 == code || // Lo       HANGUL SYLLABLE TWE
        0xD280 == code || // Lo       HANGUL SYLLABLE TWI
        0xD29C == code || // Lo       HANGUL SYLLABLE TYU
        0xD2B8 == code || // Lo       HANGUL SYLLABLE TEU
        0xD2D4 == code || // Lo       HANGUL SYLLABLE TYI
        0xD2F0 == code || // Lo       HANGUL SYLLABLE TI
        0xD30C == code || // Lo       HANGUL SYLLABLE PA
        0xD328 == code || // Lo       HANGUL SYLLABLE PAE
        0xD344 == code || // Lo       HANGUL SYLLABLE PYA
        0xD360 == code || // Lo       HANGUL SYLLABLE PYAE
        0xD37C == code || // Lo       HANGUL SYLLABLE PEO
        0xD398 == code || // Lo       HANGUL SYLLABLE PE
        0xD3B4 == code || // Lo       HANGUL SYLLABLE PYEO
        0xD3D0 == code || // Lo       HANGUL SYLLABLE PYE
        0xD3EC == code || // Lo       HANGUL SYLLABLE PO
        0xD408 == code || // Lo       HANGUL SYLLABLE PWA
        0xD424 == code || // Lo       HANGUL SYLLABLE PWAE
        0xD440 == code || // Lo       HANGUL SYLLABLE POE
        0xD45C == code || // Lo       HANGUL SYLLABLE PYO
        0xD478 == code || // Lo       HANGUL SYLLABLE PU
        0xD494 == code || // Lo       HANGUL SYLLABLE PWEO
        0xD4B0 == code || // Lo       HANGUL SYLLABLE PWE
        0xD4CC == code || // Lo       HANGUL SYLLABLE PWI
        0xD4E8 == code || // Lo       HANGUL SYLLABLE PYU
        0xD504 == code || // Lo       HANGUL SYLLABLE PEU
        0xD520 == code || // Lo       HANGUL SYLLABLE PYI
        0xD53C == code || // Lo       HANGUL SYLLABLE PI
        0xD558 == code || // Lo       HANGUL SYLLABLE HA
        0xD574 == code || // Lo       HANGUL SYLLABLE HAE
        0xD590 == code || // Lo       HANGUL SYLLABLE HYA
        0xD5AC == code || // Lo       HANGUL SYLLABLE HYAE
        0xD5C8 == code || // Lo       HANGUL SYLLABLE HEO
        0xD5E4 == code || // Lo       HANGUL SYLLABLE HE
        0xD600 == code || // Lo       HANGUL SYLLABLE HYEO
        0xD61C == code || // Lo       HANGUL SYLLABLE HYE
        0xD638 == code || // Lo       HANGUL SYLLABLE HO
        0xD654 == code || // Lo       HANGUL SYLLABLE HWA
        0xD670 == code || // Lo       HANGUL SYLLABLE HWAE
        0xD68C == code || // Lo       HANGUL SYLLABLE HOE
        0xD6A8 == code || // Lo       HANGUL SYLLABLE HYO
        0xD6C4 == code || // Lo       HANGUL SYLLABLE HU
        0xD6E0 == code || // Lo       HANGUL SYLLABLE HWEO
        0xD6FC == code || // Lo       HANGUL SYLLABLE HWE
        0xD718 == code || // Lo       HANGUL SYLLABLE HWI
        0xD734 == code || // Lo       HANGUL SYLLABLE HYU
        0xD750 == code || // Lo       HANGUL SYLLABLE HEU
        0xD76C == code || // Lo       HANGUL SYLLABLE HYI
        0xD788 == code // Lo       HANGUL SYLLABLE HI
        ) return LV;
        if (0xAC01 <= code && code <= 0xAC1B || // Lo  [27] HANGUL SYLLABLE GAG..HANGUL SYLLABLE GAH
        0xAC1D <= code && code <= 0xAC37 || // Lo  [27] HANGUL SYLLABLE GAEG..HANGUL SYLLABLE GAEH
        0xAC39 <= code && code <= 0xAC53 || // Lo  [27] HANGUL SYLLABLE GYAG..HANGUL SYLLABLE GYAH
        0xAC55 <= code && code <= 0xAC6F || // Lo  [27] HANGUL SYLLABLE GYAEG..HANGUL SYLLABLE GYAEH
        0xAC71 <= code && code <= 0xAC8B || // Lo  [27] HANGUL SYLLABLE GEOG..HANGUL SYLLABLE GEOH
        0xAC8D <= code && code <= 0xACA7 || // Lo  [27] HANGUL SYLLABLE GEG..HANGUL SYLLABLE GEH
        0xACA9 <= code && code <= 0xACC3 || // Lo  [27] HANGUL SYLLABLE GYEOG..HANGUL SYLLABLE GYEOH
        0xACC5 <= code && code <= 0xACDF || // Lo  [27] HANGUL SYLLABLE GYEG..HANGUL SYLLABLE GYEH
        0xACE1 <= code && code <= 0xACFB || // Lo  [27] HANGUL SYLLABLE GOG..HANGUL SYLLABLE GOH
        0xACFD <= code && code <= 0xAD17 || // Lo  [27] HANGUL SYLLABLE GWAG..HANGUL SYLLABLE GWAH
        0xAD19 <= code && code <= 0xAD33 || // Lo  [27] HANGUL SYLLABLE GWAEG..HANGUL SYLLABLE GWAEH
        0xAD35 <= code && code <= 0xAD4F || // Lo  [27] HANGUL SYLLABLE GOEG..HANGUL SYLLABLE GOEH
        0xAD51 <= code && code <= 0xAD6B || // Lo  [27] HANGUL SYLLABLE GYOG..HANGUL SYLLABLE GYOH
        0xAD6D <= code && code <= 0xAD87 || // Lo  [27] HANGUL SYLLABLE GUG..HANGUL SYLLABLE GUH
        0xAD89 <= code && code <= 0xADA3 || // Lo  [27] HANGUL SYLLABLE GWEOG..HANGUL SYLLABLE GWEOH
        0xADA5 <= code && code <= 0xADBF || // Lo  [27] HANGUL SYLLABLE GWEG..HANGUL SYLLABLE GWEH
        0xADC1 <= code && code <= 0xADDB || // Lo  [27] HANGUL SYLLABLE GWIG..HANGUL SYLLABLE GWIH
        0xADDD <= code && code <= 0xADF7 || // Lo  [27] HANGUL SYLLABLE GYUG..HANGUL SYLLABLE GYUH
        0xADF9 <= code && code <= 0xAE13 || // Lo  [27] HANGUL SYLLABLE GEUG..HANGUL SYLLABLE GEUH
        0xAE15 <= code && code <= 0xAE2F || // Lo  [27] HANGUL SYLLABLE GYIG..HANGUL SYLLABLE GYIH
        0xAE31 <= code && code <= 0xAE4B || // Lo  [27] HANGUL SYLLABLE GIG..HANGUL SYLLABLE GIH
        0xAE4D <= code && code <= 0xAE67 || // Lo  [27] HANGUL SYLLABLE GGAG..HANGUL SYLLABLE GGAH
        0xAE69 <= code && code <= 0xAE83 || // Lo  [27] HANGUL SYLLABLE GGAEG..HANGUL SYLLABLE GGAEH
        0xAE85 <= code && code <= 0xAE9F || // Lo  [27] HANGUL SYLLABLE GGYAG..HANGUL SYLLABLE GGYAH
        0xAEA1 <= code && code <= 0xAEBB || // Lo  [27] HANGUL SYLLABLE GGYAEG..HANGUL SYLLABLE GGYAEH
        0xAEBD <= code && code <= 0xAED7 || // Lo  [27] HANGUL SYLLABLE GGEOG..HANGUL SYLLABLE GGEOH
        0xAED9 <= code && code <= 0xAEF3 || // Lo  [27] HANGUL SYLLABLE GGEG..HANGUL SYLLABLE GGEH
        0xAEF5 <= code && code <= 0xAF0F || // Lo  [27] HANGUL SYLLABLE GGYEOG..HANGUL SYLLABLE GGYEOH
        0xAF11 <= code && code <= 0xAF2B || // Lo  [27] HANGUL SYLLABLE GGYEG..HANGUL SYLLABLE GGYEH
        0xAF2D <= code && code <= 0xAF47 || // Lo  [27] HANGUL SYLLABLE GGOG..HANGUL SYLLABLE GGOH
        0xAF49 <= code && code <= 0xAF63 || // Lo  [27] HANGUL SYLLABLE GGWAG..HANGUL SYLLABLE GGWAH
        0xAF65 <= code && code <= 0xAF7F || // Lo  [27] HANGUL SYLLABLE GGWAEG..HANGUL SYLLABLE GGWAEH
        0xAF81 <= code && code <= 0xAF9B || // Lo  [27] HANGUL SYLLABLE GGOEG..HANGUL SYLLABLE GGOEH
        0xAF9D <= code && code <= 0xAFB7 || // Lo  [27] HANGUL SYLLABLE GGYOG..HANGUL SYLLABLE GGYOH
        0xAFB9 <= code && code <= 0xAFD3 || // Lo  [27] HANGUL SYLLABLE GGUG..HANGUL SYLLABLE GGUH
        0xAFD5 <= code && code <= 0xAFEF || // Lo  [27] HANGUL SYLLABLE GGWEOG..HANGUL SYLLABLE GGWEOH
        0xAFF1 <= code && code <= 0xB00B || // Lo  [27] HANGUL SYLLABLE GGWEG..HANGUL SYLLABLE GGWEH
        0xB00D <= code && code <= 0xB027 || // Lo  [27] HANGUL SYLLABLE GGWIG..HANGUL SYLLABLE GGWIH
        0xB029 <= code && code <= 0xB043 || // Lo  [27] HANGUL SYLLABLE GGYUG..HANGUL SYLLABLE GGYUH
        0xB045 <= code && code <= 0xB05F || // Lo  [27] HANGUL SYLLABLE GGEUG..HANGUL SYLLABLE GGEUH
        0xB061 <= code && code <= 0xB07B || // Lo  [27] HANGUL SYLLABLE GGYIG..HANGUL SYLLABLE GGYIH
        0xB07D <= code && code <= 0xB097 || // Lo  [27] HANGUL SYLLABLE GGIG..HANGUL SYLLABLE GGIH
        0xB099 <= code && code <= 0xB0B3 || // Lo  [27] HANGUL SYLLABLE NAG..HANGUL SYLLABLE NAH
        0xB0B5 <= code && code <= 0xB0CF || // Lo  [27] HANGUL SYLLABLE NAEG..HANGUL SYLLABLE NAEH
        0xB0D1 <= code && code <= 0xB0EB || // Lo  [27] HANGUL SYLLABLE NYAG..HANGUL SYLLABLE NYAH
        0xB0ED <= code && code <= 0xB107 || // Lo  [27] HANGUL SYLLABLE NYAEG..HANGUL SYLLABLE NYAEH
        0xB109 <= code && code <= 0xB123 || // Lo  [27] HANGUL SYLLABLE NEOG..HANGUL SYLLABLE NEOH
        0xB125 <= code && code <= 0xB13F || // Lo  [27] HANGUL SYLLABLE NEG..HANGUL SYLLABLE NEH
        0xB141 <= code && code <= 0xB15B || // Lo  [27] HANGUL SYLLABLE NYEOG..HANGUL SYLLABLE NYEOH
        0xB15D <= code && code <= 0xB177 || // Lo  [27] HANGUL SYLLABLE NYEG..HANGUL SYLLABLE NYEH
        0xB179 <= code && code <= 0xB193 || // Lo  [27] HANGUL SYLLABLE NOG..HANGUL SYLLABLE NOH
        0xB195 <= code && code <= 0xB1AF || // Lo  [27] HANGUL SYLLABLE NWAG..HANGUL SYLLABLE NWAH
        0xB1B1 <= code && code <= 0xB1CB || // Lo  [27] HANGUL SYLLABLE NWAEG..HANGUL SYLLABLE NWAEH
        0xB1CD <= code && code <= 0xB1E7 || // Lo  [27] HANGUL SYLLABLE NOEG..HANGUL SYLLABLE NOEH
        0xB1E9 <= code && code <= 0xB203 || // Lo  [27] HANGUL SYLLABLE NYOG..HANGUL SYLLABLE NYOH
        0xB205 <= code && code <= 0xB21F || // Lo  [27] HANGUL SYLLABLE NUG..HANGUL SYLLABLE NUH
        0xB221 <= code && code <= 0xB23B || // Lo  [27] HANGUL SYLLABLE NWEOG..HANGUL SYLLABLE NWEOH
        0xB23D <= code && code <= 0xB257 || // Lo  [27] HANGUL SYLLABLE NWEG..HANGUL SYLLABLE NWEH
        0xB259 <= code && code <= 0xB273 || // Lo  [27] HANGUL SYLLABLE NWIG..HANGUL SYLLABLE NWIH
        0xB275 <= code && code <= 0xB28F || // Lo  [27] HANGUL SYLLABLE NYUG..HANGUL SYLLABLE NYUH
        0xB291 <= code && code <= 0xB2AB || // Lo  [27] HANGUL SYLLABLE NEUG..HANGUL SYLLABLE NEUH
        0xB2AD <= code && code <= 0xB2C7 || // Lo  [27] HANGUL SYLLABLE NYIG..HANGUL SYLLABLE NYIH
        0xB2C9 <= code && code <= 0xB2E3 || // Lo  [27] HANGUL SYLLABLE NIG..HANGUL SYLLABLE NIH
        0xB2E5 <= code && code <= 0xB2FF || // Lo  [27] HANGUL SYLLABLE DAG..HANGUL SYLLABLE DAH
        0xB301 <= code && code <= 0xB31B || // Lo  [27] HANGUL SYLLABLE DAEG..HANGUL SYLLABLE DAEH
        0xB31D <= code && code <= 0xB337 || // Lo  [27] HANGUL SYLLABLE DYAG..HANGUL SYLLABLE DYAH
        0xB339 <= code && code <= 0xB353 || // Lo  [27] HANGUL SYLLABLE DYAEG..HANGUL SYLLABLE DYAEH
        0xB355 <= code && code <= 0xB36F || // Lo  [27] HANGUL SYLLABLE DEOG..HANGUL SYLLABLE DEOH
        0xB371 <= code && code <= 0xB38B || // Lo  [27] HANGUL SYLLABLE DEG..HANGUL SYLLABLE DEH
        0xB38D <= code && code <= 0xB3A7 || // Lo  [27] HANGUL SYLLABLE DYEOG..HANGUL SYLLABLE DYEOH
        0xB3A9 <= code && code <= 0xB3C3 || // Lo  [27] HANGUL SYLLABLE DYEG..HANGUL SYLLABLE DYEH
        0xB3C5 <= code && code <= 0xB3DF || // Lo  [27] HANGUL SYLLABLE DOG..HANGUL SYLLABLE DOH
        0xB3E1 <= code && code <= 0xB3FB || // Lo  [27] HANGUL SYLLABLE DWAG..HANGUL SYLLABLE DWAH
        0xB3FD <= code && code <= 0xB417 || // Lo  [27] HANGUL SYLLABLE DWAEG..HANGUL SYLLABLE DWAEH
        0xB419 <= code && code <= 0xB433 || // Lo  [27] HANGUL SYLLABLE DOEG..HANGUL SYLLABLE DOEH
        0xB435 <= code && code <= 0xB44F || // Lo  [27] HANGUL SYLLABLE DYOG..HANGUL SYLLABLE DYOH
        0xB451 <= code && code <= 0xB46B || // Lo  [27] HANGUL SYLLABLE DUG..HANGUL SYLLABLE DUH
        0xB46D <= code && code <= 0xB487 || // Lo  [27] HANGUL SYLLABLE DWEOG..HANGUL SYLLABLE DWEOH
        0xB489 <= code && code <= 0xB4A3 || // Lo  [27] HANGUL SYLLABLE DWEG..HANGUL SYLLABLE DWEH
        0xB4A5 <= code && code <= 0xB4BF || // Lo  [27] HANGUL SYLLABLE DWIG..HANGUL SYLLABLE DWIH
        0xB4C1 <= code && code <= 0xB4DB || // Lo  [27] HANGUL SYLLABLE DYUG..HANGUL SYLLABLE DYUH
        0xB4DD <= code && code <= 0xB4F7 || // Lo  [27] HANGUL SYLLABLE DEUG..HANGUL SYLLABLE DEUH
        0xB4F9 <= code && code <= 0xB513 || // Lo  [27] HANGUL SYLLABLE DYIG..HANGUL SYLLABLE DYIH
        0xB515 <= code && code <= 0xB52F || // Lo  [27] HANGUL SYLLABLE DIG..HANGUL SYLLABLE DIH
        0xB531 <= code && code <= 0xB54B || // Lo  [27] HANGUL SYLLABLE DDAG..HANGUL SYLLABLE DDAH
        0xB54D <= code && code <= 0xB567 || // Lo  [27] HANGUL SYLLABLE DDAEG..HANGUL SYLLABLE DDAEH
        0xB569 <= code && code <= 0xB583 || // Lo  [27] HANGUL SYLLABLE DDYAG..HANGUL SYLLABLE DDYAH
        0xB585 <= code && code <= 0xB59F || // Lo  [27] HANGUL SYLLABLE DDYAEG..HANGUL SYLLABLE DDYAEH
        0xB5A1 <= code && code <= 0xB5BB || // Lo  [27] HANGUL SYLLABLE DDEOG..HANGUL SYLLABLE DDEOH
        0xB5BD <= code && code <= 0xB5D7 || // Lo  [27] HANGUL SYLLABLE DDEG..HANGUL SYLLABLE DDEH
        0xB5D9 <= code && code <= 0xB5F3 || // Lo  [27] HANGUL SYLLABLE DDYEOG..HANGUL SYLLABLE DDYEOH
        0xB5F5 <= code && code <= 0xB60F || // Lo  [27] HANGUL SYLLABLE DDYEG..HANGUL SYLLABLE DDYEH
        0xB611 <= code && code <= 0xB62B || // Lo  [27] HANGUL SYLLABLE DDOG..HANGUL SYLLABLE DDOH
        0xB62D <= code && code <= 0xB647 || // Lo  [27] HANGUL SYLLABLE DDWAG..HANGUL SYLLABLE DDWAH
        0xB649 <= code && code <= 0xB663 || // Lo  [27] HANGUL SYLLABLE DDWAEG..HANGUL SYLLABLE DDWAEH
        0xB665 <= code && code <= 0xB67F || // Lo  [27] HANGUL SYLLABLE DDOEG..HANGUL SYLLABLE DDOEH
        0xB681 <= code && code <= 0xB69B || // Lo  [27] HANGUL SYLLABLE DDYOG..HANGUL SYLLABLE DDYOH
        0xB69D <= code && code <= 0xB6B7 || // Lo  [27] HANGUL SYLLABLE DDUG..HANGUL SYLLABLE DDUH
        0xB6B9 <= code && code <= 0xB6D3 || // Lo  [27] HANGUL SYLLABLE DDWEOG..HANGUL SYLLABLE DDWEOH
        0xB6D5 <= code && code <= 0xB6EF || // Lo  [27] HANGUL SYLLABLE DDWEG..HANGUL SYLLABLE DDWEH
        0xB6F1 <= code && code <= 0xB70B || // Lo  [27] HANGUL SYLLABLE DDWIG..HANGUL SYLLABLE DDWIH
        0xB70D <= code && code <= 0xB727 || // Lo  [27] HANGUL SYLLABLE DDYUG..HANGUL SYLLABLE DDYUH
        0xB729 <= code && code <= 0xB743 || // Lo  [27] HANGUL SYLLABLE DDEUG..HANGUL SYLLABLE DDEUH
        0xB745 <= code && code <= 0xB75F || // Lo  [27] HANGUL SYLLABLE DDYIG..HANGUL SYLLABLE DDYIH
        0xB761 <= code && code <= 0xB77B || // Lo  [27] HANGUL SYLLABLE DDIG..HANGUL SYLLABLE DDIH
        0xB77D <= code && code <= 0xB797 || // Lo  [27] HANGUL SYLLABLE RAG..HANGUL SYLLABLE RAH
        0xB799 <= code && code <= 0xB7B3 || // Lo  [27] HANGUL SYLLABLE RAEG..HANGUL SYLLABLE RAEH
        0xB7B5 <= code && code <= 0xB7CF || // Lo  [27] HANGUL SYLLABLE RYAG..HANGUL SYLLABLE RYAH
        0xB7D1 <= code && code <= 0xB7EB || // Lo  [27] HANGUL SYLLABLE RYAEG..HANGUL SYLLABLE RYAEH
        0xB7ED <= code && code <= 0xB807 || // Lo  [27] HANGUL SYLLABLE REOG..HANGUL SYLLABLE REOH
        0xB809 <= code && code <= 0xB823 || // Lo  [27] HANGUL SYLLABLE REG..HANGUL SYLLABLE REH
        0xB825 <= code && code <= 0xB83F || // Lo  [27] HANGUL SYLLABLE RYEOG..HANGUL SYLLABLE RYEOH
        0xB841 <= code && code <= 0xB85B || // Lo  [27] HANGUL SYLLABLE RYEG..HANGUL SYLLABLE RYEH
        0xB85D <= code && code <= 0xB877 || // Lo  [27] HANGUL SYLLABLE ROG..HANGUL SYLLABLE ROH
        0xB879 <= code && code <= 0xB893 || // Lo  [27] HANGUL SYLLABLE RWAG..HANGUL SYLLABLE RWAH
        0xB895 <= code && code <= 0xB8AF || // Lo  [27] HANGUL SYLLABLE RWAEG..HANGUL SYLLABLE RWAEH
        0xB8B1 <= code && code <= 0xB8CB || // Lo  [27] HANGUL SYLLABLE ROEG..HANGUL SYLLABLE ROEH
        0xB8CD <= code && code <= 0xB8E7 || // Lo  [27] HANGUL SYLLABLE RYOG..HANGUL SYLLABLE RYOH
        0xB8E9 <= code && code <= 0xB903 || // Lo  [27] HANGUL SYLLABLE RUG..HANGUL SYLLABLE RUH
        0xB905 <= code && code <= 0xB91F || // Lo  [27] HANGUL SYLLABLE RWEOG..HANGUL SYLLABLE RWEOH
        0xB921 <= code && code <= 0xB93B || // Lo  [27] HANGUL SYLLABLE RWEG..HANGUL SYLLABLE RWEH
        0xB93D <= code && code <= 0xB957 || // Lo  [27] HANGUL SYLLABLE RWIG..HANGUL SYLLABLE RWIH
        0xB959 <= code && code <= 0xB973 || // Lo  [27] HANGUL SYLLABLE RYUG..HANGUL SYLLABLE RYUH
        0xB975 <= code && code <= 0xB98F || // Lo  [27] HANGUL SYLLABLE REUG..HANGUL SYLLABLE REUH
        0xB991 <= code && code <= 0xB9AB || // Lo  [27] HANGUL SYLLABLE RYIG..HANGUL SYLLABLE RYIH
        0xB9AD <= code && code <= 0xB9C7 || // Lo  [27] HANGUL SYLLABLE RIG..HANGUL SYLLABLE RIH
        0xB9C9 <= code && code <= 0xB9E3 || // Lo  [27] HANGUL SYLLABLE MAG..HANGUL SYLLABLE MAH
        0xB9E5 <= code && code <= 0xB9FF || // Lo  [27] HANGUL SYLLABLE MAEG..HANGUL SYLLABLE MAEH
        0xBA01 <= code && code <= 0xBA1B || // Lo  [27] HANGUL SYLLABLE MYAG..HANGUL SYLLABLE MYAH
        0xBA1D <= code && code <= 0xBA37 || // Lo  [27] HANGUL SYLLABLE MYAEG..HANGUL SYLLABLE MYAEH
        0xBA39 <= code && code <= 0xBA53 || // Lo  [27] HANGUL SYLLABLE MEOG..HANGUL SYLLABLE MEOH
        0xBA55 <= code && code <= 0xBA6F || // Lo  [27] HANGUL SYLLABLE MEG..HANGUL SYLLABLE MEH
        0xBA71 <= code && code <= 0xBA8B || // Lo  [27] HANGUL SYLLABLE MYEOG..HANGUL SYLLABLE MYEOH
        0xBA8D <= code && code <= 0xBAA7 || // Lo  [27] HANGUL SYLLABLE MYEG..HANGUL SYLLABLE MYEH
        0xBAA9 <= code && code <= 0xBAC3 || // Lo  [27] HANGUL SYLLABLE MOG..HANGUL SYLLABLE MOH
        0xBAC5 <= code && code <= 0xBADF || // Lo  [27] HANGUL SYLLABLE MWAG..HANGUL SYLLABLE MWAH
        0xBAE1 <= code && code <= 0xBAFB || // Lo  [27] HANGUL SYLLABLE MWAEG..HANGUL SYLLABLE MWAEH
        0xBAFD <= code && code <= 0xBB17 || // Lo  [27] HANGUL SYLLABLE MOEG..HANGUL SYLLABLE MOEH
        0xBB19 <= code && code <= 0xBB33 || // Lo  [27] HANGUL SYLLABLE MYOG..HANGUL SYLLABLE MYOH
        0xBB35 <= code && code <= 0xBB4F || // Lo  [27] HANGUL SYLLABLE MUG..HANGUL SYLLABLE MUH
        0xBB51 <= code && code <= 0xBB6B || // Lo  [27] HANGUL SYLLABLE MWEOG..HANGUL SYLLABLE MWEOH
        0xBB6D <= code && code <= 0xBB87 || // Lo  [27] HANGUL SYLLABLE MWEG..HANGUL SYLLABLE MWEH
        0xBB89 <= code && code <= 0xBBA3 || // Lo  [27] HANGUL SYLLABLE MWIG..HANGUL SYLLABLE MWIH
        0xBBA5 <= code && code <= 0xBBBF || // Lo  [27] HANGUL SYLLABLE MYUG..HANGUL SYLLABLE MYUH
        0xBBC1 <= code && code <= 0xBBDB || // Lo  [27] HANGUL SYLLABLE MEUG..HANGUL SYLLABLE MEUH
        0xBBDD <= code && code <= 0xBBF7 || // Lo  [27] HANGUL SYLLABLE MYIG..HANGUL SYLLABLE MYIH
        0xBBF9 <= code && code <= 0xBC13 || // Lo  [27] HANGUL SYLLABLE MIG..HANGUL SYLLABLE MIH
        0xBC15 <= code && code <= 0xBC2F || // Lo  [27] HANGUL SYLLABLE BAG..HANGUL SYLLABLE BAH
        0xBC31 <= code && code <= 0xBC4B || // Lo  [27] HANGUL SYLLABLE BAEG..HANGUL SYLLABLE BAEH
        0xBC4D <= code && code <= 0xBC67 || // Lo  [27] HANGUL SYLLABLE BYAG..HANGUL SYLLABLE BYAH
        0xBC69 <= code && code <= 0xBC83 || // Lo  [27] HANGUL SYLLABLE BYAEG..HANGUL SYLLABLE BYAEH
        0xBC85 <= code && code <= 0xBC9F || // Lo  [27] HANGUL SYLLABLE BEOG..HANGUL SYLLABLE BEOH
        0xBCA1 <= code && code <= 0xBCBB || // Lo  [27] HANGUL SYLLABLE BEG..HANGUL SYLLABLE BEH
        0xBCBD <= code && code <= 0xBCD7 || // Lo  [27] HANGUL SYLLABLE BYEOG..HANGUL SYLLABLE BYEOH
        0xBCD9 <= code && code <= 0xBCF3 || // Lo  [27] HANGUL SYLLABLE BYEG..HANGUL SYLLABLE BYEH
        0xBCF5 <= code && code <= 0xBD0F || // Lo  [27] HANGUL SYLLABLE BOG..HANGUL SYLLABLE BOH
        0xBD11 <= code && code <= 0xBD2B || // Lo  [27] HANGUL SYLLABLE BWAG..HANGUL SYLLABLE BWAH
        0xBD2D <= code && code <= 0xBD47 || // Lo  [27] HANGUL SYLLABLE BWAEG..HANGUL SYLLABLE BWAEH
        0xBD49 <= code && code <= 0xBD63 || // Lo  [27] HANGUL SYLLABLE BOEG..HANGUL SYLLABLE BOEH
        0xBD65 <= code && code <= 0xBD7F || // Lo  [27] HANGUL SYLLABLE BYOG..HANGUL SYLLABLE BYOH
        0xBD81 <= code && code <= 0xBD9B || // Lo  [27] HANGUL SYLLABLE BUG..HANGUL SYLLABLE BUH
        0xBD9D <= code && code <= 0xBDB7 || // Lo  [27] HANGUL SYLLABLE BWEOG..HANGUL SYLLABLE BWEOH
        0xBDB9 <= code && code <= 0xBDD3 || // Lo  [27] HANGUL SYLLABLE BWEG..HANGUL SYLLABLE BWEH
        0xBDD5 <= code && code <= 0xBDEF || // Lo  [27] HANGUL SYLLABLE BWIG..HANGUL SYLLABLE BWIH
        0xBDF1 <= code && code <= 0xBE0B || // Lo  [27] HANGUL SYLLABLE BYUG..HANGUL SYLLABLE BYUH
        0xBE0D <= code && code <= 0xBE27 || // Lo  [27] HANGUL SYLLABLE BEUG..HANGUL SYLLABLE BEUH
        0xBE29 <= code && code <= 0xBE43 || // Lo  [27] HANGUL SYLLABLE BYIG..HANGUL SYLLABLE BYIH
        0xBE45 <= code && code <= 0xBE5F || // Lo  [27] HANGUL SYLLABLE BIG..HANGUL SYLLABLE BIH
        0xBE61 <= code && code <= 0xBE7B || // Lo  [27] HANGUL SYLLABLE BBAG..HANGUL SYLLABLE BBAH
        0xBE7D <= code && code <= 0xBE97 || // Lo  [27] HANGUL SYLLABLE BBAEG..HANGUL SYLLABLE BBAEH
        0xBE99 <= code && code <= 0xBEB3 || // Lo  [27] HANGUL SYLLABLE BBYAG..HANGUL SYLLABLE BBYAH
        0xBEB5 <= code && code <= 0xBECF || // Lo  [27] HANGUL SYLLABLE BBYAEG..HANGUL SYLLABLE BBYAEH
        0xBED1 <= code && code <= 0xBEEB || // Lo  [27] HANGUL SYLLABLE BBEOG..HANGUL SYLLABLE BBEOH
        0xBEED <= code && code <= 0xBF07 || // Lo  [27] HANGUL SYLLABLE BBEG..HANGUL SYLLABLE BBEH
        0xBF09 <= code && code <= 0xBF23 || // Lo  [27] HANGUL SYLLABLE BBYEOG..HANGUL SYLLABLE BBYEOH
        0xBF25 <= code && code <= 0xBF3F || // Lo  [27] HANGUL SYLLABLE BBYEG..HANGUL SYLLABLE BBYEH
        0xBF41 <= code && code <= 0xBF5B || // Lo  [27] HANGUL SYLLABLE BBOG..HANGUL SYLLABLE BBOH
        0xBF5D <= code && code <= 0xBF77 || // Lo  [27] HANGUL SYLLABLE BBWAG..HANGUL SYLLABLE BBWAH
        0xBF79 <= code && code <= 0xBF93 || // Lo  [27] HANGUL SYLLABLE BBWAEG..HANGUL SYLLABLE BBWAEH
        0xBF95 <= code && code <= 0xBFAF || // Lo  [27] HANGUL SYLLABLE BBOEG..HANGUL SYLLABLE BBOEH
        0xBFB1 <= code && code <= 0xBFCB || // Lo  [27] HANGUL SYLLABLE BBYOG..HANGUL SYLLABLE BBYOH
        0xBFCD <= code && code <= 0xBFE7 || // Lo  [27] HANGUL SYLLABLE BBUG..HANGUL SYLLABLE BBUH
        0xBFE9 <= code && code <= 0xC003 || // Lo  [27] HANGUL SYLLABLE BBWEOG..HANGUL SYLLABLE BBWEOH
        0xC005 <= code && code <= 0xC01F || // Lo  [27] HANGUL SYLLABLE BBWEG..HANGUL SYLLABLE BBWEH
        0xC021 <= code && code <= 0xC03B || // Lo  [27] HANGUL SYLLABLE BBWIG..HANGUL SYLLABLE BBWIH
        0xC03D <= code && code <= 0xC057 || // Lo  [27] HANGUL SYLLABLE BBYUG..HANGUL SYLLABLE BBYUH
        0xC059 <= code && code <= 0xC073 || // Lo  [27] HANGUL SYLLABLE BBEUG..HANGUL SYLLABLE BBEUH
        0xC075 <= code && code <= 0xC08F || // Lo  [27] HANGUL SYLLABLE BBYIG..HANGUL SYLLABLE BBYIH
        0xC091 <= code && code <= 0xC0AB || // Lo  [27] HANGUL SYLLABLE BBIG..HANGUL SYLLABLE BBIH
        0xC0AD <= code && code <= 0xC0C7 || // Lo  [27] HANGUL SYLLABLE SAG..HANGUL SYLLABLE SAH
        0xC0C9 <= code && code <= 0xC0E3 || // Lo  [27] HANGUL SYLLABLE SAEG..HANGUL SYLLABLE SAEH
        0xC0E5 <= code && code <= 0xC0FF || // Lo  [27] HANGUL SYLLABLE SYAG..HANGUL SYLLABLE SYAH
        0xC101 <= code && code <= 0xC11B || // Lo  [27] HANGUL SYLLABLE SYAEG..HANGUL SYLLABLE SYAEH
        0xC11D <= code && code <= 0xC137 || // Lo  [27] HANGUL SYLLABLE SEOG..HANGUL SYLLABLE SEOH
        0xC139 <= code && code <= 0xC153 || // Lo  [27] HANGUL SYLLABLE SEG..HANGUL SYLLABLE SEH
        0xC155 <= code && code <= 0xC16F || // Lo  [27] HANGUL SYLLABLE SYEOG..HANGUL SYLLABLE SYEOH
        0xC171 <= code && code <= 0xC18B || // Lo  [27] HANGUL SYLLABLE SYEG..HANGUL SYLLABLE SYEH
        0xC18D <= code && code <= 0xC1A7 || // Lo  [27] HANGUL SYLLABLE SOG..HANGUL SYLLABLE SOH
        0xC1A9 <= code && code <= 0xC1C3 || // Lo  [27] HANGUL SYLLABLE SWAG..HANGUL SYLLABLE SWAH
        0xC1C5 <= code && code <= 0xC1DF || // Lo  [27] HANGUL SYLLABLE SWAEG..HANGUL SYLLABLE SWAEH
        0xC1E1 <= code && code <= 0xC1FB || // Lo  [27] HANGUL SYLLABLE SOEG..HANGUL SYLLABLE SOEH
        0xC1FD <= code && code <= 0xC217 || // Lo  [27] HANGUL SYLLABLE SYOG..HANGUL SYLLABLE SYOH
        0xC219 <= code && code <= 0xC233 || // Lo  [27] HANGUL SYLLABLE SUG..HANGUL SYLLABLE SUH
        0xC235 <= code && code <= 0xC24F || // Lo  [27] HANGUL SYLLABLE SWEOG..HANGUL SYLLABLE SWEOH
        0xC251 <= code && code <= 0xC26B || // Lo  [27] HANGUL SYLLABLE SWEG..HANGUL SYLLABLE SWEH
        0xC26D <= code && code <= 0xC287 || // Lo  [27] HANGUL SYLLABLE SWIG..HANGUL SYLLABLE SWIH
        0xC289 <= code && code <= 0xC2A3 || // Lo  [27] HANGUL SYLLABLE SYUG..HANGUL SYLLABLE SYUH
        0xC2A5 <= code && code <= 0xC2BF || // Lo  [27] HANGUL SYLLABLE SEUG..HANGUL SYLLABLE SEUH
        0xC2C1 <= code && code <= 0xC2DB || // Lo  [27] HANGUL SYLLABLE SYIG..HANGUL SYLLABLE SYIH
        0xC2DD <= code && code <= 0xC2F7 || // Lo  [27] HANGUL SYLLABLE SIG..HANGUL SYLLABLE SIH
        0xC2F9 <= code && code <= 0xC313 || // Lo  [27] HANGUL SYLLABLE SSAG..HANGUL SYLLABLE SSAH
        0xC315 <= code && code <= 0xC32F || // Lo  [27] HANGUL SYLLABLE SSAEG..HANGUL SYLLABLE SSAEH
        0xC331 <= code && code <= 0xC34B || // Lo  [27] HANGUL SYLLABLE SSYAG..HANGUL SYLLABLE SSYAH
        0xC34D <= code && code <= 0xC367 || // Lo  [27] HANGUL SYLLABLE SSYAEG..HANGUL SYLLABLE SSYAEH
        0xC369 <= code && code <= 0xC383 || // Lo  [27] HANGUL SYLLABLE SSEOG..HANGUL SYLLABLE SSEOH
        0xC385 <= code && code <= 0xC39F || // Lo  [27] HANGUL SYLLABLE SSEG..HANGUL SYLLABLE SSEH
        0xC3A1 <= code && code <= 0xC3BB || // Lo  [27] HANGUL SYLLABLE SSYEOG..HANGUL SYLLABLE SSYEOH
        0xC3BD <= code && code <= 0xC3D7 || // Lo  [27] HANGUL SYLLABLE SSYEG..HANGUL SYLLABLE SSYEH
        0xC3D9 <= code && code <= 0xC3F3 || // Lo  [27] HANGUL SYLLABLE SSOG..HANGUL SYLLABLE SSOH
        0xC3F5 <= code && code <= 0xC40F || // Lo  [27] HANGUL SYLLABLE SSWAG..HANGUL SYLLABLE SSWAH
        0xC411 <= code && code <= 0xC42B || // Lo  [27] HANGUL SYLLABLE SSWAEG..HANGUL SYLLABLE SSWAEH
        0xC42D <= code && code <= 0xC447 || // Lo  [27] HANGUL SYLLABLE SSOEG..HANGUL SYLLABLE SSOEH
        0xC449 <= code && code <= 0xC463 || // Lo  [27] HANGUL SYLLABLE SSYOG..HANGUL SYLLABLE SSYOH
        0xC465 <= code && code <= 0xC47F || // Lo  [27] HANGUL SYLLABLE SSUG..HANGUL SYLLABLE SSUH
        0xC481 <= code && code <= 0xC49B || // Lo  [27] HANGUL SYLLABLE SSWEOG..HANGUL SYLLABLE SSWEOH
        0xC49D <= code && code <= 0xC4B7 || // Lo  [27] HANGUL SYLLABLE SSWEG..HANGUL SYLLABLE SSWEH
        0xC4B9 <= code && code <= 0xC4D3 || // Lo  [27] HANGUL SYLLABLE SSWIG..HANGUL SYLLABLE SSWIH
        0xC4D5 <= code && code <= 0xC4EF || // Lo  [27] HANGUL SYLLABLE SSYUG..HANGUL SYLLABLE SSYUH
        0xC4F1 <= code && code <= 0xC50B || // Lo  [27] HANGUL SYLLABLE SSEUG..HANGUL SYLLABLE SSEUH
        0xC50D <= code && code <= 0xC527 || // Lo  [27] HANGUL SYLLABLE SSYIG..HANGUL SYLLABLE SSYIH
        0xC529 <= code && code <= 0xC543 || // Lo  [27] HANGUL SYLLABLE SSIG..HANGUL SYLLABLE SSIH
        0xC545 <= code && code <= 0xC55F || // Lo  [27] HANGUL SYLLABLE AG..HANGUL SYLLABLE AH
        0xC561 <= code && code <= 0xC57B || // Lo  [27] HANGUL SYLLABLE AEG..HANGUL SYLLABLE AEH
        0xC57D <= code && code <= 0xC597 || // Lo  [27] HANGUL SYLLABLE YAG..HANGUL SYLLABLE YAH
        0xC599 <= code && code <= 0xC5B3 || // Lo  [27] HANGUL SYLLABLE YAEG..HANGUL SYLLABLE YAEH
        0xC5B5 <= code && code <= 0xC5CF || // Lo  [27] HANGUL SYLLABLE EOG..HANGUL SYLLABLE EOH
        0xC5D1 <= code && code <= 0xC5EB || // Lo  [27] HANGUL SYLLABLE EG..HANGUL SYLLABLE EH
        0xC5ED <= code && code <= 0xC607 || // Lo  [27] HANGUL SYLLABLE YEOG..HANGUL SYLLABLE YEOH
        0xC609 <= code && code <= 0xC623 || // Lo  [27] HANGUL SYLLABLE YEG..HANGUL SYLLABLE YEH
        0xC625 <= code && code <= 0xC63F || // Lo  [27] HANGUL SYLLABLE OG..HANGUL SYLLABLE OH
        0xC641 <= code && code <= 0xC65B || // Lo  [27] HANGUL SYLLABLE WAG..HANGUL SYLLABLE WAH
        0xC65D <= code && code <= 0xC677 || // Lo  [27] HANGUL SYLLABLE WAEG..HANGUL SYLLABLE WAEH
        0xC679 <= code && code <= 0xC693 || // Lo  [27] HANGUL SYLLABLE OEG..HANGUL SYLLABLE OEH
        0xC695 <= code && code <= 0xC6AF || // Lo  [27] HANGUL SYLLABLE YOG..HANGUL SYLLABLE YOH
        0xC6B1 <= code && code <= 0xC6CB || // Lo  [27] HANGUL SYLLABLE UG..HANGUL SYLLABLE UH
        0xC6CD <= code && code <= 0xC6E7 || // Lo  [27] HANGUL SYLLABLE WEOG..HANGUL SYLLABLE WEOH
        0xC6E9 <= code && code <= 0xC703 || // Lo  [27] HANGUL SYLLABLE WEG..HANGUL SYLLABLE WEH
        0xC705 <= code && code <= 0xC71F || // Lo  [27] HANGUL SYLLABLE WIG..HANGUL SYLLABLE WIH
        0xC721 <= code && code <= 0xC73B || // Lo  [27] HANGUL SYLLABLE YUG..HANGUL SYLLABLE YUH
        0xC73D <= code && code <= 0xC757 || // Lo  [27] HANGUL SYLLABLE EUG..HANGUL SYLLABLE EUH
        0xC759 <= code && code <= 0xC773 || // Lo  [27] HANGUL SYLLABLE YIG..HANGUL SYLLABLE YIH
        0xC775 <= code && code <= 0xC78F || // Lo  [27] HANGUL SYLLABLE IG..HANGUL SYLLABLE IH
        0xC791 <= code && code <= 0xC7AB || // Lo  [27] HANGUL SYLLABLE JAG..HANGUL SYLLABLE JAH
        0xC7AD <= code && code <= 0xC7C7 || // Lo  [27] HANGUL SYLLABLE JAEG..HANGUL SYLLABLE JAEH
        0xC7C9 <= code && code <= 0xC7E3 || // Lo  [27] HANGUL SYLLABLE JYAG..HANGUL SYLLABLE JYAH
        0xC7E5 <= code && code <= 0xC7FF || // Lo  [27] HANGUL SYLLABLE JYAEG..HANGUL SYLLABLE JYAEH
        0xC801 <= code && code <= 0xC81B || // Lo  [27] HANGUL SYLLABLE JEOG..HANGUL SYLLABLE JEOH
        0xC81D <= code && code <= 0xC837 || // Lo  [27] HANGUL SYLLABLE JEG..HANGUL SYLLABLE JEH
        0xC839 <= code && code <= 0xC853 || // Lo  [27] HANGUL SYLLABLE JYEOG..HANGUL SYLLABLE JYEOH
        0xC855 <= code && code <= 0xC86F || // Lo  [27] HANGUL SYLLABLE JYEG..HANGUL SYLLABLE JYEH
        0xC871 <= code && code <= 0xC88B || // Lo  [27] HANGUL SYLLABLE JOG..HANGUL SYLLABLE JOH
        0xC88D <= code && code <= 0xC8A7 || // Lo  [27] HANGUL SYLLABLE JWAG..HANGUL SYLLABLE JWAH
        0xC8A9 <= code && code <= 0xC8C3 || // Lo  [27] HANGUL SYLLABLE JWAEG..HANGUL SYLLABLE JWAEH
        0xC8C5 <= code && code <= 0xC8DF || // Lo  [27] HANGUL SYLLABLE JOEG..HANGUL SYLLABLE JOEH
        0xC8E1 <= code && code <= 0xC8FB || // Lo  [27] HANGUL SYLLABLE JYOG..HANGUL SYLLABLE JYOH
        0xC8FD <= code && code <= 0xC917 || // Lo  [27] HANGUL SYLLABLE JUG..HANGUL SYLLABLE JUH
        0xC919 <= code && code <= 0xC933 || // Lo  [27] HANGUL SYLLABLE JWEOG..HANGUL SYLLABLE JWEOH
        0xC935 <= code && code <= 0xC94F || // Lo  [27] HANGUL SYLLABLE JWEG..HANGUL SYLLABLE JWEH
        0xC951 <= code && code <= 0xC96B || // Lo  [27] HANGUL SYLLABLE JWIG..HANGUL SYLLABLE JWIH
        0xC96D <= code && code <= 0xC987 || // Lo  [27] HANGUL SYLLABLE JYUG..HANGUL SYLLABLE JYUH
        0xC989 <= code && code <= 0xC9A3 || // Lo  [27] HANGUL SYLLABLE JEUG..HANGUL SYLLABLE JEUH
        0xC9A5 <= code && code <= 0xC9BF || // Lo  [27] HANGUL SYLLABLE JYIG..HANGUL SYLLABLE JYIH
        0xC9C1 <= code && code <= 0xC9DB || // Lo  [27] HANGUL SYLLABLE JIG..HANGUL SYLLABLE JIH
        0xC9DD <= code && code <= 0xC9F7 || // Lo  [27] HANGUL SYLLABLE JJAG..HANGUL SYLLABLE JJAH
        0xC9F9 <= code && code <= 0xCA13 || // Lo  [27] HANGUL SYLLABLE JJAEG..HANGUL SYLLABLE JJAEH
        0xCA15 <= code && code <= 0xCA2F || // Lo  [27] HANGUL SYLLABLE JJYAG..HANGUL SYLLABLE JJYAH
        0xCA31 <= code && code <= 0xCA4B || // Lo  [27] HANGUL SYLLABLE JJYAEG..HANGUL SYLLABLE JJYAEH
        0xCA4D <= code && code <= 0xCA67 || // Lo  [27] HANGUL SYLLABLE JJEOG..HANGUL SYLLABLE JJEOH
        0xCA69 <= code && code <= 0xCA83 || // Lo  [27] HANGUL SYLLABLE JJEG..HANGUL SYLLABLE JJEH
        0xCA85 <= code && code <= 0xCA9F || // Lo  [27] HANGUL SYLLABLE JJYEOG..HANGUL SYLLABLE JJYEOH
        0xCAA1 <= code && code <= 0xCABB || // Lo  [27] HANGUL SYLLABLE JJYEG..HANGUL SYLLABLE JJYEH
        0xCABD <= code && code <= 0xCAD7 || // Lo  [27] HANGUL SYLLABLE JJOG..HANGUL SYLLABLE JJOH
        0xCAD9 <= code && code <= 0xCAF3 || // Lo  [27] HANGUL SYLLABLE JJWAG..HANGUL SYLLABLE JJWAH
        0xCAF5 <= code && code <= 0xCB0F || // Lo  [27] HANGUL SYLLABLE JJWAEG..HANGUL SYLLABLE JJWAEH
        0xCB11 <= code && code <= 0xCB2B || // Lo  [27] HANGUL SYLLABLE JJOEG..HANGUL SYLLABLE JJOEH
        0xCB2D <= code && code <= 0xCB47 || // Lo  [27] HANGUL SYLLABLE JJYOG..HANGUL SYLLABLE JJYOH
        0xCB49 <= code && code <= 0xCB63 || // Lo  [27] HANGUL SYLLABLE JJUG..HANGUL SYLLABLE JJUH
        0xCB65 <= code && code <= 0xCB7F || // Lo  [27] HANGUL SYLLABLE JJWEOG..HANGUL SYLLABLE JJWEOH
        0xCB81 <= code && code <= 0xCB9B || // Lo  [27] HANGUL SYLLABLE JJWEG..HANGUL SYLLABLE JJWEH
        0xCB9D <= code && code <= 0xCBB7 || // Lo  [27] HANGUL SYLLABLE JJWIG..HANGUL SYLLABLE JJWIH
        0xCBB9 <= code && code <= 0xCBD3 || // Lo  [27] HANGUL SYLLABLE JJYUG..HANGUL SYLLABLE JJYUH
        0xCBD5 <= code && code <= 0xCBEF || // Lo  [27] HANGUL SYLLABLE JJEUG..HANGUL SYLLABLE JJEUH
        0xCBF1 <= code && code <= 0xCC0B || // Lo  [27] HANGUL SYLLABLE JJYIG..HANGUL SYLLABLE JJYIH
        0xCC0D <= code && code <= 0xCC27 || // Lo  [27] HANGUL SYLLABLE JJIG..HANGUL SYLLABLE JJIH
        0xCC29 <= code && code <= 0xCC43 || // Lo  [27] HANGUL SYLLABLE CAG..HANGUL SYLLABLE CAH
        0xCC45 <= code && code <= 0xCC5F || // Lo  [27] HANGUL SYLLABLE CAEG..HANGUL SYLLABLE CAEH
        0xCC61 <= code && code <= 0xCC7B || // Lo  [27] HANGUL SYLLABLE CYAG..HANGUL SYLLABLE CYAH
        0xCC7D <= code && code <= 0xCC97 || // Lo  [27] HANGUL SYLLABLE CYAEG..HANGUL SYLLABLE CYAEH
        0xCC99 <= code && code <= 0xCCB3 || // Lo  [27] HANGUL SYLLABLE CEOG..HANGUL SYLLABLE CEOH
        0xCCB5 <= code && code <= 0xCCCF || // Lo  [27] HANGUL SYLLABLE CEG..HANGUL SYLLABLE CEH
        0xCCD1 <= code && code <= 0xCCEB || // Lo  [27] HANGUL SYLLABLE CYEOG..HANGUL SYLLABLE CYEOH
        0xCCED <= code && code <= 0xCD07 || // Lo  [27] HANGUL SYLLABLE CYEG..HANGUL SYLLABLE CYEH
        0xCD09 <= code && code <= 0xCD23 || // Lo  [27] HANGUL SYLLABLE COG..HANGUL SYLLABLE COH
        0xCD25 <= code && code <= 0xCD3F || // Lo  [27] HANGUL SYLLABLE CWAG..HANGUL SYLLABLE CWAH
        0xCD41 <= code && code <= 0xCD5B || // Lo  [27] HANGUL SYLLABLE CWAEG..HANGUL SYLLABLE CWAEH
        0xCD5D <= code && code <= 0xCD77 || // Lo  [27] HANGUL SYLLABLE COEG..HANGUL SYLLABLE COEH
        0xCD79 <= code && code <= 0xCD93 || // Lo  [27] HANGUL SYLLABLE CYOG..HANGUL SYLLABLE CYOH
        0xCD95 <= code && code <= 0xCDAF || // Lo  [27] HANGUL SYLLABLE CUG..HANGUL SYLLABLE CUH
        0xCDB1 <= code && code <= 0xCDCB || // Lo  [27] HANGUL SYLLABLE CWEOG..HANGUL SYLLABLE CWEOH
        0xCDCD <= code && code <= 0xCDE7 || // Lo  [27] HANGUL SYLLABLE CWEG..HANGUL SYLLABLE CWEH
        0xCDE9 <= code && code <= 0xCE03 || // Lo  [27] HANGUL SYLLABLE CWIG..HANGUL SYLLABLE CWIH
        0xCE05 <= code && code <= 0xCE1F || // Lo  [27] HANGUL SYLLABLE CYUG..HANGUL SYLLABLE CYUH
        0xCE21 <= code && code <= 0xCE3B || // Lo  [27] HANGUL SYLLABLE CEUG..HANGUL SYLLABLE CEUH
        0xCE3D <= code && code <= 0xCE57 || // Lo  [27] HANGUL SYLLABLE CYIG..HANGUL SYLLABLE CYIH
        0xCE59 <= code && code <= 0xCE73 || // Lo  [27] HANGUL SYLLABLE CIG..HANGUL SYLLABLE CIH
        0xCE75 <= code && code <= 0xCE8F || // Lo  [27] HANGUL SYLLABLE KAG..HANGUL SYLLABLE KAH
        0xCE91 <= code && code <= 0xCEAB || // Lo  [27] HANGUL SYLLABLE KAEG..HANGUL SYLLABLE KAEH
        0xCEAD <= code && code <= 0xCEC7 || // Lo  [27] HANGUL SYLLABLE KYAG..HANGUL SYLLABLE KYAH
        0xCEC9 <= code && code <= 0xCEE3 || // Lo  [27] HANGUL SYLLABLE KYAEG..HANGUL SYLLABLE KYAEH
        0xCEE5 <= code && code <= 0xCEFF || // Lo  [27] HANGUL SYLLABLE KEOG..HANGUL SYLLABLE KEOH
        0xCF01 <= code && code <= 0xCF1B || // Lo  [27] HANGUL SYLLABLE KEG..HANGUL SYLLABLE KEH
        0xCF1D <= code && code <= 0xCF37 || // Lo  [27] HANGUL SYLLABLE KYEOG..HANGUL SYLLABLE KYEOH
        0xCF39 <= code && code <= 0xCF53 || // Lo  [27] HANGUL SYLLABLE KYEG..HANGUL SYLLABLE KYEH
        0xCF55 <= code && code <= 0xCF6F || // Lo  [27] HANGUL SYLLABLE KOG..HANGUL SYLLABLE KOH
        0xCF71 <= code && code <= 0xCF8B || // Lo  [27] HANGUL SYLLABLE KWAG..HANGUL SYLLABLE KWAH
        0xCF8D <= code && code <= 0xCFA7 || // Lo  [27] HANGUL SYLLABLE KWAEG..HANGUL SYLLABLE KWAEH
        0xCFA9 <= code && code <= 0xCFC3 || // Lo  [27] HANGUL SYLLABLE KOEG..HANGUL SYLLABLE KOEH
        0xCFC5 <= code && code <= 0xCFDF || // Lo  [27] HANGUL SYLLABLE KYOG..HANGUL SYLLABLE KYOH
        0xCFE1 <= code && code <= 0xCFFB || // Lo  [27] HANGUL SYLLABLE KUG..HANGUL SYLLABLE KUH
        0xCFFD <= code && code <= 0xD017 || // Lo  [27] HANGUL SYLLABLE KWEOG..HANGUL SYLLABLE KWEOH
        0xD019 <= code && code <= 0xD033 || // Lo  [27] HANGUL SYLLABLE KWEG..HANGUL SYLLABLE KWEH
        0xD035 <= code && code <= 0xD04F || // Lo  [27] HANGUL SYLLABLE KWIG..HANGUL SYLLABLE KWIH
        0xD051 <= code && code <= 0xD06B || // Lo  [27] HANGUL SYLLABLE KYUG..HANGUL SYLLABLE KYUH
        0xD06D <= code && code <= 0xD087 || // Lo  [27] HANGUL SYLLABLE KEUG..HANGUL SYLLABLE KEUH
        0xD089 <= code && code <= 0xD0A3 || // Lo  [27] HANGUL SYLLABLE KYIG..HANGUL SYLLABLE KYIH
        0xD0A5 <= code && code <= 0xD0BF || // Lo  [27] HANGUL SYLLABLE KIG..HANGUL SYLLABLE KIH
        0xD0C1 <= code && code <= 0xD0DB || // Lo  [27] HANGUL SYLLABLE TAG..HANGUL SYLLABLE TAH
        0xD0DD <= code && code <= 0xD0F7 || // Lo  [27] HANGUL SYLLABLE TAEG..HANGUL SYLLABLE TAEH
        0xD0F9 <= code && code <= 0xD113 || // Lo  [27] HANGUL SYLLABLE TYAG..HANGUL SYLLABLE TYAH
        0xD115 <= code && code <= 0xD12F || // Lo  [27] HANGUL SYLLABLE TYAEG..HANGUL SYLLABLE TYAEH
        0xD131 <= code && code <= 0xD14B || // Lo  [27] HANGUL SYLLABLE TEOG..HANGUL SYLLABLE TEOH
        0xD14D <= code && code <= 0xD167 || // Lo  [27] HANGUL SYLLABLE TEG..HANGUL SYLLABLE TEH
        0xD169 <= code && code <= 0xD183 || // Lo  [27] HANGUL SYLLABLE TYEOG..HANGUL SYLLABLE TYEOH
        0xD185 <= code && code <= 0xD19F || // Lo  [27] HANGUL SYLLABLE TYEG..HANGUL SYLLABLE TYEH
        0xD1A1 <= code && code <= 0xD1BB || // Lo  [27] HANGUL SYLLABLE TOG..HANGUL SYLLABLE TOH
        0xD1BD <= code && code <= 0xD1D7 || // Lo  [27] HANGUL SYLLABLE TWAG..HANGUL SYLLABLE TWAH
        0xD1D9 <= code && code <= 0xD1F3 || // Lo  [27] HANGUL SYLLABLE TWAEG..HANGUL SYLLABLE TWAEH
        0xD1F5 <= code && code <= 0xD20F || // Lo  [27] HANGUL SYLLABLE TOEG..HANGUL SYLLABLE TOEH
        0xD211 <= code && code <= 0xD22B || // Lo  [27] HANGUL SYLLABLE TYOG..HANGUL SYLLABLE TYOH
        0xD22D <= code && code <= 0xD247 || // Lo  [27] HANGUL SYLLABLE TUG..HANGUL SYLLABLE TUH
        0xD249 <= code && code <= 0xD263 || // Lo  [27] HANGUL SYLLABLE TWEOG..HANGUL SYLLABLE TWEOH
        0xD265 <= code && code <= 0xD27F || // Lo  [27] HANGUL SYLLABLE TWEG..HANGUL SYLLABLE TWEH
        0xD281 <= code && code <= 0xD29B || // Lo  [27] HANGUL SYLLABLE TWIG..HANGUL SYLLABLE TWIH
        0xD29D <= code && code <= 0xD2B7 || // Lo  [27] HANGUL SYLLABLE TYUG..HANGUL SYLLABLE TYUH
        0xD2B9 <= code && code <= 0xD2D3 || // Lo  [27] HANGUL SYLLABLE TEUG..HANGUL SYLLABLE TEUH
        0xD2D5 <= code && code <= 0xD2EF || // Lo  [27] HANGUL SYLLABLE TYIG..HANGUL SYLLABLE TYIH
        0xD2F1 <= code && code <= 0xD30B || // Lo  [27] HANGUL SYLLABLE TIG..HANGUL SYLLABLE TIH
        0xD30D <= code && code <= 0xD327 || // Lo  [27] HANGUL SYLLABLE PAG..HANGUL SYLLABLE PAH
        0xD329 <= code && code <= 0xD343 || // Lo  [27] HANGUL SYLLABLE PAEG..HANGUL SYLLABLE PAEH
        0xD345 <= code && code <= 0xD35F || // Lo  [27] HANGUL SYLLABLE PYAG..HANGUL SYLLABLE PYAH
        0xD361 <= code && code <= 0xD37B || // Lo  [27] HANGUL SYLLABLE PYAEG..HANGUL SYLLABLE PYAEH
        0xD37D <= code && code <= 0xD397 || // Lo  [27] HANGUL SYLLABLE PEOG..HANGUL SYLLABLE PEOH
        0xD399 <= code && code <= 0xD3B3 || // Lo  [27] HANGUL SYLLABLE PEG..HANGUL SYLLABLE PEH
        0xD3B5 <= code && code <= 0xD3CF || // Lo  [27] HANGUL SYLLABLE PYEOG..HANGUL SYLLABLE PYEOH
        0xD3D1 <= code && code <= 0xD3EB || // Lo  [27] HANGUL SYLLABLE PYEG..HANGUL SYLLABLE PYEH
        0xD3ED <= code && code <= 0xD407 || // Lo  [27] HANGUL SYLLABLE POG..HANGUL SYLLABLE POH
        0xD409 <= code && code <= 0xD423 || // Lo  [27] HANGUL SYLLABLE PWAG..HANGUL SYLLABLE PWAH
        0xD425 <= code && code <= 0xD43F || // Lo  [27] HANGUL SYLLABLE PWAEG..HANGUL SYLLABLE PWAEH
        0xD441 <= code && code <= 0xD45B || // Lo  [27] HANGUL SYLLABLE POEG..HANGUL SYLLABLE POEH
        0xD45D <= code && code <= 0xD477 || // Lo  [27] HANGUL SYLLABLE PYOG..HANGUL SYLLABLE PYOH
        0xD479 <= code && code <= 0xD493 || // Lo  [27] HANGUL SYLLABLE PUG..HANGUL SYLLABLE PUH
        0xD495 <= code && code <= 0xD4AF || // Lo  [27] HANGUL SYLLABLE PWEOG..HANGUL SYLLABLE PWEOH
        0xD4B1 <= code && code <= 0xD4CB || // Lo  [27] HANGUL SYLLABLE PWEG..HANGUL SYLLABLE PWEH
        0xD4CD <= code && code <= 0xD4E7 || // Lo  [27] HANGUL SYLLABLE PWIG..HANGUL SYLLABLE PWIH
        0xD4E9 <= code && code <= 0xD503 || // Lo  [27] HANGUL SYLLABLE PYUG..HANGUL SYLLABLE PYUH
        0xD505 <= code && code <= 0xD51F || // Lo  [27] HANGUL SYLLABLE PEUG..HANGUL SYLLABLE PEUH
        0xD521 <= code && code <= 0xD53B || // Lo  [27] HANGUL SYLLABLE PYIG..HANGUL SYLLABLE PYIH
        0xD53D <= code && code <= 0xD557 || // Lo  [27] HANGUL SYLLABLE PIG..HANGUL SYLLABLE PIH
        0xD559 <= code && code <= 0xD573 || // Lo  [27] HANGUL SYLLABLE HAG..HANGUL SYLLABLE HAH
        0xD575 <= code && code <= 0xD58F || // Lo  [27] HANGUL SYLLABLE HAEG..HANGUL SYLLABLE HAEH
        0xD591 <= code && code <= 0xD5AB || // Lo  [27] HANGUL SYLLABLE HYAG..HANGUL SYLLABLE HYAH
        0xD5AD <= code && code <= 0xD5C7 || // Lo  [27] HANGUL SYLLABLE HYAEG..HANGUL SYLLABLE HYAEH
        0xD5C9 <= code && code <= 0xD5E3 || // Lo  [27] HANGUL SYLLABLE HEOG..HANGUL SYLLABLE HEOH
        0xD5E5 <= code && code <= 0xD5FF || // Lo  [27] HANGUL SYLLABLE HEG..HANGUL SYLLABLE HEH
        0xD601 <= code && code <= 0xD61B || // Lo  [27] HANGUL SYLLABLE HYEOG..HANGUL SYLLABLE HYEOH
        0xD61D <= code && code <= 0xD637 || // Lo  [27] HANGUL SYLLABLE HYEG..HANGUL SYLLABLE HYEH
        0xD639 <= code && code <= 0xD653 || // Lo  [27] HANGUL SYLLABLE HOG..HANGUL SYLLABLE HOH
        0xD655 <= code && code <= 0xD66F || // Lo  [27] HANGUL SYLLABLE HWAG..HANGUL SYLLABLE HWAH
        0xD671 <= code && code <= 0xD68B || // Lo  [27] HANGUL SYLLABLE HWAEG..HANGUL SYLLABLE HWAEH
        0xD68D <= code && code <= 0xD6A7 || // Lo  [27] HANGUL SYLLABLE HOEG..HANGUL SYLLABLE HOEH
        0xD6A9 <= code && code <= 0xD6C3 || // Lo  [27] HANGUL SYLLABLE HYOG..HANGUL SYLLABLE HYOH
        0xD6C5 <= code && code <= 0xD6DF || // Lo  [27] HANGUL SYLLABLE HUG..HANGUL SYLLABLE HUH
        0xD6E1 <= code && code <= 0xD6FB || // Lo  [27] HANGUL SYLLABLE HWEOG..HANGUL SYLLABLE HWEOH
        0xD6FD <= code && code <= 0xD717 || // Lo  [27] HANGUL SYLLABLE HWEG..HANGUL SYLLABLE HWEH
        0xD719 <= code && code <= 0xD733 || // Lo  [27] HANGUL SYLLABLE HWIG..HANGUL SYLLABLE HWIH
        0xD735 <= code && code <= 0xD74F || // Lo  [27] HANGUL SYLLABLE HYUG..HANGUL SYLLABLE HYUH
        0xD751 <= code && code <= 0xD76B || // Lo  [27] HANGUL SYLLABLE HEUG..HANGUL SYLLABLE HEUH
        0xD76D <= code && code <= 0xD787 || // Lo  [27] HANGUL SYLLABLE HYIG..HANGUL SYLLABLE HYIH
        0xD789 <= code && code <= 0xD7A3 // Lo  [27] HANGUL SYLLABLE HIG..HANGUL SYLLABLE HIH
        ) return LVT;
        if (0x261D == code || // So       WHITE UP POINTING INDEX
        0x26F9 == code || // So       PERSON WITH BALL
        0x270A <= code && code <= 0x270D || // So   [4] RAISED FIST..WRITING HAND
        0x1F385 == code || // So       FATHER CHRISTMAS
        0x1F3C2 <= code && code <= 0x1F3C4 || // So   [3] SNOWBOARDER..SURFER
        0x1F3C7 == code || // So       HORSE RACING
        0x1F3CA <= code && code <= 0x1F3CC || // So   [3] SWIMMER..GOLFER
        0x1F442 <= code && code <= 0x1F443 || // So   [2] EAR..NOSE
        0x1F446 <= code && code <= 0x1F450 || // So  [11] WHITE UP POINTING BACKHAND INDEX..OPEN HANDS SIGN
        0x1F46E == code || // So       POLICE OFFICER
        0x1F470 <= code && code <= 0x1F478 || // So   [9] BRIDE WITH VEIL..PRINCESS
        0x1F47C == code || // So       BABY ANGEL
        0x1F481 <= code && code <= 0x1F483 || // So   [3] INFORMATION DESK PERSON..DANCER
        0x1F485 <= code && code <= 0x1F487 || // So   [3] NAIL POLISH..HAIRCUT
        0x1F4AA == code || // So       FLEXED BICEPS
        0x1F574 <= code && code <= 0x1F575 || // So   [2] MAN IN BUSINESS SUIT LEVITATING..SLEUTH OR SPY
        0x1F57A == code || // So       MAN DANCING
        0x1F590 == code || // So       RAISED HAND WITH FINGERS SPLAYED
        0x1F595 <= code && code <= 0x1F596 || // So   [2] REVERSED HAND WITH MIDDLE FINGER EXTENDED..RAISED HAND WITH PART BETWEEN MIDDLE AND RING FINGERS
        0x1F645 <= code && code <= 0x1F647 || // So   [3] FACE WITH NO GOOD GESTURE..PERSON BOWING DEEPLY
        0x1F64B <= code && code <= 0x1F64F || // So   [5] HAPPY PERSON RAISING ONE HAND..PERSON WITH FOLDED HANDS
        0x1F6A3 == code || // So       ROWBOAT
        0x1F6B4 <= code && code <= 0x1F6B6 || // So   [3] BICYCLIST..PEDESTRIAN
        0x1F6C0 == code || // So       BATH
        0x1F6CC == code || // So       SLEEPING ACCOMMODATION
        0x1F918 <= code && code <= 0x1F91C || // So   [5] SIGN OF THE HORNS..RIGHT-FACING FIST
        0x1F91E <= code && code <= 0x1F91F || // So   [2] HAND WITH INDEX AND MIDDLE FINGERS CROSSED..I LOVE YOU HAND SIGN
        0x1F926 == code || // So       FACE PALM
        0x1F930 <= code && code <= 0x1F939 || // So  [10] PREGNANT WOMAN..JUGGLING
        0x1F93D <= code && code <= 0x1F93E || // So   [2] WATER POLO..HANDBALL
        0x1F9D1 <= code && code <= 0x1F9DD // So  [13] ADULT..ELF
        ) return E_Base;
        if (0x1F3FB <= code && code <= 0x1F3FF // Sk   [5] EMOJI MODIFIER FITZPATRICK TYPE-1-2..EMOJI MODIFIER FITZPATRICK TYPE-6
        ) return E_Modifier;
        if (0x200D == code // Cf       ZERO WIDTH JOINER
        ) return ZWJ;
        if (0x2640 == code || // So       FEMALE SIGN
        0x2642 == code || // So       MALE SIGN
        0x2695 <= code && code <= 0x2696 || // So   [2] STAFF OF AESCULAPIUS..SCALES
        0x2708 == code || // So       AIRPLANE
        0x2764 == code || // So       HEAVY BLACK HEART
        0x1F308 == code || // So       RAINBOW
        0x1F33E == code || // So       EAR OF RICE
        0x1F373 == code || // So       COOKING
        0x1F393 == code || // So       GRADUATION CAP
        0x1F3A4 == code || // So       MICROPHONE
        0x1F3A8 == code || // So       ARTIST PALETTE
        0x1F3EB == code || // So       SCHOOL
        0x1F3ED == code || // So       FACTORY
        0x1F48B == code || // So       KISS MARK
        0x1F4BB <= code && code <= 0x1F4BC || // So   [2] PERSONAL COMPUTER..BRIEFCASE
        0x1F527 == code || // So       WRENCH
        0x1F52C == code || // So       MICROSCOPE
        0x1F5E8 == code || // So       LEFT SPEECH BUBBLE
        0x1F680 == code || // So       ROCKET
        0x1F692 == code // So       FIRE ENGINE
        ) return Glue_After_Zwj;
        if (0x1F466 <= code && code <= 0x1F469 // So   [4] BOY..WOMAN
        ) return E_Base_GAZ;
        //all unlisted characters have a grapheme break property of "Other"
        return Other;
    }
    return this;
}
if (0, $f5fcaf5cd8fda82a$exports) $f5fcaf5cd8fda82a$exports = $f5fcaf5cd8fda82a$var$GraphemeSplitter;



var $dhiZh = parcelRequire("dhiZh");
"use client";
function $09a7934ad4f9dd06$var$p(e, t) {
    void 0 === t && (t = {});
    var n = t.insertAt;
    if (e && "undefined" != typeof document) {
        var a = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
        i.type = "text/css", "top" === n && a.firstChild ? a.insertBefore(i, a.firstChild) : a.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
    }
}
$09a7934ad4f9dd06$var$p(".__sr-only{clip:rect(0,0,0,0);border-width:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}");
const $09a7934ad4f9dd06$var$c = new (0, (/*@__PURE__*/$parcel$interopDefault($f5fcaf5cd8fda82a$exports))), $09a7934ad4f9dd06$export$9f67c967e2cd05ea = ({ wrapperElement: n = "p", text: a, className: p, style: m, rotation: d = 0, staggerDuration: y = .1, fromTop: h = !1, fromLast: u = !1, initialDelay: g = 0, animateOnce: f = !1, elementVisibilityAmount: E = .5, lineHeight: b, wordByWord: v = !1 })=>{
    const x = (0, $dhiZh.useRef)(null), [k, w] = (0, $dhiZh.useState)([]);
    (0, $dhiZh.useEffect)(()=>{
        w(()=>[
                ...x.current.children
            ].map((e)=>{
                var _e_innerText;
                return (_e_innerText = e.innerText) === null || _e_innerText === void 0 ? void 0 : _e_innerText.replace(/\u00A0/g, " ");
            }));
    }, []);
    const C = (0, $a93ad9da627e0211$export$2f62ee6831462844)(x, {
        amount: E,
        once: f
    }), N = (0, $dhiZh.useMemo)(()=>Array.isArray(a) ? a : [
            a
        ], [
        a
    ]), _ = {
        hidden: {
            transition: {
                type: "spring",
                bounce: 0
            },
            rotate: d,
            y: h ? "-200%" : "200%"
        },
        visible: {
            transition: {
                type: "spring",
                bounce: 0
            },
            rotate: 0,
            y: 0
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement(n, {
        className: p,
        style: m
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
        className: "__sr-only"
    }, N.join(" ")), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
        ref: x,
        initial: "hidden",
        animate: C ? "visible" : "hidden",
        transition: {
            staggerChildren: C ? y : 0,
            staggerDirection: u ? -1 : 1,
            delayChildren: g
        }
    }, N.map((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
            key: e + n,
            style: {
                display: "block",
                overflow: "hidden",
                lineHeight: b || (k[n] === e.toUpperCase() ? "0.81" : "1.2")
            }
        }, v ? ((e)=>e.split(" ").map((n, a)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
                    key: n + a,
                    variants: _,
                    style: {
                        display: "inline-block"
                    }
                }, n), a < e.split(" ").length - 1 && (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
                    style: {
                        display: "inline-block"
                    }
                }, "\xa0"))))(e) : ((e)=>e.split(" ").map((n, a)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
                    key: n + a,
                    style: {
                        display: "inline-block"
                    }
                }, $09a7934ad4f9dd06$var$c.splitGraphemes(n).map((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
                        key: e + n,
                        variants: _,
                        style: {
                            display: "inline-block"
                        }
                    }, e)), a < e.split(" ").length - 1 && (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
                    style: {
                        display: "inline-block"
                    }
                }, "\xa0"))))(e)))));
}, $09a7934ad4f9dd06$export$29909b6ce3c40e13 = ({ wrapperElement: a = "p", text: r, className: o, style: p, filter: c = !0, animationDuration: m = .5, staggerDuration: d = .2, initialDelay: y = 0, animateOnce: h = !1, elementVisibilityAmount: u = .5 })=>{
    const g = (0, $dhiZh.useRef)(null), f = (0, $44d86ae641e1b5f8$export$9e2608686d4ad846)(), E = (0, $a93ad9da627e0211$export$2f62ee6831462844)(g, {
        amount: u,
        once: h
    }), b = r.split(" ");
    (0, $dhiZh.useEffect)(()=>{
        E ? f.start((e)=>({
                opacity: 1,
                filter: c ? "blur(0px)" : "none",
                transition: {
                    duration: m,
                    delay: y + e * d
                }
            })) : h || f.start({
            opacity: 0,
            filter: c ? "blur(10px)" : "none",
            transition: {
                duration: 0
            }
        });
    }, [
        f,
        E,
        m,
        c,
        y,
        d,
        h
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement(a, {
        className: o,
        style: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
        ref: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
        className: "__sr-only"
    }, r), b.map((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
            key: e + n,
            custom: n,
            initial: {
                opacity: 0,
                filter: c ? "blur(10px)" : "none"
            },
            animate: f
        }, e, " "))));
};
$09a7934ad4f9dd06$var$p(".text-container{overflow:hidden;position:relative;white-space:nowrap}.text-hidden{inset:0;position:absolute}");
const $09a7934ad4f9dd06$var$y = new (0, (/*@__PURE__*/$parcel$interopDefault($f5fcaf5cd8fda82a$exports))), $09a7934ad4f9dd06$export$de91232067cab022 = ({ text: e, className: n, style: a, lineHeight: o, fromTop: p = !1, fromLast: c = !1, staggerDuration: m = .02, animationDuration: d = .2 })=>{
    const h = (0, $dhiZh.useRef)(null), [u, g] = (0, $dhiZh.useState)("");
    return (0, $dhiZh.useEffect)(()=>{
        var _h_current_innerText, _h_current;
        g((_h_current = h.current) === null || _h_current === void 0 ? void 0 : (_h_current_innerText = _h_current.innerText) === null || _h_current_innerText === void 0 ? void 0 : _h_current_innerText.replace(/\u00A0/g, " "));
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
        className: "__sr-only"
    }, e), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).div, {
        initial: "initial",
        whileHover: "hovered",
        className: "text-container " + n,
        style: (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, a), {
            width: "fit-content",
            lineHeight: o || (u === e.toUpperCase() ? .81 : 1.2)
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("div", {
        ref: h
    }, $09a7934ad4f9dd06$var$y.splitGraphemes(e).map((n, a)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
            key: a,
            variants: {
                initial: {
                    y: p ? "-100%" : 0
                },
                hovered: {
                    y: p ? 0 : "-100%"
                }
            },
            transition: {
                duration: d,
                ease: "easeInOut",
                delay: m * (c ? e.length - a : a)
            },
            style: {
                display: "inline-block"
            }
        }, " " == n ? (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
            style: {
                display: "inline-block"
            }
        }, "\xa0") : n))), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("div", {
        className: "text-hidden"
    }, $09a7934ad4f9dd06$var$y.splitGraphemes(e).map((n, a)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
            key: a,
            variants: {
                initial: {
                    y: p ? 0 : "100%"
                },
                hovered: {
                    y: p ? "100%" : 0
                }
            },
            transition: {
                duration: d,
                ease: "easeInOut",
                delay: m * (c ? e.length - a : a)
            },
            style: {
                display: "inline-block"
            }
        }, " " == n ? (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
            style: {
                display: "inline-block"
            }
        }, "\xa0") : n)))));
}, $09a7934ad4f9dd06$var$u = new (0, (/*@__PURE__*/$parcel$interopDefault($f5fcaf5cd8fda82a$exports))), $09a7934ad4f9dd06$export$ace4e187a93c7986 = ({ wrapperElement: n = "p", text: a, className: r, style: s, fromCenter: o = !1, cursorConfig: p, staggerDuration: c = .125, initialDelay: m = 0, animateOnce: d = !1, elementVisibilityAmount: y = .5 })=>{
    const h = (0, $dhiZh.useRef)(null), g = (0, $a93ad9da627e0211$export$2f62ee6831462844)(h, {
        amount: y,
        once: d
    }), f = a.split(" "), E = {
        hidden: {
            display: "none",
            opacity: 0,
            transition: {
                duration: 0
            }
        },
        visible: {
            display: "inline-block",
            opacity: 1,
            transition: {
                duration: 0
            }
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement(n, {
        className: r,
        style: (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, s, o ? {
            display: "flex",
            justifyContent: "center",
            textAlign: "center"
        } : {})
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
        className: "__sr-only"
    }, a), (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
        ref: h,
        initial: "hidden",
        animate: g ? "visible" : "hidden",
        transition: {
            staggerChildren: g ? c : 0,
            delayChildren: m
        }
    }, f.map((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement("span", {
            key: e + n
        }, $09a7934ad4f9dd06$var$u.splitGraphemes(e).map((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
                key: e + n,
                variants: E
            }, e)), n < f.length - 1 && (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
            variants: E
        }, "\xa0"))), (()=>{
        var _p_type, _p_blinkRate, _p_width, _p_color, _p_marginLeft;
        const e = {
            type: (_p_type = p === null || p === void 0 ? void 0 : p.type) !== null && _p_type !== void 0 ? _p_type : "vertical",
            blinkRate: (_p_blinkRate = p === null || p === void 0 ? void 0 : p.blinkRate) !== null && _p_blinkRate !== void 0 ? _p_blinkRate : .35,
            width: (_p_width = p === null || p === void 0 ? void 0 : p.width) !== null && _p_width !== void 0 ? _p_width : "1px",
            color: (_p_color = p === null || p === void 0 ? void 0 : p.color) !== null && _p_color !== void 0 ? _p_color : "currentColor",
            marginLeft: (_p_marginLeft = p === null || p === void 0 ? void 0 : p.marginLeft) !== null && _p_marginLeft !== void 0 ? _p_marginLeft : "0px"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $db5bb82597f1f0b4$export$e25e478948902b8b).span, {
            animate: {
                opacity: [
                    0,
                    0,
                    0,
                    1,
                    1,
                    1
                ]
            },
            transition: {
                duration: e.blinkRate,
                repeat: 1 / 0,
                repeatType: "reverse",
                ease: "linear",
                times: [
                    0,
                    .2,
                    .4,
                    .6,
                    .8,
                    1
                ]
            },
            style: {
                display: "hidden" === (e === null || e === void 0 ? void 0 : e.type) ? "none" : "inline",
                color: e === null || e === void 0 ? void 0 : e.color,
                borderLeftWidth: "horizontal" === (e === null || e === void 0 ? void 0 : e.type) ? "0px" : e === null || e === void 0 ? void 0 : e.width,
                borderLeftStyle: "solid",
                borderLeftColor: e === null || e === void 0 ? void 0 : e.color,
                marginLeft: e === null || e === void 0 ? void 0 : e.marginLeft
            }
        }, "horizontal" === (e === null || e === void 0 ? void 0 : e.type) && "_");
    })()));
};



(0, $310c7edeeb54bee4$export$99ee26438460406a).registerPlugin((0, $4fdec5228fea4ed1$export$875bcbe48555930));
function $e987e357e7629534$var$isMobile() {
    return /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 800;
}
const $e987e357e7629534$var$Numbers = ({ data: data })=>{
    const containerRef = (0, $dhiZh.useRef)(null);
    const carouselRef = (0, $dhiZh.useRef)(null);
    const [ref, inView] = (0, $74bd4cb969e9d802$export$2f62ee6831462844)({
        threshold: 0.5
    });
    (0, $dhiZh.useEffect)(()=>{
        const container = containerRef.current;
        const carousel = carouselRef.current;
        let scrollWidth = carousel.scrollWidth;
        let containerWidth = container.offsetWidth;
        let endScroll;
        // Function to determine mobile layout
        function isMobile() {
            return window.innerWidth <= 768;
        }
        // Calculate scroll values
        function calculateValues() {
            scrollWidth = carousel.scrollWidth;
            containerWidth = container.offsetWidth;
            endScroll = isMobile() ? scrollWidth - containerWidth + 3000 : scrollWidth - containerWidth;
        }
        calculateValues(); // Initial calculation
        // Create GSAP timeline
        let tl = (0, $310c7edeeb54bee4$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: container,
                pin: true,
                scrub: 0.1,
                start: "top top",
                end: ()=>`+=${endScroll}`,
                markers: false,
                invalidateOnRefresh: true,
                onRefresh: calculateValues // Recalculate values on refresh
            }
        });
        // Add horizontal scroll animation to the timeline
        tl.to(carousel, {
            x: ()=>-(scrollWidth - containerWidth) + "px",
            ease: "none" // No easing for smooth scrolling
        });
        // You can add more animations or delays as needed
        tl.set({}, {}, "+=0.15"); // Optional: Add a delay or placeholder for future animations
        // Cleanup function to remove ScrollTrigger instance on component unmount
        return ()=>{
            (0, $4fdec5228fea4ed1$export$875bcbe48555930).getAll().forEach((trigger)=>trigger.kill());
        };
    }, []);
    // useEffect(() => {
    //   const container = containerRef.current;
    //   const carousel = carouselRef.current;
    //   let scrollWidth = carousel.scrollWidth;
    //   let containerWidth = container.offsetWidth;
    //   let endScroll;
    //
    //   // Function to determine mobile layout
    //   function isMobile() {
    //     return window.innerWidth <= 768;
    //   }
    //
    //   // Calculate scroll values
    //   function calculateValues() {
    //     scrollWidth = carousel.scrollWidth;
    //     containerWidth = container.offsetWidth;
    //     endScroll = isMobile() ? scrollWidth - containerWidth + 3000 : scrollWidth - containerWidth;
    //   }
    //
    //   calculateValues();  // Initial calculation
    //
    //   gsap.to(carousel, {
    //     x: () => -(scrollWidth - containerWidth),  // Use function for dynamic recalculation
    //     ease: 'ease',
    //     scrollTrigger: {
    //       trigger: container,
    //       pin: true,
    //       pinSpacing: true,
    //       scrub: 0.1,
    //       start: 'top top',
    //       end: () => `+=${endScroll}`,  // Recalculate endScroll dynamically
    //       markers: false,
    //       invalidateOnRefresh: true,  // Recalculate on resize
    //       onRefresh: calculateValues  // Recalculate values when ScrollTrigger refreshes
    //     },
    //   });
    //
    //   // Cleanup function to remove ScrollTrigger instance on component unmount
    //   return () => {
    //     ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    //   };
    // }, []);
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        ref: containerRef,
        className: "makerlab-numbers-wrapper",
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
            ref: carouselRef,
            className: "makerlab-numbers-scroll",
            children: [
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                    className: "makerlab-numbers-screen",
                    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("h4", {
                        ref: ref,
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $09a7934ad4f9dd06$export$9f67c967e2cd05ea), {
                                text: "The proof is in the pudding",
                                staggerDurationBy: 0.5,
                                wordByWord: true,
                                animateOnce: true,
                                initialDelay: 0.3
                            }),
                            inView && /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("svg", {
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 36 63",
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m2 2 31 30.122L2 61",
                                    stroke: "#000",
                                    strokeOpacity: ".5",
                                    strokeWidth: "4",
                                    strokeLinecap: "round"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                    className: "makerlab-numbers-screen",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h5", {
                            className: "blue",
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9d552c44c761fe4b$exports))), {
                                partialVisibility: true,
                                children: ({ isVisible: isVisible })=>/*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                                        children: isVisible ? /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)((0, $015932d6ce0d059e$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($100aaf8d1bb47840$exports))), {
                                                    end: 98,
                                                    duration: 2
                                                }),
                                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("small", {
                                                    children: "%"
                                                })
                                            ]
                                        }) : "0"
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h6", {
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $09a7934ad4f9dd06$export$9f67c967e2cd05ea), {
                                text: "Client satisfaction in H1 2024",
                                staggerDurationBy: 0.2,
                                wordByWord: true,
                                animateOnce: true,
                                initialDelay: 0.3
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                    className: "makerlab-numbers-screen makerlab-numbers-screen--blue",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h5", {
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9d552c44c761fe4b$exports))), {
                                partialVisibility: true,
                                children: ({ isVisible: isVisible })=>/*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                                        children: isVisible ? /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($100aaf8d1bb47840$exports))), {
                                            end: 416,
                                            duration: 3
                                        }) : "0"
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h6", {
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $09a7934ad4f9dd06$export$9f67c967e2cd05ea), {
                                text: "Hours of training a year to keep your team at their best",
                                staggerDurationBy: 0.2,
                                wordByWord: true,
                                animateOnce: true,
                                initialDelay: 0.3
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                    className: "makerlab-numbers-screen makerlab-numbers-screen--volt",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h5", {
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9d552c44c761fe4b$exports))), {
                                partialVisibility: true,
                                children: ({ isVisible: isVisible })=>/*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                                        children: isVisible ? /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)((0, $015932d6ce0d059e$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($100aaf8d1bb47840$exports))), {
                                                    start: 4567,
                                                    end: 6000,
                                                    separator: "",
                                                    duration: 3
                                                }),
                                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("small", {
                                                    children: "+"
                                                })
                                            ]
                                        }) : "0"
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h6", {
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $09a7934ad4f9dd06$export$9f67c967e2cd05ea), {
                                text: "Talented people in our network, ready to support you",
                                staggerDurationBy: 0.2,
                                wordByWord: true,
                                animateOnce: true,
                                initialDelay: 0.3
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $e987e357e7629534$export$2e2bcd8739ae039 = $e987e357e7629534$var$Numbers;




var $dhiZh = parcelRequire("dhiZh");
// src/index.ts

// src/hooks/useChain.ts
function $8c4bc528d81dc2b7$export$71511d61b312f219() {
    $8c4bc528d81dc2b7$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c4bc528d81dc2b7$export$71511d61b312f219.apply(this, arguments);
}


function $c9e1fbf136a700c5$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}







// src/index.ts
var $78ed687e3eb26156$var$updateQueue = $78ed687e3eb26156$var$makeQueue();
var $78ed687e3eb26156$export$27f233d61a9e2fa4 = (fn)=>$78ed687e3eb26156$var$schedule(fn, $78ed687e3eb26156$var$updateQueue);
var $78ed687e3eb26156$var$writeQueue = $78ed687e3eb26156$var$makeQueue();
$78ed687e3eb26156$export$27f233d61a9e2fa4.write = (fn)=>$78ed687e3eb26156$var$schedule(fn, $78ed687e3eb26156$var$writeQueue);
var $78ed687e3eb26156$var$onStartQueue = $78ed687e3eb26156$var$makeQueue();
$78ed687e3eb26156$export$27f233d61a9e2fa4.onStart = (fn)=>$78ed687e3eb26156$var$schedule(fn, $78ed687e3eb26156$var$onStartQueue);
var $78ed687e3eb26156$var$onFrameQueue = $78ed687e3eb26156$var$makeQueue();
$78ed687e3eb26156$export$27f233d61a9e2fa4.onFrame = (fn)=>$78ed687e3eb26156$var$schedule(fn, $78ed687e3eb26156$var$onFrameQueue);
var $78ed687e3eb26156$var$onFinishQueue = $78ed687e3eb26156$var$makeQueue();
$78ed687e3eb26156$export$27f233d61a9e2fa4.onFinish = (fn)=>$78ed687e3eb26156$var$schedule(fn, $78ed687e3eb26156$var$onFinishQueue);
var $78ed687e3eb26156$var$timeouts = [];
$78ed687e3eb26156$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $78ed687e3eb26156$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $78ed687e3eb26156$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $78ed687e3eb26156$var$timeouts.splice(i, 1);
        $78ed687e3eb26156$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $78ed687e3eb26156$var$timeouts.splice($78ed687e3eb26156$var$findTimeout(time), 0, timeout);
    $78ed687e3eb26156$var$pendingCount += 1;
    $78ed687e3eb26156$var$start();
    return timeout;
};
var $78ed687e3eb26156$var$findTimeout = (time)=>~(~$78ed687e3eb26156$var$timeouts.findIndex((t)=>t.time > time) || ~$78ed687e3eb26156$var$timeouts.length);
$78ed687e3eb26156$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $78ed687e3eb26156$var$onStartQueue.delete(fn);
    $78ed687e3eb26156$var$onFrameQueue.delete(fn);
    $78ed687e3eb26156$var$onFinishQueue.delete(fn);
    $78ed687e3eb26156$var$updateQueue.delete(fn);
    $78ed687e3eb26156$var$writeQueue.delete(fn);
};
$78ed687e3eb26156$export$27f233d61a9e2fa4.sync = (fn)=>{
    $78ed687e3eb26156$var$sync = true;
    $78ed687e3eb26156$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $78ed687e3eb26156$var$sync = false;
};
$78ed687e3eb26156$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $78ed687e3eb26156$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $78ed687e3eb26156$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $78ed687e3eb26156$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$78ed687e3eb26156$export$27f233d61a9e2fa4.use = (impl)=>$78ed687e3eb26156$var$nativeRaf = impl;
$78ed687e3eb26156$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$78ed687e3eb26156$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$78ed687e3eb26156$export$27f233d61a9e2fa4.catch = console.error;
$78ed687e3eb26156$export$27f233d61a9e2fa4.frameLoop = "always";
$78ed687e3eb26156$export$27f233d61a9e2fa4.advance = ()=>{
    if ($78ed687e3eb26156$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $78ed687e3eb26156$var$update();
};
var $78ed687e3eb26156$var$ts = -1;
var $78ed687e3eb26156$var$pendingCount = 0;
var $78ed687e3eb26156$var$sync = false;
function $78ed687e3eb26156$var$schedule(fn, queue) {
    if ($78ed687e3eb26156$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $78ed687e3eb26156$var$start();
    }
}
function $78ed687e3eb26156$var$start() {
    if ($78ed687e3eb26156$var$ts < 0) {
        $78ed687e3eb26156$var$ts = 0;
        if ($78ed687e3eb26156$export$27f233d61a9e2fa4.frameLoop !== "demand") $78ed687e3eb26156$var$nativeRaf($78ed687e3eb26156$var$loop);
    }
}
function $78ed687e3eb26156$var$stop() {
    $78ed687e3eb26156$var$ts = -1;
}
function $78ed687e3eb26156$var$loop() {
    if (~$78ed687e3eb26156$var$ts) {
        $78ed687e3eb26156$var$nativeRaf($78ed687e3eb26156$var$loop);
        $78ed687e3eb26156$export$27f233d61a9e2fa4.batchedUpdates($78ed687e3eb26156$var$update);
    }
}
function $78ed687e3eb26156$var$update() {
    const prevTs = $78ed687e3eb26156$var$ts;
    $78ed687e3eb26156$var$ts = $78ed687e3eb26156$export$27f233d61a9e2fa4.now();
    const count = $78ed687e3eb26156$var$findTimeout($78ed687e3eb26156$var$ts);
    if (count) {
        $78ed687e3eb26156$var$eachSafely($78ed687e3eb26156$var$timeouts.splice(0, count), (t)=>t.handler());
        $78ed687e3eb26156$var$pendingCount -= count;
    }
    if (!$78ed687e3eb26156$var$pendingCount) {
        $78ed687e3eb26156$var$stop();
        return;
    }
    $78ed687e3eb26156$var$onStartQueue.flush();
    $78ed687e3eb26156$var$updateQueue.flush(prevTs ? Math.min(64, $78ed687e3eb26156$var$ts - prevTs) : 16.667);
    $78ed687e3eb26156$var$onFrameQueue.flush();
    $78ed687e3eb26156$var$writeQueue.flush();
    $78ed687e3eb26156$var$onFinishQueue.flush();
}
function $78ed687e3eb26156$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $78ed687e3eb26156$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $78ed687e3eb26156$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $78ed687e3eb26156$var$pendingCount -= current.size;
                $78ed687e3eb26156$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $78ed687e3eb26156$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $78ed687e3eb26156$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $78ed687e3eb26156$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $78ed687e3eb26156$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $78ed687e3eb26156$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $78ed687e3eb26156$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $78ed687e3eb26156$var$ts = -1;
        $78ed687e3eb26156$var$timeouts = [];
        $78ed687e3eb26156$var$onStartQueue = $78ed687e3eb26156$var$makeQueue();
        $78ed687e3eb26156$var$updateQueue = $78ed687e3eb26156$var$makeQueue();
        $78ed687e3eb26156$var$onFrameQueue = $78ed687e3eb26156$var$makeQueue();
        $78ed687e3eb26156$var$writeQueue = $78ed687e3eb26156$var$makeQueue();
        $78ed687e3eb26156$var$onFinishQueue = $78ed687e3eb26156$var$makeQueue();
        $78ed687e3eb26156$var$pendingCount = 0;
    }
};



var $dhiZh = parcelRequire("dhiZh");
var $eb275e09d3f97530$var$__defProp = Object.defineProperty;
var $eb275e09d3f97530$var$__export = (target, all)=>{
    for(var name in all)$eb275e09d3f97530$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $eb275e09d3f97530$export$cceeabf822b64fc0 = {};
$eb275e09d3f97530$var$__export($eb275e09d3f97530$export$cceeabf822b64fc0, {
    assign: ()=>$eb275e09d3f97530$var$assign,
    colors: ()=>$eb275e09d3f97530$var$colors,
    createStringInterpolator: ()=>$eb275e09d3f97530$var$createStringInterpolator,
    skipAnimation: ()=>$eb275e09d3f97530$var$skipAnimation,
    to: ()=>$eb275e09d3f97530$var$to,
    willAdvance: ()=>$eb275e09d3f97530$var$willAdvance
});
// src/helpers.ts
function $eb275e09d3f97530$export$8793edee2d425525() {}
var $eb275e09d3f97530$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $eb275e09d3f97530$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $eb275e09d3f97530$export$248d38f6296296c5(a, b) {
    if ($eb275e09d3f97530$export$226b3eccf92c9ed9.arr(a)) {
        if (!$eb275e09d3f97530$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $eb275e09d3f97530$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $eb275e09d3f97530$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($eb275e09d3f97530$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $eb275e09d3f97530$export$45b10814cc054894 = (a)=>$eb275e09d3f97530$export$226b3eccf92c9ed9.und(a) ? [] : $eb275e09d3f97530$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $eb275e09d3f97530$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $eb275e09d3f97530$export$79b2f7037acddd43(items, iterator);
    }
}
var $eb275e09d3f97530$export$7ba486852759e806 = (queue, ...args)=>$eb275e09d3f97530$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $eb275e09d3f97530$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $eb275e09d3f97530$var$createStringInterpolator;
var $eb275e09d3f97530$var$to;
var $eb275e09d3f97530$var$colors = null;
var $eb275e09d3f97530$var$skipAnimation = false;
var $eb275e09d3f97530$var$willAdvance = $eb275e09d3f97530$export$8793edee2d425525;
var $eb275e09d3f97530$var$assign = (globals)=>{
    if (globals.to) $eb275e09d3f97530$var$to = globals.to;
    if (globals.now) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $eb275e09d3f97530$var$colors = globals.colors;
    if (globals.skipAnimation != null) $eb275e09d3f97530$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $eb275e09d3f97530$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $eb275e09d3f97530$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $eb275e09d3f97530$var$startQueue = /* @__PURE__ */ new Set();
var $eb275e09d3f97530$var$currentFrame = [];
var $eb275e09d3f97530$var$prevFrame = [];
var $eb275e09d3f97530$var$priority = 0;
var $eb275e09d3f97530$export$a57f5080a3bcc90a = {
    get idle () {
        return !$eb275e09d3f97530$var$startQueue.size && !$eb275e09d3f97530$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($eb275e09d3f97530$var$priority > animation.priority) {
            $eb275e09d3f97530$var$startQueue.add(animation);
            (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).onStart($eb275e09d3f97530$var$flushStartQueue);
        } else {
            $eb275e09d3f97530$var$startSafely(animation);
            (0, $78ed687e3eb26156$export$27f233d61a9e2fa4)($eb275e09d3f97530$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $eb275e09d3f97530$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($eb275e09d3f97530$var$priority) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).onFrame(()=>$eb275e09d3f97530$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $eb275e09d3f97530$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $eb275e09d3f97530$var$currentFrame.splice(prevIndex, 1);
                $eb275e09d3f97530$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $eb275e09d3f97530$var$currentFrame = [];
        $eb275e09d3f97530$var$startQueue.clear();
    }
};
function $eb275e09d3f97530$var$flushStartQueue() {
    $eb275e09d3f97530$var$startQueue.forEach($eb275e09d3f97530$var$startSafely);
    $eb275e09d3f97530$var$startQueue.clear();
    (0, $78ed687e3eb26156$export$27f233d61a9e2fa4)($eb275e09d3f97530$var$advance);
}
function $eb275e09d3f97530$var$startSafely(animation) {
    if (!$eb275e09d3f97530$var$currentFrame.includes(animation)) $eb275e09d3f97530$var$startUnsafely(animation);
}
function $eb275e09d3f97530$var$startUnsafely(animation) {
    $eb275e09d3f97530$var$currentFrame.splice($eb275e09d3f97530$var$findIndex($eb275e09d3f97530$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $eb275e09d3f97530$var$advance(dt) {
    const nextFrame = $eb275e09d3f97530$var$prevFrame;
    for(let i = 0; i < $eb275e09d3f97530$var$currentFrame.length; i++){
        const animation = $eb275e09d3f97530$var$currentFrame[i];
        $eb275e09d3f97530$var$priority = animation.priority;
        if (!animation.idle) {
            $eb275e09d3f97530$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $eb275e09d3f97530$var$priority = 0;
    $eb275e09d3f97530$var$prevFrame = $eb275e09d3f97530$var$currentFrame;
    $eb275e09d3f97530$var$prevFrame.length = 0;
    $eb275e09d3f97530$var$currentFrame = nextFrame;
    return $eb275e09d3f97530$var$currentFrame.length > 0;
}
function $eb275e09d3f97530$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $eb275e09d3f97530$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $eb275e09d3f97530$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $eb275e09d3f97530$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $eb275e09d3f97530$var$PERCENTAGE = $eb275e09d3f97530$var$NUMBER + "%";
function $eb275e09d3f97530$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $eb275e09d3f97530$export$8972dc0e6ad9238f = new RegExp("rgb" + $eb275e09d3f97530$var$call($eb275e09d3f97530$var$NUMBER, $eb275e09d3f97530$var$NUMBER, $eb275e09d3f97530$var$NUMBER));
var $eb275e09d3f97530$export$4e46ac54fc82cf3b = new RegExp("rgba" + $eb275e09d3f97530$var$call($eb275e09d3f97530$var$NUMBER, $eb275e09d3f97530$var$NUMBER, $eb275e09d3f97530$var$NUMBER, $eb275e09d3f97530$var$NUMBER));
var $eb275e09d3f97530$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $eb275e09d3f97530$var$call($eb275e09d3f97530$var$NUMBER, $eb275e09d3f97530$var$PERCENTAGE, $eb275e09d3f97530$var$PERCENTAGE));
var $eb275e09d3f97530$export$810b04175080204c = new RegExp("hsla" + $eb275e09d3f97530$var$call($eb275e09d3f97530$var$NUMBER, $eb275e09d3f97530$var$PERCENTAGE, $eb275e09d3f97530$var$PERCENTAGE, $eb275e09d3f97530$var$NUMBER));
var $eb275e09d3f97530$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $eb275e09d3f97530$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $eb275e09d3f97530$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $eb275e09d3f97530$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $eb275e09d3f97530$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $eb275e09d3f97530$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($eb275e09d3f97530$var$colors && $eb275e09d3f97530$var$colors[color] !== void 0) return $eb275e09d3f97530$var$colors[color];
    if (match = $eb275e09d3f97530$export$8972dc0e6ad9238f.exec(color)) return ($eb275e09d3f97530$var$parse255(match[1]) << 24 | // r
    $eb275e09d3f97530$var$parse255(match[2]) << 16 | // g
    $eb275e09d3f97530$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $eb275e09d3f97530$export$4e46ac54fc82cf3b.exec(color)) return ($eb275e09d3f97530$var$parse255(match[1]) << 24 | // r
    $eb275e09d3f97530$var$parse255(match[2]) << 16 | // g
    $eb275e09d3f97530$var$parse255(match[3]) << 8 | // b
    $eb275e09d3f97530$var$parse1(match[4])) >>> // a
    0;
    if (match = $eb275e09d3f97530$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $eb275e09d3f97530$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $eb275e09d3f97530$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $eb275e09d3f97530$export$8f4a7c0bb78e6ea8.exec(color)) return ($eb275e09d3f97530$var$hslToRgb($eb275e09d3f97530$var$parse360(match[1]), // h
    $eb275e09d3f97530$var$parsePercentage(match[2]), // s
    $eb275e09d3f97530$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $eb275e09d3f97530$export$810b04175080204c.exec(color)) return ($eb275e09d3f97530$var$hslToRgb($eb275e09d3f97530$var$parse360(match[1]), // h
    $eb275e09d3f97530$var$parsePercentage(match[2]), // s
    $eb275e09d3f97530$var$parsePercentage(match[3])) | $eb275e09d3f97530$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $eb275e09d3f97530$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $eb275e09d3f97530$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $eb275e09d3f97530$var$hue2rgb(p, q, h + 1 / 3);
    const g = $eb275e09d3f97530$var$hue2rgb(p, q, h);
    const b = $eb275e09d3f97530$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $eb275e09d3f97530$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $eb275e09d3f97530$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $eb275e09d3f97530$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $eb275e09d3f97530$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $eb275e09d3f97530$export$61db176b839af1f(input) {
    let int32Color = $eb275e09d3f97530$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $eb275e09d3f97530$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($eb275e09d3f97530$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($eb275e09d3f97530$export$226b3eccf92c9ed9.arr(range)) return $eb275e09d3f97530$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($eb275e09d3f97530$export$226b3eccf92c9ed9.str(range.output[0])) return $eb275e09d3f97530$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $eb275e09d3f97530$var$findRange(input, inputRange);
        return $eb275e09d3f97530$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $eb275e09d3f97530$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $eb275e09d3f97530$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $eb275e09d3f97530$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $eb275e09d3f97530$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $eb275e09d3f97530$var$c1 = 1.70158;
var $eb275e09d3f97530$var$c2 = $eb275e09d3f97530$var$c1 * 1.525;
var $eb275e09d3f97530$var$c3 = $eb275e09d3f97530$var$c1 + 1;
var $eb275e09d3f97530$var$c4 = 2 * Math.PI / 3;
var $eb275e09d3f97530$var$c5 = 2 * Math.PI / 4.5;
var $eb275e09d3f97530$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $eb275e09d3f97530$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$eb275e09d3f97530$var$c3 * x * x * x - $eb275e09d3f97530$var$c1 * x * x,
    easeOutBack: (x)=>1 + $eb275e09d3f97530$var$c3 * Math.pow(x - 1, 3) + $eb275e09d3f97530$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($eb275e09d3f97530$var$c2 + 1) * 2 * x - $eb275e09d3f97530$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($eb275e09d3f97530$var$c2 + 1) * (x * 2 - 2) + $eb275e09d3f97530$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $eb275e09d3f97530$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $eb275e09d3f97530$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $eb275e09d3f97530$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $eb275e09d3f97530$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $eb275e09d3f97530$var$bounceOut(1 - x),
    easeOutBounce: $eb275e09d3f97530$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $eb275e09d3f97530$var$bounceOut(1 - 2 * x)) / 2 : (1 + $eb275e09d3f97530$var$bounceOut(2 * x - 1)) / 2,
    steps: $eb275e09d3f97530$var$steps
};
// src/fluids.ts
var $eb275e09d3f97530$var$$get = Symbol.for("FluidValue.get");
var $eb275e09d3f97530$var$$observers = Symbol.for("FluidValue.observers");
var $eb275e09d3f97530$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$eb275e09d3f97530$var$$get]);
var $eb275e09d3f97530$export$e37b7520edd66839 = (arg)=>arg && arg[$eb275e09d3f97530$var$$get] ? arg[$eb275e09d3f97530$var$$get]() : arg;
var $eb275e09d3f97530$export$133f54e9f7cf1796 = (target)=>target[$eb275e09d3f97530$var$$observers] || null;
function $eb275e09d3f97530$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $eb275e09d3f97530$export$31752c40a5fab62a(target, event) {
    const observers = target[$eb275e09d3f97530$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $eb275e09d3f97530$export$8cbca1207adce0c0(observer2, event);
    });
}
var $eb275e09d3f97530$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $eb275e09d3f97530$export$a3b4618659637aa3(this, get);
    }
};
$eb275e09d3f97530$var$$get, $eb275e09d3f97530$var$$observers;
var $eb275e09d3f97530$export$a3b4618659637aa3 = (target, get)=>$eb275e09d3f97530$var$setHidden(target, $eb275e09d3f97530$var$$get, get);
function $eb275e09d3f97530$export$72d604e3f8d000a5(target, observer2) {
    if (target[$eb275e09d3f97530$var$$get]) {
        let observers = target[$eb275e09d3f97530$var$$observers];
        if (!observers) $eb275e09d3f97530$var$setHidden(target, $eb275e09d3f97530$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $eb275e09d3f97530$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$eb275e09d3f97530$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$eb275e09d3f97530$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $eb275e09d3f97530$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $eb275e09d3f97530$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $eb275e09d3f97530$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $eb275e09d3f97530$var$unitRegex = new RegExp(`(${$eb275e09d3f97530$var$numberRegex.source})(%|[a-z]+)`, "i");
var $eb275e09d3f97530$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $eb275e09d3f97530$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $eb275e09d3f97530$var$variableToRgba = (input)=>{
    const [token, fallback] = $eb275e09d3f97530$var$parseCSSVariable(input);
    if (!token || $eb275e09d3f97530$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $eb275e09d3f97530$var$cssVariableRegex.test(fallback)) return $eb275e09d3f97530$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $eb275e09d3f97530$var$parseCSSVariable = (current)=>{
    const match = $eb275e09d3f97530$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $eb275e09d3f97530$var$namedColorRegex;
var $eb275e09d3f97530$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $eb275e09d3f97530$export$4759a013d387347a = (config)=>{
    if (!$eb275e09d3f97530$var$namedColorRegex) $eb275e09d3f97530$var$namedColorRegex = $eb275e09d3f97530$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($eb275e09d3f97530$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $eb275e09d3f97530$export$e37b7520edd66839(value).replace($eb275e09d3f97530$var$cssVariableRegex, $eb275e09d3f97530$var$variableToRgba).replace($eb275e09d3f97530$var$colorRegex, $eb275e09d3f97530$export$61db176b839af1f).replace($eb275e09d3f97530$var$namedColorRegex, $eb275e09d3f97530$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($eb275e09d3f97530$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$eb275e09d3f97530$export$b12af43b97697ef5((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, config), {
            output: output2
        })));
    return (input)=>{
        var _output_find;
        const missingUnit = !$eb275e09d3f97530$var$unitRegex.test(output[0]) && ((_output_find = output.find((value)=>$eb275e09d3f97530$var$unitRegex.test(value))) === null || _output_find === void 0 ? void 0 : _output_find.replace($eb275e09d3f97530$var$numberRegex, ""));
        let i = 0;
        return output[0].replace($eb275e09d3f97530$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($eb275e09d3f97530$var$rgbaRegex, $eb275e09d3f97530$var$rgbaRound);
    };
};
// src/deprecations.ts
var $eb275e09d3f97530$export$82e9f45cca5ba907 = "react-spring: ";
var $eb275e09d3f97530$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$eb275e09d3f97530$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $eb275e09d3f97530$var$warnInterpolate = $eb275e09d3f97530$export$d2de3aaeafa91619(console.warn);
function $eb275e09d3f97530$export$2abfcde8ae218ba8() {
    $eb275e09d3f97530$var$warnInterpolate(`${$eb275e09d3f97530$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $eb275e09d3f97530$var$warnDirectCall = $eb275e09d3f97530$export$d2de3aaeafa91619(console.warn);
function $eb275e09d3f97530$export$d99d974913ad3b12() {
    $eb275e09d3f97530$var$warnDirectCall(`${$eb275e09d3f97530$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $eb275e09d3f97530$export$75bed621f62abfa9(value) {
    return $eb275e09d3f97530$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$eb275e09d3f97530$export$48d7c418edadb60c() && $eb275e09d3f97530$var$cssVariableRegex.test(value) || value in ($eb275e09d3f97530$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $eb275e09d3f97530$var$observer;
var $eb275e09d3f97530$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $eb275e09d3f97530$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        var _resizeHandlers_get;
        return (_resizeHandlers_get = $eb275e09d3f97530$var$resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach((handler)=>handler(contentRect));
    });
function $eb275e09d3f97530$var$resizeElement(handler, target) {
    if (!$eb275e09d3f97530$var$observer) {
        if (typeof ResizeObserver !== "undefined") $eb275e09d3f97530$var$observer = new ResizeObserver($eb275e09d3f97530$var$handleObservation);
    }
    let elementHandlers = $eb275e09d3f97530$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $eb275e09d3f97530$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($eb275e09d3f97530$var$observer) $eb275e09d3f97530$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $eb275e09d3f97530$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $eb275e09d3f97530$var$observer) $eb275e09d3f97530$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $eb275e09d3f97530$var$listeners = /* @__PURE__ */ new Set();
var $eb275e09d3f97530$var$cleanupWindowResizeHandler;
var $eb275e09d3f97530$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $eb275e09d3f97530$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $eb275e09d3f97530$var$resizeWindow = (callback)=>{
    $eb275e09d3f97530$var$listeners.add(callback);
    if (!$eb275e09d3f97530$var$cleanupWindowResizeHandler) $eb275e09d3f97530$var$cleanupWindowResizeHandler = $eb275e09d3f97530$var$createResizeHandler();
    return ()=>{
        $eb275e09d3f97530$var$listeners.delete(callback);
        if (!$eb275e09d3f97530$var$listeners.size && $eb275e09d3f97530$var$cleanupWindowResizeHandler) {
            $eb275e09d3f97530$var$cleanupWindowResizeHandler();
            $eb275e09d3f97530$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $eb275e09d3f97530$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $eb275e09d3f97530$var$resizeWindow(callback);
    else return $eb275e09d3f97530$var$resizeElement(callback, container);
};
// src/progress.ts
var $eb275e09d3f97530$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $eb275e09d3f97530$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $eb275e09d3f97530$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $eb275e09d3f97530$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $eb275e09d3f97530$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $eb275e09d3f97530$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $eb275e09d3f97530$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $eb275e09d3f97530$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $eb275e09d3f97530$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $eb275e09d3f97530$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $eb275e09d3f97530$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $eb275e09d3f97530$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $eb275e09d3f97530$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$eb275e09d3f97530$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers === null || containerHandlers === void 0 ? void 0 : containerHandlers.forEach((handler)=>handler.advance());
            return true;
        };
        $eb275e09d3f97530$var$scrollListeners.set(container, listener);
        const target = $eb275e09d3f97530$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $eb275e09d3f97530$var$resizeListeners.set(container, $eb275e09d3f97530$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $eb275e09d3f97530$var$scrollListeners.get(container);
    (0, $78ed687e3eb26156$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $eb275e09d3f97530$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $eb275e09d3f97530$var$scrollListeners.get(container);
        $eb275e09d3f97530$var$scrollListeners.delete(container);
        if (listener) {
            var _resizeListeners_get;
            $eb275e09d3f97530$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            (_resizeListeners_get = $eb275e09d3f97530$var$resizeListeners.get(container)) === null || _resizeListeners_get === void 0 ? void 0 : _resizeListeners_get();
        }
    };
};
function $eb275e09d3f97530$export$fe4300aa8eebea86(init) {
    const ref = (0, $dhiZh.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $eb275e09d3f97530$export$700979bc83e7db82 = $eb275e09d3f97530$export$48d7c418edadb60c() ? (0, $dhiZh.useEffect) : (0, $dhiZh.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $eb275e09d3f97530$var$useIsMounted = ()=>{
    const isMounted = (0, $dhiZh.useRef)(false);
    $eb275e09d3f97530$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $eb275e09d3f97530$export$91db9bc4f8ac944a() {
    const update = (0, $dhiZh.useState)()[1];
    const isMounted = $eb275e09d3f97530$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $eb275e09d3f97530$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $dhiZh.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $dhiZh.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $eb275e09d3f97530$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $dhiZh.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $eb275e09d3f97530$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $eb275e09d3f97530$export$392544347a18b6ea = (effect)=>(0, $dhiZh.useEffect)(effect, $eb275e09d3f97530$var$emptyDeps);
var $eb275e09d3f97530$var$emptyDeps = [];
function $eb275e09d3f97530$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $dhiZh.useRef)();
    (0, $dhiZh.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $eb275e09d3f97530$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $dhiZh.useState)(null);
    $eb275e09d3f97530$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $eb275e09d3f97530$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $dhiZh = parcelRequire("dhiZh");
// src/Animated.ts




var $dhiZh = parcelRequire("dhiZh");
var $e1655c60e9aef219$var$$node = Symbol.for("Animated:node");
var $e1655c60e9aef219$export$3df5e165e801a70f = (value)=>!!value && value[$e1655c60e9aef219$var$$node] === value;
var $e1655c60e9aef219$export$6b63995194a3a9e4 = (owner)=>owner && owner[$e1655c60e9aef219$var$$node];
var $e1655c60e9aef219$export$b553cb5b22b81b04 = (owner, node)=>(0, $eb275e09d3f97530$export$5c74248ea0e35446)(owner, $e1655c60e9aef219$var$$node, node);
var $e1655c60e9aef219$export$ccab2b64c5d440 = (owner)=>owner && owner[$e1655c60e9aef219$var$$node] && owner[$e1655c60e9aef219$var$$node].getPayload();
var $e1655c60e9aef219$export$31627395a3b18e54 = class {
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
    constructor(){
        $e1655c60e9aef219$export$b553cb5b22b81b04(this, this);
    }
};
var $e1655c60e9aef219$export$cb1e8f3c05d37ad5 = class extends $e1655c60e9aef219$export$31627395a3b18e54 {
    /** @internal */ static create(value) {
        return new $e1655c60e9aef219$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
};
var $e1655c60e9aef219$export$f6c6c4cbd7fa5b93 = class extends $e1655c60e9aef219$export$cb1e8f3c05d37ad5 {
    /** @internal */ static create(value) {
        return new $e1655c60e9aef219$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $eb275e09d3f97530$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $eb275e09d3f97530$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
};
// src/context.ts
var $e1655c60e9aef219$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $e1655c60e9aef219$export$f1b0b9e366a6e2d4 = class extends $e1655c60e9aef219$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($e1655c60e9aef219$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $eb275e09d3f97530$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $eb275e09d3f97530$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($e1655c60e9aef219$var$TreeContext.dependencies && (0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(source)) $e1655c60e9aef219$var$TreeContext.dependencies.add(source);
        const payload = $e1655c60e9aef219$export$ccab2b64c5d440(source);
        if (payload) (0, $eb275e09d3f97530$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
};
// src/AnimatedArray.ts
var $e1655c60e9aef219$export$ede394683406942d = class extends $e1655c60e9aef219$export$f1b0b9e366a6e2d4 {
    /** @internal */ static create(source) {
        return new $e1655c60e9aef219$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($e1655c60e9aef219$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
};
function $e1655c60e9aef219$var$makeAnimated(value) {
    const nodeType = (0, $eb275e09d3f97530$export$75bed621f62abfa9)(value) ? $e1655c60e9aef219$export$f6c6c4cbd7fa5b93 : $e1655c60e9aef219$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $e1655c60e9aef219$export$e6b77ddbe47b132e(value) {
    const parentNode = $e1655c60e9aef219$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(value) ? $e1655c60e9aef219$export$ede394683406942d : (0, $eb275e09d3f97530$export$75bed621f62abfa9)(value) ? $e1655c60e9aef219$export$f6c6c4cbd7fa5b93 : $e1655c60e9aef219$export$cb1e8f3c05d37ad5;
}
var $e1655c60e9aef219$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $dhiZh.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $dhiZh.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $dhiZh.useCallback)((value)=>{
            instanceRef.current = $e1655c60e9aef219$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $e1655c60e9aef219$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $eb275e09d3f97530$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $e1655c60e9aef219$var$PropsObserver(callback, deps);
        const observerRef = (0, $dhiZh.useRef)();
        (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(deps, (dep)=>(0, $eb275e09d3f97530$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $eb275e09d3f97530$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $eb275e09d3f97530$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $dhiZh.useEffect)(callback, []);
        (0, $eb275e09d3f97530$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $eb275e09d3f97530$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $eb275e09d3f97530$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $dhiZh.createElement(Component, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, usedProps), {
            ref: ref
        }));
    });
};
var $e1655c60e9aef219$var$PropsObserver = class {
    eventObserved(event) {
        if (event.type == "change") (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
};
function $e1655c60e9aef219$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $e1655c60e9aef219$var$TreeContext.dependencies = dependencies;
    if (props.style) props = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, props), {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $e1655c60e9aef219$export$f1b0b9e366a6e2d4(props);
    $e1655c60e9aef219$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $e1655c60e9aef219$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $e1655c60e9aef219$var$cacheKey = Symbol.for("AnimatedComponent");
var $e1655c60e9aef219$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $e1655c60e9aef219$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $e1655c60e9aef219$var$getDisplayName(Component) || "Anonymous";
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $e1655c60e9aef219$var$withAnimated(Component, hostConfig));
        else Component = Component[$e1655c60e9aef219$var$cacheKey] || (Component[$e1655c60e9aef219$var$cacheKey] = $e1655c60e9aef219$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(components)) key = $e1655c60e9aef219$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $e1655c60e9aef219$var$getDisplayName = (arg)=>(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $8f3a465376c8c0a5$export$b24b633b1364b94b = class {
};


function $4838f69e216ac757$var$callProp(value, ...args) {
    return (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $4838f69e216ac757$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $eb275e09d3f97530$export$45b10814cc054894)(value).includes(key)));
var $4838f69e216ac757$var$resolveProp = (prop, key)=>(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $4838f69e216ac757$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $4838f69e216ac757$var$noopTransform = (value)=>value;
var $4838f69e216ac757$var$getDefaultProps = (props, transform = $4838f69e216ac757$var$noopTransform)=>{
    let keys = $4838f69e216ac757$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $4838f69e216ac757$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $4838f69e216ac757$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $4838f69e216ac757$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$4838f69e216ac757$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $4838f69e216ac757$export$b971039a739bf227(props) {
    const to2 = $4838f69e216ac757$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, props);
}
function $4838f69e216ac757$var$computeGoal(value) {
    value = (0, $eb275e09d3f97530$export$e37b7520edd66839)(value);
    return (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(value) ? value.map($4838f69e216ac757$var$computeGoal) : (0, $eb275e09d3f97530$export$75bed621f62abfa9)(value) ? (0, $eb275e09d3f97530$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $4838f69e216ac757$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $4838f69e216ac757$var$isAsyncTo(to2) {
    return (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(to2) || (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(to2) && (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $4838f69e216ac757$var$detachRefs(ctrl, ref) {
    var _ctrl_ref;
    (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref.delete(ctrl);
    ref === null || ref === void 0 ? void 0 : ref.delete(ctrl);
}
function $4838f69e216ac757$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl_ref;
        (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $4838f69e216ac757$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $eb275e09d3f97530$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $4838f69e216ac757$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $eb275e09d3f97530$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $4838f69e216ac757$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $4838f69e216ac757$var$defaults = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, $4838f69e216ac757$export$e506a1d27d1eaa20.default), {
    mass: 1,
    damping: 1,
    easing: (0, $eb275e09d3f97530$export$15a0bf1b4bbacad8).linear,
    clamp: false
});
var $4838f69e216ac757$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $4838f69e216ac757$var$defaults);
    }
};
function $4838f69e216ac757$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, defaultConfig);
        $4838f69e216ac757$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, defaultConfig, newConfig);
    }
    $4838f69e216ac757$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $4838f69e216ac757$var$defaults)if (config2[key] == null) config2[key] = $4838f69e216ac757$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $4838f69e216ac757$var$sanitizeConfig(config2, props) {
    if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.tension) || !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.damping) || !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $4838f69e216ac757$var$emptyArray = [];
var $4838f69e216ac757$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $4838f69e216ac757$var$emptyArray;
        this.toValues = null;
        this.fromValues = $4838f69e216ac757$var$emptyArray;
        this.config = new $4838f69e216ac757$var$AnimationConfig();
        this.immediate = false;
    }
};
function $4838f69e216ac757$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        var _props_cancel;
        let cancel = $4838f69e216ac757$var$matchProp((_props_cancel = props.cancel) !== null && _props_cancel !== void 0 ? _props_cancel : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $4838f69e216ac757$var$matchProp(props.pause, key);
            let pause = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $4838f69e216ac757$var$matchProp(pause, key);
            delay = $4838f69e216ac757$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $eb275e09d3f97530$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, props), {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $4838f69e216ac757$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $4838f69e216ac757$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $4838f69e216ac757$var$getNoopResult(target.get()) : $4838f69e216ac757$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $4838f69e216ac757$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $4838f69e216ac757$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $4838f69e216ac757$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $4838f69e216ac757$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $4838f69e216ac757$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $4838f69e216ac757$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $4838f69e216ac757$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $4838f69e216ac757$export$d362d093fa99dc7();
            const skipAnimationSignal = new $4838f69e216ac757$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $eb275e09d3f97530$export$cceeabf822b64fc0).skipAnimation) {
                    $4838f69e216ac757$var$stopAsync(state);
                    skipAnimationSignal.result = $4838f69e216ac757$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(arg1) ? (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, arg1) : (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, arg2), {
                    to: arg1
                });
                props2.parentId = callId;
                (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $eb275e09d3f97530$export$cceeabf822b64fc0).skipAnimation) {
            $4838f69e216ac757$var$stopAsync(state);
            return $4838f69e216ac757$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $4838f69e216ac757$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $4838f69e216ac757$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $4838f69e216ac757$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(onRest)) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $4838f69e216ac757$var$stopAsync(state, cancelId) {
    (0, $eb275e09d3f97530$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $4838f69e216ac757$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $4838f69e216ac757$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $4838f69e216ac757$var$isFrameValue = (value)=>value instanceof $4838f69e216ac757$export$8229896f80e2495e;
var $4838f69e216ac757$var$nextId = 1;
var $4838f69e216ac757$export$8229896f80e2495e = class extends (0, $eb275e09d3f97530$export$aff8e1ac1a016a2) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $eb275e09d3f97530$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $eb275e09d3f97530$export$2abfcde8ae218ba8)();
        return (0, $eb275e09d3f97530$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $eb275e09d3f97530$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $eb275e09d3f97530$export$a57f5080a3bcc90a).sort(this);
        (0, $eb275e09d3f97530$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(){
        super(...arguments);
        this.id = $4838f69e216ac757$var$nextId++;
        this._priority = 0;
    }
};
// src/SpringPhase.ts
var $4838f69e216ac757$var$$P = Symbol.for("SpringPhase");
var $4838f69e216ac757$var$HAS_ANIMATED = 1;
var $4838f69e216ac757$var$IS_ANIMATING = 2;
var $4838f69e216ac757$var$IS_PAUSED = 4;
var $4838f69e216ac757$var$hasAnimated = (target)=>(target[$4838f69e216ac757$var$$P] & $4838f69e216ac757$var$HAS_ANIMATED) > 0;
var $4838f69e216ac757$var$isAnimating = (target)=>(target[$4838f69e216ac757$var$$P] & $4838f69e216ac757$var$IS_ANIMATING) > 0;
var $4838f69e216ac757$var$isPaused = (target)=>(target[$4838f69e216ac757$var$$P] & $4838f69e216ac757$var$IS_PAUSED) > 0;
var $4838f69e216ac757$var$setActiveBit = (target, active)=>active ? target[$4838f69e216ac757$var$$P] |= $4838f69e216ac757$var$IS_ANIMATING | $4838f69e216ac757$var$HAS_ANIMATED : target[$4838f69e216ac757$var$$P] &= ~$4838f69e216ac757$var$IS_ANIMATING;
var $4838f69e216ac757$var$setPausedBit = (target, paused)=>paused ? target[$4838f69e216ac757$var$$P] |= $4838f69e216ac757$var$IS_PAUSED : target[$4838f69e216ac757$var$$P] &= ~$4838f69e216ac757$var$IS_PAUSED;
// src/SpringValue.ts
var $4838f69e216ac757$export$5854d13427d5a954 = class extends $4838f69e216ac757$export$8229896f80e2495e {
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($4838f69e216ac757$var$isAnimating(this) || this._state.asyncTo) || $4838f69e216ac757$var$isPaused(this);
    }
    get goal() {
        return (0, $eb275e09d3f97530$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $e1655c60e9aef219$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $4838f69e216ac757$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $4838f69e216ac757$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $4838f69e216ac757$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $e1655c60e9aef219$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $eb275e09d3f97530$export$45b10814cc054894)((0, $eb275e09d3f97530$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $e1655c60e9aef219$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $eb275e09d3f97530$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($4838f69e216ac757$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(to2) ? to2 : (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, arg2), {
                to: to2
            })
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$4838f69e216ac757$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $4838f69e216ac757$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $4838f69e216ac757$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$4838f69e216ac757$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $eb275e09d3f97530$export$e37b7520edd66839)(from);
            if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update(_param, isLoop) {
        var props = (0, $8c4bc528d81dc2b7$export$71511d61b312f219)({}, (0, $c9e1fbf136a700c5$export$71511d61b312f219)(_param));
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $4838f69e216ac757$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $4838f69e216ac757$var$resolveProp(value, key) : value));
        $4838f69e216ac757$var$mergeActiveFn(this, props, "onProps");
        $4838f69e216ac757$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $4838f69e216ac757$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$4838f69e216ac757$var$isPaused(this)) {
                        $4838f69e216ac757$var$setPausedBit(this, true);
                        (0, $eb275e09d3f97530$export$7ba486852759e806)(state.pauseQueue);
                        $4838f69e216ac757$var$sendEvent(this, "onPause", $4838f69e216ac757$var$getFinishedResult(this, $4838f69e216ac757$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($4838f69e216ac757$var$isPaused(this)) {
                        $4838f69e216ac757$var$setPausedBit(this, false);
                        if ($4838f69e216ac757$var$isAnimating(this)) this._resume();
                        (0, $eb275e09d3f97530$export$7ba486852759e806)(state.resumeQueue);
                        $4838f69e216ac757$var$sendEvent(this, "onResume", $4838f69e216ac757$var$getFinishedResult(this, $4838f69e216ac757$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $4838f69e216ac757$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($4838f69e216ac757$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($4838f69e216ac757$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $eb275e09d3f97530$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $eb275e09d3f97530$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $eb275e09d3f97530$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $4838f69e216ac757$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $4838f69e216ac757$var$mergeConfig(config2, $4838f69e216ac757$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $4838f69e216ac757$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this);
        if (!node || (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(to2)) return resolve($4838f69e216ac757$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(from) && $4838f69e216ac757$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $4838f69e216ac757$var$computeGoal(to2);
        const isAnimatable = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).num(goal) || (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(goal) || (0, $eb275e09d3f97530$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $4838f69e216ac757$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $e1655c60e9aef219$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$4838f69e216ac757$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $eb275e09d3f97530$export$248d38f6296296c5)($4838f69e216ac757$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $eb275e09d3f97530$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $eb275e09d3f97530$export$248d38f6296296c5)(config2.decay, decay) || !(0, $eb275e09d3f97530$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $4838f69e216ac757$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $e1655c60e9aef219$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $eb275e09d3f97530$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $eb275e09d3f97530$export$79b2f7037acddd43)($4838f69e216ac757$var$ACTIVE_EVENTS, (type)=>$4838f69e216ac757$var$mergeActiveFn(this, props, type));
                const result = $4838f69e216ac757$var$getFinishedResult(this, $4838f69e216ac757$var$checkFinished(this, prevTo));
                (0, $eb275e09d3f97530$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    var _anim_onStart;
                    anim.changed = !reset;
                    onRest === null || onRest === void 0 ? void 0 : onRest(result, this);
                    if (reset) $4838f69e216ac757$var$callProp(defaultProps.onRest, result);
                    else (_anim_onStart = anim.onStart) === null || _anim_onStart === void 0 ? void 0 : _anim_onStart.call(anim, result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($4838f69e216ac757$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($4838f69e216ac757$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($4838f69e216ac757$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $eb275e09d3f97530$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $eb275e09d3f97530$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(to2)) {
            (0, $eb275e09d3f97530$export$72d604e3f8d000a5)(to2, this);
            if ($4838f69e216ac757$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(to2)) (0, $eb275e09d3f97530$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $eb275e09d3f97530$export$e37b7520edd66839)(arg);
        if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $eb275e09d3f97530$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $e1655c60e9aef219$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $e1655c60e9aef219$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $4838f69e216ac757$var$sendEvent(this, "onStart", $4838f69e216ac757$var$getFinishedResult(this, $4838f69e216ac757$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $4838f69e216ac757$var$callProp(this.animation.onChange, value, this);
        }
        $4838f69e216ac757$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this).reset((0, $eb275e09d3f97530$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$4838f69e216ac757$var$isAnimating(this)) {
            $4838f69e216ac757$var$setActiveBit(this, true);
            if (!$4838f69e216ac757$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $eb275e09d3f97530$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $eb275e09d3f97530$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($4838f69e216ac757$var$isAnimating(this)) {
            $4838f69e216ac757$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $eb275e09d3f97530$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $4838f69e216ac757$var$getCancelledResult(this.get()) : $4838f69e216ac757$var$getFinishedResult(this.get(), $4838f69e216ac757$var$checkFinished(this, goal !== null && goal !== void 0 ? goal : anim.to));
            (0, $eb275e09d3f97530$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $4838f69e216ac757$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $4838f69e216ac757$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(arg1) || !(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(arg1) ? (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, arg1) : (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, arg2), {
                from: arg1
            });
            if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
};
function $4838f69e216ac757$var$checkFinished(target, to2) {
    const goal = $4838f69e216ac757$var$computeGoal(to2);
    const value = $4838f69e216ac757$var$computeGoal(target.get());
    return (0, $eb275e09d3f97530$export$248d38f6296296c5)(value, goal);
}
function $4838f69e216ac757$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $4838f69e216ac757$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $4838f69e216ac757$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $4838f69e216ac757$var$createUpdate((0, $53825fa7fd9c8174$export$71511d61b312f219)((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, props), {
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $4838f69e216ac757$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset
        }), overrides));
    }
}
function $4838f69e216ac757$var$createUpdate(props) {
    const { to: to2, from: from } = props = $4838f69e216ac757$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(to2)) $4838f69e216ac757$var$findDefined(to2, keys);
    if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(from)) $4838f69e216ac757$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $4838f69e216ac757$var$declareUpdate(props) {
    const update2 = $4838f69e216ac757$var$createUpdate(props);
    if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $4838f69e216ac757$var$getDefaultProps(update2);
    return update2;
}
function $4838f69e216ac757$var$findDefined(values, keys) {
    (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $4838f69e216ac757$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $4838f69e216ac757$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $4838f69e216ac757$var$getDefaultProp(props, type) ? $4838f69e216ac757$var$resolveProp(props[type], target.key) : void 0;
}
function $4838f69e216ac757$var$sendEvent(target, type, ...args) {
    var _target_animation_type, _target_animation, _target_defaultProps_type, _target_defaultProps;
    (_target_animation_type = (_target_animation = target.animation)[type]) === null || _target_animation_type === void 0 ? void 0 : _target_animation_type.call(_target_animation, ...args);
    (_target_defaultProps_type = (_target_defaultProps = target.defaultProps)[type]) === null || _target_defaultProps_type === void 0 ? void 0 : _target_defaultProps_type.call(_target_defaultProps, ...args);
}
var $4838f69e216ac757$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $4838f69e216ac757$var$nextId2 = 1;
var $4838f69e216ac757$export$bd0bf19f25da8474 = class {
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($4838f69e216ac757$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $eb275e09d3f97530$export$45b10814cc054894)(props).map($4838f69e216ac757$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $4838f69e216ac757$var$prepareKeys(this, queue);
        return $4838f69e216ac757$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $eb275e09d3f97530$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $4838f69e216ac757$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $eb275e09d3f97530$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $eb275e09d3f97530$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $eb275e09d3f97530$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $eb275e09d3f97530$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $eb275e09d3f97530$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
    constructor(props, flush3){
        this.id = $4838f69e216ac757$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start((0, $53825fa7fd9c8174$export$71511d61b312f219)({
            default: true
        }, props));
    }
};
function $4838f69e216ac757$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$4838f69e216ac757$var$flushUpdate(ctrl, props))).then((results)=>$4838f69e216ac757$var$getCombinedResult(ctrl, results));
}
async function $4838f69e216ac757$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(to2) || (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $eb275e09d3f97530$export$79b2f7037acddd43)($4838f69e216ac757$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $eb275e09d3f97530$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $4838f69e216ac757$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($4838f69e216ac757$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $eb275e09d3f97530$export$8793edee2d425525),
            resume: (0, $eb275e09d3f97530$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $4838f69e216ac757$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($4838f69e216ac757$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($4838f69e216ac757$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $4838f69e216ac757$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $4838f69e216ac757$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $4838f69e216ac757$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $4838f69e216ac757$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $4838f69e216ac757$var$getSprings(ctrl, props) {
    const springs = (0, $53825fa7fd9c8174$export$71511d61b312f219)({}, ctrl.springs);
    if (props) (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $eb275e09d3f97530$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $4838f69e216ac757$var$createUpdate(props2);
        if (!(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(props2.to)) props2 = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, props2), {
            to: void 0
        });
        $4838f69e216ac757$var$prepareSprings(springs, props2, (key)=>{
            return $4838f69e216ac757$var$createSpring(key);
        });
    });
    $4838f69e216ac757$var$setSprings(ctrl, springs);
    return springs;
}
function $4838f69e216ac757$var$setSprings(ctrl, springs) {
    (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $eb275e09d3f97530$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $4838f69e216ac757$var$createSpring(key, observer) {
    const spring = new $4838f69e216ac757$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $eb275e09d3f97530$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $4838f69e216ac757$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $eb275e09d3f97530$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $4838f69e216ac757$var$prepareKeys(ctrl, queue) {
    (0, $eb275e09d3f97530$export$79b2f7037acddd43)(queue, (props)=>{
        $4838f69e216ac757$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $4838f69e216ac757$var$createSpring(key, ctrl);
        });
    });
}
var $4838f69e216ac757$export$f12a216ec50d2cf1 = (_param)=>{
    var { children: children } = _param, props = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "children"
    ]);
    const inherited = (0, $dhiZh.useContext)($4838f69e216ac757$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $eb275e09d3f97530$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $4838f69e216ac757$var$ctx;
    return /* @__PURE__ */ $dhiZh.createElement(Provider, {
        value: props
    }, children);
};
var $4838f69e216ac757$var$ctx = $4838f69e216ac757$var$makeContext($4838f69e216ac757$export$f12a216ec50d2cf1, {});
$4838f69e216ac757$export$f12a216ec50d2cf1.Provider = $4838f69e216ac757$var$ctx.Provider;
$4838f69e216ac757$export$f12a216ec50d2cf1.Consumer = $4838f69e216ac757$var$ctx.Consumer;
function $4838f69e216ac757$var$makeContext(target, init) {
    Object.assign(target, $dhiZh.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $4838f69e216ac757$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $eb275e09d3f97530$export$d99d974913ad3b12)();
        const results = [];
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $4838f69e216ac757$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $dhiZh.useMemo)(()=>propsFn || arguments.length == 3 ? $4838f69e216ac757$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $dhiZh.useRef)(0);
    const forceUpdate = (0, $eb275e09d3f97530$export$91db9bc4f8ac944a)();
    const state = (0, $dhiZh.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $4838f69e216ac757$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $4838f69e216ac757$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $4838f69e216ac757$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($4838f69e216ac757$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $dhiZh.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $eb275e09d3f97530$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $dhiZh.useMemo)(()=>{
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $4838f69e216ac757$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $dhiZh.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $4838f69e216ac757$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $4838f69e216ac757$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$4838f69e216ac757$var$getSprings(ctrl, updates[i]));
    const context = (0, $dhiZh.useContext)($4838f69e216ac757$export$f12a216ec50d2cf1);
    const prevContext = (0, $eb275e09d3f97530$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $4838f69e216ac757$var$hasProps(context);
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $4838f69e216ac757$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $eb275e09d3f97530$export$392544347a18b6ea)(()=>()=>{
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>(0, $53825fa7fd9c8174$export$71511d61b312f219)({}, x));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $4838f69e216ac757$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $4838f69e216ac757$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $4838f69e216ac757$var$initSpringRef = ()=>$4838f69e216ac757$export$2471ae76e2946684();
var $4838f69e216ac757$export$564bff9c23cad2ca = ()=>(0, $dhiZh.useState)($4838f69e216ac757$var$initSpringRef)[0];
var $4838f69e216ac757$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $eb275e09d3f97530$export$fe4300aa8eebea86)(()=>new $4838f69e216ac757$export$5854d13427d5a954(initial, props));
    (0, $eb275e09d3f97530$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $4838f69e216ac757$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $4838f69e216ac757$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $4838f69e216ac757$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef !== null && passedRef !== void 0 ? passedRef : result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $4838f69e216ac757$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $dhiZh.useMemo)(()=>propsFn || arguments.length == 3 ? $4838f69e216ac757$export$2471ae76e2946684() : void 0, []);
    const items = (0, $eb275e09d3f97530$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $dhiZh.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $eb275e09d3f97530$export$392544347a18b6ea)(()=>{
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(transitions, (t)=>{
            ref === null || ref === void 0 ? void 0 : ref.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $4838f69e216ac757$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $4838f69e216ac757$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>(0, $eb275e09d3f97530$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $4838f69e216ac757$var$detachRefs(ctrl, ref);
            $4838f69e216ac757$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $eb275e09d3f97530$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $eb275e09d3f97530$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $4838f69e216ac757$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, t), {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $eb275e09d3f97530$export$91db9bc4f8ac944a)();
    const defaultProps = $4838f69e216ac757$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $dhiZh.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $dhiZh.useRef)(false);
    (0, $eb275e09d3f97530$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $4838f69e216ac757$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $4838f69e216ac757$var$callProp(to2, t.item, i);
        to2 = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).obj(to2) ? $4838f69e216ac757$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $4838f69e216ac757$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = (0, $53825fa7fd9c8174$export$71511d61b312f219)((0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, defaultProps), {
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false
        }), to2);
        if (phase == "enter" /* ENTER */  && (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $4838f69e216ac757$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $4838f69e216ac757$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $4838f69e216ac757$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $4838f69e216ac757$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $dhiZh.useContext)($4838f69e216ac757$export$f12a216ec50d2cf1);
    const prevContext = (0, $eb275e09d3f97530$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $4838f69e216ac757$var$hasProps(context);
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $eb275e09d3f97530$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $eb275e09d3f97530$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $4838f69e216ac757$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $dhiZh.createElement($dhiZh.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, springs), t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $dhiZh.createElement(elem.type, (0, $01246c54742f6ed3$export$71511d61b312f219)((0, $53825fa7fd9c8174$export$71511d61b312f219)({}, elem.props), {
                key: (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).str(t.key) || (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $4838f69e216ac757$var$nextKey = 1;
function $4838f69e216ac757$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $4838f69e216ac757$var$nextKey++;
        });
    }
    return (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(keys) ? items : (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $eb275e09d3f97530$export$45b10814cc054894)(keys);
}
var $4838f69e216ac757$export$d928051c8cd740b = (_param = {})=>{
    var { container: container } = _param, springOptions = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "container"
    ]);
    const [scrollValues, api] = $4838f69e216ac757$export$c4af9125706c4d30(()=>(0, $53825fa7fd9c8174$export$71511d61b312f219)({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0
        }, springOptions), []);
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $eb275e09d3f97530$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return ()=>{
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $4838f69e216ac757$export$e8b771555dc4a003 = (_param)=>{
    var { container: container } = _param, springOptions = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "container"
    ]);
    const [sizeValues, api] = $4838f69e216ac757$export$c4af9125706c4d30(()=>(0, $53825fa7fd9c8174$export$71511d61b312f219)({
            width: 0,
            height: 0
        }, springOptions), []);
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $eb275e09d3f97530$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return ()=>{
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $4838f69e216ac757$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $4838f69e216ac757$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $dhiZh.useState)(false);
    const ref = (0, $dhiZh.useRef)();
    const propsFn = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {} } = springsProps, restSpringProps = (0, $710949f8d1eb100c$export$71511d61b312f219)(springsProps, [
        "to",
        "from"
    ]);
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $4838f69e216ac757$export$c4af9125706c4d30(()=>(0, $53825fa7fd9c8174$export$71511d61b312f219)({
            from: from
        }, restSpringProps), []);
    (0, $eb275e09d3f97530$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const _ref = intersectionArguments !== null && intersectionArguments !== void 0 ? intersectionArguments : {}, { root: root, once: once, amount: amount = "any" } = _ref, restArgs = (0, $710949f8d1eb100c$export$71511d61b312f219)(_ref, [
            "root",
            "once",
            "amount"
        ]);
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, (0, $53825fa7fd9c8174$export$71511d61b312f219)({
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $4838f69e216ac757$var$defaultThresholdOptions[amount]
        }, restArgs));
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $4838f69e216ac757$export$a500e5b516cedfc(_param) {
    var { children: children } = _param, props = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "children"
    ]);
    return children($4838f69e216ac757$export$c4af9125706c4d30(props));
}
function $4838f69e216ac757$export$3b8b9d47fbf8fd2b(_param) {
    var { items: items, children: children } = _param, props = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "items",
        "children"
    ]);
    const trails = $4838f69e216ac757$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $4838f69e216ac757$export$be58926105124dd4(_param) {
    var { items: items, children: children } = _param, props = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
        "items",
        "children"
    ]);
    return $4838f69e216ac757$export$7b286972b8d8ccbf(items, props)(children);
}
var $4838f69e216ac757$export$b0cc4f9860136880 = class extends $4838f69e216ac757$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $eb275e09d3f97530$export$248d38f6296296c5)(value, oldValue)) {
            (0, $e1655c60e9aef219$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $4838f69e216ac757$var$checkIdle(this._active)) $4838f69e216ac757$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $eb275e09d3f97530$export$e37b7520edd66839)) : (0, $eb275e09d3f97530$export$45b10814cc054894)((0, $eb275e09d3f97530$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$4838f69e216ac757$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $e1655c60e9aef219$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $eb275e09d3f97530$export$cceeabf822b64fc0).skipAnimation) {
                (0, $78ed687e3eb26156$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $4838f69e216ac757$var$becomeIdle(this);
            } else (0, $eb275e09d3f97530$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $eb275e09d3f97530$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(source)) (0, $eb275e09d3f97530$export$72d604e3f8d000a5)(source, this);
            if ($4838f69e216ac757$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $eb275e09d3f97530$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(source)) (0, $eb275e09d3f97530$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $4838f69e216ac757$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $eb275e09d3f97530$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($4838f69e216ac757$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $eb275e09d3f97530$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $e1655c60e9aef219$export$e6b77ddbe47b132e)(value);
        (0, $e1655c60e9aef219$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
};
function $4838f69e216ac757$var$isIdle(source) {
    return source.idle !== false;
}
function $4838f69e216ac757$var$checkIdle(active) {
    return !active.size || Array.from(active).every($4838f69e216ac757$var$isIdle);
}
function $4838f69e216ac757$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)((0, $e1655c60e9aef219$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $eb275e09d3f97530$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $4838f69e216ac757$export$2c618a4308a30424 = (source, ...args)=>new $4838f69e216ac757$export$b0cc4f9860136880(source, args);
var $4838f69e216ac757$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $eb275e09d3f97530$export$2abfcde8ae218ba8)(), new $4838f69e216ac757$export$b0cc4f9860136880(source, args));
(0, $eb275e09d3f97530$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $eb275e09d3f97530$export$4759a013d387347a,
    to: (source, args)=>new $4838f69e216ac757$export$b0cc4f9860136880(source, args)
});
var $4838f69e216ac757$export$722fbec263ad908a = (0, $eb275e09d3f97530$export$a57f5080a3bcc90a).advance;



var $b4Mpg = parcelRequire("b4Mpg");


// src/applyAnimatedValues.ts
var $eedb8fcef7f33356$var$isCustomPropRE = /^--/;
function $eedb8fcef7f33356$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$eedb8fcef7f33356$var$isCustomPropRE.test(name) && !($eedb8fcef7f33356$var$isUnitlessNumber.hasOwnProperty(name) && $eedb8fcef7f33356$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $eedb8fcef7f33356$var$attributeCache = {};
function $eedb8fcef7f33356$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox } = props, attributes = (0, $710949f8d1eb100c$export$71511d61b312f219)(props, [
        "style",
        "children",
        "scrollTop",
        "scrollLeft",
        "viewBox"
    ]);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $eedb8fcef7f33356$var$attributeCache[name] || ($eedb8fcef7f33356$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $eedb8fcef7f33356$var$dangerousStyleValue(name, style[name]);
        if ($eedb8fcef7f33356$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $eedb8fcef7f33356$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $eedb8fcef7f33356$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $eedb8fcef7f33356$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$eedb8fcef7f33356$var$isUnitlessNumber = Object.keys($eedb8fcef7f33356$var$isUnitlessNumber).reduce((acc, prop)=>{
    $eedb8fcef7f33356$var$prefixes.forEach((prefix)=>acc[$eedb8fcef7f33356$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $eedb8fcef7f33356$var$isUnitlessNumber);
var $eedb8fcef7f33356$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $eedb8fcef7f33356$var$pxTransforms = /^(translate)/;
var $eedb8fcef7f33356$var$degTransforms = /^(rotate|skew)/;
var $eedb8fcef7f33356$var$addUnit = (value, unit)=>(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $eedb8fcef7f33356$var$isValueIdentity = (value, id)=>(0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$eedb8fcef7f33356$var$isValueIdentity(v, id)) : (0, $eb275e09d3f97530$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $eedb8fcef7f33356$var$AnimatedStyle = class extends (0, $e1655c60e9aef219$export$f1b0b9e366a6e2d4) {
    constructor(_param){
        var { x: x, y: y, z: z } = _param, style = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
            "x",
            "y",
            "z"
        ]);
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$eedb8fcef7f33356$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $eedb8fcef7f33356$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $eb275e09d3f97530$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($eedb8fcef7f33356$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $eedb8fcef7f33356$var$pxTransforms.test(key) ? "px" : $eedb8fcef7f33356$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $eb275e09d3f97530$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$eedb8fcef7f33356$var$addUnit(deg, unit)})`,
                        $eedb8fcef7f33356$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$eedb8fcef7f33356$var$addUnit(v, unit)).join(",")})`,
                        $eedb8fcef7f33356$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $eedb8fcef7f33356$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $eedb8fcef7f33356$var$FluidTransform = class extends (0, $eb275e09d3f97530$export$aff8e1ac1a016a2) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $eb275e09d3f97530$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $eb275e09d3f97530$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $eb275e09d3f97530$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $eb275e09d3f97530$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $eb275e09d3f97530$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $eb275e09d3f97530$export$79b2f7037acddd43)(input, (value)=>(0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(value) && (0, $eb275e09d3f97530$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $eb275e09d3f97530$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $eb275e09d3f97530$export$79b2f7037acddd43)(input, (value)=>(0, $eb275e09d3f97530$export$57ea7e3a7f6280c7)(value) && (0, $eb275e09d3f97530$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $eb275e09d3f97530$export$31752c40a5fab62a)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
};
// src/primitives.ts
var $eedb8fcef7f33356$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $eb275e09d3f97530$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $b4Mpg.unstable_batchedUpdates),
    createStringInterpolator: $eb275e09d3f97530$export$4759a013d387347a,
    colors: $eb275e09d3f97530$export$8f45430ccf837300
});
var $eedb8fcef7f33356$var$host = (0, $e1655c60e9aef219$export$4ee5c78f6dcbcef)($eedb8fcef7f33356$var$primitives, {
    applyAnimatedValues: $eedb8fcef7f33356$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $eedb8fcef7f33356$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: (_param)=>{
        var { scrollTop: scrollTop, scrollLeft: scrollLeft } = _param, props = (0, $710949f8d1eb100c$export$71511d61b312f219)(_param, [
            "scrollTop",
            "scrollLeft"
        ]);
        return props;
    }
});
var $eedb8fcef7f33356$export$407448d2b89b1813 = $eedb8fcef7f33356$var$host.animated;



var $dhiZh = parcelRequire("dhiZh");

var $60fe8762caeb0dc3$var$__assign = undefined && undefined.__assign || function() {
    $60fe8762caeb0dc3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $60fe8762caeb0dc3$var$__assign.apply(this, arguments);
};
function $60fe8762caeb0dc3$var$TextTransition(props) {
    var _a = props.direction, direction = _a === void 0 ? "up" : _a, _b = props.inline, inline = _b === void 0 ? false : _b, _c = props.springConfig, springConfig = _c === void 0 ? (0, $4838f69e216ac757$export$e506a1d27d1eaa20).default : _c, _d = props.delay, delay = _d === void 0 ? 0 : _d, className = props.className, style = props.style, _e = props.translateValue, tv = _e === void 0 ? "100%" : _e, children = props.children;
    var initialRun = (0, $dhiZh.useRef)(true);
    var fromTransform = direction === "down" ? "-".concat(tv) : tv;
    var leaveTransform = direction === "down" ? tv : "-".concat(tv);
    var transitions = (0, $4838f69e216ac757$export$7b286972b8d8ccbf)([
        children
    ], {
        enter: {
            opacity: 1,
            transform: "translateY(0%)"
        },
        from: {
            opacity: 0,
            transform: "translateY(".concat(fromTransform, ")")
        },
        leave: {
            opacity: 0,
            transform: "translateY(".concat(leaveTransform, ")"),
            position: "absolute"
        },
        config: springConfig,
        immediate: initialRun.current,
        delay: !initialRun.current ? delay : undefined
    });
    var _f = (0, $dhiZh.useState)(0), width = _f[0], setWidth = _f[1];
    var currentRef = (0, $dhiZh.useRef)(null);
    var heightRef = (0, $dhiZh.useRef)("auto");
    (0, $dhiZh.useEffect)(function() {
        initialRun.current = false;
        var element = currentRef.current;
        if (!element) return;
        var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
        setWidth(width);
        heightRef.current = height;
    }, [
        children,
        setWidth,
        currentRef
    ]);
    var widthTransition = (0, $4838f69e216ac757$export$c4af9125706c4d30)({
        to: {
            width: width
        },
        config: springConfig,
        immediate: initialRun.current,
        delay: !initialRun.current ? delay : undefined
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $eedb8fcef7f33356$export$407448d2b89b1813).div, {
        className: "text-transition ".concat(className),
        style: $60fe8762caeb0dc3$var$__assign($60fe8762caeb0dc3$var$__assign($60fe8762caeb0dc3$var$__assign({}, inline && !initialRun.current ? widthTransition : undefined), style), {
            whiteSpace: inline ? "nowrap" : "normal",
            display: inline ? "inline-flex" : "flex",
            height: heightRef.current
        })
    }, transitions(function(styles, item) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).createElement((0, $eedb8fcef7f33356$export$407448d2b89b1813).div, {
            style: $60fe8762caeb0dc3$var$__assign({}, styles),
            ref: item === children ? currentRef : undefined,
            children: item
        });
    }));
}
var $60fe8762caeb0dc3$export$2e2bcd8739ae039 = $60fe8762caeb0dc3$var$TextTransition;


var $9e30868f3d8c0b4a$export$2e2bcd8739ae039 = (0, $60fe8762caeb0dc3$export$2e2bcd8739ae039);


// Intro Screen: Rotating Text
const $4d07f82f7394ea5d$var$TEXTS = [
    "Event Managers",
    "Content Creators",
    "Social Strategists",
    "Creative Designers",
    "Project Managers"
];
const $4d07f82f7394ea5d$var$InHousing = ({ data: data })=>{
    const [textIndex, setTextIndex] = (0, $dhiZh.useState)(0);
    (0, $dhiZh.useEffect)(()=>{
        const intervalId = setInterval(()=>setTextIndex((textIndex)=>textIndex + 1), 1500);
        return ()=>clearTimeout(intervalId);
    }, []);
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        className: "makerlab-section makerlab-section-fading-screen",
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
            className: "makerlab-column",
            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                className: "makerlab-fading-screen",
                children: [
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("svg", {
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 291 224",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                d: "m77.25 96 18.953 18.777 43.834 6.766h.106c.053 0 .159 0 .212.053.053 0 .106 0 .159.052h.052l40.976 24.389 4.235-3.409-36.052-35.561L77.25 96ZM152.901 202.473l-4.711-25.753-50.928 41.226 57.969-.262-2.33-15.211Z",
                                fill: "#fff"
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                d: "m66.08 112.94 70.357 69.706 11.171-9.074-9-49.46-43.305-6.661h-.106L66.08 112.94ZM210.236 143.258H224l-14.77-13.165 1.006 13.165ZM157.825 216.111l50.452-50.824-66.546-39.6 13.923 76.315 2.171 14.109ZM184.03 147.662l24.882 14.791-2.541-32.938-22.341 18.147Z",
                                fill: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("h2", {
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("p", {
                                children: "In-housing"
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $9e30868f3d8c0b4a$export$2e2bcd8739ae039), {
                                springConfig: (0, $4838f69e216ac757$export$e506a1d27d1eaa20).wobbly,
                                children: $4d07f82f7394ea5d$var$TEXTS[textIndex % $4d07f82f7394ea5d$var$TEXTS.length]
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                children: "\xa0since 2015"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $4d07f82f7394ea5d$export$2e2bcd8739ae039 = $4d07f82f7394ea5d$var$InHousing;



parcelRequire("dhiZh");

const $2312533b285e81ae$var$CookieBar = ({ data: data, showCookieBanner: showCookieBanner, toggleCookieBannerState: toggleCookieBannerState, toggleCookieConsent: toggleCookieConsent })=>{
    const handleCookieClick = ()=>{
        const cookieBanner = document.querySelector(".makerlab-cookie-wrapper");
        cookieBanner.style.display = "none";
        localStorage.setItem("showCookieBanner", "false");
        toggleCookieBannerState();
    };
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        className: "makerlab-cookie-wrapper",
        "data-show": showCookieBanner,
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
            className: "makerlab-cookie-box",
            children: [
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                    className: "makerlab-cookie-text",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h4", {
                            children: "Cookie Policies"
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                            children: (0, $6ed23f9f312890d4$export$4a295a2b4ab66da6)(data.fields.content)
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                            className: "makerlab-cookie-buttons",
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("button", {
                                    onClick: ()=>handleCookieClick(),
                                    children: "Decline"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("button", {
                                    onClick: ()=>{
                                        handleCookieClick();
                                        toggleCookieConsent();
                                    },
                                    children: "Accept"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("svg", {
                    className: "makerlab-cookie-logo",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 354 641",
                    children: [
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("g", {
                            clipPath: "url(#a)",
                            fill: "#000",
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "m248.668 80.718-92.739 71.013-86.276-63.016V49.366l84.345 64.295 94.683-74.536v41.593h-.013Z"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    d: "M172.567 15.57c30.446-7.885 49.986-31.89 49.986-59.832 0-21.373-11.26-41.417-30.787-51.934v-34.185c37.729 14.14 62.23 48.325 62.23 87.435 0 51.283-45.682 92.7-94.67 92.7-57.926 0-98.306-43.398-98.306-91.71 0-53.576 41.705-94.342 94.342-94.342 5.63 0 10.919.001 17.205.991V15.57Zm-26.483-117.683c-31.115 2.632-53.62 29.91-53.62 59.167 0 29.258 22.177 55.883 53.62 58.516v-117.683ZM247.786 426.595H147.208c-34.069 0-53.205 13.965-53.205 41.581 0 29.207 16.549 41.906 52.561 41.906h101.222V543.1H143.32c-35.369 0-49.317 16.183-49.317 40.001 0 29.207 17.521 43.485 52.877 43.485h100.893v32.994H68.038v-30.474h19.465v-.639c-17.192-14.278-24.337-27.616-24.337-50.468 0-22.852 11.36-45.705 30.168-54.592-20.436-12.699-30.168-30.161-30.168-58.09 0-45.704 29.196-71.74 75.597-71.74h109.01v33.018h.013ZM247.85 209.645h-28.717v.665c22.039 12.936 33.4 36.139 33.4 62.339 0 53.727-40.746 97.5-94.166 97.5-59.1 0-100.514-42.119-100.514-96.172 0-26.863 10.022-49.415 31.051-63.667v-.665H62.851V175.16H247.85v34.485Zm-92.159-.652c-36.063 0-66.118 25.861-66.118 64.006 0 34.486 29.714 62.678 66.118 62.678 36.404 0 65.121-28.192 65.121-62.678 0-34.485-30.055-64.006-65.121-64.006Z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("clipPath", {
                                id: "a",
                                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                    fill: "#fff",
                                    d: "M0 0h354v641H0z"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $2312533b285e81ae$export$2e2bcd8739ae039 = $2312533b285e81ae$var$CookieBar;


var $3c4c934fcc6974ed$exports = {};
"use strict";
function $3c4c934fcc6974ed$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3c4c934fcc6974ed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3c4c934fcc6974ed$var$_typeof(obj);
}
Object.defineProperty($3c4c934fcc6974ed$exports, "__esModule", {
    value: true
});
$3c4c934fcc6974ed$exports["default"] = $3c4c934fcc6974ed$exports.ReactGAImplementation = void 0;

var $3c4c934fcc6974ed$var$_ga = $3c4c934fcc6974ed$var$_interopRequireWildcard((parcelRequire("gPgNv")));
function $3c4c934fcc6974ed$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3c4c934fcc6974ed$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3c4c934fcc6974ed$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $3c4c934fcc6974ed$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $3c4c934fcc6974ed$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $3c4c934fcc6974ed$var$ReactGAImplementation = $3c4c934fcc6974ed$var$_ga.GA4;
$3c4c934fcc6974ed$exports.ReactGAImplementation = $3c4c934fcc6974ed$var$ReactGAImplementation;
var $3c4c934fcc6974ed$var$_default = $3c4c934fcc6974ed$var$_ga["default"];
$3c4c934fcc6974ed$exports["default"] = $3c4c934fcc6974ed$var$_default;


var $ffcdeb0e8017e0ef$exports = {};
!function(t, n) {
    $ffcdeb0e8017e0ef$exports = function(t, n, e, i, o) {
        for(n = n.split ? n.split(".") : n, i = 0; i < n.length; i++)t = t ? t[n[i]] : o;
        return t === o ? e : t;
    };
}($ffcdeb0e8017e0ef$exports);



var $6cce2b3292d7582c$export$601fe16600f10158 = "function", $6cce2b3292d7582c$export$a0e01ba2ebef17f2 = "string", $6cce2b3292d7582c$export$6db089fe7b26f5b6 = "undefined", $6cce2b3292d7582c$export$428cfe48a69a3b4f = "boolean", $6cce2b3292d7582c$export$8b8a958a7f6f130c = "object", $6cce2b3292d7582c$export$b119f07080a207ba = "array", $6cce2b3292d7582c$export$4e8bcd47a31d751c = "number", $6cce2b3292d7582c$export$27c95a7104c1f7aa = "symbol", $6cce2b3292d7582c$export$7a6ec76cbc235d89 = "null", $6cce2b3292d7582c$export$103bedf43ba882db = "error", $6cce2b3292d7582c$export$c5687d718b4dd379 = "typeError", $6cce2b3292d7582c$export$e34ecf4a40a7aaba = "syntaxError", $6cce2b3292d7582c$export$31f944506cdc8a6a = "asyncFunction", $6cce2b3292d7582c$export$1e73e1ed08782cb8 = "generatorFunction", $6cce2b3292d7582c$export$16532f4118857615 = "asyncGeneratorFunction", $6cce2b3292d7582c$export$b50b6e108474309b = function() {}, $6cce2b3292d7582c$export$8f1c7f430e5fef56 = "any", $6cce2b3292d7582c$export$61b49a5ae59d663 = "*", $6cce2b3292d7582c$export$c53d0f541b41b88e = "none", $6cce2b3292d7582c$export$d2f7b3f0efb6e208 = "hidden", $6cce2b3292d7582c$export$8a682ae47622dbb9 = "__", $6cce2b3292d7582c$export$b252bb901a2de2f0 = "form", $6cce2b3292d7582c$export$9ea760072c364d49 = "input", $6cce2b3292d7582c$export$b887e88d8d0739f6 = "button", $6cce2b3292d7582c$export$718a6b7ababf8ba7 = "select", $6cce2b3292d7582c$export$4bef51da9b53f613 = "change", $6cce2b3292d7582c$export$324ecb06850cfa68 = "submit", $6cce2b3292d7582c$export$c16c1c575a257f35 = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)$/, $6cce2b3292d7582c$export$13868b9442c40eb1 = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, $6cce2b3292d7582c$export$6a68ed0a7dd7373a = /^\{[\s\S]*\}$|^\[[\s\S]*\]$/, $6cce2b3292d7582c$var$F = "undefined" != typeof $26305657c8dadcb2$exports ? $26305657c8dadcb2$exports : {}, $6cce2b3292d7582c$export$83401e34d5e11bf4 = $6cce2b3292d7582c$var$F.env && $6cce2b3292d7582c$var$F.env.NODE_ENV || "", $6cce2b3292d7582c$export$1cfdf9a01e3f7773 = "production" === $6cce2b3292d7582c$export$83401e34d5e11bf4, $6cce2b3292d7582c$export$23da1d24a38b0bde = "staging" === $6cce2b3292d7582c$export$83401e34d5e11bf4, $6cce2b3292d7582c$export$40edfb7eeb78c4e8 = "development" === $6cce2b3292d7582c$export$83401e34d5e11bf4, $6cce2b3292d7582c$export$4e09c449d6c407f7 = "undefined" != typeof document, $6cce2b3292d7582c$export$f931afb2c5ecf7c7 = $6cce2b3292d7582c$export$4e09c449d6c407f7 && "localhost" === window.location.hostname, $6cce2b3292d7582c$export$8ee0fc9ee280b4ee = null != $6cce2b3292d7582c$var$F.versions && null != $6cce2b3292d7582c$var$F.versions.node, $6cce2b3292d7582c$export$8b9ca1d592a8e4c6 = "undefined" != typeof Deno && void 0 !== Deno.core, $6cce2b3292d7582c$export$97b87b8868ff7a3c = "object" == typeof self && self.constructor && "DedicatedWorkerGlobalScope" === self.constructor.name, $6cce2b3292d7582c$export$c4262d4b0bcc244 = $6cce2b3292d7582c$export$4e09c449d6c407f7 && "nodejs" === window.name || "undefined" != typeof navigator && void 0 !== navigator.userAgent && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function $6cce2b3292d7582c$var$M(n, t) {
    return t.charAt(0)[n]() + t.slice(1);
}
var $6cce2b3292d7582c$var$U = $6cce2b3292d7582c$var$M.bind(null, "toUpperCase"), $6cce2b3292d7582c$var$H = $6cce2b3292d7582c$var$M.bind(null, "toLowerCase");
function $6cce2b3292d7582c$export$9bcacca3c0b0cdd9(n) {
    return $6cce2b3292d7582c$export$630801d484da15df(n) ? $6cce2b3292d7582c$var$U("null") : "object" == typeof n ? $6cce2b3292d7582c$export$73210b253592ba3c(n) : Object.prototype.toString.call(n).slice(8, -1);
}
function $6cce2b3292d7582c$export$e2b5c5db9e2009fd(n, t) {
    void 0 === t && (t = !0);
    var e = $6cce2b3292d7582c$export$9bcacca3c0b0cdd9(n);
    return t ? $6cce2b3292d7582c$var$H(e) : e;
}
function $6cce2b3292d7582c$var$V(n, t) {
    return typeof t === n;
}
var $6cce2b3292d7582c$export$f6e2535fb5126e54 = $6cce2b3292d7582c$var$V.bind(null, "function"), $6cce2b3292d7582c$export$844ec244b1367d54 = $6cce2b3292d7582c$var$V.bind(null, "string"), $6cce2b3292d7582c$export$fce6876652108ab = $6cce2b3292d7582c$var$V.bind(null, "undefined");
function $6cce2b3292d7582c$export$4e62c701997796c1(n) {
    return !$6cce2b3292d7582c$export$fce6876652108ab(n);
}
var $6cce2b3292d7582c$export$f9ce7b637dfbe238 = $6cce2b3292d7582c$var$V.bind(null, "boolean"), $6cce2b3292d7582c$export$a244864fd9645c7f = $6cce2b3292d7582c$var$V.bind(null, "symbol");
function $6cce2b3292d7582c$export$630801d484da15df(n) {
    return null === n;
}
function $6cce2b3292d7582c$export$7e4aa119212bc614(n) {
    return "number" === $6cce2b3292d7582c$export$e2b5c5db9e2009fd(n) && !isNaN(n);
}
function $6cce2b3292d7582c$export$bbf2f88383591790(n) {
    return !isNaN(parseFloat(n));
}
function $6cce2b3292d7582c$export$5578ef75f4140928(n) {
    return !!$6cce2b3292d7582c$export$f6e2535fb5126e54(n) && /^class /.test(Function.prototype.toString.call(n));
}
function $6cce2b3292d7582c$export$43bee75e5e14138e(n) {
    return "array" === $6cce2b3292d7582c$export$e2b5c5db9e2009fd(n);
}
function $6cce2b3292d7582c$export$a6cdc56e425d0d0a(n) {
    if (!$6cce2b3292d7582c$export$c10d0b04eaa80a43(n)) return !1;
    for(var t = n; null !== Object.getPrototypeOf(t);)t = Object.getPrototypeOf(t);
    return Object.getPrototypeOf(n) === t;
}
function $6cce2b3292d7582c$export$c10d0b04eaa80a43(n) {
    return n && ("object" == typeof n || null !== n);
}
function $6cce2b3292d7582c$export$952e1d8683e4d0c4(n) {
    if (!$6cce2b3292d7582c$export$844ec244b1367d54(n) || !$6cce2b3292d7582c$export$6a68ed0a7dd7373a.test(n)) return !1;
    try {
        JSON.parse(n);
    } catch (n) {
        return !1;
    }
    return !0;
}
function $6cce2b3292d7582c$export$c3825b437cbdea5c(n) {
    if ($6cce2b3292d7582c$export$630801d484da15df(n)) return !0;
    switch(typeof n){
        case "string":
        case "number":
        case "symbol":
        case "undefined":
        case "boolean":
            return !0;
        default:
            return !1;
    }
}
function $6cce2b3292d7582c$export$ed2133acb96eb5aa(n, t) {
    return $6cce2b3292d7582c$export$a6cdc56e425d0d0a(n) && $6cce2b3292d7582c$export$f6e2535fb5126e54(n[t]);
}
function $6cce2b3292d7582c$export$4369c812aac99591(n) {
    return !!n && !!(!$6cce2b3292d7582c$export$fce6876652108ab(Promise) && n instanceof Promise || n.then && $6cce2b3292d7582c$export$f6e2535fb5126e54(n.then));
}
function $6cce2b3292d7582c$export$6ab7812f1bac68be(n) {
    return $6cce2b3292d7582c$export$c10d0b04eaa80a43(n) && $6cce2b3292d7582c$export$f6e2535fb5126e54(n.throw) && $6cce2b3292d7582c$export$f6e2535fb5126e54(n.return) && $6cce2b3292d7582c$export$f6e2535fb5126e54(n.next);
}
function $6cce2b3292d7582c$export$111f0b41304fc890(n) {
    return "generatorFunction" === $6cce2b3292d7582c$export$e2b5c5db9e2009fd(n);
}
function $6cce2b3292d7582c$export$cb3f0f7ea9814480(n) {
    return "asyncFunction" === $6cce2b3292d7582c$export$e2b5c5db9e2009fd(n);
}
function $6cce2b3292d7582c$export$73210b253592ba3c(n) {
    return $6cce2b3292d7582c$export$f6e2535fb5126e54(n.constructor) ? n.constructor.name : null;
}
function $6cce2b3292d7582c$export$6750766a7c7ec627(n) {
    return n instanceof Set;
}
function $6cce2b3292d7582c$export$5c90113a285f2241(n) {
    return n instanceof Map;
}
function $6cce2b3292d7582c$export$2569c41dd933e9ea(n) {
    return n instanceof RegExp;
}
function $6cce2b3292d7582c$export$a7884ebc965f8f54(n) {
    return !(!n.constructor || !$6cce2b3292d7582c$export$f6e2535fb5126e54(n.constructor.isBuffer)) && n.constructor.isBuffer(n);
}
function $6cce2b3292d7582c$export$e6127cc7fe7395c3(n) {
    return n instanceof Error || $6cce2b3292d7582c$export$844ec244b1367d54(n.message) && n.constructor && $6cce2b3292d7582c$export$7e4aa119212bc614(n.constructor.stackTraceLimit);
}
function $6cce2b3292d7582c$export$7713bb8b33f5c3c9(n) {
    return $6cce2b3292d7582c$export$c10d0b04eaa80a43(n) && $6cce2b3292d7582c$export$844ec244b1367d54(n.message) && $6cce2b3292d7582c$export$844ec244b1367d54(n.name);
}
function $6cce2b3292d7582c$var$On(n, t) {
    if ("object" != typeof t || $6cce2b3292d7582c$export$630801d484da15df(t)) return !1;
    if (t instanceof n) return !0;
    var e = $6cce2b3292d7582c$export$e2b5c5db9e2009fd(new n(""));
    if ($6cce2b3292d7582c$export$e6127cc7fe7395c3(t)) for(; t;){
        if ($6cce2b3292d7582c$export$e2b5c5db9e2009fd(t) === e) return !0;
        t = Object.getPrototypeOf(t);
    }
    return !1;
}
var $6cce2b3292d7582c$export$aa18726dfaabc422 = $6cce2b3292d7582c$var$On.bind(null, TypeError), $6cce2b3292d7582c$export$1a429acb1a7bd90f = $6cce2b3292d7582c$var$On.bind(null, SyntaxError);
function $6cce2b3292d7582c$export$429d1a71f461eaed(n) {
    if (!$6cce2b3292d7582c$export$f6e2535fb5126e54(n)) return !1;
    var t = /{(\r|\n|\s)*}/gm, e = $6cce2b3292d7582c$export$b50b6e108474309b + "";
    return e === (n.toString().match(t) || [
        ""
    ])[0].replace(t, e);
}
function $6cce2b3292d7582c$export$dbbb9d8cd6fff001(n) {
    try {
        if ($6cce2b3292d7582c$export$7e4aa119212bc614(n.length) && $6cce2b3292d7582c$export$f6e2535fb5126e54(n.callee)) return !0;
    } catch (n) {
        if (-1 !== n.message.indexOf("callee")) return !0;
    }
    return !1;
}
function $6cce2b3292d7582c$export$8f9cae6546f97a9f(n) {
    return !($6cce2b3292d7582c$export$844ec244b1367d54(n) && "false" === n.toLowerCase() || !n);
}
function $6cce2b3292d7582c$export$3f8b302b845e89ac(n) {
    return !n;
}
function $6cce2b3292d7582c$export$7afc298d8ffd816(n) {
    return !0 === n;
}
function $6cce2b3292d7582c$export$e2f8ac82f39fa177(n) {
    return !1 === n;
}
function $6cce2b3292d7582c$export$7fbbfbca30081d0(n) {
    return !(n.length > 320) && $6cce2b3292d7582c$export$13868b9442c40eb1.test(n);
}
function $6cce2b3292d7582c$export$871608497c498473(n) {
    return n instanceof Date || $6cce2b3292d7582c$export$f6e2535fb5126e54(n.toDateString) && $6cce2b3292d7582c$export$f6e2535fb5126e54(n.getDate) && $6cce2b3292d7582c$export$f6e2535fb5126e54(n.setDate);
}
function $6cce2b3292d7582c$export$88436b756d94fab0(n) {
    return $6cce2b3292d7582c$export$c16c1c575a257f35.test(n);
}
function $6cce2b3292d7582c$export$dd1bc94b04021eeb(n) {
    return !(!$6cce2b3292d7582c$export$630801d484da15df(n) && ($6cce2b3292d7582c$export$43bee75e5e14138e(n) ? n.length : $6cce2b3292d7582c$export$6750766a7c7ec627(n) || $6cce2b3292d7582c$export$5c90113a285f2241(n) ? n.size : $6cce2b3292d7582c$export$a6cdc56e425d0d0a(n) && Object.keys(n).length));
}
function $6cce2b3292d7582c$export$ff45fc08c57bb9d0(n) {
    return NodeList.prototype.isPrototypeOf(n);
}
function $6cce2b3292d7582c$export$45a5e7f76e0caa8d(n, t) {
    var e = n instanceof Element || n instanceof HTMLDocument;
    return e && t ? $6cce2b3292d7582c$export$eed71c63fec63a4c(n, t) : e;
}
function $6cce2b3292d7582c$export$eed71c63fec63a4c(n, t) {
    return void 0 === t && (t = ""), n && n.nodeName === t.toUpperCase();
}
function $6cce2b3292d7582c$var$_n(n) {
    var t = [].slice.call(arguments, 1);
    return function() {
        return n.apply(void 0, [].slice.call(arguments).concat(t));
    };
}
var $6cce2b3292d7582c$export$56bc004e92322d77 = $6cce2b3292d7582c$var$_n($6cce2b3292d7582c$export$45a5e7f76e0caa8d, "form"), $6cce2b3292d7582c$export$35a0171ee384c875 = $6cce2b3292d7582c$var$_n($6cce2b3292d7582c$export$45a5e7f76e0caa8d, "button"), $6cce2b3292d7582c$export$495c8a5c4c240111 = $6cce2b3292d7582c$var$_n($6cce2b3292d7582c$export$45a5e7f76e0caa8d, "input"), $6cce2b3292d7582c$export$47ed34a15a70bfcf = $6cce2b3292d7582c$var$_n($6cce2b3292d7582c$export$45a5e7f76e0caa8d, "select");
function $6cce2b3292d7582c$export$ee695c13482bb5dd(n, t) {
    if (!n || "hidden" === getComputedStyle(n).visibility) return !0;
    for(; n;){
        if (null != t && n === t) return !1;
        if ("none" === getComputedStyle(n).display) return !0;
        n = n.parentElement;
    }
    return !1;
}
function $6cce2b3292d7582c$export$d0c8ecbd4ed8940c(n) {
    return n ? $6cce2b3292d7582c$export$43bee75e5e14138e(n) ? n : [
        n
    ] : [];
}


function $e44340a642fc927d$export$6f2bdf7ec2bb0a56(e) {
    try {
        return decodeURIComponent(e.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
function $e44340a642fc927d$export$563e375d286a76a7() {
    if (0, $6cce2b3292d7582c$export$4e09c449d6c407f7) {
        var r = navigator, t = r.languages;
        return r.userLanguage || (t && t.length ? t[0] : r.language);
    }
}
function $e44340a642fc927d$export$c3133dbc11f66777() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {}
}
function $e44340a642fc927d$export$9deab7494de17489(r) {
    if (!(0, $6cce2b3292d7582c$export$4e09c449d6c407f7)) return !1;
    var t = r || document.referrer;
    if (t) {
        var n = window.document.location.port, o = t.split("/")[2];
        return n && (o = o.replace(":" + n, "")), o !== window.location.hostname;
    }
    return !1;
}
function $e44340a642fc927d$export$98388c96821836c(n) {
    if (!(0, $6cce2b3292d7582c$export$4e09c449d6c407f7)) return !0;
    var o = document.getElementsByTagName("script");
    return !!Object.keys(o).filter(function(e) {
        var a = o[e].src;
        return (0, $6cce2b3292d7582c$export$844ec244b1367d54)(n) ? -1 !== a.indexOf(n) : !!(0, $6cce2b3292d7582c$export$2569c41dd933e9ea)(n) && a.match(n);
    }).length;
}
function $e44340a642fc927d$export$a444fa4d5cc1e893(e, r) {
    var t = (e.split("?") || [
        , 
    ])[1];
    if (!t || -1 === t.indexOf(r)) return e;
    var n = new RegExp("(\\&|\\?)" + r + '([_A-Za-z0-9"+=.\\/\\-@%]+)', "g"), o = ("?" + t).replace(n, "").replace(/^&/, "?");
    return e.replace("?" + t, o);
}
function $e44340a642fc927d$export$fad328bd6e05ae97(e, r) {
    return $e44340a642fc927d$export$6f2bdf7ec2bb0a56((RegExp(e + "=(.+?)(&|$)").exec(r) || [
        ,
        ""
    ])[1]);
}
function $e44340a642fc927d$export$e0a0f6787544c815(r) {
    return function(e) {
        for(var r, t = Object.create(null), o = /([^&=]+)=?([^&]*)/g; r = o.exec(e);){
            var a = $e44340a642fc927d$export$6f2bdf7ec2bb0a56(r[1]), i = $e44340a642fc927d$export$6f2bdf7ec2bb0a56(r[2]);
            "[]" === a.substring(a.length - 2) ? (t[a = a.substring(0, a.length - 2)] || (t[a] = [])).push(i) : t[a] = "" === i || i;
        }
        for(var u in t){
            var c = u.split("[");
            c.length > 1 && ($e44340a642fc927d$var$m(t, c.map(function(e) {
                return e.replace(/[?[\]\\ ]/g, "");
            }), t[u]), delete t[u]);
        }
        return t;
    }(function(r) {
        if (r) {
            var t = r.match(/\?(.*)/);
            return t && t[1] ? t[1].split("#")[0] : "";
        }
        return (0, $6cce2b3292d7582c$export$4e09c449d6c407f7) && window.location.search.substring(1);
    }(r));
}
function $e44340a642fc927d$var$m(e, r, t) {
    for(var n = r.length - 1, o = 0; o < n; ++o){
        var a = r[o];
        if ("__proto__" === a || "constructor" === a) break;
        a in e || (e[a] = {}), e = e[a];
    }
    e[r[n]] = t;
}
function $e44340a642fc927d$export$84be79996b4dc2e2(r, t) {
    return (0, $6cce2b3292d7582c$export$4e09c449d6c407f7) ? new Promise(function(e, n) {
        if (window.history && window.history.replaceState) {
            var o = window.location.href, a = $e44340a642fc927d$export$a444fa4d5cc1e893(o, r);
            o !== a && history.replaceState({}, "", a);
        }
        return t && t(), e();
    }) : Promise.resolve();
}
function $e44340a642fc927d$var$g(r) {
    if (!(0, $6cce2b3292d7582c$export$4e09c449d6c407f7)) return null;
    var t = document.createElement("a");
    return t.setAttribute("href", r), t.hostname;
}
function $e44340a642fc927d$var$p(e) {
    return ($e44340a642fc927d$var$g(e) || "").split(".").slice(-2).join(".");
}
function $e44340a642fc927d$var$x(e) {
    var r = e.split(".");
    return r.length > 1 ? r.slice(0, -1).join(".") : e;
}
var $e44340a642fc927d$export$128fa18b7194ef = {
    trimTld: $e44340a642fc927d$var$x,
    getDomainBase: $e44340a642fc927d$var$p,
    getDomainHost: $e44340a642fc927d$var$g
};
function $e44340a642fc927d$export$985b0e7bcb74e372(r, t) {
    if (!(0, $6cce2b3292d7582c$export$4e09c449d6c407f7)) return !1;
    var n = {
        source: "(direct)",
        medium: "(none)",
        campaign: "(not set)"
    };
    r && $e44340a642fc927d$export$9deab7494de17489(r) && (n.referrer = r);
    var o = function(r) {
        if (!r || !(0, $6cce2b3292d7582c$export$4e09c449d6c407f7)) return !1;
        var t = $e44340a642fc927d$var$p(r), n = document.createElement("a");
        if (n.href = r, n.hostname.indexOf("google") > -1 && (t = "google"), $e44340a642fc927d$var$w[t]) {
            var o = $e44340a642fc927d$var$w[t], a = new RegExp(("string" == typeof o ? o : o.p) + "=.*?([^&#]*|$)", "gi"), u = n.search.match(a);
            return {
                source: o.n || $e44340a642fc927d$var$x(t),
                medium: "organic",
                term: (u ? u[0].split("=")[1] : "") || "(not provided)"
            };
        }
        var c = $e44340a642fc927d$export$9deab7494de17489(r) ? "referral" : "internal";
        return {
            source: n.hostname,
            medium: c
        };
    }(r);
    o && Object.keys(o).length && (n = Object.assign({}, n, o));
    var a = $e44340a642fc927d$export$e0a0f6787544c815(t), u = Object.keys(a);
    if (!u.length) return n;
    var c = u.reduce(function(e, r) {
        return r.match(/^utm_/) && (e["" + r.replace(/^utm_/, "")] = a[r]), r.match(/^(d|g)clid/) && (e.source = "google", e.medium = a.gclid ? "cpc" : "cpm", e[r] = a[r]), e;
    }, {});
    return Object.assign({}, n, c);
}
var $e44340a642fc927d$var$h = "q", $e44340a642fc927d$var$w = {
    "daum.net": $e44340a642fc927d$var$h,
    "eniro.se": "search_word",
    "naver.com": "query",
    "yahoo.com": "p",
    "msn.com": $e44340a642fc927d$var$h,
    "aol.com": $e44340a642fc927d$var$h,
    "ask.com": $e44340a642fc927d$var$h,
    "baidu.com": "wd",
    "yandex.com": "text",
    "rambler.ru": "words",
    google: $e44340a642fc927d$var$h,
    "bing.com": {
        p: $e44340a642fc927d$var$h,
        n: "live"
    }
};
function $e44340a642fc927d$export$31b40729666a4ae0() {
    for(var e = "", r = 0, t = 4294967295 * Math.random() | 0; r++ < 36;){
        var n = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[r - 1], o = 15 & t;
        e += "-" == n || "4" == n ? n : ("x" == n ? o : 3 & o | 8).toString(16), t = r % 8 == 0 ? 4294967295 * Math.random() | 0 : t >> 4;
    }
    return e;
}
function $e44340a642fc927d$export$de363e709c412c8a(e, r) {
    var t, n, o, a = null, i = 0, u = function() {
        i = new Date, a = null, o = e.apply(t, n);
    };
    return function() {
        var c = new Date;
        i || (i = c);
        var l = r - (c - i);
        return t = this, n = arguments, l <= 0 ? (clearTimeout(a), a = null, i = c, o = e.apply(t, n)) : a || (a = setTimeout(u, l)), o;
    };
}



var $d3bc06c108ca0c17$export$17ff3f7e02c6ac22 = "global", $d3bc06c108ca0c17$export$7167c830cefcb6b5 = (0, $6cce2b3292d7582c$export$8a682ae47622dbb9) + "global" + (0, $6cce2b3292d7582c$export$8a682ae47622dbb9), $d3bc06c108ca0c17$export$348e0aeab6fdbe51 = typeof self === (0, $6cce2b3292d7582c$export$8b8a958a7f6f130c) && self.self === self && self || typeof $parcel$global === (0, $6cce2b3292d7582c$export$8b8a958a7f6f130c) && $parcel$global.global === $parcel$global && $parcel$global || void 0;
function $d3bc06c108ca0c17$export$3988ae62b71be9a3(t) {
    return $d3bc06c108ca0c17$export$348e0aeab6fdbe51[$d3bc06c108ca0c17$export$7167c830cefcb6b5][t];
}
function $d3bc06c108ca0c17$export$adaa4cf7ef1b65be(t, e) {
    return $d3bc06c108ca0c17$export$348e0aeab6fdbe51[$d3bc06c108ca0c17$export$7167c830cefcb6b5][t] = e;
}
function $d3bc06c108ca0c17$export$cd7f480d6b8286c3(t) {
    delete $d3bc06c108ca0c17$export$348e0aeab6fdbe51[$d3bc06c108ca0c17$export$7167c830cefcb6b5][t];
}
function $d3bc06c108ca0c17$export$4997ffc0176396a6(t, e, r) {
    var l;
    try {
        if ($d3bc06c108ca0c17$export$b6e153cbe86ff8d5(t)) {
            var o = window[t];
            l = o[e].bind(o);
        }
    } catch (t) {}
    return l || r;
}
$d3bc06c108ca0c17$export$348e0aeab6fdbe51[$d3bc06c108ca0c17$export$7167c830cefcb6b5] || ($d3bc06c108ca0c17$export$348e0aeab6fdbe51[$d3bc06c108ca0c17$export$7167c830cefcb6b5] = {});
var $d3bc06c108ca0c17$var$c = {};
function $d3bc06c108ca0c17$export$b6e153cbe86ff8d5(t) {
    if (typeof $d3bc06c108ca0c17$var$c[t] !== (0, $6cce2b3292d7582c$export$6db089fe7b26f5b6)) return $d3bc06c108ca0c17$var$c[t];
    try {
        var e = window[t];
        e.setItem((0, $6cce2b3292d7582c$export$6db089fe7b26f5b6), (0, $6cce2b3292d7582c$export$6db089fe7b26f5b6)), e.removeItem((0, $6cce2b3292d7582c$export$6db089fe7b26f5b6));
    } catch (e) {
        return $d3bc06c108ca0c17$var$c[t] = !1;
    }
    return $d3bc06c108ca0c17$var$c[t] = !0;
}



function $d8e80c8a40ff91b5$var$v() {
    return $d8e80c8a40ff91b5$var$v = Object.assign || function(e) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
    }, $d8e80c8a40ff91b5$var$v.apply(this, arguments);
}
var $d8e80c8a40ff91b5$var$y = "function", $d8e80c8a40ff91b5$var$b = "undefined", $d8e80c8a40ff91b5$var$I = "@@redux/" + Math.random().toString(36), $d8e80c8a40ff91b5$var$w = /* #__PURE__ */ function() {
    return typeof Symbol === $d8e80c8a40ff91b5$var$y && Symbol.observable || "@@observable";
}(), $d8e80c8a40ff91b5$var$E = " != " + $d8e80c8a40ff91b5$var$y;
function $d8e80c8a40ff91b5$var$P(e, n, t) {
    var r;
    if (typeof n === $d8e80c8a40ff91b5$var$y && typeof t === $d8e80c8a40ff91b5$var$b && (t = n, n = void 0), typeof t !== $d8e80c8a40ff91b5$var$b) {
        if (typeof t !== $d8e80c8a40ff91b5$var$y) throw new Error("enhancer" + $d8e80c8a40ff91b5$var$E);
        return t($d8e80c8a40ff91b5$var$P)(e, n);
    }
    if (typeof e !== $d8e80c8a40ff91b5$var$y) throw new Error("reducer" + $d8e80c8a40ff91b5$var$E);
    var i = e, a = n, o = [], u = o, c = !1;
    function s() {
        u === o && (u = o.slice());
    }
    function f() {
        return a;
    }
    function d(e) {
        if (typeof e !== $d8e80c8a40ff91b5$var$y) throw new Error("Listener" + $d8e80c8a40ff91b5$var$E);
        var n = !0;
        return s(), u.push(e), function() {
            if (n) {
                n = !1, s();
                var t = u.indexOf(e);
                u.splice(t, 1);
            }
        };
    }
    function p(e) {
        if (!(0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(e)) throw new Error("Act != obj");
        if (typeof e.type === $d8e80c8a40ff91b5$var$b) throw new Error("ActType " + $d8e80c8a40ff91b5$var$b);
        if (c) throw new Error("Dispatch in reducer");
        try {
            c = !0, a = i(a, e);
        } finally{
            c = !1;
        }
        for(var n = o = u, t = 0; t < n.length; t++)(0, n[t])();
        return e;
    }
    return p({
        type: "@@redux/INIT"
    }), (r = {
        dispatch: p,
        subscribe: d,
        getState: f,
        replaceReducer: function(e) {
            if (typeof e !== $d8e80c8a40ff91b5$var$y) throw new Error("next reducer" + $d8e80c8a40ff91b5$var$E);
            i = e, p({
                type: "@@redux/INIT"
            });
        }
    })[$d8e80c8a40ff91b5$var$w] = function() {
        var e, n = d;
        return (e = {
            subscribe: function(e) {
                if ("object" != typeof e) throw new TypeError("Observer != obj");
                function t() {
                    e.next && e.next(f());
                }
                return t(), {
                    unsubscribe: n(t)
                };
            }
        })[$d8e80c8a40ff91b5$var$w] = function() {
            return this;
        }, e;
    }, r;
}
function $d8e80c8a40ff91b5$var$S(e, n) {
    var t = n && n.type;
    return "action " + (t && t.toString() || "?") + "reducer " + e + " returns " + $d8e80c8a40ff91b5$var$b;
}
function $d8e80c8a40ff91b5$var$N() {
    var e = [].slice.call(arguments);
    return 0 === e.length ? function(e) {
        return e;
    } : 1 === e.length ? e[0] : e.reduce(function(e, n) {
        return function() {
            return e(n.apply(void 0, [].slice.call(arguments)));
        };
    });
}
function $d8e80c8a40ff91b5$var$O() {
    var e = arguments;
    return function(n) {
        return function(t, r, i) {
            var a, o = n(t, r, i), u = o.dispatch, c = {
                getState: o.getState,
                dispatch: function(e) {
                    return u(e);
                }
            };
            return a = [].slice.call(e).map(function(e) {
                return e(c);
            }), $d8e80c8a40ff91b5$var$v({}, o, {
                dispatch: u = $d8e80c8a40ff91b5$var$N.apply(void 0, a)(o.dispatch)
            });
        };
    };
}
var $d8e80c8a40ff91b5$var$A = (0, $6cce2b3292d7582c$export$8a682ae47622dbb9) + "anon_id", $d8e80c8a40ff91b5$var$_ = (0, $6cce2b3292d7582c$export$8a682ae47622dbb9) + "user_id", $d8e80c8a40ff91b5$var$x = (0, $6cce2b3292d7582c$export$8a682ae47622dbb9) + "user_traits", $d8e80c8a40ff91b5$export$588c7fdda06fbb0a = {
    __proto__: null,
    ANON_ID: $d8e80c8a40ff91b5$var$A,
    USER_ID: $d8e80c8a40ff91b5$var$_,
    USER_TRAITS: $d8e80c8a40ff91b5$var$x
}, $d8e80c8a40ff91b5$var$k = "userId", $d8e80c8a40ff91b5$var$T = "anonymousId", $d8e80c8a40ff91b5$var$z = [
    "bootstrap",
    "params",
    "campaign",
    "initializeStart",
    "initialize",
    "initializeEnd",
    "ready",
    "resetStart",
    "reset",
    "resetEnd",
    "pageStart",
    "page",
    "pageEnd",
    "pageAborted",
    "trackStart",
    "track",
    "trackEnd",
    "trackAborted",
    "identifyStart",
    "identify",
    "identifyEnd",
    "identifyAborted",
    "userIdChanged",
    "registerPlugins",
    "enablePlugin",
    "disablePlugin",
    "online",
    "offline",
    "setItemStart",
    "setItem",
    "setItemEnd",
    "setItemAborted",
    "removeItemStart",
    "removeItem",
    "removeItemEnd",
    "removeItemAborted"
], $d8e80c8a40ff91b5$var$M = [
    "name",
    "EVENTS",
    "config",
    "loaded"
], $d8e80c8a40ff91b5$export$fa3d5b535a2458a1 = $d8e80c8a40ff91b5$var$z.reduce(function(e, n) {
    return e[n] = n, e;
}, {
    registerPluginType: function(e) {
        return "registerPlugin:" + e;
    },
    pluginReadyType: function(e) {
        return "ready:" + e;
    }
}), $d8e80c8a40ff91b5$var$U = /^utm_/, $d8e80c8a40ff91b5$var$V = /^an_prop_/, $d8e80c8a40ff91b5$var$L = /^an_trait_/;
function $d8e80c8a40ff91b5$var$C(e) {
    var n = e.storage.setItem;
    return function(t) {
        return function(r) {
            return function(i) {
                if (i.type === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.bootstrap) {
                    var a = i.params, o = i.user, u = i.persistedUser, c = i.initialUser, s = u.userId === o.userId;
                    u.anonymousId !== o.anonymousId && n($d8e80c8a40ff91b5$var$A, o.anonymousId), s || n($d8e80c8a40ff91b5$var$_, o.userId), c.traits && n($d8e80c8a40ff91b5$var$x, $d8e80c8a40ff91b5$var$v({}, s && u.traits ? u.traits : {}, c.traits));
                    var l = Object.keys(i.params);
                    if (l.length) {
                        var f = a.an_uid, d = a.an_event, p = l.reduce(function(e, n) {
                            if (n.match($d8e80c8a40ff91b5$var$U) || n.match(/^(d|g)clid/)) {
                                var t = n.replace($d8e80c8a40ff91b5$var$U, "");
                                e.campaign["campaign" === t ? "name" : t] = a[n];
                            }
                            return n.match($d8e80c8a40ff91b5$var$V) && (e.props[n.replace($d8e80c8a40ff91b5$var$V, "")] = a[n]), n.match($d8e80c8a40ff91b5$var$L) && (e.traits[n.replace($d8e80c8a40ff91b5$var$L, "")] = a[n]), e;
                        }, {
                            campaign: {},
                            props: {},
                            traits: {}
                        });
                        t.dispatch($d8e80c8a40ff91b5$var$v({
                            type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.params,
                            raw: a
                        }, p, f ? {
                            userId: f
                        } : {})), f && setTimeout(function() {
                            return e.identify(f, p.traits);
                        }, 0), d && setTimeout(function() {
                            return e.track(d, p.props);
                        }, 0), Object.keys(p.campaign).length && t.dispatch({
                            type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.campaign,
                            campaign: p.campaign
                        });
                    }
                }
                return r(i);
            };
        };
    };
}
function $d8e80c8a40ff91b5$var$R(e) {
    return function(n, t) {
        if (void 0 === n && (n = {}), void 0 === t && (t = {}), t.type === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.setItemEnd) {
            if (t.key === $d8e80c8a40ff91b5$var$A) return $d8e80c8a40ff91b5$var$v({}, n, {
                anonymousId: t.value
            });
            if (t.key === $d8e80c8a40ff91b5$var$_) return $d8e80c8a40ff91b5$var$v({}, n, {
                userId: t.value
            });
        }
        switch(t.type){
            case $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.identify:
                return Object.assign({}, n, {
                    userId: t.userId,
                    traits: $d8e80c8a40ff91b5$var$v({}, n.traits, t.traits)
                });
            case $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.reset:
                return [
                    $d8e80c8a40ff91b5$var$_,
                    $d8e80c8a40ff91b5$var$A,
                    $d8e80c8a40ff91b5$var$x
                ].forEach(function(n) {
                    e.removeItem(n);
                }), Object.assign({}, n, {
                    userId: null,
                    anonymousId: null,
                    traits: {}
                });
            default:
                return n;
        }
    };
}
function $d8e80c8a40ff91b5$var$$(e) {
    return {
        userId: e.getItem($d8e80c8a40ff91b5$var$_),
        anonymousId: e.getItem($d8e80c8a40ff91b5$var$A),
        traits: e.getItem($d8e80c8a40ff91b5$var$x)
    };
}
var $d8e80c8a40ff91b5$var$D = function(e) {
    return (0, $6cce2b3292d7582c$export$8a682ae47622dbb9) + "TEMP" + (0, $6cce2b3292d7582c$export$8a682ae47622dbb9) + e;
};
function $d8e80c8a40ff91b5$var$B(n) {
    var t = n.storage, r = t.setItem, i = t.removeItem, a = t.getItem;
    return function(n) {
        return function(t) {
            return function(u) {
                var c = u.userId, s = u.traits, l = u.options;
                if (u.type === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.reset && ([
                    $d8e80c8a40ff91b5$var$_,
                    $d8e80c8a40ff91b5$var$x,
                    $d8e80c8a40ff91b5$var$A
                ].forEach(function(e) {
                    i(e);
                }), [
                    $d8e80c8a40ff91b5$var$k,
                    $d8e80c8a40ff91b5$var$T,
                    "traits"
                ].forEach(function(e) {
                    (0, $d3bc06c108ca0c17$export$cd7f480d6b8286c3)($d8e80c8a40ff91b5$var$D(e));
                })), u.type === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.identify) {
                    a($d8e80c8a40ff91b5$var$A) || r($d8e80c8a40ff91b5$var$A, (0, $e44340a642fc927d$export$31b40729666a4ae0)());
                    var f = a($d8e80c8a40ff91b5$var$_), d = a($d8e80c8a40ff91b5$var$x) || {};
                    f && f !== c && n.dispatch({
                        type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.userIdChanged,
                        old: {
                            userId: f,
                            traits: d
                        },
                        new: {
                            userId: c,
                            traits: s
                        },
                        options: l
                    }), c && r($d8e80c8a40ff91b5$var$_, c), s && r($d8e80c8a40ff91b5$var$x, $d8e80c8a40ff91b5$var$v({}, d, s));
                }
                return t(u);
            };
        };
    };
}
var $d8e80c8a40ff91b5$var$X = {};
function $d8e80c8a40ff91b5$var$J(e, n) {
    $d8e80c8a40ff91b5$var$X[e] && (0, $6cce2b3292d7582c$export$f6e2535fb5126e54)($d8e80c8a40ff91b5$var$X[e]) && ($d8e80c8a40ff91b5$var$X[e](n), delete $d8e80c8a40ff91b5$var$X[e]);
}
function $d8e80c8a40ff91b5$var$W(e, n, t) {
    return new Promise(function(r, i) {
        return n() ? r(e) : t < 1 ? i($d8e80c8a40ff91b5$var$v({}, e, {
            queue: !0
        })) : new Promise(function(e) {
            return setTimeout(e, 10);
        }).then(function(a) {
            return $d8e80c8a40ff91b5$var$W(e, n, t - 10).then(r, i);
        });
    });
}
function $d8e80c8a40ff91b5$var$H(e) {
    return {
        abort: e
    };
}
function $d8e80c8a40ff91b5$var$F(e, n, t) {
    var r = {}, i = n(), a = e.getState(), o = a.plugins, u = a.queue, c = a.user;
    if (!a.context.offline && u && u.actions && u.actions.length) {
        var s = u.actions.reduce(function(e, n, t) {
            return o[n.plugin].loaded ? (e.process.push(n), e.processIndex.push(t)) : (e.requeue.push(n), e.requeueIndex.push(t)), e;
        }, {
            processIndex: [],
            process: [],
            requeue: [],
            requeueIndex: []
        });
        if (s.processIndex && s.processIndex.length) {
            s.processIndex.forEach(function(n) {
                var a = u.actions[n], s = a.plugin, f = a.payload.type, p = i[s][f];
                if (p && (0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(p)) {
                    var m, g = function(e, n) {
                        return void 0 === e && (e = {}), void 0 === n && (n = {}), [
                            $d8e80c8a40ff91b5$var$k,
                            $d8e80c8a40ff91b5$var$T
                        ].reduce(function(t, r) {
                            return e.hasOwnProperty(r) && n[r] && n[r] !== e[r] && (t[r] = n[r]), t;
                        }, e);
                    }(a.payload, c), h = r[g.meta.rid];
                    if (!h && (m = p({
                        payload: g,
                        config: o[s].config,
                        instance: t,
                        abort: $d8e80c8a40ff91b5$var$H
                    })) && (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(m) && m.abort) return void (r[g.meta.rid] = !0);
                    if (!h) {
                        var y = f + ":" + s;
                        e.dispatch($d8e80c8a40ff91b5$var$v({}, g, {
                            type: y,
                            _: {
                                called: y,
                                from: "queueDrain"
                            }
                        }));
                    }
                }
            });
            var f = u.actions.filter(function(e, n) {
                return !~s.processIndex.indexOf(n);
            });
            u.actions = f;
        }
    }
}
var $d8e80c8a40ff91b5$var$G = function(e) {
    var n = e.data, t = e.action, r = e.instance, i = e.state, a = e.allPlugins, o = e.allMatches, u = e.store, c = e.EVENTS;
    try {
        var s = i.plugins, f = i.context, p = t.type, m = p.match($d8e80c8a40ff91b5$var$K), g = n.exact.map(function(e) {
            return e.pluginName;
        });
        m && (g = o.during.map(function(e) {
            return e.pluginName;
        }));
        var h = function(e, n) {
            return function(t, r, i) {
                var a = r.config, o = r.name, u = o + "." + t.type;
                i && (u = i.event);
                var c = t.type.match($d8e80c8a40ff91b5$var$K) ? function(e, n, t, r, i) {
                    return function(a, o) {
                        var u = r ? r.name : e, c = o && $d8e80c8a40ff91b5$var$ae(o) ? o : t;
                        if (r && (!(c = o && $d8e80c8a40ff91b5$var$ae(o) ? o : [
                            e
                        ]).includes(e) || 1 !== c.length)) throw new Error("Method " + n + " can only abort " + e + " plugin. " + JSON.stringify(c) + " input valid");
                        return $d8e80c8a40ff91b5$var$v({}, i, {
                            abort: {
                                reason: a,
                                plugins: c,
                                caller: n,
                                _: u
                            }
                        });
                    };
                }(o, u, n, i, t) : function(e, n) {
                    return function() {
                        throw new Error(e.type + " action not cancellable. Remove abort in " + n);
                    };
                }(t, u);
                return {
                    payload: $d8e80c8a40ff91b5$var$ce(t),
                    instance: e,
                    config: a || {},
                    abort: c
                };
            };
        }(r, g), y = n.exact.reduce(function(e, n) {
            var t = n.pluginName, r = n.methodName, i = !1;
            return r.match(/^initialize/) || r.match(/^reset/) || (i = !s[t].loaded), f.offline && r.match(/^(page|track|identify)/) && (i = !0), e["" + t] = i, e;
        }, {});
        return Promise.resolve(n.exact.reduce(function(e, i, o) {
            try {
                var u = i.pluginName;
                return Promise.resolve(e).then(function(e) {
                    function i() {
                        return Promise.resolve(e);
                    }
                    var o = function() {
                        if (n.namespaced && n.namespaced[u]) return Promise.resolve(n.namespaced[u].reduce(function(e, n, t) {
                            try {
                                return Promise.resolve(e).then(function(e) {
                                    var t, i, o;
                                    return n.method && (0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(n.method) ? (function(e, n) {
                                        var t = $d8e80c8a40ff91b5$var$ue(e);
                                        if (t && t.name === n) {
                                            var r = $d8e80c8a40ff91b5$var$ue(t.method);
                                            throw new Error([
                                                n + " plugin is calling method " + e,
                                                "Plugins cant call self",
                                                "Use " + t.method + " " + (r ? "or " + r.method : "") + " in " + n + " plugin insteadof " + e
                                            ].join("\n"));
                                        }
                                    }(n.methodName, n.pluginName), Promise.resolve(n.method({
                                        payload: e,
                                        instance: r,
                                        abort: (t = e, i = u, o = n.pluginName, function(e, n) {
                                            return $d8e80c8a40ff91b5$var$v({}, t, {
                                                abort: {
                                                    reason: e,
                                                    plugins: n || [
                                                        i
                                                    ],
                                                    caller: p,
                                                    from: o || i
                                                }
                                            });
                                        }),
                                        config: $d8e80c8a40ff91b5$var$ee(n.pluginName, s, a),
                                        plugins: s
                                    })).then(function(n) {
                                        var t = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(n) ? n : {};
                                        return Promise.resolve($d8e80c8a40ff91b5$var$v({}, e, t));
                                    })) : e;
                                });
                            } catch (e) {
                                return Promise.reject(e);
                            }
                        }, Promise.resolve(t))).then(function(n) {
                            e[u] = n;
                        });
                        e[u] = t;
                    }();
                    return o && o.then ? o.then(i) : i();
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, Promise.resolve({}))).then(function(e) {
            return Promise.resolve(n.exact.reduce(function(t, i, o) {
                try {
                    var c = n.exact.length === o + 1, f = i.pluginName, d = a[f];
                    return Promise.resolve(t).then(function(n) {
                        var t = e[f] ? e[f] : {};
                        if (m && (t = n), $d8e80c8a40ff91b5$var$re(t, f)) return $d8e80c8a40ff91b5$var$Z({
                            data: t,
                            method: p,
                            instance: r,
                            pluginName: f,
                            store: u
                        }), Promise.resolve(n);
                        if ($d8e80c8a40ff91b5$var$re(n, f)) return c && $d8e80c8a40ff91b5$var$Z({
                            data: n,
                            method: p,
                            instance: r,
                            store: u
                        }), Promise.resolve(n);
                        if (y.hasOwnProperty(f) && !0 === y[f]) return u.dispatch({
                            type: "queue",
                            plugin: f,
                            payload: t,
                            _: {
                                called: "queue",
                                from: "queueMechanism"
                            }
                        }), Promise.resolve(n);
                        var i = h(e[f], a[f]);
                        return Promise.resolve(d[p]({
                            abort: i.abort,
                            payload: t,
                            instance: r,
                            config: $d8e80c8a40ff91b5$var$ee(f, s, a),
                            plugins: s
                        })).then(function(i) {
                            var a = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(i) ? i : {}, o = $d8e80c8a40ff91b5$var$v({}, n, a), c = e[f];
                            if ($d8e80c8a40ff91b5$var$re(c, f)) $d8e80c8a40ff91b5$var$Z({
                                data: c,
                                method: p,
                                instance: r,
                                pluginName: f,
                                store: u
                            });
                            else {
                                var s = p + ":" + f;
                                (s.match(/:/g) || []).length < 2 && !p.match($d8e80c8a40ff91b5$var$Q) && !p.match($d8e80c8a40ff91b5$var$Y) && r.dispatch($d8e80c8a40ff91b5$var$v({}, m ? o : t, {
                                    type: s,
                                    _: {
                                        called: s,
                                        from: "submethod"
                                    }
                                }));
                            }
                            return Promise.resolve(o);
                        });
                    });
                } catch (e) {
                    return Promise.reject(e);
                }
            }, Promise.resolve(t))).then(function(e) {
                if (!(p.match($d8e80c8a40ff91b5$var$K) || p.match(/^registerPlugin/) || p.match($d8e80c8a40ff91b5$var$Y) || p.match($d8e80c8a40ff91b5$var$Q) || p.match(/^params/) || p.match(/^userIdChanged/))) {
                    if (c.plugins.includes(p), e._ && e._.originalAction === p) return e;
                    var t = $d8e80c8a40ff91b5$var$v({}, e, {
                        _: {
                            originalAction: e.type,
                            called: e.type,
                            from: "engineEnd"
                        }
                    });
                    $d8e80c8a40ff91b5$var$ie(e, n.exact.length) && !p.match(/End$/) && (t = $d8e80c8a40ff91b5$var$v({}, t, {
                        type: e.type + "Aborted"
                    })), u.dispatch(t);
                }
                return e;
            });
        });
    } catch (e) {
        return Promise.reject(e);
    }
}, $d8e80c8a40ff91b5$var$K = /Start$/, $d8e80c8a40ff91b5$var$Q = /^bootstrap/, $d8e80c8a40ff91b5$var$Y = /^ready/;
function $d8e80c8a40ff91b5$var$Z(e) {
    var n = e.pluginName, t = e.method + "Aborted" + (n ? ":" + n : "");
    e.store.dispatch($d8e80c8a40ff91b5$var$v({}, e.data, {
        type: t,
        _: {
            called: t,
            from: "abort"
        }
    }));
}
function $d8e80c8a40ff91b5$var$ee(e, n, t) {
    var r = n[e] || t[e];
    return r && r.config ? r.config : {};
}
function $d8e80c8a40ff91b5$var$ne(e, n) {
    return n.reduce(function(n, t) {
        return t[e] ? n.concat({
            methodName: e,
            pluginName: t.name,
            method: t[e]
        }) : n;
    }, []);
}
function $d8e80c8a40ff91b5$var$te(e, n) {
    var t = e.replace($d8e80c8a40ff91b5$var$K, ""), r = n ? ":" + n : "";
    return [
        "" + e + r,
        "" + t + r,
        t + "End" + r
    ];
}
function $d8e80c8a40ff91b5$var$re(e, n) {
    var t = e.abort;
    return !!t && (!0 === t || $d8e80c8a40ff91b5$var$oe(t, n) || t && $d8e80c8a40ff91b5$var$oe(t.plugins, n));
}
function $d8e80c8a40ff91b5$var$ie(e, n) {
    var t = e.abort;
    if (!t) return !1;
    if (!0 === t || (0, $6cce2b3292d7582c$export$844ec244b1367d54)(t)) return !0;
    var r = t.plugins;
    return $d8e80c8a40ff91b5$var$ae(t) && t.length === n || $d8e80c8a40ff91b5$var$ae(r) && r.length === n;
}
function $d8e80c8a40ff91b5$var$ae(e) {
    return Array.isArray(e);
}
function $d8e80c8a40ff91b5$var$oe(e, n) {
    return !(!e || !$d8e80c8a40ff91b5$var$ae(e)) && e.includes(n);
}
function $d8e80c8a40ff91b5$var$ue(e) {
    var n = e.match(/(.*):(.*)/);
    return !!n && {
        method: n[1],
        name: n[2]
    };
}
function $d8e80c8a40ff91b5$var$ce(e) {
    return Object.keys(e).reduce(function(n, t) {
        return "type" === t || (n[t] = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(e[t]) ? Object.assign({}, e[t]) : e[t]), n;
    }, {});
}
function $d8e80c8a40ff91b5$var$se(e, n, t) {
    var r = {};
    return function(i) {
        return function(a) {
            return function(o) {
                try {
                    var u, c = function(e) {
                        return u ? e : a(f);
                    }, s = o.type, l = o.plugins, f = o;
                    if (o.abort) return Promise.resolve(a(o));
                    if (s === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.enablePlugin && i.dispatch({
                        type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.initializeStart,
                        plugins: l,
                        disabled: [],
                        fromEnable: !0,
                        meta: o.meta
                    }), s === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.disablePlugin && setTimeout(function() {
                        return $d8e80c8a40ff91b5$var$J(o.meta.rid, {
                            payload: o
                        });
                    }, 0), s === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.initializeEnd) {
                        var m = n(), g = Object.keys(m), h = g.filter(function(e) {
                            return l.includes(e);
                        }).map(function(e) {
                            return m[e];
                        }), y = [], b = [], I = o.disabled, w = h.map(function(e) {
                            var n = e.loaded, t = e.name, a = e.config;
                            return $d8e80c8a40ff91b5$var$W(e, function() {
                                return n({
                                    config: a
                                });
                            }, 1e4).then(function(n) {
                                return r[t] || (i.dispatch({
                                    type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.pluginReadyType(t),
                                    name: t,
                                    events: Object.keys(e).filter(function(e) {
                                        return !$d8e80c8a40ff91b5$var$M.includes(e);
                                    })
                                }), r[t] = !0), y = y.concat(t), e;
                            }).catch(function(e) {
                                if (e instanceof Error) throw new Error(e);
                                return b = b.concat(e.name), e;
                            });
                        });
                        Promise.all(w).then(function(e) {
                            var n = {
                                plugins: y,
                                failed: b,
                                disabled: I
                            };
                            setTimeout(function() {
                                g.length === w.length + I.length && i.dispatch($d8e80c8a40ff91b5$var$v({}, {
                                    type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.ready
                                }, n));
                            }, 0);
                        });
                    }
                    var E = function() {
                        if (s !== $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.bootstrap) return /^ready:([^:]*)$/.test(s) && setTimeout(function() {
                            return $d8e80c8a40ff91b5$var$F(i, n, e);
                        }, 0), Promise.resolve(function(e, n, t, r, i) {
                            try {
                                var a = (0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(n) ? n() : n, o = e.type, u = o.replace($d8e80c8a40ff91b5$var$K, "");
                                if (e._ && e._.called) return Promise.resolve(e);
                                var c = t.getState(), s = (m = a, void 0 === (g = c.plugins) && (g = {}), void 0 === (h = e.options) && (h = {}), Object.keys(m).filter(function(e) {
                                    var n = h.plugins || {};
                                    return (0, $6cce2b3292d7582c$export$f9ce7b637dfbe238)(n[e]) ? n[e] : !1 !== n.all && (!g[e] || !1 !== g[e].enabled);
                                }).map(function(e) {
                                    return m[e];
                                }));
                                o === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.initializeStart && e.fromEnable && (s = Object.keys(c.plugins).filter(function(n) {
                                    var t = c.plugins[n];
                                    return e.plugins.includes(n) && !t.initialized;
                                }).map(function(e) {
                                    return a[e];
                                }));
                                var l = s.map(function(e) {
                                    return e.name;
                                }), f = function(e, n, t) {
                                    var r = $d8e80c8a40ff91b5$var$te(e).map(function(e) {
                                        return $d8e80c8a40ff91b5$var$ne(e, n);
                                    });
                                    return n.reduce(function(t, r) {
                                        var i = r.name, a = $d8e80c8a40ff91b5$var$te(e, i).map(function(e) {
                                            return $d8e80c8a40ff91b5$var$ne(e, n);
                                        }), o = a[0], u = a[1], c = a[2];
                                        return o.length && (t.beforeNS[i] = o), u.length && (t.duringNS[i] = u), c.length && (t.afterNS[i] = c), t;
                                    }, {
                                        before: r[0],
                                        beforeNS: {},
                                        during: r[1],
                                        duringNS: {},
                                        after: r[2],
                                        afterNS: {}
                                    });
                                }(o, s);
                                return Promise.resolve($d8e80c8a40ff91b5$var$G({
                                    action: e,
                                    data: {
                                        exact: f.before,
                                        namespaced: f.beforeNS
                                    },
                                    state: c,
                                    allPlugins: a,
                                    allMatches: f,
                                    instance: t,
                                    store: r,
                                    EVENTS: i
                                })).then(function(e) {
                                    function n() {
                                        var n = function() {
                                            if (o.match($d8e80c8a40ff91b5$var$K)) return Promise.resolve($d8e80c8a40ff91b5$var$G({
                                                action: $d8e80c8a40ff91b5$var$v({}, s, {
                                                    type: u + "End"
                                                }),
                                                data: {
                                                    exact: f.after,
                                                    namespaced: f.afterNS
                                                },
                                                state: c,
                                                allPlugins: a,
                                                allMatches: f,
                                                instance: t,
                                                store: r,
                                                EVENTS: i
                                            })).then(function(e) {
                                                e.meta && e.meta.hasCallback && $d8e80c8a40ff91b5$var$J(e.meta.rid, {
                                                    payload: e
                                                });
                                            });
                                        }();
                                        return n && n.then ? n.then(function() {
                                            return e;
                                        }) : e;
                                    }
                                    if ($d8e80c8a40ff91b5$var$ie(e, l.length)) return e;
                                    var s, d = function() {
                                        if (o !== u) return Promise.resolve($d8e80c8a40ff91b5$var$G({
                                            action: $d8e80c8a40ff91b5$var$v({}, e, {
                                                type: u
                                            }),
                                            data: {
                                                exact: f.during,
                                                namespaced: f.duringNS
                                            },
                                            state: c,
                                            allPlugins: a,
                                            allMatches: f,
                                            instance: t,
                                            store: r,
                                            EVENTS: i
                                        })).then(function(e) {
                                            s = e;
                                        });
                                        s = e;
                                    }();
                                    return d && d.then ? d.then(n) : n();
                                });
                            } catch (e) {
                                return Promise.reject(e);
                            }
                            var m, g, h;
                        }(o, n, e, i, t)).then(function(e) {
                            return u = 1, a(e);
                        });
                    }();
                    return Promise.resolve(E && E.then ? E.then(c) : c(E));
                } catch (e) {
                    return Promise.reject(e);
                }
            };
        };
    };
}
function $d8e80c8a40ff91b5$var$le(e) {
    return function(n) {
        return function(n) {
            return function(t) {
                var r = t.type, i = t.key, a = t.value, o = t.options;
                if (r === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.setItem || r === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.removeItem) {
                    if (t.abort) return n(t);
                    r === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.setItem ? e.setItem(i, a, o) : e.removeItem(i, o);
                }
                return n(t);
            };
        };
    };
}
var $d8e80c8a40ff91b5$var$fe = function() {
    var e = this;
    this.before = [], this.after = [], this.addMiddleware = function(n, t) {
        e[t] = e[t].concat(n);
    }, this.removeMiddleware = function(n, t) {
        var r = e[t].findIndex(function(e) {
            return e === n;
        });
        -1 !== r && (e[t] = [].concat(e[t].slice(0, r), e[t].slice(r + 1)));
    }, this.dynamicMiddlewares = function(n) {
        return function(t) {
            return function(r) {
                return function(i) {
                    var a = {
                        getState: t.getState,
                        dispatch: function(e) {
                            return t.dispatch(e);
                        }
                    }, o = e[n].map(function(e) {
                        return e(a);
                    });
                    return $d8e80c8a40ff91b5$var$N.apply(void 0, o)(r)(i);
                };
            };
        };
    };
};
function $d8e80c8a40ff91b5$var$de(e) {
    return function(n, t) {
        void 0 === n && (n = {});
        var r = {};
        if ("initialize:aborted" === t.type) return n;
        if (/^registerPlugin:([^:]*)$/.test(t.type)) {
            var i = $d8e80c8a40ff91b5$var$pe(t.type, "registerPlugin"), a = e()[i];
            if (!a || !i) return n;
            var o = t.enabled, u = a.config;
            return r[i] = {
                enabled: o,
                initialized: !!o && Boolean(!a.initialize),
                loaded: !!o && Boolean(a.loaded({
                    config: u
                })),
                config: u
            }, $d8e80c8a40ff91b5$var$v({}, n, r);
        }
        if (/^initialize:([^:]*)$/.test(t.type)) {
            var c = $d8e80c8a40ff91b5$var$pe(t.type, $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.initialize), s = e()[c];
            return s && c ? (r[c] = $d8e80c8a40ff91b5$var$v({}, n[c], {
                initialized: !0,
                loaded: Boolean(s.loaded({
                    config: s.config
                }))
            }), $d8e80c8a40ff91b5$var$v({}, n, r)) : n;
        }
        if (/^ready:([^:]*)$/.test(t.type)) return r[t.name] = $d8e80c8a40ff91b5$var$v({}, n[t.name], {
            loaded: !0
        }), $d8e80c8a40ff91b5$var$v({}, n, r);
        switch(t.type){
            case $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.disablePlugin:
                return $d8e80c8a40ff91b5$var$v({}, n, $d8e80c8a40ff91b5$var$me(t.plugins, !1, n));
            case $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.enablePlugin:
                return $d8e80c8a40ff91b5$var$v({}, n, $d8e80c8a40ff91b5$var$me(t.plugins, !0, n));
            default:
                return n;
        }
    };
}
function $d8e80c8a40ff91b5$var$pe(e, n) {
    return e.substring(n.length + 1, e.length);
}
function $d8e80c8a40ff91b5$var$me(e, n, t) {
    return e.reduce(function(e, r) {
        return e[r] = $d8e80c8a40ff91b5$var$v({}, t[r], {
            enabled: n
        }), e;
    }, t);
}
function $d8e80c8a40ff91b5$var$ge(e) {
    try {
        return JSON.parse(JSON.stringify(e));
    } catch (e) {}
    return e;
}
var $d8e80c8a40ff91b5$var$he = {
    last: {},
    history: []
};
function $d8e80c8a40ff91b5$var$ve(e, n) {
    void 0 === e && (e = $d8e80c8a40ff91b5$var$he);
    var t = n.options, r = n.meta;
    if (n.type === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.track) {
        var i = $d8e80c8a40ff91b5$var$ge($d8e80c8a40ff91b5$var$v({
            event: n.event,
            properties: n.properties
        }, Object.keys(t).length && {
            options: t
        }, {
            meta: r
        }));
        return $d8e80c8a40ff91b5$var$v({}, e, {
            last: i,
            history: e.history.concat(i)
        });
    }
    return e;
}
var $d8e80c8a40ff91b5$var$ye = {
    actions: []
};
function $d8e80c8a40ff91b5$var$be(e, n) {
    void 0 === e && (e = $d8e80c8a40ff91b5$var$ye);
    var t = n.payload;
    switch(n.type){
        case "queue":
            var r;
            return r = t && t.type && t.type === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.identify ? [
                n
            ].concat(e.actions) : e.actions.concat(n), $d8e80c8a40ff91b5$var$v({}, e, {
                actions: r
            });
        case "dequeue":
            return [];
        default:
            return e;
    }
}
var $d8e80c8a40ff91b5$var$Ie = /#.*$/;
function $d8e80c8a40ff91b5$var$we(e) {
    var n = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g.exec(e);
    return "/" + (n && n[3] ? n[3].split("?")[0].replace($d8e80c8a40ff91b5$var$Ie, "") : "");
}
var $d8e80c8a40ff91b5$var$Ee, $d8e80c8a40ff91b5$var$Pe, $d8e80c8a40ff91b5$var$Se, $d8e80c8a40ff91b5$var$Ne, $d8e80c8a40ff91b5$var$Oe = function(e) {
    if (void 0 === e && (e = {}), !(0, $6cce2b3292d7582c$export$4e09c449d6c407f7)) return e;
    var n = document, t = n.title, r = n.referrer, i = window, a = i.location, o = i.innerWidth, u = i.innerHeight, c = a.hash, s = a.search, l = function(e) {
        var n = function() {
            if (0, $6cce2b3292d7582c$export$4e09c449d6c407f7) {
                for(var e, n = document.getElementsByTagName("link"), t = 0; e = n[t]; t++)if ("canonical" === e.getAttribute("rel")) return e.getAttribute("href");
            }
        }();
        return n ? n.match(/\?/) ? n : n + e : window.location.href.replace($d8e80c8a40ff91b5$var$Ie, "");
    }(s), f = {
        title: t,
        url: l,
        path: $d8e80c8a40ff91b5$var$we(l),
        hash: c,
        search: s,
        width: o,
        height: u
    };
    return r && "" !== r && (f.referrer = r), $d8e80c8a40ff91b5$var$v({}, f, e);
}, $d8e80c8a40ff91b5$var$Ae = {
    last: {},
    history: []
};
function $d8e80c8a40ff91b5$var$_e(e, n) {
    void 0 === e && (e = $d8e80c8a40ff91b5$var$Ae);
    var t = n.options;
    if (n.type === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.page) {
        var r = $d8e80c8a40ff91b5$var$ge($d8e80c8a40ff91b5$var$v({
            properties: n.properties,
            meta: n.meta
        }, Object.keys(t).length && {
            options: t
        }));
        return $d8e80c8a40ff91b5$var$v({}, e, {
            last: r,
            history: e.history.concat(r)
        });
    }
    return e;
}
$d8e80c8a40ff91b5$var$Ee = function() {
    if (!(0, $6cce2b3292d7582c$export$4e09c449d6c407f7)) return !1;
    var e = navigator.appVersion;
    return ~e.indexOf("Win") ? "Windows" : ~e.indexOf("Mac") ? "MacOS" : ~e.indexOf("X11") ? "UNIX" : ~e.indexOf("Linux") ? "Linux" : "Unknown OS";
}(), $d8e80c8a40ff91b5$var$Pe = (0, $6cce2b3292d7582c$export$4e09c449d6c407f7) ? document.referrer : null, $d8e80c8a40ff91b5$var$Se = (0, $e44340a642fc927d$export$563e375d286a76a7)(), $d8e80c8a40ff91b5$var$Ne = (0, $e44340a642fc927d$export$c3133dbc11f66777)();
var $d8e80c8a40ff91b5$var$xe = {
    initialized: !1,
    sessionId: (0, $e44340a642fc927d$export$31b40729666a4ae0)(),
    app: null,
    version: null,
    debug: !1,
    offline: !!(0, $6cce2b3292d7582c$export$4e09c449d6c407f7) && !navigator.onLine,
    os: {
        name: $d8e80c8a40ff91b5$var$Ee
    },
    userAgent: (0, $6cce2b3292d7582c$export$4e09c449d6c407f7) ? navigator.userAgent : "node",
    library: {
        name: "analytics",
        version: "0.12.14"
    },
    timezone: $d8e80c8a40ff91b5$var$Ne,
    locale: $d8e80c8a40ff91b5$var$Se,
    campaign: {},
    referrer: $d8e80c8a40ff91b5$var$Pe
};
function $d8e80c8a40ff91b5$var$je(e, n) {
    void 0 === e && (e = $d8e80c8a40ff91b5$var$xe);
    var t = e.initialized, r = n.campaign;
    switch(n.type){
        case $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.campaign:
            return $d8e80c8a40ff91b5$var$v({}, e, {
                campaign: r
            });
        case $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.offline:
            return $d8e80c8a40ff91b5$var$v({}, e, {
                offline: !0
            });
        case $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.online:
            return $d8e80c8a40ff91b5$var$v({}, e, {
                offline: !1
            });
        default:
            return t ? e : $d8e80c8a40ff91b5$var$v({}, $d8e80c8a40ff91b5$var$xe, e, {
                initialized: !0
            });
    }
}
var $d8e80c8a40ff91b5$var$ke = [
    "plugins",
    "reducers",
    "storage"
];
function $d8e80c8a40ff91b5$var$Te(e, n, t) {
    if (0, $6cce2b3292d7582c$export$4e09c449d6c407f7) {
        var r = window[(t ? "add" : "remove") + "EventListener"];
        e.split(" ").forEach(function(e) {
            r(e, n);
        });
    }
}
function $d8e80c8a40ff91b5$var$ze(e) {
    var n = $d8e80c8a40ff91b5$var$Te.bind(null, "online offline", function(n) {
        return Promise.resolve(!navigator.onLine).then(e);
    });
    return n(!0), function(e) {
        return n(!1);
    };
}
function $d8e80c8a40ff91b5$var$Me() {
    return (0, $d3bc06c108ca0c17$export$adaa4cf7ef1b65be)("analytics", []), function(e) {
        return function(n, t, r) {
            var i = e(n, t, r), a = i.dispatch;
            return Object.assign(i, {
                dispatch: function(e) {
                    return (0, $d3bc06c108ca0c17$export$348e0aeab6fdbe51)[0, $d3bc06c108ca0c17$export$7167c830cefcb6b5].analytics.push(e.action || e), a(e);
                }
            });
        };
    };
}
function $d8e80c8a40ff91b5$var$qe(e) {
    return function() {
        return $d8e80c8a40ff91b5$var$N($d8e80c8a40ff91b5$var$N.apply(null, arguments), $d8e80c8a40ff91b5$var$Me());
    };
}
function $d8e80c8a40ff91b5$var$Ue(e) {
    return e ? (0, $6cce2b3292d7582c$export$43bee75e5e14138e)(e) ? e : [
        e
    ] : [];
}
function $d8e80c8a40ff91b5$var$Ve(n, t, r) {
    void 0 === n && (n = {});
    var i, a, o = (0, $e44340a642fc927d$export$31b40729666a4ae0)();
    return t && ($d8e80c8a40ff91b5$var$X[o] = (i = t, a = function(e) {
        for(var n, t = e || Array.prototype.slice.call(arguments), r = 0; r < t.length; r++)if ((0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(t[r])) {
            n = t[r];
            break;
        }
        return n;
    }(r), function(e) {
        a && a(e), i(e);
    })), $d8e80c8a40ff91b5$var$v({}, n, {
        rid: o,
        ts: (new Date).getTime()
    }, t ? {
        hasCallback: !0
    } : {});
}
function $d8e80c8a40ff91b5$export$2b3af6baec22bd98(n) {
    void 0 === n && (n = {});
    var t = n.reducers || {}, c = n.initialUser || {}, s = (n.plugins || []).reduce(function(e, n) {
        if ((0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(n)) return e.middlewares = e.middlewares.concat(n), e;
        if (n.NAMESPACE && (n.name = n.NAMESPACE), !n.name) throw new Error("https://lytics.dev/errors/1");
        n.config || (n.config = {});
        var t = n.EVENTS ? Object.keys(n.EVENTS).map(function(e) {
            return n.EVENTS[e];
        }) : [];
        e.pluginEnabled[n.name] = !(!1 === n.enabled || !1 === n.config.enabled), delete n.enabled, n.methods && (e.methods[n.name] = Object.keys(n.methods).reduce(function(e, t) {
            var r;
            return e[t] = (r = n.methods[t], function() {
                for(var e = Array.prototype.slice.call(arguments), n = new Array(r.length), t = 0; t < e.length; t++)n[t] = e[t];
                return n[n.length] = Q, r.apply({
                    instance: Q
                }, n);
            }), e;
        }, {}), delete n.methods);
        var r = Object.keys(n).concat(t), i = new Set(e.events.concat(r));
        if (e.events = Array.from(i), e.pluginsArray = e.pluginsArray.concat(n), e.plugins[n.name]) throw new Error(n.name + "AlreadyLoaded");
        return e.plugins[n.name] = n, e.plugins[n.name].loaded || (e.plugins[n.name].loaded = function() {
            return !0;
        }), e;
    }, {
        plugins: {},
        pluginEnabled: {},
        methods: {},
        pluginsArray: [],
        middlewares: [],
        events: []
    }), f = n.storage ? n.storage : {
        getItem: (0, $d3bc06c108ca0c17$export$3988ae62b71be9a3),
        setItem: (0, $d3bc06c108ca0c17$export$adaa4cf7ef1b65be),
        removeItem: (0, $d3bc06c108ca0c17$export$cd7f480d6b8286c3)
    }, p = function(e) {
        return function(n, t, r) {
            return t.getState("user")[n] || (r && (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(r) && r[n] ? r[n] : $d8e80c8a40ff91b5$var$$(e)[n] || (0, $d3bc06c108ca0c17$export$3988ae62b71be9a3)($d8e80c8a40ff91b5$var$D(n)) || null);
        };
    }(f), h = s.plugins, w = s.events.filter(function(e) {
        return !$d8e80c8a40ff91b5$var$M.includes(e);
    }).sort(), E = new Set(w.concat($d8e80c8a40ff91b5$var$z).filter(function(e) {
        return !$d8e80c8a40ff91b5$var$M.includes(e);
    })), _ = Array.from(E).sort(), x = function() {
        return h;
    }, j = new $d8e80c8a40ff91b5$var$fe, U = j.addMiddleware, V = j.removeMiddleware, L = j.dynamicMiddlewares, X = function() {
        throw new Error("Abort disabled inListener");
    }, J = (0, $e44340a642fc927d$export$e0a0f6787544c815)(), W = $d8e80c8a40ff91b5$var$$(f), H = $d8e80c8a40ff91b5$var$v({}, W, c, J.an_uid ? {
        userId: J.an_uid
    } : {}, J.an_aid ? {
        anonymousId: J.an_aid
    } : {});
    H.anonymousId || (H.anonymousId = (0, $e44340a642fc927d$export$31b40729666a4ae0)());
    var G = $d8e80c8a40ff91b5$var$v({
        enable: function(e, n) {
            return new Promise(function(t) {
                ue.dispatch({
                    type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.enablePlugin,
                    plugins: $d8e80c8a40ff91b5$var$Ue(e),
                    _: {
                        originalAction: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.enablePlugin
                    }
                }, t, [
                    n
                ]);
            });
        },
        disable: function(e, n) {
            return new Promise(function(t) {
                ue.dispatch({
                    type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.disablePlugin,
                    plugins: $d8e80c8a40ff91b5$var$Ue(e),
                    _: {
                        originalAction: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.disablePlugin
                    }
                }, t, [
                    n
                ]);
            });
        }
    }, s.methods), K = !1, Q = {
        identify: function(e, n, t, r) {
            try {
                var i = (0, $6cce2b3292d7582c$export$844ec244b1367d54)(e) ? e : null, a = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(e) ? e : n, o = t || {}, c = Q.user();
                (0, $d3bc06c108ca0c17$export$adaa4cf7ef1b65be)($d8e80c8a40ff91b5$var$D($d8e80c8a40ff91b5$var$k), i);
                var s = i || a.userId || p($d8e80c8a40ff91b5$var$k, Q, a);
                return Promise.resolve(new Promise(function(e) {
                    ue.dispatch($d8e80c8a40ff91b5$var$v({
                        type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.identifyStart,
                        userId: s,
                        traits: a || {},
                        options: o,
                        anonymousId: c.anonymousId
                    }, c.id && c.id !== i && {
                        previousId: c.id
                    }), e, [
                        n,
                        t,
                        r
                    ]);
                }));
            } catch (e) {
                return Promise.reject(e);
            }
        },
        track: function(e, n, t, r) {
            try {
                var i = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(e) ? e.event : e;
                if (!i || !(0, $6cce2b3292d7582c$export$844ec244b1367d54)(i)) throw new Error("EventMissing");
                var a = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(e) ? e : n || {}, o = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(t) ? t : {};
                return Promise.resolve(new Promise(function(e) {
                    ue.dispatch({
                        type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.trackStart,
                        event: i,
                        properties: a,
                        options: o,
                        userId: p($d8e80c8a40ff91b5$var$k, Q, n),
                        anonymousId: p($d8e80c8a40ff91b5$var$T, Q, n)
                    }, e, [
                        n,
                        t,
                        r
                    ]);
                }));
            } catch (e) {
                return Promise.reject(e);
            }
        },
        page: function(e, n, t) {
            try {
                var r = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(e) ? e : {}, i = (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(n) ? n : {};
                return Promise.resolve(new Promise(function(a) {
                    ue.dispatch({
                        type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.pageStart,
                        properties: $d8e80c8a40ff91b5$var$Oe(r),
                        options: i,
                        userId: p($d8e80c8a40ff91b5$var$k, Q, r),
                        anonymousId: p($d8e80c8a40ff91b5$var$T, Q, r)
                    }, a, [
                        e,
                        n,
                        t
                    ]);
                }));
            } catch (e) {
                return Promise.reject(e);
            }
        },
        user: function(e) {
            if (e === $d8e80c8a40ff91b5$var$k || "id" === e) return p($d8e80c8a40ff91b5$var$k, Q);
            if (e === $d8e80c8a40ff91b5$var$T || "anonId" === e) return p($d8e80c8a40ff91b5$var$T, Q);
            var n = Q.getState("user");
            return e ? (0, (/*@__PURE__*/$parcel$interopDefault($ffcdeb0e8017e0ef$exports)))(n, e) : n;
        },
        reset: function(e) {
            return new Promise(function(n) {
                ue.dispatch({
                    type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.resetStart
                }, n, e);
            });
        },
        ready: function(e) {
            return K && e({
                plugins: G,
                instance: Q
            }), Q.on($d8e80c8a40ff91b5$export$fa3d5b535a2458a1.ready, function(n) {
                e(n), K = !0;
            });
        },
        on: function(e, n) {
            if (!e || !(0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(n)) return !1;
            if (e === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.bootstrap) throw new Error(".on disabled for " + e);
            var t = /Start$|Start:/;
            if ("*" === e) {
                var r = function(e) {
                    return function(e) {
                        return function(r) {
                            return r.type.match(t) && n({
                                payload: r,
                                instance: Q,
                                plugins: h
                            }), e(r);
                        };
                    };
                }, i = function(e) {
                    return function(e) {
                        return function(r) {
                            return r.type.match(t) || n({
                                payload: r,
                                instance: Q,
                                plugins: h
                            }), e(r);
                        };
                    };
                };
                return U(r, $d8e80c8a40ff91b5$var$Ce), U(i, $d8e80c8a40ff91b5$var$Re), function() {
                    V(r, $d8e80c8a40ff91b5$var$Ce), V(i, $d8e80c8a40ff91b5$var$Re);
                };
            }
            var a = e.match(t) ? $d8e80c8a40ff91b5$var$Ce : $d8e80c8a40ff91b5$var$Re, o = function(t) {
                return function(t) {
                    return function(r) {
                        return r.type === e && n({
                            payload: r,
                            instance: Q,
                            plugins: h,
                            abort: X
                        }), t(r);
                    };
                };
            };
            return U(o, a), function() {
                return V(o, a);
            };
        },
        once: function(e, n) {
            if (!e || !(0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(n)) return !1;
            if (e === $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.bootstrap) throw new Error(".once disabled for " + e);
            var t = Q.on(e, function(e) {
                n({
                    payload: e.payload,
                    instance: Q,
                    plugins: h,
                    abort: X
                }), t();
            });
            return t;
        },
        getState: function(e) {
            var n = ue.getState();
            return e ? (0, (/*@__PURE__*/$parcel$interopDefault($ffcdeb0e8017e0ef$exports)))(n, e) : Object.assign({}, n);
        },
        dispatch: function(e) {
            var n = (0, $6cce2b3292d7582c$export$844ec244b1367d54)(e) ? {
                type: e
            } : e;
            if ($d8e80c8a40ff91b5$var$z.includes(n.type)) throw new Error("reserved action " + n.type);
            var t = $d8e80c8a40ff91b5$var$v({}, n, {
                _: $d8e80c8a40ff91b5$var$v({
                    originalAction: n.type
                }, e._ || {})
            });
            ue.dispatch(t);
        },
        enablePlugin: G.enable,
        disablePlugin: G.disable,
        plugins: G,
        storage: {
            getItem: f.getItem,
            setItem: function(e, n, t) {
                ue.dispatch({
                    type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.setItemStart,
                    key: e,
                    value: n,
                    options: t
                });
            },
            removeItem: function(e, n) {
                ue.dispatch({
                    type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.removeItemStart,
                    key: e,
                    options: n
                });
            }
        },
        setAnonymousId: function(e, n) {
            Q.storage.setItem($d8e80c8a40ff91b5$var$A, e, n);
        },
        events: {
            core: $d8e80c8a40ff91b5$var$z,
            plugins: w
        }
    }, Y = s.middlewares.concat([
        function(e) {
            return function(e) {
                return function(n) {
                    return n.meta || (n.meta = $d8e80c8a40ff91b5$var$Ve()), e(n);
                };
            };
        },
        L($d8e80c8a40ff91b5$var$Ce),
        $d8e80c8a40ff91b5$var$se(Q, x, {
            all: _,
            plugins: w
        }),
        $d8e80c8a40ff91b5$var$le(f),
        $d8e80c8a40ff91b5$var$C(Q),
        $d8e80c8a40ff91b5$var$B(Q),
        L($d8e80c8a40ff91b5$var$Re)
    ]), Z = {
        context: $d8e80c8a40ff91b5$var$je,
        user: $d8e80c8a40ff91b5$var$R(f),
        page: $d8e80c8a40ff91b5$var$_e,
        track: $d8e80c8a40ff91b5$var$ve,
        plugins: $d8e80c8a40ff91b5$var$de(x),
        queue: $d8e80c8a40ff91b5$var$be
    }, ee = $d8e80c8a40ff91b5$var$N, ne = $d8e80c8a40ff91b5$var$N;
    if ((0, $6cce2b3292d7582c$export$4e09c449d6c407f7) && n.debug) {
        var te = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        te && (ee = te({
            trace: !0,
            traceLimit: 25
        })), ne = function() {
            return 0 === arguments.length ? $d8e80c8a40ff91b5$var$Me() : (0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(typeof arguments[0]) ? $d8e80c8a40ff91b5$var$qe() : $d8e80c8a40ff91b5$var$qe().apply(null, arguments);
        };
    }
    var re, ie = function(e) {
        return Object.keys(e).reduce(function(n, t) {
            return $d8e80c8a40ff91b5$var$ke.includes(t) || (n[t] = e[t]), n;
        }, {});
    }(n), ae = s.pluginsArray.reduce(function(e, n) {
        var t = n.name, r = n.config, i = n.loaded, a = s.pluginEnabled[t];
        return e[t] = {
            enabled: a,
            initialized: !!a && Boolean(!n.initialize),
            loaded: Boolean(i({
                config: r
            })),
            config: r
        }, e;
    }, {}), oe = {
        context: ie,
        user: H,
        plugins: ae
    }, ue = $d8e80c8a40ff91b5$var$P(function(e) {
        for(var n = Object.keys(e), t = {}, r = 0; r < n.length; r++){
            var i = n[r];
            typeof e[i] === $d8e80c8a40ff91b5$var$y && (t[i] = e[i]);
        }
        var a, o = Object.keys(t);
        try {
            !function(e) {
                Object.keys(e).forEach(function(n) {
                    var t = e[n];
                    if (typeof t(void 0, {
                        type: "@@redux/INIT"
                    }) === $d8e80c8a40ff91b5$var$b || typeof t(void 0, {
                        type: $d8e80c8a40ff91b5$var$I
                    }) === $d8e80c8a40ff91b5$var$b) throw new Error("reducer " + n + " " + $d8e80c8a40ff91b5$var$b);
                });
            }(t);
        } catch (e) {
            a = e;
        }
        return function(e, n) {
            if (void 0 === e && (e = {}), a) throw a;
            for(var r = !1, i = {}, u = 0; u < o.length; u++){
                var c = o[u], s = e[c], l = (0, t[c])(s, n);
                if (typeof l === $d8e80c8a40ff91b5$var$b) {
                    var f = $d8e80c8a40ff91b5$var$S(c, n);
                    throw new Error(f);
                }
                i[c] = l, r = r || l !== s;
            }
            return r ? i : e;
        };
    }($d8e80c8a40ff91b5$var$v({}, Z, t)), oe, ne(ee($d8e80c8a40ff91b5$var$O.apply(void 0, Y))));
    ue.dispatch = (re = ue.dispatch, function(e, n, t) {
        var r = $d8e80c8a40ff91b5$var$v({}, e, {
            meta: $d8e80c8a40ff91b5$var$Ve(e.meta, n, $d8e80c8a40ff91b5$var$Ue(t))
        });
        return re.apply(null, [
            r
        ]);
    });
    var ce = Object.keys(h);
    ue.dispatch({
        type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.bootstrap,
        plugins: ce,
        config: ie,
        params: J,
        user: H,
        initialUser: c,
        persistedUser: W
    });
    var pe = ce.filter(function(e) {
        return s.pluginEnabled[e];
    }), me = ce.filter(function(e) {
        return !s.pluginEnabled[e];
    });
    return ue.dispatch({
        type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.registerPlugins,
        plugins: ce,
        enabled: s.pluginEnabled
    }), s.pluginsArray.map(function(e, n) {
        var t = e.bootstrap, r = e.config, i = e.name;
        t && (0, $6cce2b3292d7582c$export$f6e2535fb5126e54)(t) && t({
            instance: Q,
            config: r,
            payload: e
        }), ue.dispatch({
            type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.registerPluginType(i),
            name: i,
            enabled: s.pluginEnabled[i],
            plugin: e
        }), s.pluginsArray.length === n + 1 && ue.dispatch({
            type: $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.initializeStart,
            plugins: pe,
            disabled: me
        });
    }), $d8e80c8a40ff91b5$var$ze(function(e) {
        ue.dispatch({
            type: e ? $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.offline : $d8e80c8a40ff91b5$export$fa3d5b535a2458a1.online
        });
    }), function(e, n, t) {
        setInterval(function() {
            return $d8e80c8a40ff91b5$var$F(e, n, t);
        }, 3e3);
    }(ue, x, Q), Q;
}
var $d8e80c8a40ff91b5$var$Ce = "before", $d8e80c8a40ff91b5$var$Re = "after";




var $d517855739f731bd$export$a81eb6a5a8ca4672 = "cookie", $d517855739f731bd$var$i = $d517855739f731bd$export$2eb042b3621b84d9(), $d517855739f731bd$export$4be65e66cfa2648a = $d517855739f731bd$var$d, $d517855739f731bd$export$110700823644f4a6 = $d517855739f731bd$var$d;
function $d517855739f731bd$export$6a874b7a74007875(o) {
    return $d517855739f731bd$var$i ? $d517855739f731bd$var$d(o, "", -1) : (0, $d3bc06c108ca0c17$export$cd7f480d6b8286c3)(o);
}
function $d517855739f731bd$export$2eb042b3621b84d9() {
    if (void 0 !== $d517855739f731bd$var$i) return $d517855739f731bd$var$i;
    var e = "cookiecookie";
    try {
        $d517855739f731bd$var$d(e, e), $d517855739f731bd$var$i = -1 !== document.cookie.indexOf(e), $d517855739f731bd$export$6a874b7a74007875(e);
    } catch (e) {
        $d517855739f731bd$var$i = !1;
    }
    return $d517855739f731bd$var$i;
}
function $d517855739f731bd$var$d(e, t, r, c, u, a) {
    if ("undefined" != typeof window) {
        var d = arguments.length > 1;
        return !1 === $d517855739f731bd$var$i && (d ? (0, $d3bc06c108ca0c17$export$adaa4cf7ef1b65be)(e, t) : (0, $d3bc06c108ca0c17$export$3988ae62b71be9a3)(e)), d ? document.cookie = e + "=" + encodeURIComponent(t) + (r ? "; expires=" + new Date(+new Date + 1e3 * r).toUTCString() + (c ? "; path=" + c : "") + (u ? "; domain=" + u : "") + (a ? "; secure" : "") : "") : decodeURIComponent((("; " + document.cookie).split("; " + e + "=")[1] || "").split(";")[0]);
    }
}



var $e13027ff1fd41840$export$c6a7366241a86d6d = "localStorage", $e13027ff1fd41840$export$c65995f51d426373 = (0, $d3bc06c108ca0c17$export$b6e153cbe86ff8d5).bind(null, "localStorage"), $e13027ff1fd41840$export$f92dfeb71e9bb569 = (0, $d3bc06c108ca0c17$export$4997ffc0176396a6)("localStorage", "getItem", (0, $d3bc06c108ca0c17$export$3988ae62b71be9a3)), $e13027ff1fd41840$export$8a8216c44337cd5 = (0, $d3bc06c108ca0c17$export$4997ffc0176396a6)("localStorage", "setItem", (0, $d3bc06c108ca0c17$export$adaa4cf7ef1b65be)), $e13027ff1fd41840$export$fe2d9b4e03920b4c = (0, $d3bc06c108ca0c17$export$4997ffc0176396a6)("localStorage", "removeItem", (0, $d3bc06c108ca0c17$export$cd7f480d6b8286c3));



var $9e6dff85c4c266e0$export$555d535a92367525 = "sessionStorage", $9e6dff85c4c266e0$export$fad41989c658534f = (0, $d3bc06c108ca0c17$export$b6e153cbe86ff8d5).bind(null, "sessionStorage"), $9e6dff85c4c266e0$export$fdf7104ff19cc288 = (0, $d3bc06c108ca0c17$export$4997ffc0176396a6)("sessionStorage", "getItem", (0, $d3bc06c108ca0c17$export$3988ae62b71be9a3)), $9e6dff85c4c266e0$export$a5376dd4adeb0fbf = (0, $d3bc06c108ca0c17$export$4997ffc0176396a6)("sessionStorage", "setItem", (0, $d3bc06c108ca0c17$export$adaa4cf7ef1b65be)), $9e6dff85c4c266e0$export$28dca8ac7b96d4da = (0, $d3bc06c108ca0c17$export$4997ffc0176396a6)("sessionStorage", "removeItem", (0, $d3bc06c108ca0c17$export$cd7f480d6b8286c3));



function $2638a051010f33b2$var$I(t) {
    var o = t;
    try {
        if ("true" === (o = JSON.parse(t))) return !0;
        if ("false" === o) return !1;
        if ((0, $6cce2b3292d7582c$export$a6cdc56e425d0d0a)(o)) return o;
        parseFloat(o) === o && (o = parseFloat(o));
    } catch (t) {}
    if (null !== o && "" !== o) return o;
}
var $2638a051010f33b2$var$k = (0, $e13027ff1fd41840$export$c65995f51d426373)(), $2638a051010f33b2$var$O = (0, $9e6dff85c4c266e0$export$fad41989c658534f)(), $2638a051010f33b2$var$x = (0, $d517855739f731bd$export$2eb042b3621b84d9)();
function $2638a051010f33b2$export$f92dfeb71e9bb569(o, e) {
    if (o) {
        var r = $2638a051010f33b2$var$A(e), a = !$2638a051010f33b2$var$N(r), i = $2638a051010f33b2$var$d(r) ? $2638a051010f33b2$var$I(localStorage.getItem(o)) : void 0;
        if (a && !(0, $6cce2b3292d7582c$export$fce6876652108ab)(i)) return i;
        var n = $2638a051010f33b2$var$h(r) ? $2638a051010f33b2$var$I((0, $d517855739f731bd$export$4be65e66cfa2648a)(o)) : void 0;
        if (a && n) return n;
        var l = $2638a051010f33b2$var$E(r) ? $2638a051010f33b2$var$I(sessionStorage.getItem(o)) : void 0;
        if (a && l) return l;
        var u = (0, $d3bc06c108ca0c17$export$3988ae62b71be9a3)(o);
        return a ? u : {
            localStorage: i,
            sessionStorage: l,
            cookie: n,
            global: u
        };
    }
}
function $2638a051010f33b2$export$8a8216c44337cd5(r, a, l) {
    if (r && !(0, $6cce2b3292d7582c$export$fce6876652108ab)(a)) {
        var u = {}, g = $2638a051010f33b2$var$A(l), m = JSON.stringify(a), S = !$2638a051010f33b2$var$N(g);
        return $2638a051010f33b2$var$d(g) && (u[0, $e13027ff1fd41840$export$c6a7366241a86d6d] = $2638a051010f33b2$var$F((0, $e13027ff1fd41840$export$c6a7366241a86d6d), a, $2638a051010f33b2$var$I(localStorage.getItem(r))), localStorage.setItem(r, m), S) ? u[0, $e13027ff1fd41840$export$c6a7366241a86d6d] : $2638a051010f33b2$var$h(g) && (u[0, $d517855739f731bd$export$a81eb6a5a8ca4672] = $2638a051010f33b2$var$F((0, $d517855739f731bd$export$a81eb6a5a8ca4672), a, $2638a051010f33b2$var$I((0, $d517855739f731bd$export$4be65e66cfa2648a)(r))), (0, $d517855739f731bd$export$110700823644f4a6)(r, m), S) ? u[0, $d517855739f731bd$export$a81eb6a5a8ca4672] : $2638a051010f33b2$var$E(g) && (u[0, $9e6dff85c4c266e0$export$555d535a92367525] = $2638a051010f33b2$var$F((0, $9e6dff85c4c266e0$export$555d535a92367525), a, $2638a051010f33b2$var$I(sessionStorage.getItem(r))), sessionStorage.setItem(r, m), S) ? u[0, $9e6dff85c4c266e0$export$555d535a92367525] : (u[0, $d3bc06c108ca0c17$export$17ff3f7e02c6ac22] = $2638a051010f33b2$var$F((0, $d3bc06c108ca0c17$export$17ff3f7e02c6ac22), a, (0, $d3bc06c108ca0c17$export$3988ae62b71be9a3)(r)), (0, $d3bc06c108ca0c17$export$adaa4cf7ef1b65be)(r, a), S ? u[0, $d3bc06c108ca0c17$export$17ff3f7e02c6ac22] : u);
    }
}
function $2638a051010f33b2$export$fe2d9b4e03920b4c(t, e) {
    if (t) {
        var a = $2638a051010f33b2$var$A(e), s = $2638a051010f33b2$export$f92dfeb71e9bb569(t, (0, $6cce2b3292d7582c$export$61b49a5ae59d663)), n = {};
        return !(0, $6cce2b3292d7582c$export$fce6876652108ab)(s.localStorage) && $2638a051010f33b2$var$d(a) && (localStorage.removeItem(t), n[0, $e13027ff1fd41840$export$c6a7366241a86d6d] = s.localStorage), !(0, $6cce2b3292d7582c$export$fce6876652108ab)(s.cookie) && $2638a051010f33b2$var$h(a) && ((0, $d517855739f731bd$export$6a874b7a74007875)(t), n[0, $d517855739f731bd$export$a81eb6a5a8ca4672] = s.cookie), !(0, $6cce2b3292d7582c$export$fce6876652108ab)(s.sessionStorage) && $2638a051010f33b2$var$E(a) && (sessionStorage.removeItem(t), n[0, $9e6dff85c4c266e0$export$555d535a92367525] = s.sessionStorage), !(0, $6cce2b3292d7582c$export$fce6876652108ab)(s.global) && $2638a051010f33b2$var$G(a, (0, $d3bc06c108ca0c17$export$17ff3f7e02c6ac22)) && ((0, $d3bc06c108ca0c17$export$cd7f480d6b8286c3)(t), n[0, $d3bc06c108ca0c17$export$17ff3f7e02c6ac22] = s.global), n;
    }
}
function $2638a051010f33b2$var$A(t) {
    return t ? (0, $6cce2b3292d7582c$export$844ec244b1367d54)(t) ? t : t.storage : (0, $6cce2b3292d7582c$export$8f1c7f430e5fef56);
}
function $2638a051010f33b2$var$d(t) {
    return $2638a051010f33b2$var$k && $2638a051010f33b2$var$G(t, (0, $e13027ff1fd41840$export$c6a7366241a86d6d));
}
function $2638a051010f33b2$var$h(t) {
    return $2638a051010f33b2$var$x && $2638a051010f33b2$var$G(t, (0, $d517855739f731bd$export$a81eb6a5a8ca4672));
}
function $2638a051010f33b2$var$E(t) {
    return $2638a051010f33b2$var$O && $2638a051010f33b2$var$G(t, (0, $9e6dff85c4c266e0$export$555d535a92367525));
}
function $2638a051010f33b2$var$N(t) {
    return t === (0, $6cce2b3292d7582c$export$61b49a5ae59d663) || "all" === t;
}
function $2638a051010f33b2$var$G(t, o) {
    return t === (0, $6cce2b3292d7582c$export$8f1c7f430e5fef56) || t === o || $2638a051010f33b2$var$N(t);
}
function $2638a051010f33b2$var$F(t, o, e) {
    return {
        location: t,
        current: o,
        previous: e
    };
}
var $2638a051010f33b2$export$2e2bcd8739ae039 = {
    setItem: $2638a051010f33b2$export$8a8216c44337cd5,
    getItem: $2638a051010f33b2$export$f92dfeb71e9bb569,
    removeItem: $2638a051010f33b2$export$fe2d9b4e03920b4c
};


function $af4001dded841a10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af4001dded841a10$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $af4001dded841a10$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $af4001dded841a10$var$ownKeys(Object(source), !0).forEach(function(key) {
            $af4001dded841a10$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $af4001dded841a10$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $af4001dded841a10$export$2b3af6baec22bd98() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaultSettings = {
        storage: (0, $2638a051010f33b2$export$2e2bcd8739ae039)
    };
    return (0, $d8e80c8a40ff91b5$export$2b3af6baec22bd98)($af4001dded841a10$var$_objectSpread2($af4001dded841a10$var$_objectSpread2({}, defaultSettings), opts));
}


function $91b5c8ae132f5e32$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $91b5c8ae132f5e32$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $91b5c8ae132f5e32$var$ownKeys(Object(source), !0).forEach(function(key) {
            $91b5c8ae132f5e32$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $91b5c8ae132f5e32$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $91b5c8ae132f5e32$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $91b5c8ae132f5e32$var$config = {
    debug: false,
    containerId: null,
    dataLayerName: "dataLayer",
    dataLayer: undefined,
    preview: undefined,
    auth: undefined,
    execution: "async" // assumesPageview: true,
};
var $91b5c8ae132f5e32$var$initializedDataLayerName;
/**
 * Google tag manager plugin
 * @link https://getanalytics.io/plugins/google-tag-manager
 * @link https://developers.google.com/tag-manager/
 * @param {object} pluginConfig - Plugin settings
 * @param {string} pluginConfig.containerId - The Container ID uniquely identifies the GTM Container.
 * @param {string} [pluginConfig.dataLayerName=dataLayer] - The optional name for dataLayer-object. Defaults to dataLayer.
 * @param {string} [pluginConfig.customScriptSrc] - Load Google Tag Manager script from a custom source
 * @param {string} [pluginConfig.preview] - The preview-mode environment
 * @param {string} [pluginConfig.auth] - The preview-mode authentication credentials
 * @param {string} [pluginConfig.execution] - The script execution mode
 * @return {object} Analytics plugin
 * @example
 *
 * googleTagManager({
 *   containerId: 'GTM-123xyz'
 * })
 */ function $91b5c8ae132f5e32$var$googleTagManager() {
    var pluginConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaultScriptSrc = "https://www.googletagmanager.com/gtm.js"; // Allow for userland overides of base methods
    return {
        name: "google-tag-manager",
        config: $91b5c8ae132f5e32$var$_objectSpread($91b5c8ae132f5e32$var$_objectSpread({}, $91b5c8ae132f5e32$var$config), pluginConfig),
        initialize: function initialize(_ref) {
            var config = _ref.config;
            var containerId = config.containerId, dataLayerName = config.dataLayerName, customScriptSrc = config.customScriptSrc, preview = config.preview, auth = config.auth, execution = config.execution;
            if (!containerId) throw new Error("No google tag manager containerId defined");
            if (preview && !auth) throw new Error("When enabling preview mode, both preview and auth parameters must be defined");
            var scriptSrc = customScriptSrc || defaultScriptSrc;
            if (!$91b5c8ae132f5e32$var$scriptLoaded(containerId, scriptSrc)) {
                /* eslint-disable */ (function(w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({
                        "gtm.start": new Date().getTime(),
                        event: "gtm.js"
                    });
                    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "", p = preview ? "&gtm_preview=" + preview + "&gtm_auth=" + auth + "&gtm_cookies_win=x" : "";
                    if (execution) j[execution] = true;
                    j.src = "".concat(scriptSrc, "?id=") + i + dl + p;
                    f.parentNode.insertBefore(j, f);
                })(window, document, "script", dataLayerName, containerId);
                /* eslint-enable */ $91b5c8ae132f5e32$var$initializedDataLayerName = dataLayerName;
                config.dataLayer = window[dataLayerName];
            }
        },
        page: function page(_ref2) {
            var payload = _ref2.payload;
            _ref2.options;
            _ref2.instance;
            var config = _ref2.config;
            if (typeof config.dataLayer !== "undefined") config.dataLayer.push(payload.properties);
        },
        track: function track(_ref3) {
            var payload = _ref3.payload;
            _ref3.options;
            var config = _ref3.config;
            if (typeof config.dataLayer !== "undefined") {
                var anonymousId = payload.anonymousId, userId = payload.userId, properties = payload.properties;
                var formattedPayload = properties;
                if (userId) formattedPayload.userId = userId;
                if (anonymousId) formattedPayload.anonymousId = anonymousId;
                if (!properties.category) formattedPayload.category = "All";
                if (config.debug) console.log("dataLayer push", $91b5c8ae132f5e32$var$_objectSpread({
                    event: payload.event
                }, formattedPayload));
                config.dataLayer.push($91b5c8ae132f5e32$var$_objectSpread({
                    event: payload.event
                }, formattedPayload));
            }
        },
        loaded: function loaded() {
            var hasDataLayer = !!$91b5c8ae132f5e32$var$initializedDataLayerName && !!(window[$91b5c8ae132f5e32$var$initializedDataLayerName] && Array.prototype.push !== window[$91b5c8ae132f5e32$var$initializedDataLayerName].push);
            return $91b5c8ae132f5e32$var$scriptLoaded(pluginConfig.containerId, pluginConfig.customScriptSrc || defaultScriptSrc) && hasDataLayer;
        }
    };
}
var $91b5c8ae132f5e32$var$regexCache = {};
/*
TODO add logic to make it impossible to load 2 plugins with the same container ID
[containerID]: pluginName
*/ function $91b5c8ae132f5e32$var$scriptLoaded(containerId, scriptSrc) {
    var regex = $91b5c8ae132f5e32$var$regexCache[containerId];
    if (!regex) {
        var scriptSrcEscaped = scriptSrc.replace(/^https?:\/\//, "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        regex = new RegExp(scriptSrcEscaped + ".*[?&]id=" + containerId);
        $91b5c8ae132f5e32$var$regexCache[containerId] = regex;
    }
    var scripts = document.querySelectorAll("script[src]");
    return !!Object.keys(scripts).filter(function(key) {
        return (scripts[key].src || "").match(regex);
    }).length;
}
/* This module will shake out unused code and work in browser and node 🎉 */ var $91b5c8ae132f5e32$export$2e2bcd8739ae039 = $91b5c8ae132f5e32$var$googleTagManager;



var $dhiZh = parcelRequire("dhiZh");
const $be939d5691cff9c5$var$SoproPlugin = ()=>{
    (0, $dhiZh.useEffect)(()=>{
        const script = document.createElement("script");
        script.innerHTML = `
      (function (o, u, t, b, a, s, e) {
        window[b] = window[b] || {}; (e = e || [])['key'] = o; e['__obr'] = u.location.href; a = [];
        u.location.search.replace('?', '').split('&').forEach(function (q) { if (q.startsWith(b) || q.startsWith('_obid')) e[q.split('=')[0]] = q.split('=')[1]; });
        e['_obid'] = e['_obid'] || (u.cookie.match(/(^|;)\s*_obid\s*=\s*([^;]+)/) || []).pop() || 0;
        for (let k in e) { if (e.hasOwnProperty(k)) a.push(encodeURIComponent(k) + '=' + encodeURIComponent(e[k])); }
        s = u.createElement('script'); s.src = t + '?' + a.join('&'); u.body.appendChild(s);
      })('6325cba9-7386-4372-bb0b-9279ea1649e7', document, 'https://plugin.sopro.io/hq.js', 'outbase');
    `;
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script); // Cleanup script when component unmounts
        };
    }, []);
    return null;
};
var $be939d5691cff9c5$export$2e2bcd8739ae039 = $be939d5691cff9c5$var$SoproPlugin;


const $e3db95ae91402725$var$Content = ({ menuList: menuList, introScreen: introScreen, clientsScreen: clientsScreen, talentOnYourTermsScreen: talentOnYourTermsScreen, casesScreen: casesScreen, championsScreen: championsScreen, cookieBanner: cookieBanner, footerData: footerData })=>{
    var _introScreen_fields_introHeroMedia_fields_file_contentType, _introScreen_fields_introHeroMedia_fields_file, _introScreen_fields_introHeroMedia_fields, _introScreen_fields_introHeroMedia, _introScreen_fields_introHeroMedia_fields_file1, _introScreen_fields_introHeroMedia_fields1, _introScreen_fields_introHeroMedia1, _introScreen_fields_introHeroMedia_fields_file2, _introScreen_fields_introHeroMedia_fields2, _introScreen_fields_introHeroMedia2, _clientsScreen_fields;
    const videoRef = (0, $dhiZh.useRef)(null);
    const [showCookieBanner, setShowCookieBanner] = (0, $dhiZh.useState)(null);
    const [userAcceptedCookies, setUserAcceptedCookies] = (0, $dhiZh.useState)(false);
    const [showBottomArrow, setShowBottomArrow] = (0, $dhiZh.useState)(false);
    const [playCount, setPlayCount] = (0, $dhiZh.useState)(0);
    const { hash: hash } = (0, $5687d04bb9f2cada$export$45d76561a5302f2b)();
    (0, $dhiZh.useEffect)(()=>{
        setShowCookieBanner(!localStorage.getItem("showCookieBanner"));
        setUserAcceptedCookies(document.cookie.includes("cookie-consent=true"));
    // console.log("COOKIE: ", !userAcceptedCookies);
    }, []);
    // handle Analytics
    (0, $dhiZh.useEffect)(()=>{
        if (showCookieBanner === false && userAcceptedCookies) {
            // console.log("here");
            (0, (/*@__PURE__*/$parcel$interopDefault($3c4c934fcc6974ed$exports))).initialize("G-E27XB1EFSM");
            const analytics = (0, $af4001dded841a10$export$2b3af6baec22bd98)({
                app: "awesome-app",
                plugins: [
                    (0, $91b5c8ae132f5e32$export$2e2bcd8739ae039)({
                        containerId: "GTM-PKWX985H"
                    })
                ]
            });
            /* Track a page view */ analytics.page();
        }
    }, [
        showCookieBanner
    ]);
    (0, $dhiZh.useEffect)(()=>{
        if (!videoRef.current) return;
        if (!videoRef.current.muted) {
            //open bug since 2017 that you cannot set muted in video element https://github.com/facebook/react/issues/10389
            videoRef.current.defaultMuted = true;
            videoRef.current.muted = true;
            if (showCookieBanner && userAcceptedCookies) videoRef.current.pause();
            else videoRef.current.play();
        }
        if (showCookieBanner === false && userAcceptedCookies) videoRef.current.play();
    }, [
        showCookieBanner,
        userAcceptedCookies
    ]);
    const handleTimeUpdate = ()=>{
        if (videoRef.current.currentTime >= videoRef.current.duration - 0.1) setPlayCount((prevCount)=>{
            const newCount = prevCount + 1;
            if (newCount === 2) setShowBottomArrow(true);
            return newCount;
        });
    };
    const toggleCookieBannerState = ()=>{
        setShowCookieBanner(false);
        localStorage.setItem("showCookieBanner", "false");
    };
    const toggleCookieConsent = ()=>{
        document.cookie = "cookie-consent=true; max-age=31536000; path=/";
        setUserAcceptedCookies(true);
    };
    // scroll if hash
    (0, $dhiZh.useEffect)(()=>{
        setTimeout(()=>{
            const handleHashChange = ()=>{
                const hash = window.location.hash;
                const element = document.getElementById(hash.substring(1));
                if (element) element.scrollIntoView({
                    behavior: "instant"
                });
            };
            window.addEventListener("hashchange", handleHashChange);
            // Call the function on mount
            handleHashChange();
            return ()=>{
                window.removeEventListener("hashchange", handleHashChange);
            };
        }, 100);
    }, []);
    // useEffect(() => {
    //   if (hash) {
    //     const scrollToElement = () => {
    //       console.log("here")
    //       const element = document.getElementById(hash.slice(1));
    //       if (element) {
    //         element.scrollIntoView();
    //       } else {
    //         // Try again after a short delay
    //         setTimeout(scrollToElement, 10);
    //       }
    //     };
    //
    //     scrollToElement(); // Initial call
    //   }
    // }, [hash]);
    // mobile
    function isMobile() {
        return /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 800;
    }
    if (isMobile()) // In your React component
    (0, $dhiZh.useEffect)(()=>{
        const setDynamicVh = ()=>{
            const vh = window.visualViewport.height * 0.01; // Calculate 1% of the visual viewport height
            document.documentElement.style.setProperty("--vh", `${vh}px`); // Set CSS variable
        };
        setDynamicVh(); // Set initial value
        // Listen to resize events on the visual viewport
        window.visualViewport.addEventListener("resize", setDynamicVh);
        return ()=>{
            window.visualViewport.removeEventListener("resize", setDynamicVh); // Cleanup on unmount
        };
    }, []);
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
        className: "home-content",
        children: [
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $be939d5691cff9c5$export$2e2bcd8739ae039), {}),
            !userAcceptedCookies && /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $2312533b285e81ae$export$2e2bcd8739ae039), {
                data: cookieBanner,
                showCookieBanner: !userAcceptedCookies,
                toggleCookieBannerState: toggleCookieBannerState,
                toggleCookieConsent: toggleCookieConsent
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $01d6e97cae1259ec$export$2e2bcd8739ae039), {
                menuList: menuList,
                caseProp: false
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                id: "reel",
                className: "makerlab-section makerlab-section-intro",
                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                    className: "makerlab-column",
                    children: [
                        ((_introScreen_fields_introHeroMedia = introScreen.fields.introHeroMedia) === null || _introScreen_fields_introHeroMedia === void 0 ? void 0 : (_introScreen_fields_introHeroMedia_fields = _introScreen_fields_introHeroMedia.fields) === null || _introScreen_fields_introHeroMedia_fields === void 0 ? void 0 : (_introScreen_fields_introHeroMedia_fields_file = _introScreen_fields_introHeroMedia_fields.file) === null || _introScreen_fields_introHeroMedia_fields_file === void 0 ? void 0 : (_introScreen_fields_introHeroMedia_fields_file_contentType = _introScreen_fields_introHeroMedia_fields_file.contentType) === null || _introScreen_fields_introHeroMedia_fields_file_contentType === void 0 ? void 0 : _introScreen_fields_introHeroMedia_fields_file_contentType.includes("video")) ? /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("video", {
                            loop: true,
                            autoPlay: true,
                            playsInline: true,
                            ref: videoRef,
                            onTimeUpdate: handleTimeUpdate,
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("source", {
                                    src: (_introScreen_fields_introHeroMedia1 = introScreen.fields.introHeroMedia) === null || _introScreen_fields_introHeroMedia1 === void 0 ? void 0 : (_introScreen_fields_introHeroMedia_fields1 = _introScreen_fields_introHeroMedia1.fields) === null || _introScreen_fields_introHeroMedia_fields1 === void 0 ? void 0 : (_introScreen_fields_introHeroMedia_fields_file1 = _introScreen_fields_introHeroMedia_fields1.file) === null || _introScreen_fields_introHeroMedia_fields_file1 === void 0 ? void 0 : _introScreen_fields_introHeroMedia_fields_file1.url,
                                    type: (_introScreen_fields_introHeroMedia2 = introScreen.fields.introHeroMedia) === null || _introScreen_fields_introHeroMedia2 === void 0 ? void 0 : (_introScreen_fields_introHeroMedia_fields2 = _introScreen_fields_introHeroMedia2.fields) === null || _introScreen_fields_introHeroMedia_fields2 === void 0 ? void 0 : (_introScreen_fields_introHeroMedia_fields_file2 = _introScreen_fields_introHeroMedia_fields2.file) === null || _introScreen_fields_introHeroMedia_fields_file2 === void 0 ? void 0 : _introScreen_fields_introHeroMedia_fields_file2.contentType
                                }),
                                "Your browser does not support the video tag."
                            ]
                        }) : "img",
                        /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                            className: "makerlab-scrolltobottom",
                            "data-show": showBottomArrow,
                            children: [
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("span", {
                                    children: "SCROLL"
                                }),
                                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("svg", {
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 63 36",
                                    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("path", {
                                        d: "M61 2 30.878 33 2 2",
                                        stroke: "#fff",
                                        strokeOpacity: ".5",
                                        strokeWidth: "4",
                                        strokeLinecap: "round"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $e2c2f54d2fe66d4f$export$2e2bcd8739ae039), {
                logos: clientsScreen === null || clientsScreen === void 0 ? void 0 : (_clientsScreen_fields = clientsScreen.fields) === null || _clientsScreen_fields === void 0 ? void 0 : _clientsScreen_fields.newClientLogos
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $4d07f82f7394ea5d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $fe4c4a426df04f81$export$2e2bcd8739ae039), {
                data: talentOnYourTermsScreen === null || talentOnYourTermsScreen === void 0 ? void 0 : talentOnYourTermsScreen.fields
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $e987e357e7629534$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $9a168c4a5080b636$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $4d1796e773ded861$export$2e2bcd8739ae039), {
                data: casesScreen.fields
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                className: "makerlab-carousel-container",
                children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $8ad3ddd758769fa0$export$2e2bcd8739ae039), {
                    data: championsScreen
                })
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $2e0b63450ba28dd7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $0315981ce3006dd3$export$2e2bcd8739ae039), {
                menuList: menuList,
                footerData: footerData
            })
        ]
    });
};
var $e3db95ae91402725$export$2e2bcd8739ae039 = $e3db95ae91402725$var$Content;



parcelRequire("dhiZh");



const $6e8a7e64ba91efcb$var$CasePage = ({ data: data, menuList: menuList })=>{
    const { slug: slug } = (0, $5687d04bb9f2cada$export$99eaa27ddbbb95ef)();
    if (!data || !data.fields || !Array.isArray(data.fields.cases)) return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        children: "Invalid data"
    });
    const caseData = data.fields.cases.find((caseItem)=>caseItem.fields.slug === slug);
    if (!caseData) return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        children: "Case not found"
    });
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $01d6e97cae1259ec$export$2e2bcd8739ae039), {
                menuList: menuList,
                isfaded: false,
                caseProp: true
            }),
            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                className: "makerlab-case-wrapper",
                children: [
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)("div", {
                        className: "makerlab-case-left",
                        children: [
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("img", {
                                src: caseData.fields.caseLogo.fields.file.url,
                                alt: caseData.fields.caseLogo.fields.file.fileName
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("h2", {
                                children: caseData.fields.caseDescription
                            }),
                            /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                                className: "makerlab-case-text-wrapper",
                                children: (0, $6ed23f9f312890d4$export$4a295a2b4ab66da6)(caseData.fields.caseText)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
                        className: "makerlab-case-right",
                        children: caseData.fields.caseGallery.map((item, index)=>{
                            return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("img", {
                                src: item.fields.file.url,
                                alt: item.fields.file.fileName
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
var $6e8a7e64ba91efcb$export$2e2bcd8739ae039 = $6e8a7e64ba91efcb$var$CasePage;


const $720a834293462484$var$AppRouter = ({ data: data })=>{
    // console.log("router data: ", data);
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $ff12a13c25436077$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsxs)((0, $5687d04bb9f2cada$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $5687d04bb9f2cada$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $e3db95ae91402725$export$2e2bcd8739ae039), {
                        menuList: data.MenuList,
                        introScreen: data.introScreen,
                        clientsScreen: data.clientsScreen,
                        talentOnYourTermsScreen: data.talentOnYourTermsScreen,
                        microAgenciesScreen: data.microAgenciesScreen,
                        casesScreen: data.casesScreen,
                        aboutScreen: data.aboutScreen,
                        championsScreen: data.championsScreen,
                        insightsScreen: data.insightsScreen,
                        cookieBanner: data.cookieBanner,
                        footerData: data.footerData
                    })
                }),
                /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $5687d04bb9f2cada$export$e7b0ac011bb776c6), {
                    path: "/case/:slug",
                    element: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $6e8a7e64ba91efcb$export$2e2bcd8739ae039), {
                        data: data.casesScreen,
                        menuList: data.MenuList
                    })
                })
            ]
        })
    });
};
var $720a834293462484$export$2e2bcd8739ae039 = $720a834293462484$var$AppRouter;


const $8278965c894eda9c$var$client = (0, $1d80c4c551df3035$export$5d730b7aed1a3eb0)({
    space: "fsgdw7ij4976",
    accessToken: "hTQ7sDny1rl_1tTgYSbHjkT2RHleJN_ydS6rYjG5oEI"
});
const $8278965c894eda9c$var$fetcher = async ()=>{
    try {
        const MenuListData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "menuList"
        });
        const introScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "introScreen"
        });
        const clientsScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "clientsScreen"
        });
        const talentOnYourTermsScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "talentOnYourTerms"
        });
        const microAgenciesScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "microAgenciesScreen"
        });
        const casesScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "casesScreen"
        });
        const aboutScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "aboutScreen"
        });
        const championsScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "championsScreen"
        });
        const insightsScreenData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "insightsScreen"
        });
        const cookieBannerData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "cookieBanner"
        });
        const footerData = await $8278965c894eda9c$var$client.getEntries({
            content_type: "footer"
        });
        return {
            MenuList: MenuListData.items[0],
            introScreen: introScreenData.items[0],
            clientsScreen: clientsScreenData.items[0],
            talentOnYourTermsScreen: talentOnYourTermsScreenData.items[0],
            microAgenciesScreen: microAgenciesScreenData.items[0],
            casesScreen: casesScreenData.items[0],
            aboutScreen: aboutScreenData.items[0],
            championsScreen: championsScreenData.items[0],
            insightsScreen: insightsScreenData.items[0],
            cookieBanner: cookieBannerData.items[0],
            footerData: footerData.items[0]
        };
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};
function $8278965c894eda9c$var$App() {
    const { data: data, error: error } = (0, $16594a2605e0dfee$export$2e2bcd8739ae039)("contentful", $8278965c894eda9c$var$fetcher);
    const lenis = (0, $69a63ea936e703ee$export$69a110ee5442c47)(({ scroll: scroll })=>{
    // called every scroll
    });
    if (error) {
        console.error(error);
        return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
            children: "Failed to load"
        });
    }
    if (!data) return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("div", {
        className: "makerlab-spinner-container",
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $1b767d384492f23e$export$7f7cbe89f1eacd2), {
            size: "large"
        })
    });
    return /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $69a63ea936e703ee$export$4be146f3ae50d23a), {
        root: true,
        options: {
            duration: 1,
            easing: (t)=>1 - Math.pow(1 - t, 5),
            lerp: 0.15,
            smooth: true
        },
        children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)("main", {
            children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $720a834293462484$export$2e2bcd8739ae039), {
                data: data
            })
        })
    });
}
var $8278965c894eda9c$export$2e2bcd8739ae039 = $8278965c894eda9c$var$App;


const $8240e79c6aa9bd54$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($fa54abf3c5b19ab2$exports))).createRoot(document.getElementById("root"));
$8240e79c6aa9bd54$var$root.render(/*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dhiZh))).StrictMode, {
    children: /*#__PURE__*/ (0, $015932d6ce0d059e$exports.jsx)((0, $8278965c894eda9c$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.c9a18a81.js.map
